/* tslint:disable */
/* eslint-disable */
/**
 * Loglass API Documentation
 * This is a loglass-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface Absolute {
    'actualPeriod'?: AbsolutePeriod;
    'aggregationPeriod': AbsolutePeriod;
    'unused'?: string;
}
export interface AbsolutePeriod {
    'end': string;
    'start': string;
}
export interface AccountConversionStepDetailView {
    'description'?: string;
    'destinationAccountId': string;
    'name': string;
    'sourceAccountId': string;
    'sourceAccountType': string;
    'sourceUnitPriceMasterItemId': string;
    'stepId': string;
}
export interface AccountConversionStepView {
    'accountConversionStepId': string;
    'accountConversionStepName': string;
    'description'?: string;
    'destinationAccountName': string;
    'executionOrder': number;
    'sourceAccountName': string;
    'sourceUnitPriceMasterItemName': string;
}
export interface AccountConversionStepsView {
    'steps': Array<AccountConversionStepView>;
}
export interface AccountDrillDownConditionParam {
    'accountIds': Array<string>;
    'drillDownType': AccountDrillDownConditionParamDrillDownTypeEnum;
}

export const AccountDrillDownConditionParamDrillDownTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
    Period: 'PERIOD',
} as const;

export type AccountDrillDownConditionParamDrillDownTypeEnum = typeof AccountDrillDownConditionParamDrillDownTypeEnum[keyof typeof AccountDrillDownConditionParamDrillDownTypeEnum];

export interface AccountFlatTreeForSelectionView {
    'items': Array<AccountTreeNodeForSelectionView>;
    'meta': AccountTreeMetaView;
    'notIncludes': Array<AccountView>;
}
export interface AccountFlatTreeView {
    'items': Array<AccountTreeNodeView>;
    'meta': AccountTreeMetaView;
}
export interface AccountFlatTreeWithMatchedNodesView {
    'items': Array<AccountTreeNodeView>;
    'meta': AccountTreeMetaView;
    'openNodeIds': Array<string>;
}
export interface AccountGroupView {
    'code': string;
    'id': string;
    'name': string;
}
export interface AccountLabelOverride {
    'accountId': string;
    'customLabel'?: string;
}
export interface AccountTreeListView {
    'items': Array<AccountTreeMetaView>;
}
export interface AccountTreeMetaView {
    'id': string;
    'isPrimary': boolean;
    'name': string;
}
export interface AccountTreeNodeForSelectionView {
    'accountId': string;
    'data': AccountView;
    'isAggregation': boolean;
    'isOwnValue': boolean;
    'isViewable': boolean;
    'level': number;
    'parentAccountId'?: string;
    'rowType': AccountTreeNodeForSelectionViewRowTypeEnum;
}

export const AccountTreeNodeForSelectionViewRowTypeEnum = {
    Account: 'ACCOUNT',
    AccountOwnValue: 'ACCOUNT_OWN_VALUE',
} as const;

export type AccountTreeNodeForSelectionViewRowTypeEnum = typeof AccountTreeNodeForSelectionViewRowTypeEnum[keyof typeof AccountTreeNodeForSelectionViewRowTypeEnum];

export interface AccountTreeNodeView {
    'accountType': AccountTreeNodeViewAccountTypeEnum;
    'accountingSystemCodePair'?: AccountingSystemCodePairView;
    'calculationType': AccountTreeNodeViewCalculationTypeEnum;
    'canInsertNewAccount': boolean;
    'code': string;
    'id': string;
    'level': number;
    'matched': boolean;
    'matchedKeyword': MatchedPLAccountKeywordView;
    'name': string;
    'parentId'?: string;
    'rowType': AccountTreeNodeViewRowTypeEnum;
    'viewControlType': AccountTreeNodeViewViewControlTypeEnum;
}

export const AccountTreeNodeViewAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type AccountTreeNodeViewAccountTypeEnum = typeof AccountTreeNodeViewAccountTypeEnum[keyof typeof AccountTreeNodeViewAccountTypeEnum];
export const AccountTreeNodeViewCalculationTypeEnum = {
    Normal: 'NORMAL',
} as const;

export type AccountTreeNodeViewCalculationTypeEnum = typeof AccountTreeNodeViewCalculationTypeEnum[keyof typeof AccountTreeNodeViewCalculationTypeEnum];
export const AccountTreeNodeViewRowTypeEnum = {
    Account: 'ACCOUNT',
    AccountOwnValue: 'ACCOUNT_OWN_VALUE',
} as const;

export type AccountTreeNodeViewRowTypeEnum = typeof AccountTreeNodeViewRowTypeEnum[keyof typeof AccountTreeNodeViewRowTypeEnum];
export const AccountTreeNodeViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type AccountTreeNodeViewViewControlTypeEnum = typeof AccountTreeNodeViewViewControlTypeEnum[keyof typeof AccountTreeNodeViewViewControlTypeEnum];

export interface AccountTreeWithFormulaNodeDataView {
    'accountId': string;
    'accountName': string;
    'formula': FinancialModelFormulaWithTypeView;
    'isAggregationType': boolean;
    'level': number;
}
export interface AccountTreeWithHiddenFinancialSimulationDatasetFormulaIdsNodeDataView {
    'accountId': string;
    'accountName': string;
    'hiddenFinancialSimulationDatasetFormulaIds': Array<string>;
    'level': number;
}
export interface AccountTreeWithHiddenFinancialSimulationDatasetFormulaIdsView {
    'financialDatasetFormulas': Array<FinancialSimulationDatasetFormulaDetailView>;
    'rootNodes': Array<TreeNodeViewAccountTreeWithHiddenFinancialSimulationDatasetFormulaIdsNodeDataView>;
}
export interface AccountView {
    'accountType': AccountViewAccountTypeEnum;
    'accountingSystemCodePair'?: AccountingSystemCodePairView;
    'calculationType': AccountViewCalculationTypeEnum;
    'code': string;
    'id': string;
    'name': string;
    'subAccounts': SubAccountsView;
    'viewControlType': AccountViewViewControlTypeEnum;
}

export const AccountViewAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type AccountViewAccountTypeEnum = typeof AccountViewAccountTypeEnum[keyof typeof AccountViewAccountTypeEnum];
export const AccountViewCalculationTypeEnum = {
    Normal: 'NORMAL',
} as const;

export type AccountViewCalculationTypeEnum = typeof AccountViewCalculationTypeEnum[keyof typeof AccountViewCalculationTypeEnum];
export const AccountViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type AccountViewViewControlTypeEnum = typeof AccountViewViewControlTypeEnum[keyof typeof AccountViewViewControlTypeEnum];

export interface AccountingSystemCodePairView {
    'exCodeView': AccountingSystemCodeView;
    'exSubCodeView'?: AccountingSystemSubCodeView;
}
export interface AccountingSystemCodeView {
    'code': string;
    'id': string;
}
export interface AccountingSystemSubCodeView {
    'code': string;
    'id': string;
}
export interface AccountsForReplaceRootNodeSelectionView {
    'currentRootNodeAccount': AccountView;
    'selectionAccounts': Array<AccountView>;
}
export interface AccountsView {
    'value': Array<AccountView>;
}
export interface ActiveUserCountDto {
    'view': number;
    'write': number;
}
export interface ActualImportEventDto {
    'deleteStartAt'?: string;
    'eventId': IDImpl;
    'importedAt': string;
    'importedCount'?: number;
    'importedFileName': string;
    'importerName': string;
    'max'?: string;
    'min'?: string;
    'status': ActualImportEventDtoStatusEnum;
}

export const ActualImportEventDtoStatusEnum = {
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Error: 'ERROR',
    MasterNotCreatedError: 'MASTER_NOT_CREATED_ERROR',
    Deleting: 'DELETING',
} as const;

export type ActualImportEventDtoStatusEnum = typeof ActualImportEventDtoStatusEnum[keyof typeof ActualImportEventDtoStatusEnum];

export interface ActualImportEventView {
    'id': string;
}
export interface ActualImportMapping {
    'actualImportMappingColumnFilters': Array<ActualImportMappingFilterData>;
    'actualImportMappingDebitCreditConditions': Array<ActualImportMappingDebitCreditConditionData>;
    'actualImportMappingItems': Array<ActualImportMappingItemData>;
    'actualImportMappingRowFilters': Array<ActualImportMappingFilterData>;
    'actualImportMappingSubsidiaryCodes': Array<ActualImportMappingSubsidiaryCodeData>;
    'actualImportPattern': ActualImportMappingActualImportPatternEnum;
    'amountDataDirection': ActualImportMappingAmountDataDirectionEnum;
    'createdAt': DateTimeData;
    'headerRowIndex': number;
    'id': IDImpl;
    'isFindByNameForExistingAccount': boolean;
    'journalOrBalance': ActualImportMappingJournalOrBalanceEnum;
    'name': NameVO;
    'processSettingIds': Array<IDImpl>;
    'repeatColumnHeaderType'?: ActualImportMappingRepeatColumnHeaderTypeEnum;
    'updatedAt': DateTimeData;
}

export const ActualImportMappingActualImportPatternEnum = {
    Divide: 'DIVIDE',
    Combine: 'COMBINE',
    AccountType: 'ACCOUNT_TYPE',
} as const;

export type ActualImportMappingActualImportPatternEnum = typeof ActualImportMappingActualImportPatternEnum[keyof typeof ActualImportMappingActualImportPatternEnum];
export const ActualImportMappingAmountDataDirectionEnum = {
    RowColumn: 'ROW_COLUMN',
    Column: 'COLUMN',
} as const;

export type ActualImportMappingAmountDataDirectionEnum = typeof ActualImportMappingAmountDataDirectionEnum[keyof typeof ActualImportMappingAmountDataDirectionEnum];
export const ActualImportMappingJournalOrBalanceEnum = {
    Journal: 'JOURNAL',
    Balance: 'BALANCE',
} as const;

export type ActualImportMappingJournalOrBalanceEnum = typeof ActualImportMappingJournalOrBalanceEnum[keyof typeof ActualImportMappingJournalOrBalanceEnum];
export const ActualImportMappingRepeatColumnHeaderTypeEnum = {
    Date: 'DATE',
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
} as const;

export type ActualImportMappingRepeatColumnHeaderTypeEnum = typeof ActualImportMappingRepeatColumnHeaderTypeEnum[keyof typeof ActualImportMappingRepeatColumnHeaderTypeEnum];

export interface ActualImportMappingData {
    'actualImportMappingColumnFilters': Array<ActualImportMappingFilterData>;
    'actualImportMappingDebitCreditConditions': Array<ActualImportMappingDebitCreditConditionData>;
    'actualImportMappingItems': Array<ActualImportMappingItemData>;
    'actualImportMappingRowFilters': Array<ActualImportMappingFilterData>;
    'actualImportMappingSubsidiaryCodes': Array<ActualImportMappingSubsidiaryCodeData>;
    'actualImportPattern': ActualImportMappingDataActualImportPatternEnum;
    'amountDataDirection': ActualImportMappingDataAmountDataDirectionEnum;
    'createdAt': DateTimeData;
    'headerRowIndex': number;
    'id': IDImpl;
    'isFindByNameForExistingAccount': boolean;
    'journalOrBalance': ActualImportMappingDataJournalOrBalanceEnum;
    'name': NameVO;
    'processSettingIds': Array<IDImpl>;
    'repeatColumnHeaderType'?: ActualImportMappingDataRepeatColumnHeaderTypeEnum;
    'updatedAt': DateTimeData;
    'actualImportMappingFilters'?: Array<ActualImportMappingFilterData>;
}

export const ActualImportMappingDataActualImportPatternEnum = {
    Divide: 'DIVIDE',
    Combine: 'COMBINE',
    AccountType: 'ACCOUNT_TYPE',
} as const;

export type ActualImportMappingDataActualImportPatternEnum = typeof ActualImportMappingDataActualImportPatternEnum[keyof typeof ActualImportMappingDataActualImportPatternEnum];
export const ActualImportMappingDataAmountDataDirectionEnum = {
    RowColumn: 'ROW_COLUMN',
    Column: 'COLUMN',
} as const;

export type ActualImportMappingDataAmountDataDirectionEnum = typeof ActualImportMappingDataAmountDataDirectionEnum[keyof typeof ActualImportMappingDataAmountDataDirectionEnum];
export const ActualImportMappingDataJournalOrBalanceEnum = {
    Journal: 'JOURNAL',
    Balance: 'BALANCE',
} as const;

export type ActualImportMappingDataJournalOrBalanceEnum = typeof ActualImportMappingDataJournalOrBalanceEnum[keyof typeof ActualImportMappingDataJournalOrBalanceEnum];
export const ActualImportMappingDataRepeatColumnHeaderTypeEnum = {
    Date: 'DATE',
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
} as const;

export type ActualImportMappingDataRepeatColumnHeaderTypeEnum = typeof ActualImportMappingDataRepeatColumnHeaderTypeEnum[keyof typeof ActualImportMappingDataRepeatColumnHeaderTypeEnum];

export interface ActualImportMappingDebitCreditCondition {
    'columnIndex': number;
    'conditionType': ActualImportMappingDebitCreditConditionConditionTypeEnum;
    'conditionValue'?: string;
    'debitCredit': ActualImportMappingDebitCreditConditionDebitCreditEnum;
    'id': IDImpl;
}

export const ActualImportMappingDebitCreditConditionConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type ActualImportMappingDebitCreditConditionConditionTypeEnum = typeof ActualImportMappingDebitCreditConditionConditionTypeEnum[keyof typeof ActualImportMappingDebitCreditConditionConditionTypeEnum];
export const ActualImportMappingDebitCreditConditionDebitCreditEnum = {
    Debit: 'DEBIT',
    Credit: 'CREDIT',
} as const;

export type ActualImportMappingDebitCreditConditionDebitCreditEnum = typeof ActualImportMappingDebitCreditConditionDebitCreditEnum[keyof typeof ActualImportMappingDebitCreditConditionDebitCreditEnum];

export interface ActualImportMappingDebitCreditConditionData {
    'columnIndex': number;
    'conditionType': ActualImportMappingDebitCreditConditionDataConditionTypeEnum;
    'conditionValue'?: string;
    'debitCredit': ActualImportMappingDebitCreditConditionDataDebitCreditEnum;
    'id': IDImpl;
    'condition': ActualImportMappingDebitCreditConditionDataAllOfCondition;
}

export const ActualImportMappingDebitCreditConditionDataConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type ActualImportMappingDebitCreditConditionDataConditionTypeEnum = typeof ActualImportMappingDebitCreditConditionDataConditionTypeEnum[keyof typeof ActualImportMappingDebitCreditConditionDataConditionTypeEnum];
export const ActualImportMappingDebitCreditConditionDataDebitCreditEnum = {
    Debit: 'DEBIT',
    Credit: 'CREDIT',
} as const;

export type ActualImportMappingDebitCreditConditionDataDebitCreditEnum = typeof ActualImportMappingDebitCreditConditionDataDebitCreditEnum[keyof typeof ActualImportMappingDebitCreditConditionDataDebitCreditEnum];

/**
 * @type ActualImportMappingDebitCreditConditionDataAllOfCondition
 */
export type ActualImportMappingDebitCreditConditionDataAllOfCondition = Contains | EndsWith | Entered | Equals | EqualsAny | NotContains | NotEntered | NotEquals | StartsWith;

export interface ActualImportMappingFilter {
    'columnIndex': number;
    'conditionType': ActualImportMappingFilterConditionTypeEnum;
    'conditionValue'?: string;
    'id': IDImpl;
    'isColumnFilter': boolean;
    'isRowFilter': boolean;
    'targetType': ActualImportMappingFilterTargetTypeEnum;
}

export const ActualImportMappingFilterConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type ActualImportMappingFilterConditionTypeEnum = typeof ActualImportMappingFilterConditionTypeEnum[keyof typeof ActualImportMappingFilterConditionTypeEnum];
export const ActualImportMappingFilterTargetTypeEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
} as const;

export type ActualImportMappingFilterTargetTypeEnum = typeof ActualImportMappingFilterTargetTypeEnum[keyof typeof ActualImportMappingFilterTargetTypeEnum];

export interface ActualImportMappingFilterData {
    'columnIndex': number;
    'conditionType': ActualImportMappingFilterDataConditionTypeEnum;
    'conditionValue'?: string;
    'id': IDImpl;
    'isColumnFilter': boolean;
    'isRowFilter': boolean;
    'targetType': ActualImportMappingFilterDataTargetTypeEnum;
    'condition': ActualImportMappingFilterDataAllOfCondition;
}

export const ActualImportMappingFilterDataConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type ActualImportMappingFilterDataConditionTypeEnum = typeof ActualImportMappingFilterDataConditionTypeEnum[keyof typeof ActualImportMappingFilterDataConditionTypeEnum];
export const ActualImportMappingFilterDataTargetTypeEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
} as const;

export type ActualImportMappingFilterDataTargetTypeEnum = typeof ActualImportMappingFilterDataTargetTypeEnum[keyof typeof ActualImportMappingFilterDataTargetTypeEnum];

/**
 * @type ActualImportMappingFilterDataAllOfCondition
 */
export type ActualImportMappingFilterDataAllOfCondition = Contains | EndsWith | Entered | Equals | EqualsAny | NotContains | NotEntered | NotEquals | StartsWith;

export interface ActualImportMappingItem {
    'columnIndex': number;
    'dimensionId'?: IDImpl;
    'id': IDImpl;
    'type': ActualImportMappingItemTypeEnum;
}

export const ActualImportMappingItemTypeEnum = {
    Date: 'DATE',
    DebitAmount: 'DEBIT_AMOUNT',
    CreditAmount: 'CREDIT_AMOUNT',
    DebitAccountName: 'DEBIT_ACCOUNT_NAME',
    CreditAccountName: 'CREDIT_ACCOUNT_NAME',
    DocumentId: 'DOCUMENT_ID',
    Description: 'DESCRIPTION',
    DebitAccountExCode: 'DEBIT_ACCOUNT_EX_CODE',
    CreditAccountExCode: 'CREDIT_ACCOUNT_EX_CODE',
    DebitDepartmentName: 'DEBIT_DEPARTMENT_NAME',
    CreditDepartmentName: 'CREDIT_DEPARTMENT_NAME',
    DebitDepartmentExCode: 'DEBIT_DEPARTMENT_EX_CODE',
    CreditDepartmentExCode: 'CREDIT_DEPARTMENT_EX_CODE',
    DebitSubAccountName: 'DEBIT_SUB_ACCOUNT_NAME',
    CreditSubAccountName: 'CREDIT_SUB_ACCOUNT_NAME',
    DebitSubAccountExCode: 'DEBIT_SUB_ACCOUNT_EX_CODE',
    CreditSubAccountExCode: 'CREDIT_SUB_ACCOUNT_EX_CODE',
    DebitSupplierName: 'DEBIT_SUPPLIER_NAME',
    CreditSupplierName: 'CREDIT_SUPPLIER_NAME',
    DebitSupplierExCode: 'DEBIT_SUPPLIER_EX_CODE',
    CreditSupplierExCode: 'CREDIT_SUPPLIER_EX_CODE',
    DebitDimensionName: 'DEBIT_DIMENSION_NAME',
    CreditDimensionName: 'CREDIT_DIMENSION_NAME',
    Amount: 'AMOUNT',
    AccountName: 'ACCOUNT_NAME',
    AccountExCode: 'ACCOUNT_EX_CODE',
    DepartmentName: 'DEPARTMENT_NAME',
    DepartmentExCode: 'DEPARTMENT_EX_CODE',
    SubAccountName: 'SUB_ACCOUNT_NAME',
    SubAccountExCode: 'SUB_ACCOUNT_EX_CODE',
    SupplierName: 'SUPPLIER_NAME',
    SupplierExCode: 'SUPPLIER_EX_CODE',
    DimensionName: 'DIMENSION_NAME',
} as const;

export type ActualImportMappingItemTypeEnum = typeof ActualImportMappingItemTypeEnum[keyof typeof ActualImportMappingItemTypeEnum];

export interface ActualImportMappingItemData {
    'columnIndex': number;
    'dimensionId'?: IDImpl;
    'id': IDImpl;
    'type': ActualImportMappingItemDataTypeEnum;
}

export const ActualImportMappingItemDataTypeEnum = {
    Date: 'DATE',
    DebitAmount: 'DEBIT_AMOUNT',
    CreditAmount: 'CREDIT_AMOUNT',
    DebitAccountName: 'DEBIT_ACCOUNT_NAME',
    CreditAccountName: 'CREDIT_ACCOUNT_NAME',
    DocumentId: 'DOCUMENT_ID',
    Description: 'DESCRIPTION',
    DebitAccountExCode: 'DEBIT_ACCOUNT_EX_CODE',
    CreditAccountExCode: 'CREDIT_ACCOUNT_EX_CODE',
    DebitDepartmentName: 'DEBIT_DEPARTMENT_NAME',
    CreditDepartmentName: 'CREDIT_DEPARTMENT_NAME',
    DebitDepartmentExCode: 'DEBIT_DEPARTMENT_EX_CODE',
    CreditDepartmentExCode: 'CREDIT_DEPARTMENT_EX_CODE',
    DebitSubAccountName: 'DEBIT_SUB_ACCOUNT_NAME',
    CreditSubAccountName: 'CREDIT_SUB_ACCOUNT_NAME',
    DebitSubAccountExCode: 'DEBIT_SUB_ACCOUNT_EX_CODE',
    CreditSubAccountExCode: 'CREDIT_SUB_ACCOUNT_EX_CODE',
    DebitSupplierName: 'DEBIT_SUPPLIER_NAME',
    CreditSupplierName: 'CREDIT_SUPPLIER_NAME',
    DebitSupplierExCode: 'DEBIT_SUPPLIER_EX_CODE',
    CreditSupplierExCode: 'CREDIT_SUPPLIER_EX_CODE',
    DebitDimensionName: 'DEBIT_DIMENSION_NAME',
    CreditDimensionName: 'CREDIT_DIMENSION_NAME',
    Amount: 'AMOUNT',
    AccountName: 'ACCOUNT_NAME',
    AccountExCode: 'ACCOUNT_EX_CODE',
    DepartmentName: 'DEPARTMENT_NAME',
    DepartmentExCode: 'DEPARTMENT_EX_CODE',
    SubAccountName: 'SUB_ACCOUNT_NAME',
    SubAccountExCode: 'SUB_ACCOUNT_EX_CODE',
    SupplierName: 'SUPPLIER_NAME',
    SupplierExCode: 'SUPPLIER_EX_CODE',
    DimensionName: 'DIMENSION_NAME',
} as const;

export type ActualImportMappingItemDataTypeEnum = typeof ActualImportMappingItemDataTypeEnum[keyof typeof ActualImportMappingItemDataTypeEnum];

export interface ActualImportMappingSubsidiaryCode {
    'code': string;
    'id': IDImpl;
    'name': NameVO;
}
export interface ActualImportMappingSubsidiaryCodeData {
    'code': string;
    'id': IDImpl;
    'name': NameVO;
}
export interface ActualMonthRangeView {
    'latestMonth'?: string;
}
export interface ActualPlanSelect {
    'planIds': Array<string>;
    'planningProjectIds': Array<string>;
    'requireActual': boolean;
}
export interface ActualsImportMappingView {
    'actualImportMappingColumnFilters': Array<ActualImportMappingFilterData>;
    'actualImportMappingItems': Array<ActualImportMappingItemData>;
    'actualImportMappingRowFilters': Array<ActualImportMappingFilterData>;
    'actualImportMappingSubsidiaryCodes': Array<ActualImportMappingSubsidiaryCodeData>;
    'amountDataDirection': ActualsImportMappingViewAmountDataDirectionEnum;
    'createdAt': string;
    'headerRowIndex': number;
    'id': IDImpl;
    'name': string;
    'processSettingIds': Array<IDImpl>;
    'repeatColumnHeaderType'?: ActualsImportMappingViewRepeatColumnHeaderTypeEnum;
    'updatedAt': string;
}

export const ActualsImportMappingViewAmountDataDirectionEnum = {
    RowColumn: 'ROW_COLUMN',
    Column: 'COLUMN',
} as const;

export type ActualsImportMappingViewAmountDataDirectionEnum = typeof ActualsImportMappingViewAmountDataDirectionEnum[keyof typeof ActualsImportMappingViewAmountDataDirectionEnum];
export const ActualsImportMappingViewRepeatColumnHeaderTypeEnum = {
    Date: 'DATE',
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
} as const;

export type ActualsImportMappingViewRepeatColumnHeaderTypeEnum = typeof ActualsImportMappingViewRepeatColumnHeaderTypeEnum[keyof typeof ActualsImportMappingViewRepeatColumnHeaderTypeEnum];

export interface AddBSAccountRequestBody {
    'parentAccountId'?: string;
    'targetAccountId': string;
}
export interface AddDimensionTreeNodeRequestBody {
    'parentDimensionTagId'?: string;
    'targetDimensionTagId': string;
}
export interface AddNodeToNonFinancialAccountTreeBody {
    'parentNode'?: NonFinancialAccountTreeNodeBody;
    'targetNode': NonFinancialAccountTreeNodeBody;
}
export interface AddPeriodSumFormulaRequestBody {
    'endPeriod': string;
    'name': string;
    'previousPeriodId': string;
    'startPeriod': string;
}
export interface AddableNotIncludedAccountsView {
    'listAccountView': Array<NotIncludedAccountView>;
}
export interface AiChatCustomPromptView {
    'companyContext': string;
    'reportTemplate': string;
}
export interface AiChatTermsConsentView {
    'consented': boolean;
    'requiresReconsent': boolean;
}
export interface AllPlanSheetsView {
    'planMasters': Array<PlanMasterWithPlanSheetsView>;
}
export interface AllReportCommentCellLabelView {
    'columnLabel': string;
    'dataLabel': string;
    'rowLabel': string;
}
export interface AllReportCommentLatestCommentView {
    'author': ReportCellCommentAuthorView;
    'commentId': string;
    'commentText': string;
    'createdAt': string;
}
export interface AllReportCommentView {
    'allowed': AllReportCommentViewAllowedEnum;
    'cellCommentId': string;
    'cellLabel': AllReportCommentCellLabelView;
    'commentCount': number;
    'latestComment': AllReportCommentLatestCommentView;
    'reportId': string;
    'reportName': string;
    'threadId': string;
}

export const AllReportCommentViewAllowedEnum = {
    All: 'ALL',
    Restricted: 'RESTRICTED',
} as const;

export type AllReportCommentViewAllowedEnum = typeof AllReportCommentViewAllowedEnum[keyof typeof AllReportCommentViewAllowedEnum];

export interface AllocationAccountDto {
    'accountType': AllocationAccountDtoAccountTypeEnum;
    'code': string;
    'id': string;
    'name': string;
}

export const AllocationAccountDtoAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type AllocationAccountDtoAccountTypeEnum = typeof AllocationAccountDtoAccountTypeEnum[keyof typeof AllocationAccountDtoAccountTypeEnum];

export interface AllocationAxisCondition {
    'axisId': string;
    'dest': AxisTagsWithTree;
    'src': AxisTagsWithTree;
}
export interface AllocationDepartmentDto {
    'code': string;
    'id': string;
    'name': string;
}
export interface AllocationDimensionDto {
    'dimensionId': string;
    'dimensionName': string;
    'dimensionNumber': number;
}
export interface AllocationDimensionTagDto {
    'code': string;
    'id': string;
    'name': string;
}
export interface AllocationPatternParam {
    'allocationPatternId': string;
    'allocationPatternName': string;
}
export interface AllocationResultKey {
    'dataSourceId': string;
    'patternId': string;
    'yearMonth': string;
}
export interface AllocationRuleDetailSummary {
    'id': string;
    'name': string;
    'referencingDataSourceList': Array<AllocationRuleReferencingDataSource>;
    'steps': Array<AllocationTransferStepListItem>;
}
export interface AllocationRuleReferencingDataSource {
    'dataSourceName': string;
    'yearMonthList': Array<string>;
}
export interface AllocationRuleSummaryDto {
    'id': string;
    'name': string;
    'stepIds': Array<string>;
}
export interface AllocationStandardDestination {
    'id': string;
    'name': string;
    'weights': Array<AllocationStandardYearMonthWeight>;
}
export interface AllocationStandardDto {
    'allocationStandardReference'?: AllocationStandardReferenceDto;
    'allocationStandardUpdated'?: AllocationStandardUpdatedDto;
    'dimensionId'?: string;
    'dimensionName'?: string;
    'hasReferencePlanOrActual': boolean;
    'id': string;
    'isDimensionEnabled': boolean;
    'name': string;
    'yearMonthStandards': Array<AllocationYearMonthStandardDto>;
}
export interface AllocationStandardExcelFileExistsResponse {
    'exists': boolean;
}
export interface AllocationStandardLastUpdatedUserDto {
    'firstName': string;
    'id': string;
    'lastName': string;
}
export interface AllocationStandardReferenceAccountDto {
    'accountType': string;
    'id': string;
    'name': string;
}
export interface AllocationStandardReferenceDto {
    'accounts': Array<AllocationStandardReferenceAccountDto>;
    'planMaster'?: AllocationStandardReferencePlanMasterDto;
    'referenceValueType': string;
}
export interface AllocationStandardReferencePlanMasterDto {
    'id': string;
    'name': string;
}
export interface AllocationStandardSum {
    'percentage': string;
    'weight': string;
    'yearMonth': string;
}
export interface AllocationStandardSummaryDto {
    'destinationDepartments': Array<AllocationDepartmentDto>;
    'destinationDimension'?: AllocationDimensionDto;
    'destinationDimensionTags'?: Array<AllocationDimensionTagDto>;
    'endYearMonth'?: string;
    'id': string;
    'isDimensionEnabled': boolean;
    'name': string;
    'referenceValueType'?: AllocationStandardSummaryDtoReferenceValueTypeEnum;
    'startYearMonth'?: string;
}

export const AllocationStandardSummaryDtoReferenceValueTypeEnum = {
    OwnValue: 'OWN_VALUE',
    SumValue: 'SUM_VALUE',
} as const;

export type AllocationStandardSummaryDtoReferenceValueTypeEnum = typeof AllocationStandardSummaryDtoReferenceValueTypeEnum[keyof typeof AllocationStandardSummaryDtoReferenceValueTypeEnum];

export interface AllocationStandardSummaryView {
    'dataSourceId': string;
    'dataSourceName': string;
    'referenceAccountNames'?: Array<string>;
    'referenceSource': string;
}
export interface AllocationStandardUpdatedDto {
    'lastUpdatedAt': string;
    'lastUpdatedUser': AllocationStandardLastUpdatedUserDto;
}
export interface AllocationStandardView {
    'axisName': string;
    'destinations': Array<AllocationStandardDestination>;
    'sums': Array<AllocationStandardSum>;
}
export interface AllocationStandardWeightDto {
    'departmentCode': string;
    'departmentId': string;
    'departmentName': string;
    'dimensionTagCode'?: string;
    'dimensionTagId'?: string;
    'dimensionTagName'?: string;
    'percentage': number;
    'weight': number;
}
export interface AllocationStandardYearMonthWeight {
    'percentage': string;
    'weight': string;
    'yearMonth': string;
}
export interface AllocationStepSummaryView {
    'allocationDestination': AxisSummaryView;
    'allocationSource': AxisSummaryView;
    'allocationStandard': AllocationStandardSummaryView;
    'filterConditions': Array<AxisSummaryView>;
    'loopCondition'?: AxisSummaryView;
    'stepId': string;
    'stepName': string;
}
export interface AllocationStepView {
    'allocationStandardId'?: string;
    'allocationStandardName'?: string;
    'description'?: string;
    'destinationAccount'?: AllocationAccountDto;
    'destinationDepartments': Array<AllocationDepartmentDto>;
    'destinationDimensionTagIds'?: Array<string>;
    'id': string;
    'name': string;
    'order': number;
    'ruleId': string;
    'ruleName': string;
    'sourceAccounts': Array<AllocationAccountDto>;
    'sourceDepartments': Array<AllocationDepartmentDto>;
    'sourceDimensionDimensionTagIdsMap'?: { [key: string]: Array<string>; };
    'stepType': AllocationStepViewStepTypeEnum;
}

export const AllocationStepViewStepTypeEnum = {
    Allocation: 'ALLOCATION',
    Transfer: 'TRANSFER',
} as const;

export type AllocationStepViewStepTypeEnum = typeof AllocationStepViewStepTypeEnum[keyof typeof AllocationStepViewStepTypeEnum];

export interface AllocationStrategyDto {
    'eachMonthResults': Array<LastAllocationResultDto>;
    'name': string;
    'planId'?: string;
    'targetType': AllocationStrategyDtoTargetTypeEnum;
}

export const AllocationStrategyDtoTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type AllocationStrategyDtoTargetTypeEnum = typeof AllocationStrategyDtoTargetTypeEnum[keyof typeof AllocationStrategyDtoTargetTypeEnum];

export interface AllocationStrategySummaryDto {
    'name': string;
    'planId'?: string;
    'targetType': AllocationStrategySummaryDtoTargetTypeEnum;
}

export const AllocationStrategySummaryDtoTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type AllocationStrategySummaryDtoTargetTypeEnum = typeof AllocationStrategySummaryDtoTargetTypeEnum[keyof typeof AllocationStrategySummaryDtoTargetTypeEnum];

export interface AllocationTransferStepListItem {
    'description'?: string;
    'id': string;
    'name': string;
    'order': number;
    'standardName'?: string;
    'stepType': AllocationTransferStepListItemStepTypeEnum;
}

export const AllocationTransferStepListItemStepTypeEnum = {
    Allocation: 'ALLOCATION',
    Transfer: 'TRANSFER',
} as const;

export type AllocationTransferStepListItemStepTypeEnum = typeof AllocationTransferStepListItemStepTypeEnum[keyof typeof AllocationTransferStepListItemStepTypeEnum];

export interface AllocationYearMonthStandardDto {
    'allocationStandardWeights': Array<AllocationStandardWeightDto>;
    'sumOfWeight': number;
    'yearMonth': string;
}
export interface AmountErrorView {
    'message': string;
    'value': string;
}
export interface AppliedNumberLimitsView {
    'limits': Array<NumberLimitView>;
}
export interface ApplyAccountConversionRuleBody {
    'targetMonth': string;
}
export interface ApproveErrorMessage {
    'departmentId': string;
    'departmentName': string;
    'message': string;
    'planUpdateRequestId': string;
}
export interface ApprovePlanUpdateRequestBody {
    'planExchangeRateId'?: string;
}
export interface AssignSimulationConversionRulesetBody {
    'conversionRulesetId': string;
}
export interface AssignUserDepartmentParam {
    'userId': string;
}
export interface AssignedDepartmentFlattenView {
    'departmentId': string;
    'departmentName': string;
}
export interface AssignmentEachDepartmentDetailView {
    'userId': string;
}
export interface AssignmentEachDepartmentView {
    'assignments': Array<AssignmentEachDepartmentDetailView>;
    'departmentId': string;
}
export interface AvailableTenantView {
    'tenantId': string;
    'tenantName': string;
}
export interface AxisSummaryView {
    'axisId': string;
    'axisName': string;
    'axisTags': Array<AxisTagSummaryView>;
}
export interface AxisTagSummaryView {
    'axisTagId': string;
    'axisTagName': string;
}
export interface AxisTagsWithTree {
    'tagIds': Array<IdWithReferenceType>;
    'treeId': string;
}
export interface BSAccountFlatTreeView {
    'id': string;
    'items': Array<BSAccountTreeNodeView>;
    'openNodeIds': Array<string>;
}
export interface BSAccountFlatTreeViewForCandidate {
    'id': string;
    'items': Array<BSAccountTreeNodeView>;
}
export interface BSAccountTreeNameView {
    'id': string;
    'name': string;
}
export interface BSAccountTreeNodeView {
    'accountType': BSAccountTreeNodeViewAccountTypeEnum;
    'accountingSystemCodePair'?: AccountingSystemCodePairView;
    'calculationType': BSAccountTreeNodeViewCalculationTypeEnum;
    'code': string;
    'id': string;
    'level': number;
    'matched': boolean;
    'matchedKeyword': MatchedAccountKeywordView;
    'name': string;
    'parentId'?: string;
    'rowType': BSAccountTreeNodeViewRowTypeEnum;
    'viewControlType': BSAccountTreeNodeViewViewControlTypeEnum;
}

export const BSAccountTreeNodeViewAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type BSAccountTreeNodeViewAccountTypeEnum = typeof BSAccountTreeNodeViewAccountTypeEnum[keyof typeof BSAccountTreeNodeViewAccountTypeEnum];
export const BSAccountTreeNodeViewCalculationTypeEnum = {
    Normal: 'NORMAL',
} as const;

export type BSAccountTreeNodeViewCalculationTypeEnum = typeof BSAccountTreeNodeViewCalculationTypeEnum[keyof typeof BSAccountTreeNodeViewCalculationTypeEnum];
export const BSAccountTreeNodeViewRowTypeEnum = {
    Account: 'ACCOUNT',
    AccountOwnValue: 'ACCOUNT_OWN_VALUE',
} as const;

export type BSAccountTreeNodeViewRowTypeEnum = typeof BSAccountTreeNodeViewRowTypeEnum[keyof typeof BSAccountTreeNodeViewRowTypeEnum];
export const BSAccountTreeNodeViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type BSAccountTreeNodeViewViewControlTypeEnum = typeof BSAccountTreeNodeViewViewControlTypeEnum[keyof typeof BSAccountTreeNodeViewViewControlTypeEnum];

export interface BSReportConditionSchema {
    'cellGroupOrders': Array<CellGroupOrder>;
    'columnAggregationDimension': ColumnAggregationDimension;
    'comparisonConditions': Array<ComparisonCondition>;
    'currencyCode': string;
    'dataConditions': Array<DataCondition>;
    'isShowEmptyRows': boolean;
    'isTreeView': boolean;
    'rowAggregationDimensions': Array<RowAggregationDimension>;
    'showCumulativeRow'?: boolean;
    'showNumbersIn': BSReportConditionSchemaShowNumbersInEnum;
    'showSumRow': boolean;
    'sortCondition'?: SortCondition;
}

export const BSReportConditionSchemaShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type BSReportConditionSchemaShowNumbersInEnum = typeof BSReportConditionSchemaShowNumbersInEnum[keyof typeof BSReportConditionSchemaShowNumbersInEnum];

export interface BaseConditionRequestBody {
    'accountId': MaybeOwnValueAccountId;
    'accountTreeId': string;
    'departmentId': MaybeOwnValueDepartmentId;
    'orgTreeId'?: string;
    'requireAllocatedItem': boolean;
}
export interface Board {
    'boardFilterConditions': Array<DimensionFilter>;
    'dashboardId': IDImpl;
    'displayOrder': number;
    'id': IDImpl;
    'name': NameVO;
}
export interface BoardFilterValidationResponse {
    'displayMessages': Array<DisplayMessageView>;
    'validatedFilters': Array<DimensionFilter>;
}
export interface BoardUsageView {
    'boardId': string;
    'boardName': string;
    'dashboardId': string;
    'dashboardName': string;
}
export interface BoardView {
    'board': Board;
    'boardFilterConditions': Array<DimensionFilter>;
    'createdAt': string;
    'createdUserName': string;
    'updatedAt': string;
    'updatedUserName': string;
    'widgets': Array<WidgetView>;
}
export interface BsNotIncludedAccountView {
    'accountView': AccountView;
    'isVisible': boolean;
}
export interface BsNotIncludedAccountsView {
    'listAccountView': Array<BsNotIncludedAccountView>;
}
export interface BsReferenceAccountsResponse {
    'bsAccountIds': Array<string>;
}
export interface BulkPlanUpdateRequestBody {
    'currencyCode'?: string;
    'planExchangeRateId'?: string;
    'planUpdateRequestIds': Array<string>;
}
export interface BulkUpdateAccountTypeRequestBody {
    'items': Array<UpdateAccountTypeWithIdRequestBody>;
}
export interface BySpec {
    'config': KpiCardConfig;
    'reportId': string;
    'title': string;
    'viewFilterConditions'?: Array<DimensionFilter>;
}
export interface CFAccountFlatTreeViewForCandidate {
    'id': string;
    'items': Array<CfAccountFlatTreeNodeView>;
}
export interface CFReportConditionSchema {
    'cellGroupOrders': Array<CellGroupOrder>;
    'columnAggregationDimension': ColumnAggregationDimension;
    'comparisonConditions': Array<ComparisonCondition>;
    'currencyCode': string;
    'dataConditions': Array<DataCondition>;
    'isShowEmptyRows': boolean;
    'isTreeView': boolean;
    'rowAggregationDimensions': Array<RowAggregationDimension>;
    'showCumulativeRow'?: boolean;
    'showNumbersIn': CFReportConditionSchemaShowNumbersInEnum;
    'showSumRow': boolean;
    'sortCondition'?: SortCondition;
}

export const CFReportConditionSchemaShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type CFReportConditionSchemaShowNumbersInEnum = typeof CFReportConditionSchemaShowNumbersInEnum[keyof typeof CFReportConditionSchemaShowNumbersInEnum];

export interface CalculateActionParams {
    'formula': string;
}
export interface CalculatedAccountView {
    'code': string;
    'formula': string;
    'id': string;
    'isSelectable': boolean;
    'name': string;
    'roundingPrecision': CalculatedAccountViewRoundingPrecisionEnum;
    'valueFormat': CalculatedAccountViewValueFormatEnum;
}

export const CalculatedAccountViewRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type CalculatedAccountViewRoundingPrecisionEnum = typeof CalculatedAccountViewRoundingPrecisionEnum[keyof typeof CalculatedAccountViewRoundingPrecisionEnum];
export const CalculatedAccountViewValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type CalculatedAccountViewValueFormatEnum = typeof CalculatedAccountViewValueFormatEnum[keyof typeof CalculatedAccountViewValueFormatEnum];

export interface CalculatedAccountsView {
    'items': Array<CalculatedAccountView>;
}
export interface CellAddress {
    'key': PlanUpdateRequestMappingShowNumbersInKey;
}
export interface CellDimensionCondition {
    'dimensionTreeId'?: string;
    'dimensionType': CellDimensionConditionDimensionTypeEnum;
    'id': string;
    'periodAggregation'?: CellDimensionConditionPeriodAggregationEnum;
}

export const CellDimensionConditionDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION1',
    Dimension2: 'DIMENSION2',
    Dimension3: 'DIMENSION3',
    Dimension4: 'DIMENSION4',
    Dimension5: 'DIMENSION5',
    Dimension6: 'DIMENSION6',
    Dimension7: 'DIMENSION7',
    Period: 'PERIOD',
} as const;

export type CellDimensionConditionDimensionTypeEnum = typeof CellDimensionConditionDimensionTypeEnum[keyof typeof CellDimensionConditionDimensionTypeEnum];
export const CellDimensionConditionPeriodAggregationEnum = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    FiscalYear: 'FISCAL_YEAR',
    FiscalHalfYear: 'FISCAL_HALF_YEAR',
} as const;

export type CellDimensionConditionPeriodAggregationEnum = typeof CellDimensionConditionPeriodAggregationEnum[keyof typeof CellDimensionConditionPeriodAggregationEnum];

export interface CellGroupOrder {
    'key': string;
    'type': CellGroupOrderTypeEnum;
}

export const CellGroupOrderTypeEnum = {
    Data: 'DATA',
    Comparison: 'COMPARISON',
} as const;

export type CellGroupOrderTypeEnum = typeof CellGroupOrderTypeEnum[keyof typeof CellGroupOrderTypeEnum];

export interface CellGroupOrderKey {
    'value': string;
}
export interface CellGroupOrderKeyImpl {
    'value': string;
}
export interface CellGroupView {
    'cells': Array<CellGroupViewCellsInner>;
    'valueFormat'?: CellGroupViewValueFormatEnum;
}

export const CellGroupViewValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type CellGroupViewValueFormatEnum = typeof CellGroupViewValueFormatEnum[keyof typeof CellGroupViewValueFormatEnum];

/**
 * @type CellGroupViewCellsInner
 */
export type CellGroupViewCellsInner = ComparisonFormulaCellView | DataCellView;

export interface CellView {
    'eitherAmountOrError'?: EitherAmountOrErrorView;
    'id': string;
    'orderKey': CellGroupOrderKeyImpl;
    'type': ReportCellType;
}


export interface CfAccount {
    'cfAccountId': IDImpl;
    'cfAccountReferenceType': CfAccountCfAccountReferenceTypeEnum;
    'code': string;
    'name': string;
    'referenceAccountIds'?: Array<IDImpl>;
}

export const CfAccountCfAccountReferenceTypeEnum = {
    NetCashEquivalents: 'NET_CASH_EQUIVALENTS',
    EndingBalanceCashEquivalents: 'ENDING_BALANCE_CASH_EQUIVALENTS',
    BeginningBalanceCashEquivalents: 'BEGINNING_BALANCE_CASH_EQUIVALENTS',
    ReferPl: 'REFER_PL',
    ReferBs: 'REFER_BS',
    AggregationOfSubHierarchy: 'AGGREGATION_OF_SUB_HIERARCHY',
} as const;

export type CfAccountCfAccountReferenceTypeEnum = typeof CfAccountCfAccountReferenceTypeEnum[keyof typeof CfAccountCfAccountReferenceTypeEnum];

export interface CfAccountFlatTreeNodeView {
    'accountType': CfAccountFlatTreeNodeViewAccountTypeEnum;
    'calculationType': CfAccountFlatTreeNodeViewCalculationTypeEnum;
    'canInsertNewAccount': boolean;
    'canMove': boolean;
    'cfAccountReference'?: CfAccountReferenceView;
    'code': string;
    'hasIncompleteSettings'?: boolean;
    'id': string;
    'level': number;
    'matched': boolean;
    'matchedKeyword': MatchedCFAccountKeywordView;
    'name': string;
    'parentId'?: string;
    'viewControlType': CfAccountFlatTreeNodeViewViewControlTypeEnum;
}

export const CfAccountFlatTreeNodeViewAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type CfAccountFlatTreeNodeViewAccountTypeEnum = typeof CfAccountFlatTreeNodeViewAccountTypeEnum[keyof typeof CfAccountFlatTreeNodeViewAccountTypeEnum];
export const CfAccountFlatTreeNodeViewCalculationTypeEnum = {
    Normal: 'NORMAL',
} as const;

export type CfAccountFlatTreeNodeViewCalculationTypeEnum = typeof CfAccountFlatTreeNodeViewCalculationTypeEnum[keyof typeof CfAccountFlatTreeNodeViewCalculationTypeEnum];
export const CfAccountFlatTreeNodeViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type CfAccountFlatTreeNodeViewViewControlTypeEnum = typeof CfAccountFlatTreeNodeViewViewControlTypeEnum[keyof typeof CfAccountFlatTreeNodeViewViewControlTypeEnum];

export interface CfAccountFlatTreeView {
    'items': Array<CfAccountFlatTreeNodeView>;
    'meta'?: CfAccountTreeMetaView;
    'openNodeIds': Array<string>;
}
export interface CfAccountReferenceView {
    'cashIncreaseDecrease': CfAccountReferenceViewCashIncreaseDecreaseEnum;
    'cfAccountId': string;
    'referenceAccounts': Array<AccountView>;
    'referenceType': CfAccountReferenceViewReferenceTypeEnum;
}

export const CfAccountReferenceViewCashIncreaseDecreaseEnum = {
    Increase: 'INCREASE',
    Decrease: 'DECREASE',
} as const;

export type CfAccountReferenceViewCashIncreaseDecreaseEnum = typeof CfAccountReferenceViewCashIncreaseDecreaseEnum[keyof typeof CfAccountReferenceViewCashIncreaseDecreaseEnum];
export const CfAccountReferenceViewReferenceTypeEnum = {
    NetCashEquivalents: 'NET_CASH_EQUIVALENTS',
    EndingBalanceCashEquivalents: 'ENDING_BALANCE_CASH_EQUIVALENTS',
    BeginningBalanceCashEquivalents: 'BEGINNING_BALANCE_CASH_EQUIVALENTS',
    ReferPl: 'REFER_PL',
    ReferBs: 'REFER_BS',
    AggregationOfSubHierarchy: 'AGGREGATION_OF_SUB_HIERARCHY',
} as const;

export type CfAccountReferenceViewReferenceTypeEnum = typeof CfAccountReferenceViewReferenceTypeEnum[keyof typeof CfAccountReferenceViewReferenceTypeEnum];

export interface CfAccountTreeMetaView {
    'id': string;
    'name': string;
    'plAccountTreeMeta': AccountTreeMetaView;
    'tenantId': string;
}
export interface ColumnAggregationDimension {
    'dimensionTreeId'?: string;
    'dimensionType': ColumnAggregationDimensionDimensionTypeEnum;
    'periodAggregation'?: ColumnAggregationDimensionPeriodAggregationEnum;
    'visibleIds': Array<string>;
}

export const ColumnAggregationDimensionDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Period: 'PERIOD',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type ColumnAggregationDimensionDimensionTypeEnum = typeof ColumnAggregationDimensionDimensionTypeEnum[keyof typeof ColumnAggregationDimensionDimensionTypeEnum];
export const ColumnAggregationDimensionPeriodAggregationEnum = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    FiscalYear: 'FISCAL_YEAR',
    FiscalHalfYear: 'FISCAL_HALF_YEAR',
} as const;

export type ColumnAggregationDimensionPeriodAggregationEnum = typeof ColumnAggregationDimensionPeriodAggregationEnum[keyof typeof ColumnAggregationDimensionPeriodAggregationEnum];

export interface ColumnHeaderLabelOverride {
    'customLabel'?: string;
    'id': string;
}
export interface ComboBarConfig {
    'colorPalettes'?: { [key: string]: string; };
    'showAsBreakdown': boolean;
    'showCumulativeRow': boolean;
    'showDataLabels': boolean;
    'showStackTotalLabels': boolean;
    'stackingMode': ComboBarConfigStackingModeEnum;
    'visibleMetrics': Array<ComboBarConfigVisibleMetricsEnum>;
    'visibleRowTagIds': Array<Array<string>>;
    'yaxisLabel': string;
    'yaxisMax'?: number;
    'yaxisMin'?: number;
}

export const ComboBarConfigStackingModeEnum = {
    None: 'NONE',
    Normal: 'NORMAL',
    Percent: 'PERCENT',
} as const;

export type ComboBarConfigStackingModeEnum = typeof ComboBarConfigStackingModeEnum[keyof typeof ComboBarConfigStackingModeEnum];
export const ComboBarConfigVisibleMetricsEnum = {
    DataA: 'DATA_A',
    DataB: 'DATA_B',
    DataC: 'DATA_C',
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type ComboBarConfigVisibleMetricsEnum = typeof ComboBarConfigVisibleMetricsEnum[keyof typeof ComboBarConfigVisibleMetricsEnum];

export interface ComboChartDataView {
    'barChartData': GraphDataView;
    'categoryAxisLabels': Array<string>;
    'cellCount': number;
    'lineChartData': GraphDataView;
}
export interface ComboLineConfig {
    'colorPalettes'?: { [key: string]: string; };
    'showCumulativeRow': boolean;
    'showDataLabels': boolean;
    'visibleMetrics': Array<ComboLineConfigVisibleMetricsEnum>;
    'visibleRowTagIds': Array<Array<string>>;
    'yaxisLabel': string;
    'yaxisMax'?: number;
    'yaxisMin'?: number;
}

export const ComboLineConfigVisibleMetricsEnum = {
    DataA: 'DATA_A',
    DataB: 'DATA_B',
    DataC: 'DATA_C',
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type ComboLineConfigVisibleMetricsEnum = typeof ComboLineConfigVisibleMetricsEnum[keyof typeof ComboLineConfigVisibleMetricsEnum];

export interface ComparisonCellDetailV3View {
    'commentCount'?: number;
    'hasDetails': boolean;
    'periodKeyValue': string;
    'periodLabel': string;
    'sum'?: number;
}
export interface ComparisonCellV3View {
    'comparisonDetail': ComparisonDetailView;
    'id': string;
    'periodPairKey': string;
    'planA': ComparisonCellDetailV3View;
    'planB': ComparisonCellDetailV3View;
}
export interface ComparisonCondition {
    'calculationFormula': ComparisonConditionCalculationFormulaEnum;
    'comparisonType': ComparisonConditionComparisonTypeEnum;
}

export const ComparisonConditionCalculationFormulaEnum = {
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type ComparisonConditionCalculationFormulaEnum = typeof ComparisonConditionCalculationFormulaEnum[keyof typeof ComparisonConditionCalculationFormulaEnum];
export const ComparisonConditionComparisonTypeEnum = {
    Diff: 'DIFF',
    DiffRatio: 'DIFF_RATIO',
    AchievementRatio: 'ACHIEVEMENT_RATIO',
    SpecificAccountRatio: 'SPECIFIC_ACCOUNT_RATIO',
} as const;

export type ComparisonConditionComparisonTypeEnum = typeof ComparisonConditionComparisonTypeEnum[keyof typeof ComparisonConditionComparisonTypeEnum];

export interface ComparisonDetailView {
    'diffRatio'?: ComparisonDiffRatioView;
    'specificAccountRatio'?: ComparisonSpecificAccountRatioView;
}
export interface ComparisonDiffRatioView {
    'diff'?: number;
    'diffCommentCount'?: number;
    'diffHighlight': boolean;
    'ratio'?: number;
    'ratioCommentCount'?: number;
    'ratioHighlight': boolean;
}
export interface ComparisonFlatTreeItemV3View {
    'accountId': string;
    'accountType': ComparisonFlatTreeItemV3ViewAccountTypeEnum;
    'code': string;
    'comparisonDetail': ComparisonDetailView;
    'data': Array<ComparisonCellV3View>;
    'id': string;
    'level': number;
    'name': string;
    'parentId'?: string;
    'planASum'?: number;
    'planBSum'?: number;
    'rowType': ComparisonFlatTreeItemV3ViewRowTypeEnum;
    'viewControlType': ComparisonFlatTreeItemV3ViewViewControlTypeEnum;
}

export const ComparisonFlatTreeItemV3ViewAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type ComparisonFlatTreeItemV3ViewAccountTypeEnum = typeof ComparisonFlatTreeItemV3ViewAccountTypeEnum[keyof typeof ComparisonFlatTreeItemV3ViewAccountTypeEnum];
export const ComparisonFlatTreeItemV3ViewRowTypeEnum = {
    Account: 'ACCOUNT',
    AccountOwnValue: 'ACCOUNT_OWN_VALUE',
} as const;

export type ComparisonFlatTreeItemV3ViewRowTypeEnum = typeof ComparisonFlatTreeItemV3ViewRowTypeEnum[keyof typeof ComparisonFlatTreeItemV3ViewRowTypeEnum];
export const ComparisonFlatTreeItemV3ViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type ComparisonFlatTreeItemV3ViewViewControlTypeEnum = typeof ComparisonFlatTreeItemV3ViewViewControlTypeEnum[keyof typeof ComparisonFlatTreeItemV3ViewViewControlTypeEnum];

export interface ComparisonFlatTreeV3View {
    'items': Array<ComparisonFlatTreeItemV3View>;
}
export interface ComparisonFormulaCellView {
    'eitherAmountOrError'?: EitherAmountOrErrorView;
    'id': string;
    'orderKey': CellGroupOrderKeyImpl;
    'type': ReportCellType;
}


export interface ComparisonLabelOverride {
    'customComparisonTypeLabel'?: string;
    'customFormulaLabel'?: string;
    'originalComparisonTypeLabel': string;
    'originalFormulaLabel': string;
}
export interface ComparisonPeriodPair {
    'periodPairKey': string;
    'planA': PeriodComparisonCellTypeV3View;
    'planB': PeriodComparisonCellTypeV3View;
}
export interface ComparisonSheetSelectedConditionDetailDto {
    'accountTreeId': string;
    'aggregate': ComparisonSheetSelectedConditionDetailDtoAggregateEnum;
    'departmentIds': Array<string>;
    'highlightThreshold'?: number;
    'highlightType'?: ComparisonSheetSelectedConditionDetailDtoHighlightTypeEnum;
    'orgTreeId': string;
    'planAActualEndYearMonth'?: string;
    'planAActualStartYearMonth'?: string;
    'planAEndYearMonth': string;
    'planAMasterId'?: string;
    'planAShowActual': boolean;
    'planAStartYearMonth': string;
    'planAUpdateProjectId'?: string;
    'planBActualEndYearMonth'?: string;
    'planBActualStartYearMonth'?: string;
    'planBEndYearMonth': string;
    'planBMasterId'?: string;
    'planBShowActual': boolean;
    'planBStartYearMonth': string;
    'planBUpdateProjectId'?: string;
    'requireAllocatedItem': boolean;
}

export const ComparisonSheetSelectedConditionDetailDtoAggregateEnum = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    FiscalYear: 'FISCAL_YEAR',
    FiscalHalfYear: 'FISCAL_HALF_YEAR',
} as const;

export type ComparisonSheetSelectedConditionDetailDtoAggregateEnum = typeof ComparisonSheetSelectedConditionDetailDtoAggregateEnum[keyof typeof ComparisonSheetSelectedConditionDetailDtoAggregateEnum];
export const ComparisonSheetSelectedConditionDetailDtoHighlightTypeEnum = {
    DiffAmount: 'DIFF_AMOUNT',
    DiffRatio: 'DIFF_RATIO',
} as const;

export type ComparisonSheetSelectedConditionDetailDtoHighlightTypeEnum = typeof ComparisonSheetSelectedConditionDetailDtoHighlightTypeEnum[keyof typeof ComparisonSheetSelectedConditionDetailDtoHighlightTypeEnum];

export interface ComparisonSheetSelectedConditionDto {
    'comparisonSheetSelectedConditionGroupId': string;
    'comparisonSheetSelectedConditionId': string;
    'detail': ComparisonSheetSelectedConditionDetailDto;
    'name': string;
}
export interface ComparisonSheetSelectedConditionForSelectionView {
    'conditionGroupId': string;
    'conditionGroupName': string;
}
export interface ComparisonSheetSelectedConditionGroupView {
    'conditionGroupId': string;
    'conditionGroupName': string;
    'conditions': Array<ComparisonSheetSelectedConditionView>;
}
export interface ComparisonSheetSelectedConditionView {
    'comparisonSheetSelectedConditionGroupId': string;
    'comparisonSheetSelectedConditionId': string;
    'createdUserId': string;
    'detail': SelectedConditionDetail;
    'name': string;
}
export interface ComparisonSpecificAccountRatioView {
    'specificAccountRatioA'?: number;
    'specificAccountRatioB'?: number;
}
export interface ComparisonTableMetaV3View {
    'periodPairs': Array<ComparisonPeriodPair>;
    'planA': PlanDetailView;
    'planAActualEnd'?: string;
    'planAActualStart'?: string;
    'planAEnd'?: string;
    'planAStart'?: string;
    'planB': PlanDetailView;
    'planBActualEnd'?: string;
    'planBActualStart'?: string;
    'planBEnd'?: string;
    'planBStart'?: string;
    'roundingMode': ComparisonTableMetaV3ViewRoundingModeEnum;
    'showDecimalPlacesIn': ComparisonTableMetaV3ViewShowDecimalPlacesInEnum;
    'showIn': ComparisonTableMetaV3ViewShowInEnum;
}

export const ComparisonTableMetaV3ViewRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type ComparisonTableMetaV3ViewRoundingModeEnum = typeof ComparisonTableMetaV3ViewRoundingModeEnum[keyof typeof ComparisonTableMetaV3ViewRoundingModeEnum];
export const ComparisonTableMetaV3ViewShowDecimalPlacesInEnum = {
    None: 'NONE',
    One: 'ONE',
    Two: 'TWO',
    Three: 'THREE',
    Four: 'FOUR',
} as const;

export type ComparisonTableMetaV3ViewShowDecimalPlacesInEnum = typeof ComparisonTableMetaV3ViewShowDecimalPlacesInEnum[keyof typeof ComparisonTableMetaV3ViewShowDecimalPlacesInEnum];
export const ComparisonTableMetaV3ViewShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type ComparisonTableMetaV3ViewShowInEnum = typeof ComparisonTableMetaV3ViewShowInEnum[keyof typeof ComparisonTableMetaV3ViewShowInEnum];

export interface ComparisonTableV3View {
    'meta': ComparisonTableMetaV3View;
    'tree': ComparisonFlatTreeV3View;
}
export interface ComparisonWaterfallChartConfig {
    'endDataConditionId': ComparisonWaterfallChartConfigEndDataConditionIdEnum;
    'legendPosition'?: ComparisonWaterfallChartConfigLegendPositionEnum;
    'middlePoints': ComparisonWaterfallMiddlePoints;
    'middleSteps': Array<ComparisonWaterfallMiddleStep>;
    'showCumulativeRow': boolean;
    'showDataLabels': boolean;
    'startDataConditionId': ComparisonWaterfallChartConfigStartDataConditionIdEnum;
    'startEndRowAccountId': string;
    'targetColumnGroupId': string;
    'waterfallType': ComparisonWaterfallChartConfigWaterfallTypeEnum;
    'yaxisLabel': string;
    'yaxisMax'?: number;
    'yaxisMin'?: number;
}

export const ComparisonWaterfallChartConfigEndDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type ComparisonWaterfallChartConfigEndDataConditionIdEnum = typeof ComparisonWaterfallChartConfigEndDataConditionIdEnum[keyof typeof ComparisonWaterfallChartConfigEndDataConditionIdEnum];
export const ComparisonWaterfallChartConfigLegendPositionEnum = {
    Right: 'RIGHT',
    Left: 'LEFT',
    Top: 'TOP',
    Bottom: 'BOTTOM',
    Hidden: 'HIDDEN',
} as const;

export type ComparisonWaterfallChartConfigLegendPositionEnum = typeof ComparisonWaterfallChartConfigLegendPositionEnum[keyof typeof ComparisonWaterfallChartConfigLegendPositionEnum];
export const ComparisonWaterfallChartConfigStartDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type ComparisonWaterfallChartConfigStartDataConditionIdEnum = typeof ComparisonWaterfallChartConfigStartDataConditionIdEnum[keyof typeof ComparisonWaterfallChartConfigStartDataConditionIdEnum];
export const ComparisonWaterfallChartConfigWaterfallTypeEnum = {
    Transition: 'TRANSITION',
    Comparison: 'COMPARISON',
} as const;

export type ComparisonWaterfallChartConfigWaterfallTypeEnum = typeof ComparisonWaterfallChartConfigWaterfallTypeEnum[keyof typeof ComparisonWaterfallChartConfigWaterfallTypeEnum];

export interface ComparisonWaterfallInitialMiddlePoints {
    'ids': Array<string>;
    'rowAggregationType': ComparisonWaterfallInitialMiddlePointsRowAggregationTypeEnum;
}

export const ComparisonWaterfallInitialMiddlePointsRowAggregationTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type ComparisonWaterfallInitialMiddlePointsRowAggregationTypeEnum = typeof ComparisonWaterfallInitialMiddlePointsRowAggregationTypeEnum[keyof typeof ComparisonWaterfallInitialMiddlePointsRowAggregationTypeEnum];

export interface ComparisonWaterfallInitialValuesResult {
    'endDataConditionId': ComparisonWaterfallInitialValuesResultEndDataConditionIdEnum;
    'middlePoints': ComparisonWaterfallInitialMiddlePoints;
    'startDataConditionId': ComparisonWaterfallInitialValuesResultStartDataConditionIdEnum;
    'startEndRowAccountId': string;
    'targetColumnGroupId': string;
    'waterfallType': ComparisonWaterfallInitialValuesResultWaterfallTypeEnum;
}

export const ComparisonWaterfallInitialValuesResultEndDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type ComparisonWaterfallInitialValuesResultEndDataConditionIdEnum = typeof ComparisonWaterfallInitialValuesResultEndDataConditionIdEnum[keyof typeof ComparisonWaterfallInitialValuesResultEndDataConditionIdEnum];
export const ComparisonWaterfallInitialValuesResultStartDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type ComparisonWaterfallInitialValuesResultStartDataConditionIdEnum = typeof ComparisonWaterfallInitialValuesResultStartDataConditionIdEnum[keyof typeof ComparisonWaterfallInitialValuesResultStartDataConditionIdEnum];
export const ComparisonWaterfallInitialValuesResultWaterfallTypeEnum = {
    Transition: 'TRANSITION',
    Comparison: 'COMPARISON',
} as const;

export type ComparisonWaterfallInitialValuesResultWaterfallTypeEnum = typeof ComparisonWaterfallInitialValuesResultWaterfallTypeEnum[keyof typeof ComparisonWaterfallInitialValuesResultWaterfallTypeEnum];

export interface ComparisonWaterfallMatryoshkaAnalysis {
    'ancestorMap': { [key: string]: Array<string>; };
    'independentBars': Array<ComparisonWaterfallStackChild>;
    'stackGroups': Array<ComparisonWaterfallStackGroup>;
}
export interface ComparisonWaterfallMiddlePoints {
    'rowAggregationType': ComparisonWaterfallMiddlePointsRowAggregationTypeEnum;
}

export const ComparisonWaterfallMiddlePointsRowAggregationTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type ComparisonWaterfallMiddlePointsRowAggregationTypeEnum = typeof ComparisonWaterfallMiddlePointsRowAggregationTypeEnum[keyof typeof ComparisonWaterfallMiddlePointsRowAggregationTypeEnum];

export interface ComparisonWaterfallMiddleStep {
    'id'?: string;
    'type': ComparisonWaterfallMiddleStepTypeEnum;
}

export const ComparisonWaterfallMiddleStepTypeEnum = {
    RowItem: 'ROW_ITEM',
    IntermediateSum: 'INTERMEDIATE_SUM',
} as const;

export type ComparisonWaterfallMiddleStepTypeEnum = typeof ComparisonWaterfallMiddleStepTypeEnum[keyof typeof ComparisonWaterfallMiddleStepTypeEnum];

export interface ComparisonWaterfallPreviewRequest {
    'endDataConditionId': ComparisonWaterfallPreviewRequestEndDataConditionIdEnum;
    'middlePoints': ComparisonWaterfallMiddlePoints;
    'middleSteps': Array<ComparisonWaterfallMiddleStep>;
    'reportId': string;
    'showCumulativeRow': boolean;
    'startDataConditionId': ComparisonWaterfallPreviewRequestStartDataConditionIdEnum;
    'startEndRowAccountId': string;
    'targetColumnGroupId': string;
    'viewFilterConditions'?: Array<DimensionFilter>;
}

export const ComparisonWaterfallPreviewRequestEndDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type ComparisonWaterfallPreviewRequestEndDataConditionIdEnum = typeof ComparisonWaterfallPreviewRequestEndDataConditionIdEnum[keyof typeof ComparisonWaterfallPreviewRequestEndDataConditionIdEnum];
export const ComparisonWaterfallPreviewRequestStartDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type ComparisonWaterfallPreviewRequestStartDataConditionIdEnum = typeof ComparisonWaterfallPreviewRequestStartDataConditionIdEnum[keyof typeof ComparisonWaterfallPreviewRequestStartDataConditionIdEnum];

export interface ComparisonWaterfallPreviewResult {
    'amountAxisUnitLabel': string;
    'cellCount': number;
    'matryoshkaAnalysis': ComparisonWaterfallMatryoshkaAnalysis;
    'points': Array<WaterfallPoint>;
    'reportMetadata': GraphReportMetadata;
}
export interface ComparisonWaterfallStackChild {
    'id': string;
    'label': string;
    'value': number;
}
export interface ComparisonWaterfallStackGroup {
    'children': Array<ComparisonWaterfallStackChild>;
    'otherValue': number;
    'parentId': string;
    'parentLabel': string;
    'parentValue': number;
}
export interface ComponentTable {
    'id': IDImpl;
    'type': ComponentTableTypeEnum;
}

export const ComponentTableTypeEnum = {
    Pl: 'PL',
    Bs: 'BS',
    Cf: 'CF',
} as const;

export type ComponentTableTypeEnum = typeof ComponentTableTypeEnum[keyof typeof ComponentTableTypeEnum];

export interface ComponentTableRequestBody {
    'id': string;
    'type': ComponentTableRequestBodyTypeEnum;
}

export const ComponentTableRequestBodyTypeEnum = {
    Pl: 'PL',
    Bs: 'BS',
    Cf: 'CF',
} as const;

export type ComponentTableRequestBodyTypeEnum = typeof ComponentTableRequestBodyTypeEnum[keyof typeof ComponentTableRequestBodyTypeEnum];

export interface CompositeCellGroupView {
    'cells': Array<CellGroupViewCellsInner>;
    'reportId': string;
    'valueFormat'?: CompositeCellGroupViewValueFormatEnum;
}

export const CompositeCellGroupViewValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type CompositeCellGroupViewValueFormatEnum = typeof CompositeCellGroupViewValueFormatEnum[keyof typeof CompositeCellGroupViewValueFormatEnum];

export interface CompositeReportLayoutRequest {
    'reportIds': Array<Array<string>>;
}
export interface CompositeReportMetadataView {
    'currencyCode': string;
    'dataConditions': Array<DataCondition>;
    'reportId': string;
    'reportName': string;
    'rowAggregationDimensions': Array<RowAggregationDimension>;
}
export interface CompositeReportTableView {
    'meta': MetaView;
    'rows': Array<CompositeRowView>;
}
export interface CompositeReportTreeTableView {
    'meta': MetaView;
    'rootRowTreeNodes': Array<MutableTreeNode>;
}
export interface CompositeRowView {
    'cellGroups': Array<CompositeCellGroupView>;
    'rowAggregationKeys': Array<RowAggregationKeyView>;
}
export interface CompositeRowViewForTree {
    'cellGroups': Array<CompositeCellGroupView>;
    'level': number;
    'rowAggregationKeys': Array<RowAggregationKeyView>;
}
export interface CompositeTableWidget {
    'configSchemaVersion': number;
    'id': IDImpl;
    'rows': Array<Array<ComponentTable>>;
}
export interface ConcurrentPostEventParam {
    'effectiveYearMonth': string;
    'ratios': Array<ConcurrentPostEventRatio>;
    'type': ConcurrentPostEventParamTypeEnum;
}

export const ConcurrentPostEventParamTypeEnum = {
    Start: 'START',
    Release: 'RELEASE',
} as const;

export type ConcurrentPostEventParamTypeEnum = typeof ConcurrentPostEventParamTypeEnum[keyof typeof ConcurrentPostEventParamTypeEnum];

export interface ConcurrentPostEventRatio {
    'departmentId': string;
    'dimensionIdToTagIds': Array<DimensionIdToTagId>;
    'ratio': number;
}
export interface ConcurrentPostRatioInfosView {
    'departmentName': string;
    'dimensionTagNames': Array<string>;
    'ratio': number;
}
export interface ConnectedWorkforcePlanningSimulationView {
    'creationStatus'?: string;
    'name': string;
    'simulationId': string;
}
export interface Contains {
    'conditionValue': string;
}
export interface ContractUserTypeAndActiveUserCountDto {
    'activeUserCount': ActiveUserCountDto;
    'contractUserTypeCount': ContractUserTypeCountDto;
}
export interface ContractUserTypeCountDto {
    'view': number;
    'write': number;
}
export interface ConversionRuleDryRunResult {
    'matchResult': Array<PatternDryRunResult>;
    'ruleId': string;
    'ruleName': string;
}
export interface ConversionRulesetConditionDto {
    'description': string;
    'id': string;
    'name': string;
}
export interface ConvertScenarioTableToPlanRequestBody {
    'newPlanName': string;
    'newPlanType': ConvertScenarioTableToPlanRequestBodyNewPlanTypeEnum;
}

export const ConvertScenarioTableToPlanRequestBodyNewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type ConvertScenarioTableToPlanRequestBodyNewPlanTypeEnum = typeof ConvertScenarioTableToPlanRequestBodyNewPlanTypeEnum[keyof typeof ConvertScenarioTableToPlanRequestBodyNewPlanTypeEnum];

export interface CopiedBoardDto {
    'boardId': string;
}
export interface CopiedDashboardResponse {
    'copiedReportCount': number;
    'dashboardId': string;
}
export interface CopiedGraphDto {
    'reportGraphId': string;
}
export interface CopyDimensionTreeBody {
    'dimensionTreeName': string;
}
export interface CopyNonFinancialAccountTreeBody {
    'newName': string;
}
export interface CopyOrganizationTreeParam {
    'treeName': string;
}
export interface CopyStepRequestBody {
    'stepName': string;
}
export interface CopyStepView {
    'id': string;
}
export interface CopyWorkforcePlanningItemConversionRulesetBody {
    'description': string;
    'name': string;
}
export interface CopyWorkforcePlanningItemConversionRulesetView {
    'id': string;
}
export interface CountDepartmentsNotIncludedInOrgDto {
    'count': number;
}
export interface CreateAccountAndAddNonFinancialAccountTreeBody {
    'code': string;
    'externalSystemAccountCode'?: string;
    'name': string;
    'nonFinancialAccountTreeId': string;
    'parentNode'?: NonFinancialAccountTreeNodeBody;
    'roundingPrecision'?: CreateAccountAndAddNonFinancialAccountTreeBodyRoundingPrecisionEnum;
    'valueFormat'?: CreateAccountAndAddNonFinancialAccountTreeBodyValueFormatEnum;
    'viewControlType'?: CreateAccountAndAddNonFinancialAccountTreeBodyViewControlTypeEnum;
}

export const CreateAccountAndAddNonFinancialAccountTreeBodyRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type CreateAccountAndAddNonFinancialAccountTreeBodyRoundingPrecisionEnum = typeof CreateAccountAndAddNonFinancialAccountTreeBodyRoundingPrecisionEnum[keyof typeof CreateAccountAndAddNonFinancialAccountTreeBodyRoundingPrecisionEnum];
export const CreateAccountAndAddNonFinancialAccountTreeBodyValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type CreateAccountAndAddNonFinancialAccountTreeBodyValueFormatEnum = typeof CreateAccountAndAddNonFinancialAccountTreeBodyValueFormatEnum[keyof typeof CreateAccountAndAddNonFinancialAccountTreeBodyValueFormatEnum];
export const CreateAccountAndAddNonFinancialAccountTreeBodyViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type CreateAccountAndAddNonFinancialAccountTreeBodyViewControlTypeEnum = typeof CreateAccountAndAddNonFinancialAccountTreeBodyViewControlTypeEnum[keyof typeof CreateAccountAndAddNonFinancialAccountTreeBodyViewControlTypeEnum];

export interface CreateAccountRequestBody {
    'accountType': CreateAccountRequestBodyAccountTypeEnum;
    'code': string;
    'externalSystemAccountCode'?: string;
    'externalSystemSubAccountCode'?: string;
    'name': string;
    'roundingPrecision'?: CreateAccountRequestBodyRoundingPrecisionEnum;
    'valueFormat'?: CreateAccountRequestBodyValueFormatEnum;
    'viewControlType': CreateAccountRequestBodyViewControlTypeEnum;
}

export const CreateAccountRequestBodyAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type CreateAccountRequestBodyAccountTypeEnum = typeof CreateAccountRequestBodyAccountTypeEnum[keyof typeof CreateAccountRequestBodyAccountTypeEnum];
export const CreateAccountRequestBodyRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type CreateAccountRequestBodyRoundingPrecisionEnum = typeof CreateAccountRequestBodyRoundingPrecisionEnum[keyof typeof CreateAccountRequestBodyRoundingPrecisionEnum];
export const CreateAccountRequestBodyValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type CreateAccountRequestBodyValueFormatEnum = typeof CreateAccountRequestBodyValueFormatEnum[keyof typeof CreateAccountRequestBodyValueFormatEnum];
export const CreateAccountRequestBodyViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type CreateAccountRequestBodyViewControlTypeEnum = typeof CreateAccountRequestBodyViewControlTypeEnum[keyof typeof CreateAccountRequestBodyViewControlTypeEnum];

export interface CreateActualsImportMappingDebitCreditConditionParams {
    'columnIndex': number;
    'conditionType': CreateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum;
    'conditionValue'?: string;
    'debitCredit': CreateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum;
}

export const CreateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type CreateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum = typeof CreateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum[keyof typeof CreateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum];
export const CreateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum = {
    Debit: 'DEBIT',
    Credit: 'CREDIT',
} as const;

export type CreateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum = typeof CreateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum[keyof typeof CreateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum];

export interface CreateActualsImportMappingFilterParams {
    'columnIndex': number;
    'conditionType': CreateActualsImportMappingFilterParamsConditionTypeEnum;
    'conditionValue'?: string;
    'targetType': CreateActualsImportMappingFilterParamsTargetTypeEnum;
}

export const CreateActualsImportMappingFilterParamsConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type CreateActualsImportMappingFilterParamsConditionTypeEnum = typeof CreateActualsImportMappingFilterParamsConditionTypeEnum[keyof typeof CreateActualsImportMappingFilterParamsConditionTypeEnum];
export const CreateActualsImportMappingFilterParamsTargetTypeEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
} as const;

export type CreateActualsImportMappingFilterParamsTargetTypeEnum = typeof CreateActualsImportMappingFilterParamsTargetTypeEnum[keyof typeof CreateActualsImportMappingFilterParamsTargetTypeEnum];

export interface CreateActualsImportMappingItemParams {
    'columnIndex'?: number;
    'dimensionId'?: string;
    'type': CreateActualsImportMappingItemParamsTypeEnum;
}

export const CreateActualsImportMappingItemParamsTypeEnum = {
    Date: 'DATE',
    DebitAmount: 'DEBIT_AMOUNT',
    CreditAmount: 'CREDIT_AMOUNT',
    DebitAccountName: 'DEBIT_ACCOUNT_NAME',
    CreditAccountName: 'CREDIT_ACCOUNT_NAME',
    DocumentId: 'DOCUMENT_ID',
    Description: 'DESCRIPTION',
    DebitAccountExCode: 'DEBIT_ACCOUNT_EX_CODE',
    CreditAccountExCode: 'CREDIT_ACCOUNT_EX_CODE',
    DebitDepartmentName: 'DEBIT_DEPARTMENT_NAME',
    CreditDepartmentName: 'CREDIT_DEPARTMENT_NAME',
    DebitDepartmentExCode: 'DEBIT_DEPARTMENT_EX_CODE',
    CreditDepartmentExCode: 'CREDIT_DEPARTMENT_EX_CODE',
    DebitSubAccountName: 'DEBIT_SUB_ACCOUNT_NAME',
    CreditSubAccountName: 'CREDIT_SUB_ACCOUNT_NAME',
    DebitSubAccountExCode: 'DEBIT_SUB_ACCOUNT_EX_CODE',
    CreditSubAccountExCode: 'CREDIT_SUB_ACCOUNT_EX_CODE',
    DebitSupplierName: 'DEBIT_SUPPLIER_NAME',
    CreditSupplierName: 'CREDIT_SUPPLIER_NAME',
    DebitSupplierExCode: 'DEBIT_SUPPLIER_EX_CODE',
    CreditSupplierExCode: 'CREDIT_SUPPLIER_EX_CODE',
    DebitDimensionName: 'DEBIT_DIMENSION_NAME',
    CreditDimensionName: 'CREDIT_DIMENSION_NAME',
    Amount: 'AMOUNT',
    AccountName: 'ACCOUNT_NAME',
    AccountExCode: 'ACCOUNT_EX_CODE',
    DepartmentName: 'DEPARTMENT_NAME',
    DepartmentExCode: 'DEPARTMENT_EX_CODE',
    SubAccountName: 'SUB_ACCOUNT_NAME',
    SubAccountExCode: 'SUB_ACCOUNT_EX_CODE',
    SupplierName: 'SUPPLIER_NAME',
    SupplierExCode: 'SUPPLIER_EX_CODE',
    DimensionName: 'DIMENSION_NAME',
} as const;

export type CreateActualsImportMappingItemParamsTypeEnum = typeof CreateActualsImportMappingItemParamsTypeEnum[keyof typeof CreateActualsImportMappingItemParamsTypeEnum];

export interface CreateActualsImportMappingParams {
    'actualImportMappingFilters': Array<CreateActualsImportMappingFilterParams>;
    'actualImportMappingItems': Array<CreateActualsImportMappingItemParams>;
    'actualImportMappingSubsidiaryCodes': Array<CreateActualsImportMappingSubsidiaryCodeParams>;
    'actualImportPattern': CreateActualsImportMappingParamsActualImportPatternEnum;
    'actualsImportMappingDebitCreditConditions': Array<CreateActualsImportMappingDebitCreditConditionParams>;
    'amountDataDirection': CreateActualsImportMappingParamsAmountDataDirectionEnum;
    'headerRowIndex': number;
    'journalOrBalance': CreateActualsImportMappingParamsJournalOrBalanceEnum;
    'name': string;
    'processSettingIds': Array<string>;
    'repeatColumnHeaderType'?: CreateActualsImportMappingParamsRepeatColumnHeaderTypeEnum;
}

export const CreateActualsImportMappingParamsActualImportPatternEnum = {
    Divide: 'DIVIDE',
    Combine: 'COMBINE',
    AccountType: 'ACCOUNT_TYPE',
} as const;

export type CreateActualsImportMappingParamsActualImportPatternEnum = typeof CreateActualsImportMappingParamsActualImportPatternEnum[keyof typeof CreateActualsImportMappingParamsActualImportPatternEnum];
export const CreateActualsImportMappingParamsAmountDataDirectionEnum = {
    RowColumn: 'ROW_COLUMN',
    Column: 'COLUMN',
} as const;

export type CreateActualsImportMappingParamsAmountDataDirectionEnum = typeof CreateActualsImportMappingParamsAmountDataDirectionEnum[keyof typeof CreateActualsImportMappingParamsAmountDataDirectionEnum];
export const CreateActualsImportMappingParamsJournalOrBalanceEnum = {
    Journal: 'JOURNAL',
    Balance: 'BALANCE',
} as const;

export type CreateActualsImportMappingParamsJournalOrBalanceEnum = typeof CreateActualsImportMappingParamsJournalOrBalanceEnum[keyof typeof CreateActualsImportMappingParamsJournalOrBalanceEnum];
export const CreateActualsImportMappingParamsRepeatColumnHeaderTypeEnum = {
    Date: 'DATE',
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
} as const;

export type CreateActualsImportMappingParamsRepeatColumnHeaderTypeEnum = typeof CreateActualsImportMappingParamsRepeatColumnHeaderTypeEnum[keyof typeof CreateActualsImportMappingParamsRepeatColumnHeaderTypeEnum];

export interface CreateActualsImportMappingSubsidiaryCodeParams {
    'code': string;
    'name': string;
}
export interface CreateAllocationRuleRequestBody {
    'name': string;
}
export interface CreateAllocationStandardDepartmentsRequestBody {
    /**
     * DepartmentIDに寄せられないか検討して、できるなら消す
     * @deprecated
     */
    'departmentCode': string;
    'departmentId': string;
}
export interface CreateAllocationStandardReferenceRequestBody {
    'accountIds': Array<string>;
    'planId'?: string;
    'referenceValueType': string;
}
export interface CreateAllocationStepRequestBody {
    'allocationStandardId'?: string;
    'description'?: string;
    'destinationAccountId'?: string;
    'destinationDepartmentIds': Array<string>;
    'destinationDimensionTagIds'?: Array<string>;
    'name': string;
    'sourceAccountIds': Array<string>;
    'sourceDepartmentIds': Array<string>;
    'sourceDimensionTagIds'?: Array<string>;
    'stepType': CreateAllocationStepRequestBodyStepTypeEnum;
}

export const CreateAllocationStepRequestBodyStepTypeEnum = {
    Allocation: 'ALLOCATION',
    Transfer: 'TRANSFER',
} as const;

export type CreateAllocationStepRequestBodyStepTypeEnum = typeof CreateAllocationStepRequestBodyStepTypeEnum[keyof typeof CreateAllocationStepRequestBodyStepTypeEnum];

export interface CreateAllocationStrategyRequestBody {
    'yearMonthSet': Array<YearMonthRequestBody>;
}
export interface CreateAndAddDimensionTagsRequestBody {
    'createParam': CreateDimensionTagsRequestBody;
    'parentDimensionTagId': string;
}
export interface CreateAndAddToTreeAccountParam {
    'accountType': CreateAndAddToTreeAccountParamAccountTypeEnum;
    'code': string;
    'externalSystemAccountCode'?: string;
    'externalSystemSubAccountCode'?: string;
    'name': string;
    'viewControlType': CreateAndAddToTreeAccountParamViewControlTypeEnum;
}

export const CreateAndAddToTreeAccountParamAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type CreateAndAddToTreeAccountParamAccountTypeEnum = typeof CreateAndAddToTreeAccountParamAccountTypeEnum[keyof typeof CreateAndAddToTreeAccountParamAccountTypeEnum];
export const CreateAndAddToTreeAccountParamViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type CreateAndAddToTreeAccountParamViewControlTypeEnum = typeof CreateAndAddToTreeAccountParamViewControlTypeEnum[keyof typeof CreateAndAddToTreeAccountParamViewControlTypeEnum];

export interface CreateBoardRequestBody {
    'name': string;
}
export interface CreateBulkPlanUpdateRequestGSheetParam {
    'accessToken': string;
    'spreadsheetIdOrURL'?: string;
}
export interface CreateCalculatedAccountRequestBody {
    'code': string;
    'formula': string;
    'name': string;
    'roundingPrecision': CreateCalculatedAccountRequestBodyRoundingPrecisionEnum;
    'valueFormat': CreateCalculatedAccountRequestBodyValueFormatEnum;
}

export const CreateCalculatedAccountRequestBodyRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type CreateCalculatedAccountRequestBodyRoundingPrecisionEnum = typeof CreateCalculatedAccountRequestBodyRoundingPrecisionEnum[keyof typeof CreateCalculatedAccountRequestBodyRoundingPrecisionEnum];
export const CreateCalculatedAccountRequestBodyValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type CreateCalculatedAccountRequestBodyValueFormatEnum = typeof CreateCalculatedAccountRequestBodyValueFormatEnum[keyof typeof CreateCalculatedAccountRequestBodyValueFormatEnum];

export interface CreateCfAccountRequestBody {
    'cashIncreaseDecrease': string;
    'cfAccountReferenceType': string;
    'code': string;
    'name': string;
    'parentAccountId'?: string;
    'referenceAccountIds'?: Array<string>;
}
export interface CreateComparisonSheetSelectedConditionResponse {
    'comparisonSheetSelectedConditionId': string;
}
export interface CreateConnectionBody {
    'params': Array<CreateConnectionBodyParam>;
}
export interface CreateConnectionBodyParam {
    'plannedYearMonth': string;
    'workforceActualEventId': string;
    'workforceActualId': string;
    'workforceSlotId': string;
}
export interface CreateDashboardFolderBody {
    'name': string;
    'parentFolderId'?: string;
}
export interface CreateDashboardRequestBody {
    'folderId'?: string;
    'name': string;
}
export interface CreateDepartmentComparisonSheetSelectedConditionRequestBody {
    'accountTreeId': string;
    'departmentIds': Array<string>;
    'name': string;
    'orgTreeId': string;
    'planAActualEndYearMonth'?: string;
    'planAActualStartYearMonth'?: string;
    'planAEndYearMonth': string;
    'planAMasterId'?: string;
    'planAShowActual': boolean;
    'planAStartYearMonth': string;
    'planAUpdateProjectId'?: string;
    'planBActualEndYearMonth'?: string;
    'planBActualStartYearMonth'?: string;
    'planBEndYearMonth': string;
    'planBMasterId'?: string;
    'planBShowActual': boolean;
    'planBStartYearMonth': string;
    'planBUpdateProjectId'?: string;
    'requireAllocatedItem': boolean;
}
export interface CreateDepartmentComparisonSheetSelectedConditionResponse {
    'departmentComparisonSheetSelectedConditionId': string;
}
export interface CreateDepartmentParam {
    'code': string;
    'externalSystemDepartmentCode'?: string;
    'name': string;
}
export interface CreateDimensionTagsRequestBody {
    'description'?: string;
    'dimensionId': string;
    'dimensionTagCode': string;
    'dimensionTagName': string;
    'exCodes': Array<string>;
}
export interface CreateFinancialModelResponse {
    'financialModelId': string;
}
export interface CreateFinancialSheetCommentRequestBody {
    'baseCondition': BaseConditionRequestBody;
    'commentText': string;
    'commentType': CreateFinancialSheetCommentRequestBodyCommentTypeEnum;
    'planACondition'?: DetailConditionRequestBody;
    'planBCondition'?: DetailConditionRequestBody;
}

export const CreateFinancialSheetCommentRequestBodyCommentTypeEnum = {
    Amount: 'AMOUNT',
    DiffAmount: 'DIFF_AMOUNT',
    DiffRatio: 'DIFF_RATIO',
} as const;

export type CreateFinancialSheetCommentRequestBodyCommentTypeEnum = typeof CreateFinancialSheetCommentRequestBodyCommentTypeEnum[keyof typeof CreateFinancialSheetCommentRequestBodyCommentTypeEnum];

export interface CreateFinancialSheetCommentView {
    'financialSheetCommentId': string;
}
export interface CreateFinancialSimulationFolderBody {
    'name': string;
    'parentFolderId'?: string;
}
export interface CreateFinancialSimulationRequestBody {
    'actualPeriod'?: FinancialSimulationPeriod;
    'compareTargets': Array<FinancialSimulationCompareTargetRequestParam>;
    'copySourceSimulationId'?: string;
    'dimensionId'?: string;
    'dimensionTreeId'?: string;
    'dimensionType': FinancialSimulationDimensionTypeRequest;
    'financialModelId'?: string;
    'name': string;
    'nonFinancialAccountTreeId': string;
    'orgTreeId'?: string;
    'parentFolderId'?: string;
    'period': FinancialSimulationPeriod;
    'plAccountTreeId': string;
    'planMasterId': string;
    'targetPlanRequiredAllocatedItems': boolean;
}


export interface CreateFromDraftRequest {
    'planningProjectId': string;
    'sheetId': string;
}
export interface CreateFromDraftResponse {
    'createdCount': number;
    'createdPlanUpdateRequestIds': Array<string>;
}
export interface CreateGSheetParam {
    'accessToken': string;
    'departmentId'?: string;
    'spreadsheetIdOrURL'?: string;
}
export interface CreateGraphRequestBody {
    'config': CreateGraphRequestBodyConfig;
    'reportId': string;
    'title': string;
    'type': CreateGraphRequestBodyTypeEnum;
    'viewFilterConditions': Array<DimensionFilter>;
}

export const CreateGraphRequestBodyTypeEnum = {
    Bar: 'BAR',
    HorizontalBar: 'HORIZONTAL_BAR',
    Line: 'LINE',
    Kpi: 'KPI',
    Combo: 'COMBO',
    Waterfall: 'WATERFALL',
    Pie: 'PIE',
} as const;

export type CreateGraphRequestBodyTypeEnum = typeof CreateGraphRequestBodyTypeEnum[keyof typeof CreateGraphRequestBodyTypeEnum];

/**
 * @type CreateGraphRequestBodyConfig
 */
export type CreateGraphRequestBodyConfig = ComparisonWaterfallChartConfig | KpiCardConfig | PieChartConfig | ReportComboGraphConfig | ReportGraphConfig | WaterfallChartConfig;

export interface CreateGroupAndAddToNonFinancialAccountTreeBody {
    'code': string;
    'name': string;
    'parentNode'?: NonFinancialAccountTreeNodeBody;
}
export interface CreateLinkedGSheetParam {
    'departmentId': string;
    'sheetId': string;
    'sheetName': string;
}
export interface CreateNoDiffPlanUpdateRequestBody {
    'departmentId': string;
}
export interface CreateOrUpdateAccountConversionStepBody {
    'description'?: string;
    'destinationAccountId': string;
    'name': string;
    'sourceAccountId': string;
    'sourceUnitPriceMasterItemId': string;
}
export interface CreateOrUpdateAllocationStandardRequestBody {
    'allocationStandardReference'?: CreateAllocationStandardReferenceRequestBody;
    'destinationDepartments': Array<CreateAllocationStandardDepartmentsRequestBody>;
    'destinationDimensionTagIds'?: Array<string>;
    'dimensionId'?: string;
    'endYearMonth': string;
    'isDimensionEnabled': boolean;
    'name': string;
    'startYearMonth': string;
}
export interface CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody {
    'conditionGroupName': string;
}
export interface CreateOrUpdateComparisonSheetSelectedConditionRequestBody {
    'accountTreeId': string;
    'aggregate': string;
    'departmentIds': Array<string>;
    'groupId': string;
    'highlightThreshold'?: number;
    'highlightType'?: CreateOrUpdateComparisonSheetSelectedConditionRequestBodyHighlightTypeEnum;
    'name': string;
    'orgTreeId'?: string;
    'planAActualEndYearMonth'?: string;
    'planAActualStartYearMonth'?: string;
    'planAEndYearMonth': string;
    'planAMasterId'?: string;
    'planAShowActual': boolean;
    'planAStartYearMonth': string;
    'planAUpdateProjectId'?: string;
    'planBActualEndYearMonth'?: string;
    'planBActualStartYearMonth'?: string;
    'planBEndYearMonth': string;
    'planBMasterId'?: string;
    'planBShowActual': boolean;
    'planBStartYearMonth': string;
    'planBUpdateProjectId'?: string;
    'requireAllocatedItem': boolean;
}

export const CreateOrUpdateComparisonSheetSelectedConditionRequestBodyHighlightTypeEnum = {
    DiffAmount: 'DIFF_AMOUNT',
    DiffRatio: 'DIFF_RATIO',
} as const;

export type CreateOrUpdateComparisonSheetSelectedConditionRequestBodyHighlightTypeEnum = typeof CreateOrUpdateComparisonSheetSelectedConditionRequestBodyHighlightTypeEnum[keyof typeof CreateOrUpdateComparisonSheetSelectedConditionRequestBodyHighlightTypeEnum];

export interface CreateOrganizationTreeParam {
    'treeName': string;
}
export interface CreatePatternRequestBody {
    'name': string;
    'ruleIds': Array<string>;
}
export interface CreatePatternView {
    'id': string;
}
export interface CreatePlanMaster {
    'name': string;
    'planType': CreatePlanMasterPlanTypeEnum;
}

export const CreatePlanMasterPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type CreatePlanMasterPlanTypeEnum = typeof CreatePlanMasterPlanTypeEnum[keyof typeof CreatePlanMasterPlanTypeEnum];

export interface CreatePlanSheetParam {
    'aggregatedViewReportId'?: string;
    'assignedDepartmentIds'?: Array<string>;
    'condition': SheetConditionSchema;
    'isEditRestricted'?: boolean;
    'name': string;
}
export interface CreatePlanUpdateRequestFormatParams {
    'downloadableDepartments': Array<string>;
    'name': string;
}
export interface CreatePlanUpdateRequestMappingAccountKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': CreatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum;
}

export const CreatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type CreatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum = typeof CreatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum[keyof typeof CreatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum];

export interface CreatePlanUpdateRequestMappingAmountParams {
    'endColumnIndex'?: number;
    'endRowIndex'?: number;
    'startColumnIndex': number;
    'startRowIndex': number;
}
export interface CreatePlanUpdateRequestMappingDepartmentKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': CreatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum;
}

export const CreatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type CreatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum = typeof CreatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum[keyof typeof CreatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum];

export interface CreatePlanUpdateRequestMappingDescriptionKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
}
export interface CreatePlanUpdateRequestMappingDimensionKeyParams {
    'dimensionId': string;
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': CreatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum;
}

export const CreatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type CreatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum = typeof CreatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum[keyof typeof CreatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum];

export interface CreatePlanUpdateRequestMappingFilterParams {
    'conditionType': CreatePlanUpdateRequestMappingFilterParamsConditionTypeEnum;
    'conditionValue': string;
    'mappedTo': PlanUpdateRequestMappingAddress;
}

export const CreatePlanUpdateRequestMappingFilterParamsConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Empty: 'EMPTY',
    NotEmpty: 'NOT_EMPTY',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type CreatePlanUpdateRequestMappingFilterParamsConditionTypeEnum = typeof CreatePlanUpdateRequestMappingFilterParamsConditionTypeEnum[keyof typeof CreatePlanUpdateRequestMappingFilterParamsConditionTypeEnum];

export interface CreatePlanUpdateRequestMappingParams {
    'accountKey': CreatePlanUpdateRequestMappingAccountKeyParams;
    'amountParams': CreatePlanUpdateRequestMappingAmountParams;
    'canUseForDownload': boolean;
    'canUseForUpload': boolean;
    'departmentKey': CreatePlanUpdateRequestMappingDepartmentKeyParams;
    'descriptionKey'?: CreatePlanUpdateRequestMappingDescriptionKeyParams;
    'dimensionKeys': Array<CreatePlanUpdateRequestMappingDimensionKeyParams>;
    'filters': Array<CreatePlanUpdateRequestMappingFilterParams>;
    'name': string;
    'planUpdateRequestMappingUniqueKey'?: string;
    'showNumbersIn'?: CreatePlanUpdateRequestMappingParamsShowNumbersInEnum;
    'showNumbersInKey'?: CreatePlanUpdateRequestMappingShowNumbersInKeyParams;
    'yearMonthKey': CreatePlanUpdateRequestMappingYearMonthKeyParams;
}

export const CreatePlanUpdateRequestMappingParamsShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type CreatePlanUpdateRequestMappingParamsShowNumbersInEnum = typeof CreatePlanUpdateRequestMappingParamsShowNumbersInEnum[keyof typeof CreatePlanUpdateRequestMappingParamsShowNumbersInEnum];

export interface CreatePlanUpdateRequestMappingShowNumbersInKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
}
export interface CreatePlanUpdateRequestMappingYearMonthKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
}
export interface CreatePlanningProjectDepartmentCommentBody {
    'commentText': string;
    'departmentId': string;
    'planningProjectId': string;
}
export interface CreatePlanningProjectParam {
    'accountTreeId': string;
    'actualDownloadPeriodEnd'?: string;
    'actualDownloadPeriodStart'?: string;
    'assignedDepartments': Array<string>;
    'canActualDownload': boolean;
    'canRequestActualMonth': boolean;
    'name': string;
    'orgTreeId': string;
    'requirePlanMasterAllocatedItems': boolean;
    'scheduledPlanningProjectEndAt': string;
    'targetEnd': string;
    'targetStart': string;
    'useMultiStepApprovalFlow': boolean;
    'workforcePlanningItemConversionRulesetId'?: string;
}
export interface CreateReportBody {
    'folderId'?: string;
    'name'?: string;
    'type': string;
}
export interface CreateReportCommentRequestBody {
    'allowed': CreateReportCommentRequestBodyAllowedEnum;
    'allowedUserIds': Array<string>;
    'cellKey': ReportCellKey;
    'commentText': string;
    'condition': PLReportConditionSchema;
    'reportId': string;
}

export const CreateReportCommentRequestBodyAllowedEnum = {
    All: 'ALL',
    Restricted: 'RESTRICTED',
} as const;

export type CreateReportCommentRequestBodyAllowedEnum = typeof CreateReportCommentRequestBodyAllowedEnum[keyof typeof CreateReportCommentRequestBodyAllowedEnum];

export interface CreateReportCommentView {
    'cellCommentId': string;
    'commentId': string;
    'threadId': string;
}
export interface CreateReportDescriptionBody {
    'content': string;
}
export interface CreateReportFolderBody {
    'name': string;
    'parentFolderId'?: string;
}
export interface CreateReportFromTemplateBody {
    'folderId'?: string;
    'templateType': CreateReportFromTemplateBodyTemplateTypeEnum;
}

export const CreateReportFromTemplateBodyTemplateTypeEnum = {
    PlHistory: 'PLHistory',
    PlComparison: 'PLComparison',
} as const;

export type CreateReportFromTemplateBodyTemplateTypeEnum = typeof CreateReportFromTemplateBodyTemplateTypeEnum[keyof typeof CreateReportFromTemplateBodyTemplateTypeEnum];

export interface CreateRuleRequestBody {
    'dataSourceId': string;
    'name': string;
}
export interface CreateRuleView {
    'id': string;
}
export interface CreateSimulatingWorkforceSlotBody {
    'code': string;
    'departmentId'?: string;
    'dimensionIdToTagIdMap': { [key: string]: string; };
    'inDepartmentId'?: string;
    'name': string;
    'outDepartmentId'?: string;
    'slotType': CreateSimulatingWorkforceSlotBodySlotTypeEnum;
    'unitAmountItems': Array<CreateSimulatingWorkforceSlotBodyUnitAmountItem>;
}

export const CreateSimulatingWorkforceSlotBodySlotTypeEnum = {
    Hiring: 'HIRING',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    TransferDepartment: 'TRANSFER_DEPARTMENT',
} as const;

export type CreateSimulatingWorkforceSlotBodySlotTypeEnum = typeof CreateSimulatingWorkforceSlotBodySlotTypeEnum[keyof typeof CreateSimulatingWorkforceSlotBodySlotTypeEnum];

export interface CreateSimulatingWorkforceSlotBodyUnitAmountItem {
    'itemId': string;
    'unitAmount': number;
}
export interface CreateStepRequestBody {
    'allocationAxisCondition': AllocationAxisCondition;
    'description'?: string;
    'destinationAccount'?: DestinationAccount;
    'filterConditions': Array<FilterCondition>;
    'loopCondition'?: LoopCondition;
    'name': string;
    'sourceAccounts': SourceAccounts;
    'standardAccounts'?: StandardAccounts;
}
export interface CreateStepView {
    'id': string;
}
export interface CreateStrategyResultDto {
    'planId'?: string;
    'targetType': CreateStrategyResultDtoTargetTypeEnum;
}

export const CreateStrategyResultDtoTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type CreateStrategyResultDtoTargetTypeEnum = typeof CreateStrategyResultDtoTargetTypeEnum[keyof typeof CreateStrategyResultDtoTargetTypeEnum];

export interface CreateTransferStepRequestBody {
    'description'?: string;
    'destinationAccountId'?: string;
    'destinationDepartmentId'?: string;
    'destinationDimensionTagIds': Array<string>;
    'name': string;
    'sourceAccountIds': Array<string>;
    'sourceDepartmentIds': Array<string>;
    'sourceDimensionTagIds': Array<string>;
}
export interface CreateTransferStepV2RequestBody {
    'description'?: string;
    'destinationAccountCondition'?: TransferSingleAccountCondition;
    'destinationAxisConditions'?: Array<TransferSingleAxisCondition>;
    'name': string;
    'sourceAccountCondition': TransferAccountCondition;
    'sourceAxisConditions'?: Array<TransferAxisCondition>;
}
export interface CreateUnitPriceMasterItemRequest {
    'name': string;
}
export interface CreateUserParam {
    'email': string;
    'firstName': string;
    'lastName': string;
    'requireMFA': boolean;
    'role': CreateUserParamRoleEnum;
}

export const CreateUserParamRoleEnum = {
    LoglassSystemAdmin: 'LOGLASS_SYSTEM_ADMIN',
    TenantAdmin: 'TENANT_ADMIN',
    CorpPlanning: 'CORP_PLANNING',
    Manager: 'MANAGER',
    ItStaff: 'IT_STAFF',
    General: 'GENERAL',
} as const;

export type CreateUserParamRoleEnum = typeof CreateUserParamRoleEnum[keyof typeof CreateUserParamRoleEnum];

export interface CreateViewPermissionParams {
    'name': string;
    'selectedAccounts': Array<string>;
    'selectedCalculatedAccounts': Array<string>;
    'users': Array<string>;
    'viewableAccountScope': CreateViewPermissionParamsViewableAccountScopeEnum;
}

export const CreateViewPermissionParamsViewableAccountScopeEnum = {
    All: 'ALL',
    Selected: 'SELECTED',
} as const;

export type CreateViewPermissionParamsViewableAccountScopeEnum = typeof CreateViewPermissionParamsViewableAccountScopeEnum[keyof typeof CreateViewPermissionParamsViewableAccountScopeEnum];

export interface CreateWorkforceActualImportMappingTargetDimensionParam {
    'columnAlphabet': string;
    'dimensionId': string;
}
export interface CreateWorkforceActualImportMappingTargetParam {
    'columnAlphabet': string;
    'type': CreateWorkforceActualImportMappingTargetParamTypeEnum;
}

export const CreateWorkforceActualImportMappingTargetParamTypeEnum = {
    WorkforceCode: 'WORKFORCE_CODE',
    LastName: 'LAST_NAME',
    FirstName: 'FIRST_NAME',
    StartDate: 'START_DATE',
    EndDate: 'END_DATE',
    LeaveOfAbsenceMonth: 'LEAVE_OF_ABSENCE_MONTH',
    ReturnToWorkMonth: 'RETURN_TO_WORK_MONTH',
    ExternalSystemDepartmentCode: 'EXTERNAL_SYSTEM_DEPARTMENT_CODE',
    EffectiveDate: 'EFFECTIVE_DATE',
} as const;

export type CreateWorkforceActualImportMappingTargetParamTypeEnum = typeof CreateWorkforceActualImportMappingTargetParamTypeEnum[keyof typeof CreateWorkforceActualImportMappingTargetParamTypeEnum];

export interface CreateWorkforceActualImportRowFilterParam {
    'columnAlphabet': string;
    'conditionType': CreateWorkforceActualImportRowFilterParamConditionTypeEnum;
    'conditionValue'?: string;
}

export const CreateWorkforceActualImportRowFilterParamConditionTypeEnum = {
    Equal: 'EQUAL',
    NotEqual: 'NOT_EQUAL',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
} as const;

export type CreateWorkforceActualImportRowFilterParamConditionTypeEnum = typeof CreateWorkforceActualImportRowFilterParamConditionTypeEnum[keyof typeof CreateWorkforceActualImportRowFilterParamConditionTypeEnum];

export interface CreateWorkforceConversionRuleBody {
    'conversionTiming': CreateWorkforceConversionRuleBodyConversionTimingEnum;
    'patterns': Array<WorkforceConversionRulePatternBody>;
    'ruleName': string;
    'rulesetId': string;
    'unitAmountItemId'?: string;
}

export const CreateWorkforceConversionRuleBodyConversionTimingEnum = {
    Monthly: 'MONTHLY',
    UponJoining: 'UPON_JOINING',
} as const;

export type CreateWorkforceConversionRuleBodyConversionTimingEnum = typeof CreateWorkforceConversionRuleBodyConversionTimingEnum[keyof typeof CreateWorkforceConversionRuleBodyConversionTimingEnum];

export interface CreateWorkforcePlanningItemConversionRulesetBody {
    'description': string;
    'name': string;
}
export interface CreateWorkforcePlanningItemConversionRulesetView {
    'id': string;
}
export interface CreateWorkforcePlanningProjectSimulationBody {
    'baseYearMonth'?: string;
    'departmentIds': Array<string>;
    'name': string;
}
export interface CreateWorkforceSlotUnitAmountTableBody {
    'attributes': Array<WorkforceSlotUnitAmountTableAttributeBody>;
    'items': Array<WorkforceSlotUnitAmountTableItemBody>;
    'name': string;
}
export interface CreateWorkforceSlotUnitAmountTableView {
    'id': string;
}
export interface CreatedBoardDto {
    'boardId': string;
}
export interface CreatedDashboardDto {
    'dashboardId': string;
}
export interface CreatedFinancialSimulationDto {
    'model': FinancialModelDto;
    'scenario': ScenarioDto;
    'simulation': FinancialSimulationDto;
}
export interface CreatedGSheetView {
    'spreadsheetId': string;
    'spreadsheetUrl': string;
}
export interface CreatedGraphDto {
    'reportGraphId': string;
}
export interface CreatedPermissionGroupView {
    'permissionGroupId': string;
}
export interface CreatedSimulatingWorkforceSlotView {
    'id': string;
}
export interface CreatedWorkforcePlanningProjectSimulationView {
    'simulationId': string;
}
export interface CurrencyMaster {
    'code': string;
    'name': string;
}
export interface CurrencyMasterByDepartmentsRequestParam {
    'departmentIds': Array<string>;
}
export interface CurrentIpView {
    'currentIp': string;
    'type': CurrentIpViewTypeEnum;
}

export const CurrentIpViewTypeEnum = {
    Ipv4: 'IPv4',
    Ipv6: 'IPv6',
} as const;

export type CurrentIpViewTypeEnum = typeof CurrentIpViewTypeEnum[keyof typeof CurrentIpViewTypeEnum];

export interface CurrentUserEmailNotificationSettingsView {
    'activeEmailNotificationSources': Array<CurrentUserEmailNotificationSettingsViewActiveEmailNotificationSourcesEnum>;
    'availableEmailNotificationSources': Array<CurrentUserEmailNotificationSettingsViewAvailableEmailNotificationSourcesEnum>;
}

export const CurrentUserEmailNotificationSettingsViewActiveEmailNotificationSourcesEnum = {
    PlanningProject: 'PLANNING_PROJECT',
    PlanUpdateRequest: 'PLAN_UPDATE_REQUEST',
    AllocationStandard: 'ALLOCATION_STANDARD',
    ReportComment: 'REPORT_COMMENT',
} as const;

export type CurrentUserEmailNotificationSettingsViewActiveEmailNotificationSourcesEnum = typeof CurrentUserEmailNotificationSettingsViewActiveEmailNotificationSourcesEnum[keyof typeof CurrentUserEmailNotificationSettingsViewActiveEmailNotificationSourcesEnum];
export const CurrentUserEmailNotificationSettingsViewAvailableEmailNotificationSourcesEnum = {
    PlanningProject: 'PLANNING_PROJECT',
    PlanUpdateRequest: 'PLAN_UPDATE_REQUEST',
    AllocationStandard: 'ALLOCATION_STANDARD',
    ReportComment: 'REPORT_COMMENT',
} as const;

export type CurrentUserEmailNotificationSettingsViewAvailableEmailNotificationSourcesEnum = typeof CurrentUserEmailNotificationSettingsViewAvailableEmailNotificationSourcesEnum[keyof typeof CurrentUserEmailNotificationSettingsViewAvailableEmailNotificationSourcesEnum];

export interface CurrentUserView {
    'auth0UserId': string;
    'email': string;
    'firstName': string;
    'lastName': string;
    'name': string;
    'role': CurrentUserViewRoleEnum;
    'tenantId': string;
    'tenantName': string;
    'userId': string;
}

export const CurrentUserViewRoleEnum = {
    LoglassSystemAdmin: 'LOGLASS_SYSTEM_ADMIN',
    TenantAdmin: 'TENANT_ADMIN',
    CorpPlanning: 'CORP_PLANNING',
    Manager: 'MANAGER',
    ItStaff: 'IT_STAFF',
    General: 'GENERAL',
} as const;

export type CurrentUserViewRoleEnum = typeof CurrentUserViewRoleEnum[keyof typeof CurrentUserViewRoleEnum];

/**
 * Custom format
 */
export interface CustomFormatDto {
    /**
     * Rounding precision
     */
    'roundingPrecision': string;
    /**
     * Value format
     */
    'valueFormat': CustomFormatDtoValueFormatEnum;
}

export const CustomFormatDtoValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type CustomFormatDtoValueFormatEnum = typeof CustomFormatDtoValueFormatEnum[keyof typeof CustomFormatDtoValueFormatEnum];

export interface DashboardCopyLimitCheckResponse {
    'dashboardCountAfterCopy': number;
    'dashboardLimit'?: number;
    'limitErrorMessage'?: string;
    'reportCountAfterCopy': number;
    'reportLimit'?: number;
}
export interface DashboardFolderDetailResponse {
    'currentFolder'?: DashboardFolderInfoResponse;
    'items': Array<DashboardFolderItemResponse>;
    'paths': Array<DashboardFolderInfoResponse>;
}
export interface DashboardFolderInfoResponse {
    'id': string;
    'name': string;
}
export interface DashboardFolderItemResponse {
    'createdAt'?: string;
    'id': string;
    'isEditRestricted': boolean;
    'isOwner': boolean;
    'itemType': DashboardFolderItemResponseItemTypeEnum;
    'lastUpdatedAt'?: string;
    'lastUpdatedUserName': string;
    'name': string;
    'parentFolderInfo'?: DashboardFolderInfoResponse;
}

export const DashboardFolderItemResponseItemTypeEnum = {
    Folder: 'FOLDER',
    Dashboard: 'DASHBOARD',
} as const;

export type DashboardFolderItemResponseItemTypeEnum = typeof DashboardFolderItemResponseItemTypeEnum[keyof typeof DashboardFolderItemResponseItemTypeEnum];

export interface DashboardFolderTreeForSelectionResponse {
    'rootNodes': Array<TreeNodeDashboardFolderTreeNode>;
    'totalCount': number;
}
export interface DashboardFolderTreeNode {
    'id': string;
    'isSelectable': boolean;
    'name': string;
    'parentId'?: string;
}
export interface DataCellView {
    'eitherAmountOrError'?: EitherAmountOrErrorView;
    'id': string;
    'orderKey': CellGroupOrderKeyImpl;
    'type': ReportCellType;
    'dataConditionId': DataCellViewDataConditionIdEnum;
    'uniqueKey': UniqueKeyView;
}

export const DataCellViewDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type DataCellViewDataConditionIdEnum = typeof DataCellViewDataConditionIdEnum[keyof typeof DataCellViewDataConditionIdEnum];

export interface DataCondition {
    'accountTreeId': string;
    'actualExchangeRateId'?: string;
    'actualPeriod'?: Period;
    'allocationPatternId'?: string;
    'dimensionFilters': Array<DimensionFilter>;
    'id': DataConditionIdEnum;
    'nonFinancialAccountTreeId'?: string;
    'orgTreeId': string;
    'period': Period;
    'periodSettings'?: DataConditionPeriodSettings;
    'planExchangeRateId'?: string;
    'planId'?: PlanId;
    'requireAllocatedItem': boolean;
    'showActual': boolean;
}

export const DataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type DataConditionIdEnum = typeof DataConditionIdEnum[keyof typeof DataConditionIdEnum];

export interface DataConditionLabelOverride {
    'customLabel'?: string;
    'dataConditionId': string;
    'planId'?: string;
    'showActual': boolean;
}
/**
 * @type DataConditionPeriodSettings
 */
export type DataConditionPeriodSettings = Absolute | Relative;

export interface DataSource {
    'id': string;
    'name': string;
}
export interface DataSourceDto {
    'id': string;
    'name': string;
}
export interface DataSourceExecution {
    'dataSource': DataSourceResponse;
    'yearMonths': Array<YearMonthExecution>;
}
export interface DataSourceForExecutionSettings {
    'id': string;
    'name': string;
}
export interface DataSourceResponse {
    'id': string;
    'name': string;
}
export interface DataSourceView {
    'id': string;
    'name': string;
}
export interface DateTime {
    'value': string;
}
export interface DateTimeData {
    'value': string;
}
export interface DefaultCfAccountRegistrationRequest {
    'plTreeId': string;
}
export interface DefaultCfAccountRegistrationResponse {
    'duplicateCodes': Array<string>;
    'duplicateNames': Array<string>;
}
export interface DefaultHttpStatusCode {
    'error'?: boolean;
    'is1xxInformational'?: boolean;
    'is2xxSuccessful'?: boolean;
    'is3xxRedirection'?: boolean;
    'is4xxClientError'?: boolean;
    'is5xxServerError'?: boolean;
}
export interface DefaultTenantView {
    'tenantId': string;
}
export interface DeleteConnectionBody {
    'connectionIds': Array<string>;
}
export interface DeleteExecutionsRequest {
    'targets': Array<DeletionTargetExecution>;
}
export interface DeleteSimulatingSlotsBody {
    'simulatingSlotIds': Array<string>;
}
export interface DeletionTargetExecution {
    'dataSourceId': string;
    'patternId': string;
    'yearMonth': string;
}
export interface Delta {
    'amount': string;
    'calculationFormula': DeltaCalculationFormulaEnum;
    'comparisonType': DeltaComparisonTypeEnum;
    'description': string;
    'label': string;
    'trend': DeltaTrendEnum;
}

export const DeltaCalculationFormulaEnum = {
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type DeltaCalculationFormulaEnum = typeof DeltaCalculationFormulaEnum[keyof typeof DeltaCalculationFormulaEnum];
export const DeltaComparisonTypeEnum = {
    Diff: 'DIFF',
    DiffRatio: 'DIFF_RATIO',
    AchievementRatio: 'ACHIEVEMENT_RATIO',
    SpecificAccountRatio: 'SPECIFIC_ACCOUNT_RATIO',
} as const;

export type DeltaComparisonTypeEnum = typeof DeltaComparisonTypeEnum[keyof typeof DeltaComparisonTypeEnum];
export const DeltaTrendEnum = {
    Up: 'UP',
    Down: 'DOWN',
    Flat: 'FLAT',
} as const;

export type DeltaTrendEnum = typeof DeltaTrendEnum[keyof typeof DeltaTrendEnum];

export interface DepartmentAssignedActiveUserView {
    'firstName': string;
    'id': string;
    'lastName': string;
    'role': DepartmentAssignedActiveUserViewRoleEnum;
}

export const DepartmentAssignedActiveUserViewRoleEnum = {
    LoglassSystemAdmin: 'LOGLASS_SYSTEM_ADMIN',
    TenantAdmin: 'TENANT_ADMIN',
    CorpPlanning: 'CORP_PLANNING',
    Manager: 'MANAGER',
    ItStaff: 'IT_STAFF',
    General: 'GENERAL',
} as const;

export type DepartmentAssignedActiveUserViewRoleEnum = typeof DepartmentAssignedActiveUserViewRoleEnum[keyof typeof DepartmentAssignedActiveUserViewRoleEnum];

export interface DepartmentComparisonSheetSelectedConditionDetailDto {
    'accountTreeId': string;
    'departmentIds': Array<string>;
    'orgTreeId': string;
    'planAActualEndYearMonth'?: string;
    'planAActualStartYearMonth'?: string;
    'planAEndYearMonth': string;
    'planAMasterId'?: string;
    'planAShowActual': boolean;
    'planAStartYearMonth': string;
    'planAUpdateProjectId'?: string;
    'planBActualEndYearMonth'?: string;
    'planBActualStartYearMonth'?: string;
    'planBEndYearMonth': string;
    'planBMasterId'?: string;
    'planBShowActual': boolean;
    'planBStartYearMonth': string;
    'planBUpdateProjectId'?: string;
    'requireAllocatedItem': boolean;
}
export interface DepartmentComparisonSheetSelectedConditionDto {
    'departmentComparisonSheetSelectedConditionId': string;
    'detail': DepartmentComparisonSheetSelectedConditionDetailDto;
    'name': string;
}
export interface DepartmentLabelOverride {
    'customLabel'?: string;
    'departmentId': string;
}
export interface DepartmentView {
    'code': string;
    'externalSystemDepartmentCode'?: string;
    'id': string;
    'name': string;
}
export interface DepartmentViewWithIsAssignedAndIsArchived {
    'department': DepartmentView;
    'isArchived': boolean;
    'isAssigned': boolean;
}
export interface DepartmentWithAssignedActiveUsersView {
    'department': DepartmentView;
    'users': Array<DepartmentAssignedActiveUserView>;
}
export interface DepartmentWithAssignmentView {
    'assignment': AssignmentEachDepartmentView;
    'department': DepartmentView;
}
export interface DepartmentsView {
    'items': Array<DepartmentView>;
}
export interface DeprecatedCreateSimulationBody {
    'departmentIds': Array<string>;
    'name': string;
    'planMasterId'?: string;
    'planningProjectId'?: string;
    'targetPeriodEnd': string;
    'targetPeriodStart': string;
}
export interface DeprecatedCreatedSimulationView {
    'simulationId': string;
}
export interface DeprecatedListSimulationView {
    'items': Array<DeprecatedSimulationListItem>;
}
export interface DeprecatedSimulatingWorkforceSlotListView {
    'columns': Array<SimulatingSlotHeaderItemView>;
    'hiringSlots': Array<SimulatingSlotListItemView>;
    'leaveOfAbsenceSlots': Array<SimulatingSlotListItemView>;
    'resignationSlots': Array<SimulatingSlotListItemView>;
    'returnToWorkSlots': Array<SimulatingSlotListItemView>;
    'transferDepartmentSlots': TransferDepartmentSlotList;
}
export interface DeprecatedSimulationListItem {
    'createdBy': string;
    'id': string;
    'isAllowedToEditNameAndDelete': boolean;
    'lastUpdatedAt': string;
    'lastUpdatedBy': string;
    'name': string;
}
export interface DeprecatedWorkforcePlanningSimulationItem {
    'sum'?: number;
    'yearMonthId': string;
}
export interface DestinationAccount {
    'account': IdWithReferenceType;
    'treeId': string;
}
export interface DetachNonFinancialAccountTreeNodeBody {
    'targetNode': NonFinancialAccountTreeNodeBody;
}
export interface DetailConditionRequestBody {
    'commentedAmount'?: number;
    'periodKeyValue': string;
    'planMasterId'?: string;
    'planningProjectId'?: string;
}
export interface DiffRatioView {
    'diff'?: number;
    'diffCommentCount'?: number;
    'ratio'?: number;
    'ratioCommentCount'?: number;
}
export interface DimensionFilter {
    'dimensionTreeId'?: string;
    'dimensionType': DimensionFilterDimensionTypeEnum;
    'ids': Array<string>;
}

export const DimensionFilterDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type DimensionFilterDimensionTypeEnum = typeof DimensionFilterDimensionTypeEnum[keyof typeof DimensionFilterDimensionTypeEnum];

export interface DimensionFilterConditionParam {
    'ids': Array<string>;
    'type': DimensionFilterConditionParamTypeEnum;
}

export const DimensionFilterConditionParamTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
    Period: 'PERIOD',
} as const;

export type DimensionFilterConditionParamTypeEnum = typeof DimensionFilterConditionParamTypeEnum[keyof typeof DimensionFilterConditionParamTypeEnum];

export interface DimensionIdToTagId {
    'dimensionId': string;
    'dimensionTagId': string;
}
export interface DimensionLabelOverrides {
    'dimensionNumber': number;
    'tagLabelOverrides': Array<DimensionTagLabelOverride>;
}
export interface DimensionName {
    'value': string;
}
export interface DimensionTagFlatTreeNodeView {
    'code': string;
    'description'?: string;
    'exCodes': Array<string>;
    'id': string;
    'level': number;
    'matched': boolean;
    'matchedKeyword': MatchedDimensionTagKeywordView;
    'name': string;
    'parentId'?: string;
}
export interface DimensionTagFlatTreeView {
    'id': string;
    'items': Array<DimensionTagFlatTreeNodeView>;
    'openNodeIds': Array<string>;
}
export interface DimensionTagInfoView {
    'dimensionName': string;
    'dimensionTagName': string;
}
export interface DimensionTagLabelOverride {
    'customLabel'?: string;
    'dimensionTagId': string;
}
export interface DimensionTagListView {
    'dimensionName': string;
    'paging': PagingDto;
    'tags': Array<DimensionTagView>;
}
export interface DimensionTagView {
    'description'?: string;
    'dimensionTagCode': string;
    'dimensionTagId': string;
    'dimensionTagName': string;
    'exCodes': Array<string>;
}
export interface DimensionTagsView {
    'items': Array<DimensionTagView>;
}
export interface DimensionTreeForSelectionView {
    'id': string;
    'items': Array<DimensionTreeNodesForSelectionView>;
    'notIncludedItems': Array<DimensionTreeNodesForSelectionView>;
}
export interface DimensionTreeListView {
    'items': Array<DimensionTreeView>;
}
export interface DimensionTreeMetaView {
    'dimensionId': string;
    'id': string;
    'name': string;
}
export interface DimensionTreeNodeForSelectionView {
    'description'?: string;
    'dimensionTagCode': string;
    'dimensionTagId': string;
    'dimensionTagName': string;
    'exCodes': Array<string>;
    'isOwnValue': boolean;
    'level': number;
    'parentId'?: string;
}
export interface DimensionTreeNodesForSelectionView {
    'value': TreeNodeDimensionTreeNodeForSelectionView;
}
export interface DimensionTreeView {
    'dimensionId': string;
    'dimensionTreeId': string;
    'name': string;
}
export interface DimensionView {
    'dimensionId': string;
    'dimensionName': string;
    'dimensionNumber': number;
    'importColumnName': string;
}
export interface DimensionVisibilityConditionParam {
    'ids': Array<string>;
    'type': DimensionVisibilityConditionParamTypeEnum;
}

export const DimensionVisibilityConditionParamTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
    Period: 'PERIOD',
} as const;

export type DimensionVisibilityConditionParamTypeEnum = typeof DimensionVisibilityConditionParamTypeEnum[keyof typeof DimensionVisibilityConditionParamTypeEnum];

export interface DisplayMessageView {
    'level': DisplayMessageViewLevelEnum;
    'message': string;
}

export const DisplayMessageViewLevelEnum = {
    Info: 'INFO',
    Warn: 'WARN',
} as const;

export type DisplayMessageViewLevelEnum = typeof DisplayMessageViewLevelEnum[keyof typeof DisplayMessageViewLevelEnum];

export interface DownloadActualExcelRequestBody {
    'actualEnd': string;
    'actualStart': string;
    'allocationPatternId': string;
    'departmentIds'?: Array<string>;
    'isAsc': boolean;
    'orgTreeId': string;
    'period'?: string;
    'requireAllocatedItems': boolean;
    'rowType': DownloadActualExcelRequestBodyRowTypeEnum;
    'sortKey': DownloadActualExcelRequestBodySortKeyEnum;
}

export const DownloadActualExcelRequestBodyRowTypeEnum = {
    Account: 'ACCOUNT',
    AccountOwnValue: 'ACCOUNT_OWN_VALUE',
} as const;

export type DownloadActualExcelRequestBodyRowTypeEnum = typeof DownloadActualExcelRequestBodyRowTypeEnum[keyof typeof DownloadActualExcelRequestBodyRowTypeEnum];
export const DownloadActualExcelRequestBodySortKeyEnum = {
    JournalDate: 'JOURNAL_DATE',
    DepartmentName: 'DEPARTMENT_NAME',
    AccountName: 'ACCOUNT_NAME',
    SupplierName: 'SUPPLIER_NAME',
    Description: 'DESCRIPTION',
    Amount: 'AMOUNT',
} as const;

export type DownloadActualExcelRequestBodySortKeyEnum = typeof DownloadActualExcelRequestBodySortKeyEnum[keyof typeof DownloadActualExcelRequestBodySortKeyEnum];

export interface DownloadManagementDto {
    'downloadManagementId': string;
    'fileName': string;
    'filePath'?: string;
    'functionDataType': DownloadManagementDtoFunctionDataTypeEnum;
    'queueCompletedAt'?: string;
    'queueStartedAt': string;
    'status': DownloadManagementDtoStatusEnum;
}

export const DownloadManagementDtoFunctionDataTypeEnum = {
    ReportTableDetail: 'REPORT_TABLE_DETAIL',
    AnalyticsData: 'ANALYTICS_DATA',
} as const;

export type DownloadManagementDtoFunctionDataTypeEnum = typeof DownloadManagementDtoFunctionDataTypeEnum[keyof typeof DownloadManagementDtoFunctionDataTypeEnum];
export const DownloadManagementDtoStatusEnum = {
    Process: 'PROCESS',
    Success: 'SUCCESS',
    Failed: 'FAILED',
} as const;

export type DownloadManagementDtoStatusEnum = typeof DownloadManagementDtoStatusEnum[keyof typeof DownloadManagementDtoStatusEnum];

export interface DownloadMultipleAllocationResultsRequest {
    'allocationResultKeys': Array<AllocationResultKey>;
}
export interface DownloadRequestBody {
    'accountTreeId': string;
    'actualPlanSelect': ActualPlanSelect;
    'allocationPatternParam'?: AllocationPatternParam;
    'departmentIds': Array<MaybeOwnValueDepartmentId>;
    'format': DownloadRequestBodyFormatEnum;
    'nonFinancialAccountTreeId'?: string;
    'requireAllocatedItems': boolean;
    'targetMonthRange': TargetYearMonthRange;
    'withExCode': boolean;
    'withLoglassCode': boolean;
}

export const DownloadRequestBodyFormatEnum = {
    Raw: 'Raw',
    Aggregate: 'Aggregate',
} as const;

export type DownloadRequestBodyFormatEnum = typeof DownloadRequestBodyFormatEnum[keyof typeof DownloadRequestBodyFormatEnum];

export interface DryRunConversionRulesResponse {
    'results': Array<ConversionRuleDryRunResult>;
}
export interface DuplicateRuleRequestBody {
    'dataSourceId': string;
    'name': string;
}
export interface DuplicateRuleView {
    'id': string;
}
export interface EachConcurrentPostDiff {
    'departmentName': string;
    'dimensionTagNames': Array<string>;
    'eachConcurrentPostDiffItems': Array<EachConcurrentPostDiffItem>;
}
export interface EachConcurrentPostDiffItem {
    'afterAmount'?: number;
    'beforeAmount'?: number;
    'diffAmount'?: number;
    'yearMonthId': string;
}
export interface EachDepartmentComparisonCellDetailV2View {
    'hasDetails': boolean;
    'sum'?: number;
}
export interface EachDepartmentComparisonCellTypeV2View {
    'columnTypeA': EachDepartmentComparisonCellTypeV2ViewColumnTypeAEnum;
    'columnTypeB': EachDepartmentComparisonCellTypeV2ViewColumnTypeBEnum;
    'departmentIds': Array<string>;
    'key': string;
    'topDepartmentCode': string;
    'topDepartmentName': string;
}

export const EachDepartmentComparisonCellTypeV2ViewColumnTypeAEnum = {
    ActualBudget: 'ACTUAL_BUDGET',
    ActualForecast: 'ACTUAL_FORECAST',
    ActualBudgetMixed: 'ACTUAL_BUDGET_MIXED',
    ActualForecastMixed: 'ACTUAL_FORECAST_MIXED',
    ActualNull: 'ACTUAL_NULL',
    NullNull: 'NULL_NULL',
    NullBudget: 'NULL_BUDGET',
    NullForecast: 'NULL_FORECAST',
} as const;

export type EachDepartmentComparisonCellTypeV2ViewColumnTypeAEnum = typeof EachDepartmentComparisonCellTypeV2ViewColumnTypeAEnum[keyof typeof EachDepartmentComparisonCellTypeV2ViewColumnTypeAEnum];
export const EachDepartmentComparisonCellTypeV2ViewColumnTypeBEnum = {
    ActualBudget: 'ACTUAL_BUDGET',
    ActualForecast: 'ACTUAL_FORECAST',
    ActualBudgetMixed: 'ACTUAL_BUDGET_MIXED',
    ActualForecastMixed: 'ACTUAL_FORECAST_MIXED',
    ActualNull: 'ACTUAL_NULL',
    NullNull: 'NULL_NULL',
    NullBudget: 'NULL_BUDGET',
    NullForecast: 'NULL_FORECAST',
} as const;

export type EachDepartmentComparisonCellTypeV2ViewColumnTypeBEnum = typeof EachDepartmentComparisonCellTypeV2ViewColumnTypeBEnum[keyof typeof EachDepartmentComparisonCellTypeV2ViewColumnTypeBEnum];

export interface EachDepartmentComparisonCellV2View {
    'comparisonA': EachDepartmentComparisonCellDetailV2View;
    'comparisonB': EachDepartmentComparisonCellDetailV2View;
    'diff': DiffRatioView;
    'id': string;
    'key': string;
    'name': string;
}
export interface EachDepartmentComparisonFlatTreeV2View {
    'items': Array<EachDepartmentComparisonTreeV4View>;
}
export interface EachDepartmentComparisonTableMetaPlanView {
    'containsActual': boolean;
    'containsPlan': boolean;
    'name'?: string;
    'planMasterId'?: string;
    'planSelected': boolean;
    'planType'?: EachDepartmentComparisonTableMetaPlanViewPlanTypeEnum;
    'planUpdateProjectId'?: string;
}

export const EachDepartmentComparisonTableMetaPlanViewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type EachDepartmentComparisonTableMetaPlanViewPlanTypeEnum = typeof EachDepartmentComparisonTableMetaPlanViewPlanTypeEnum[keyof typeof EachDepartmentComparisonTableMetaPlanViewPlanTypeEnum];

export interface EachDepartmentComparisonTableMetaV2View {
    'accountTreeId': string;
    'comparisonA': EachDepartmentComparisonTableMetaPlanView;
    'comparisonB': EachDepartmentComparisonTableMetaPlanView;
    'roundingMode': EachDepartmentComparisonTableMetaV2ViewRoundingModeEnum;
    'showDecimalPlacesIn': EachDepartmentComparisonTableMetaV2ViewShowDecimalPlacesInEnum;
    'showIn': EachDepartmentComparisonTableMetaV2ViewShowInEnum;
    'topDepartments': Array<EachDepartmentComparisonCellTypeV2View>;
}

export const EachDepartmentComparisonTableMetaV2ViewRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type EachDepartmentComparisonTableMetaV2ViewRoundingModeEnum = typeof EachDepartmentComparisonTableMetaV2ViewRoundingModeEnum[keyof typeof EachDepartmentComparisonTableMetaV2ViewRoundingModeEnum];
export const EachDepartmentComparisonTableMetaV2ViewShowDecimalPlacesInEnum = {
    None: 'NONE',
    One: 'ONE',
    Two: 'TWO',
    Three: 'THREE',
    Four: 'FOUR',
} as const;

export type EachDepartmentComparisonTableMetaV2ViewShowDecimalPlacesInEnum = typeof EachDepartmentComparisonTableMetaV2ViewShowDecimalPlacesInEnum[keyof typeof EachDepartmentComparisonTableMetaV2ViewShowDecimalPlacesInEnum];
export const EachDepartmentComparisonTableMetaV2ViewShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type EachDepartmentComparisonTableMetaV2ViewShowInEnum = typeof EachDepartmentComparisonTableMetaV2ViewShowInEnum[keyof typeof EachDepartmentComparisonTableMetaV2ViewShowInEnum];

export interface EachDepartmentComparisonTreeV4View {
    'accountId': string;
    'accountType': EachDepartmentComparisonTreeV4ViewAccountTypeEnum;
    'code': string;
    'data': Array<EachDepartmentComparisonCellV2View>;
    'id': string;
    'level': number;
    'name': string;
    'parentId'?: string;
    'rowType': EachDepartmentComparisonTreeV4ViewRowTypeEnum;
    'sumA'?: number;
    'sumB'?: number;
    'sumDiff': DiffRatioView;
    'viewControlType': EachDepartmentComparisonTreeV4ViewViewControlTypeEnum;
}

export const EachDepartmentComparisonTreeV4ViewAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type EachDepartmentComparisonTreeV4ViewAccountTypeEnum = typeof EachDepartmentComparisonTreeV4ViewAccountTypeEnum[keyof typeof EachDepartmentComparisonTreeV4ViewAccountTypeEnum];
export const EachDepartmentComparisonTreeV4ViewRowTypeEnum = {
    Account: 'ACCOUNT',
    AccountOwnValue: 'ACCOUNT_OWN_VALUE',
} as const;

export type EachDepartmentComparisonTreeV4ViewRowTypeEnum = typeof EachDepartmentComparisonTreeV4ViewRowTypeEnum[keyof typeof EachDepartmentComparisonTreeV4ViewRowTypeEnum];
export const EachDepartmentComparisonTreeV4ViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type EachDepartmentComparisonTreeV4ViewViewControlTypeEnum = typeof EachDepartmentComparisonTreeV4ViewViewControlTypeEnum[keyof typeof EachDepartmentComparisonTreeV4ViewViewControlTypeEnum];

export interface EachDepartmentComparisonV2View {
    'meta': EachDepartmentComparisonTableMetaV2View;
    'tree': EachDepartmentComparisonFlatTreeV2View;
}
export interface EachMonthFixedPatternBody {
    'monthToFixedAmounts': Array<MonthToFixedAmount>;
    'targetAccountId': string;
}
export interface EachMonthFixedPatternView {
    'monthToFixedAmounts': Array<MonthToFixedAmount>;
    'targetAccountId': string;
    'targetAccountName': string;
}
export interface EachMonthRatioPatternBody {
    'monthToRatios': Array<MonthToRatio>;
    'targetAccountId': string;
}
export interface EachMonthRatioPatternView {
    'monthToRatios': Array<MonthToRatio>;
    'targetAccountId': string;
    'targetAccountName': string;
}
export interface EachMonthRealValuePatternBody {
    'monthToRealValues': Array<MonthToRealValue>;
    'targetAccountId': string;
}
export interface EachMonthRealValuePatternView {
    'monthToRealValues': Array<MonthToRealValue>;
    'targetAccountId': string;
    'targetAccountName': string;
}
export interface EachWorkforceDiffItem {
    'afterAmount'?: number;
    'beforeAmount'?: number;
    'diffAmount'?: number;
    'isLeaveOfAbsence': boolean;
    'yearMonthId': string;
}
export interface EachWorkforceDiffRow {
    'eachConcurrentPostDiffs': Array<EachConcurrentPostDiff>;
    'eachWorkforceDiffItems': Array<EachWorkforceDiffItem>;
    'id': string;
    'name': string;
    'transferDepartmentDiffs': Array<TransferDepartmentDiff>;
    'workforceOrSlotType': EachWorkforceDiffRowWorkforceOrSlotTypeEnum;
}

export const EachWorkforceDiffRowWorkforceOrSlotTypeEnum = {
    Workforce: 'WORKFORCE',
    HiringSlot: 'HIRING_SLOT',
    ResignationSlot: 'RESIGNATION_SLOT',
    LeaveOfAbsenceSlot: 'LEAVE_OF_ABSENCE_SLOT',
    ReturnToWorkSlot: 'RETURN_TO_WORK_SLOT',
    TransferDepartmentSlot: 'TRANSFER_DEPARTMENT_SLOT',
} as const;

export type EachWorkforceDiffRowWorkforceOrSlotTypeEnum = typeof EachWorkforceDiffRowWorkforceOrSlotTypeEnum[keyof typeof EachWorkforceDiffRowWorkforceOrSlotTypeEnum];

export interface EditReportDescriptionBody {
    'content': string;
}
export interface EditUserParam {
    'email'?: string;
    'firstName'?: string;
    'lastName'?: string;
    'mfaMethod'?: string;
    'requireMFA': boolean;
    'role': EditUserParamRoleEnum;
}

export const EditUserParamRoleEnum = {
    LoglassSystemAdmin: 'LOGLASS_SYSTEM_ADMIN',
    TenantAdmin: 'TENANT_ADMIN',
    CorpPlanning: 'CORP_PLANNING',
    Manager: 'MANAGER',
    ItStaff: 'IT_STAFF',
    General: 'GENERAL',
} as const;

export type EditUserParamRoleEnum = typeof EditUserParamRoleEnum[keyof typeof EditUserParamRoleEnum];

export interface EitherAmountOrErrorView {
    'amount'?: string;
    'error'?: AmountErrorView;
}
export interface EnabledFeaturesDto {
    'enabledFeatures': Array<EnabledFeaturesDtoEnabledFeaturesEnum>;
}

export const EnabledFeaturesDtoEnabledFeaturesEnum = {
    ActualItemDetailView: 'ACTUAL_ITEM_DETAIL_VIEW',
    FinancialSheetComment: 'FINANCIAL_SHEET_COMMENT',
    FinancialSheetExcelDownload: 'FINANCIAL_SHEET_EXCEL_DOWNLOAD',
    ComparisonSheetSelectedConditionSave: 'COMPARISON_SHEET_SELECTED_CONDITION_SAVE',
    ComparisonSheetHighlight: 'COMPARISON_SHEET_HIGHLIGHT',
    AnalyticsDataDownload: 'ANALYTICS_DATA_DOWNLOAD',
    BulkPlanUpdateRequest: 'BULK_PLAN_UPDATE_REQUEST',
    DevTableauDashboard: 'DEV_TABLEAU_DASHBOARD',
    ViewPermission: 'VIEW_PERMISSION',
    NonFinancialActualCsvFormat: 'NON_FINANCIAL_ACTUAL_CSV_FORMAT',
    FinancialSheetHistoryAndDepartment: 'FINANCIAL_SHEET_HISTORY_AND_DEPARTMENT',
    IpRestriction: 'IP_RESTRICTION',
    IpRestrictionLoglassSystemAdmin: 'IP_RESTRICTION_LOGLASS_SYSTEM_ADMIN',
    MultiProductUserDeletionRestriction: 'MULTI_PRODUCT_USER_DELETION_RESTRICTION',
    AiAssistant: 'AI_ASSISTANT',
    AiAssistantForCorpPlanning: 'AI_ASSISTANT_FOR_CORP_PLANNING',
    AiAssistantForEditor: 'AI_ASSISTANT_FOR_EDITOR',
    AiAssistantForViewer: 'AI_ASSISTANT_FOR_VIEWER',
    NewDashboard: 'NEW_DASHBOARD',
    ReportEnhance: 'REPORT_ENHANCE',
    AllocationByDimensions: 'ALLOCATION_BY_DIMENSIONS',
    WorkforcePlanning: 'WORKFORCE_PLANNING',
    ApiIntegration: 'API_INTEGRATION',
    AllocationForEachItem: 'ALLOCATION_FOR_EACH_ITEM',
    AllocationRemake: 'ALLOCATION_REMAKE',
    FinancialSimulator: 'FINANCIAL_SIMULATOR',
    CashFlow: 'CASH_FLOW',
    IncreaseDimensionTagLimit: 'INCREASE_DIMENSION_TAG_LIMIT',
    ForeignCurrency: 'FOREIGN_CURRENCY',
    AllocationOldDeactivation: 'ALLOCATION_OLD_DEACTIVATION',
    NewWorkforcePlanningSimulation: 'NEW_WORKFORCE_PLANNING_SIMULATION',
    OldWorkforcePlanningSimulation: 'OLD_WORKFORCE_PLANNING_SIMULATION',
    AsyncAllocationExecution: 'ASYNC_ALLOCATION_EXECUTION',
    TmpAllocationFeatureForIne: 'TMP_ALLOCATION_FEATURE_FOR_INE',
    UnitPriceDataImportActual: 'UNIT_PRICE_DATA_IMPORT_ACTUAL',
    CashFlowPolars: 'CASH_FLOW_POLARS',
    ReportEnhance2: 'REPORT_ENHANCE_2',
    ReportEnhance3: 'REPORT_ENHANCE_3',
    CategoryAxisSelection: 'CATEGORY_AXIS_SELECTION',
    CustomPlanFormat: 'CUSTOM_PLAN_FORMAT',
    AiChatMaintenance: 'AI_CHAT_MAINTENANCE',
    ReportCumulativeRow: 'REPORT_CUMULATIVE_ROW',
    AiChatSpeedModeThinkingDisabled: 'AI_CHAT_SPEED_MODE_THINKING_DISABLED',
    AggregateParquetMonthlyPartition: 'AGGREGATE_PARQUET_MONTHLY_PARTITION',
    CommentNotification: 'COMMENT_NOTIFICATION',
    EmailNotificationPerFeature: 'EMAIL_NOTIFICATION_PER_FEATURE',
} as const;

export type EnabledFeaturesDtoEnabledFeaturesEnum = typeof EnabledFeaturesDtoEnabledFeaturesEnum[keyof typeof EnabledFeaturesDtoEnabledFeaturesEnum];

export interface EndsWith {
    'conditionValue': string;
}
export interface Entered {
    'conditionValue'?: string;
}
export interface Equals {
    'conditionValue': string;
}
export interface EqualsAny {
    'conditionValue': string;
    'conditionValues': Array<string>;
}
export interface ErrorResponse {
    'error': string;
    'errorCode': ErrorResponseErrorCodeEnum;
    'jsonMsg'?: string;
    'message': string;
    'statusCode': ErrorResponseStatusCodeEnum;
}

export const ErrorResponseErrorCodeEnum = {
    ValidationError: 'VALIDATION_ERROR',
    InvalidYearMonth: 'INVALID_YEAR_MONTH',
    BadRequest: 'BAD_REQUEST',
    UnavailableFeature: 'UNAVAILABLE_FEATURE',
    InvalidStateOfTree: 'INVALID_STATE_OF_TREE',
    PlanningProjectIsFixed: 'PLANNING_PROJECT_IS_FIXED',
    PlanningProjectIsNotFixing: 'PLANNING_PROJECT_IS_NOT_FIXING',
    PlanningProjectIsFixing: 'PLANNING_PROJECT_IS_FIXING',
    PlanUpdateRequestIsNotLatest: 'PLAN_UPDATE_REQUEST_IS_NOT_LATEST',
    PlanUpdateRequestIsClosed: 'PLAN_UPDATE_REQUEST_IS_CLOSED',
    PlanUpdateRequestHasNoDiff: 'PLAN_UPDATE_REQUEST_HAS_NO_DIFF',
    BulkPullrequestsHaveNoDiff: 'BULK_PULLREQUESTS_HAVE_NO_DIFF',
    Unauthenticated: 'UNAUTHENTICATED',
    PermissionDenied: 'PERMISSION_DENIED',
    NotFound: 'NOT_FOUND',
    DuplicatedEmail: 'DUPLICATED_EMAIL',
    CodeConflict: 'CODE_CONFLICT',
    NameConflict: 'NAME_CONFLICT',
    ConcurrentUpdate: 'CONCURRENT_UPDATE',
    InternalServerError: 'INTERNAL_SERVER_ERROR',
} as const;

export type ErrorResponseErrorCodeEnum = typeof ErrorResponseErrorCodeEnum[keyof typeof ErrorResponseErrorCodeEnum];
export const ErrorResponseStatusCodeEnum = {
    Default: 'DEFAULT',
    Continue: 'CONTINUE',
    SwitchingProtocols: 'SWITCHING_PROTOCOLS',
    Processing: 'PROCESSING',
    Ok: 'OK',
    Created: 'CREATED',
    Accepted: 'ACCEPTED',
    NonAuthoritativeInformation: 'NON_AUTHORITATIVE_INFORMATION',
    NoContent: 'NO_CONTENT',
    ResetContent: 'RESET_CONTENT',
    PartialContent: 'PARTIAL_CONTENT',
    MultiStatus: 'MULTI_STATUS',
    ImUsed: 'IM_USED',
    MultipleChoices: 'MULTIPLE_CHOICES',
    HttpStatusCodeMovedPermanently: 'HTTP_STATUS_CODE_MOVED_PERMANENTLY',
    Found: 'FOUND',
    SeeOther: 'SEE_OTHER',
    NotModified: 'NOT_MODIFIED',
    UseProxy: 'USE_PROXY',
    Unused: 'UNUSED',
    TemporaryRedirect: 'TEMPORARY_REDIRECT',
    BadRequest: 'BAD_REQUEST',
    Unauthorized: 'UNAUTHORIZED',
    PaymentRequired: 'PAYMENT_REQUIRED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    MethodNotAllowed: 'METHOD_NOT_ALLOWED',
    NotAcceptable: 'NOT_ACCEPTABLE',
    ProxyAuthenticationRequired: 'PROXY_AUTHENTICATION_REQUIRED',
    RequestTimeOut: 'REQUEST_TIME_OUT',
    Conflict: 'CONFLICT',
    Gone: 'GONE',
    LengthRequired: 'LENGTH_REQUIRED',
    PreconditionFailed: 'PRECONDITION_FAILED',
    RequestEntityTooLarge: 'REQUEST_ENTITY_TOO_LARGE',
    RequestUriTooLong: 'REQUEST_URI_TOO_LONG',
    UnsupportedMediaType: 'UNSUPPORTED_MEDIA_TYPE',
    RequestedRangeNotSatisfiable: 'REQUESTED_RANGE_NOT_SATISFIABLE',
    ExpectationFailed: 'EXPECTATION_FAILED',
    UnprocessableEntity: 'UNPROCESSABLE_ENTITY',
    Locked: 'LOCKED',
    FailedDependency: 'FAILED_DEPENDENCY',
    UpgradeRequired: 'UPGRADE_REQUIRED',
    InternalServerError: 'INTERNAL_SERVER_ERROR',
    NotImplemented: 'NOT_IMPLEMENTED',
    BadGateway: 'BAD_GATEWAY',
    ServiceUnavailable: 'SERVICE_UNAVAILABLE',
    GatewayTimeOut: 'GATEWAY_TIME_OUT',
    HttpVersionNotSupported: 'HTTP_VERSION_NOT_SUPPORTED',
    VariantAlsoNegotiates: 'VARIANT_ALSO_NEGOTIATES',
    InsufficientStorage: 'INSUFFICIENT_STORAGE',
    BandWidthLimitExceeded: 'BAND_WIDTH_LIMIT_EXCEEDED',
    NotExtended: 'NOT_EXTENDED',
} as const;

export type ErrorResponseStatusCodeEnum = typeof ErrorResponseStatusCodeEnum[keyof typeof ErrorResponseStatusCodeEnum];

export interface EventDetail {
    'departmentId'?: string;
    'dimensionId'?: string;
    'dimensionTagId'?: string;
    'eventType': EventDetailEventTypeEnum;
}

export const EventDetailEventTypeEnum = {
    Started: 'STARTED',
    End: 'END',
    DepartmentChanged: 'DEPARTMENT_CHANGED',
    DimensionTagChanged: 'DIMENSION_TAG_CHANGED',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
} as const;

export type EventDetailEventTypeEnum = typeof EventDetailEventTypeEnum[keyof typeof EventDetailEventTypeEnum];

export interface EventParam {
    'details': Array<EventDetail>;
    'yearMonth': string;
}
export interface ExchangeRateCurrencyData {
    'currencyLocalId': string;
    'currencyLocalName': string;
    'fiscalMonthData': { [key: string]: number; };
}
export interface ExchangeRateCurrencyDataParam {
    'currencyLocalId': string;
    'fiscalMonthData': { [key: string]: string; };
}
export interface ExchangeRateData {
    'amountLastUpdateUserName': string;
    'amountLastUpdatedAt': string;
    'exchangeRateId': string;
    'isActualPrimary'?: boolean;
    'isPlanPrimary'?: boolean;
    'name': string;
    'remarks'?: string;
}
export interface ExchangeRateDetailData {
    'amountLastUpdatedAt': string;
    'exchangeRateCurrencyList': Array<ExchangeRateCurrencyData>;
    'exchangeRateId': string;
    'isActualPrimary'?: boolean;
    'isPlanPrimary'?: boolean;
    'lastUpdateUserName': string;
    'name': string;
    'remarks'?: string;
}
export interface ExchangeRatePrimaryData {
    'exchangeRateId': string;
    'exchangeRatePrimaryId': string;
    'targetType': ExchangeRatePrimaryDataTargetTypeEnum;
    'tenantId': string;
}

export const ExchangeRatePrimaryDataTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type ExchangeRatePrimaryDataTargetTypeEnum = typeof ExchangeRatePrimaryDataTargetTypeEnum[keyof typeof ExchangeRatePrimaryDataTargetTypeEnum];

export interface ExchangeRatePrimaryRequestParam {
    'exchangeRateId': string;
    'targetType': ExchangeRatePrimaryRequestParamTargetTypeEnum;
}

export const ExchangeRatePrimaryRequestParamTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type ExchangeRatePrimaryRequestParamTargetTypeEnum = typeof ExchangeRatePrimaryRequestParamTargetTypeEnum[keyof typeof ExchangeRatePrimaryRequestParamTargetTypeEnum];

export interface ExchangeRateRequestParam {
    'name': string;
    'remarks'?: string;
}
export interface ExcludePatternBody {
    'name': string;
}
export interface ExcludePatternView {
    'name': string;
}
export interface ExcludedPlanContentView {
    'event': WorkforcePlanChangeEventView;
    'planChangeType': ExcludedPlanContentViewPlanChangeTypeEnum;
    'yearMonth': string;
}

export const ExcludedPlanContentViewPlanChangeTypeEnum = {
    DepartmentChanged: 'DEPARTMENT_CHANGED',
    DimensionTagChanged: 'DIMENSION_TAG_CHANGED',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    End: 'END',
    EndDateChanged: 'END_DATE_CHANGED',
    ConcurrentPostStart: 'CONCURRENT_POST_START',
    ConcurrentPostRelease: 'CONCURRENT_POST_RELEASE',
} as const;

export type ExcludedPlanContentViewPlanChangeTypeEnum = typeof ExcludedPlanContentViewPlanChangeTypeEnum[keyof typeof ExcludedPlanContentViewPlanChangeTypeEnum];

export interface ExcludedWorkforcePlanChangeView {
    'departmentName'?: string;
    'planContents': Array<ExcludedPlanContentView>;
    'reason': ExcludedWorkforcePlanChangeViewReasonEnum;
    'workforceName': string;
}

export const ExcludedWorkforcePlanChangeViewReasonEnum = {
    UnapprovedRequestConflict: 'UNAPPROVED_REQUEST_CONFLICT',
    PrecedingChangeNotApproved: 'PRECEDING_CHANGE_NOT_APPROVED',
    ActualMismatch: 'ACTUAL_MISMATCH',
} as const;

export type ExcludedWorkforcePlanChangeViewReasonEnum = typeof ExcludedWorkforcePlanChangeViewReasonEnum[keyof typeof ExcludedWorkforcePlanChangeViewReasonEnum];

export interface ExcludedWorkforcePlanView {
    'departmentNames': Array<string>;
    'planContents': Array<ExcludedPlanContentView>;
    'reason': ExcludedWorkforcePlanViewReasonEnum;
    'workforceName': string;
}

export const ExcludedWorkforcePlanViewReasonEnum = {
    UnapprovedRequestConflict: 'UNAPPROVED_REQUEST_CONFLICT',
    PrecedingChangeNotApproved: 'PRECEDING_CHANGE_NOT_APPROVED',
    ActualMismatch: 'ACTUAL_MISMATCH',
} as const;

export type ExcludedWorkforcePlanViewReasonEnum = typeof ExcludedWorkforcePlanViewReasonEnum[keyof typeof ExcludedWorkforcePlanViewReasonEnum];

export interface ExcludedWorkforceSlotPlanView {
    'departmentName'?: string;
    'reason': ExcludedWorkforceSlotPlanViewReasonEnum;
    'workforceSlotName': string;
}

export const ExcludedWorkforceSlotPlanViewReasonEnum = {
    UnapprovedRequestConflict: 'UNAPPROVED_REQUEST_CONFLICT',
    PrecedingChangeNotApproved: 'PRECEDING_CHANGE_NOT_APPROVED',
    ActualMismatch: 'ACTUAL_MISMATCH',
} as const;

export type ExcludedWorkforceSlotPlanViewReasonEnum = typeof ExcludedWorkforceSlotPlanViewReasonEnum[keyof typeof ExcludedWorkforceSlotPlanViewReasonEnum];

export interface ExecuteAllocationRequest {
    'dataSourceId': string;
    'patternId': string;
    'yearMonth': string;
}
export interface ExecuteAllocationRequestBody {
    'patternId': string;
    'targetType': ExecuteAllocationRequestBodyTargetTypeEnum;
    'yearMonthSet': Array<string>;
}

export const ExecuteAllocationRequestBodyTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type ExecuteAllocationRequestBodyTargetTypeEnum = typeof ExecuteAllocationRequestBodyTargetTypeEnum[keyof typeof ExecuteAllocationRequestBodyTargetTypeEnum];

export interface ExecutionResult {
    'executedAt'?: string;
    'status': ExecutionResultStatusEnum;
}

export const ExecutionResultStatusEnum = {
    NotStarted: 'NOT_STARTED',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    CompletedWithChanges: 'COMPLETED_WITH_CHANGES',
    Error: 'ERROR',
} as const;

export type ExecutionResultStatusEnum = typeof ExecutionResultStatusEnum[keyof typeof ExecutionResultStatusEnum];

export interface ExecutionResultDetail {
    'errorMessage'?: string;
    'executedAt'?: string;
    'status': ExecutionResultDetailStatusEnum;
}

export const ExecutionResultDetailStatusEnum = {
    NotStarted: 'NOT_STARTED',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    CompletedWithChanges: 'COMPLETED_WITH_CHANGES',
    Error: 'ERROR',
} as const;

export type ExecutionResultDetailStatusEnum = typeof ExecutionResultDetailStatusEnum[keyof typeof ExecutionResultDetailStatusEnum];

export interface ExecutionResultPattern {
    'id': string;
    'name': string;
    'rules': Array<ExecutionResultRule>;
}
export interface ExecutionResultResponse {
    'pattern': ExecutionResultPattern;
    'result': ExecutionResultDetail;
    'yearMonth': string;
}
export interface ExecutionResultRule {
    'id': string;
    'name': string;
    'referenceValue': string;
}
export interface ExecutionsResponse {
    'dataSources': Array<DataSourceForExecutionSettings>;
    'executions': Array<DataSourceExecution>;
    'statuses': Array<ExecutionsResponseStatusesEnum>;
}

export const ExecutionsResponseStatusesEnum = {
    NotStarted: 'NOT_STARTED',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    CompletedWithChanges: 'COMPLETED_WITH_CHANGES',
    Error: 'ERROR',
} as const;

export type ExecutionsResponseStatusesEnum = typeof ExecutionsResponseStatusesEnum[keyof typeof ExecutionsResponseStatusesEnum];

export interface FetchActualRequestBody {
    'actualEnd': string;
    'actualStart': string;
    'allocationPatternId': string;
    'departmentIds'?: Array<string>;
    'isAsc': boolean;
    'limit': number;
    'offset': number;
    'orgTreeId': string;
    'period'?: string;
    'requireAllocatedItems': boolean;
    'rowType': FetchActualRequestBodyRowTypeEnum;
    'showIn'?: FetchActualRequestBodyShowInEnum;
    'sortKey': FetchActualRequestBodySortKeyEnum;
}

export const FetchActualRequestBodyRowTypeEnum = {
    Account: 'ACCOUNT',
    AccountOwnValue: 'ACCOUNT_OWN_VALUE',
} as const;

export type FetchActualRequestBodyRowTypeEnum = typeof FetchActualRequestBodyRowTypeEnum[keyof typeof FetchActualRequestBodyRowTypeEnum];
export const FetchActualRequestBodyShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FetchActualRequestBodyShowInEnum = typeof FetchActualRequestBodyShowInEnum[keyof typeof FetchActualRequestBodyShowInEnum];
export const FetchActualRequestBodySortKeyEnum = {
    JournalDate: 'JOURNAL_DATE',
    DepartmentName: 'DEPARTMENT_NAME',
    AccountName: 'ACCOUNT_NAME',
    SupplierName: 'SUPPLIER_NAME',
    Description: 'DESCRIPTION',
    Amount: 'AMOUNT',
} as const;

export type FetchActualRequestBodySortKeyEnum = typeof FetchActualRequestBodySortKeyEnum[keyof typeof FetchActualRequestBodySortKeyEnum];

export interface FetchAggregatePlanUpdateRequestRequestBody {
    'actualExchangeRateId'?: string;
    'currencyCode'?: string;
    'departmentIds': Array<string>;
    'planExchangeRateId'?: string;
    'showIn'?: FetchAggregatePlanUpdateRequestRequestBodyShowInEnum;
    'target': FetchAggregatePlanUpdateRequestRequestBodyTargetEnum;
}

export const FetchAggregatePlanUpdateRequestRequestBodyShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FetchAggregatePlanUpdateRequestRequestBodyShowInEnum = typeof FetchAggregatePlanUpdateRequestRequestBodyShowInEnum[keyof typeof FetchAggregatePlanUpdateRequestRequestBodyShowInEnum];
export const FetchAggregatePlanUpdateRequestRequestBodyTargetEnum = {
    Pl: 'PL',
    Bs: 'BS',
} as const;

export type FetchAggregatePlanUpdateRequestRequestBodyTargetEnum = typeof FetchAggregatePlanUpdateRequestRequestBodyTargetEnum[keyof typeof FetchAggregatePlanUpdateRequestRequestBodyTargetEnum];

export interface FetchAllocationSanitizedStepView {
    'allocationAxisCondition': SanitizedAllocationAxisCondition;
    'description'?: string;
    'destinationAccount'?: SanitizedDestinationAccount;
    'filterConditions': Array<SanitizedFilterCondition>;
    'loopCondition'?: SanitizedLoopCondition;
    'name': string;
    'sourceAccounts': SanitizedSourceAccounts;
    'standardAccounts'?: SanitizedStandardAccounts;
}
export interface FetchAllocationStepView {
    'allocationAxisCondition': AllocationAxisCondition;
    'description'?: string;
    'destinationAccount'?: DestinationAccount;
    'filterConditions': Array<FilterCondition>;
    'id': string;
    'loopCondition'?: LoopCondition;
    'name': string;
    'sourceAccounts': SourceAccounts;
    'standardAccounts'?: StandardAccountsWithAccountType;
}
export interface FetchComboChartDataRequestBody {
    'barShowAsBreakdown': boolean;
    'barShowCumulativeRow': boolean;
    'barStackingMode': FetchComboChartDataRequestBodyBarStackingModeEnum;
    'barVisibleMetrics': Array<FetchComboChartDataRequestBodyBarVisibleMetricsEnum>;
    'barVisibleRowTagIds': Array<Array<string>>;
    'lineShowCumulativeRow': boolean;
    'lineVisibleMetrics': Array<FetchComboChartDataRequestBodyLineVisibleMetricsEnum>;
    'lineVisibleRowTagIds': Array<Array<string>>;
    'reportId': string;
    'viewFilterConditions'?: Array<DimensionFilter>;
    'visibleColumnTagIds'?: Array<Array<string>>;
}

export const FetchComboChartDataRequestBodyBarStackingModeEnum = {
    None: 'NONE',
    Normal: 'NORMAL',
    Percent: 'PERCENT',
} as const;

export type FetchComboChartDataRequestBodyBarStackingModeEnum = typeof FetchComboChartDataRequestBodyBarStackingModeEnum[keyof typeof FetchComboChartDataRequestBodyBarStackingModeEnum];
export const FetchComboChartDataRequestBodyBarVisibleMetricsEnum = {
    DataA: 'DATA_A',
    DataB: 'DATA_B',
    DataC: 'DATA_C',
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type FetchComboChartDataRequestBodyBarVisibleMetricsEnum = typeof FetchComboChartDataRequestBodyBarVisibleMetricsEnum[keyof typeof FetchComboChartDataRequestBodyBarVisibleMetricsEnum];
export const FetchComboChartDataRequestBodyLineVisibleMetricsEnum = {
    DataA: 'DATA_A',
    DataB: 'DATA_B',
    DataC: 'DATA_C',
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type FetchComboChartDataRequestBodyLineVisibleMetricsEnum = typeof FetchComboChartDataRequestBodyLineVisibleMetricsEnum[keyof typeof FetchComboChartDataRequestBodyLineVisibleMetricsEnum];

export interface FetchComparisonActualStartEndParam {
    'end': string;
    'start': string;
}
export interface FetchComparisonHighlightParam {
    'threshold': number;
    'type': FetchComparisonHighlightParamTypeEnum;
}

export const FetchComparisonHighlightParamTypeEnum = {
    DiffAmount: 'DIFF_AMOUNT',
    DiffRatio: 'DIFF_RATIO',
} as const;

export type FetchComparisonHighlightParamTypeEnum = typeof FetchComparisonHighlightParamTypeEnum[keyof typeof FetchComparisonHighlightParamTypeEnum];

export interface FetchComparisonRequestABParam {
    'actualStartEnd'?: FetchComparisonActualStartEndParam;
    'planEnd': string;
    'planMasterId'?: string;
    'planShowActual': boolean;
    'planStart': string;
    'planningProjectId'?: string;
}
export interface FetchComparisonRequestBody {
    'accountTreeId': string;
    'aggregate': FetchComparisonRequestBodyAggregateEnum;
    'allocationPatternId': string;
    'departmentIds': Array<string>;
    'highlightParam'?: FetchComparisonHighlightParam;
    'isSpecificAccountRatio': boolean;
    'orgTreeId': string;
    'paramA': FetchComparisonRequestABParam;
    'paramB': FetchComparisonRequestABParam;
    'requireAllocatedItems': boolean;
    'showIn': FetchComparisonRequestBodyShowInEnum;
}

export const FetchComparisonRequestBodyAggregateEnum = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    FiscalYear: 'FISCAL_YEAR',
    FiscalHalfYear: 'FISCAL_HALF_YEAR',
} as const;

export type FetchComparisonRequestBodyAggregateEnum = typeof FetchComparisonRequestBodyAggregateEnum[keyof typeof FetchComparisonRequestBodyAggregateEnum];
export const FetchComparisonRequestBodyShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FetchComparisonRequestBodyShowInEnum = typeof FetchComparisonRequestBodyShowInEnum[keyof typeof FetchComparisonRequestBodyShowInEnum];

export interface FetchConnectionByWorkforceResult {
    'code': string;
    'connectionId': string;
    'name': string;
    'slotType': FetchConnectionByWorkforceResultSlotTypeEnum;
    'workforceSlotId': string;
}

export const FetchConnectionByWorkforceResultSlotTypeEnum = {
    Hiring: 'HIRING',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    TransferDepartment: 'TRANSFER_DEPARTMENT',
} as const;

export type FetchConnectionByWorkforceResultSlotTypeEnum = typeof FetchConnectionByWorkforceResultSlotTypeEnum[keyof typeof FetchConnectionByWorkforceResultSlotTypeEnum];

export interface FetchConnectionsBySlotResult {
    'connectedYearMonth': string;
    'connectionId': string;
    'effectiveYearMonth': string;
    'personCode': string;
    'personFullName': string;
}
export interface FetchDetailRequestBody {
    'accountId'?: string;
    'accountTreeId': string;
    'departmentIds'?: Array<MaybeOwnValueDepartmentId>;
    'dimensionId'?: string;
    'groupingType': FetchDetailRequestBodyGroupingTypeEnum;
    'limit': number;
    'offset': number;
    'orgTreeId': string;
    'planAActualStartEnd'?: FetchPlanActualDetailActualStartEndParam;
    'planAEnd': string;
    'planAMasterId'?: string;
    'planAPlanUpdateProjectId'?: string;
    'planAShowActual': boolean;
    'planAStart': string;
    'planBActualStartEnd'?: FetchPlanActualDetailActualStartEndParam;
    'planBEnd': string;
    'planBMasterId'?: string;
    'planBPlanUpdateProjectId'?: string;
    'planBShowActual': boolean;
    'planBStart': string;
    'rowType': FetchDetailRequestBodyRowTypeEnum;
    'showIn'?: FetchDetailRequestBodyShowInEnum;
}

export const FetchDetailRequestBodyGroupingTypeEnum = {
    Dimension: 'DIMENSION',
} as const;

export type FetchDetailRequestBodyGroupingTypeEnum = typeof FetchDetailRequestBodyGroupingTypeEnum[keyof typeof FetchDetailRequestBodyGroupingTypeEnum];
export const FetchDetailRequestBodyRowTypeEnum = {
    Account: 'ACCOUNT',
    AccountOwnValue: 'ACCOUNT_OWN_VALUE',
} as const;

export type FetchDetailRequestBodyRowTypeEnum = typeof FetchDetailRequestBodyRowTypeEnum[keyof typeof FetchDetailRequestBodyRowTypeEnum];
export const FetchDetailRequestBodyShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FetchDetailRequestBodyShowInEnum = typeof FetchDetailRequestBodyShowInEnum[keyof typeof FetchDetailRequestBodyShowInEnum];

export interface FetchEachDepartmentComparisonV2ActualStartEndParam {
    'end': string;
    'start': string;
}
export interface FetchEachDepartmentComparisonV2RequestABParam {
    'actualStartEnd'?: FetchEachDepartmentComparisonV2ActualStartEndParam;
    'planEnd': string;
    'planMasterId'?: string;
    'planShowActual': boolean;
    'planStart': string;
    'planUpdateProjectId'?: string;
}
export interface FetchEachDepartmentComparisonV2RequestBody {
    'accountTreeId': string;
    'allocationPatternId': string;
    'departmentIds'?: Array<string>;
    'orgTreeId': string;
    'paramA': FetchEachDepartmentComparisonV2RequestABParam;
    'paramB': FetchEachDepartmentComparisonV2RequestABParam;
    'requireAllocatedItems'?: boolean;
    'showIn'?: FetchEachDepartmentComparisonV2RequestBodyShowInEnum;
}

export const FetchEachDepartmentComparisonV2RequestBodyShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FetchEachDepartmentComparisonV2RequestBodyShowInEnum = typeof FetchEachDepartmentComparisonV2RequestBodyShowInEnum[keyof typeof FetchEachDepartmentComparisonV2RequestBodyShowInEnum];

export interface FetchFinancialSimulationScenarioCondition {
    'accountDrillDownConditionMap': { [key: string]: AccountDrillDownConditionParam; };
    'compareTargetIds': Array<string>;
    'datasetFormulaIds': Array<string>;
    'dimensionFilterConditionMap': { [key: string]: DimensionFilterConditionParam; };
    'dimensionVisibilityConditionMap': { [key: string]: DimensionVisibilityConditionParam; };
    'showNumbersIn': FetchFinancialSimulationScenarioConditionShowNumbersInEnum;
}

export const FetchFinancialSimulationScenarioConditionShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FetchFinancialSimulationScenarioConditionShowNumbersInEnum = typeof FetchFinancialSimulationScenarioConditionShowNumbersInEnum[keyof typeof FetchFinancialSimulationScenarioConditionShowNumbersInEnum];

export interface FetchFinancialSimulationScenarioRequestBody {
    'condition': FetchFinancialSimulationScenarioCondition;
    'dimensionType': FetchFinancialSimulationScenarioRequestBodyDimensionTypeEnum;
    'rows': Array<FinancialSimulationReportRowRequest>;
}

export const FetchFinancialSimulationScenarioRequestBodyDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
    Period: 'PERIOD',
} as const;

export type FetchFinancialSimulationScenarioRequestBodyDimensionTypeEnum = typeof FetchFinancialSimulationScenarioRequestBodyDimensionTypeEnum[keyof typeof FetchFinancialSimulationScenarioRequestBodyDimensionTypeEnum];

export interface FetchGraphDataRequestBody {
    'graphType': FetchGraphDataRequestBodyGraphTypeEnum;
    'reportId': string;
    'showAsBreakdown': boolean;
    'showCumulativeRow': boolean;
    'stackingMode': FetchGraphDataRequestBodyStackingModeEnum;
    'viewFilterConditions'?: Array<DimensionFilter>;
    'visibleColumnTagIds'?: Array<Array<string>>;
    'visibleMetrics': Array<FetchGraphDataRequestBodyVisibleMetricsEnum>;
    'visibleRowTagIds': Array<Array<string>>;
}

export const FetchGraphDataRequestBodyGraphTypeEnum = {
    Bar: 'BAR',
    HorizontalBar: 'HORIZONTAL_BAR',
    Line: 'LINE',
    Kpi: 'KPI',
    Combo: 'COMBO',
    Waterfall: 'WATERFALL',
    Pie: 'PIE',
} as const;

export type FetchGraphDataRequestBodyGraphTypeEnum = typeof FetchGraphDataRequestBodyGraphTypeEnum[keyof typeof FetchGraphDataRequestBodyGraphTypeEnum];
export const FetchGraphDataRequestBodyStackingModeEnum = {
    None: 'NONE',
    Normal: 'NORMAL',
    Percent: 'PERCENT',
} as const;

export type FetchGraphDataRequestBodyStackingModeEnum = typeof FetchGraphDataRequestBodyStackingModeEnum[keyof typeof FetchGraphDataRequestBodyStackingModeEnum];
export const FetchGraphDataRequestBodyVisibleMetricsEnum = {
    DataA: 'DATA_A',
    DataB: 'DATA_B',
    DataC: 'DATA_C',
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type FetchGraphDataRequestBodyVisibleMetricsEnum = typeof FetchGraphDataRequestBodyVisibleMetricsEnum[keyof typeof FetchGraphDataRequestBodyVisibleMetricsEnum];

export interface FetchPermissionGroupAssignTargetUsersView {
    'users': Array<UnassignedPermissionGroupUser>;
}
export interface FetchPieChartDataRequestBody {
    'reportId': string;
    'selectedBreakdownIds'?: Array<string>;
    'selectedColumnId': string;
    'selectedDataConditionId': FetchPieChartDataRequestBodySelectedDataConditionIdEnum;
    'selectedMainDimensionIds': Array<string>;
    'showCumulativeRow': boolean;
    'viewFilterConditions'?: Array<DimensionFilter>;
}

export const FetchPieChartDataRequestBodySelectedDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type FetchPieChartDataRequestBodySelectedDataConditionIdEnum = typeof FetchPieChartDataRequestBodySelectedDataConditionIdEnum[keyof typeof FetchPieChartDataRequestBodySelectedDataConditionIdEnum];

export interface FetchPlanActualDetailActualStartEndParam {
    'end': string;
    'start': string;
}
export interface FetchPlanActualDetailRowView {
    'accountCode': string;
    'accountName': string;
    'cells': Array<PlanActualCellView>;
    'departmentName': string;
    'planASumScaledAmount'?: string;
    'planBSumScaledAmount'?: string;
    'sumDiffRatio'?: string;
    'sumDiffScaledAmount'?: string;
    'tagName': string;
}
export interface FetchPlanActualDetailView {
    'meta': FetchPlanActualMetaView;
    'rows': Array<FetchPlanActualDetailRowView>;
}
export interface FetchPlanActualMetaView {
    'paging': PagingDto;
    'periodPairs': Array<PlanPeriodPairView>;
}
export interface FetchSimulatingWorkforceConstraintUseCaseReturn {
    'allowedYearMonths': Array<SimulatingWorkforceUsableEvent>;
}
export interface FetchSimulatingWorkforceEventsUseCaseReturn {
    'concurrentPostEvents': Array<SimulatingWorkforceConcurrentPostEventItem>;
    'eventByEffectiveYearMonth': Array<SimulatingWorkforceEventItem>;
    'leaveOfAbsencePeriods': Array<SimulatingWorkforceLeavePeriodItem>;
}
export interface FetchSimulatingWorkforceUseCaseReturn {
    'code': string;
    'current': SimulatingWorkforceCurrentMonthInfo;
    'endDate'?: string;
    'id': string;
    'name': string;
    'startDate': string;
    'yearMonth': string;
}
export interface FetchTransferSanitizedStepView {
    'description'?: string;
    'destinationAccountCondition'?: SanitizedDestinationAccountCondition;
    'destinationAxisConditions': Array<SanitizedDestinationAxisCondition>;
    'name': string;
    'sourceAccountCondition'?: SanitizedSourceAccountsCondition;
    'sourceAxisConditions': Array<SanitizedSourceAxisCondition>;
}
export interface FetchTransferStepView {
    'description'?: string;
    'destinationAccountCondition'?: TransferSingleAccountCondition;
    'destinationAxisConditions': Array<TransferSingleAxisCondition>;
    'id': string;
    'name': string;
    'sourceAccountCondition'?: TransferAccountCondition;
    'sourceAxisConditions': Array<TransferAxisCondition>;
}
export interface FetchUnitAmountSuggestionsRequestBody {
    'departmentId'?: string;
    'dimensionTagIds': { [key: string]: string; };
}
export interface FetchUnitAmountSuggestionsResponse {
    'suggestions': Array<UnitAmountSuggestionView>;
}
export interface FetchWorkforcePlanningAllowedActionReturn {
    'allowedActions': Array<FetchWorkforcePlanningAllowedActionReturnAllowedActionsEnum>;
    'availableWorkforceActualDetail': boolean;
}

export const FetchWorkforcePlanningAllowedActionReturnAllowedActionsEnum = {
    CrudWorkforceActual: 'CRUD_WORKFORCE_ACTUAL',
    CrudUnitAmount: 'CRUD_UNIT_AMOUNT',
    ConnectWorkforceSlotToActual: 'CONNECT_WORKFORCE_SLOT_TO_ACTUAL',
} as const;

export type FetchWorkforcePlanningAllowedActionReturnAllowedActionsEnum = typeof FetchWorkforcePlanningAllowedActionReturnAllowedActionsEnum[keyof typeof FetchWorkforcePlanningAllowedActionReturnAllowedActionsEnum];

export interface FetchWorkforcePlanningPermissionGroupReturn {
    'assignedUserIds': Array<string>;
    'id': string;
    'name': string;
    'restrictedActions': Array<FetchWorkforcePlanningPermissionGroupReturnRestrictedActionsEnum>;
}

export const FetchWorkforcePlanningPermissionGroupReturnRestrictedActionsEnum = {
    CrudWorkforceActual: 'CRUD_WORKFORCE_ACTUAL',
    CrudUnitAmount: 'CRUD_UNIT_AMOUNT',
    ConnectWorkforceSlotToActual: 'CONNECT_WORKFORCE_SLOT_TO_ACTUAL',
} as const;

export type FetchWorkforcePlanningPermissionGroupReturnRestrictedActionsEnum = typeof FetchWorkforcePlanningPermissionGroupReturnRestrictedActionsEnum[keyof typeof FetchWorkforcePlanningPermissionGroupReturnRestrictedActionsEnum];

export interface FetchWorkforcePlanningProjectDto {
    'rulesetId'?: string;
    'rulesetName'?: string;
    'status': FetchWorkforcePlanningProjectDtoStatusEnum;
    'workforcePlanningProjectId': string;
}

export const FetchWorkforcePlanningProjectDtoStatusEnum = {
    Assigned: 'ASSIGNED',
    Deleted: 'DELETED',
    NotAssigned: 'NOT_ASSIGNED',
} as const;

export type FetchWorkforcePlanningProjectDtoStatusEnum = typeof FetchWorkforcePlanningProjectDtoStatusEnum[keyof typeof FetchWorkforcePlanningProjectDtoStatusEnum];

export interface FetchWorkforcePlanningProjectUseCaseReturn {
    'workforcePlanningProject'?: FetchWorkforcePlanningProjectDto;
}
export interface FetchWorkforcePlanningSimulationTargetDepartmentUseCaseReturn {
    'allDepartments': Array<WorkforcePlanningSimulationTargetDepartmentItem>;
    'visibleDepartments': Array<WorkforcePlanningSimulationTargetDepartmentItem>;
}
export interface FetchWorkforcePlanningSimulationUsingDimensionUseCaseReturn {
    'items': Array<WorkforcePlanningSimulationUsingDimension>;
}
export interface FetchWorkforceSlotsWithHistoryQueryServiceItem {
    'code': string;
    'departmentName'?: string;
    'dimensionTagNameList': Array<WorkforceSlotListItemDimensionTagDto>;
    'hasSlotPlanVersion': boolean;
    'name': string;
    'slotId': string;
    'slotType': FetchWorkforceSlotsWithHistoryQueryServiceItemSlotTypeEnum;
    'toDepartmentName'?: string;
    'totalActualUsedCount': number;
    'totalPlannedCount'?: number;
    'unitAmounts': Array<WorkforceSlotListUnitAmountItemDto>;
}

export const FetchWorkforceSlotsWithHistoryQueryServiceItemSlotTypeEnum = {
    Hiring: 'HIRING',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    TransferDepartment: 'TRANSFER_DEPARTMENT',
} as const;

export type FetchWorkforceSlotsWithHistoryQueryServiceItemSlotTypeEnum = typeof FetchWorkforceSlotsWithHistoryQueryServiceItemSlotTypeEnum[keyof typeof FetchWorkforceSlotsWithHistoryQueryServiceItemSlotTypeEnum];

export interface FilterCondition {
    'axisId': string;
    'axisTagId': IdWithReferenceType;
    'axisTreeId': string;
}
export interface FinancialModelDetailFinancialModelView {
    'canEdit': boolean;
    'createdBy': string;
    'id': string;
    'isEditRestricted': boolean;
    'name': string;
}
export interface FinancialModelDetailView {
    'calculateInActualPeriods': boolean;
    'financialModel': FinancialModelDetailFinancialModelView;
    'rows': Array<TreeNodeViewAccountTreeWithFormulaNodeDataView>;
}
export interface FinancialModelDto {
    'id': string;
    'name': string;
}
export interface FinancialModelFormulaWithTypeView {
    'type': FinancialModelFormulaWithTypeViewTypeEnum;
    'value'?: string;
}

export const FinancialModelFormulaWithTypeViewTypeEnum = {
    Const: 'CONST',
    Accumulation: 'ACCUMULATION',
    Formula: 'FORMULA',
    Parameter: 'PARAMETER',
} as const;

export type FinancialModelFormulaWithTypeViewTypeEnum = typeof FinancialModelFormulaWithTypeViewTypeEnum[keyof typeof FinancialModelFormulaWithTypeViewTypeEnum];

export interface FinancialModelView {
    'createdAt': DateTimeData;
    'createdBy': string;
    'description'?: string;
    'id': string;
    'isEditRestricted': boolean;
    'name': string;
    'updatedAt': DateTimeData;
}
export interface FinancialSheetCommentDetailView {
    'canDelete': boolean;
    'commentText': string;
    'createAt': string;
    'financialSheetCommentId': string;
    'userFirstName': string;
    'userId': string;
    'userLastName': string;
}
export interface FinancialSheetCommentListItemConditionDto {
    'periodKey': string;
    'planMasterOrPlanningProjectId'?: PlanMasterOrPlanningProjectId;
}
export interface FinancialSheetCommentListItemDto {
    'accountId': string;
    'accountName': string;
    'commentText': string;
    'commentType': FinancialSheetCommentListItemDtoCommentTypeEnum;
    'createAt': string;
    'departmentId': string;
    'departmentName': string;
    'financialSheetCommentId': string;
    'mainCondition': FinancialSheetCommentListItemConditionDto;
    'subCondition'?: FinancialSheetCommentListItemConditionDto;
    'userFirstName': string;
    'userLastName': string;
}

export const FinancialSheetCommentListItemDtoCommentTypeEnum = {
    Amount: 'AMOUNT',
    DiffAmount: 'DIFF_AMOUNT',
    DiffRatio: 'DIFF_RATIO',
} as const;

export type FinancialSheetCommentListItemDtoCommentTypeEnum = typeof FinancialSheetCommentListItemDtoCommentTypeEnum[keyof typeof FinancialSheetCommentListItemDtoCommentTypeEnum];

export interface FinancialSheetCommentsByCellView {
    'value': Array<FinancialSheetCommentsByDepartmentView>;
}
export interface FinancialSheetCommentsByDepartmentView {
    'comments': Array<FinancialSheetCommentDetailView>;
    'departmentId': string;
    'departmentName': string;
}
export interface FinancialSimulationAccountTreeIdView {
    'nonFinancialAccountTreeId': string;
    'plAccountTreeId': string;
}
export interface FinancialSimulationCompareTargetRequestParam {
    'actualPeriod'?: FinancialSimulationPeriod;
    'compareTargetId': string;
    'planId'?: string;
    'requiredAllocatedItems': boolean;
    'yearOffset': number;
}
export interface FinancialSimulationCompareTargetView {
    'actualPeriod'?: FinancialSimulationPeriodView;
    'datasetId': FinancialSimulationCompareTargetViewDatasetIdEnum;
    'datasetLabel': string;
    'datasetType': FinancialSimulationCompareTargetViewDatasetTypeEnum;
    'period': FinancialSimulationPeriodView;
    'planMaster'?: FinancialSimulationPlanMasterView;
    'requiredAllocatedItems': boolean;
}

export const FinancialSimulationCompareTargetViewDatasetIdEnum = {
    A: 'A',
    B: 'B',
} as const;

export type FinancialSimulationCompareTargetViewDatasetIdEnum = typeof FinancialSimulationCompareTargetViewDatasetIdEnum[keyof typeof FinancialSimulationCompareTargetViewDatasetIdEnum];
export const FinancialSimulationCompareTargetViewDatasetTypeEnum = {
    Actual: 'ACTUAL',
    Forecast: 'FORECAST',
    Budget: 'BUDGET',
} as const;

export type FinancialSimulationCompareTargetViewDatasetTypeEnum = typeof FinancialSimulationCompareTargetViewDatasetTypeEnum[keyof typeof FinancialSimulationCompareTargetViewDatasetTypeEnum];

export interface FinancialSimulationConditionContentRequest {
    'accountDrillDownConditionMap': { [key: string]: AccountDrillDownConditionParam; };
    'compareTargetIds': Array<string>;
    'datasetFormulaIds': Array<string>;
    'dimensionFilterConditionMap': { [key: string]: DimensionFilterConditionParam; };
    'dimensionVisibilityConditionMap': { [key: string]: DimensionVisibilityConditionParam; };
    'directInput': boolean;
    'parameterVisibilityConditionMap': { [key: string]: ParameterVisibilityConditionParam; };
    'showNumbersIn': FinancialSimulationConditionContentRequestShowNumbersInEnum;
    'showParameterTableShowEmptyRows': boolean;
}

export const FinancialSimulationConditionContentRequestShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FinancialSimulationConditionContentRequestShowNumbersInEnum = typeof FinancialSimulationConditionContentRequestShowNumbersInEnum[keyof typeof FinancialSimulationConditionContentRequestShowNumbersInEnum];

export interface FinancialSimulationConditionView {
    'accountDrillDownConditionMap': { [key: string]: AccountDrillDownConditionParam; };
    'compareTargetIds': Array<string>;
    'datasetFormulaIds': Array<string>;
    'dimensionFilterConditionMap': { [key: string]: DimensionFilterConditionParam; };
    'dimensionVisibilityConditionMap': { [key: string]: DimensionVisibilityConditionParam; };
    'directInput': boolean;
    'parameterVisibilityConditionMap': { [key: string]: ParameterVisibilityConditionParam; };
    'showNumbersIn': FinancialSimulationConditionViewShowNumbersInEnum;
    'showParameterTableShowEmptyRows': boolean;
}

export const FinancialSimulationConditionViewShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FinancialSimulationConditionViewShowNumbersInEnum = typeof FinancialSimulationConditionViewShowNumbersInEnum[keyof typeof FinancialSimulationConditionViewShowNumbersInEnum];


export const FinancialSimulationConditionWarningType = {
    MissingAccounts: 'MISSING_ACCOUNTS',
    MissingDimensionTags: 'MISSING_DIMENSION_TAGS',
    MissingDepartments: 'MISSING_DEPARTMENTS',
    MissingDatasetFormulas: 'MISSING_DATASET_FORMULAS',
} as const;

export type FinancialSimulationConditionWarningType = typeof FinancialSimulationConditionWarningType[keyof typeof FinancialSimulationConditionWarningType];


export interface FinancialSimulationConditionWarningView {
    'invalidIds': Array<string>;
    'message': string;
    'type': FinancialSimulationConditionWarningType;
}


export interface FinancialSimulationDatasetFormulaDetailView {
    'format': FinancialSimulationDatasetFormulaFormatDto;
    'hiddenAccountIds': Array<string>;
    'id': string;
    'name': string;
    'sortOrder': number;
    'value': string;
}
/**
 * @type FinancialSimulationDatasetFormulaFormatDto
 * Financial Simulation Dataset Formula Format
 */
export type FinancialSimulationDatasetFormulaFormatDto = CustomFormatDto | SameToAccountFormatDto;

export interface FinancialSimulationDescriptionView {
    'content': string;
    'createdDate': string;
    'financialSimulationId': string;
    'lastUpdatedDate': string;
}
export interface FinancialSimulationDetailDimensionView {
    'dimensionId'?: string;
    'dimensionTreeId'?: string;
    'dimensionType': FinancialSimulationDetailDimensionViewDimensionTypeEnum;
    'name': string;
    'orgTreeId'?: string;
}

export const FinancialSimulationDetailDimensionViewDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
    Period: 'PERIOD',
} as const;

export type FinancialSimulationDetailDimensionViewDimensionTypeEnum = typeof FinancialSimulationDetailDimensionViewDimensionTypeEnum[keyof typeof FinancialSimulationDetailDimensionViewDimensionTypeEnum];

export interface FinancialSimulationDetailView {
    'accountTreeId': FinancialSimulationAccountTreeIdView;
    'canEdit': boolean;
    'compareTargets': Array<FinancialSimulationCompareTargetView>;
    'condition'?: FinancialSimulationConditionView;
    'conditionWarnings': Array<FinancialSimulationConditionWarningView>;
    'datasetFormulaIds': Array<FinancialSimulationDatasetFormulaDetailView>;
    'dimension': FinancialSimulationDetailDimensionView;
    'id': string;
    'isEditRestricted': boolean;
    'name': string;
    'parentFolderId'?: string;
    'showNumbersIn': FinancialSimulationDetailViewShowNumbersInEnum;
    'targetPlan': FinancialSimulationSimulationTargetPlanView;
}

export const FinancialSimulationDetailViewShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FinancialSimulationDetailViewShowNumbersInEnum = typeof FinancialSimulationDetailViewShowNumbersInEnum[keyof typeof FinancialSimulationDetailViewShowNumbersInEnum];

/**
 * シミュレーションの軸タイプ
 */

export const FinancialSimulationDimensionTypeRequest = {
    Department: 'DEPARTMENT',
    Dimension: 'DIMENSION',
} as const;

export type FinancialSimulationDimensionTypeRequest = typeof FinancialSimulationDimensionTypeRequest[keyof typeof FinancialSimulationDimensionTypeRequest];


export interface FinancialSimulationDto {
    'id': string;
    'name': string;
}
/**
 * 経営シミュレーションフォルダのパンくずリスト項目
 */
export interface FinancialSimulationFolderBreadcrumbView {
    /**
     * フォルダID
     */
    'folderId': string;
    /**
     * フォルダ名
     */
    'folderName': string;
}
export interface FinancialSimulationFolderForSelectionView {
    'id': string;
    'name': string;
    'parentFolderId'?: string;
}
export interface FinancialSimulationFolderListItemView {
    'canDelete': boolean;
    'canEdit': boolean;
    'createdBy'?: string;
    'id': string;
    'lastUpdatedAt': string;
    'lastUpdatedBy'?: string;
    'name': string;
    'scenarioIds': Array<string>;
}
export interface FinancialSimulationFolderTreeForSelectionView {
    'folders': Array<FinancialSimulationFolderForSelectionView>;
}
export interface FinancialSimulationListItemView {
    'createdAt': string;
    'createdUserName': string;
    'id': string;
    'name': string;
    'scenarioIds': Array<string>;
}
export interface FinancialSimulationPeriod {
    'end': string;
    'start': string;
}
export interface FinancialSimulationPeriodSumFormulaIdView {
    'id': string;
}
export interface FinancialSimulationPeriodView {
    'periodEnd': string;
    'periodStart': string;
}
export interface FinancialSimulationPlanMasterView {
    'id': string;
    'name': string;
}
export interface FinancialSimulationReferenceView {
    'id': string;
    'name': string;
}
export interface FinancialSimulationReportCellRequest {
    'amount'?: number;
    'id': string;
}
export interface FinancialSimulationReportRowIdView {
    'first': string;
    'second'?: string;
}
export interface FinancialSimulationReportRowRequest {
    'cells': Array<FinancialSimulationReportCellRequest>;
    'id': FinancialSimulationReportRowIdView;
}
export interface FinancialSimulationScenarioCellView {
    'amount'?: number;
    'amountStr': string;
    'cellId': string;
    'isEditableCell': boolean;
}
export interface FinancialSimulationScenarioParameterCellView {
    'amount'?: number;
}
export interface FinancialSimulationScenarioParameterColumnView {
    'columnId': string;
    'columnLabel': string;
    'editable': boolean;
}
export interface FinancialSimulationScenarioParameterRowView {
    'amountFormat': FinancialSimulationScenarioTableAmountFormatView;
    'cells': { [key: string]: FinancialSimulationScenarioParameterCellView; };
    'rowAccountLabel': string;
    'rowDimensionLabel': string;
    'rowId': string;
}
export interface FinancialSimulationScenarioParameterTableView {
    'columns': Array<FinancialSimulationScenarioParameterColumnView>;
    'rows': Array<FinancialSimulationScenarioParameterRowView>;
}
export interface FinancialSimulationScenarioRowGroupView {
    'canDrillDown': boolean;
    'drilledDown': boolean;
    'parentAccountName'?: string;
    'parentRowGroupId'?: string;
    'rowGroupId': string;
    'rowGroupLabel': string;
    'rows': Array<FinancialSimulationScenarioRowView>;
}
export interface FinancialSimulationScenarioRowView {
    'amountFormat': FinancialSimulationScenarioTableAmountFormatView;
    'cells': { [key: string]: FinancialSimulationScenarioCellView; };
    'isEditableTotal': boolean;
    'isSimulationTarget': boolean;
    'level': number;
    'rowGroupType': FinancialSimulationScenarioRowViewRowGroupTypeEnum;
    'rowId': string;
    'rowLabel': string;
    'sumAmount'?: number;
    'sumAmountStr': string;
}

export const FinancialSimulationScenarioRowViewRowGroupTypeEnum = {
    Dataset: 'DATASET',
    DatasetFormula: 'DATASET_FORMULA',
} as const;

export type FinancialSimulationScenarioRowViewRowGroupTypeEnum = typeof FinancialSimulationScenarioRowViewRowGroupTypeEnum[keyof typeof FinancialSimulationScenarioRowViewRowGroupTypeEnum];

export interface FinancialSimulationScenarioTableAmountFormatView {
    'roundingMode': FinancialSimulationScenarioTableAmountFormatViewRoundingModeEnum;
    'roundingPrecision': FinancialSimulationScenarioTableAmountFormatViewRoundingPrecisionEnum;
    'valueFormat': FinancialSimulationScenarioTableAmountFormatViewValueFormatEnum;
}

export const FinancialSimulationScenarioTableAmountFormatViewRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type FinancialSimulationScenarioTableAmountFormatViewRoundingModeEnum = typeof FinancialSimulationScenarioTableAmountFormatViewRoundingModeEnum[keyof typeof FinancialSimulationScenarioTableAmountFormatViewRoundingModeEnum];
export const FinancialSimulationScenarioTableAmountFormatViewRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type FinancialSimulationScenarioTableAmountFormatViewRoundingPrecisionEnum = typeof FinancialSimulationScenarioTableAmountFormatViewRoundingPrecisionEnum[keyof typeof FinancialSimulationScenarioTableAmountFormatViewRoundingPrecisionEnum];
export const FinancialSimulationScenarioTableAmountFormatViewValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type FinancialSimulationScenarioTableAmountFormatViewValueFormatEnum = typeof FinancialSimulationScenarioTableAmountFormatViewValueFormatEnum[keyof typeof FinancialSimulationScenarioTableAmountFormatViewValueFormatEnum];

export interface FinancialSimulationScenarioTableColumnView {
    'columnId': string;
    'columnLabel': string;
    'isPeriodSumFormula': boolean;
}
export interface FinancialSimulationScenarioTableMetaView {
    'columns': Array<FinancialSimulationScenarioTableColumnView>;
}
export interface FinancialSimulationScenarioTableView {
    'condition': FetchFinancialSimulationScenarioCondition;
    'meta': FinancialSimulationScenarioTableMetaView;
    'rowGroups': Array<FinancialSimulationScenarioRowGroupView>;
}
export interface FinancialSimulationSimulationTargetPlanView {
    'actualPeriod'?: FinancialSimulationPeriodView;
    'period': FinancialSimulationPeriodView;
    'planMaster': FinancialSimulationPlanMasterView;
    'requiredAllocatedItems': boolean;
}
export interface FindCalculateActionDto {
    'formula': string;
}
export interface FindProcessConditionDataDto {
    'conditionType': string;
    'conditionValue'?: string;
    'number': string;
    'rowColumnType': FindProcessConditionDataDtoRowColumnTypeEnum;
}

export const FindProcessConditionDataDtoRowColumnTypeEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
} as const;

export type FindProcessConditionDataDtoRowColumnTypeEnum = typeof FindProcessConditionDataDtoRowColumnTypeEnum[keyof typeof FindProcessConditionDataDtoRowColumnTypeEnum];

export interface FindProcessInsertSettingDto {
    'columns': Array<string>;
    'rows': Array<string>;
}
export interface FindProcessOperationDataDto {
    'calculateAction'?: FindCalculateActionDto;
    'isReused': boolean;
    'replaceAction'?: FindReplaceActionDto;
    'rowColumnType': FindProcessOperationDataDtoRowColumnTypeEnum;
    'splitAction'?: FindSplitActionDto;
    'variableName'?: string;
}

export const FindProcessOperationDataDtoRowColumnTypeEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
} as const;

export type FindProcessOperationDataDtoRowColumnTypeEnum = typeof FindProcessOperationDataDtoRowColumnTypeEnum[keyof typeof FindProcessOperationDataDtoRowColumnTypeEnum];

export interface FindProcessSettingDto {
    'insertSetting': FindProcessInsertSettingDto;
    'name': string;
    'transformSettings': Array<FindProcessTransformSettingDto>;
}
export interface FindProcessTransformDto {
    'conditions': Array<FindProcessConditionDataDto>;
    'matchingType': FindProcessTransformDtoMatchingTypeEnum;
    'operations': Array<FindProcessOperationDataDto>;
}

export const FindProcessTransformDtoMatchingTypeEnum = {
    And: 'AND',
    Or: 'OR',
} as const;

export type FindProcessTransformDtoMatchingTypeEnum = typeof FindProcessTransformDtoMatchingTypeEnum[keyof typeof FindProcessTransformDtoMatchingTypeEnum];

export interface FindProcessTransformSettingDto {
    'conditionalTransforms': Array<FindProcessTransformDto>;
    'notes'?: string;
    'number': string;
    'targetRowColumnType': FindProcessTransformSettingDtoTargetRowColumnTypeEnum;
    'unConditionalTransform'?: FindProcessUnConditionalTransformDto;
}

export const FindProcessTransformSettingDtoTargetRowColumnTypeEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
} as const;

export type FindProcessTransformSettingDtoTargetRowColumnTypeEnum = typeof FindProcessTransformSettingDtoTargetRowColumnTypeEnum[keyof typeof FindProcessTransformSettingDtoTargetRowColumnTypeEnum];

export interface FindProcessUnConditionalTransformDto {
    'operations': Array<FindProcessOperationDataDto>;
}
export interface FindReplaceActionDto {
    'format': string;
}
export interface FindSplitActionDto {
    'delimiter': string;
    'pickingNumber': number;
    'target': string;
}
export interface FixedPatternBody {
    'fixedAmount': number;
    'targetAccountId': string;
}
export interface FixedPatternView {
    'fixedAmount': number;
    'targetAccountId': string;
    'targetAccountName': string;
}
export interface FixedValue {
    'value': FixedValueValueEnum;
}

export const FixedValueValueEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type FixedValueValueEnum = typeof FixedValueValueEnum[keyof typeof FixedValueValueEnum];

export interface ForOpenApiGenerator1Request {
    'uploadExcelPlanUpdateParams': UploadExcelPlanUpdateParams;
}
export interface ForOpenApiGenerator2Request {
    'createParams': CreatePlanUpdateRequestFormatParams;
    'updateParams': UpdatePlanUpdateRequestFormatParams;
}
export interface ForOpenApiGenerator3Request {
    'updateParams': UploadNonFinancialItemsParams;
}
export interface ForOpenApiGeneratorRequest {
    'updateParams': UploadActualByMappingParams;
}
export interface GenerateReportTableDetailDownloadBody {
    'cellCondition': ReportTableCellCondition;
    'currencyCode': string;
    'dataCondition': DataCondition;
    'downloadType': GenerateReportTableDetailDownloadBodyDownloadTypeEnum;
    'isActual': boolean;
    'isAsc': boolean;
    'rowAggregationDimensions': Array<RowAggregationDimension>;
    'showNumbersIn': GenerateReportTableDetailDownloadBodyShowNumbersInEnum;
    'sortKey': GenerateReportTableDetailDownloadBodySortKeyEnum;
    'totalCount': number;
}

export const GenerateReportTableDetailDownloadBodyDownloadTypeEnum = {
    Excel: 'EXCEL',
} as const;

export type GenerateReportTableDetailDownloadBodyDownloadTypeEnum = typeof GenerateReportTableDetailDownloadBodyDownloadTypeEnum[keyof typeof GenerateReportTableDetailDownloadBodyDownloadTypeEnum];
export const GenerateReportTableDetailDownloadBodyShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type GenerateReportTableDetailDownloadBodyShowNumbersInEnum = typeof GenerateReportTableDetailDownloadBodyShowNumbersInEnum[keyof typeof GenerateReportTableDetailDownloadBodyShowNumbersInEnum];
export const GenerateReportTableDetailDownloadBodySortKeyEnum = {
    JournalDate: 'JOURNAL_DATE',
    DepartmentName: 'DEPARTMENT_NAME',
    AccountName: 'ACCOUNT_NAME',
    Description: 'DESCRIPTION',
    Amount: 'AMOUNT',
    Dimension1Name: 'DIMENSION_1_NAME',
    Dimension2Name: 'DIMENSION_2_NAME',
    Dimension3Name: 'DIMENSION_3_NAME',
    Dimension4Name: 'DIMENSION_4_NAME',
    Dimension5Name: 'DIMENSION_5_NAME',
    Dimension6Name: 'DIMENSION_6_NAME',
    Dimension7Name: 'DIMENSION_7_NAME',
} as const;

export type GenerateReportTableDetailDownloadBodySortKeyEnum = typeof GenerateReportTableDetailDownloadBodySortKeyEnum[keyof typeof GenerateReportTableDetailDownloadBodySortKeyEnum];

export interface GetBSReportTableWithBoardFilterBody {
    'boardFilterConditions'?: Array<DimensionFilter>;
    'schema': BSReportConditionSchema;
}
export interface GetCFReportTableWithBoardFilterBody {
    'boardFilterConditions'?: Array<DimensionFilter>;
    'schema': CFReportConditionSchema;
}
export interface GetComboChartDataBody {
    'boardFilterConditions'?: Array<DimensionFilter>;
}
export interface GetComparisonWaterfallInitialValuesBody {
    'reportId': string;
}
export interface GetComparisonWaterfallPeriodColumnGroupsBody {
    'endDataConditionId': GetComparisonWaterfallPeriodColumnGroupsBodyEndDataConditionIdEnum;
    'reportId': string;
    'startDataConditionId': GetComparisonWaterfallPeriodColumnGroupsBodyStartDataConditionIdEnum;
}

export const GetComparisonWaterfallPeriodColumnGroupsBodyEndDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type GetComparisonWaterfallPeriodColumnGroupsBodyEndDataConditionIdEnum = typeof GetComparisonWaterfallPeriodColumnGroupsBodyEndDataConditionIdEnum[keyof typeof GetComparisonWaterfallPeriodColumnGroupsBodyEndDataConditionIdEnum];
export const GetComparisonWaterfallPeriodColumnGroupsBodyStartDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type GetComparisonWaterfallPeriodColumnGroupsBodyStartDataConditionIdEnum = typeof GetComparisonWaterfallPeriodColumnGroupsBodyStartDataConditionIdEnum[keyof typeof GetComparisonWaterfallPeriodColumnGroupsBodyStartDataConditionIdEnum];

export interface GetCompositeReportTableValuesByReportIdsBody {
    'boardFilterConditions'?: Array<DimensionFilter>;
    'compositeTableId'?: string;
    'layout': CompositeReportLayoutRequest;
}
export interface GetCompositeReportTableValuesResponse {
    'cellCount': number;
    'flatTable'?: CompositeReportTableView;
    'reportMetadataMap': { [key: string]: CompositeReportMetadataView; };
    'showNumbersIn': GetCompositeReportTableValuesResponseShowNumbersInEnum;
    'treeTable'?: CompositeReportTreeTableView;
}

export const GetCompositeReportTableValuesResponseShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type GetCompositeReportTableValuesResponseShowNumbersInEnum = typeof GetCompositeReportTableValuesResponseShowNumbersInEnum[keyof typeof GetCompositeReportTableValuesResponseShowNumbersInEnum];

export interface GetDownloadManagementFileUrlDto {
    'url': string;
}
export interface GetGraphDataBody {
    'boardFilterConditions'?: Array<DimensionFilter>;
}
export interface GetKpiCardDataBody {
    'boardFilterConditions'?: Array<DimensionFilter>;
}
export interface GetLoglassPLValueBulkRequest {
    'params': Array<GetLoglassPLValueParam>;
}
export interface GetLoglassPLValueBulkResponseView {
    'values': Array<GetLoglassPLValueResponseView>;
}
export interface GetLoglassPLValueParam {
    'accountCode': string;
    'accountTreeName'?: string;
    'departmentCode': string;
    'endYearMonth'?: string;
    'fetchItemType': string;
    'orgTreeName'?: string;
    'sourceName'?: string;
    'startYearMonth': string;
}
export interface GetLoglassPLValueResponseView {
    'message'?: string;
    'status': string;
    'value'?: number;
}
export interface GetPeriodColumnsBody {
    'dataConditionId': GetPeriodColumnsBodyDataConditionIdEnum;
}

export const GetPeriodColumnsBodyDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type GetPeriodColumnsBodyDataConditionIdEnum = typeof GetPeriodColumnsBodyDataConditionIdEnum[keyof typeof GetPeriodColumnsBodyDataConditionIdEnum];

export interface GetPieChartDataBody {
    'boardFilterConditions'?: Array<DimensionFilter>;
}
export interface GetPlanSheetTableView {
    'appliedCondition': SheetConditionSchema;
    'displayMessages': Array<PlanSheetDisplayMessageView>;
    'invalidConditions': Array<PlanSheetInvalidConditionView>;
    'isReportDataSourceUpdating': boolean;
    'omitRowsCount': number;
    'planSheetTable'?: PlanSheetTableView;
}
export interface GetReportCellLabelRequestBody {
    'cellKey': ReportCellKey;
    'condition': PLReportConditionSchema;
    'reportId': string;
}
export interface GetReportCellLabelView {
    'cellLabel': ReportCommentCellLabelView;
    'tooltip': ReportCommentTooltipView;
}
export interface GetReportTableDetailBody {
    'cellCondition': ReportTableCellCondition;
    'currencyCode': string;
    'dataCondition': DataCondition;
    'isAsc': boolean;
    'limit': number;
    'offset': number;
    'rowAggregationDimensions': Array<RowAggregationDimension>;
    'showNumbersIn': GetReportTableDetailBodyShowNumbersInEnum;
    'sortKey': GetReportTableDetailBodySortKeyEnum;
}

export const GetReportTableDetailBodyShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type GetReportTableDetailBodyShowNumbersInEnum = typeof GetReportTableDetailBodyShowNumbersInEnum[keyof typeof GetReportTableDetailBodyShowNumbersInEnum];
export const GetReportTableDetailBodySortKeyEnum = {
    JournalDate: 'JOURNAL_DATE',
    DepartmentName: 'DEPARTMENT_NAME',
    AccountName: 'ACCOUNT_NAME',
    Description: 'DESCRIPTION',
    Amount: 'AMOUNT',
    Dimension1Name: 'DIMENSION_1_NAME',
    Dimension2Name: 'DIMENSION_2_NAME',
    Dimension3Name: 'DIMENSION_3_NAME',
    Dimension4Name: 'DIMENSION_4_NAME',
    Dimension5Name: 'DIMENSION_5_NAME',
    Dimension6Name: 'DIMENSION_6_NAME',
    Dimension7Name: 'DIMENSION_7_NAME',
} as const;

export type GetReportTableDetailBodySortKeyEnum = typeof GetReportTableDetailBodySortKeyEnum[keyof typeof GetReportTableDetailBodySortKeyEnum];

export interface GetReportTableDetailView {
    'header': ReportTableDetailHeaderView;
    'paging': PagingDto;
    'rows': Array<ReportTableDetailRowView>;
    'title': string;
}
export interface GetReportTableView {
    'appliedCondition': GetReportTableViewAppliedCondition;
    'cellCount': number;
    'displayMessages': Array<DisplayMessageView>;
    'invalidConditions': Array<InvalidConditionView>;
    'isReportDataSourceUpdating': boolean;
    'omitRowsCount': number;
    'reportFlatTable'?: ReportTableView;
    'reportTreeTable'?: ReportTreeTableView;
}
/**
 * @type GetReportTableViewAppliedCondition
 */
export type GetReportTableViewAppliedCondition = BSReportConditionSchema | CFReportConditionSchema | PLReportConditionSchema;

export interface GetReportTableWithBoardFilterBody {
    'boardFilterConditions'?: Array<DimensionFilter>;
    'schema': PLReportConditionSchema;
}
export interface GetUnconnectedSlotTypesReturn {
    'workforceSlotTypes': Array<GetUnconnectedSlotTypesReturnWorkforceSlotTypesEnum>;
}

export const GetUnconnectedSlotTypesReturnWorkforceSlotTypesEnum = {
    Hiring: 'HIRING',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    TransferDepartment: 'TRANSFER_DEPARTMENT',
} as const;

export type GetUnconnectedSlotTypesReturnWorkforceSlotTypesEnum = typeof GetUnconnectedSlotTypesReturnWorkforceSlotTypesEnum[keyof typeof GetUnconnectedSlotTypesReturnWorkforceSlotTypesEnum];

export interface GetWaterfallDataBody {
    'boardFilterConditions'?: Array<DimensionFilter>;
}
export interface GraphDataView {
    'amountAxisUnitLabel': string;
    'categoryAxisLabels': Array<string>;
    'cellCount': number;
    'isPercentStacking': boolean;
    'reportMetadata'?: GraphReportMetadata;
    'series': Array<SeriesData>;
    'seriesStackTotals': Array<SeriesStackTotal>;
}
export interface GraphDefaultVisibleIds {
    'row1Id'?: string;
    'row2Id'?: string;
    'rowDefaultIds': Array<string>;
}
export interface GraphDisplaySettings {
    'seriesLabelOverrides': Array<SeriesLabelOverride>;
}
export interface GraphDisplaySettingsRequestBody {
    'seriesLabelOverrides': Array<SeriesLabelOverride>;
}
export interface GraphReportMetadata {
    'currencyCode': string;
    'dataConditions': Array<DataCondition>;
    'reportId': string;
    'roundingMode': GraphReportMetadataRoundingModeEnum;
    'rowAggregationDimensions': Array<RowAggregationDimension>;
    'showNumbersIn': GraphReportMetadataShowNumbersInEnum;
}

export const GraphReportMetadataRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type GraphReportMetadataRoundingModeEnum = typeof GraphReportMetadataRoundingModeEnum[keyof typeof GraphReportMetadataRoundingModeEnum];
export const GraphReportMetadataShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type GraphReportMetadataShowNumbersInEnum = typeof GraphReportMetadataShowNumbersInEnum[keyof typeof GraphReportMetadataShowNumbersInEnum];

export interface GraphUniqueKeyMeta {
    'canShowDetail': boolean;
    'columnType': GraphUniqueKeyMetaColumnTypeEnum;
    'dataConditionId': string;
    'isCumulative': boolean;
}

export const GraphUniqueKeyMetaColumnTypeEnum = {
    ActualBudget: 'ACTUAL_BUDGET',
    ActualForecast: 'ACTUAL_FORECAST',
    ActualBudgetMixed: 'ACTUAL_BUDGET_MIXED',
    ActualForecastMixed: 'ACTUAL_FORECAST_MIXED',
    ActualNull: 'ACTUAL_NULL',
    NullNull: 'NULL_NULL',
    NullBudget: 'NULL_BUDGET',
    NullForecast: 'NULL_FORECAST',
} as const;

export type GraphUniqueKeyMetaColumnTypeEnum = typeof GraphUniqueKeyMetaColumnTypeEnum[keyof typeof GraphUniqueKeyMetaColumnTypeEnum];

export interface GraphUniqueKeyView {
    'cellCondition': ReportTableCellCondition;
    'meta': GraphUniqueKeyMeta;
}
export interface HeaderCellGroupView {
    'cells': Array<HeaderCellGroupViewCellsInner>;
}
/**
 * @type HeaderCellGroupViewCellsInner
 */
export type HeaderCellGroupViewCellsInner = HeaderComparisonFormulaCellView | HeaderDataCellView;

export interface HeaderCellView {
    'id': string;
    'label': string;
    'orderKey': CellGroupOrderKeyImpl;
    'type': ReportCellType;
}


export interface HeaderComparisonFormulaCellView {
    'id': string;
    'label': string;
    'orderKey': CellGroupOrderKeyImpl;
    'type': ReportCellType;
    'description': string;
}


export interface HeaderDataCellView {
    'id': string;
    'label': string;
    'orderKey': CellGroupOrderKeyImpl;
    'type': ReportCellType;
    'actualPlanLabel': string;
    'dataConditionId': HeaderDataCellViewDataConditionIdEnum;
}

export const HeaderDataCellViewDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type HeaderDataCellViewDataConditionIdEnum = typeof HeaderDataCellViewDataConditionIdEnum[keyof typeof HeaderDataCellViewDataConditionIdEnum];

export interface HeaderSumCellGroupView {
    'cells': Array<HeaderCellGroupViewCellsInner>;
}

export const HttpStatus = {
    _100Continue: '100 CONTINUE',
    _101SwitchingProtocols: '101 SWITCHING_PROTOCOLS',
    _102Processing: '102 PROCESSING',
    _103EarlyHints: '103 EARLY_HINTS',
    _200Ok: '200 OK',
    _201Created: '201 CREATED',
    _202Accepted: '202 ACCEPTED',
    _203NonAuthoritativeInformation: '203 NON_AUTHORITATIVE_INFORMATION',
    _204NoContent: '204 NO_CONTENT',
    _205ResetContent: '205 RESET_CONTENT',
    _206PartialContent: '206 PARTIAL_CONTENT',
    _207MultiStatus: '207 MULTI_STATUS',
    _208AlreadyReported: '208 ALREADY_REPORTED',
    _226ImUsed: '226 IM_USED',
    _300MultipleChoices: '300 MULTIPLE_CHOICES',
    _301MovedPermanently: '301 MOVED_PERMANENTLY',
    _302Found: '302 FOUND',
    _303SeeOther: '303 SEE_OTHER',
    _304NotModified: '304 NOT_MODIFIED',
    _307TemporaryRedirect: '307 TEMPORARY_REDIRECT',
    _308PermanentRedirect: '308 PERMANENT_REDIRECT',
    _400BadRequest: '400 BAD_REQUEST',
    _401Unauthorized: '401 UNAUTHORIZED',
    _402PaymentRequired: '402 PAYMENT_REQUIRED',
    _403Forbidden: '403 FORBIDDEN',
    _404NotFound: '404 NOT_FOUND',
    _405MethodNotAllowed: '405 METHOD_NOT_ALLOWED',
    _406NotAcceptable: '406 NOT_ACCEPTABLE',
    _407ProxyAuthenticationRequired: '407 PROXY_AUTHENTICATION_REQUIRED',
    _408RequestTimeout: '408 REQUEST_TIMEOUT',
    _409Conflict: '409 CONFLICT',
    _410Gone: '410 GONE',
    _411LengthRequired: '411 LENGTH_REQUIRED',
    _412PreconditionFailed: '412 PRECONDITION_FAILED',
    _413ContentTooLarge: '413 CONTENT_TOO_LARGE',
    _413PayloadTooLarge: '413 PAYLOAD_TOO_LARGE',
    _414UriTooLong: '414 URI_TOO_LONG',
    _415UnsupportedMediaType: '415 UNSUPPORTED_MEDIA_TYPE',
    _416RequestedRangeNotSatisfiable: '416 REQUESTED_RANGE_NOT_SATISFIABLE',
    _417ExpectationFailed: '417 EXPECTATION_FAILED',
    _418IAmATeapot: '418 I_AM_A_TEAPOT',
    _421MisdirectedRequest: '421 MISDIRECTED_REQUEST',
    _422UnprocessableContent: '422 UNPROCESSABLE_CONTENT',
    _422UnprocessableEntity: '422 UNPROCESSABLE_ENTITY',
    _423Locked: '423 LOCKED',
    _424FailedDependency: '424 FAILED_DEPENDENCY',
    _425TooEarly: '425 TOO_EARLY',
    _426UpgradeRequired: '426 UPGRADE_REQUIRED',
    _428PreconditionRequired: '428 PRECONDITION_REQUIRED',
    _429TooManyRequests: '429 TOO_MANY_REQUESTS',
    _431RequestHeaderFieldsTooLarge: '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
    _451UnavailableForLegalReasons: '451 UNAVAILABLE_FOR_LEGAL_REASONS',
    _500InternalServerError: '500 INTERNAL_SERVER_ERROR',
    _501NotImplemented: '501 NOT_IMPLEMENTED',
    _502BadGateway: '502 BAD_GATEWAY',
    _503ServiceUnavailable: '503 SERVICE_UNAVAILABLE',
    _504GatewayTimeout: '504 GATEWAY_TIMEOUT',
    _505HttpVersionNotSupported: '505 HTTP_VERSION_NOT_SUPPORTED',
    _506VariantAlsoNegotiates: '506 VARIANT_ALSO_NEGOTIATES',
    _507InsufficientStorage: '507 INSUFFICIENT_STORAGE',
    _508LoopDetected: '508 LOOP_DETECTED',
    _509BandwidthLimitExceeded: '509 BANDWIDTH_LIMIT_EXCEEDED',
    _510NotExtended: '510 NOT_EXTENDED',
    _511NetworkAuthenticationRequired: '511 NETWORK_AUTHENTICATION_REQUIRED',
} as const;

export type HttpStatus = typeof HttpStatus[keyof typeof HttpStatus];


export interface HttpStatusCode {
    'error'?: boolean;
    'is1xxInformational'?: boolean;
    'is2xxSuccessful'?: boolean;
    'is3xxRedirection'?: boolean;
    'is4xxClientError'?: boolean;
    'is5xxServerError'?: boolean;
}
export interface IDAccount {
    'value': string;
}
export interface IDActualImportEvent {
    'value': string;
}
export interface IDActualImportMapping {
    'value': string;
}
export interface IDDepartment {
    'value': string;
}
export interface IDImpl {
    'value': string;
}
export interface IDPlanUpdateRequestFile {
    'value': string;
}
export interface IDPlanUpdateRequestFormat {
    'value': string;
}
export interface IDPlanUpdateRequestMappingFilter {
    'value': string;
}
export interface IDPlanUpdateRequestMappingShowNumbersInKey {
    'value': string;
}
export interface IDPlanningProject {
    'value': string;
}
export interface IDProcessSetting {
    'value': string;
}
export interface IDReport {
    'value': string;
}
export interface IDUser {
    'value': string;
}
export interface IDViewPermission {
    'value': string;
}
export interface IdWithName {
    'id': string;
    'name': string;
}
export interface IdWithReferenceType {
    'id': string;
    'referenceType': IdWithReferenceTypeReferenceTypeEnum;
}

export const IdWithReferenceTypeReferenceTypeEnum = {
    Sum: 'SUM',
    Own: 'OWN',
} as const;

export type IdWithReferenceTypeReferenceTypeEnum = typeof IdWithReferenceTypeReferenceTypeEnum[keyof typeof IdWithReferenceTypeReferenceTypeEnum];

export interface InconsistentAllocationExecution {
    'patternId': string;
    'yearMonth': string;
}
export interface InconsistentAllocationExecutionCheckResponse {
    'inconsistentExecutions': Array<InconsistentAllocationExecution>;
}
export interface IncreaseRateForEachMonthView {
    'month': number;
    'ratePercent': string;
}
export interface InvalidConditionView {
    'dimensionLabel': string;
    'idWithNames': Array<IdWithName>;
    'treeLabel'?: string;
    'type': InvalidConditionViewTypeEnum;
}

export const InvalidConditionViewTypeEnum = {
    NotIncludedInTree: 'NOT_INCLUDED_IN_TREE',
    Deleted: 'DELETED',
} as const;

export type InvalidConditionViewTypeEnum = typeof InvalidConditionViewTypeEnum[keyof typeof InvalidConditionViewTypeEnum];

export interface IpRestrictionDryRunRequest {
    'allowedIpAddresses': Array<string>;
}
export interface IpRestrictionSettingView {
    'ipAddresses': Array<string>;
}
export interface JournalDescriptionView {
    'accountName': string;
    'amount': string;
    'departmentName': string;
    'description': string;
    'descriptionWithTags': string;
    'id': string;
    'journalDate': string;
    'subAccountName'?: string;
    'supplierName'?: string;
    'tags': Array<TagView>;
}
export interface JournalDescriptionsView {
    'count': number;
    'limit': number;
    'offset': number;
    'roundingMode': JournalDescriptionsViewRoundingModeEnum;
    'showDecimalPlacesIn': JournalDescriptionsViewShowDecimalPlacesInEnum;
    'showNumbersIn': JournalDescriptionsViewShowNumbersInEnum;
    'values': Array<JournalDescriptionView>;
}

export const JournalDescriptionsViewRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type JournalDescriptionsViewRoundingModeEnum = typeof JournalDescriptionsViewRoundingModeEnum[keyof typeof JournalDescriptionsViewRoundingModeEnum];
export const JournalDescriptionsViewShowDecimalPlacesInEnum = {
    None: 'NONE',
    One: 'ONE',
    Two: 'TWO',
    Three: 'THREE',
    Four: 'FOUR',
} as const;

export type JournalDescriptionsViewShowDecimalPlacesInEnum = typeof JournalDescriptionsViewShowDecimalPlacesInEnum[keyof typeof JournalDescriptionsViewShowDecimalPlacesInEnum];
export const JournalDescriptionsViewShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type JournalDescriptionsViewShowNumbersInEnum = typeof JournalDescriptionsViewShowNumbersInEnum[keyof typeof JournalDescriptionsViewShowNumbersInEnum];

export interface KpiCardColumnSelector {
    'columnKey': string;
}
export interface KpiCardConfig {
    'columnSelector'?: KpiCardColumnSelector;
    'comparisonMetrics': Array<ComparisonCondition>;
    'displayData': KpiCardConfigDisplayDataEnum;
    'rowSelector'?: KpiCardRowSelector;
    'showCumulativeRow': boolean;
}

export const KpiCardConfigDisplayDataEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type KpiCardConfigDisplayDataEnum = typeof KpiCardConfigDisplayDataEnum[keyof typeof KpiCardConfigDisplayDataEnum];

export interface KpiCardRowSelector {
    'selections': { [key: string]: string; };
}
export interface KpiDeltaLabelOverride {
    'calculationFormula': KpiDeltaLabelOverrideCalculationFormulaEnum;
    'comparisonType': KpiDeltaLabelOverrideComparisonTypeEnum;
    'customLabel'?: string;
}

export const KpiDeltaLabelOverrideCalculationFormulaEnum = {
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type KpiDeltaLabelOverrideCalculationFormulaEnum = typeof KpiDeltaLabelOverrideCalculationFormulaEnum[keyof typeof KpiDeltaLabelOverrideCalculationFormulaEnum];
export const KpiDeltaLabelOverrideComparisonTypeEnum = {
    Diff: 'DIFF',
    DiffRatio: 'DIFF_RATIO',
    AchievementRatio: 'ACHIEVEMENT_RATIO',
    SpecificAccountRatio: 'SPECIFIC_ACCOUNT_RATIO',
} as const;

export type KpiDeltaLabelOverrideComparisonTypeEnum = typeof KpiDeltaLabelOverrideComparisonTypeEnum[keyof typeof KpiDeltaLabelOverrideComparisonTypeEnum];

export interface KpiDisplaySettings {
    'deltaLabelOverrides': Array<KpiDeltaLabelOverride>;
}
export interface KpiDisplaySettingsRequestBody {
    'deltaLabelOverrides': Array<KpiDeltaLabelOverride>;
}
export interface LastAllocationResultDto {
    'allocationStatus': LastAllocationResultDtoAllocationStatusEnum;
    'allocationTargetType': LastAllocationResultDtoAllocationTargetTypeEnum;
    'hasSkippedSteps': boolean;
    'lastExecutedAt'?: string;
    'lastExecutionFinishedAt'?: string;
    'planId'?: string;
    'resultMessage'?: string;
    'ruleId': string;
    'ruleName': string;
    'yearMonth': string;
}

export const LastAllocationResultDtoAllocationStatusEnum = {
    NoExecutionHistory: 'NO_EXECUTION_HISTORY',
    ErrorSetting: 'ERROR_SETTING',
    SuccessfulCompletion: 'SUCCESSFUL_COMPLETION',
    ErrorTermination: 'ERROR_TERMINATION',
    InProgress: 'IN_PROGRESS',
} as const;

export type LastAllocationResultDtoAllocationStatusEnum = typeof LastAllocationResultDtoAllocationStatusEnum[keyof typeof LastAllocationResultDtoAllocationStatusEnum];
export const LastAllocationResultDtoAllocationTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type LastAllocationResultDtoAllocationTargetTypeEnum = typeof LastAllocationResultDtoAllocationTargetTypeEnum[keyof typeof LastAllocationResultDtoAllocationTargetTypeEnum];

export interface LatestPlanningProjectNodeMetaView {
    'accountTreeId': string;
    'actualDownloadPeriodEnd'?: string;
    'actualDownloadPeriodStart'?: string;
    'actualEndWhenPlanningProject'?: string;
    'assignedDepartments': Array<DepartmentView>;
    'canActualDownload': boolean;
    'organizationTreeId': string;
    'overview': PlanningProjectOverView;
    'planMasterId': string;
    'planMasterName': string;
    'planType': LatestPlanningProjectNodeMetaViewPlanTypeEnum;
    'planningProjectEndAt'?: string;
    'planningProjectId': string;
    'planningProjectName': string;
    'planningProjectStartAt': string;
    'planningTargetEnd': string;
    'planningTargetStart': string;
    'requirePlanMasterAllocatedItems': boolean;
    'roundingMode': LatestPlanningProjectNodeMetaViewRoundingModeEnum;
    'scheduledPlanningProjectEndAt': string;
    'status': LatestPlanningProjectNodeMetaViewStatusEnum;
    'useMultiStepApprovalFlow': boolean;
}

export const LatestPlanningProjectNodeMetaViewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type LatestPlanningProjectNodeMetaViewPlanTypeEnum = typeof LatestPlanningProjectNodeMetaViewPlanTypeEnum[keyof typeof LatestPlanningProjectNodeMetaViewPlanTypeEnum];
export const LatestPlanningProjectNodeMetaViewRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type LatestPlanningProjectNodeMetaViewRoundingModeEnum = typeof LatestPlanningProjectNodeMetaViewRoundingModeEnum[keyof typeof LatestPlanningProjectNodeMetaViewRoundingModeEnum];
export const LatestPlanningProjectNodeMetaViewStatusEnum = {
    Creating: 'CREATING',
    CreateError: 'CREATE_ERROR',
    Wip: 'WIP',
    BulkApproving: 'BULK_APPROVING',
    Fixing: 'FIXING',
    Error: 'ERROR',
    Fixed: 'FIXED',
} as const;

export type LatestPlanningProjectNodeMetaViewStatusEnum = typeof LatestPlanningProjectNodeMetaViewStatusEnum[keyof typeof LatestPlanningProjectNodeMetaViewStatusEnum];

export interface LayoutPosition {
    'h': number;
    'w': number;
    'x': number;
    'y': number;
}
export interface LinkedGSheetsView {
    'items': Array<LinkedGoogleSheetView>;
    'tenantId': string;
}
export interface LinkedGoogleSheetView {
    'departmentId': string;
    'sheetId': string;
    'sheetName': string;
}
export interface ListAllReportCommentsView {
    'comments': Array<AllReportCommentView>;
    'total': number;
}
export interface ListAmountTypeCommentRequestBody {
    'accountId': MaybeOwnValueAccountId;
    'accountTreeId': string;
    'departmentIds'?: Array<string>;
    'orgTreeId'?: string;
    'periodKeyValue': string;
    'planMasterId'?: string;
    'planningProjectId'?: string;
    'requireAllocatedItem': boolean;
}
export interface ListCommentsActualStartEndParam {
    'end': string;
    'start': string;
}
export interface ListCommentsRequestABParam {
    'actualStartEnd'?: ListCommentsActualStartEndParam;
    'planEnd': string;
    'planMasterId'?: string;
    'planShowActual': boolean;
    'planStart': string;
    'planningProjectId'?: string;
}
export interface ListCommentsRequestBody {
    'accountTreeId': string;
    'departmentIds'?: Array<string>;
    'orgTreeId'?: string;
    'paramA': ListCommentsRequestABParam;
    'paramB': ListCommentsRequestABParam;
    'requireAllocatedItems': boolean;
}
export interface ListDiffTypeCommentRequestBody {
    'accountId': MaybeOwnValueAccountId;
    'accountTreeId': string;
    'departmentIds'?: Array<string>;
    'isRatio': boolean;
    'orgTreeId'?: string;
    'planAPeriodKeyValue': string;
    'planAPlanMasterId'?: string;
    'planAPlanningProjectId'?: string;
    'planBPeriodKeyValue': string;
    'planBPlanMasterId'?: string;
    'planBPlanningProjectId'?: string;
    'requireAllocatedItem': boolean;
}
export interface ListPlannedWorkforceSlotsRequestBody {
    'departmentIds': Array<string>;
    'planMasterId': string;
}
export interface ListReportBriefsRequestBody {
    'reportIds': Array<string>;
}
export interface ListReportBriefsReturn {
    'items': Array<ReportBriefView>;
}
export interface ListReportCommentVisibilitySelectableUsersView {
    'users': Array<ReportCommentVisibilitySelectableUserView>;
}
export interface ListReportCommentsRequestBody {
    'allowedFilter'?: ListReportCommentsRequestBodyAllowedFilterEnum;
    'appliedCondition': PLReportConditionSchema;
    'reportId': string;
}

export const ListReportCommentsRequestBodyAllowedFilterEnum = {
    All: 'ALL',
    Restricted: 'RESTRICTED',
} as const;

export type ListReportCommentsRequestBodyAllowedFilterEnum = typeof ListReportCommentsRequestBodyAllowedFilterEnum[keyof typeof ListReportCommentsRequestBodyAllowedFilterEnum];

export interface ListReportCommentsView {
    'comments': Array<ReportCommentView>;
}
export interface ListRulesRequest {
    'limit': number;
    'offset': number;
}
export interface ListSimulatingWorkforceConcurrentPostHistoriesBody {
    'condition': ListSimulatingWorkforceConcurrentPostHistoryCondition;
    'yearMonth': string;
}
export interface ListSimulatingWorkforceConcurrentPostHistoryCondition {
    'eventFilter': Array<ListSimulatingWorkforceConcurrentPostHistoryConditionEventFilterEnum>;
    'globalFilter': SimulationFilterCondition;
    'sortKey': ListSimulatingWorkforceConcurrentPostHistoryConditionSortKeyEnum;
    'sortOrder': ListSimulatingWorkforceConcurrentPostHistoryConditionSortOrderEnum;
}

export const ListSimulatingWorkforceConcurrentPostHistoryConditionEventFilterEnum = {
    Start: 'START',
    Release: 'RELEASE',
} as const;

export type ListSimulatingWorkforceConcurrentPostHistoryConditionEventFilterEnum = typeof ListSimulatingWorkforceConcurrentPostHistoryConditionEventFilterEnum[keyof typeof ListSimulatingWorkforceConcurrentPostHistoryConditionEventFilterEnum];
export const ListSimulatingWorkforceConcurrentPostHistoryConditionSortKeyEnum = {
    Name: 'NAME',
    Code: 'CODE',
    StartDate: 'START_DATE',
    EndDate: 'END_DATE',
} as const;

export type ListSimulatingWorkforceConcurrentPostHistoryConditionSortKeyEnum = typeof ListSimulatingWorkforceConcurrentPostHistoryConditionSortKeyEnum[keyof typeof ListSimulatingWorkforceConcurrentPostHistoryConditionSortKeyEnum];
export const ListSimulatingWorkforceConcurrentPostHistoryConditionSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;

export type ListSimulatingWorkforceConcurrentPostHistoryConditionSortOrderEnum = typeof ListSimulatingWorkforceConcurrentPostHistoryConditionSortOrderEnum[keyof typeof ListSimulatingWorkforceConcurrentPostHistoryConditionSortOrderEnum];

export interface ListSimulatingWorkforceConcurrentPostHistoryUseCaseReturn {
    'dimensionColumns': Array<SimulatingWorkforceHistoryDimensionColumnView>;
    'items': Array<SimulatingWorkforceConcurrentPostHistoryListItem>;
}
export interface ListSimulatingWorkforceHistoriesBody {
    'condition': ListSimulatingWorkforceHistoryCondition;
    'yearMonth': string;
}
export interface ListSimulatingWorkforceHistoryCondition {
    'eventFilter': Array<ListSimulatingWorkforceHistoryConditionEventFilterEnum>;
    'globalFilter': SimulationFilterCondition;
    'sortKey': ListSimulatingWorkforceHistoryConditionSortKeyEnum;
    'sortOrder': ListSimulatingWorkforceHistoryConditionSortOrderEnum;
}

export const ListSimulatingWorkforceHistoryConditionEventFilterEnum = {
    DepartmentChanged: 'DEPARTMENT_CHANGED',
    DimensionTagChanged: 'DIMENSION_TAG_CHANGED',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    End: 'END',
} as const;

export type ListSimulatingWorkforceHistoryConditionEventFilterEnum = typeof ListSimulatingWorkforceHistoryConditionEventFilterEnum[keyof typeof ListSimulatingWorkforceHistoryConditionEventFilterEnum];
export const ListSimulatingWorkforceHistoryConditionSortKeyEnum = {
    Name: 'NAME',
    Code: 'CODE',
    EmploymentStatus: 'EMPLOYMENT_STATUS',
    StartDate: 'START_DATE',
    EndDate: 'END_DATE',
    DepartmentCode: 'DEPARTMENT_CODE',
    Dimension1Code: 'DIMENSION_1_CODE',
    Dimension2Code: 'DIMENSION_2_CODE',
    Dimension3Code: 'DIMENSION_3_CODE',
    Dimension4Code: 'DIMENSION_4_CODE',
    Dimension5Code: 'DIMENSION_5_CODE',
    Dimension6Code: 'DIMENSION_6_CODE',
    Dimension7Code: 'DIMENSION_7_CODE',
} as const;

export type ListSimulatingWorkforceHistoryConditionSortKeyEnum = typeof ListSimulatingWorkforceHistoryConditionSortKeyEnum[keyof typeof ListSimulatingWorkforceHistoryConditionSortKeyEnum];
export const ListSimulatingWorkforceHistoryConditionSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;

export type ListSimulatingWorkforceHistoryConditionSortOrderEnum = typeof ListSimulatingWorkforceHistoryConditionSortOrderEnum[keyof typeof ListSimulatingWorkforceHistoryConditionSortOrderEnum];

export interface ListSimulatingWorkforceHistoryItem {
    'code': string;
    'departmentName': string;
    'dimensionTags': Array<SimulatingWorkforceHistoryDimensionView>;
    'employmentStatus': ListSimulatingWorkforceHistoryItemEmploymentStatusEnum;
    'endDate'?: string;
    'events': Array<ListSimulatingWorkforceHistoryItemEventsEnum>;
    'id': string;
    'leaveOfAbsencePeriods': Array<SimulatingWorkforceLeavePeriodItem>;
    'name': string;
    'startDate': string;
}

export const ListSimulatingWorkforceHistoryItemEmploymentStatusEnum = {
    Active: 'ACTIVE',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    Resigned: 'RESIGNED',
} as const;

export type ListSimulatingWorkforceHistoryItemEmploymentStatusEnum = typeof ListSimulatingWorkforceHistoryItemEmploymentStatusEnum[keyof typeof ListSimulatingWorkforceHistoryItemEmploymentStatusEnum];
export const ListSimulatingWorkforceHistoryItemEventsEnum = {
    DepartmentChanged: 'DEPARTMENT_CHANGED',
    DimensionTagChanged: 'DIMENSION_TAG_CHANGED',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    End: 'END',
} as const;

export type ListSimulatingWorkforceHistoryItemEventsEnum = typeof ListSimulatingWorkforceHistoryItemEventsEnum[keyof typeof ListSimulatingWorkforceHistoryItemEventsEnum];

export interface ListSimulatingWorkforceHistoryUseCaseReturn {
    'dimensionColumns': Array<SimulatingWorkforceHistoryDimensionColumnView>;
    'items': Array<ListSimulatingWorkforceHistoryItem>;
}
export interface ListSimulatingWorkforceSlotsBody {
    'filterCondition': SimulationFilterCondition;
    'sortCondition': SimulatingSlotSortCondition;
}
export interface ListSimulationView {
    'items': Array<SimulationListItem>;
}
export interface ListUnassignedActiveUserDto {
    'firstName': string;
    'id': string;
    'lastName': string;
    'role': ListUnassignedActiveUserDtoRoleEnum;
}

export const ListUnassignedActiveUserDtoRoleEnum = {
    LoglassSystemAdmin: 'LOGLASS_SYSTEM_ADMIN',
    TenantAdmin: 'TENANT_ADMIN',
    CorpPlanning: 'CORP_PLANNING',
    Manager: 'MANAGER',
    ItStaff: 'IT_STAFF',
    General: 'GENERAL',
} as const;

export type ListUnassignedActiveUserDtoRoleEnum = typeof ListUnassignedActiveUserDtoRoleEnum[keyof typeof ListUnassignedActiveUserDtoRoleEnum];

export interface ListUnconnectedWorkforceActualEventReturn {
    'items': Array<UnconnectedWorkforceActualEventDto>;
}
export interface ListUnitAmountItemsResponse {
    'items': Array<UnitAmountItemView>;
}
export interface ListWorkforcePlanningProjectsView {
    'items': Array<WorkforcePlanningProjectListItem>;
}
export interface ListWorkforceSlotsRequestBody {
    'departmentIds': Array<string>;
    'planMasterId'?: string;
}
export interface ListWorkforceSlotsReturn {
    'items': Array<FetchWorkforceSlotsWithHistoryQueryServiceItem>;
}
export interface ListWorkforceSlotsV2Return {
    'items': Array<FetchWorkforceSlotsWithHistoryQueryServiceItem>;
}
export interface LocalCurrencyData {
    'conversionFactor': number;
    'currency': CurrencyMaster;
    'currencyLocalId': string;
    'departmentIds': Array<string>;
    'displayDecimal': number;
    'name': string;
}
export interface LocalCurrencyRequestParam {
    'conversionFactor': number;
    'currencyCode': string;
    'departmentIds'?: Array<string>;
    'displayDecimal': number;
    'name': string;
}
export interface LoglassYearMonth {
    'value': string;
}
export interface LoglassYearMonthData {
    'value': string;
}
export interface LoopCondition {
    'axisId': string;
    'axisTagIds': Array<IdWithReferenceType>;
    'axisTreeId': string;
}
export interface MappedDimensionForUnitPriceMasterItemView {
    'dimensionId'?: string;
    'dimensionName'?: string;
}
export interface MappingSheetIndex {
    'mappingId': string;
    'sheetIndexes': Array<number>;
}
export interface MatchCondition {
    'conditionValue'?: string;
}
export interface MatchedAccountKeywordView {
    'code'?: string;
    'exAccountCode'?: string;
    'name'?: string;
}
export interface MatchedCFAccountKeywordView {
    'code'?: string;
    'name'?: string;
}
export interface MatchedDimensionTagKeywordView {
    'code'?: string;
    'description'?: string;
    'exCodes'?: Array<string>;
    'name'?: string;
}
export interface MatchedPLAccountKeywordView {
    'code'?: string;
    'exAccountCode'?: string;
    'name'?: string;
}
export interface MaybeOwnValueAccountCode {
    'value': string;
}
export interface MaybeOwnValueAccountId {
    'value': string;
}
export interface MaybeOwnValueDepartmentCode {
    'value': string;
}
export interface MaybeOwnValueDepartmentId {
    'value': string;
}
export interface Meta {
    'canShowDetail': boolean;
    'columnType': MetaColumnTypeEnum;
    'dataConditionId': string;
    'hasAllocatedItem': boolean;
    'isCumulative': boolean;
    'roundingMode': MetaRoundingModeEnum;
    'showNumbersIn': MetaShowNumbersInEnum;
}

export const MetaColumnTypeEnum = {
    ActualBudget: 'ACTUAL_BUDGET',
    ActualForecast: 'ACTUAL_FORECAST',
    ActualBudgetMixed: 'ACTUAL_BUDGET_MIXED',
    ActualForecastMixed: 'ACTUAL_FORECAST_MIXED',
    ActualNull: 'ACTUAL_NULL',
    NullNull: 'NULL_NULL',
    NullBudget: 'NULL_BUDGET',
    NullForecast: 'NULL_FORECAST',
} as const;

export type MetaColumnTypeEnum = typeof MetaColumnTypeEnum[keyof typeof MetaColumnTypeEnum];
export const MetaRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type MetaRoundingModeEnum = typeof MetaRoundingModeEnum[keyof typeof MetaRoundingModeEnum];
export const MetaShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type MetaShowNumbersInEnum = typeof MetaShowNumbersInEnum[keyof typeof MetaShowNumbersInEnum];

export interface MetaView {
    'headerCellGroups': Array<HeaderCellGroupView>;
    'headerSumCellGroup'?: HeaderSumCellGroupView;
    'rowAggregationKeyMetas': Array<RowAggregationKeyMetaView>;
}
export interface Metric {
    'amount': string;
    'scaleLabel'?: string;
    'unit': MetricUnitEnum;
}

export const MetricUnitEnum = {
    Yen: 'YEN',
    None: 'NONE',
} as const;

export type MetricUnitEnum = typeof MetricUnitEnum[keyof typeof MetricUnitEnum];

export interface ModelAndView {
    'empty'?: boolean;
    'model'?: { [key: string]: any; };
    'modelMap'?: ModelAndViewModelMap;
    'reference'?: boolean;
    'status'?: ModelAndViewStatus;
    'view'?: View;
    'viewName'?: string;
}
export interface ModelAndViewModelMap {
    [key: string]: any;

    'empty'?: boolean;
}
/**
 * @type ModelAndViewStatus
 */
export type ModelAndViewStatus = DefaultHttpStatusCode | HttpStatus;

export interface ModifiedStepSummary {
    'detail': string;
    'isLoop': boolean;
    'loopAxisTagName'?: string;
    'ruleName': string;
    'stepName': string;
    'stepOrder': number;
}
export interface MonthToFixedAmount {
    'fixedAmount': number;
    'month': number;
}
export interface MonthToRatio {
    'month': number;
    'ratio': string;
}
export interface MonthToRealValue {
    'month': number;
    'realValue': string;
}
export interface MoveBSAccountTreeNodeRequestBody {
    'newParentAccountId'?: string;
    'targetAccountId': string;
}
export interface MoveComparisonSheetSelectedConditionGroupRequestBody {
    'groupId': string;
}
export interface MoveDashboardFolderBody {
    'destinationFolderId'?: string;
}
export interface MoveDashboardRequestBody {
    'destinationFolderId'?: string;
}
export interface MoveDimensionTreeNodeRequestBody {
    'parentDimensionTagId'?: string;
    'targetDimensionTagId': string;
}
export interface MoveFinancialSimulationBody {
    'destinationFolderId'?: string;
}
export interface MoveFinancialSimulationFolderBody {
    'destinationFolderId'?: string;
}
export interface MoveNodesRequestBody {
    'newParentAccountId': string;
    'targetAccountId': string;
}
export interface MoveNonFinancialAccountTreeNodeBody {
    'newParentNode'?: NonFinancialAccountTreeNodeBody;
    'targetNode': NonFinancialAccountTreeNodeBody;
}
export interface MoveReportBody {
    'destinationFolderId'?: string;
}
export interface MoveReportFolderBody {
    'destinationFolderId'?: string;
}
export interface MoveReportTargetIdBody {
    'itemId': string;
    'itemType': MoveReportTargetIdBodyItemTypeEnum;
}

export const MoveReportTargetIdBodyItemTypeEnum = {
    Folder: 'FOLDER',
    NormalReport: 'NORMAL_REPORT',
} as const;

export type MoveReportTargetIdBodyItemTypeEnum = typeof MoveReportTargetIdBodyItemTypeEnum[keyof typeof MoveReportTargetIdBodyItemTypeEnum];

export interface MoveReportsBody {
    'destinationFolderId'?: string;
    'itemIds': Array<MoveReportTargetIdBody>;
}
export interface MovedNotIncludedAccountsView {
    'movedNotIncludedBSSubAccounts': MovedNotIncludedBSSubAccountsView;
    'movedNotIncludedSubAccounts': MovedNotIncludedSubAccountsView;
}
export interface MovedNotIncludedBSSubAccountsView {
    'numOfMoved': number;
}
export interface MovedNotIncludedSubAccountsView {
    'numOfMoved': number;
}
export interface MutableTreeNode {
    'children': Array<MutableTreeNodeObject>;
    'value': any;
}
export interface MutableTreeNodeObject {
    'children': Array<any>;
    'value': any;
}
export interface Name {
    'value': string;
}
export interface NameVO {
    'value': string;
}
export interface NonFinancialAccountFlatTreeForSelectionView {
    'items': Array<NonFinancialAccountTreeNodeForSelectionView>;
    'meta': NonFinancialAccountTreeView;
}
export interface NonFinancialAccountFlatTreeNodeView {
    'accountingSystemCode'?: AccountingSystemCodeView;
    'code': string;
    'id': string;
    'level': number;
    'matched': boolean;
    'matchedKeyword': MatchedAccountKeywordView;
    'name': string;
    'nodeType': NonFinancialAccountFlatTreeNodeViewNodeTypeEnum;
    'parentId'?: string;
    'parentNodeType'?: NonFinancialAccountFlatTreeNodeViewParentNodeTypeEnum;
    'roundingPrecision'?: NonFinancialAccountFlatTreeNodeViewRoundingPrecisionEnum;
    'valueFormat'?: NonFinancialAccountFlatTreeNodeViewValueFormatEnum;
    'viewControlType'?: NonFinancialAccountFlatTreeNodeViewViewControlTypeEnum;
}

export const NonFinancialAccountFlatTreeNodeViewNodeTypeEnum = {
    AccountGroup: 'ACCOUNT_GROUP',
    Account: 'ACCOUNT',
} as const;

export type NonFinancialAccountFlatTreeNodeViewNodeTypeEnum = typeof NonFinancialAccountFlatTreeNodeViewNodeTypeEnum[keyof typeof NonFinancialAccountFlatTreeNodeViewNodeTypeEnum];
export const NonFinancialAccountFlatTreeNodeViewParentNodeTypeEnum = {
    AccountGroup: 'ACCOUNT_GROUP',
    Account: 'ACCOUNT',
} as const;

export type NonFinancialAccountFlatTreeNodeViewParentNodeTypeEnum = typeof NonFinancialAccountFlatTreeNodeViewParentNodeTypeEnum[keyof typeof NonFinancialAccountFlatTreeNodeViewParentNodeTypeEnum];
export const NonFinancialAccountFlatTreeNodeViewRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type NonFinancialAccountFlatTreeNodeViewRoundingPrecisionEnum = typeof NonFinancialAccountFlatTreeNodeViewRoundingPrecisionEnum[keyof typeof NonFinancialAccountFlatTreeNodeViewRoundingPrecisionEnum];
export const NonFinancialAccountFlatTreeNodeViewValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type NonFinancialAccountFlatTreeNodeViewValueFormatEnum = typeof NonFinancialAccountFlatTreeNodeViewValueFormatEnum[keyof typeof NonFinancialAccountFlatTreeNodeViewValueFormatEnum];
export const NonFinancialAccountFlatTreeNodeViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type NonFinancialAccountFlatTreeNodeViewViewControlTypeEnum = typeof NonFinancialAccountFlatTreeNodeViewViewControlTypeEnum[keyof typeof NonFinancialAccountFlatTreeNodeViewViewControlTypeEnum];

export interface NonFinancialAccountFlatTreeView {
    'id': string;
    'internalNodeIds': Array<string>;
    'items': Array<NonFinancialAccountFlatTreeNodeView>;
}
export interface NonFinancialAccountFlatTreeWithNotIncludedForSelectionView {
    'items': Array<NonFinancialAccountTreeNodeForSelectionView>;
    'meta': NonFinancialAccountTreeView;
    'notIncludes': Array<NonFinancialAccountTreeNodeContentForSelectionView>;
}
export interface NonFinancialAccountTreeListView {
    'items': Array<NonFinancialAccountTreeView>;
}
export interface NonFinancialAccountTreeNodeBody {
    'id': string;
    'nodeType': NonFinancialAccountTreeNodeBodyNodeTypeEnum;
}

export const NonFinancialAccountTreeNodeBodyNodeTypeEnum = {
    AccountGroup: 'ACCOUNT_GROUP',
    Account: 'ACCOUNT',
} as const;

export type NonFinancialAccountTreeNodeBodyNodeTypeEnum = typeof NonFinancialAccountTreeNodeBodyNodeTypeEnum[keyof typeof NonFinancialAccountTreeNodeBodyNodeTypeEnum];

export interface NonFinancialAccountTreeNodeContentForSelectionView {
    'accountingSystemCode'?: AccountingSystemCodeView;
    'code': string;
    'id': string;
    'name': string;
    'nodeType': NonFinancialAccountTreeNodeContentForSelectionViewNodeTypeEnum;
    'roundingPrecision'?: NonFinancialAccountTreeNodeContentForSelectionViewRoundingPrecisionEnum;
    'valueFormat'?: NonFinancialAccountTreeNodeContentForSelectionViewValueFormatEnum;
}

export const NonFinancialAccountTreeNodeContentForSelectionViewNodeTypeEnum = {
    AccountGroup: 'ACCOUNT_GROUP',
    Account: 'ACCOUNT',
} as const;

export type NonFinancialAccountTreeNodeContentForSelectionViewNodeTypeEnum = typeof NonFinancialAccountTreeNodeContentForSelectionViewNodeTypeEnum[keyof typeof NonFinancialAccountTreeNodeContentForSelectionViewNodeTypeEnum];
export const NonFinancialAccountTreeNodeContentForSelectionViewRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type NonFinancialAccountTreeNodeContentForSelectionViewRoundingPrecisionEnum = typeof NonFinancialAccountTreeNodeContentForSelectionViewRoundingPrecisionEnum[keyof typeof NonFinancialAccountTreeNodeContentForSelectionViewRoundingPrecisionEnum];
export const NonFinancialAccountTreeNodeContentForSelectionViewValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type NonFinancialAccountTreeNodeContentForSelectionViewValueFormatEnum = typeof NonFinancialAccountTreeNodeContentForSelectionViewValueFormatEnum[keyof typeof NonFinancialAccountTreeNodeContentForSelectionViewValueFormatEnum];

export interface NonFinancialAccountTreeNodeForSelectionView {
    'data': NonFinancialAccountTreeNodeContentForSelectionView;
    'isViewable': boolean;
    'level': number;
    'nodeId': string;
    'parentNodeId'?: string;
    'parentNodeType'?: NonFinancialAccountTreeNodeForSelectionViewParentNodeTypeEnum;
}

export const NonFinancialAccountTreeNodeForSelectionViewParentNodeTypeEnum = {
    AccountGroup: 'ACCOUNT_GROUP',
    Account: 'ACCOUNT',
} as const;

export type NonFinancialAccountTreeNodeForSelectionViewParentNodeTypeEnum = typeof NonFinancialAccountTreeNodeForSelectionViewParentNodeTypeEnum[keyof typeof NonFinancialAccountTreeNodeForSelectionViewParentNodeTypeEnum];

export interface NonFinancialAccountTreeView {
    'id': string;
    'isPrimary': boolean;
    'name': string;
}
export interface NonFinancialAccountView {
    'accountId': string;
    'accountingSystemCode'?: AccountingSystemCodeView;
    'code': string;
    'isSelectable': boolean;
    'name': string;
    'roundingPrecision': NonFinancialAccountViewRoundingPrecisionEnum;
    'valueFormat': NonFinancialAccountViewValueFormatEnum;
}

export const NonFinancialAccountViewRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type NonFinancialAccountViewRoundingPrecisionEnum = typeof NonFinancialAccountViewRoundingPrecisionEnum[keyof typeof NonFinancialAccountViewRoundingPrecisionEnum];
export const NonFinancialAccountViewValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type NonFinancialAccountViewValueFormatEnum = typeof NonFinancialAccountViewValueFormatEnum[keyof typeof NonFinancialAccountViewValueFormatEnum];

export interface NonFinancialItemsUploadEventsDto {
    'deleteStartAt'?: string;
    'nonFinancialItemUploadEventId': string;
    'status': NonFinancialItemsUploadEventsDtoStatusEnum;
    'targetEndMonth': string;
    'targetStartMonth': string;
    'uploadUserName': string;
    'uploadedAt': string;
    'uploadedFileName': string;
    'uploadedItemCount': number;
}

export const NonFinancialItemsUploadEventsDtoStatusEnum = {
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Error: 'ERROR',
    Deleting: 'DELETING',
} as const;

export type NonFinancialItemsUploadEventsDtoStatusEnum = typeof NonFinancialItemsUploadEventsDtoStatusEnum[keyof typeof NonFinancialItemsUploadEventsDtoStatusEnum];

export interface NotContains {
    'conditionValue': string;
}
export interface NotEntered {
    'conditionValue'?: string;
}
export interface NotEquals {
    'conditionValue': string;
}
export interface NotIncludedAccountCountView {
    'response': number;
}
export interface NotIncludedAccountView {
    'accountView': AccountView;
    'isArchived': boolean;
    'isVisible': boolean;
}
export interface NotIncludedAccountsView {
    'listAccountView': Array<NotIncludedAccountView>;
    'paging'?: PagingDto;
}
export interface NotIncludedDimensionTagView {
    'code': string;
    'description'?: string;
    'exCodes': Array<string>;
    'id': string;
    'name': string;
}
export interface NotIncludedDimensionTagsView {
    'items': Array<NotIncludedDimensionTagView>;
}
export interface NotIncludedNonFinancialAccountCountView {
    'count': number;
}
export interface NotIncludedNonFinancialAccountView {
    'accountingSystemCode'?: AccountingSystemCodeView;
    'code': string;
    'id': string;
    'isArchived': boolean;
    'name': string;
    'nodeType': NotIncludedNonFinancialAccountViewNodeTypeEnum;
    'roundingPrecision': NotIncludedNonFinancialAccountViewRoundingPrecisionEnum;
    'valueFormat': NotIncludedNonFinancialAccountViewValueFormatEnum;
    'viewControlType': NotIncludedNonFinancialAccountViewViewControlTypeEnum;
}

export const NotIncludedNonFinancialAccountViewNodeTypeEnum = {
    AccountGroup: 'ACCOUNT_GROUP',
    Account: 'ACCOUNT',
} as const;

export type NotIncludedNonFinancialAccountViewNodeTypeEnum = typeof NotIncludedNonFinancialAccountViewNodeTypeEnum[keyof typeof NotIncludedNonFinancialAccountViewNodeTypeEnum];
export const NotIncludedNonFinancialAccountViewRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type NotIncludedNonFinancialAccountViewRoundingPrecisionEnum = typeof NotIncludedNonFinancialAccountViewRoundingPrecisionEnum[keyof typeof NotIncludedNonFinancialAccountViewRoundingPrecisionEnum];
export const NotIncludedNonFinancialAccountViewValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type NotIncludedNonFinancialAccountViewValueFormatEnum = typeof NotIncludedNonFinancialAccountViewValueFormatEnum[keyof typeof NotIncludedNonFinancialAccountViewValueFormatEnum];
export const NotIncludedNonFinancialAccountViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type NotIncludedNonFinancialAccountViewViewControlTypeEnum = typeof NotIncludedNonFinancialAccountViewViewControlTypeEnum[keyof typeof NotIncludedNonFinancialAccountViewViewControlTypeEnum];

export interface NotIncludedNonFinancialAccountsView {
    'items': Array<NotIncludedNonFinancialAccountView>;
}
export interface NumberLimitView {
    'maxNumber': number;
    'numberLimitDataName': NumberLimitViewNumberLimitDataNameEnum;
}

export const NumberLimitViewNumberLimitDataNameEnum = {
    Dimension: 'DIMENSION',
    DimensionTree: 'DIMENSION_TREE',
    AccountTree: 'ACCOUNT_TREE',
    NonFinancialAccountTree: 'NON_FINANCIAL_ACCOUNT_TREE',
    OrgTree: 'ORG_TREE',
    Report: 'REPORT',
    PlanUpdateRequestFormat: 'PLAN_UPDATE_REQUEST_FORMAT',
    ActualImportMapping: 'ACTUAL_IMPORT_MAPPING',
    Dashboard: 'DASHBOARD',
} as const;

export type NumberLimitViewNumberLimitDataNameEnum = typeof NumberLimitViewNumberLimitDataNameEnum[keyof typeof NumberLimitViewNumberLimitDataNameEnum];

export interface OkJson {
    'response': string;
}
export interface OpenWorkforcePlanUpdateRequestTargetDepartments {
    'departments': Array<TargetDepartment>;
    'visibleDepartments': Array<TargetDepartment>;
}
export interface OpenWorkforcePlanUpdateRequestTargetPlanningProjects {
    'planningProjects': Array<TargetPlanningProject>;
}
export interface OrgTreeForSelectionView {
    'meta': OrgTreeMetaView;
    'nodes': Array<OrgTreeNodeForSelectionView>;
}
export interface OrgTreeMetaView {
    'id': string;
    'isPrimary': boolean;
    'name': string;
}
export interface OrgTreeNodeForSelectionView {
    'data': DepartmentView;
    'departmentId': string;
    'isOwnValue'?: boolean;
    'isSelectable': boolean;
    'level': number;
    'parentDepartmentId'?: string;
}
export interface OrgTreeNodeV2View {
    'children': Array<OrgTreeNodeV2View>;
    'data': DepartmentView;
    'departmentId': string;
    'level': number;
    'parentDepartmentId'?: string;
}
export interface OrgTreeNodeView {
    'data': DepartmentView;
    'departmentId': string;
    'isOwnValue'?: boolean;
    'level': number;
    'parentDepartmentId'?: string;
}
export interface OrgTreeV2View {
    'meta': OrgTreeMetaView;
    'nodes'?: OrgTreeNodeV2View;
}
export interface OrgTreeView {
    'meta': OrgTreeMetaView;
    'nodes': Array<OrgTreeNodeView>;
}
export interface OrganizationTreeListView {
    'items': Array<OrganizationTreeView>;
}
export interface OrganizationTreeView {
    'forAuthority': boolean;
    'isPrimary': boolean;
    'name': string;
    'organizationTreeId': string;
}
export interface OverwriteWorkforcePlanningProjectSimulationBody {
    'baseYearMonth'?: string;
    'departmentIds': Array<string>;
    'name': string;
}
export interface OverwrittenWorkforcePlanningProjectSimulationView {
    'simulationId': string;
}
export interface PLAccountFlatTreeViewForCandidate {
    'id': string;
    'items': Array<AccountTreeNodeView>;
}
export interface PLReportConditionSchema {
    'cellGroupOrders': Array<CellGroupOrder>;
    'columnAggregationDimension': ColumnAggregationDimension;
    'comparisonConditions': Array<ComparisonCondition>;
    'currencyCode': string;
    'dataConditions': Array<DataCondition>;
    'isShowEmptyRows': boolean;
    'isTreeView': boolean;
    'rowAggregationDimensions': Array<RowAggregationDimension>;
    'showCumulativeRow'?: boolean;
    'showNumbersIn': PLReportConditionSchemaShowNumbersInEnum;
    'showSumRow': boolean;
    'sortCondition'?: SortCondition;
}

export const PLReportConditionSchemaShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type PLReportConditionSchemaShowNumbersInEnum = typeof PLReportConditionSchemaShowNumbersInEnum[keyof typeof PLReportConditionSchemaShowNumbersInEnum];

export interface PageDtoActualImportEventDto {
    'items': Array<ActualImportEventDto>;
    'paging': PagingDto;
}
export interface PageDtoAllocationRuleSummaryDto {
    'items': Array<AllocationRuleSummaryDto>;
    'paging': PagingDto;
}
export interface PageDtoAllocationStandardSummaryDto {
    'items': Array<AllocationStandardSummaryDto>;
    'paging': PagingDto;
}
export interface PageDtoDepartmentViewWithIsAssignedAndIsArchived {
    'items': Array<DepartmentViewWithIsAssignedAndIsArchived>;
    'paging': PagingDto;
}
export interface PageDtoDownloadManagementDto {
    'items': Array<DownloadManagementDto>;
    'paging': PagingDto;
}
export interface PageDtoFinancialSimulationListItemView {
    'items': Array<FinancialSimulationListItemView>;
    'paging': PagingDto;
}
export interface PageDtoNonFinancialItemsUploadEventsDto {
    'items': Array<NonFinancialItemsUploadEventsDto>;
    'paging': PagingDto;
}
export interface PageDtoPersonListItem {
    'items': Array<PersonListItem>;
    'paging': PagingDto;
}
export interface PageDtoUnitAmountListItem {
    'items': Array<UnitAmountListItem>;
    'paging': PagingDto;
}
export interface PageDtoUserWithDepartmentNamesDto {
    'items': Array<UserWithDepartmentNamesDto>;
    'paging': PagingDto;
}
export interface PageViewModifiedStepSummary {
    'items': Array<ModifiedStepSummary>;
    'limit': number;
    'offset': number;
    'totalCount': number;
}
export interface PageViewRuleSummary {
    'items': Array<RuleSummary>;
    'limit': number;
    'offset': number;
    'totalCount': number;
}
export interface PagingDto {
    'limit': number;
    'offset': number;
    'totalCount': number;
}
export interface ParameterVisibilityConditionParam {
    'ids': Array<string>;
    'type': ParameterVisibilityConditionParamTypeEnum;
}

export const ParameterVisibilityConditionParamTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
    Period: 'PERIOD',
} as const;

export type ParameterVisibilityConditionParamTypeEnum = typeof ParameterVisibilityConditionParamTypeEnum[keyof typeof ParameterVisibilityConditionParamTypeEnum];

export interface PatchBSAccountRequestBody {
    'code': string;
    'externalSystemAccountCode'?: string;
    'externalSystemSubAccountCode'?: string;
    'name': string;
    'viewControlType': PatchBSAccountRequestBodyViewControlTypeEnum;
}

export const PatchBSAccountRequestBodyViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type PatchBSAccountRequestBodyViewControlTypeEnum = typeof PatchBSAccountRequestBodyViewControlTypeEnum[keyof typeof PatchBSAccountRequestBodyViewControlTypeEnum];

export interface Pattern {
    'id': string;
    'name': string;
}
export interface PatternDepartmentConditionDryRunResult {
    'departmentIds': Array<string>;
}
export interface PatternDetailDto {
    'id': string;
    'name': string;
    'rules': Array<RuleDetailDto>;
}
export interface PatternDimensionConditionDryRunResult {
    'dimensionId': string;
    'dimensionTagIds': Array<string>;
}
export interface PatternDryRunResult {
    'departmentConditions': Array<PatternDepartmentConditionDryRunResult>;
    'dimensionConditions': Array<PatternDimensionConditionDryRunResult>;
    'patternId': string;
    'personMonthInfos': Array<PersonMonthInfo>;
    'type': PatternDryRunResultTypeEnum;
    'yearMonth': string;
}

export const PatternDryRunResultTypeEnum = {
    ByRatio: 'BY_RATIO',
    ByRealValue: 'BY_REAL_VALUE',
    ByFixed: 'BY_FIXED',
    ByEachMonthRatio: 'BY_EACH_MONTH_RATIO',
    ByEachMonthRealValue: 'BY_EACH_MONTH_REAL_VALUE',
    ByEachMonthFixed: 'BY_EACH_MONTH_FIXED',
    Exclude: 'EXCLUDE',
} as const;

export type PatternDryRunResultTypeEnum = typeof PatternDryRunResultTypeEnum[keyof typeof PatternDryRunResultTypeEnum];

export interface PatternExecution {
    'pattern': Pattern;
    'result': ExecutionResult;
}
export interface PatternSummary {
    'isDefault': boolean;
    'patternId': string;
    'patternName': string;
    'ruleCount': number;
}
export interface PatternSummaryView {
    'isDefault': boolean;
    'patternId': string;
    'patternName': string;
}
export interface Period {
    'end': string;
    'start': string;
}
export interface PeriodColumn {
    'id': string;
    'label': string;
}
export interface PeriodColumnGroup {
    'id': string;
    'label': string;
}
export interface PeriodComparisonCellTypeV3View {
    'comparisonType': PeriodComparisonCellTypeV3ViewComparisonTypeEnum;
    'periodKey': string;
    'periodLabel': string;
}

export const PeriodComparisonCellTypeV3ViewComparisonTypeEnum = {
    ActualBudget: 'ACTUAL_BUDGET',
    ActualForecast: 'ACTUAL_FORECAST',
    ActualBudgetMixed: 'ACTUAL_BUDGET_MIXED',
    ActualForecastMixed: 'ACTUAL_FORECAST_MIXED',
    ActualNull: 'ACTUAL_NULL',
    NullNull: 'NULL_NULL',
    NullBudget: 'NULL_BUDGET',
    NullForecast: 'NULL_FORECAST',
} as const;

export type PeriodComparisonCellTypeV3ViewComparisonTypeEnum = typeof PeriodComparisonCellTypeV3ViewComparisonTypeEnum[keyof typeof PeriodComparisonCellTypeV3ViewComparisonTypeEnum];

export interface PermissionItemView {
    'item': Array<WorkforcePlanningPermissionItem>;
}
export interface PersonListFilterCondition {
    'department'?: PersonListFilterIds;
    'dimensions'?: { [key: string]: PersonListFilterIds; };
    'statuses'?: Array<PersonListFilterConditionStatusesEnum>;
}

export const PersonListFilterConditionStatusesEnum = {
    Unenrolled: 'UNENROLLED',
    Active: 'ACTIVE',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    Resigned: 'RESIGNED',
} as const;

export type PersonListFilterConditionStatusesEnum = typeof PersonListFilterConditionStatusesEnum[keyof typeof PersonListFilterConditionStatusesEnum];

export interface PersonListFilterIds {
    'ids': Array<string>;
}
export interface PersonListItem {
    'departmentName'?: string;
    'dimensionTagViews': Array<PersonListItemDimensionTagView>;
    'employmentStatus': PersonListItemEmploymentStatusEnum;
    'endDate'?: string;
    'personCode': string;
    'personName': string;
    'startDate'?: string;
    'workforceId': string;
}

export const PersonListItemEmploymentStatusEnum = {
    Active: 'ACTIVE',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    Resigned: 'RESIGNED',
    Unenrolled: 'UNENROLLED',
    Cancelled: 'CANCELLED',
} as const;

export type PersonListItemEmploymentStatusEnum = typeof PersonListItemEmploymentStatusEnum[keyof typeof PersonListItemEmploymentStatusEnum];

export interface PersonListItemDimensionTagView {
    'dimensionId': string;
    'dimensionTagName': string;
}
export interface PersonMonthInfo {
    'departmentId': string;
    'dimensionTagIds': Array<string>;
    'value': number;
    'workforceDimensionTagId': string;
}
export interface PersonView {
    'firstName': string;
    'lastName': string;
    'personCode': string;
    'workforceId': string;
}
export interface PieChartConfig {
    'colorPalettes'?: { [key: string]: string; };
    'legendPosition'?: PieChartConfigLegendPositionEnum;
    'selectedBreakdownIds'?: Array<string>;
    'selectedColumnId': string;
    'selectedDataConditionId': string;
    'selectedMainDimensionIds': Array<string>;
    'showCumulativeRow': boolean;
    'showDataLabels': boolean;
}

export const PieChartConfigLegendPositionEnum = {
    Right: 'RIGHT',
    Left: 'LEFT',
    Top: 'TOP',
    Bottom: 'BOTTOM',
    Hidden: 'HIDDEN',
} as const;

export type PieChartConfigLegendPositionEnum = typeof PieChartConfigLegendPositionEnum[keyof typeof PieChartConfigLegendPositionEnum];

export interface PieChartDataView {
    'amountAxisUnitLabel': string;
    'cellCount': number;
    'chartDataUnscaledUnit': string;
    'chartSlicePercentages': Array<string>;
    'chartSliceTotal': string;
    'chartSliceTotalUnscaled'?: string;
    'chartSliceValues': Array<string>;
    'chartSliceValuesUnscaled': Array<string>;
    'columnLabel': string;
    'displaySliceTotal': string;
    'displaySliceValues': Array<string>;
    'metricName': string;
    'reportMetadata'?: GraphReportMetadata;
    'sectorRowDimensionConditions': Array<Array<SeriesRowDimensionCondition>>;
    'selectedVisibleMetric': string;
    'sliceLabels': Array<string>;
    'sliceTotal': string;
    'sliceValues': Array<string>;
    'uniqueKeys': Array<GraphUniqueKeyView>;
}
export interface PlanActualCellView {
    'diffRatio'?: string;
    'diffScaledAmount'?: string;
    'periodNumber': number;
    'planAOriginalValue'?: number;
    'planAScaledValue'?: string;
    'planBOriginalValue'?: number;
    'planBScaledValue'?: string;
}
export interface PlanDetailView {
    'masterId'?: string;
    'name'?: string;
    'planSelected': boolean;
    'planType'?: PlanDetailViewPlanTypeEnum;
    'planningProjectId'?: string;
}

export const PlanDetailViewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type PlanDetailViewPlanTypeEnum = typeof PlanDetailViewPlanTypeEnum[keyof typeof PlanDetailViewPlanTypeEnum];

export interface PlanId {
    'id': string;
    'type': PlanIdTypeEnum;
}

export const PlanIdTypeEnum = {
    PlanMaster: 'PLAN_MASTER',
    PlanningProject: 'PLANNING_PROJECT',
    PlanUpdateRequestDraft: 'PLAN_UPDATE_REQUEST_DRAFT',
} as const;

export type PlanIdTypeEnum = typeof PlanIdTypeEnum[keyof typeof PlanIdTypeEnum];

export interface PlanMasterMetaView {
    'createdAt': string;
    'isArchived': boolean;
    'originId'?: string;
    'originName'?: string;
    'planMasterId': string;
    'planMasterName': string;
    'planType': PlanMasterMetaViewPlanTypeEnum;
    'updatedAt': string;
}

export const PlanMasterMetaViewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type PlanMasterMetaViewPlanTypeEnum = typeof PlanMasterMetaViewPlanTypeEnum[keyof typeof PlanMasterMetaViewPlanTypeEnum];

export interface PlanMasterOrPlanningProjectId {
    'id': string;
    'isPlanMaster': boolean;
}
export interface PlanMasterPlanningProjectsView {
    'meta': PlanMasterMetaView;
    'planningProjects': Array<PlanningProjectMetaView>;
}
export interface PlanMasterWithPlanSheetsView {
    'planMasterId': string;
    'planMasterName': string;
    'planningProjects': Array<PlanningProjectWithPlanSheetsView>;
}
export interface PlanMastersPlanningProjectsView {
    'inUseDraftItemsPlanningProjectIds': Array<string>;
    'planMasters': Array<PlanMasterPlanningProjectsView>;
}
export interface PlanMastersView {
    'count': number;
    'items': Array<PlanMasterMetaView>;
    'limit'?: number;
    'offset'?: number;
}
export interface PlanPeriodPairView {
    'periodNumber': number;
    'planA': RowInfo;
    'planB': RowInfo;
}
export interface PlanSheetCellGroupView {
    'cells': Array<PlanSheetCellView>;
}
export interface PlanSheetCellView {
    'canShowDetail': boolean;
    'dataConditionId': PlanSheetCellViewDataConditionIdEnum;
    'eitherAmountOrError'?: EitherAmountOrErrorView;
    'hasAllocatedItem': boolean;
    'id': string;
}

export const PlanSheetCellViewDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type PlanSheetCellViewDataConditionIdEnum = typeof PlanSheetCellViewDataConditionIdEnum[keyof typeof PlanSheetCellViewDataConditionIdEnum];

export interface PlanSheetDisplayMessageView {
    'level': PlanSheetDisplayMessageViewLevelEnum;
    'message': string;
}

export const PlanSheetDisplayMessageViewLevelEnum = {
    Info: 'INFO',
    Warn: 'WARN',
} as const;

export type PlanSheetDisplayMessageViewLevelEnum = typeof PlanSheetDisplayMessageViewLevelEnum[keyof typeof PlanSheetDisplayMessageViewLevelEnum];

export interface PlanSheetHeaderCellGroupView {
    'cells': Array<PlanSheetHeaderCellView>;
}
export interface PlanSheetHeaderCellView {
    'actualPlanLabel': string;
    'dataConditionId': PlanSheetHeaderCellViewDataConditionIdEnum;
    'id': string;
    'label': string;
}

export const PlanSheetHeaderCellViewDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type PlanSheetHeaderCellViewDataConditionIdEnum = typeof PlanSheetHeaderCellViewDataConditionIdEnum[keyof typeof PlanSheetHeaderCellViewDataConditionIdEnum];

export interface PlanSheetHeaderSumCellGroupView {
    'cells': Array<PlanSheetHeaderSumCellView>;
}
export interface PlanSheetHeaderSumCellView {
    'actualPlanLabel': string;
    'dataConditionId': PlanSheetHeaderSumCellViewDataConditionIdEnum;
    'id': string;
    'label': string;
}

export const PlanSheetHeaderSumCellViewDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type PlanSheetHeaderSumCellViewDataConditionIdEnum = typeof PlanSheetHeaderSumCellViewDataConditionIdEnum[keyof typeof PlanSheetHeaderSumCellViewDataConditionIdEnum];

export interface PlanSheetIdWithNameView {
    'id': string;
    'name': string;
}
export interface PlanSheetInvalidConditionView {
    'dimensionLabel': string;
    'idWithNames': Array<PlanSheetIdWithNameView>;
    'treeLabel'?: string;
    'type': PlanSheetInvalidConditionViewTypeEnum;
}

export const PlanSheetInvalidConditionViewTypeEnum = {
    NotIncludedInTree: 'NOT_INCLUDED_IN_TREE',
    Deleted: 'DELETED',
    BecameLeaf: 'BECAME_LEAF',
} as const;

export type PlanSheetInvalidConditionViewTypeEnum = typeof PlanSheetInvalidConditionViewTypeEnum[keyof typeof PlanSheetInvalidConditionViewTypeEnum];

export interface PlanSheetMetaView {
    'headerCellGroups': Array<PlanSheetHeaderCellGroupView>;
    'headerSumCellGroup'?: PlanSheetHeaderSumCellGroupView;
    'rowAggregationKeyMetas': Array<PlanSheetRowAggregationKeyMetaView>;
}
export interface PlanSheetRowAggregationKeyMetaView {
    'label': string;
}
export interface PlanSheetRowAggregationKeyView {
    'id': string;
    'label': string;
    'rowAggregationKeyType': PlanSheetRowAggregationKeyViewRowAggregationKeyTypeEnum;
}

export const PlanSheetRowAggregationKeyViewRowAggregationKeyTypeEnum = {
    AggregatedAccount: 'AGGREGATED_ACCOUNT',
    CalculatedAccount: 'CALCULATED_ACCOUNT',
    AccountGroup: 'ACCOUNT_GROUP',
} as const;

export type PlanSheetRowAggregationKeyViewRowAggregationKeyTypeEnum = typeof PlanSheetRowAggregationKeyViewRowAggregationKeyTypeEnum[keyof typeof PlanSheetRowAggregationKeyViewRowAggregationKeyTypeEnum];

export interface PlanSheetRowView {
    'cellGroups': Array<PlanSheetCellGroupView>;
    'rowAggregationKeys': Array<PlanSheetRowAggregationKeyView>;
    'sumCellGroup'?: PlanSheetSumCellGroupView;
}
export interface PlanSheetSumCellGroupView {
    'cells': Array<PlanSheetSumCellView>;
}
export interface PlanSheetSumCellView {
    'dataConditionId': PlanSheetSumCellViewDataConditionIdEnum;
    'eitherAmountOrError'?: EitherAmountOrErrorView;
    'id': string;
}

export const PlanSheetSumCellViewDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type PlanSheetSumCellViewDataConditionIdEnum = typeof PlanSheetSumCellViewDataConditionIdEnum[keyof typeof PlanSheetSumCellViewDataConditionIdEnum];

export interface PlanSheetSummaryView {
    'name': string;
    'sheetId': string;
}
export interface PlanSheetTableView {
    'meta': PlanSheetMetaView;
    'rows': Array<PlanSheetRowView>;
}
export interface PlanSheetTemplateView {
    'fileName': string;
    'registeredAt': string;
    'registeredByUserName': string;
}
export interface PlanSheetUploadEventListView {
    'items': Array<PlanSheetUploadEventView>;
    'total': number;
}
export interface PlanSheetUploadEventView {
    'departments': Array<string>;
    'fileName': string;
    'id': string;
    'uploadedAt': string;
    'uploadedUserId': string;
    'uploadedUserName': string;
}
export interface PlanSheetView {
    'aggregatedViewReportId'?: string;
    'assignedDepartmentIds': Array<string>;
    'condition': SheetConditionSchema;
    'createUserId': string;
    'createUserName': string;
    'createdAt': string;
    'isEditRestricted': boolean;
    'lastUpdateUserId': string;
    'lastUpdateUserName': string;
    'lastUpdatedAt': string;
    'name': string;
    'planningProjectId': string;
    'sheetId': string;
    'version': number;
}
export interface PlanUpdateRequestAggregateTreeNodeMetaView {
    'actualEndWhenPlanningProject'?: string;
    'departmentIds': Array<string>;
    'departmentNames': Array<string>;
    'periodEnd': string;
    'periodStart': string;
    'periods': Array<PlanUpdateRequestPeriodView>;
    'planMasterId': string;
    'planMasterName': string;
    'planType': PlanUpdateRequestAggregateTreeNodeMetaViewPlanTypeEnum;
    'planUpdateRequestIds': Array<string>;
    'planningProjectId': string;
    'planningProjectName': string;
    'showNumbersIn': PlanUpdateRequestAggregateTreeNodeMetaViewShowNumbersInEnum;
}

export const PlanUpdateRequestAggregateTreeNodeMetaViewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type PlanUpdateRequestAggregateTreeNodeMetaViewPlanTypeEnum = typeof PlanUpdateRequestAggregateTreeNodeMetaViewPlanTypeEnum[keyof typeof PlanUpdateRequestAggregateTreeNodeMetaViewPlanTypeEnum];
export const PlanUpdateRequestAggregateTreeNodeMetaViewShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type PlanUpdateRequestAggregateTreeNodeMetaViewShowNumbersInEnum = typeof PlanUpdateRequestAggregateTreeNodeMetaViewShowNumbersInEnum[keyof typeof PlanUpdateRequestAggregateTreeNodeMetaViewShowNumbersInEnum];

export interface PlanUpdateRequestAggregateView {
    'meta': PlanUpdateRequestAggregateTreeNodeMetaView;
    'tree': PlanUpdateRequestTreeFlatV2View;
}
export interface PlanUpdateRequestCellScaledView {
    'id': string;
    'periodKey': string;
    'sum': SumDiffScaledView;
}
export interface PlanUpdateRequestFileListView {
    'items': Array<PlanUpdateRequestFileView>;
    'total': number;
}
export interface PlanUpdateRequestFileSubmittedDepartmentView {
    'departmentCode': string;
    'departmentId': string;
    'departmentName': string;
    'planUpdateRequestId': string;
}
export interface PlanUpdateRequestFileUnreflectableActualCheckResultView {
    'isExistUnreflectableActual': boolean;
}
export interface PlanUpdateRequestFileView {
    'id': IDImpl;
    'name': string;
    'planMasterId': string;
    'planMasterName': string;
    'planningProjectId': string;
    'planningProjectName': string;
    'submittedAt': string;
    'submittedDepartments': Array<PlanUpdateRequestFileSubmittedDepartmentView>;
    'submittedUser': string;
}
export interface PlanUpdateRequestFormatDownloadableDepartmentView {
    'code': string;
    'id': string;
    'name': string;
}
export interface PlanUpdateRequestFormatListView {
    'limit'?: number;
    'list': Array<PlanUpdateRequestFormatView>;
    'offset': number;
    'total': number;
}
export interface PlanUpdateRequestFormatView {
    'downloadableDepartments': Array<PlanUpdateRequestFormatDownloadableDepartmentView>;
    'fileName': string;
    'id': IDImpl;
    'name': string;
    'updatedAt': string;
}
export interface PlanUpdateRequestMapping {
    'accountKey': PlanUpdateRequestMappingAccountKey;
    'canUseForDownload': boolean;
    'canUseForUpload': boolean;
    'departmentKey': PlanUpdateRequestMappingDepartmentKey;
    'descriptionKey'?: PlanUpdateRequestMappingDescriptionKey;
    'dimensionKeys': Array<PlanUpdateRequestMappingDimensionKey>;
    'endColumnIndex'?: number;
    'endRowIndex'?: number;
    'filters': Array<PlanUpdateRequestMappingFilter>;
    'id': IDImpl;
    'name': NameVO;
    'planUpdateRequestMappingUniqueKey'?: IDImpl;
    'showNumbersIn'?: PlanUpdateRequestMappingShowNumbersInEnum;
    'showNumbersInKey'?: PlanUpdateRequestMappingShowNumbersInKey;
    'showNumbersInSpecification': PlanUpdateRequestMappingShowNumbersInSpecification;
    'startColumnIndex': number;
    'startRowIndex': number;
    'yearMonthKey': PlanUpdateRequestMappingYearMonthKey;
}

export const PlanUpdateRequestMappingShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type PlanUpdateRequestMappingShowNumbersInEnum = typeof PlanUpdateRequestMappingShowNumbersInEnum[keyof typeof PlanUpdateRequestMappingShowNumbersInEnum];

export interface PlanUpdateRequestMappingAccountKey {
    'id': IDImpl;
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': PlanUpdateRequestMappingAccountKeyValueTypeEnum;
}

export const PlanUpdateRequestMappingAccountKeyValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type PlanUpdateRequestMappingAccountKeyValueTypeEnum = typeof PlanUpdateRequestMappingAccountKeyValueTypeEnum[keyof typeof PlanUpdateRequestMappingAccountKeyValueTypeEnum];

export interface PlanUpdateRequestMappingAddress {
    'columnIndex': number;
    'rowIndex': number;
    'type': PlanUpdateRequestMappingAddressTypeEnum;
}

export const PlanUpdateRequestMappingAddressTypeEnum = {
    Cell: 'CELL',
    Row: 'ROW',
    Column: 'COLUMN',
} as const;

export type PlanUpdateRequestMappingAddressTypeEnum = typeof PlanUpdateRequestMappingAddressTypeEnum[keyof typeof PlanUpdateRequestMappingAddressTypeEnum];

export interface PlanUpdateRequestMappingDepartmentKey {
    'id': IDImpl;
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': PlanUpdateRequestMappingDepartmentKeyValueTypeEnum;
}

export const PlanUpdateRequestMappingDepartmentKeyValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type PlanUpdateRequestMappingDepartmentKeyValueTypeEnum = typeof PlanUpdateRequestMappingDepartmentKeyValueTypeEnum[keyof typeof PlanUpdateRequestMappingDepartmentKeyValueTypeEnum];

export interface PlanUpdateRequestMappingDescriptionKey {
    'id': IDImpl;
    'mappedTo': PlanUpdateRequestMappingAddress;
}
export interface PlanUpdateRequestMappingDimensionKey {
    'dimensionId': IDImpl;
    'id': IDImpl;
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': PlanUpdateRequestMappingDimensionKeyValueTypeEnum;
}

export const PlanUpdateRequestMappingDimensionKeyValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type PlanUpdateRequestMappingDimensionKeyValueTypeEnum = typeof PlanUpdateRequestMappingDimensionKeyValueTypeEnum[keyof typeof PlanUpdateRequestMappingDimensionKeyValueTypeEnum];

export interface PlanUpdateRequestMappingDimensionKeyView {
    'dimensionId': IDImpl;
    'dimensionName': DimensionName;
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': PlanUpdateRequestMappingDimensionKeyViewValueTypeEnum;
}

export const PlanUpdateRequestMappingDimensionKeyViewValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type PlanUpdateRequestMappingDimensionKeyViewValueTypeEnum = typeof PlanUpdateRequestMappingDimensionKeyViewValueTypeEnum[keyof typeof PlanUpdateRequestMappingDimensionKeyViewValueTypeEnum];

export interface PlanUpdateRequestMappingFilter {
    'conditionType': PlanUpdateRequestMappingFilterConditionTypeEnum;
    'conditionValue'?: string;
    'id': IDImpl;
    'mappedTo': PlanUpdateRequestMappingAddress;
}

export const PlanUpdateRequestMappingFilterConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Empty: 'EMPTY',
    NotEmpty: 'NOT_EMPTY',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type PlanUpdateRequestMappingFilterConditionTypeEnum = typeof PlanUpdateRequestMappingFilterConditionTypeEnum[keyof typeof PlanUpdateRequestMappingFilterConditionTypeEnum];

export interface PlanUpdateRequestMappingShowNumbersInKey {
    'id': IDImpl;
    'mappedTo': PlanUpdateRequestMappingAddress;
}
/**
 * @type PlanUpdateRequestMappingShowNumbersInSpecification
 */
export type PlanUpdateRequestMappingShowNumbersInSpecification = CellAddress | FixedValue;

export interface PlanUpdateRequestMappingUniqueKeyView {
    'dimensionId': IDImpl;
    'dimensionName': DimensionName;
}
export interface PlanUpdateRequestMappingView {
    'accountKey': PlanUpdateRequestMappingAccountKey;
    'canUseForDownload': boolean;
    'canUseForUpload': boolean;
    'departmentKey': PlanUpdateRequestMappingDepartmentKey;
    'dimensionKeys': Array<PlanUpdateRequestMappingDimensionKeyView>;
    'endColumnIndex'?: number;
    'endRowIndex'?: number;
    'filters': Array<PlanUpdateRequestMappingFilter>;
    'id': IDImpl;
    'name': NameVO;
    'planUpdateRequestMappingUniqueKey'?: PlanUpdateRequestMappingUniqueKeyView;
    'startColumnIndex': number;
    'startRowIndex': number;
    'yearMonthKey': PlanUpdateRequestMappingYearMonthKey;
}
export interface PlanUpdateRequestMappingYearMonthKey {
    'id': IDImpl;
    'mappedTo': PlanUpdateRequestMappingAddress;
}
export interface PlanUpdateRequestMetaView {
    'createdAt': string;
    'createdUserId': string;
    'createdUserName': string;
    'departmentId': string;
    'departmentName': string;
    'isWorkforcePlanUpdateRequest': boolean;
    'periodEnd': string;
    'periodStart': string;
    'planMasterId': string;
    'planMasterName': string;
    'planUpdateRequestId': string;
    'planningProjectId': string;
    'planningProjectName': string;
    'status': PlanUpdateRequestMetaViewStatusEnum;
}

export const PlanUpdateRequestMetaViewStatusEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED',
    Closing: 'CLOSING',
    ApprovalFailed: 'APPROVAL_FAILED',
} as const;

export type PlanUpdateRequestMetaViewStatusEnum = typeof PlanUpdateRequestMetaViewStatusEnum[keyof typeof PlanUpdateRequestMetaViewStatusEnum];

export interface PlanUpdateRequestPeriodView {
    'actual': boolean;
    'key': string;
    'plan': boolean;
}
export interface PlanUpdateRequestStatusesView {
    'errorMessages': Array<ApproveErrorMessage>;
    'hasApproving': boolean;
}
export interface PlanUpdateRequestSumCellScaledView {
    'sum': SumDiffScaledView;
}
export interface PlanUpdateRequestTreeFlatV2View {
    'hasRestrictedItems': boolean;
    'items': Array<PlanUpdateRequestTreeNodeFlatV2View>;
}
export interface PlanUpdateRequestTreeNodeFlatV2View {
    'accountId': string;
    'accountType': PlanUpdateRequestTreeNodeFlatV2ViewAccountTypeEnum;
    'code': string;
    'data': Array<PlanUpdateRequestCellScaledView>;
    'id': string;
    'level': number;
    'name': string;
    'parentId'?: string;
    'rowType': PlanUpdateRequestTreeNodeFlatV2ViewRowTypeEnum;
    'subAccountId'?: string;
    'sumData': PlanUpdateRequestSumCellScaledView;
    'viewControlType': PlanUpdateRequestTreeNodeFlatV2ViewViewControlTypeEnum;
}

export const PlanUpdateRequestTreeNodeFlatV2ViewAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type PlanUpdateRequestTreeNodeFlatV2ViewAccountTypeEnum = typeof PlanUpdateRequestTreeNodeFlatV2ViewAccountTypeEnum[keyof typeof PlanUpdateRequestTreeNodeFlatV2ViewAccountTypeEnum];
export const PlanUpdateRequestTreeNodeFlatV2ViewRowTypeEnum = {
    Account: 'ACCOUNT',
    AccountOwnValue: 'ACCOUNT_OWN_VALUE',
} as const;

export type PlanUpdateRequestTreeNodeFlatV2ViewRowTypeEnum = typeof PlanUpdateRequestTreeNodeFlatV2ViewRowTypeEnum[keyof typeof PlanUpdateRequestTreeNodeFlatV2ViewRowTypeEnum];
export const PlanUpdateRequestTreeNodeFlatV2ViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type PlanUpdateRequestTreeNodeFlatV2ViewViewControlTypeEnum = typeof PlanUpdateRequestTreeNodeFlatV2ViewViewControlTypeEnum[keyof typeof PlanUpdateRequestTreeNodeFlatV2ViewViewControlTypeEnum];

export interface PlanUpdateRequestTreeNodeMetaV2View {
    'actualEndWhenPlanningProject'?: string;
    'approvalFailedMessages': Array<string>;
    'createdAt': string;
    'createdUserId': string;
    'createdUserName': string;
    'departmentId': string;
    'departmentName': string;
    'periodEnd': string;
    'periodStart': string;
    'periods': Array<PlanUpdateRequestPeriodView>;
    'planMasterId': string;
    'planMasterName': string;
    'planType': PlanUpdateRequestTreeNodeMetaV2ViewPlanTypeEnum;
    'planUpdateRequestFileId'?: IDImpl;
    'planUpdateRequestId': string;
    'planUpdateRequestOriginFilePath'?: string;
    'planUpdateRequestOriginType'?: PlanUpdateRequestTreeNodeMetaV2ViewPlanUpdateRequestOriginTypeEnum;
    'planningProjectId': string;
    'planningProjectName': string;
    'roundingMode': PlanUpdateRequestTreeNodeMetaV2ViewRoundingModeEnum;
    'showNumbersIn': PlanUpdateRequestTreeNodeMetaV2ViewShowNumbersInEnum;
    'status': PlanUpdateRequestTreeNodeMetaV2ViewStatusEnum;
}

export const PlanUpdateRequestTreeNodeMetaV2ViewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type PlanUpdateRequestTreeNodeMetaV2ViewPlanTypeEnum = typeof PlanUpdateRequestTreeNodeMetaV2ViewPlanTypeEnum[keyof typeof PlanUpdateRequestTreeNodeMetaV2ViewPlanTypeEnum];
export const PlanUpdateRequestTreeNodeMetaV2ViewPlanUpdateRequestOriginTypeEnum = {
    Csv: 'CSV',
    Excel: 'Excel',
    SpreadSheet: 'SpreadSheet',
    Ui: 'UI',
    Workforce: 'WORKFORCE',
} as const;

export type PlanUpdateRequestTreeNodeMetaV2ViewPlanUpdateRequestOriginTypeEnum = typeof PlanUpdateRequestTreeNodeMetaV2ViewPlanUpdateRequestOriginTypeEnum[keyof typeof PlanUpdateRequestTreeNodeMetaV2ViewPlanUpdateRequestOriginTypeEnum];
export const PlanUpdateRequestTreeNodeMetaV2ViewRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type PlanUpdateRequestTreeNodeMetaV2ViewRoundingModeEnum = typeof PlanUpdateRequestTreeNodeMetaV2ViewRoundingModeEnum[keyof typeof PlanUpdateRequestTreeNodeMetaV2ViewRoundingModeEnum];
export const PlanUpdateRequestTreeNodeMetaV2ViewShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type PlanUpdateRequestTreeNodeMetaV2ViewShowNumbersInEnum = typeof PlanUpdateRequestTreeNodeMetaV2ViewShowNumbersInEnum[keyof typeof PlanUpdateRequestTreeNodeMetaV2ViewShowNumbersInEnum];
export const PlanUpdateRequestTreeNodeMetaV2ViewStatusEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED',
    Closing: 'CLOSING',
} as const;

export type PlanUpdateRequestTreeNodeMetaV2ViewStatusEnum = typeof PlanUpdateRequestTreeNodeMetaV2ViewStatusEnum[keyof typeof PlanUpdateRequestTreeNodeMetaV2ViewStatusEnum];

export interface PlanUpdateRequestV2View {
    'meta': PlanUpdateRequestTreeNodeMetaV2View;
    'tree': PlanUpdateRequestTreeFlatV2View;
}
export interface PlanUpdateRequestsView {
    'items': Array<PlanUpdateRequestMetaView>;
}
export interface PlanningProjectDepartmentCommentMapView {
    'planningProjectDepartmentCommentMap': { [key: string]: Array<PlanningProjectDepartmentCommentView>; };
}
export interface PlanningProjectDepartmentCommentView {
    'canDelete': boolean;
    'commentText': string;
    'createdAt': string;
    'createdUserId': string;
    'createdUserName': string;
    'departmentId': string;
    'planningProjectDepartmentCommentId': string;
    'planningProjectId': string;
    'updatedAt': string;
}
export interface PlanningProjectDepartmentTreeNodeView {
    'departmentCode': string;
    'departmentId': string;
    'departmentName': string;
    'departmentPlanningProjectProgress': PlanningProjectDepartmentTreeNodeViewDepartmentPlanningProjectProgressEnum;
    'isOwnValue': boolean;
    'isSelectable': boolean;
    'level': number;
    'parentDepartmentId'?: string;
    'submissions': number;
    'submittedPlanUpdateRequests': Array<PlanUpdateRequestMetaView>;
}

export const PlanningProjectDepartmentTreeNodeViewDepartmentPlanningProjectProgressEnum = {
    InReview: 'IN_REVIEW',
    Done: 'DONE',
    NotSubmitted: 'NOT_SUBMITTED',
} as const;

export type PlanningProjectDepartmentTreeNodeViewDepartmentPlanningProjectProgressEnum = typeof PlanningProjectDepartmentTreeNodeViewDepartmentPlanningProjectProgressEnum[keyof typeof PlanningProjectDepartmentTreeNodeViewDepartmentPlanningProjectProgressEnum];

export interface PlanningProjectListView {
    'limit'?: number;
    'list': Array<PlanningProjectMetaView>;
    'offset': number;
    'total': number;
}
export interface PlanningProjectMetaView {
    'accountTreeId': string;
    'organizationTreeId': string;
    'planEnd': string;
    'planMasterId': string;
    'planMasterName': string;
    'planStart': string;
    'planningProjectEndAt'?: string;
    'planningProjectId': string;
    'planningProjectName': string;
    'planningProjectStartAt': string;
    'projectStatus': PlanningProjectMetaViewProjectStatusEnum;
    'scheduledPlanningProjectEndAt': string;
    'useMultiStepApprovalFlow': boolean;
}

export const PlanningProjectMetaViewProjectStatusEnum = {
    Creating: 'CREATING',
    CreateError: 'CREATE_ERROR',
    Wip: 'WIP',
    BulkApproving: 'BULK_APPROVING',
    Fixing: 'FIXING',
    Error: 'ERROR',
    Fixed: 'FIXED',
} as const;

export type PlanningProjectMetaViewProjectStatusEnum = typeof PlanningProjectMetaViewProjectStatusEnum[keyof typeof PlanningProjectMetaViewProjectStatusEnum];

export interface PlanningProjectNodeMetaView {
    'accountTreeId': string;
    'accountTreeName': string;
    'actualDownloadPeriodEnd'?: string;
    'actualDownloadPeriodStart'?: string;
    'actualEndWhenPlanningProject'?: string;
    'assignedDepartments': Array<DepartmentView>;
    'canActualDownload': boolean;
    'creationErrorMessage'?: string;
    'isArchived'?: boolean;
    'nonFinancialAccountTreeId': string;
    'nonFinancialAccountTreeName': string;
    'organizationTreeId': string;
    'organizationTreeName': string;
    'overview': PlanningProjectOverView;
    'planMasterId': string;
    'planMasterName': string;
    'planType': PlanningProjectNodeMetaViewPlanTypeEnum;
    'planningProjectDepartmentTreeNodeList': Array<PlanningProjectDepartmentTreeNodeView>;
    'planningProjectEndAt'?: string;
    'planningProjectId': string;
    'planningProjectName': string;
    'planningProjectStartAt': string;
    'planningTargetEnd': string;
    'planningTargetStart': string;
    'requirePlanMasterAllocatedItems': boolean;
    'roundingMode': PlanningProjectNodeMetaViewRoundingModeEnum;
    'scheduledPlanningProjectEndAt': string;
    'showDecimalPlacesIn': PlanningProjectNodeMetaViewShowDecimalPlacesInEnum;
    'showIn': PlanningProjectNodeMetaViewShowInEnum;
    'status': PlanningProjectNodeMetaViewStatusEnum;
    'useMultiStepApprovalFlow': boolean;
}

export const PlanningProjectNodeMetaViewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type PlanningProjectNodeMetaViewPlanTypeEnum = typeof PlanningProjectNodeMetaViewPlanTypeEnum[keyof typeof PlanningProjectNodeMetaViewPlanTypeEnum];
export const PlanningProjectNodeMetaViewRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type PlanningProjectNodeMetaViewRoundingModeEnum = typeof PlanningProjectNodeMetaViewRoundingModeEnum[keyof typeof PlanningProjectNodeMetaViewRoundingModeEnum];
export const PlanningProjectNodeMetaViewShowDecimalPlacesInEnum = {
    None: 'NONE',
    One: 'ONE',
    Two: 'TWO',
    Three: 'THREE',
    Four: 'FOUR',
} as const;

export type PlanningProjectNodeMetaViewShowDecimalPlacesInEnum = typeof PlanningProjectNodeMetaViewShowDecimalPlacesInEnum[keyof typeof PlanningProjectNodeMetaViewShowDecimalPlacesInEnum];
export const PlanningProjectNodeMetaViewShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type PlanningProjectNodeMetaViewShowInEnum = typeof PlanningProjectNodeMetaViewShowInEnum[keyof typeof PlanningProjectNodeMetaViewShowInEnum];
export const PlanningProjectNodeMetaViewStatusEnum = {
    Creating: 'CREATING',
    CreateError: 'CREATE_ERROR',
    Wip: 'WIP',
    BulkApproving: 'BULK_APPROVING',
    Fixing: 'FIXING',
    Error: 'ERROR',
    Fixed: 'FIXED',
} as const;

export type PlanningProjectNodeMetaViewStatusEnum = typeof PlanningProjectNodeMetaViewStatusEnum[keyof typeof PlanningProjectNodeMetaViewStatusEnum];

export interface PlanningProjectOverView {
    'allAssignedDepartmentsCount': number;
    'finishedPlanningDepartmentsCount': number;
    'notSubmittedDepartmentsCount': number;
}
export interface PlanningProjectView {
    'meta': PlanningProjectNodeMetaView;
}
export interface PlanningProjectWithPlanSheetsView {
    'planSheets': Array<PlanSheetSummaryView>;
    'planningProjectId': string;
    'planningProjectName': string;
}
export interface PreviewHighlightData {
    'columnIndexes': Array<number>;
    'rowIndexes': Array<number>;
}
export interface ProcessConditionDataParams {
    'conditionType': string;
    'conditionValue'?: string;
    'number': string;
}
export interface ProcessInsertSettingParams {
    'columns': Array<string>;
    'rows': Array<string>;
}
export interface ProcessOperationDataParams {
    'calculateAction'?: CalculateActionParams;
    'replaceAction'?: ReplaceActionParams;
    'splitAction'?: SplitActionParams;
    'variableName'?: string;
}
export interface ProcessSettingParams {
    'insertSetting': ProcessInsertSettingParams;
    'name': string;
    'transformSettings': Array<ProcessTransformSettingParams>;
}
export interface ProcessSettingPreview {
    'data': ProcessSettingPreviewData;
    'highlightData': PreviewHighlightData;
}
export interface ProcessSettingPreviewData {
    'rows': Array<Array<string>>;
}
export interface ProcessSettingView {
    'id': IDImpl;
    'name': string;
    'updatedAt': string;
}
export interface ProcessTransformParams {
    'conditions': Array<ProcessConditionDataParams>;
    'matchingType': ProcessTransformParamsMatchingTypeEnum;
    'operations': Array<ProcessOperationDataParams>;
}

export const ProcessTransformParamsMatchingTypeEnum = {
    And: 'AND',
    Or: 'OR',
} as const;

export type ProcessTransformParamsMatchingTypeEnum = typeof ProcessTransformParamsMatchingTypeEnum[keyof typeof ProcessTransformParamsMatchingTypeEnum];

export interface ProcessTransformSettingParams {
    'notes'?: string;
    'number': string;
    'targetRowColumnType': ProcessTransformSettingParamsTargetRowColumnTypeEnum;
    'transforms': Array<ProcessTransformParams>;
    'unConditionalTransform'?: ProcessUnConditonalTransformParams;
}

export const ProcessTransformSettingParamsTargetRowColumnTypeEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
} as const;

export type ProcessTransformSettingParamsTargetRowColumnTypeEnum = typeof ProcessTransformSettingParamsTargetRowColumnTypeEnum[keyof typeof ProcessTransformSettingParamsTargetRowColumnTypeEnum];

export interface ProcessUnConditonalTransformParams {
    'operations': Array<ProcessOperationDataParams>;
}
export interface PutNonFinancialAccountTreeNameBody {
    'newName': string;
}
export interface RatioPatternBody {
    'ratioString': string;
    'targetAccountId': string;
}
export interface RatioPatternView {
    'ratioString': string;
    'targetAccountId': string;
    'targetAccountName': string;
}
export interface RealValuePatternBody {
    'realValueString': string;
    'targetAccountId': string;
}
export interface RealValuePatternView {
    'realValueString': string;
    'targetAccountId': string;
    'targetAccountName': string;
}
export interface Relative {
    'actualPeriod'?: RelativeActualPeriodEnum;
    'aggregationPeriod': RelativeAggregationPeriodEnum;
}

export const RelativeActualPeriodEnum = {
    CurrentMonth: 'CURRENT_MONTH',
    PreviousMonth: 'PREVIOUS_MONTH',
    TwoMonthsAgo: 'TWO_MONTHS_AGO',
    SameMonthPreviousYear: 'SAME_MONTH_PREVIOUS_YEAR',
    PreviousMonthPreviousYear: 'PREVIOUS_MONTH_PREVIOUS_YEAR',
    TwoMonthsAgoPreviousYear: 'TWO_MONTHS_AGO_PREVIOUS_YEAR',
    SameMonthTwoYearsAgo: 'SAME_MONTH_TWO_YEARS_AGO',
    PreviousMonthTwoYearsAgo: 'PREVIOUS_MONTH_TWO_YEARS_AGO',
    TwoMonthsAgoTwoYearsAgo: 'TWO_MONTHS_AGO_TWO_YEARS_AGO',
    CurrentFiscalYear: 'CURRENT_FISCAL_YEAR',
    LastFiscalYear: 'LAST_FISCAL_YEAR',
    TwoFiscalYearsAgo: 'TWO_FISCAL_YEARS_AGO',
    UpToCurrentMonth: 'UP_TO_CURRENT_MONTH',
    UpToPreviousMonth: 'UP_TO_PREVIOUS_MONTH',
    UpToTwoMonthsAgo: 'UP_TO_TWO_MONTHS_AGO',
    UpToSameMonthPreviousYear: 'UP_TO_SAME_MONTH_PREVIOUS_YEAR',
    UpToPreviousMonthPreviousYear: 'UP_TO_PREVIOUS_MONTH_PREVIOUS_YEAR',
    UpToTwoMonthsAgoPreviousYear: 'UP_TO_TWO_MONTHS_AGO_PREVIOUS_YEAR',
    UpToSameMonthTwoYearsAgo: 'UP_TO_SAME_MONTH_TWO_YEARS_AGO',
    UpToPreviousMonthTwoYearsAgo: 'UP_TO_PREVIOUS_MONTH_TWO_YEARS_AGO',
    UpToTwoMonthsAgoTwoYearsAgo: 'UP_TO_TWO_MONTHS_AGO_TWO_YEARS_AGO',
    Last12Months: 'LAST_12_MONTHS',
} as const;

export type RelativeActualPeriodEnum = typeof RelativeActualPeriodEnum[keyof typeof RelativeActualPeriodEnum];
export const RelativeAggregationPeriodEnum = {
    CurrentMonth: 'CURRENT_MONTH',
    PreviousMonth: 'PREVIOUS_MONTH',
    TwoMonthsAgo: 'TWO_MONTHS_AGO',
    SameMonthPreviousYear: 'SAME_MONTH_PREVIOUS_YEAR',
    PreviousMonthPreviousYear: 'PREVIOUS_MONTH_PREVIOUS_YEAR',
    TwoMonthsAgoPreviousYear: 'TWO_MONTHS_AGO_PREVIOUS_YEAR',
    SameMonthTwoYearsAgo: 'SAME_MONTH_TWO_YEARS_AGO',
    PreviousMonthTwoYearsAgo: 'PREVIOUS_MONTH_TWO_YEARS_AGO',
    TwoMonthsAgoTwoYearsAgo: 'TWO_MONTHS_AGO_TWO_YEARS_AGO',
    CurrentFiscalYear: 'CURRENT_FISCAL_YEAR',
    LastFiscalYear: 'LAST_FISCAL_YEAR',
    TwoFiscalYearsAgo: 'TWO_FISCAL_YEARS_AGO',
    UpToCurrentMonth: 'UP_TO_CURRENT_MONTH',
    UpToPreviousMonth: 'UP_TO_PREVIOUS_MONTH',
    UpToTwoMonthsAgo: 'UP_TO_TWO_MONTHS_AGO',
    UpToSameMonthPreviousYear: 'UP_TO_SAME_MONTH_PREVIOUS_YEAR',
    UpToPreviousMonthPreviousYear: 'UP_TO_PREVIOUS_MONTH_PREVIOUS_YEAR',
    UpToTwoMonthsAgoPreviousYear: 'UP_TO_TWO_MONTHS_AGO_PREVIOUS_YEAR',
    UpToSameMonthTwoYearsAgo: 'UP_TO_SAME_MONTH_TWO_YEARS_AGO',
    UpToPreviousMonthTwoYearsAgo: 'UP_TO_PREVIOUS_MONTH_TWO_YEARS_AGO',
    UpToTwoMonthsAgoTwoYearsAgo: 'UP_TO_TWO_MONTHS_AGO_TWO_YEARS_AGO',
    Last12Months: 'LAST_12_MONTHS',
} as const;

export type RelativeAggregationPeriodEnum = typeof RelativeAggregationPeriodEnum[keyof typeof RelativeAggregationPeriodEnum];

export interface RemainingCountByYearMonth {
    'remainingCount': number;
    'yearMonth': string;
}
export interface RenameDashboardFolderBody {
    'name': string;
}
export interface RenameFinancialSimulationFolderBody {
    'name': string;
}
export interface RenamePermissionGroupNameBody {
    'name': string;
}
export interface RenameReportFolderBody {
    'name': string;
}
export interface RenameWorkforceSlotUnitAmountTableBody {
    'name': string;
}
export interface ReorderBoardsRequestBody {
    'boardIds': Array<string>;
}
export interface ReorderGraphsRequestBody {
    'graphIds': Array<string>;
    'reportId': string;
}
export interface ReorderLocalCurrencyRequestParam {
    'currencyLocalIds': Array<string>;
}
export interface ReplaceActionParams {
    'format': string;
}
export interface ReplaceRootNodeRequestBody {
    'newRootAccountId': string;
}
export interface ReplaceWorkforceActualBody {
    'endDate'?: string;
    'events': Array<ReplaceWorkforceActualEventBody>;
    'firstName': string;
    'lastName': string;
    'leaveOfAbsencePeriods': Array<ReplaceWorkforceActualLeaveOfAbsencePeriodBody>;
    'personCode': string;
    'startDate': string;
    'started': ReplaceWorkforceActualStartedBody;
}
export interface ReplaceWorkforceActualDimensionTagBody {
    'dimensionId': string;
    'dimensionTagId': string;
}
export interface ReplaceWorkforceActualEventBody {
    'details': Array<ReplaceWorkforceActualEventDetailBody>;
    'yearMonth': string;
}
export interface ReplaceWorkforceActualEventDetailBody {
    'departmentId'?: string;
    'dimensionId'?: string;
    'dimensionTagId'?: string;
    'eventType': ReplaceWorkforceActualEventDetailBodyEventTypeEnum;
}

export const ReplaceWorkforceActualEventDetailBodyEventTypeEnum = {
    DepartmentChanged: 'DEPARTMENT_CHANGED',
    DimensionTagChanged: 'DIMENSION_TAG_CHANGED',
} as const;

export type ReplaceWorkforceActualEventDetailBodyEventTypeEnum = typeof ReplaceWorkforceActualEventDetailBodyEventTypeEnum[keyof typeof ReplaceWorkforceActualEventDetailBodyEventTypeEnum];

export interface ReplaceWorkforceActualLeaveOfAbsencePeriodBody {
    'leaveYearMonth': string;
    'returnYearMonth'?: string;
}
export interface ReplaceWorkforceActualStartedBody {
    'departmentId': string;
    'dimensionIdToTagIds': Array<ReplaceWorkforceActualDimensionTagBody>;
}
export interface ReplyToReportCommentThreadRequestBody {
    'commentText': string;
}
export interface ReplyToReportCommentThreadView {
    'cellCommentId': string;
    'commentId': string;
    'threadId': string;
}
export interface ReportBriefDataConditionView {
    'accountTreeId': string;
    'allocationPatternId'?: string;
    'dataConditionId': string;
    'nonFinancialAccountTreeId'?: string;
    'orgTreeId': string;
    'period': ReportBriefPeriodView;
    'planId'?: ReportBriefPlanIdView;
    'requireAllocatedItem': boolean;
    'showActual': boolean;
}
export interface ReportBriefDimensionView {
    'dimensionTreeId'?: string;
    'dimensionType': string;
    'visibleCount': number;
}
export interface ReportBriefPeriodView {
    'end': string;
    'start': string;
}
export interface ReportBriefPlanIdView {
    'id': string;
    'type': string;
}
export interface ReportBriefView {
    'columnAggregationDimension': ReportBriefDimensionView;
    'dataConditions': Array<ReportBriefDataConditionView>;
    'description'?: string;
    'id': string;
    'name': string;
    'rowAggregationDimensions': Array<ReportBriefDimensionView>;
}
export interface ReportCellCommentAuthorView {
    'displayName': string;
    'isDeleted': boolean;
    'userId': string;
}
export interface ReportCellCommentPermissionsView {
    'canDelete': boolean;
    'canEdit': boolean;
}
export interface ReportCellCommentView {
    'author': ReportCellCommentAuthorView;
    'cellCommentId': string;
    'commentId': string;
    'commentText': string;
    'createdAt': string;
    'permissions': ReportCellCommentPermissionsView;
    'updatedAt': string;
}
export interface ReportCellKey {
    'columnIndicator': ReportCellKeyColumnIndicator;
    'columnItem': ReportCellKeyColumnItem;
    'rowItems': Array<ReportCellKeyRowItem>;
    'rowType': ReportCellKeyRowTypeEnum;
}

export const ReportCellKeyRowTypeEnum = {
    Single: 'SINGLE',
    Cumulative: 'CUMULATIVE',
} as const;

export type ReportCellKeyRowTypeEnum = typeof ReportCellKeyRowTypeEnum[keyof typeof ReportCellKeyRowTypeEnum];

export interface ReportCellKeyColumnIndicator {
    'comparisonExpression'?: string;
    'dataConditionId'?: ReportCellKeyColumnIndicatorDataConditionIdEnum;
    'type': ReportCellKeyColumnIndicatorTypeEnum;
}

export const ReportCellKeyColumnIndicatorDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type ReportCellKeyColumnIndicatorDataConditionIdEnum = typeof ReportCellKeyColumnIndicatorDataConditionIdEnum[keyof typeof ReportCellKeyColumnIndicatorDataConditionIdEnum];
export const ReportCellKeyColumnIndicatorTypeEnum = {
    DataCondition: 'DATA_CONDITION',
    Comparison: 'COMPARISON',
} as const;

export type ReportCellKeyColumnIndicatorTypeEnum = typeof ReportCellKeyColumnIndicatorTypeEnum[keyof typeof ReportCellKeyColumnIndicatorTypeEnum];

export interface ReportCellKeyColumnItem {
    'dimensionType': ReportCellKeyColumnItemDimensionTypeEnum;
    'id': string;
}

export const ReportCellKeyColumnItemDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Period: 'PERIOD',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type ReportCellKeyColumnItemDimensionTypeEnum = typeof ReportCellKeyColumnItemDimensionTypeEnum[keyof typeof ReportCellKeyColumnItemDimensionTypeEnum];

export interface ReportCellKeyRowItem {
    'dimensionType': ReportCellKeyRowItemDimensionTypeEnum;
    'id': string;
}

export const ReportCellKeyRowItemDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type ReportCellKeyRowItemDimensionTypeEnum = typeof ReportCellKeyRowItemDimensionTypeEnum[keyof typeof ReportCellKeyRowItemDimensionTypeEnum];


export const ReportCellType = {
    Data: 'DATA',
    Comparison: 'COMPARISON',
} as const;

export type ReportCellType = typeof ReportCellType[keyof typeof ReportCellType];


export interface ReportComboGraphConfig {
    'barConfig': ComboBarConfig;
    'legendPosition'?: ReportComboGraphConfigLegendPositionEnum;
    'lineConfig': ComboLineConfig;
    'visibleColumnTagIds'?: Array<Array<string>>;
}

export const ReportComboGraphConfigLegendPositionEnum = {
    Right: 'RIGHT',
    Left: 'LEFT',
    Top: 'TOP',
    Bottom: 'BOTTOM',
    Hidden: 'HIDDEN',
} as const;

export type ReportComboGraphConfigLegendPositionEnum = typeof ReportComboGraphConfigLegendPositionEnum[keyof typeof ReportComboGraphConfigLegendPositionEnum];

export interface ReportCommentCellLabelView {
    'line1': string;
    'line2': string;
    'line3': string;
}
export interface ReportCommentThreadView {
    'allowed': ReportCommentThreadViewAllowedEnum;
    'allowedUserIds': Array<string>;
    'canChangeVisibility': boolean;
    'comments': Array<ReportCellCommentView>;
    'createdAt': string;
    'sortOrder': number;
    'threadId': string;
    'updatedAt': string;
}

export const ReportCommentThreadViewAllowedEnum = {
    All: 'ALL',
    Restricted: 'RESTRICTED',
} as const;

export type ReportCommentThreadViewAllowedEnum = typeof ReportCommentThreadViewAllowedEnum[keyof typeof ReportCommentThreadViewAllowedEnum];

export interface ReportCommentTooltipView {
    'lines': Array<string>;
}
export interface ReportCommentView {
    'cellKeys': Array<ReportCellKey>;
    'cellLabel': ReportCommentCellLabelView;
    'commentId': string;
    'createdAt': string;
    'hidden': boolean;
    'reportId': string;
    'threads': Array<ReportCommentThreadView>;
    'tooltip': ReportCommentTooltipView;
    'updatedAt': string;
}
export interface ReportCommentVisibilitySelectableUserView {
    'mailAddress': string;
    'userFullName': string;
    'userId': string;
}
export interface ReportConditionSchema {
    'cellGroupOrders': Array<CellGroupOrder>;
    'columnAggregationDimension': ColumnAggregationDimension;
    'comparisonConditions': Array<ComparisonCondition>;
    'currencyCode': string;
    'dataConditions': Array<DataCondition>;
    'isShowEmptyRows': boolean;
    'isTreeView': boolean;
    'rowAggregationDimensions': Array<RowAggregationDimension>;
    'showCumulativeRow'?: boolean;
    'showNumbersIn': ReportConditionSchemaShowNumbersInEnum;
    'showSumRow': boolean;
    'sortCondition'?: SortCondition;
}

export const ReportConditionSchemaShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type ReportConditionSchemaShowNumbersInEnum = typeof ReportConditionSchemaShowNumbersInEnum[keyof typeof ReportConditionSchemaShowNumbersInEnum];

export interface ReportDashboardUsagesView {
    'report': ReportUsageView;
    'views': Array<ReportGraphUsageView>;
}
export interface ReportDescriptionView {
    'content': string;
    'createdDate': string;
    'lastUpdatedDate': string;
    'reportId': string;
}
export interface ReportDisplaySettings {
    'accountLabelOverrides': Array<AccountLabelOverride>;
    'columnHeaderLabelOverrides': Array<ColumnHeaderLabelOverride>;
    'comparisonLabelOverrides': Array<ComparisonLabelOverride>;
    'dataConditionLabelOverrides': Array<DataConditionLabelOverride>;
    'departmentLabelOverrides': Array<DepartmentLabelOverride>;
    'dimensionLabelOverrides': Array<DimensionLabelOverrides>;
    'reportId': string;
}
export interface ReportDisplaySettingsRequestBody {
    'accountLabelOverrides': Array<AccountLabelOverride>;
    'columnHeaderLabelOverrides': Array<ColumnHeaderLabelOverride>;
    'comparisonLabelOverrides': Array<ComparisonLabelOverride>;
    'dataConditionLabelOverrides': Array<DataConditionLabelOverride>;
    'departmentLabelOverrides': Array<DepartmentLabelOverride>;
    'dimensionLabelOverrides': Array<DimensionLabelOverrides>;
    'reportId': string;
}
export interface ReportFolderDetailView {
    'currentFolder'?: ReportFolderInfo;
    'items': Array<ReportFolderItem>;
    'maxReportLimit': number;
    'paths': Array<ReportFolderInfo>;
    'totalReportCount': number;
}
export interface ReportFolderInfo {
    'id': string;
    'name': string;
}
export interface ReportFolderItem {
    'canDelete': boolean;
    'canRename': boolean;
    'canSave': boolean;
    'createdAt'?: string;
    'id': string;
    'isEditRestricted'?: boolean;
    'itemType': ReportFolderItemItemTypeEnum;
    'lastUpdatedAt'?: string;
    'lastUpdatedUserName': string;
    'name': string;
    'parentFolderInfo'?: ReportFolderInfo;
    'reportType'?: ReportFolderItemReportTypeEnum;
}

export const ReportFolderItemItemTypeEnum = {
    Folder: 'FOLDER',
    NormalReport: 'NORMAL_REPORT',
} as const;

export type ReportFolderItemItemTypeEnum = typeof ReportFolderItemItemTypeEnum[keyof typeof ReportFolderItemItemTypeEnum];
export const ReportFolderItemReportTypeEnum = {
    Pl: 'PL',
    Bs: 'BS',
    Cf: 'CF',
} as const;

export type ReportFolderItemReportTypeEnum = typeof ReportFolderItemReportTypeEnum[keyof typeof ReportFolderItemReportTypeEnum];

export interface ReportFolderTreeForSelectionView {
    'rootNodes': Array<TreeNodeReportFolderTreeNode>;
    'totalCount': number;
}
export interface ReportFolderTreeNode {
    'id': string;
    'isSelectable': boolean;
    'name': string;
    'parentId'?: string;
}
export interface ReportGraphConfig {
    'colorPalettes'?: { [key: string]: string; };
    'legendPosition'?: ReportGraphConfigLegendPositionEnum;
    'showAsBreakdown': boolean;
    'showCumulativeRow': boolean;
    'showDataLabels': boolean;
    'showStackTotalLabels': boolean;
    'stackingMode': ReportGraphConfigStackingModeEnum;
    'visibleColumnTagIds'?: Array<Array<string>>;
    'visibleMetrics': Array<ReportGraphConfigVisibleMetricsEnum>;
    'visibleRowTagIds': Array<Array<string>>;
    'yaxisLabel': string;
    'yaxisMax'?: number;
    'yaxisMin'?: number;
}

export const ReportGraphConfigLegendPositionEnum = {
    Right: 'RIGHT',
    Left: 'LEFT',
    Top: 'TOP',
    Bottom: 'BOTTOM',
    Hidden: 'HIDDEN',
} as const;

export type ReportGraphConfigLegendPositionEnum = typeof ReportGraphConfigLegendPositionEnum[keyof typeof ReportGraphConfigLegendPositionEnum];
export const ReportGraphConfigStackingModeEnum = {
    None: 'NONE',
    Normal: 'NORMAL',
    Percent: 'PERCENT',
} as const;

export type ReportGraphConfigStackingModeEnum = typeof ReportGraphConfigStackingModeEnum[keyof typeof ReportGraphConfigStackingModeEnum];
export const ReportGraphConfigVisibleMetricsEnum = {
    DataA: 'DATA_A',
    DataB: 'DATA_B',
    DataC: 'DATA_C',
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type ReportGraphConfigVisibleMetricsEnum = typeof ReportGraphConfigVisibleMetricsEnum[keyof typeof ReportGraphConfigVisibleMetricsEnum];

export interface ReportGraphUsageView {
    'boards': Array<BoardUsageView>;
    'graphType': ReportGraphUsageViewGraphTypeEnum;
    'reportGraphId': string;
    'title': string;
}

export const ReportGraphUsageViewGraphTypeEnum = {
    Bar: 'BAR',
    HorizontalBar: 'HORIZONTAL_BAR',
    Line: 'LINE',
    Kpi: 'KPI',
    Combo: 'COMBO',
    Waterfall: 'WATERFALL',
    Pie: 'PIE',
} as const;

export type ReportGraphUsageViewGraphTypeEnum = typeof ReportGraphUsageViewGraphTypeEnum[keyof typeof ReportGraphUsageViewGraphTypeEnum];

export interface ReportGraphView {
    'config': CreateGraphRequestBodyConfig;
    'createdAt': string;
    'createdUserName': string;
    'graphType': ReportGraphViewGraphTypeEnum;
    'reportGraphId': string;
    'reportId': string;
    'reportName': string;
    'reportType': ReportGraphViewReportTypeEnum;
    'title': string;
    'updatedAt': string;
    'updatedUserName': string;
    'viewFilterConditions': Array<DimensionFilter>;
}

export const ReportGraphViewGraphTypeEnum = {
    Bar: 'BAR',
    HorizontalBar: 'HORIZONTAL_BAR',
    Line: 'LINE',
    Kpi: 'KPI',
    Combo: 'COMBO',
    Waterfall: 'WATERFALL',
    Pie: 'PIE',
} as const;

export type ReportGraphViewGraphTypeEnum = typeof ReportGraphViewGraphTypeEnum[keyof typeof ReportGraphViewGraphTypeEnum];
export const ReportGraphViewReportTypeEnum = {
    Pl: 'PL',
    Bs: 'BS',
    Cf: 'CF',
} as const;

export type ReportGraphViewReportTypeEnum = typeof ReportGraphViewReportTypeEnum[keyof typeof ReportGraphViewReportTypeEnum];

export interface ReportListView {
    'reports': Array<ReportSummaryView>;
}
export interface ReportSummaryView {
    'id': string;
    'name': string;
    'type': ReportSummaryViewTypeEnum;
}

export const ReportSummaryViewTypeEnum = {
    Pl: 'PL',
    Bs: 'BS',
    Cf: 'CF',
} as const;

export type ReportSummaryViewTypeEnum = typeof ReportSummaryViewTypeEnum[keyof typeof ReportSummaryViewTypeEnum];

export interface ReportTableCellCondition {
    'dimensionConditions': Array<CellDimensionCondition>;
    'isCumulative': boolean;
}
export interface ReportTableDetailHeaderDimensionView {
    'name': string;
    'sortKey': ReportTableDetailHeaderDimensionViewSortKeyEnum;
}

export const ReportTableDetailHeaderDimensionViewSortKeyEnum = {
    JournalDate: 'JOURNAL_DATE',
    DepartmentName: 'DEPARTMENT_NAME',
    AccountName: 'ACCOUNT_NAME',
    Description: 'DESCRIPTION',
    Amount: 'AMOUNT',
    Dimension1Name: 'DIMENSION_1_NAME',
    Dimension2Name: 'DIMENSION_2_NAME',
    Dimension3Name: 'DIMENSION_3_NAME',
    Dimension4Name: 'DIMENSION_4_NAME',
    Dimension5Name: 'DIMENSION_5_NAME',
    Dimension6Name: 'DIMENSION_6_NAME',
    Dimension7Name: 'DIMENSION_7_NAME',
} as const;

export type ReportTableDetailHeaderDimensionViewSortKeyEnum = typeof ReportTableDetailHeaderDimensionViewSortKeyEnum[keyof typeof ReportTableDetailHeaderDimensionViewSortKeyEnum];

export interface ReportTableDetailHeaderView {
    'amountColumnName': string;
    'dimensions': Array<ReportTableDetailHeaderDimensionView>;
}
export interface ReportTableDetailRowView {
    'account': string;
    'amount': string;
    'department': string;
    'description': string;
    'dimensionTagNames': Array<string>;
    'journalDate': string;
}
export interface ReportTableKeyItem {
    'dimensionTreeId'?: string;
    'dimensionType': ReportTableKeyItemDimensionTypeEnum;
    'id': string;
    'periodAggregation'?: ReportTableKeyItemPeriodAggregationEnum;
}

export const ReportTableKeyItemDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION1',
    Dimension2: 'DIMENSION2',
    Dimension3: 'DIMENSION3',
    Dimension4: 'DIMENSION4',
    Dimension5: 'DIMENSION5',
    Dimension6: 'DIMENSION6',
    Dimension7: 'DIMENSION7',
    Period: 'PERIOD',
} as const;

export type ReportTableKeyItemDimensionTypeEnum = typeof ReportTableKeyItemDimensionTypeEnum[keyof typeof ReportTableKeyItemDimensionTypeEnum];
export const ReportTableKeyItemPeriodAggregationEnum = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    FiscalYear: 'FISCAL_YEAR',
    FiscalHalfYear: 'FISCAL_HALF_YEAR',
} as const;

export type ReportTableKeyItemPeriodAggregationEnum = typeof ReportTableKeyItemPeriodAggregationEnum[keyof typeof ReportTableKeyItemPeriodAggregationEnum];

export interface ReportTableMetadataView {
    'appliedCondition': GetReportTableViewAppliedCondition;
    'isTreeView': boolean;
    'meta': MetaView;
}
export interface ReportTableView {
    'meta': MetaView;
    'rows': Array<RowView>;
}
export interface ReportTreeTableView {
    'meta': MetaView;
    'rootRowTreeNodes': Array<MutableTreeNode>;
}
export interface ReportUsageView {
    'boards': Array<BoardUsageView>;
    'reportId': string;
}
export interface ReportView {
    'canDelete': boolean;
    'canEditAllow': boolean;
    'canEditRestrict': boolean;
    'canRename': boolean;
    'canSave': boolean;
    'condition'?: GetReportTableViewAppliedCondition;
    'createUserName': string;
    'createdAt': string;
    'folderId'?: string;
    'id': string;
    'isEditRestricted': boolean;
    'lastUpdateUserName': string;
    'lastUpdatedAt': string;
    'name': string;
    'version': number;
}
export interface ReuseSheetsParam {
    'sheetIds': Array<string>;
}
export interface RowAggregationDimension {
    'dimensionTreeId'?: string;
    'dimensionType': RowAggregationDimensionDimensionTypeEnum;
    'showSubtotal'?: boolean;
    'visibleIds': Array<string>;
}

export const RowAggregationDimensionDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type RowAggregationDimensionDimensionTypeEnum = typeof RowAggregationDimensionDimensionTypeEnum[keyof typeof RowAggregationDimensionDimensionTypeEnum];

export interface RowAggregationKeyMetaView {
    'label': string;
}
export interface RowAggregationKeyView {
    'id': string;
    'label'?: string;
    'rowAggregationKeyType'?: RowAggregationKeyViewRowAggregationKeyTypeEnum;
}

export const RowAggregationKeyViewRowAggregationKeyTypeEnum = {
    AggregatedAccount: 'AGGREGATED_ACCOUNT',
    CalculatedAccount: 'CALCULATED_ACCOUNT',
    AccountGroup: 'ACCOUNT_GROUP',
} as const;

export type RowAggregationKeyViewRowAggregationKeyTypeEnum = typeof RowAggregationKeyViewRowAggregationKeyTypeEnum[keyof typeof RowAggregationKeyViewRowAggregationKeyTypeEnum];

export interface RowInfo {
    'periodKey': string;
    'type': RowInfoTypeEnum;
}

export const RowInfoTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
    Actual: 'ACTUAL',
    None: 'NONE',
} as const;

export type RowInfoTypeEnum = typeof RowInfoTypeEnum[keyof typeof RowInfoTypeEnum];

export interface RowView {
    'cellGroups': Array<CellGroupView>;
    'isCumulative': boolean;
    'rowAggregationKeys': Array<RowAggregationKeyView>;
    'sumCellGroup'?: SumCellGroupView;
}
export interface RowViewForTree {
    'cellGroups': Array<CellGroupView>;
    'level': number;
    'rowAggregationKeys': Array<RowAggregationKeyView>;
    'sumCellGroup'?: SumCellGroupView;
}
export interface RuleDetailDto {
    'dataSource': DataSourceDto;
    'id': string;
    'name': string;
    'steps': Array<StepListItemDto>;
}
export interface RuleForSelectView {
    'id': string;
    'name': string;
}
export interface RuleSummary {
    'dataSource'?: DataSource;
    'id': string;
    'name': string;
    'stepCount': number;
}
export interface RuleUpdateView {
    'id': string;
}
export interface SalesAccountView {
    'code': string;
    'id': string;
    'name': string;
}
/**
 * Same as account format
 */
export interface SameToAccountFormatDto {
    /**
     * Rounding precision
     */
    'roundingPrecision': string;
    /**
     * Value format
     */
    'valueFormat': SameToAccountFormatDtoValueFormatEnum;
}

export const SameToAccountFormatDtoValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type SameToAccountFormatDtoValueFormatEnum = typeof SameToAccountFormatDtoValueFormatEnum[keyof typeof SameToAccountFormatDtoValueFormatEnum];

export interface SanitizedAllocationAxisCondition {
    'axisId'?: string;
    'dest': SanitizedAxisTagsWithTree;
    'src': SanitizedAxisTagsWithTree;
}
export interface SanitizedAllocationStepRequestBody {
    'allocationAxisCondition': AllocationAxisCondition;
    'description'?: string;
    'destinationAccount'?: DestinationAccount;
    'filterConditions': Array<FilterCondition>;
    'loopCondition'?: LoopCondition;
    'name': string;
    'sourceAccounts': SourceAccounts;
    'standardAccounts'?: StandardAccounts;
}
export interface SanitizedAxisTagsWithTree {
    'tagIds': Array<IdWithReferenceType>;
    'treeId'?: string;
}
export interface SanitizedDestinationAccount {
    'account'?: IdWithReferenceType;
    'treeId'?: string;
}
export interface SanitizedDestinationAccountCondition {
    'id'?: string;
    'treeId'?: string;
}
export interface SanitizedDestinationAxisCondition {
    'axisId': string;
    'axisTagId'?: string;
    'axisTreeId'?: string;
}
export interface SanitizedFilterCondition {
    'axisId': string;
    'axisTagId'?: IdWithReferenceType;
    'axisTreeId'?: string;
}
export interface SanitizedLoopCondition {
    'axisId'?: string;
    'axisTagIds': Array<IdWithReferenceType>;
    'axisTreeId'?: string;
}
export interface SanitizedSourceAccounts {
    'ids': Array<IdWithReferenceType>;
    'treeId'?: string;
}
export interface SanitizedSourceAccountsCondition {
    'ids': Array<IdWithReferenceType>;
    'treeId'?: string;
}
export interface SanitizedSourceAxisCondition {
    'axisId': string;
    'axisTagIds': Array<IdWithReferenceType>;
    'axisTreeId'?: string;
}
export interface SanitizedStandardAccounts {
    'ids': Array<IdWithReferenceType>;
    'treeId'?: string;
}
export interface SanitizedTransferStepRequestBody {
    'description'?: string;
    'destinationAccountCondition'?: TransferSingleAccountCondition;
    'destinationAxisConditions'?: Array<TransferSingleAxisCondition>;
    'name': string;
    'sourceAccountCondition'?: TransferAccountCondition;
    'sourceAxisConditions'?: Array<TransferAxisCondition>;
}
export interface SaveAiChatCustomPromptParam {
    'companyContext': string;
    'reportTemplate': string;
}
export interface SaveFinancialSimulationScenarioRequestBody {
    'dimensionType': SaveFinancialSimulationScenarioRequestBodyDimensionTypeEnum;
    'rows': Array<FinancialSimulationReportRowRequest>;
}

export const SaveFinancialSimulationScenarioRequestBodyDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
    Period: 'PERIOD',
} as const;

export type SaveFinancialSimulationScenarioRequestBodyDimensionTypeEnum = typeof SaveFinancialSimulationScenarioRequestBodyDimensionTypeEnum[keyof typeof SaveFinancialSimulationScenarioRequestBodyDimensionTypeEnum];

export interface SavePermissionGroupBody {
    'assignmentTargets': Array<string>;
    'name': string;
    'restrictedActions': Array<SavePermissionGroupBodyRestrictedActionsEnum>;
}

export const SavePermissionGroupBodyRestrictedActionsEnum = {
    CrudWorkforceActual: 'CRUD_WORKFORCE_ACTUAL',
    CrudUnitAmount: 'CRUD_UNIT_AMOUNT',
    ConnectWorkforceSlotToActual: 'CONNECT_WORKFORCE_SLOT_TO_ACTUAL',
} as const;

export type SavePermissionGroupBodyRestrictedActionsEnum = typeof SavePermissionGroupBodyRestrictedActionsEnum[keyof typeof SavePermissionGroupBodyRestrictedActionsEnum];

export interface ScenarioDetailView {
    'financialModelId': string;
    'financialModelName': string;
    'id': string;
    'name': string;
}
export interface ScenarioDto {
    'id': string;
    'name': string;
}
export interface SearchPersonListConditionBody {
    'filterCondition'?: PersonListFilterCondition;
    'searchWord'?: string;
    'sortKey'?: SearchPersonListConditionBodySortKeyEnum;
    'sortOrder'?: SearchPersonListConditionBodySortOrderEnum;
}

export const SearchPersonListConditionBodySortKeyEnum = {
    Code: 'CODE',
    StartDate: 'START_DATE',
    EndDate: 'END_DATE',
} as const;

export type SearchPersonListConditionBodySortKeyEnum = typeof SearchPersonListConditionBodySortKeyEnum[keyof typeof SearchPersonListConditionBodySortKeyEnum];
export const SearchPersonListConditionBodySortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;

export type SearchPersonListConditionBodySortOrderEnum = typeof SearchPersonListConditionBodySortOrderEnum[keyof typeof SearchPersonListConditionBodySortOrderEnum];

export interface SearchPersonListRequestBody {
    'condition'?: SearchPersonListConditionBody;
    'limit': number;
    'offset': number;
    'yearMonth': string;
}
export interface SearchPlanUpdateRequestFilesParams {
    'departmentIds': Array<string>;
    'fileName'?: string;
    'limit': number;
    'offset': number;
    'planId'?: string;
    'planningProjectId'?: string;
    'userNameOrEmail'?: string;
    'yearMonthRange'?: YearMonthRangeParams;
}
export interface SearchPlanUpdateRequestFormatsParams {
    'departmentIds'?: Array<string>;
    'limit': number;
    'name'?: string;
    'offset': number;
}
export interface SearchUnitAmountConditionBody {
    'filterCondition'?: UnitAmountListFilterCondition;
    'searchWord'?: string;
    'sortOrder'?: SearchUnitAmountConditionBodySortOrderEnum;
    'withoutUnitAmountOnly'?: boolean;
}

export const SearchUnitAmountConditionBodySortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;

export type SearchUnitAmountConditionBodySortOrderEnum = typeof SearchUnitAmountConditionBodySortOrderEnum[keyof typeof SearchUnitAmountConditionBodySortOrderEnum];

export interface SearchUnitAmountRequestBody {
    'condition'?: SearchUnitAmountConditionBody;
    'limit': number;
    'offset': number;
    'yearMonth': string;
}
export interface SelectedConditionDetail {
    'accountTreeId': IDImpl;
    'aggregate': SelectedConditionDetailAggregateEnum;
    'departmentIds': Array<IDImpl>;
    'highlightThreshold'?: number;
    'highlightType'?: SelectedConditionDetailHighlightTypeEnum;
    'organizationTreeId': IDImpl;
    'planAActualEndYearMonth'?: LoglassYearMonthData;
    'planAActualStartYearMonth'?: LoglassYearMonthData;
    'planAEndYearMonth': LoglassYearMonthData;
    'planAMasterId'?: IDImpl;
    'planAShowActual': boolean;
    'planAStartYearMonth': LoglassYearMonthData;
    'planAUpdateProjectId'?: IDImpl;
    'planBActualEndYearMonth'?: LoglassYearMonthData;
    'planBActualStartYearMonth'?: LoglassYearMonthData;
    'planBEndYearMonth': LoglassYearMonthData;
    'planBMasterId'?: IDImpl;
    'planBShowActual': boolean;
    'planBStartYearMonth': LoglassYearMonthData;
    'planBUpdateProjectId'?: IDImpl;
    'requireAllocatedItem': boolean;
}

export const SelectedConditionDetailAggregateEnum = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    FiscalYear: 'FISCAL_YEAR',
    FiscalHalfYear: 'FISCAL_HALF_YEAR',
} as const;

export type SelectedConditionDetailAggregateEnum = typeof SelectedConditionDetailAggregateEnum[keyof typeof SelectedConditionDetailAggregateEnum];
export const SelectedConditionDetailHighlightTypeEnum = {
    DiffAmount: 'DIFF_AMOUNT',
    DiffRatio: 'DIFF_RATIO',
} as const;

export type SelectedConditionDetailHighlightTypeEnum = typeof SelectedConditionDetailHighlightTypeEnum[keyof typeof SelectedConditionDetailHighlightTypeEnum];

export interface SeriesData {
    'chartData': Array<string>;
    'chartDataUnscaled': Array<string>;
    'chartDataUnscaledUnit': string;
    'chartPercentageData'?: Array<string>;
    'data': Array<string>;
    'displayData': Array<string>;
    'displayLabel': string;
    'id': string;
    'name': string;
    'rowDimensionConditions'?: Array<SeriesRowDimensionCondition>;
    'stackId': string;
    'tooltipContexts': Array<TooltipContext>;
    'uniqueKeys': Array<GraphUniqueKeyView>;
    'visibleMetric': string;
}
export interface SeriesLabelOverride {
    'comboSide'?: SeriesLabelOverrideComboSideEnum;
    'customLabel'?: string;
    'planId'?: string;
    'rowDimensionConditions': Array<SeriesRowDimensionCondition>;
    'showActual'?: boolean;
    'visibleMetric': string;
}

export const SeriesLabelOverrideComboSideEnum = {
    Bar: 'BAR',
    Line: 'LINE',
} as const;

export type SeriesLabelOverrideComboSideEnum = typeof SeriesLabelOverrideComboSideEnum[keyof typeof SeriesLabelOverrideComboSideEnum];

export interface SeriesRowDimensionCondition {
    'dimensionType': SeriesRowDimensionConditionDimensionTypeEnum;
    'id': string;
}

export const SeriesRowDimensionConditionDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION1',
    Dimension2: 'DIMENSION2',
    Dimension3: 'DIMENSION3',
    Dimension4: 'DIMENSION4',
    Dimension5: 'DIMENSION5',
    Dimension6: 'DIMENSION6',
    Dimension7: 'DIMENSION7',
} as const;

export type SeriesRowDimensionConditionDimensionTypeEnum = typeof SeriesRowDimensionConditionDimensionTypeEnum[keyof typeof SeriesRowDimensionConditionDimensionTypeEnum];

export interface SeriesStackTotal {
    'chartData': Array<string>;
    'chartDataUnscaled': Array<string>;
    'chartDataUnscaledUnit': string;
    'data': Array<string>;
    'displayData': Array<string>;
    'stackId': string;
}
export interface SettingsExcelSheetProtectionView {
    'excelSheetProtectionPasswordForPlanUpdateRequest'?: string;
}
export interface SettingsView {
    'accountingSystemCode': SettingsViewAccountingSystemCodeEnum;
    'activeEmailNotificationSources': Array<SettingsViewActiveEmailNotificationSourcesEnum>;
    'availableEmailNotificationSources': Array<SettingsViewAvailableEmailNotificationSourcesEnum>;
    'defaultDepartmentIdImportActual'?: string;
    'defaultDepartmentNameImportActual'?: string;
    'enableExcelSheetProtectionForPlanUpdateRequest': boolean;
    'enableMasterAutoGenerate': boolean;
    'firstViewPage': SettingsViewFirstViewPageEnum;
    'fiscalYearStartMonth': string;
    'hideAccountsIfEmptyOnPl': boolean;
    'isActiveEmailNotification': boolean;
    'limitPermissionToAddToNewSpreadsheet': boolean;
    'roundingMode': SettingsViewRoundingModeEnum;
    'showDecimalPlacesIn': SettingsViewShowDecimalPlacesInEnum;
    'showNumbersIn': SettingsViewShowNumbersInEnum;
    'tableauDashboardUrl'?: string;
    'tableauTargetAccountTreeId'?: string;
}

export const SettingsViewAccountingSystemCodeEnum = {
    Miroku: 'MIROKU',
    KanjoBugyo: 'KANJO_BUGYO',
    MoneyForward: 'MONEY_FORWARD',
    MoneyForwardPlus: 'MONEY_FORWARD_PLUS',
    Freee: 'FREEE',
    FreeeV2: 'FREEE_V2',
    Obic7: 'OBIC7',
    Yayoi: 'YAYOI',
    Sap: 'SAP',
    SapSalesReport: 'SAP_SALES_REPORT',
    Pca: 'PCA',
    NetSuite: 'NET_SUITE',
    Fx4: 'FX4',
    Fx5: 'FX5',
    BizIntegral: 'BIZ_INTEGRAL',
    Ai21: 'AI21',
    LoglassDepartments: 'LOGLASS_DEPARTMENTS',
    LoglassDetail: 'LOGLASS_DETAIL',
    SuperStream: 'SUPER_STREAM',
    LoglassJournal: 'LOGLASS_JOURNAL',
    Loglass: 'LOGLASS',
    Mapping: 'MAPPING',
    AccountConversion: 'ACCOUNT_CONVERSION',
} as const;

export type SettingsViewAccountingSystemCodeEnum = typeof SettingsViewAccountingSystemCodeEnum[keyof typeof SettingsViewAccountingSystemCodeEnum];
export const SettingsViewActiveEmailNotificationSourcesEnum = {
    PlanningProject: 'PLANNING_PROJECT',
    PlanUpdateRequest: 'PLAN_UPDATE_REQUEST',
    AllocationStandard: 'ALLOCATION_STANDARD',
    ReportComment: 'REPORT_COMMENT',
} as const;

export type SettingsViewActiveEmailNotificationSourcesEnum = typeof SettingsViewActiveEmailNotificationSourcesEnum[keyof typeof SettingsViewActiveEmailNotificationSourcesEnum];
export const SettingsViewAvailableEmailNotificationSourcesEnum = {
    PlanningProject: 'PLANNING_PROJECT',
    PlanUpdateRequest: 'PLAN_UPDATE_REQUEST',
    AllocationStandard: 'ALLOCATION_STANDARD',
    ReportComment: 'REPORT_COMMENT',
} as const;

export type SettingsViewAvailableEmailNotificationSourcesEnum = typeof SettingsViewAvailableEmailNotificationSourcesEnum[keyof typeof SettingsViewAvailableEmailNotificationSourcesEnum];
export const SettingsViewFirstViewPageEnum = {
    FinancialSheetHistory: 'FINANCIAL_SHEET_HISTORY',
    Reports: 'REPORTS',
} as const;

export type SettingsViewFirstViewPageEnum = typeof SettingsViewFirstViewPageEnum[keyof typeof SettingsViewFirstViewPageEnum];
export const SettingsViewRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type SettingsViewRoundingModeEnum = typeof SettingsViewRoundingModeEnum[keyof typeof SettingsViewRoundingModeEnum];
export const SettingsViewShowDecimalPlacesInEnum = {
    None: 'NONE',
    One: 'ONE',
    Two: 'TWO',
    Three: 'THREE',
    Four: 'FOUR',
} as const;

export type SettingsViewShowDecimalPlacesInEnum = typeof SettingsViewShowDecimalPlacesInEnum[keyof typeof SettingsViewShowDecimalPlacesInEnum];
export const SettingsViewShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type SettingsViewShowNumbersInEnum = typeof SettingsViewShowNumbersInEnum[keyof typeof SettingsViewShowNumbersInEnum];

export interface SheetCellGroupOrder {
    'key': string;
    'type': SheetCellGroupOrderTypeEnum;
}

export const SheetCellGroupOrderTypeEnum = {
    Data: 'DATA',
    Comparison: 'COMPARISON',
} as const;

export type SheetCellGroupOrderTypeEnum = typeof SheetCellGroupOrderTypeEnum[keyof typeof SheetCellGroupOrderTypeEnum];

export interface SheetColumnAggregationDimension {
    'dimensionTreeId'?: string;
    'dimensionType': SheetColumnAggregationDimensionDimensionTypeEnum;
    'periodAggregation'?: SheetColumnAggregationDimensionPeriodAggregationEnum;
    'visibleIds': Array<string>;
}

export const SheetColumnAggregationDimensionDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Period: 'PERIOD',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type SheetColumnAggregationDimensionDimensionTypeEnum = typeof SheetColumnAggregationDimensionDimensionTypeEnum[keyof typeof SheetColumnAggregationDimensionDimensionTypeEnum];
export const SheetColumnAggregationDimensionPeriodAggregationEnum = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    FiscalYear: 'FISCAL_YEAR',
    FiscalHalfYear: 'FISCAL_HALF_YEAR',
} as const;

export type SheetColumnAggregationDimensionPeriodAggregationEnum = typeof SheetColumnAggregationDimensionPeriodAggregationEnum[keyof typeof SheetColumnAggregationDimensionPeriodAggregationEnum];

export interface SheetComparisonCondition {
    'calculationFormula': SheetComparisonConditionCalculationFormulaEnum;
    'comparisonType': SheetComparisonConditionComparisonTypeEnum;
}

export const SheetComparisonConditionCalculationFormulaEnum = {
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
} as const;

export type SheetComparisonConditionCalculationFormulaEnum = typeof SheetComparisonConditionCalculationFormulaEnum[keyof typeof SheetComparisonConditionCalculationFormulaEnum];
export const SheetComparisonConditionComparisonTypeEnum = {
    Diff: 'DIFF',
} as const;

export type SheetComparisonConditionComparisonTypeEnum = typeof SheetComparisonConditionComparisonTypeEnum[keyof typeof SheetComparisonConditionComparisonTypeEnum];

export interface SheetConditionSchema {
    'cellGroupOrders': Array<SheetCellGroupOrder>;
    'columnAggregationDimension': SheetColumnAggregationDimension;
    'comparisonConditions': Array<SheetComparisonCondition>;
    'dataConditions': Array<SheetDataCondition>;
    'isShowEmptyRows': boolean;
    'rowAggregationDimensions': Array<SheetRowAggregationDimension>;
    'showNumbersIn': SheetConditionSchemaShowNumbersInEnum;
    'showSumRow': boolean;
    'sortCondition'?: SheetSortCondition;
    'version': number;
}

export const SheetConditionSchemaShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type SheetConditionSchemaShowNumbersInEnum = typeof SheetConditionSchemaShowNumbersInEnum[keyof typeof SheetConditionSchemaShowNumbersInEnum];

export interface SheetDataCondition {
    /**
     * PlanningProject.accountTreeId() を使用
     * @deprecated
     */
    'accountTreeId': string;
    'actualPeriod'?: SheetPeriod;
    'dimensionFilters': Array<SheetDimensionFilter>;
    'id': SheetDataConditionIdEnum;
    /**
     * PlanningProject.nonFinancialAccountTreeId() を使用
     * @deprecated
     */
    'nonFinancialAccountTreeId': string;
    /**
     * PlanningProject.orgTreeId() を使用
     * @deprecated
     */
    'orgTreeId': string;
    'period': SheetPeriod;
    'planId'?: SheetPlanId;
    'requireAllocatedItem': boolean;
    'showActual': boolean;
}

export const SheetDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type SheetDataConditionIdEnum = typeof SheetDataConditionIdEnum[keyof typeof SheetDataConditionIdEnum];

export interface SheetDimensionFilter {
    'dimensionTreeId'?: string;
    'dimensionType': SheetDimensionFilterDimensionTypeEnum;
    'ids': Array<string>;
}

export const SheetDimensionFilterDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type SheetDimensionFilterDimensionTypeEnum = typeof SheetDimensionFilterDimensionTypeEnum[keyof typeof SheetDimensionFilterDimensionTypeEnum];

export interface SheetInfoView {
    'selectable': boolean;
    'sheetIndex': number;
    'sheetName': string;
}
export interface SheetPeriod {
    'end': string;
    'start': string;
}
export interface SheetPlanId {
    'id': string;
    'type': SheetPlanIdTypeEnum;
}

export const SheetPlanIdTypeEnum = {
    PlanMaster: 'PLAN_MASTER',
    PlanningProject: 'PLANNING_PROJECT',
    PlanUpdateRequestDraft: 'PLAN_UPDATE_REQUEST_DRAFT',
} as const;

export type SheetPlanIdTypeEnum = typeof SheetPlanIdTypeEnum[keyof typeof SheetPlanIdTypeEnum];

export interface SheetRowAggregationDimension {
    'dimensionTreeId'?: string;
    'dimensionType': SheetRowAggregationDimensionDimensionTypeEnum;
    'visibleIds': Array<string>;
}

export const SheetRowAggregationDimensionDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
} as const;

export type SheetRowAggregationDimensionDimensionTypeEnum = typeof SheetRowAggregationDimensionDimensionTypeEnum[keyof typeof SheetRowAggregationDimensionDimensionTypeEnum];

export interface SheetSortCondition {
    'sortKey': SheetSortKey;
    'sortOrder': SheetSortConditionSortOrderEnum;
}

export const SheetSortConditionSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;

export type SheetSortConditionSortOrderEnum = typeof SheetSortConditionSortOrderEnum[keyof typeof SheetSortConditionSortOrderEnum];

export interface SheetSortKey {
    'columnAggregationId': string;
    'dataOrComparisonType': SheetSortKeyDataOrComparisonTypeEnum;
}

export const SheetSortKeyDataOrComparisonTypeEnum = {
    DataA: 'DATA_A',
    DataB: 'DATA_B',
    DataC: 'DATA_C',
} as const;

export type SheetSortKeyDataOrComparisonTypeEnum = typeof SheetSortKeyDataOrComparisonTypeEnum[keyof typeof SheetSortKeyDataOrComparisonTypeEnum];

export interface SimulatingSlotCellView {
    'columnId': string;
    'value': number;
}
export interface SimulatingSlotColumnView {
    'yearMonth': string;
}
export interface SimulatingSlotDepartmentView {
    'id': string;
    'name': string;
}
export interface SimulatingSlotDimensionView {
    'dimensionId': string;
    'dimensionName': string;
    'dimensionTagId': string;
    'dimensionTagName': string;
}
export interface SimulatingSlotHeaderItemView {
    'id': string;
    'yearMonth': string;
}
export interface SimulatingSlotItemView {
    'code': string;
    'createdAt': string;
    'department': SimulatingSlotDepartmentView;
    'dimensions': Array<SimulatingSlotDimensionView>;
    'fromWorkforceSlotId'?: string;
    'id': string;
    'inDepartment'?: SimulatingSlotDepartmentView;
    'name': string;
    'outDepartment'?: SimulatingSlotDepartmentView;
    'showUsedCount': boolean;
    'slotType': SimulatingSlotItemViewSlotTypeEnum;
    'totalCount': number;
    'unitAmounts': Array<SimulatingSlotUnitAmountView>;
    'usages': Array<SimulatingSlotUsageView>;
    'usedCount': number;
}

export const SimulatingSlotItemViewSlotTypeEnum = {
    Hiring: 'HIRING',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    TransferDepartment: 'TRANSFER_DEPARTMENT',
} as const;

export type SimulatingSlotItemViewSlotTypeEnum = typeof SimulatingSlotItemViewSlotTypeEnum[keyof typeof SimulatingSlotItemViewSlotTypeEnum];

export interface SimulatingSlotListItemDepartment {
    'id': string;
    'name': string;
}
export interface SimulatingSlotListItemDimension {
    'dimensionId': string;
    'dimensionTagId': string;
    'dimensionTagName': string;
}
export interface SimulatingSlotListItemLockedInfo {
    'lockedAt': string;
    'lockedUserName': string;
}
export interface SimulatingSlotListItemView {
    'cells': Array<SimulatingSlotCellView>;
    'department': SimulatingSlotListItemDepartment;
    'dimensions': Array<SimulatingSlotListItemDimension>;
    'isLocked': boolean;
    'isNewSlot': boolean;
    'lockedInfo'?: SimulatingSlotListItemLockedInfo;
    'simulatingSlotId': string;
    'slotCode': string;
    'slotName': string;
    'slotType': SimulatingSlotListItemViewSlotTypeEnum;
    'unitAmounts': Array<SimulatingSlotRowUnitAmountView>;
}

export const SimulatingSlotListItemViewSlotTypeEnum = {
    Hiring: 'HIRING',
    ReturnToWork: 'RETURN_TO_WORK',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    TransferInDepartment: 'TRANSFER_IN_DEPARTMENT',
    TransferOutDepartment: 'TRANSFER_OUT_DEPARTMENT',
    FixedTransferDepartment: 'FIXED_TRANSFER_DEPARTMENT',
} as const;

export type SimulatingSlotListItemViewSlotTypeEnum = typeof SimulatingSlotListItemViewSlotTypeEnum[keyof typeof SimulatingSlotListItemViewSlotTypeEnum];

export interface SimulatingSlotRowUnitAmountView {
    'itemId': string;
    'unitAmount': number;
}
export interface SimulatingSlotSortCondition {
    'dimensionSortTargetId'?: string;
    'keyName': SimulatingSlotSortConditionKeyNameEnum;
    'sortOrder': SimulatingSlotSortConditionSortOrderEnum;
    'unitAmountSortTargetId'?: string;
}

export const SimulatingSlotSortConditionKeyNameEnum = {
    Name: 'NAME',
    Code: 'CODE',
    SlotType: 'SLOT_TYPE',
    DepartmentCode: 'DEPARTMENT_CODE',
    OutDepartmentCode: 'OUT_DEPARTMENT_CODE',
    InDepartmentCode: 'IN_DEPARTMENT_CODE',
    CreatedAt: 'CREATED_AT',
    DimensionTagCode: 'DIMENSION_TAG_CODE',
    UnitAmount: 'UNIT_AMOUNT',
    TotalCount: 'TOTAL_COUNT',
    UsedCount: 'USED_COUNT',
} as const;

export type SimulatingSlotSortConditionKeyNameEnum = typeof SimulatingSlotSortConditionKeyNameEnum[keyof typeof SimulatingSlotSortConditionKeyNameEnum];
export const SimulatingSlotSortConditionSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;

export type SimulatingSlotSortConditionSortOrderEnum = typeof SimulatingSlotSortConditionSortOrderEnum[keyof typeof SimulatingSlotSortConditionSortOrderEnum];

export interface SimulatingSlotUnitAmountView {
    'itemId': string;
    'itemName': string;
    'unitAmount': number;
}
export interface SimulatingSlotUsageView {
    'remainingCount': number;
    'usedCount': number;
    'yearMonth': string;
}
export interface SimulatingTransferDepartmentSlotListItemView {
    'cells': Array<SimulatingSlotCellView>;
    'dimensions': Array<SimulatingSlotListItemDimension>;
    'inDepartment'?: SimulatingSlotListItemDepartment;
    'isLocked': boolean;
    'isNewSlot': boolean;
    'lockedInfo'?: SimulatingSlotListItemLockedInfo;
    'outDepartment'?: SimulatingSlotListItemDepartment;
    'simulatingSlotId': string;
    'slotCode': string;
    'slotName': string;
    'slotType': SimulatingTransferDepartmentSlotListItemViewSlotTypeEnum;
    'unitAmounts': Array<SimulatingSlotRowUnitAmountView>;
}

export const SimulatingTransferDepartmentSlotListItemViewSlotTypeEnum = {
    Hiring: 'HIRING',
    ReturnToWork: 'RETURN_TO_WORK',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    TransferInDepartment: 'TRANSFER_IN_DEPARTMENT',
    TransferOutDepartment: 'TRANSFER_OUT_DEPARTMENT',
    FixedTransferDepartment: 'FIXED_TRANSFER_DEPARTMENT',
} as const;

export type SimulatingTransferDepartmentSlotListItemViewSlotTypeEnum = typeof SimulatingTransferDepartmentSlotListItemViewSlotTypeEnum[keyof typeof SimulatingTransferDepartmentSlotListItemViewSlotTypeEnum];

export interface SimulatingWorkforceBulkUploadHistoryView {
    'createdAt': string;
    'createdByUserName': string;
    'fileName': string;
    'id': string;
}
export interface SimulatingWorkforceConcurrentPostEventInfo {
    'departmentId': string;
    'dimensionTags': Array<SimulatingWorkforceDimensionInfo>;
    'ratio': number;
}
export interface SimulatingWorkforceConcurrentPostEventItem {
    'effectiveYearMonth': string;
    'ratios': Array<SimulatingWorkforceConcurrentPostEventInfo>;
    'type': SimulatingWorkforceConcurrentPostEventItemTypeEnum;
    'usingDimensionIds': Array<string>;
}

export const SimulatingWorkforceConcurrentPostEventItemTypeEnum = {
    Start: 'START',
    Release: 'RELEASE',
} as const;

export type SimulatingWorkforceConcurrentPostEventItemTypeEnum = typeof SimulatingWorkforceConcurrentPostEventItemTypeEnum[keyof typeof SimulatingWorkforceConcurrentPostEventItemTypeEnum];

export interface SimulatingWorkforceConcurrentPostHistoryListItem {
    'code': string;
    'endDate'?: string;
    'events': Array<SimulatingWorkforceConcurrentPostHistoryListItemEventsEnum>;
    'id': string;
    'name': string;
    'ratios': Array<SimulatingWorkforceConcurrentPostHistoryRatio>;
    'startDate': string;
}

export const SimulatingWorkforceConcurrentPostHistoryListItemEventsEnum = {
    Start: 'START',
    Release: 'RELEASE',
} as const;

export type SimulatingWorkforceConcurrentPostHistoryListItemEventsEnum = typeof SimulatingWorkforceConcurrentPostHistoryListItemEventsEnum[keyof typeof SimulatingWorkforceConcurrentPostHistoryListItemEventsEnum];

export interface SimulatingWorkforceConcurrentPostHistoryRatio {
    'departmentName': string;
    'dimensionTags': Array<SimulatingWorkforceHistoryDimensionView>;
    'ratio': number;
}
export interface SimulatingWorkforceCurrentMonthDimensionTagInfo {
    'dimensionId': string;
    'dimensionTagName': string;
}
export interface SimulatingWorkforceCurrentMonthInfo {
    'departmentName': string;
    'dimensionTags': Array<SimulatingWorkforceCurrentMonthDimensionTagInfo>;
    'employmentStatus': SimulatingWorkforceCurrentMonthInfoEmploymentStatusEnum;
}

export const SimulatingWorkforceCurrentMonthInfoEmploymentStatusEnum = {
    Active: 'ACTIVE',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    Resigned: 'RESIGNED',
} as const;

export type SimulatingWorkforceCurrentMonthInfoEmploymentStatusEnum = typeof SimulatingWorkforceCurrentMonthInfoEmploymentStatusEnum[keyof typeof SimulatingWorkforceCurrentMonthInfoEmploymentStatusEnum];

export interface SimulatingWorkforceDimensionInfo {
    'dimensionId': string;
    'dimensionTagId': string;
}
export interface SimulatingWorkforceEventItem {
    'effectiveYearMonth': string;
    'events': Array<SimulatingWorkforceEventItemInfo>;
}
export interface SimulatingWorkforceEventItemInfo {
    'departmentId'?: string;
    'departmentName'?: string;
    'dimensionId'?: string;
    'dimensionTagId'?: string;
    'dimensionTagName'?: string;
    'eventType': SimulatingWorkforceEventItemInfoEventTypeEnum;
    'origin': SimulatingWorkforceEventItemInfoOriginEnum;
}

export const SimulatingWorkforceEventItemInfoEventTypeEnum = {
    Started: 'STARTED',
    End: 'END',
    DepartmentChanged: 'DEPARTMENT_CHANGED',
    DimensionTagChanged: 'DIMENSION_TAG_CHANGED',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
} as const;

export type SimulatingWorkforceEventItemInfoEventTypeEnum = typeof SimulatingWorkforceEventItemInfoEventTypeEnum[keyof typeof SimulatingWorkforceEventItemInfoEventTypeEnum];
export const SimulatingWorkforceEventItemInfoOriginEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type SimulatingWorkforceEventItemInfoOriginEnum = typeof SimulatingWorkforceEventItemInfoOriginEnum[keyof typeof SimulatingWorkforceEventItemInfoOriginEnum];

export interface SimulatingWorkforceHistoryDimensionColumnView {
    'dimensionId': string;
    'dimensionName': string;
    'dimensionNumber': number;
}
export interface SimulatingWorkforceHistoryDimensionView {
    'dimensionId': string;
    'dimensionTagName': string;
}
export interface SimulatingWorkforceLeavePeriodItem {
    'leaveOfAbsence': SimulatingWorkforceLeavePeriodLeaveSide;
    'returnToWork': SimulatingWorkforceLeavePeriodReturnSide;
}
export interface SimulatingWorkforceLeavePeriodLeaveSide {
    'origin'?: SimulatingWorkforceLeavePeriodLeaveSideOriginEnum;
    'status': SimulatingWorkforceLeavePeriodLeaveSideStatusEnum;
    'yearMonth'?: string;
}

export const SimulatingWorkforceLeavePeriodLeaveSideOriginEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type SimulatingWorkforceLeavePeriodLeaveSideOriginEnum = typeof SimulatingWorkforceLeavePeriodLeaveSideOriginEnum[keyof typeof SimulatingWorkforceLeavePeriodLeaveSideOriginEnum];
export const SimulatingWorkforceLeavePeriodLeaveSideStatusEnum = {
    Displayed: 'DISPLAYED',
    OutOfRange: 'OUT_OF_RANGE',
    Restricted: 'RESTRICTED',
} as const;

export type SimulatingWorkforceLeavePeriodLeaveSideStatusEnum = typeof SimulatingWorkforceLeavePeriodLeaveSideStatusEnum[keyof typeof SimulatingWorkforceLeavePeriodLeaveSideStatusEnum];

export interface SimulatingWorkforceLeavePeriodReturnSide {
    'origin'?: SimulatingWorkforceLeavePeriodReturnSideOriginEnum;
    'status': SimulatingWorkforceLeavePeriodReturnSideStatusEnum;
    'yearMonth'?: string;
}

export const SimulatingWorkforceLeavePeriodReturnSideOriginEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type SimulatingWorkforceLeavePeriodReturnSideOriginEnum = typeof SimulatingWorkforceLeavePeriodReturnSideOriginEnum[keyof typeof SimulatingWorkforceLeavePeriodReturnSideOriginEnum];
export const SimulatingWorkforceLeavePeriodReturnSideStatusEnum = {
    Displayed: 'DISPLAYED',
    OutOfRange: 'OUT_OF_RANGE',
    Restricted: 'RESTRICTED',
    NotScheduled: 'NOT_SCHEDULED',
} as const;

export type SimulatingWorkforceLeavePeriodReturnSideStatusEnum = typeof SimulatingWorkforceLeavePeriodReturnSideStatusEnum[keyof typeof SimulatingWorkforceLeavePeriodReturnSideStatusEnum];

export interface SimulatingWorkforceSlotActualEventConnectionDto {
    'connectedYearMonth': string;
    'effectiveYearMonth'?: string;
    'name': string;
}
export interface SimulatingWorkforceSlotActualEventConnectionsReturn {
    'hasConnections': boolean;
    'visibleConnections': Array<SimulatingWorkforceSlotActualEventConnectionDto>;
}
export interface SimulatingWorkforceSlotBody {
    'departmentIds': Array<string>;
    'onlyUnFixed': boolean;
}
export interface SimulatingWorkforceSlotBulkUploadHistoryView {
    'createdAt': string;
    'createdByUserName': string;
    'fileName': string;
    'id': string;
}
export interface SimulatingWorkforceSlotListView {
    'columns': Array<SimulatingSlotColumnView>;
    'slots': Array<SimulatingSlotItemView>;
}
export interface SimulatingWorkforceUsableEvent {
    'usableEvents': Array<SimulatingWorkforceUsableEventUsableEventsEnum>;
    'yearMonth': string;
}

export const SimulatingWorkforceUsableEventUsableEventsEnum = {
    DepartmentChanged: 'DEPARTMENT_CHANGED',
    DimensionTagChanged: 'DIMENSION_TAG_CHANGED',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    End: 'END',
} as const;

export type SimulatingWorkforceUsableEventUsableEventsEnum = typeof SimulatingWorkforceUsableEventUsableEventsEnum[keyof typeof SimulatingWorkforceUsableEventUsableEventsEnum];

export interface SimulationCellCondition {
    'columnCondition': SimulationDimensionCondition;
    'rowConditions': Array<SimulationDimensionCondition>;
}
export interface SimulationDimensionCondition {
    'dimensionType': SimulationDimensionConditionDimensionTypeEnum;
    'id': string;
}

export const SimulationDimensionConditionDimensionTypeEnum = {
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
    Dimension1: 'DIMENSION_1',
    Dimension2: 'DIMENSION_2',
    Dimension3: 'DIMENSION_3',
    Dimension4: 'DIMENSION_4',
    Dimension5: 'DIMENSION_5',
    Dimension6: 'DIMENSION_6',
    Dimension7: 'DIMENSION_7',
    Period: 'PERIOD',
} as const;

export type SimulationDimensionConditionDimensionTypeEnum = typeof SimulationDimensionConditionDimensionTypeEnum[keyof typeof SimulationDimensionConditionDimensionTypeEnum];

export interface SimulationEachDepartmentAndDimensionRow {
    'department': SimulationWorkforceRowMeta;
    'dimensionTags': Array<SimulationWorkforceRowMeta>;
    'items': Array<DeprecatedWorkforcePlanningSimulationItem>;
}
export interface SimulationEachWorkforceRow {
    'eachDepartmentAndDimension': Array<SimulationEachDepartmentAndDimensionRow>;
    'items': Array<DeprecatedWorkforcePlanningSimulationItem>;
    'meta': SimulationWorkforceRowMeta;
}
export interface SimulationFilterCondition {
    'department'?: WorkforcePlanningSimulationGlobalFilterSchema;
    'dimensions': { [key: string]: WorkforcePlanningSimulationGlobalFilterSchema; };
}
export interface SimulationHeaderCellGroupView {
    'cells': Array<SimulationHeaderCellView>;
}
export interface SimulationHeaderCellView {
    'id': string;
    'label': string;
}
export interface SimulationListItem {
    'createdBy': string;
    'id': string;
    'isAllowedToEditNameAndDelete': boolean;
    'name': string;
    'planMasterId'?: string;
    'planName': string;
    'planningProjectId': string;
    'planningProjectName': string;
    'targetRangeEnd': string;
    'targetRangeStart': string;
    'updatedAt': string;
    'updatedBy': string;
}
export interface SimulationPLCellView {
    'amount'?: string;
    'yearMonth': string;
}
export interface SimulationPLRowView {
    'accountId': string;
    'accountName': string;
    'cells': Array<SimulationPLCellView>;
    'isLeaf': boolean;
    'level': number;
    'parentAccountId'?: string;
}
export interface SimulationPLTableView {
    'columns': Array<string>;
    'rows': Array<SimulationPLRowView>;
}
export interface SimulationPagingView {
    'limit': number;
    'offset': number;
    'totalCount': number;
}
export interface SimulationPlanUpdateRequestBody {
    'departmentId': string;
    'planningProjectId': string;
}
export interface SimulationReportBody {
    'accountIds'?: Array<string>;
    'filterCondition': SimulationFilterCondition;
    'showNumbersIn': SimulationReportBodyShowNumbersInEnum;
    'viewType': SimulationReportBodyViewTypeEnum;
}

export const SimulationReportBodyShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type SimulationReportBodyShowNumbersInEnum = typeof SimulationReportBodyShowNumbersInEnum[keyof typeof SimulationReportBodyShowNumbersInEnum];
export const SimulationReportBodyViewTypeEnum = {
    Pl: 'PL',
    PersonAndSlot: 'PERSON_AND_SLOT',
} as const;

export type SimulationReportBodyViewTypeEnum = typeof SimulationReportBodyViewTypeEnum[keyof typeof SimulationReportBodyViewTypeEnum];

export interface SimulationReportCellContent {
    'amount'?: string;
    'error'?: SimulationReportCellContentError;
}
export interface SimulationReportCellContentError {
    'message': string;
    'value': string;
}
export interface SimulationReportCellDiff {
    'amount': string;
    'diffType': SimulationReportCellDiffDiffTypeEnum;
}

export const SimulationReportCellDiffDiffTypeEnum = {
    Plus: 'PLUS',
    Minus: 'MINUS',
    NoDiff: 'NO_DIFF',
} as const;

export type SimulationReportCellDiffDiffTypeEnum = typeof SimulationReportCellDiffDiffTypeEnum[keyof typeof SimulationReportCellDiffDiffTypeEnum];

export interface SimulationReportCellView {
    'after': SimulationReportCellContent;
    'before': SimulationReportCellContent;
    'canShowDetail': boolean;
    'columnId': string;
    'diff'?: SimulationReportCellDiff;
}
export interface SimulationReportDetailHeaderDimensionView {
    'name': string;
    'sortKey': SimulationReportDetailHeaderDimensionViewSortKeyEnum;
}

export const SimulationReportDetailHeaderDimensionViewSortKeyEnum = {
    JournalDate: 'JOURNAL_DATE',
    DepartmentName: 'DEPARTMENT_NAME',
    AccountName: 'ACCOUNT_NAME',
    Description: 'DESCRIPTION',
    Amount: 'AMOUNT',
    Dimension1Name: 'DIMENSION_1_NAME',
    Dimension2Name: 'DIMENSION_2_NAME',
    Dimension3Name: 'DIMENSION_3_NAME',
    Dimension4Name: 'DIMENSION_4_NAME',
    Dimension5Name: 'DIMENSION_5_NAME',
    Dimension6Name: 'DIMENSION_6_NAME',
    Dimension7Name: 'DIMENSION_7_NAME',
} as const;

export type SimulationReportDetailHeaderDimensionViewSortKeyEnum = typeof SimulationReportDetailHeaderDimensionViewSortKeyEnum[keyof typeof SimulationReportDetailHeaderDimensionViewSortKeyEnum];

export interface SimulationReportDetailHeaderView {
    'dimensions': Array<SimulationReportDetailHeaderDimensionView>;
}
export interface SimulationReportDetailParam {
    'cellCondition': SimulationCellCondition;
    'filterCondition': SimulationFilterCondition;
    'limit': number;
    'offset': number;
    'showNumbersIn': SimulationReportDetailParamShowNumbersInEnum;
    'sortKey': SimulationSortKey;
}

export const SimulationReportDetailParamShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type SimulationReportDetailParamShowNumbersInEnum = typeof SimulationReportDetailParamShowNumbersInEnum[keyof typeof SimulationReportDetailParamShowNumbersInEnum];

export interface SimulationReportDetailResponse {
    'header': SimulationReportDetailHeaderView;
    'isNonFinancial': boolean;
    'paging': SimulationPagingView;
    'rows': Array<SimulationReportDetailRowView>;
    'title': string;
}
export interface SimulationReportDetailRowView {
    'account': string;
    'amount': string;
    'dateOrYearMonth': string;
    'department': string;
    'description': string;
    'dimensionTagNames': Array<string>;
}
export interface SimulationReportFlatTableView {
    'meta': SimulationReportMetaView;
    'rows': Array<SimulationReportRowView>;
}
export interface SimulationReportMetaView {
    'headerCellGroups': Array<SimulationHeaderCellGroupView>;
    'rowAggregationKeyMetas': Array<SimulationRowAggregationKeyMetaView>;
}
export interface SimulationReportResponse {
    'flatOrTree': SimulationReportResponseFlatOrTreeEnum;
    'flatTable'?: SimulationReportFlatTableView;
    'treeTable'?: SimulationReportTreeTableView;
}

export const SimulationReportResponseFlatOrTreeEnum = {
    Flat: 'FLAT',
    Tree: 'TREE',
} as const;

export type SimulationReportResponseFlatOrTreeEnum = typeof SimulationReportResponseFlatOrTreeEnum[keyof typeof SimulationReportResponseFlatOrTreeEnum];

export interface SimulationReportRowView {
    'cells': Array<SimulationReportCellView>;
    'rowKeys': Array<SimulationRowKeyView>;
    'sumCell': SimulationReportSumCellView;
}
export interface SimulationReportSumCellView {
    'after': SimulationReportCellContent;
    'before': SimulationReportCellContent;
    'diff'?: SimulationReportCellDiff;
}
export interface SimulationReportTreeTableView {
    'meta': SimulationReportMetaView;
    'rootRowTreeNodes': Array<TreeNodeViewSimulationReportRowView>;
}
export interface SimulationRowAggregationKeyMetaView {
    'label': string;
}
export interface SimulationRowKeyView {
    'id': string;
    'label'?: string;
    'level'?: number;
}
export interface SimulationSortKey {
    'keyName': SimulationSortKeyKeyNameEnum;
    'sortOrder': SimulationSortKeySortOrderEnum;
}

export const SimulationSortKeyKeyNameEnum = {
    JournalDate: 'JOURNAL_DATE',
    DepartmentName: 'DEPARTMENT_NAME',
    AccountName: 'ACCOUNT_NAME',
    Description: 'DESCRIPTION',
    Amount: 'AMOUNT',
    Dimension1Name: 'DIMENSION_1_NAME',
    Dimension2Name: 'DIMENSION_2_NAME',
    Dimension3Name: 'DIMENSION_3_NAME',
    Dimension4Name: 'DIMENSION_4_NAME',
    Dimension5Name: 'DIMENSION_5_NAME',
    Dimension6Name: 'DIMENSION_6_NAME',
    Dimension7Name: 'DIMENSION_7_NAME',
} as const;

export type SimulationSortKeyKeyNameEnum = typeof SimulationSortKeyKeyNameEnum[keyof typeof SimulationSortKeyKeyNameEnum];
export const SimulationSortKeySortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;

export type SimulationSortKeySortOrderEnum = typeof SimulationSortKeySortOrderEnum[keyof typeof SimulationSortKeySortOrderEnum];

export interface SimulationSubTotalRow {
    'eachWorkforceRows': Array<SimulationEachWorkforceRow>;
    'subTotalItems': Array<DeprecatedWorkforcePlanningSimulationItem>;
}
export interface SimulationWorkforcePlanningBody {
    'departmentIds': Array<string>;
}
export interface SimulationWorkforceRowMeta {
    'code': string;
    'id': string;
    'name': string;
}
export interface SkippedAllocationStandardView {
    'id': string;
    'name': string;
}
export interface SkippedAllocationStepView {
    'description'?: string;
    'id': string;
    'name': string;
    'order': number;
    'standard'?: SkippedAllocationStandardView;
    'stepType': SkippedAllocationStepViewStepTypeEnum;
}

export const SkippedAllocationStepViewStepTypeEnum = {
    Allocation: 'ALLOCATION',
    Transfer: 'TRANSFER',
} as const;

export type SkippedAllocationStepViewStepTypeEnum = typeof SkippedAllocationStepViewStepTypeEnum[keyof typeof SkippedAllocationStepViewStepTypeEnum];

export interface SkippedAllocationStepsSummaryView {
    'ruleId': string;
    'ruleName': string;
    'steps': Array<SkippedAllocationStepView>;
}
export interface SlotInfoView {
    'remainingCountByYearMonth': Array<RemainingCountByYearMonth>;
    'totalRemainingCount': number;
}
export interface SlotUsageByMonthView {
    'totalCount': number;
    'usedCount': number;
    'yearMonth': string;
}
export interface SocialLoginsDto {
    'googleState': SocialLoginsDtoGoogleStateEnum;
}

export const SocialLoginsDtoGoogleStateEnum = {
    CanLink: 'CAN_LINK',
    CannotLink: 'CANNOT_LINK',
    Linked: 'LINKED',
} as const;

export type SocialLoginsDtoGoogleStateEnum = typeof SocialLoginsDtoGoogleStateEnum[keyof typeof SocialLoginsDtoGoogleStateEnum];

export interface SortCondition {
    'sortKey': SortKey;
    'sortOrder': SortConditionSortOrderEnum;
}

export const SortConditionSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;

export type SortConditionSortOrderEnum = typeof SortConditionSortOrderEnum[keyof typeof SortConditionSortOrderEnum];

export interface SortKey {
    'columnAggregationId': string;
    'dataOrComparisonType': SortKeyDataOrComparisonTypeEnum;
}

export const SortKeyDataOrComparisonTypeEnum = {
    DataA: 'DATA_A',
    DataB: 'DATA_B',
    DataC: 'DATA_C',
    DiffAb: 'DIFF_AB',
    DiffAc: 'DIFF_AC',
    DiffBa: 'DIFF_BA',
    DiffBc: 'DIFF_BC',
    DiffCa: 'DIFF_CA',
    DiffCb: 'DIFF_CB',
    DiffRatioAb: 'DIFF_RATIO_AB',
    DiffRatioAc: 'DIFF_RATIO_AC',
    DiffRatioBa: 'DIFF_RATIO_BA',
    DiffRatioBc: 'DIFF_RATIO_BC',
    DiffRatioCa: 'DIFF_RATIO_CA',
    DiffRatioCb: 'DIFF_RATIO_CB',
    AchievementRatioAb: 'ACHIEVEMENT_RATIO_AB',
    AchievementRatioAc: 'ACHIEVEMENT_RATIO_AC',
    AchievementRatioBa: 'ACHIEVEMENT_RATIO_BA',
    AchievementRatioBc: 'ACHIEVEMENT_RATIO_BC',
    AchievementRatioCa: 'ACHIEVEMENT_RATIO_CA',
    AchievementRatioCb: 'ACHIEVEMENT_RATIO_CB',
    SpecificAccountRatioA: 'SPECIFIC_ACCOUNT_RATIO_A',
    SpecificAccountRatioB: 'SPECIFIC_ACCOUNT_RATIO_B',
    SpecificAccountRatioC: 'SPECIFIC_ACCOUNT_RATIO_C',
} as const;

export type SortKeyDataOrComparisonTypeEnum = typeof SortKeyDataOrComparisonTypeEnum[keyof typeof SortKeyDataOrComparisonTypeEnum];

export interface SourceAccounts {
    'ids': Array<IdWithReferenceType>;
    'treeId': string;
}
export interface SplitActionParams {
    'delimiter': string;
    'pickingNumber': number;
    'target': string;
}
export interface StandardAccounts {
    'ids': Array<IdWithReferenceType>;
    'treeId': string;
}
export interface StandardAccountsWithAccountType {
    'accountType': string;
    'ids': Array<IdWithReferenceType>;
    'treeId': string;
}
export interface StartsWith {
    'conditionValue': string;
}
export interface StepListItemDto {
    'description': string;
    'hasLoopCondition': boolean;
    'id': string;
    'name': string;
    'order': number;
    'standardType'?: string;
    'type': string;
}
export interface SubAccountView {
    'accountId': string;
    'accountingSystemCode'?: AccountingSystemCodeView;
    'code': string;
    'id': string;
    'name': string;
    'viewControlType': SubAccountViewViewControlTypeEnum;
}

export const SubAccountViewViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type SubAccountViewViewControlTypeEnum = typeof SubAccountViewViewControlTypeEnum[keyof typeof SubAccountViewViewControlTypeEnum];

export interface SubAccountsView {
    'value': Array<SubAccountView>;
}
export interface SubTotalRow {
    'eachWorkforceDiffRows': Array<EachWorkforceDiffRow>;
    'subTotalItems': Array<TotalItem>;
}
export interface SubmitPlanUpdateRequestFromWorkforcePlanningSimulationBody {
    'departmentId': string;
}
export interface SubmitPlanUpdateRequestFromWorkforcePlanningSimulationView {
    'excludedChanges': Array<ExcludedWorkforcePlanChangeView>;
    'excludedCount': number;
    'excludedWorkforceSlots': Array<ExcludedWorkforceSlotPlanView>;
    'excludedWorkforces': Array<ExcludedWorkforcePlanView>;
    'includedCount': number;
    'workforcePlanUpdateRequestId': string;
}
export interface SumCellGroupView {
    'cells': Array<SumCellGroupViewCellsInner>;
    'valueFormat'?: SumCellGroupViewValueFormatEnum;
}

export const SumCellGroupViewValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type SumCellGroupViewValueFormatEnum = typeof SumCellGroupViewValueFormatEnum[keyof typeof SumCellGroupViewValueFormatEnum];

/**
 * @type SumCellGroupViewCellsInner
 */
export type SumCellGroupViewCellsInner = SumComparisonFormulaCellView | SumDataCellView;

export interface SumCellView {
    'eitherAmountOrError'?: EitherAmountOrErrorView;
    'id': string;
    'orderKey': CellGroupOrderKeyImpl;
    'type': ReportCellType;
}


export interface SumComparisonFormulaCellView {
    'eitherAmountOrError'?: EitherAmountOrErrorView;
    'id': string;
    'orderKey': CellGroupOrderKeyImpl;
    'type': ReportCellType;
}


export interface SumDataCellView {
    'eitherAmountOrError'?: EitherAmountOrErrorView;
    'id': string;
    'orderKey': CellGroupOrderKeyImpl;
    'type': ReportCellType;
    'dataConditionId': SumDataCellViewDataConditionIdEnum;
}

export const SumDataCellViewDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type SumDataCellViewDataConditionIdEnum = typeof SumDataCellViewDataConditionIdEnum[keyof typeof SumDataCellViewDataConditionIdEnum];

export interface SumDiffScaledView {
    'actualSum'?: string;
    'currentSum'?: string;
    'diff'?: string;
    'diffType': SumDiffScaledViewDiffTypeEnum;
    'newSum'?: string;
}

export const SumDiffScaledViewDiffTypeEnum = {
    Increase: 'INCREASE',
    Decrease: 'DECREASE',
    NoChanges: 'NO_CHANGES',
    Undefined: 'UNDEFINED',
} as const;

export type SumDiffScaledViewDiffTypeEnum = typeof SumDiffScaledViewDiffTypeEnum[keyof typeof SumDiffScaledViewDiffTypeEnum];

export interface SwitchFinancialModelIdRequestBody {
    'financialModelId': string;
    'shouldCarryOverSimulationResults': boolean;
}
export interface TableDisplaySettings {
    'reportDisplaySettings': Array<ReportDisplaySettings>;
}
export interface TableDisplaySettingsRequestBody {
    'reportDisplaySettings': Array<ReportDisplaySettingsRequestBody>;
}
export interface TableauDashboardDto {
    'dashboardUrl': string;
    'targetAccountTreeId': string;
}
export interface TagView {
    'id': string;
    'name': string;
    'tagType': TagViewTagTypeEnum;
}

export const TagViewTagTypeEnum = {
    Item: 'ITEM',
    Section: 'SECTION',
    Memo: 'MEMO',
    Partner: 'PARTNER',
    SegmentOne: 'SEGMENT_ONE',
    SegmentTwo: 'SEGMENT_TWO',
    SegmentTree: 'SEGMENT_TREE',
} as const;

export type TagViewTagTypeEnum = typeof TagViewTagTypeEnum[keyof typeof TagViewTagTypeEnum];

export interface TargetAccountView {
    'id': string;
    'name': string;
}
export interface TargetDepartment {
    'id': string;
    'name': string;
}
export interface TargetPlanningProject {
    'id': string;
    'planMasterName': string;
    'planningProjectName': string;
}
export interface TargetYearMonthRange {
    'end': string;
    'start': string;
}
export interface TenantView {
    'hasSamlConnection': boolean;
    'id': string;
    'name': string;
}
export interface TextWidget {
    'id': IDImpl;
    'textContent': string;
}
export interface TooltipContext {
    'categoryLabel'?: string;
    'comparisonDetailLabel'?: string;
}
export interface TotalItem {
    'afterSum': number;
    'beforeSum': number;
    'diffAmount': number;
    'yearMonthId': string;
}
export interface TransferAccountCondition {
    'accounts': Array<IdWithReferenceType>;
    'treeId': string;
}
export interface TransferAxisCondition {
    'axisId': string;
    'axisTags': Array<IdWithReferenceType>;
    'treeId': string;
}
export interface TransferDepartmentDiff {
    'departmentName': string;
    'transferDepartmentDiffItems': Array<TransferDepartmentDiffItem>;
}
export interface TransferDepartmentDiffItem {
    'afterAmount'?: number;
    'beforeAmount'?: number;
    'diffAmount'?: number;
    'yearMonthId': string;
}
export interface TransferDepartmentSlotList {
    'items': Array<SimulatingTransferDepartmentSlotListItemView>;
    'unFixedDepartmentCount': number;
}
export interface TransferSingleAccountCondition {
    'account': IdWithReferenceType;
    'treeId': string;
}
export interface TransferSingleAxisCondition {
    'axisId': string;
    'axisTag': IdWithReferenceType;
    'treeId': string;
}
export interface TransferStepView {
    'description'?: string;
    'destinationAccountId'?: string;
    'destinationDepartmentId'?: string;
    'destinationDimensionDimensionTagIdMap': { [key: string]: string; };
    'id': string;
    'name': string;
    'sourceAccountIds': Array<string>;
    'sourceDepartmentIds'?: Array<string>;
    'sourceDimensionDimensionTagIdsMap': { [key: string]: Array<string>; };
}
export interface TreeNodeCompositeRowViewForTree {
    'children': Array<MutableTreeNode>;
    'value': CompositeRowViewForTree;
}
export interface TreeNodeDashboardFolderTreeNode {
    'children': Array<TreeNodeDashboardFolderTreeNode>;
    'value': DashboardFolderTreeNode;
}
export interface TreeNodeDimensionTreeNodeForSelectionView {
    'children': Array<TreeNodeDimensionTreeNodeForSelectionView>;
    'value': DimensionTreeNodeForSelectionView;
}
export interface TreeNodeReportFolderTreeNode {
    'children': Array<TreeNodeReportFolderTreeNode>;
    'value': ReportFolderTreeNode;
}
export interface TreeNodeRowViewForTree {
    'children': Array<MutableTreeNode>;
    'value': RowViewForTree;
}
export interface TreeNodeViewAccountTreeWithFormulaNodeDataView {
    'children': Array<TreeNodeViewAccountTreeWithFormulaNodeDataView>;
    'value': AccountTreeWithFormulaNodeDataView;
}
export interface TreeNodeViewAccountTreeWithHiddenFinancialSimulationDatasetFormulaIdsNodeDataView {
    'children': Array<TreeNodeViewAccountTreeWithHiddenFinancialSimulationDatasetFormulaIdsNodeDataView>;
    'value': AccountTreeWithHiddenFinancialSimulationDatasetFormulaIdsNodeDataView;
}
export interface TreeNodeViewSimulationReportRowView {
    'children': Array<TreeNodeViewSimulationReportRowView>;
    'value': SimulationReportRowView;
}
export interface UnassignedPermissionGroupUser {
    'departmentName'?: string;
    'fullName': string;
    'role': UnassignedPermissionGroupUserRoleEnum;
    'userId': string;
}

export const UnassignedPermissionGroupUserRoleEnum = {
    LoglassSystemAdmin: 'LOGLASS_SYSTEM_ADMIN',
    TenantAdmin: 'TENANT_ADMIN',
    CorpPlanning: 'CORP_PLANNING',
    Manager: 'MANAGER',
    ItStaff: 'IT_STAFF',
    General: 'GENERAL',
} as const;

export type UnassignedPermissionGroupUserRoleEnum = typeof UnassignedPermissionGroupUserRoleEnum[keyof typeof UnassignedPermissionGroupUserRoleEnum];

export interface UnconnectedWorkforceActualEventDto {
    'departmentName': string;
    'dimensionTagNames': Array<string>;
    'effectiveYearMonth': string;
    'eventType': UnconnectedWorkforceActualEventDtoEventTypeEnum;
    'personCode': string;
    'personName': string;
    'previousDepartmentName'?: string;
    'workforceActualEventId': string;
    'workforceActualId': string;
}

export const UnconnectedWorkforceActualEventDtoEventTypeEnum = {
    Start: 'START',
    End: 'END',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    TransferDepartment: 'TRANSFER_DEPARTMENT',
} as const;

export type UnconnectedWorkforceActualEventDtoEventTypeEnum = typeof UnconnectedWorkforceActualEventDtoEventTypeEnum[keyof typeof UnconnectedWorkforceActualEventDtoEventTypeEnum];

export interface UniqueKeyView {
    'meta': Meta;
    'reportTableKey': Array<ReportTableKeyItem>;
}
export interface UnitAmountItemView {
    'id': string;
    'name': string;
}
export interface UnitAmountListFilterCondition {
    'department'?: UnitAmountListFilterIds;
}
export interface UnitAmountListFilterIds {
    'ids': Array<string>;
}
export interface UnitAmountListItem {
    'departmentName': string;
    'personCode': string;
    'personFirstName': string;
    'personLastName': string;
    'unitAmounts': Array<UnitAmountListItemUnitAmount>;
    'workforceId': string;
}
export interface UnitAmountListItemUnitAmount {
    'itemId': string;
    'unitAmount': number;
}
export interface UnitAmountSuggestionView {
    'amount': number;
    'unitAmountItemId': string;
}
export interface UnitAmountView {
    'amount'?: number;
    'unitAmountItemId': string;
    'unitAmountItemName': string;
}
export interface UnitPriceGroupedByDimensionTagView {
    'amounts': { [key: string]: string; };
    'dimensionTagCode': string;
    'dimensionTagId': string;
    'dimensionTagName': string;
}
export interface UnitPriceListView {
    'allYearMonths': Array<string>;
    'items': Array<UnitPriceGroupedByDimensionTagView>;
}
export interface UnitPriceMasterItemListView {
    'items': Array<UnitPriceMasterItemView>;
}
export interface UnitPriceMasterItemView {
    'name': string;
    'unitPriceMasterItemId': string;
}
export interface UpdateAccountGroupRequestBody {
    'code': string;
    'name': string;
}
export interface UpdateAccountRequestBody {
    'accountType': UpdateAccountRequestBodyAccountTypeEnum;
    'code': string;
    'externalSystemAccountCode'?: string;
    'externalSystemSubAccountCode'?: string;
    'name': string;
    'roundingPrecision'?: UpdateAccountRequestBodyRoundingPrecisionEnum;
    'valueFormat'?: UpdateAccountRequestBodyValueFormatEnum;
    'viewControlType': UpdateAccountRequestBodyViewControlTypeEnum;
}

export const UpdateAccountRequestBodyAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type UpdateAccountRequestBodyAccountTypeEnum = typeof UpdateAccountRequestBodyAccountTypeEnum[keyof typeof UpdateAccountRequestBodyAccountTypeEnum];
export const UpdateAccountRequestBodyRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type UpdateAccountRequestBodyRoundingPrecisionEnum = typeof UpdateAccountRequestBodyRoundingPrecisionEnum[keyof typeof UpdateAccountRequestBodyRoundingPrecisionEnum];
export const UpdateAccountRequestBodyValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type UpdateAccountRequestBodyValueFormatEnum = typeof UpdateAccountRequestBodyValueFormatEnum[keyof typeof UpdateAccountRequestBodyValueFormatEnum];
export const UpdateAccountRequestBodyViewControlTypeEnum = {
    Public: 'PUBLIC',
    Limited: 'LIMITED',
} as const;

export type UpdateAccountRequestBodyViewControlTypeEnum = typeof UpdateAccountRequestBodyViewControlTypeEnum[keyof typeof UpdateAccountRequestBodyViewControlTypeEnum];

export interface UpdateAccountTypeWithIdRequestBody {
    'accountId': string;
    'accountType': UpdateAccountTypeWithIdRequestBodyAccountTypeEnum;
}

export const UpdateAccountTypeWithIdRequestBodyAccountTypeEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;

export type UpdateAccountTypeWithIdRequestBodyAccountTypeEnum = typeof UpdateAccountTypeWithIdRequestBodyAccountTypeEnum[keyof typeof UpdateAccountTypeWithIdRequestBodyAccountTypeEnum];

export interface UpdateActualsImportMappingDebitCreditConditionParams {
    'columnIndex': number;
    'conditionType': UpdateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum;
    'conditionValue'?: string;
    'debitCredit': UpdateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum;
}

export const UpdateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type UpdateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum = typeof UpdateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum[keyof typeof UpdateActualsImportMappingDebitCreditConditionParamsConditionTypeEnum];
export const UpdateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum = {
    Debit: 'DEBIT',
    Credit: 'CREDIT',
} as const;

export type UpdateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum = typeof UpdateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum[keyof typeof UpdateActualsImportMappingDebitCreditConditionParamsDebitCreditEnum];

export interface UpdateActualsImportMappingFilterParams {
    'columnIndex': number;
    'conditionType': UpdateActualsImportMappingFilterParamsConditionTypeEnum;
    'conditionValue'?: string;
    'targetType': UpdateActualsImportMappingFilterParamsTargetTypeEnum;
}

export const UpdateActualsImportMappingFilterParamsConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type UpdateActualsImportMappingFilterParamsConditionTypeEnum = typeof UpdateActualsImportMappingFilterParamsConditionTypeEnum[keyof typeof UpdateActualsImportMappingFilterParamsConditionTypeEnum];
export const UpdateActualsImportMappingFilterParamsTargetTypeEnum = {
    Row: 'ROW',
    Column: 'COLUMN',
} as const;

export type UpdateActualsImportMappingFilterParamsTargetTypeEnum = typeof UpdateActualsImportMappingFilterParamsTargetTypeEnum[keyof typeof UpdateActualsImportMappingFilterParamsTargetTypeEnum];

export interface UpdateActualsImportMappingItemParams {
    'columnIndex'?: number;
    'dimensionId'?: string;
    'type': UpdateActualsImportMappingItemParamsTypeEnum;
}

export const UpdateActualsImportMappingItemParamsTypeEnum = {
    Date: 'DATE',
    DebitAmount: 'DEBIT_AMOUNT',
    CreditAmount: 'CREDIT_AMOUNT',
    DebitAccountName: 'DEBIT_ACCOUNT_NAME',
    CreditAccountName: 'CREDIT_ACCOUNT_NAME',
    DocumentId: 'DOCUMENT_ID',
    Description: 'DESCRIPTION',
    DebitAccountExCode: 'DEBIT_ACCOUNT_EX_CODE',
    CreditAccountExCode: 'CREDIT_ACCOUNT_EX_CODE',
    DebitDepartmentName: 'DEBIT_DEPARTMENT_NAME',
    CreditDepartmentName: 'CREDIT_DEPARTMENT_NAME',
    DebitDepartmentExCode: 'DEBIT_DEPARTMENT_EX_CODE',
    CreditDepartmentExCode: 'CREDIT_DEPARTMENT_EX_CODE',
    DebitSubAccountName: 'DEBIT_SUB_ACCOUNT_NAME',
    CreditSubAccountName: 'CREDIT_SUB_ACCOUNT_NAME',
    DebitSubAccountExCode: 'DEBIT_SUB_ACCOUNT_EX_CODE',
    CreditSubAccountExCode: 'CREDIT_SUB_ACCOUNT_EX_CODE',
    DebitSupplierName: 'DEBIT_SUPPLIER_NAME',
    CreditSupplierName: 'CREDIT_SUPPLIER_NAME',
    DebitSupplierExCode: 'DEBIT_SUPPLIER_EX_CODE',
    CreditSupplierExCode: 'CREDIT_SUPPLIER_EX_CODE',
    DebitDimensionName: 'DEBIT_DIMENSION_NAME',
    CreditDimensionName: 'CREDIT_DIMENSION_NAME',
    Amount: 'AMOUNT',
    AccountName: 'ACCOUNT_NAME',
    AccountExCode: 'ACCOUNT_EX_CODE',
    DepartmentName: 'DEPARTMENT_NAME',
    DepartmentExCode: 'DEPARTMENT_EX_CODE',
    SubAccountName: 'SUB_ACCOUNT_NAME',
    SubAccountExCode: 'SUB_ACCOUNT_EX_CODE',
    SupplierName: 'SUPPLIER_NAME',
    SupplierExCode: 'SUPPLIER_EX_CODE',
    DimensionName: 'DIMENSION_NAME',
} as const;

export type UpdateActualsImportMappingItemParamsTypeEnum = typeof UpdateActualsImportMappingItemParamsTypeEnum[keyof typeof UpdateActualsImportMappingItemParamsTypeEnum];

export interface UpdateActualsImportMappingParams {
    'actualImportMappingFilters': Array<UpdateActualsImportMappingFilterParams>;
    'actualImportMappingItems': Array<UpdateActualsImportMappingItemParams>;
    'actualImportMappingSubsidiaryCodes': Array<UpdateActualsImportMappingSubsidiaryCodeParams>;
    'actualsImportMappingDebitCreditConditions': Array<UpdateActualsImportMappingDebitCreditConditionParams>;
    'amountDataDirection': UpdateActualsImportMappingParamsAmountDataDirectionEnum;
    'headerRowIndex': number;
    'journalOrBalance': UpdateActualsImportMappingParamsJournalOrBalanceEnum;
    'name': string;
    'processSettingIds': Array<string>;
    'repeatColumnHeaderType'?: UpdateActualsImportMappingParamsRepeatColumnHeaderTypeEnum;
}

export const UpdateActualsImportMappingParamsAmountDataDirectionEnum = {
    RowColumn: 'ROW_COLUMN',
    Column: 'COLUMN',
} as const;

export type UpdateActualsImportMappingParamsAmountDataDirectionEnum = typeof UpdateActualsImportMappingParamsAmountDataDirectionEnum[keyof typeof UpdateActualsImportMappingParamsAmountDataDirectionEnum];
export const UpdateActualsImportMappingParamsJournalOrBalanceEnum = {
    Journal: 'JOURNAL',
    Balance: 'BALANCE',
} as const;

export type UpdateActualsImportMappingParamsJournalOrBalanceEnum = typeof UpdateActualsImportMappingParamsJournalOrBalanceEnum[keyof typeof UpdateActualsImportMappingParamsJournalOrBalanceEnum];
export const UpdateActualsImportMappingParamsRepeatColumnHeaderTypeEnum = {
    Date: 'DATE',
    Account: 'ACCOUNT',
    Department: 'DEPARTMENT',
} as const;

export type UpdateActualsImportMappingParamsRepeatColumnHeaderTypeEnum = typeof UpdateActualsImportMappingParamsRepeatColumnHeaderTypeEnum[keyof typeof UpdateActualsImportMappingParamsRepeatColumnHeaderTypeEnum];

export interface UpdateActualsImportMappingSubsidiaryCodeParams {
    'code': string;
    'name': string;
}
export interface UpdateAllocationRuleRequestBody {
    'name': string;
}
export interface UpdateAllocationStepOrderRequestBody {
    'items': Array<string>;
}
export interface UpdateAllocationStepRequestBody {
    'allocationStandardId'?: string;
    'description'?: string;
    'destinationAccountId'?: string;
    'destinationDepartmentIds': Array<string>;
    'destinationDimensionTagIds'?: Array<string>;
    'name': string;
    'sourceAccountIds': Array<string>;
    'sourceDepartmentIds': Array<string>;
    'sourceDimensionTagIds'?: Array<string>;
    'stepType': UpdateAllocationStepRequestBodyStepTypeEnum;
}

export const UpdateAllocationStepRequestBodyStepTypeEnum = {
    Allocation: 'ALLOCATION',
    Transfer: 'TRANSFER',
} as const;

export type UpdateAllocationStepRequestBodyStepTypeEnum = typeof UpdateAllocationStepRequestBodyStepTypeEnum[keyof typeof UpdateAllocationStepRequestBodyStepTypeEnum];

export interface UpdateAllocationStrategyRequestBody {
    'planId'?: string;
    'ruleId': string;
    'targetType': UpdateAllocationStrategyRequestBodyTargetTypeEnum;
    'yearMonth': string;
}

export const UpdateAllocationStrategyRequestBodyTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;

export type UpdateAllocationStrategyRequestBodyTargetTypeEnum = typeof UpdateAllocationStrategyRequestBodyTargetTypeEnum[keyof typeof UpdateAllocationStrategyRequestBodyTargetTypeEnum];

export interface UpdateAssignmentsParam {
    'departmentIds': Array<string>;
}
export interface UpdateBSReportConditionBody {
    'condition': BSReportConditionSchema;
}
export interface UpdateBoardFilterConditionsRequestBody {
    'boardFilterConditions': Array<DimensionFilter>;
}
export interface UpdateBoardLayoutRequestBody {
    'widgets': Array<WidgetRequestBody>;
}
export interface UpdateBoardRequestBody {
    'name': string;
}
export interface UpdateCFReportConditionBody {
    'condition': CFReportConditionSchema;
}
export interface UpdateCalculatedAccountRequestBody {
    'code': string;
    'formula': string;
    'id': string;
    'name': string;
    'roundingPrecision': UpdateCalculatedAccountRequestBodyRoundingPrecisionEnum;
    'valueFormat': UpdateCalculatedAccountRequestBodyValueFormatEnum;
}

export const UpdateCalculatedAccountRequestBodyRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type UpdateCalculatedAccountRequestBodyRoundingPrecisionEnum = typeof UpdateCalculatedAccountRequestBodyRoundingPrecisionEnum[keyof typeof UpdateCalculatedAccountRequestBodyRoundingPrecisionEnum];
export const UpdateCalculatedAccountRequestBodyValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type UpdateCalculatedAccountRequestBodyValueFormatEnum = typeof UpdateCalculatedAccountRequestBodyValueFormatEnum[keyof typeof UpdateCalculatedAccountRequestBodyValueFormatEnum];

export interface UpdateCfAccountPlTreeRequest {
    'newPlTreeId': string;
}
export interface UpdateCfAccountRequestBody {
    'cashIncreaseDecrease': string;
    'code': string;
    'name': string;
    'referenceAccountIds'?: Array<string>;
}
export interface UpdateCurrentUserEmailNotificationSettingsParam {
    'activeEmailNotificationSources': Array<UpdateCurrentUserEmailNotificationSettingsParamActiveEmailNotificationSourcesEnum>;
}

export const UpdateCurrentUserEmailNotificationSettingsParamActiveEmailNotificationSourcesEnum = {
    PlanningProject: 'PLANNING_PROJECT',
    PlanUpdateRequest: 'PLAN_UPDATE_REQUEST',
    AllocationStandard: 'ALLOCATION_STANDARD',
    ReportComment: 'REPORT_COMMENT',
} as const;

export type UpdateCurrentUserEmailNotificationSettingsParamActiveEmailNotificationSourcesEnum = typeof UpdateCurrentUserEmailNotificationSettingsParamActiveEmailNotificationSourcesEnum[keyof typeof UpdateCurrentUserEmailNotificationSettingsParamActiveEmailNotificationSourcesEnum];

export interface UpdateDashboardEditRestrictedRequestBody {
    'isEditRestricted': boolean;
}
export interface UpdateDashboardRequestBody {
    'name': string;
}
export interface UpdateDepartmentParam {
    'assignments'?: Array<AssignUserDepartmentParam>;
    'code'?: string;
    'externalSystemDepartmentCode'?: string;
    'name'?: string;
}
export interface UpdateDimensionTagsRequestBody {
    'description'?: string;
    'dimensionTagCode': string;
    'dimensionTagName': string;
    'exCodes': Array<string>;
}
export interface UpdateDimensionTreeNameBody {
    'dimensionTreeName': string;
}
export interface UpdateExchangeRateValueRequestParam {
    'data': Array<ExchangeRateCurrencyDataParam>;
    'financialReportType': UpdateExchangeRateValueRequestParamFinancialReportTypeEnum;
}

export const UpdateExchangeRateValueRequestParamFinancialReportTypeEnum = {
    Pl: 'PL',
    Bs: 'BS',
} as const;

export type UpdateExchangeRateValueRequestParamFinancialReportTypeEnum = typeof UpdateExchangeRateValueRequestParamFinancialReportTypeEnum[keyof typeof UpdateExchangeRateValueRequestParamFinancialReportTypeEnum];

export interface UpdateFinancialModelDetailRequest {
    'calculateInActualPeriods': boolean;
    'description'?: string;
    'formulas': Array<UpdateFinancialModelDetailRequestElement>;
    'name': string;
    'parameterAccountIds': Array<string>;
}
export interface UpdateFinancialModelDetailRequestElement {
    'accountId': string;
    'formula': string;
}
export interface UpdateFinancialModelEditRestrictionRequest {
    'isEditRestricted': boolean;
}
export interface UpdateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody {
    'accountIdToHiddenDatasetFormulaIdsMap': { [key: string]: Array<string>; };
}
export interface UpdateFinancialSimulationEditRestrictionRequestBody {
    'isEditRestricted': boolean;
}
export interface UpdateFinancialSimulationEditRestrictionView {
    'isEditRestricted': boolean;
}
export interface UpdateFinancialSimulationNameRequestBody {
    'name': string;
}
export interface UpdateGraphRequestBody {
    'config': CreateGraphRequestBodyConfig;
    'title': string;
    'type': UpdateGraphRequestBodyTypeEnum;
    'viewFilterConditions': Array<DimensionFilter>;
}

export const UpdateGraphRequestBodyTypeEnum = {
    Bar: 'BAR',
    HorizontalBar: 'HORIZONTAL_BAR',
    Line: 'LINE',
    Kpi: 'KPI',
    Combo: 'COMBO',
    Waterfall: 'WATERFALL',
    Pie: 'PIE',
} as const;

export type UpdateGraphRequestBodyTypeEnum = typeof UpdateGraphRequestBodyTypeEnum[keyof typeof UpdateGraphRequestBodyTypeEnum];

export interface UpdateGraphTitleRequestBody {
    'title': string;
}
export interface UpdateOrgTreeNameBody {
    'orgTreeName': string;
}
export interface UpdatePatternRequestBody {
    'name': string;
    'ruleIds': Array<string>;
}
export interface UpdatePersonNameAndCodeRequestBody {
    'firstName': string;
    'lastName': string;
    'personCode': string;
}
export interface UpdatePinnedDataSourcesRequest {
    'dataSourceIds': Array<string>;
}
export interface UpdatePlanMaster {
    'name'?: string;
    'planType'?: UpdatePlanMasterPlanTypeEnum;
}

export const UpdatePlanMasterPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type UpdatePlanMasterPlanTypeEnum = typeof UpdatePlanMasterPlanTypeEnum[keyof typeof UpdatePlanMasterPlanTypeEnum];

export interface UpdatePlanSheetParam {
    'aggregatedViewReportId'?: string;
    'assignedDepartmentIds': Array<string>;
    'condition': SheetConditionSchema;
    'isEditRestricted': boolean;
    'name': string;
}
export interface UpdatePlanUpdateRequestFormatParams {
    'downloadableDepartments': Array<string>;
    'name': string;
}
export interface UpdatePlanUpdateRequestMappingAccountKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': UpdatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum;
}

export const UpdatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type UpdatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum = typeof UpdatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum[keyof typeof UpdatePlanUpdateRequestMappingAccountKeyParamsValueTypeEnum];

export interface UpdatePlanUpdateRequestMappingAmountParams {
    'endColumnIndex'?: number;
    'endRowIndex'?: number;
    'startColumnIndex': number;
    'startRowIndex': number;
}
export interface UpdatePlanUpdateRequestMappingDepartmentKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': UpdatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum;
}

export const UpdatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type UpdatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum = typeof UpdatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum[keyof typeof UpdatePlanUpdateRequestMappingDepartmentKeyParamsValueTypeEnum];

export interface UpdatePlanUpdateRequestMappingDescriptionKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
}
export interface UpdatePlanUpdateRequestMappingDimensionKeyParams {
    'dimensionId': string;
    'mappedTo': PlanUpdateRequestMappingAddress;
    'valueType': UpdatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum;
}

export const UpdatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum = {
    Id: 'ID',
    Name: 'NAME',
    Code: 'CODE',
    ExCode: 'EX_CODE',
} as const;

export type UpdatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum = typeof UpdatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum[keyof typeof UpdatePlanUpdateRequestMappingDimensionKeyParamsValueTypeEnum];

export interface UpdatePlanUpdateRequestMappingFilterParams {
    'conditionType': UpdatePlanUpdateRequestMappingFilterParamsConditionTypeEnum;
    'conditionValue': string;
    'mappedTo': PlanUpdateRequestMappingAddress;
}

export const UpdatePlanUpdateRequestMappingFilterParamsConditionTypeEnum = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Empty: 'EMPTY',
    NotEmpty: 'NOT_EMPTY',
    EqualsAny: 'EQUALS_ANY',
} as const;

export type UpdatePlanUpdateRequestMappingFilterParamsConditionTypeEnum = typeof UpdatePlanUpdateRequestMappingFilterParamsConditionTypeEnum[keyof typeof UpdatePlanUpdateRequestMappingFilterParamsConditionTypeEnum];

export interface UpdatePlanUpdateRequestMappingParams {
    'accountKey': UpdatePlanUpdateRequestMappingAccountKeyParams;
    'amountParams': UpdatePlanUpdateRequestMappingAmountParams;
    'canUseForDownload': boolean;
    'canUseForUpload': boolean;
    'departmentKey': UpdatePlanUpdateRequestMappingDepartmentKeyParams;
    'descriptionKey'?: UpdatePlanUpdateRequestMappingDescriptionKeyParams;
    'dimensionKeys': Array<UpdatePlanUpdateRequestMappingDimensionKeyParams>;
    'filters': Array<UpdatePlanUpdateRequestMappingFilterParams>;
    'name': string;
    'planUpdateRequestMappingUniqueKey'?: string;
    'showNumbersIn'?: UpdatePlanUpdateRequestMappingParamsShowNumbersInEnum;
    'showNumbersInKey'?: UpdatePlanUpdateRequestMappingShowNumbersInKeyParams;
    'yearMonthKey': UpdatePlanUpdateRequestMappingYearMonthKeyParams;
}

export const UpdatePlanUpdateRequestMappingParamsShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type UpdatePlanUpdateRequestMappingParamsShowNumbersInEnum = typeof UpdatePlanUpdateRequestMappingParamsShowNumbersInEnum[keyof typeof UpdatePlanUpdateRequestMappingParamsShowNumbersInEnum];

export interface UpdatePlanUpdateRequestMappingShowNumbersInKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
}
export interface UpdatePlanUpdateRequestMappingYearMonthKeyParams {
    'mappedTo': PlanUpdateRequestMappingAddress;
}
export interface UpdatePlanningProjectParam {
    'assignedDepartments'?: Array<string>;
    'name'?: string;
    'requirePlanMasterAllocatedItems'?: boolean;
    'scheduledPlanningProjectEndAt'?: string;
}
export interface UpdateReportCommentPermissionRequestBody {
    'allowed': UpdateReportCommentPermissionRequestBodyAllowedEnum;
    'allowedUserIds': Array<string>;
}

export const UpdateReportCommentPermissionRequestBodyAllowedEnum = {
    All: 'ALL',
    Restricted: 'RESTRICTED',
} as const;

export type UpdateReportCommentPermissionRequestBodyAllowedEnum = typeof UpdateReportCommentPermissionRequestBodyAllowedEnum[keyof typeof UpdateReportCommentPermissionRequestBodyAllowedEnum];

export interface UpdateReportCommentRequestBody {
    'commentText': string;
}
export interface UpdateReportConditionBody {
    'condition': PLReportConditionSchema;
}
export interface UpdateReportEditRestrictedBody {
    'isEditRestricted': boolean;
}
export interface UpdateReportNameBody {
    'name': string;
}
export interface UpdateRuleRequestBody {
    'dataSourceId': string;
    'name': string;
}
export interface UpdateSettingsParam {
    'activeEmailNotificationSources'?: Array<UpdateSettingsParamActiveEmailNotificationSourcesEnum>;
    'defaultDepartmentIdWhenImportActual'?: string;
    'enableExcelSheetProtectionForPlanUpdateRequest': boolean;
    'enableMasterAutoGenerate': boolean;
    'externalSystemCode': UpdateSettingsParamExternalSystemCodeEnum;
    'firstViewPage': UpdateSettingsParamFirstViewPageEnum;
    'fiscalYearStartMonth'?: number;
    'hideAccountsIfEmptyOnPl'?: boolean;
    'isActiveEmailNotification': boolean;
    'limitPermissionToAddToNewSpreadsheet'?: boolean;
    'roundingMode'?: UpdateSettingsParamRoundingModeEnum;
    'showDecimalPlacesIn'?: UpdateSettingsParamShowDecimalPlacesInEnum;
    'showNumbersIn'?: UpdateSettingsParamShowNumbersInEnum;
    'tableauDashboardUrl'?: string;
    'tableauTargetAccountTreeId'?: string;
}

export const UpdateSettingsParamActiveEmailNotificationSourcesEnum = {
    PlanningProject: 'PLANNING_PROJECT',
    PlanUpdateRequest: 'PLAN_UPDATE_REQUEST',
    AllocationStandard: 'ALLOCATION_STANDARD',
    ReportComment: 'REPORT_COMMENT',
} as const;

export type UpdateSettingsParamActiveEmailNotificationSourcesEnum = typeof UpdateSettingsParamActiveEmailNotificationSourcesEnum[keyof typeof UpdateSettingsParamActiveEmailNotificationSourcesEnum];
export const UpdateSettingsParamExternalSystemCodeEnum = {
    Miroku: 'MIROKU',
    KanjoBugyo: 'KANJO_BUGYO',
    MoneyForward: 'MONEY_FORWARD',
    MoneyForwardPlus: 'MONEY_FORWARD_PLUS',
    Freee: 'FREEE',
    FreeeV2: 'FREEE_V2',
    Obic7: 'OBIC7',
    Yayoi: 'YAYOI',
    Sap: 'SAP',
    SapSalesReport: 'SAP_SALES_REPORT',
    Pca: 'PCA',
    NetSuite: 'NET_SUITE',
    Fx4: 'FX4',
    Fx5: 'FX5',
    BizIntegral: 'BIZ_INTEGRAL',
    Ai21: 'AI21',
    LoglassDepartments: 'LOGLASS_DEPARTMENTS',
    LoglassDetail: 'LOGLASS_DETAIL',
    SuperStream: 'SUPER_STREAM',
    LoglassJournal: 'LOGLASS_JOURNAL',
    Loglass: 'LOGLASS',
    Mapping: 'MAPPING',
    AccountConversion: 'ACCOUNT_CONVERSION',
} as const;

export type UpdateSettingsParamExternalSystemCodeEnum = typeof UpdateSettingsParamExternalSystemCodeEnum[keyof typeof UpdateSettingsParamExternalSystemCodeEnum];
export const UpdateSettingsParamFirstViewPageEnum = {
    FinancialSheetHistory: 'FINANCIAL_SHEET_HISTORY',
    Reports: 'REPORTS',
} as const;

export type UpdateSettingsParamFirstViewPageEnum = typeof UpdateSettingsParamFirstViewPageEnum[keyof typeof UpdateSettingsParamFirstViewPageEnum];
export const UpdateSettingsParamRoundingModeEnum = {
    Down: 'DOWN',
    HalfUp: 'HALF_UP',
} as const;

export type UpdateSettingsParamRoundingModeEnum = typeof UpdateSettingsParamRoundingModeEnum[keyof typeof UpdateSettingsParamRoundingModeEnum];
export const UpdateSettingsParamShowDecimalPlacesInEnum = {
    None: 'NONE',
    One: 'ONE',
    Two: 'TWO',
    Three: 'THREE',
    Four: 'FOUR',
} as const;

export type UpdateSettingsParamShowDecimalPlacesInEnum = typeof UpdateSettingsParamShowDecimalPlacesInEnum[keyof typeof UpdateSettingsParamShowDecimalPlacesInEnum];
export const UpdateSettingsParamShowNumbersInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;

export type UpdateSettingsParamShowNumbersInEnum = typeof UpdateSettingsParamShowNumbersInEnum[keyof typeof UpdateSettingsParamShowNumbersInEnum];

export interface UpdateSimulatingWorkforceBody {
    'param': UpdateSimulatingWorkforceUseCaseParam;
}
export interface UpdateSimulatingWorkforceUseCaseParam {
    'concurrentPosts': Array<ConcurrentPostEventParam>;
    'endDate'?: string;
    'events': Array<EventParam>;
}
export interface UpdateSimulationBaseYearMonthBody {
    'baseYearMonth'?: string;
}
export interface UpdateSimulationBody {
    'name': string;
}
export interface UpdateSimulationNameBody {
    'name': string;
}
export interface UpdateStepOrderRequestBody {
    'stepIds': Array<string>;
}
export interface UpdateStepRequestBody {
    'allocationAxisCondition': AllocationAxisCondition;
    'description'?: string;
    'destinationAccount'?: DestinationAccount;
    'filterConditions': Array<FilterCondition>;
    'loopCondition'?: LoopCondition;
    'name': string;
    'sourceAccounts': SourceAccounts;
    'standardAccounts'?: StandardAccounts;
}
export interface UpdateTextWidgetRequestBody {
    'textContent': string;
}
export interface UpdateTransferStepRequestBody {
    'description'?: string;
    'destinationAccountId'?: string;
    'destinationDepartmentId'?: string;
    'destinationDimensionTagIds': Array<string>;
    'name': string;
    'sourceAccountIds': Array<string>;
    'sourceDepartmentIds': Array<string>;
    'sourceDimensionTagIds': Array<string>;
}
export interface UpdateTransferStepV2RequestBody {
    'description'?: string;
    'destinationAccountCondition'?: TransferSingleAccountCondition;
    'destinationAxisConditions'?: Array<TransferSingleAxisCondition>;
    'name': string;
    'sourceAccountCondition': TransferAccountCondition;
    'sourceAxisConditions'?: Array<TransferAxisCondition>;
}
export interface UpdateUnitPriceMasterItemParam {
    'name': string;
}
export interface UpdateViewPermissionParams {
    'name': string;
    'selectedAccounts': Array<string>;
    'selectedCalculatedAccounts': Array<string>;
    'users': Array<string>;
    'viewableAccountScope': UpdateViewPermissionParamsViewableAccountScopeEnum;
}

export const UpdateViewPermissionParamsViewableAccountScopeEnum = {
    All: 'ALL',
    Selected: 'SELECTED',
} as const;

export type UpdateViewPermissionParamsViewableAccountScopeEnum = typeof UpdateViewPermissionParamsViewableAccountScopeEnum[keyof typeof UpdateViewPermissionParamsViewableAccountScopeEnum];

export interface UpdateWorkforceConversionRuleBody {
    'conversionTiming': UpdateWorkforceConversionRuleBodyConversionTimingEnum;
    'patterns': Array<WorkforceConversionRulePatternBody>;
    'ruleName': string;
    'unitAmountItemId'?: string;
}

export const UpdateWorkforceConversionRuleBodyConversionTimingEnum = {
    Monthly: 'MONTHLY',
    UponJoining: 'UPON_JOINING',
} as const;

export type UpdateWorkforceConversionRuleBodyConversionTimingEnum = typeof UpdateWorkforceConversionRuleBodyConversionTimingEnum[keyof typeof UpdateWorkforceConversionRuleBodyConversionTimingEnum];

export interface UpdateWorkforcePlanningBaseSalaryIncreaseRuleViewBody {
    'increaseRates': Array<IncreaseRateForEachMonthView>;
    'targetAccounts': Array<string>;
}
export interface UpdateWorkforcePlanningItemConversionRulesetBody {
    'description'?: string;
    'name'?: string;
}
export interface UpdateWorkforcePlanningProjectConversionRulesetBody {
    'conversionRulesetId': string;
}
export interface UpdateWorkforceSimulationSlotBody {
    'departmentId'?: string;
    'dimensionIdToTagIdMap': { [key: string]: string; };
    'inDepartmentId'?: string;
    'outDepartmentId'?: string;
    'simulatingSlotId': string;
    'unitAmountItems': Array<WorkforceSimulationSlotBodyUnitAmountItem>;
    'yearMonthToRemainingCounts': Array<UpdateWorkforceSimulationSlotBodyRemainingCount>;
}
export interface UpdateWorkforceSimulationSlotBodyRemainingCount {
    'remainingCount': number;
    'yearMonth': string;
}
export interface UpdateWorkforceSlotNameAndCodeRequestBody {
    'slotType': UpdateWorkforceSlotNameAndCodeRequestBodySlotTypeEnum;
    'workforceSlotCode': string;
    'workforceSlotName': string;
}

export const UpdateWorkforceSlotNameAndCodeRequestBodySlotTypeEnum = {
    Hiring: 'HIRING',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    TransferDepartment: 'TRANSFER_DEPARTMENT',
} as const;

export type UpdateWorkforceSlotNameAndCodeRequestBodySlotTypeEnum = typeof UpdateWorkforceSlotNameAndCodeRequestBodySlotTypeEnum[keyof typeof UpdateWorkforceSlotNameAndCodeRequestBodySlotTypeEnum];

export interface UpdateWorkforceSlotStartYearMonthParam {
    'yearMonth'?: string;
}
export interface UpdateWorkforceSlotUnitAmountTableBody {
    'attributes': Array<WorkforceSlotUnitAmountTableAttributeBody>;
    'items': Array<WorkforceSlotUnitAmountTableItemBody>;
    'name': string;
    'records': Array<WorkforceSlotUnitAmountRecordBody>;
}
export interface UploadActualByMappingParams {
    'actualImportMappingId': string;
    'processSettingId': string;
    'subsidiaryCode': string;
}
export interface UploadExcelParams {
    'planningProjectId': string;
}
export interface UploadExcelPlanUpdateParams {
    'mappingSheetIndexList': Array<MappingSheetIndex>;
    'planningProjectId': string;
}
export interface UploadNonFinancialItemsParams {
    'actualImportMappingId': string;
    'processSettingId': string;
}
export interface UploadRuleStepStandardExcelRequest {
    'file'?: File;
}
export interface UpsertDimensionRequestBody {
    'dimensionName': string;
    'importColumnName': string;
}
export interface UpsertFinancialSimulationConditionRequestBody {
    'content': FinancialSimulationConditionContentRequest;
    'schemaVersion': number;
}
export interface UpsertFinancialSimulationConditionResponse {
    'warnings': Array<FinancialSimulationConditionWarningView>;
}
export interface UpsertFinancialSimulationDatasetFormulaRequestBody {
    'name': string;
    'roundingPrecision': UpsertFinancialSimulationDatasetFormulaRequestBodyRoundingPrecisionEnum;
    'scenarioId': string;
    'value': string;
    'valueFormat': UpsertFinancialSimulationDatasetFormulaRequestBodyValueFormatEnum;
}

export const UpsertFinancialSimulationDatasetFormulaRequestBodyRoundingPrecisionEnum = {
    None: 'NONE',
    ToOneDecimal: 'TO_ONE_DECIMAL',
    ToTwoDecimals: 'TO_TWO_DECIMALS',
    ToThreeDecimals: 'TO_THREE_DECIMALS',
    ToFourDecimals: 'TO_FOUR_DECIMALS',
} as const;

export type UpsertFinancialSimulationDatasetFormulaRequestBodyRoundingPrecisionEnum = typeof UpsertFinancialSimulationDatasetFormulaRequestBodyRoundingPrecisionEnum[keyof typeof UpsertFinancialSimulationDatasetFormulaRequestBodyRoundingPrecisionEnum];
export const UpsertFinancialSimulationDatasetFormulaRequestBodyValueFormatEnum = {
    Amount: 'AMOUNT',
    Percentage: 'PERCENTAGE',
    Other: 'OTHER',
} as const;

export type UpsertFinancialSimulationDatasetFormulaRequestBodyValueFormatEnum = typeof UpsertFinancialSimulationDatasetFormulaRequestBodyValueFormatEnum[keyof typeof UpsertFinancialSimulationDatasetFormulaRequestBodyValueFormatEnum];

export interface UpsertFinancialSimulationDescriptionBody {
    'content': string;
}
export interface UpsertUnitAmountItemParam {
    'name': string;
}
export interface UpsertUnitPriceMasterItemDimensionMappingRequest {
    'dimensionId': string;
}
export interface UpsertWorkforceActualImportMappingSettingParam {
    'headerRowIndex': number;
    'name': string;
    'workforceActualImportMappingTargetDimensions': Array<CreateWorkforceActualImportMappingTargetDimensionParam>;
    'workforceActualImportMappingTargets': Array<CreateWorkforceActualImportMappingTargetParam>;
    'workforceActualImportRowFilters': Array<CreateWorkforceActualImportRowFilterParam>;
}
export interface UserNameView {
    'fullName': string;
    'userId': string;
}
export interface UserView {
    'emailAddress': string;
    'firstName': string;
    'id': string;
    'isDeleted': boolean;
    'lastName': string;
    'requireMFA': boolean;
    'role': UserViewRoleEnum;
}

export const UserViewRoleEnum = {
    LoglassSystemAdmin: 'LOGLASS_SYSTEM_ADMIN',
    TenantAdmin: 'TENANT_ADMIN',
    CorpPlanning: 'CORP_PLANNING',
    Manager: 'MANAGER',
    ItStaff: 'IT_STAFF',
    General: 'GENERAL',
} as const;

export type UserViewRoleEnum = typeof UserViewRoleEnum[keyof typeof UserViewRoleEnum];

export interface UserWithDepartmentNamesDto {
    'departmentNames': Array<string>;
    'emailAddress': string;
    'firstName': string;
    'id': string;
    'isDeleted': boolean;
    'lastName': string;
    'mfaMethod'?: UserWithDepartmentNamesDtoMfaMethodEnum;
    'requireMFA': boolean;
    'role': UserWithDepartmentNamesDtoRoleEnum;
    'totalDepartmentCount': number;
}

export const UserWithDepartmentNamesDtoMfaMethodEnum = {
    Totp: 'TOTP',
    Email: 'EMAIL',
} as const;

export type UserWithDepartmentNamesDtoMfaMethodEnum = typeof UserWithDepartmentNamesDtoMfaMethodEnum[keyof typeof UserWithDepartmentNamesDtoMfaMethodEnum];
export const UserWithDepartmentNamesDtoRoleEnum = {
    LoglassSystemAdmin: 'LOGLASS_SYSTEM_ADMIN',
    TenantAdmin: 'TENANT_ADMIN',
    CorpPlanning: 'CORP_PLANNING',
    Manager: 'MANAGER',
    ItStaff: 'IT_STAFF',
    General: 'GENERAL',
} as const;

export type UserWithDepartmentNamesDtoRoleEnum = typeof UserWithDepartmentNamesDtoRoleEnum[keyof typeof UserWithDepartmentNamesDtoRoleEnum];

export interface UserWithMfaMethodView {
    'emailAddress': string;
    'firstName': string;
    'id': string;
    'isDeleted': boolean;
    'lastName': string;
    'mfaMethod'?: UserWithMfaMethodViewMfaMethodEnum;
    'requireMFA': boolean;
    'role': UserWithMfaMethodViewRoleEnum;
}

export const UserWithMfaMethodViewMfaMethodEnum = {
    Totp: 'TOTP',
    Email: 'EMAIL',
} as const;

export type UserWithMfaMethodViewMfaMethodEnum = typeof UserWithMfaMethodViewMfaMethodEnum[keyof typeof UserWithMfaMethodViewMfaMethodEnum];
export const UserWithMfaMethodViewRoleEnum = {
    LoglassSystemAdmin: 'LOGLASS_SYSTEM_ADMIN',
    TenantAdmin: 'TENANT_ADMIN',
    CorpPlanning: 'CORP_PLANNING',
    Manager: 'MANAGER',
    ItStaff: 'IT_STAFF',
    General: 'GENERAL',
} as const;

export type UserWithMfaMethodViewRoleEnum = typeof UserWithMfaMethodViewRoleEnum[keyof typeof UserWithMfaMethodViewRoleEnum];

export interface ValidateAllocationStepRequestBody {
    'allocationAxisCondition': AllocationAxisCondition;
    'description'?: string;
    'destinationAccount'?: DestinationAccount;
    'filterConditions': Array<FilterCondition>;
    'loopCondition'?: LoopCondition;
    'name': string;
    'sourceAccounts': SourceAccounts;
    'standardAccounts'?: StandardAccounts;
}
export interface ValidateAllocationStepView {
    'isValid': boolean;
}
export interface ValidateBoardFilterRequest {
    'filters': Array<DimensionFilter>;
}
export interface ValidateCompositeReportTableBody {
    'layout': CompositeReportLayoutRequest;
}
export interface ValidateTransferStepRequestBody {
    'description'?: string;
    'destinationAccountCondition'?: TransferSingleAccountCondition;
    'destinationAxisConditions'?: Array<TransferSingleAxisCondition>;
    'name': string;
    'sourceAccountCondition'?: TransferAccountCondition;
    'sourceAxisConditions'?: Array<TransferAxisCondition>;
}
export interface ValidateTransferStepView {
    'isValid': boolean;
}
export interface VerifyDepartmentDataRequestParam {
    'departmentIds': Array<string>;
}
export interface VerifyDepartmentDataResult {
    'isExistData': boolean;
}
export interface View {
    'cellCount': number;
    'deltas': Array<Delta>;
    'metric': Metric;
    'metricUniqueKey'?: GraphUniqueKeyView;
    'reportMetadata'?: GraphReportMetadata;
    'sourceReportId': string;
    'title': string;
}
export interface ViewPermission {
    'createdAt': DateTimeData;
    'createdUser': IDImpl;
    'id': IDImpl;
    'isViewableWorkforceDimensionId': boolean;
    'name': NameVO;
    'selectedAccounts': Array<IDImpl>;
    'selectedCalculatedAccounts': Array<IDImpl>;
    'updatedAt': DateTimeData;
    'updatedUser': IDImpl;
    'users': Array<IDImpl>;
    'viewableAccountScope': ViewPermissionViewableAccountScopeEnum;
}

export const ViewPermissionViewableAccountScopeEnum = {
    All: 'ALL',
    Selected: 'SELECTED',
} as const;

export type ViewPermissionViewableAccountScopeEnum = typeof ViewPermissionViewableAccountScopeEnum[keyof typeof ViewPermissionViewableAccountScopeEnum];

export interface ViewPermissionUsersForSelectionView {
    'departmentNames': Array<string>;
    'firstName': string;
    'lastName': string;
    'userId': string;
    'viewPermissionId'?: string;
}
export interface ViewPermissionView {
    'id': IDImpl;
    'name': string;
    'updatedAt': string;
    'viewableAccountScope': ViewPermissionViewViewableAccountScopeEnum;
}

export const ViewPermissionViewViewableAccountScopeEnum = {
    All: 'ALL',
    Selected: 'SELECTED',
} as const;

export type ViewPermissionViewViewableAccountScopeEnum = typeof ViewPermissionViewViewableAccountScopeEnum[keyof typeof ViewPermissionViewViewableAccountScopeEnum];

export interface WaterfallChartConfig {
    'endAccountId': string;
    'legendPosition'?: WaterfallChartConfigLegendPositionEnum;
    'selectedColumnId': string;
    'selectedDataConditionId': string;
    'selectedRow1Id'?: string;
    'selectedRowIds': Array<string>;
    'showCumulativeRow': boolean;
    'showDataLabels': boolean;
    'startAccountId': string;
    'waterfallType': WaterfallChartConfigWaterfallTypeEnum;
    'yaxisLabel': string;
    'yaxisMax'?: number;
    'yaxisMin'?: number;
}

export const WaterfallChartConfigLegendPositionEnum = {
    Right: 'RIGHT',
    Left: 'LEFT',
    Top: 'TOP',
    Bottom: 'BOTTOM',
    Hidden: 'HIDDEN',
} as const;

export type WaterfallChartConfigLegendPositionEnum = typeof WaterfallChartConfigLegendPositionEnum[keyof typeof WaterfallChartConfigLegendPositionEnum];
export const WaterfallChartConfigWaterfallTypeEnum = {
    Transition: 'TRANSITION',
    Comparison: 'COMPARISON',
} as const;

export type WaterfallChartConfigWaterfallTypeEnum = typeof WaterfallChartConfigWaterfallTypeEnum[keyof typeof WaterfallChartConfigWaterfallTypeEnum];

export interface WaterfallDataView {
    'amountAxisUnitLabel': string;
    'cellCount': number;
    'points': Array<WaterfallPoint>;
    'reportMetadata'?: GraphReportMetadata;
}
export interface WaterfallInitialValuesResult {
    'endAccountId': string;
    'selectedColumnId': string;
    'selectedDataConditionId': string;
    'selectedRow1Id': string;
    'selectedRowIds': Array<string>;
    'startAccountId': string;
    'waterfallType': string;
}
export interface WaterfallPoint {
    'absoluteValue': string;
    'chartAbsoluteValue': string;
    'chartAbsoluteValueUnscaled'?: string;
    'chartDataUnscaledUnit': string;
    'displayAbsoluteValue': string;
    'id': string;
    'label': string;
    'legendLabel': string;
    'sign': WaterfallPointSignEnum;
    'tooltipContext': TooltipContext;
    'type': WaterfallPointTypeEnum;
    'uniqueKey'?: GraphUniqueKeyView;
}

export const WaterfallPointSignEnum = {
    Positive: 'POSITIVE',
    Negative: 'NEGATIVE',
} as const;

export type WaterfallPointSignEnum = typeof WaterfallPointSignEnum[keyof typeof WaterfallPointSignEnum];
export const WaterfallPointTypeEnum = {
    Start: 'START',
    End: 'END',
    SubTotal: 'SUB_TOTAL',
    Delta: 'DELTA',
} as const;

export type WaterfallPointTypeEnum = typeof WaterfallPointTypeEnum[keyof typeof WaterfallPointTypeEnum];

export interface WaterfallPreviewRequest {
    'endAccountId': string;
    'reportId': string;
    'selectedColumnId': string;
    'selectedDataConditionId': WaterfallPreviewRequestSelectedDataConditionIdEnum;
    'selectedRow1Id'?: string;
    'selectedRowIds': Array<string>;
    'showCumulativeRow': boolean;
    'startAccountId': string;
    'viewFilterConditions'?: Array<DimensionFilter>;
    'waterfallType': WaterfallPreviewRequestWaterfallTypeEnum;
}

export const WaterfallPreviewRequestSelectedDataConditionIdEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type WaterfallPreviewRequestSelectedDataConditionIdEnum = typeof WaterfallPreviewRequestSelectedDataConditionIdEnum[keyof typeof WaterfallPreviewRequestSelectedDataConditionIdEnum];
export const WaterfallPreviewRequestWaterfallTypeEnum = {
    Transition: 'TRANSITION',
    Comparison: 'COMPARISON',
} as const;

export type WaterfallPreviewRequestWaterfallTypeEnum = typeof WaterfallPreviewRequestWaterfallTypeEnum[keyof typeof WaterfallPreviewRequestWaterfallTypeEnum];

export interface WaterfallSelectableAccountsResult {
    'endEnabledIds': Array<string>;
    'middleEnabledIds': Array<string>;
}
export interface Widget {
    'boardId': IDImpl;
    'contentId': string;
    'displaySettings'?: WidgetDisplaySettings;
    'id': IDImpl;
    'layoutPositions': WidgetLayoutPositions;
    'sourceSheetType'?: WidgetSourceSheetTypeEnum;
    'type': WidgetTypeEnum;
}

export const WidgetSourceSheetTypeEnum = {
    Pl: 'PL',
    Bs: 'BS',
    Cf: 'CF',
} as const;

export type WidgetSourceSheetTypeEnum = typeof WidgetSourceSheetTypeEnum[keyof typeof WidgetSourceSheetTypeEnum];
export const WidgetTypeEnum = {
    Graph: 'GRAPH',
    Table: 'TABLE',
    Text: 'TEXT',
    KpiCard: 'KPI_CARD',
    CompositeTable: 'COMPOSITE_TABLE',
    ComboChart: 'COMBO_CHART',
    WaterfallChart: 'WATERFALL_CHART',
    PieChart: 'PIE_CHART',
} as const;

export type WidgetTypeEnum = typeof WidgetTypeEnum[keyof typeof WidgetTypeEnum];

export interface WidgetDisplaySettings {
    'graphSettings'?: GraphDisplaySettings;
    'kpiSettings'?: KpiDisplaySettings;
    'tableSettings'?: TableDisplaySettings;
}
export interface WidgetDisplaySettingsRequestBody {
    'graphSettings'?: GraphDisplaySettingsRequestBody;
    'kpiSettings'?: KpiDisplaySettingsRequestBody;
    'tableSettings'?: TableDisplaySettingsRequestBody;
}
export interface WidgetLayoutPositions {
    'lg': LayoutPosition;
    'md': LayoutPosition;
    'sm': LayoutPosition;
    'xs': LayoutPosition;
    'xxs': LayoutPosition;
}
export interface WidgetRequestBody {
    'compositeTableLayout'?: Array<Array<ComponentTableRequestBody>>;
    'contentId': string;
    'displaySettings'?: WidgetDisplaySettingsRequestBody;
    'layoutPositions': WidgetLayoutPositions;
    'sourceSheetType'?: WidgetRequestBodySourceSheetTypeEnum;
    'textContent'?: string;
    'type': WidgetRequestBodyTypeEnum;
}

export const WidgetRequestBodySourceSheetTypeEnum = {
    Pl: 'PL',
    Bs: 'BS',
    Cf: 'CF',
} as const;

export type WidgetRequestBodySourceSheetTypeEnum = typeof WidgetRequestBodySourceSheetTypeEnum[keyof typeof WidgetRequestBodySourceSheetTypeEnum];
export const WidgetRequestBodyTypeEnum = {
    Graph: 'GRAPH',
    Table: 'TABLE',
    Text: 'TEXT',
    KpiCard: 'KPI_CARD',
    CompositeTable: 'COMPOSITE_TABLE',
    ComboChart: 'COMBO_CHART',
    WaterfallChart: 'WATERFALL_CHART',
    PieChart: 'PIE_CHART',
} as const;

export type WidgetRequestBodyTypeEnum = typeof WidgetRequestBodyTypeEnum[keyof typeof WidgetRequestBodyTypeEnum];

export interface WidgetView {
    'compositeTableLayout'?: CompositeTableWidget;
    'textWidget'?: TextWidget;
    'widget': Widget;
}
export interface WorkforceActualAppliedEventView {
    'actualImportEventFileName': string;
    'createdAt': string;
    'createdByUserName': string;
    'errorMessage'?: string;
    'id': string;
    'status': WorkforceActualAppliedEventViewStatusEnum;
}

export const WorkforceActualAppliedEventViewStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
} as const;

export type WorkforceActualAppliedEventViewStatusEnum = typeof WorkforceActualAppliedEventViewStatusEnum[keyof typeof WorkforceActualAppliedEventViewStatusEnum];

export interface WorkforceActualClosingHistoryView {
    'closableFiscalMonths': Array<string>;
    'latestClosingFiscalMonth': string;
    'openableFiscalMonths': Array<string>;
}
export interface WorkforceActualClosingJobAcceptedView {
    'jobId': string;
}
export interface WorkforceActualClosingJobDto {
    'endYearMonth': string;
    'errorMessage'?: string;
    'id': string;
    'processedYearMonth'?: string;
    'startYearMonth': string;
    'status': WorkforceActualClosingJobDtoStatusEnum;
    'type': WorkforceActualClosingJobDtoTypeEnum;
}

export const WorkforceActualClosingJobDtoStatusEnum = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
} as const;

export type WorkforceActualClosingJobDtoStatusEnum = typeof WorkforceActualClosingJobDtoStatusEnum[keyof typeof WorkforceActualClosingJobDtoStatusEnum];
export const WorkforceActualClosingJobDtoTypeEnum = {
    Close: 'CLOSE',
    Open: 'OPEN',
} as const;

export type WorkforceActualClosingJobDtoTypeEnum = typeof WorkforceActualClosingJobDtoTypeEnum[keyof typeof WorkforceActualClosingJobDtoTypeEnum];

export interface WorkforceActualClosingJobLatestView {
    'job'?: WorkforceActualClosingJobDto;
}
export interface WorkforceActualCurrentDepartmentDto {
    'id': string;
    'name'?: string;
}
export interface WorkforceActualCurrentDimensionTagDto {
    'dimensionId': string;
    'dimensionName': string;
    'dimensionTagId'?: string;
    'dimensionTagName'?: string;
}
export interface WorkforceActualCurrentDto {
    'department'?: WorkforceActualCurrentDepartmentDto;
    'dimensionTags': Array<WorkforceActualCurrentDimensionTagDto>;
    'employmentStatus': WorkforceActualCurrentDtoEmploymentStatusEnum;
    'yearMonth': string;
}

export const WorkforceActualCurrentDtoEmploymentStatusEnum = {
    Unenrolled: 'UNENROLLED',
    Active: 'ACTIVE',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    Resigned: 'RESIGNED',
} as const;

export type WorkforceActualCurrentDtoEmploymentStatusEnum = typeof WorkforceActualCurrentDtoEmploymentStatusEnum[keyof typeof WorkforceActualCurrentDtoEmploymentStatusEnum];

export interface WorkforceActualDto {
    'closingYearMonth': string;
    'endDate'?: string;
    'eventByEffectiveYearMonth': Array<WorkforceActualEventByYearMonthDto>;
    'firstName': string;
    'lastName': string;
    'leaveOfAbsencePeriods': Array<WorkforceActualLeaveOfAbsencePeriodDto>;
    'personCode': string;
    'startDate': string;
    'started': WorkforceActualStartedDto;
    'workforceId': string;
}
export interface WorkforceActualEventByYearMonthDto {
    'effectiveYearMonth': string;
    'events': Array<WorkforceActualEventDto>;
}
export interface WorkforceActualEventDto {
    'departmentId'?: string;
    'departmentName'?: string;
    'dimensionId'?: string;
    'dimensionTagId'?: string;
    'dimensionTagName'?: string;
    'eventType': WorkforceActualEventDtoEventTypeEnum;
}

export const WorkforceActualEventDtoEventTypeEnum = {
    DepartmentChanged: 'DEPARTMENT_CHANGED',
    DimensionTagChanged: 'DIMENSION_TAG_CHANGED',
} as const;

export type WorkforceActualEventDtoEventTypeEnum = typeof WorkforceActualEventDtoEventTypeEnum[keyof typeof WorkforceActualEventDtoEventTypeEnum];

export interface WorkforceActualImportMappingSettingListItem {
    'mappingSettingId': string;
    'mappingSettingName': string;
    'updatedAt': string;
}
export interface WorkforceActualImportMappingSettingView {
    'headerRowNumber': number;
    'importMappingTargetDimensions': Array<WorkforceActualImportMappingTargetDimensionView>;
    'importRowFilters': Array<WorkforceActualImportRowFilterView>;
    'name': string;
    'optionalImportMappingTargets': Array<WorkforceActualImportMappingTargetView>;
    'requiredImportMappingTargets': Array<WorkforceActualImportMappingTargetView>;
}
export interface WorkforceActualImportMappingTargetDimensionView {
    'columnAlphabet'?: string;
    'dimensionId': string;
    'dimensionName': string;
}
export interface WorkforceActualImportMappingTargetView {
    'columnAlphabet'?: string;
    'type': WorkforceActualImportMappingTargetViewTypeEnum;
}

export const WorkforceActualImportMappingTargetViewTypeEnum = {
    WorkforceCode: 'WORKFORCE_CODE',
    LastName: 'LAST_NAME',
    FirstName: 'FIRST_NAME',
    StartDate: 'START_DATE',
    EndDate: 'END_DATE',
    LeaveOfAbsenceMonth: 'LEAVE_OF_ABSENCE_MONTH',
    ReturnToWorkMonth: 'RETURN_TO_WORK_MONTH',
    ExternalSystemDepartmentCode: 'EXTERNAL_SYSTEM_DEPARTMENT_CODE',
    EffectiveDate: 'EFFECTIVE_DATE',
} as const;

export type WorkforceActualImportMappingTargetViewTypeEnum = typeof WorkforceActualImportMappingTargetViewTypeEnum[keyof typeof WorkforceActualImportMappingTargetViewTypeEnum];

export interface WorkforceActualImportRowFilterView {
    'columnAlphabet': string;
    'conditionType': WorkforceActualImportRowFilterViewConditionTypeEnum;
    'conditionValue'?: string;
}

export const WorkforceActualImportRowFilterViewConditionTypeEnum = {
    Equal: 'EQUAL',
    NotEqual: 'NOT_EQUAL',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    StartsWith: 'STARTS_WITH',
    EndsWith: 'ENDS_WITH',
    Entered: 'ENTERED',
    NotEntered: 'NOT_ENTERED',
} as const;

export type WorkforceActualImportRowFilterViewConditionTypeEnum = typeof WorkforceActualImportRowFilterViewConditionTypeEnum[keyof typeof WorkforceActualImportRowFilterViewConditionTypeEnum];

export interface WorkforceActualLeaveOfAbsencePeriodDto {
    'leaveYearMonth': string;
    'returnYearMonth'?: string;
}
export interface WorkforceActualStartedDimensionTagDto {
    'dimensionId': string;
    'dimensionTagId': string;
    'dimensionTagName'?: string;
}
export interface WorkforceActualStartedDto {
    'departmentId': string;
    'departmentName'?: string;
    'dimensionIdToTagIds': Array<WorkforceActualStartedDimensionTagDto>;
}
export interface WorkforceActualUploadEventView {
    'createdAt': string;
    'createdBy': string;
    'fileName': string;
    'id': string;
    'periodEndMonth': string;
    'periodStartMonth': string;
}
export interface WorkforceConversionRuleConditionDetailView {
    'condition': WorkforceConversionRuleConditionDetailViewConditionEnum;
    'dimensionId'?: string;
    'ids': Array<string>;
}

export const WorkforceConversionRuleConditionDetailViewConditionEnum = {
    Department: 'DEPARTMENT',
    Dimension: 'DIMENSION',
} as const;

export type WorkforceConversionRuleConditionDetailViewConditionEnum = typeof WorkforceConversionRuleConditionDetailViewConditionEnum[keyof typeof WorkforceConversionRuleConditionDetailViewConditionEnum];

export interface WorkforceConversionRulePatternBody {
    'conditions': Array<WorkforceConversionRuleConditionDetailView>;
    'eachMonthFixedPattern'?: EachMonthFixedPatternBody;
    'eachMonthRatioPattern'?: EachMonthRatioPatternBody;
    'eachMonthRealValuePattern'?: EachMonthRealValuePatternBody;
    'excludePattern'?: ExcludePatternBody;
    'fixedPattern'?: FixedPatternBody;
    'patternType': WorkforceConversionRulePatternBodyPatternTypeEnum;
    'ratioPattern'?: RatioPatternBody;
    'realValuePattern'?: RealValuePatternBody;
}

export const WorkforceConversionRulePatternBodyPatternTypeEnum = {
    Ratio: 'RATIO',
    RealValue: 'REAL_VALUE',
    Fixed: 'FIXED',
    EachMonthRatio: 'EACH_MONTH_RATIO',
    EachMonthRealValue: 'EACH_MONTH_REAL_VALUE',
    EachMonthFixed: 'EACH_MONTH_FIXED',
    Exclude: 'EXCLUDE',
} as const;

export type WorkforceConversionRulePatternBodyPatternTypeEnum = typeof WorkforceConversionRulePatternBodyPatternTypeEnum[keyof typeof WorkforceConversionRulePatternBodyPatternTypeEnum];

export interface WorkforceConversionRulePatternView {
    'conditions': Array<WorkforceConversionRuleConditionDetailView>;
    'eachMonthFixedPattern'?: EachMonthFixedPatternView;
    'eachMonthRatioPattern'?: EachMonthRatioPatternView;
    'eachMonthRealValuePattern'?: EachMonthRealValuePatternView;
    'excludePattern'?: ExcludePatternView;
    'fixedPattern'?: FixedPatternView;
    'patternType': WorkforceConversionRulePatternViewPatternTypeEnum;
    'ratioPattern'?: RatioPatternView;
    'realValuePattern'?: RealValuePatternView;
}

export const WorkforceConversionRulePatternViewPatternTypeEnum = {
    Ratio: 'RATIO',
    RealValue: 'REAL_VALUE',
    Fixed: 'FIXED',
    EachMonthRatio: 'EACH_MONTH_RATIO',
    EachMonthRealValue: 'EACH_MONTH_REAL_VALUE',
    EachMonthFixed: 'EACH_MONTH_FIXED',
    Exclude: 'EXCLUDE',
} as const;

export type WorkforceConversionRulePatternViewPatternTypeEnum = typeof WorkforceConversionRulePatternViewPatternTypeEnum[keyof typeof WorkforceConversionRulePatternViewPatternTypeEnum];

export interface WorkforceDimensionView {
    'dimensionId': string;
    'dimensionName': string;
    'dimensionNumber': number;
    'importColumnName': string;
}
export interface WorkforceEmploymentDetails {
    'concurrentPostRatioInfos': Array<ConcurrentPostRatioInfosView>;
    'departmentName'?: string;
    'dimensionTagInfos': Array<DimensionTagInfoView>;
    'employmentStatus': WorkforceEmploymentDetailsEmploymentStatusEnum;
    'isEmptyHistory': boolean;
    'slotInfo'?: SlotInfoView;
    'toDepartmentName'?: string;
    'unitAmounts': Array<UnitAmountView>;
}

export const WorkforceEmploymentDetailsEmploymentStatusEnum = {
    Active: 'ACTIVE',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    Resignation: 'RESIGNATION',
} as const;

export type WorkforceEmploymentDetailsEmploymentStatusEnum = typeof WorkforceEmploymentDetailsEmploymentStatusEnum[keyof typeof WorkforceEmploymentDetailsEmploymentStatusEnum];

export interface WorkforcePlanChangeEventAssignedInfoView {
    'departmentName'?: string;
    'dimensionTagNames': Array<string>;
    'leaveOfAbsenceEvent'?: WorkforcePlanChangeEventAssignedInfoViewLeaveOfAbsenceEventEnum;
    'ratio'?: string;
    'remainingSlotCount'?: number;
    'remainingSlotYearMonth'?: string;
    'toDepartmentName'?: string;
    'unitAmounts': Array<UnitAmountView>;
    'usedSlotCount'?: number;
}

export const WorkforcePlanChangeEventAssignedInfoViewLeaveOfAbsenceEventEnum = {
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnFromLeaveOfAbsence: 'RETURN_FROM_LEAVE_OF_ABSENCE',
} as const;

export type WorkforcePlanChangeEventAssignedInfoViewLeaveOfAbsenceEventEnum = typeof WorkforcePlanChangeEventAssignedInfoViewLeaveOfAbsenceEventEnum[keyof typeof WorkforcePlanChangeEventAssignedInfoViewLeaveOfAbsenceEventEnum];

export interface WorkforcePlanChangeEventByYearMonthView {
    'events': Array<WorkforcePlanChangeEventView>;
    'yearMonth': string;
}
export interface WorkforcePlanChangeEventView {
    'assignedInfo': WorkforcePlanChangeEventAssignedInfoView;
    'cancelled': boolean;
    'changeType': WorkforcePlanChangeEventViewChangeTypeEnum;
    'date'?: string;
}

export const WorkforcePlanChangeEventViewChangeTypeEnum = {
    Start: 'START',
    Update: 'UPDATE',
    End: 'END',
    ConcurrentPostStart: 'CONCURRENT_POST_START',
    ConcurrentPostRelease: 'CONCURRENT_POST_RELEASE',
    ResignationSlot: 'RESIGNATION_SLOT',
    HiringSlot: 'HIRING_SLOT',
    LeaveOfAbsenceSlot: 'LEAVE_OF_ABSENCE_SLOT',
    ReturnToWorkSlot: 'RETURN_TO_WORK_SLOT',
    TransferDepartmentSlot: 'TRANSFER_DEPARTMENT_SLOT',
    UnitAmountChanged: 'UNIT_AMOUNT_CHANGED',
    CancelledStart: 'CANCELLED_START',
    StartDateChanged: 'START_DATE_CHANGED',
    EndDateChanged: 'END_DATE_CHANGED',
} as const;

export type WorkforcePlanChangeEventViewChangeTypeEnum = typeof WorkforcePlanChangeEventViewChangeTypeEnum[keyof typeof WorkforcePlanChangeEventViewChangeTypeEnum];

export interface WorkforcePlanUpdateRequestCalculationStatusView {
    'errorMessages': Array<string>;
    'isCalculationWorkforcePlanUpdateRequest': boolean;
}
export interface WorkforcePlanUpdateRequestEventByWorkforceView {
    'eventByYearMonth': Array<WorkforcePlanChangeEventByYearMonthView>;
    'workforceName': string;
    'workforceOrSlotId': string;
}
export interface WorkforcePlanUpdateRequestEventsView {
    'items': Array<WorkforcePlanUpdateRequestEventByWorkforceView>;
}
export interface WorkforcePlanUpdateRequestPLView {
    'hasRestrictedItems': boolean;
    'items': Array<PlanUpdateRequestTreeNodeFlatV2View>;
    'periods': Array<PlanUpdateRequestPeriodView>;
    'planType': WorkforcePlanUpdateRequestPLViewPlanTypeEnum;
    'targetDepartmentNames': Array<string>;
}

export const WorkforcePlanUpdateRequestPLViewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type WorkforcePlanUpdateRequestPLViewPlanTypeEnum = typeof WorkforcePlanUpdateRequestPLViewPlanTypeEnum[keyof typeof WorkforcePlanUpdateRequestPLViewPlanTypeEnum];

export interface WorkforcePlanUpdateRequestSourceView {
    'simulationId'?: string;
    'type': WorkforcePlanUpdateRequestSourceViewTypeEnum;
}

export const WorkforcePlanUpdateRequestSourceViewTypeEnum = {
    Simulation: 'SIMULATION',
    WorkforcePlanningSimulation: 'WORKFORCE_PLANNING_SIMULATION',
    File: 'FILE',
    SyncWithActual: 'SYNC_WITH_ACTUAL',
} as const;

export type WorkforcePlanUpdateRequestSourceViewTypeEnum = typeof WorkforcePlanUpdateRequestSourceViewTypeEnum[keyof typeof WorkforcePlanUpdateRequestSourceViewTypeEnum];

export interface WorkforcePlanUpdateRequestStatusesView {
    'errorMessages': Array<ApproveErrorMessage>;
    'hasApproving': boolean;
}
export interface WorkforcePlanUpdateRequestView {
    'approvalFailedMessages': Array<string>;
    'createdAt': string;
    'createdUserId': string;
    'createdUserName': string;
    'departmentName': string;
    'planMasterName': string;
    'planningProjectName': string;
    'source'?: WorkforcePlanUpdateRequestSourceView;
    'status': WorkforcePlanUpdateRequestViewStatusEnum;
    'workforcePlanUpdateRequestId': string;
}

export const WorkforcePlanUpdateRequestViewStatusEnum = {
    Open: 'OPEN',
    Closed: 'CLOSED',
    Closing: 'CLOSING',
    ApprovalFailed: 'APPROVAL_FAILED',
} as const;

export type WorkforcePlanUpdateRequestViewStatusEnum = typeof WorkforcePlanUpdateRequestViewStatusEnum[keyof typeof WorkforcePlanUpdateRequestViewStatusEnum];

export interface WorkforcePlanUpdateRequestWorkforceDetailByYearMonthView {
    'employmentDetails'?: WorkforceEmploymentDetails;
    'workforceName': string;
    'yearMonth': string;
}
export interface WorkforcePlanUpdateRequestWorkforceDiffView {
    'hiringSlotSubTotal': SubTotalRow;
    'leaveOfAbsenceSlotSubTotal': SubTotalRow;
    'personSubTotal': SubTotalRow;
    'planType': WorkforcePlanUpdateRequestWorkforceDiffViewPlanTypeEnum;
    'resignationSlotSubTotal': SubTotalRow;
    'returnToWorkSlotSubTotal': SubTotalRow;
    'targetYearMonths': Array<string>;
    'totalItems': Array<TotalItem>;
    'transferSlotDepartmentSubTotal': SubTotalRow;
}

export const WorkforcePlanUpdateRequestWorkforceDiffViewPlanTypeEnum = {
    Budget: 'BUDGET',
    Forecast: 'FORECAST',
} as const;

export type WorkforcePlanUpdateRequestWorkforceDiffViewPlanTypeEnum = typeof WorkforcePlanUpdateRequestWorkforceDiffViewPlanTypeEnum[keyof typeof WorkforcePlanUpdateRequestWorkforceDiffViewPlanTypeEnum];

export interface WorkforcePlanningBaseSalaryIncreaseRuleView {
    'increaseRates': Array<IncreaseRateForEachMonthView>;
    'targetAccounts': Array<TargetAccountView>;
}
export interface WorkforcePlanningItemConversionRulesetDetailView {
    'description': string;
    'descriptionUpdatedAt'?: string;
    'id': string;
    'name': string;
    'rules': Array<WorkforcePlanningItemConvertRuleView>;
}
export interface WorkforcePlanningItemConversionRulesetDto {
    'description': string;
    'id': string;
    'name': string;
}
export interface WorkforcePlanningItemConvertRuleDetailView {
    'conversionTiming': WorkforcePlanningItemConvertRuleDetailViewConversionTimingEnum;
    'patterns': Array<WorkforceConversionRulePatternView>;
    'ruleId': string;
    'ruleName': string;
    'unitAmountItemId'?: string;
}

export const WorkforcePlanningItemConvertRuleDetailViewConversionTimingEnum = {
    Monthly: 'MONTHLY',
    UponJoining: 'UPON_JOINING',
} as const;

export type WorkforcePlanningItemConvertRuleDetailViewConversionTimingEnum = typeof WorkforcePlanningItemConvertRuleDetailViewConversionTimingEnum[keyof typeof WorkforcePlanningItemConvertRuleDetailViewConversionTimingEnum];

export interface WorkforcePlanningItemConvertRuleView {
    'calculationMethod': Array<string>;
    'conversionTiming': WorkforcePlanningItemConvertRuleViewConversionTimingEnum;
    'ruleId': string;
    'ruleName': string;
}

export const WorkforcePlanningItemConvertRuleViewConversionTimingEnum = {
    Monthly: 'MONTHLY',
    UponJoining: 'UPON_JOINING',
} as const;

export type WorkforcePlanningItemConvertRuleViewConversionTimingEnum = typeof WorkforcePlanningItemConvertRuleViewConversionTimingEnum[keyof typeof WorkforcePlanningItemConvertRuleViewConversionTimingEnum];

export interface WorkforcePlanningPermissionItem {
    'id': string;
    'lastUpdatedBy': string;
    'name': string;
    'restrictedActions': Array<WorkforcePlanningPermissionItemRestrictedActionsEnum>;
    'updatedAt': string;
}

export const WorkforcePlanningPermissionItemRestrictedActionsEnum = {
    CrudWorkforceActual: 'CRUD_WORKFORCE_ACTUAL',
    CrudUnitAmount: 'CRUD_UNIT_AMOUNT',
    ConnectWorkforceSlotToActual: 'CONNECT_WORKFORCE_SLOT_TO_ACTUAL',
} as const;

export type WorkforcePlanningPermissionItemRestrictedActionsEnum = typeof WorkforcePlanningPermissionItemRestrictedActionsEnum[keyof typeof WorkforcePlanningPermissionItemRestrictedActionsEnum];

export interface WorkforcePlanningProjectListItem {
    'connectedSimulationId'?: string;
    'planningProjectId': string;
    'targetDepartmentIds': Array<string>;
    'workforcePlanningProjectId': string;
}
export interface WorkforcePlanningProjectSimulationConnectionView {
    'connectedSimulation'?: ConnectedWorkforcePlanningSimulationView;
}
export interface WorkforcePlanningSimulationActiveEditorDto {
    'displayName': string;
    'lastAccessedAt': string;
    'userId': string;
}
export interface WorkforcePlanningSimulationAsyncStatusDto {
    'creationErrorMessage': string;
    'creationStatus': WorkforcePlanningSimulationAsyncStatusDtoCreationStatusEnum;
    'recalculationErrorMessage'?: string;
    'recalculationStatus'?: WorkforcePlanningSimulationAsyncStatusDtoRecalculationStatusEnum;
}

export const WorkforcePlanningSimulationAsyncStatusDtoCreationStatusEnum = {
    Processing: 'PROCESSING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
} as const;

export type WorkforcePlanningSimulationAsyncStatusDtoCreationStatusEnum = typeof WorkforcePlanningSimulationAsyncStatusDtoCreationStatusEnum[keyof typeof WorkforcePlanningSimulationAsyncStatusDtoCreationStatusEnum];
export const WorkforcePlanningSimulationAsyncStatusDtoRecalculationStatusEnum = {
    Processing: 'PROCESSING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
} as const;

export type WorkforcePlanningSimulationAsyncStatusDtoRecalculationStatusEnum = typeof WorkforcePlanningSimulationAsyncStatusDtoRecalculationStatusEnum[keyof typeof WorkforcePlanningSimulationAsyncStatusDtoRecalculationStatusEnum];

export interface WorkforcePlanningSimulationCalculateResult {
    'hiringSlotSubTotal': SimulationSubTotalRow;
    'leaveOfAbsenceSlotSubTotal': SimulationSubTotalRow;
    'personSubTotal': SimulationSubTotalRow;
    'resignationSlotSubTotal': SimulationSubTotalRow;
    'returnToWorkSlotSubTotal': SimulationSubTotalRow;
    'targetYearMonths': Array<string>;
    'totalItems': Array<DeprecatedWorkforcePlanningSimulationItem>;
    'transferDepartmentSlotSubTotal': SimulationSubTotalRow;
}
export interface WorkforcePlanningSimulationConditionView {
    'baseYearMonth'?: string;
    'conversionRuleset'?: ConversionRulesetConditionDto;
    'salaryIncreaseConfigured': boolean;
}
export interface WorkforcePlanningSimulationGlobalFilterSchema {
    'ids': Array<string>;
}
export interface WorkforcePlanningSimulationMetaView {
    'conversionRulesetName'?: string;
    'conversionRulesetStatus': WorkforcePlanningSimulationMetaViewConversionRulesetStatusEnum;
    'errorMessage'?: string;
    'lastUpdatedAt': string;
    'lastUpdatedUserName': string;
    'latestImportEventStatus': WorkforcePlanningSimulationMetaViewLatestImportEventStatusEnum;
    'mode': WorkforcePlanningSimulationMetaViewModeEnum;
    'planMasterName': string;
    'planningProjectName': string;
    'planningSimulationName': string;
    'targetDepartmentNames': Array<string>;
}

export const WorkforcePlanningSimulationMetaViewConversionRulesetStatusEnum = {
    Assigned: 'ASSIGNED',
    Deleted: 'DELETED',
    NotAssigned: 'NOT_ASSIGNED',
} as const;

export type WorkforcePlanningSimulationMetaViewConversionRulesetStatusEnum = typeof WorkforcePlanningSimulationMetaViewConversionRulesetStatusEnum[keyof typeof WorkforcePlanningSimulationMetaViewConversionRulesetStatusEnum];
export const WorkforcePlanningSimulationMetaViewLatestImportEventStatusEnum = {
    Importing: 'IMPORTING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
} as const;

export type WorkforcePlanningSimulationMetaViewLatestImportEventStatusEnum = typeof WorkforcePlanningSimulationMetaViewLatestImportEventStatusEnum[keyof typeof WorkforcePlanningSimulationMetaViewLatestImportEventStatusEnum];
export const WorkforcePlanningSimulationMetaViewModeEnum = {
    View: 'VIEW',
    Editing: 'EDITING',
} as const;

export type WorkforcePlanningSimulationMetaViewModeEnum = typeof WorkforcePlanningSimulationMetaViewModeEnum[keyof typeof WorkforcePlanningSimulationMetaViewModeEnum];

export interface WorkforcePlanningSimulationRuleVersionStalenessDto {
    'isBaseSalaryIncreaseRuleStale': boolean;
    'isConversionRuleStale': boolean;
}
export interface WorkforcePlanningSimulationTargetDepartmentItem {
    'id': string;
    'name': string;
}
export interface WorkforcePlanningSimulationUsingDimension {
    'dimensionId': string;
    'dimensionName': string;
    'dimensionTags': Array<WorkforcePlanningSimulationUsingDimensionTag>;
    'required': boolean;
}
export interface WorkforcePlanningSimulationUsingDimensionTag {
    'dimensionTagId': string;
    'dimensionTagName': string;
}
export interface WorkforcePlanningSimulationView {
    'accountTreeId': string;
    'accountTreeName': string;
    'createdAt': string;
    'createdBy': string;
    'name': string;
    'nonFinancialAccountTreeId'?: string;
    'nonFinancialAccountTreeName'?: string;
    'organizationTreeName': string;
    'personAndSlotAccountIds': Array<string>;
    'planMasterId'?: string;
    'planName': string;
    'planningProjectName': string;
    'targetDepartmentNames': Array<string>;
    'targetRangeEnd': string;
    'targetRangeStart': string;
    'updatedAt': string;
    'updatedBy': string;
}
export interface WorkforcePlanningUsingDimensionView {
    'dimensionId': string;
    'dimensionName': string;
    'dimensionNumber': number;
    'importColumnName': string;
}
export interface WorkforceSimulationSlotBody {
    'code': string;
    'departmentId'?: string;
    'dimensionIdToTagIdMap': { [key: string]: string; };
    'inDepartmentId'?: string;
    'name': string;
    'outDepartmentId'?: string;
    'slotType': WorkforceSimulationSlotBodySlotTypeEnum;
    'unitAmountItems': Array<WorkforceSimulationSlotBodyUnitAmountItem>;
}

export const WorkforceSimulationSlotBodySlotTypeEnum = {
    Hiring: 'HIRING',
    ReturnToWork: 'RETURN_TO_WORK',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    TransferInDepartment: 'TRANSFER_IN_DEPARTMENT',
    TransferOutDepartment: 'TRANSFER_OUT_DEPARTMENT',
    FixedTransferDepartment: 'FIXED_TRANSFER_DEPARTMENT',
} as const;

export type WorkforceSimulationSlotBodySlotTypeEnum = typeof WorkforceSimulationSlotBodySlotTypeEnum[keyof typeof WorkforceSimulationSlotBodySlotTypeEnum];

export interface WorkforceSimulationSlotBodyUnitAmountItem {
    'itemId': string;
    'unitAmount': number;
}
export interface WorkforceSlotAndSlotPlanVersionView {
    'code': string;
    'departmentName'?: string;
    'dimensionTagNameList': Array<WorkforceSlotListItemDimensionTagDto>;
    'hasSlotPlanVersion': boolean;
    'name': string;
    'slotId': string;
    'slotType': WorkforceSlotAndSlotPlanVersionViewSlotTypeEnum;
    'slotUsageByYearMonth': Array<SlotUsageByMonthView>;
    'toDepartmentName'?: string;
    'totalActualUsedCount': number;
    'totalPlannedCount'?: number;
    'unitAmounts': Array<WorkforceSlotListUnitAmountItemDto>;
}

export const WorkforceSlotAndSlotPlanVersionViewSlotTypeEnum = {
    Hiring: 'HIRING',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    TransferDepartment: 'TRANSFER_DEPARTMENT',
} as const;

export type WorkforceSlotAndSlotPlanVersionViewSlotTypeEnum = typeof WorkforceSlotAndSlotPlanVersionViewSlotTypeEnum[keyof typeof WorkforceSlotAndSlotPlanVersionViewSlotTypeEnum];

export interface WorkforceSlotListItemDimensionTagDto {
    'dimensionId': string;
    'dimensionName': string;
    'dimensionTagName': string;
}
export interface WorkforceSlotListUnitAmountItemDto {
    'itemId': string;
    'unitAmount': number;
}
export interface WorkforceSlotStartYearMonthView {
    'yearMonth'?: string;
}
export interface WorkforceSlotUnitAmountAttributeDto {
    'dimension'?: WorkforceSlotUnitAmountDimensionDto;
    'type': WorkforceSlotUnitAmountAttributeDtoTypeEnum;
}

export const WorkforceSlotUnitAmountAttributeDtoTypeEnum = {
    Department: 'DEPARTMENT',
    Dimension: 'DIMENSION',
} as const;

export type WorkforceSlotUnitAmountAttributeDtoTypeEnum = typeof WorkforceSlotUnitAmountAttributeDtoTypeEnum[keyof typeof WorkforceSlotUnitAmountAttributeDtoTypeEnum];

export interface WorkforceSlotUnitAmountDimensionDto {
    'id': string;
    'name': string;
}
export interface WorkforceSlotUnitAmountItemDto {
    'id': string;
    'name': string;
}
export interface WorkforceSlotUnitAmountRecordAttributeBody {
    'attributeType': WorkforceSlotUnitAmountRecordAttributeBodyAttributeTypeEnum;
    'department'?: WorkforceSlotUnitAmountRecordDepartmentBody;
    'dimension'?: WorkforceSlotUnitAmountRecordDimensionBody;
}

export const WorkforceSlotUnitAmountRecordAttributeBodyAttributeTypeEnum = {
    Department: 'DEPARTMENT',
    Dimension: 'DIMENSION',
} as const;

export type WorkforceSlotUnitAmountRecordAttributeBodyAttributeTypeEnum = typeof WorkforceSlotUnitAmountRecordAttributeBodyAttributeTypeEnum[keyof typeof WorkforceSlotUnitAmountRecordAttributeBodyAttributeTypeEnum];

export interface WorkforceSlotUnitAmountRecordAttributeDto {
    'department'?: WorkforceSlotUnitAmountRecordDepartmentDto;
    'dimension'?: WorkforceSlotUnitAmountRecordDimensionDto;
    'type': WorkforceSlotUnitAmountRecordAttributeDtoTypeEnum;
}

export const WorkforceSlotUnitAmountRecordAttributeDtoTypeEnum = {
    Department: 'DEPARTMENT',
    Dimension: 'DIMENSION',
} as const;

export type WorkforceSlotUnitAmountRecordAttributeDtoTypeEnum = typeof WorkforceSlotUnitAmountRecordAttributeDtoTypeEnum[keyof typeof WorkforceSlotUnitAmountRecordAttributeDtoTypeEnum];

export interface WorkforceSlotUnitAmountRecordBody {
    'attributes': Array<WorkforceSlotUnitAmountRecordAttributeBody>;
    'items': Array<WorkforceSlotUnitAmountRecordItemBody>;
}
export interface WorkforceSlotUnitAmountRecordDepartmentBody {
    'departmentId': string;
}
export interface WorkforceSlotUnitAmountRecordDepartmentDto {
    'id': string;
    'name': string;
}
export interface WorkforceSlotUnitAmountRecordDimensionBody {
    'dimensionId': string;
    'dimensionTagId': string;
}
export interface WorkforceSlotUnitAmountRecordDimensionDto {
    'id': string;
    'tagId': string;
    'tagName': string;
}
export interface WorkforceSlotUnitAmountRecordDto {
    'attributes': Array<WorkforceSlotUnitAmountRecordAttributeDto>;
    'id': string;
    'items': Array<WorkforceSlotUnitAmountRecordItemDto>;
}
export interface WorkforceSlotUnitAmountRecordItemBody {
    'amount': number;
    'unitAmountItemId': string;
}
export interface WorkforceSlotUnitAmountRecordItemDto {
    'amount': number;
    'unitAmountItemId': string;
}
export interface WorkforceSlotUnitAmountTableAttributeBody {
    'attributeType': WorkforceSlotUnitAmountTableAttributeBodyAttributeTypeEnum;
    'dimensionId'?: string;
}

export const WorkforceSlotUnitAmountTableAttributeBodyAttributeTypeEnum = {
    Department: 'DEPARTMENT',
    Dimension: 'DIMENSION',
} as const;

export type WorkforceSlotUnitAmountTableAttributeBodyAttributeTypeEnum = typeof WorkforceSlotUnitAmountTableAttributeBodyAttributeTypeEnum[keyof typeof WorkforceSlotUnitAmountTableAttributeBodyAttributeTypeEnum];

export interface WorkforceSlotUnitAmountTableDto {
    'attributes': Array<WorkforceSlotUnitAmountAttributeDto>;
    'id': string;
    'name': string;
    'records': Array<WorkforceSlotUnitAmountRecordDto>;
    'unitAmountItems': Array<WorkforceSlotUnitAmountItemDto>;
}
export interface WorkforceSlotUnitAmountTableItemBody {
    'unitAmountItemId': string;
}
export interface WorkforceSlotUnitAmountTableListDto {
    'attributes': Array<WorkforceSlotUnitAmountAttributeDto>;
    'id': string;
    'name': string;
    'unitAmountItems': Array<WorkforceSlotUnitAmountItemDto>;
}
export interface WorkforceSlotView {
    'workforceSlotCode': string;
    'workforceSlotId': string;
    'workforceSlotName': string;
}
export interface WorkforceWithoutUnitAmountItem {
    'personCode': string;
    'personFirstName': string;
    'personLastName': string;
    'workforceId': string;
}
export interface WorkforceWithoutUnitAmountItems {
    'items': Array<WorkforceWithoutUnitAmountItem>;
}
export interface XpaDashboardListResponse {
    'count': number;
    'items': Array<XpaDashboardResponse>;
    'limit': number;
}
export interface XpaDashboardResponse {
    'createdAt': string;
    'createdUserName': string;
    'dashboardId': string;
    'dashboardName': string;
    'folderId'?: string;
    'isEditRestricted': boolean;
    'isOwner': boolean;
    'updatedAt': string;
    'updatedUserName': string;
}
export interface YearMonthExecution {
    'patterns': Array<PatternExecution>;
    'yearMonth': string;
}
export interface YearMonthRangeParams {
    'end': string;
    'start': string;
}
export interface YearMonthRequestBody {
    'ruleId': string;
    'yearMonth': string;
}
export interface ZendeskJwtDto {
    'jwt': string;
}

/**
 * AccountControllerApi - axios parameter creator
 */
export const AccountControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 科目の科目タイプを一括更新
         * @param {BulkUpdateAccountTypeRequestBody} bulkUpdateAccountTypeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateAccountType: async (bulkUpdateAccountTypeRequestBody: BulkUpdateAccountTypeRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateAccountTypeRequestBody' is not null or undefined
            assertParamExists('bulkUpdateAccountType', 'bulkUpdateAccountTypeRequestBody', bulkUpdateAccountTypeRequestBody)
            const localVarPath = `/api/accounts/accountType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateAccountTypeRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目を作成する
         * @param {CreateAccountRequestBody} createAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: async (createAccountRequestBody: CreateAccountRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAccountRequestBody' is not null or undefined
            assertParamExists('createAccount', 'createAccountRequestBody', createAccountRequestBody)
            const localVarPath = `/api/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目を作成し、科目階層に追加する
         * @param {string} accountTreeId 
         * @param {string} parentAccountId 
         * @param {CreateAndAddToTreeAccountParam} createAndAddToTreeAccountParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndAddToTree: async (accountTreeId: string, parentAccountId: string, createAndAddToTreeAccountParam: CreateAndAddToTreeAccountParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('createAndAddToTree', 'accountTreeId', accountTreeId)
            // verify required parameter 'parentAccountId' is not null or undefined
            assertParamExists('createAndAddToTree', 'parentAccountId', parentAccountId)
            // verify required parameter 'createAndAddToTreeAccountParam' is not null or undefined
            assertParamExists('createAndAddToTree', 'createAndAddToTreeAccountParam', createAndAddToTreeAccountParam)
            const localVarPath = `/api/accounts/create-and-add-tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            if (parentAccountId !== undefined) {
                localVarQueryParameter['parentAccountId'] = parentAccountId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAndAddToTreeAccountParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目を削除する。階層構造で子科目を持たず、実績や計画で使われていない場合のみ削除できる
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAccount', 'accountId', accountId)
            const localVarPath = `/api/accounts/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目一覧Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountsExcel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Excelアップロードし、科目を一括作成・更新する。
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload2: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('fileUpload2', 'file', file)
            const localVarPath = `/api/accounts/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目を取得する。補助科目の情報も返す
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccount', 'accountId', accountId)
            const localVarPath = `/api/accounts/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 全ての科目を取得する。accountTypeを複数指定して絞り込める
         * @param {Array<ListAccountsAccountTypesEnum>} [accountTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts: async (accountTypes?: Array<ListAccountsAccountTypesEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTypes) {
                localVarQueryParameter['accountTypes'] = accountTypes;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS科目階層に含まれない科目一覧を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBsAccountsNotIncludedTree: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/bs/not-included`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS科目階層の未設定科目一覧(階層に含まれないBS科目、未識別)を取得するAPI
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBsAccountsNotIncludedTreeAndUnknowns: async (searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/accounts/bs/not-included-and-unknowns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目を更新する
         * @param {string} accountId 
         * @param {UpdateAccountRequestBody} updateAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount: async (accountId: string, updateAccountRequestBody: UpdateAccountRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateAccount', 'accountId', accountId)
            // verify required parameter 'updateAccountRequestBody' is not null or undefined
            assertParamExists('updateAccount', 'updateAccountRequestBody', updateAccountRequestBody)
            const localVarPath = `/api/accounts/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目階層にある科目を更新
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {UpdateAccountRequestBody} updateAccountRequestBody 
         * @param {string} [insertDestinationParentAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountInTree: async (accountId: string, accountTreeId: string, updateAccountRequestBody: UpdateAccountRequestBody, insertDestinationParentAccountId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateAccountInTree', 'accountId', accountId)
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('updateAccountInTree', 'accountTreeId', accountTreeId)
            // verify required parameter 'updateAccountRequestBody' is not null or undefined
            assertParamExists('updateAccountInTree', 'updateAccountRequestBody', updateAccountRequestBody)
            const localVarPath = `/api/accounts/{accountId}/in-tree`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            if (insertDestinationParentAccountId !== undefined) {
                localVarQueryParameter['insertDestinationParentAccountId'] = insertDestinationParentAccountId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS科目階層に入っている科目を更新する
         * @param {string} accountId 
         * @param {PatchBSAccountRequestBody} patchBSAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBSAccount: async (accountId: string, patchBSAccountRequestBody: PatchBSAccountRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateBSAccount', 'accountId', accountId)
            // verify required parameter 'patchBSAccountRequestBody' is not null or undefined
            assertParamExists('updateBSAccount', 'patchBSAccountRequestBody', patchBSAccountRequestBody)
            const localVarPath = `/api/accounts/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchBSAccountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountControllerApi - functional programming interface
 */
export const AccountControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 科目の科目タイプを一括更新
         * @param {BulkUpdateAccountTypeRequestBody} bulkUpdateAccountTypeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateAccountType(bulkUpdateAccountTypeRequestBody: BulkUpdateAccountTypeRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateAccountType(bulkUpdateAccountTypeRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.bulkUpdateAccountType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目を作成する
         * @param {CreateAccountRequestBody} createAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccount(createAccountRequestBody: CreateAccountRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(createAccountRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.createAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目を作成し、科目階層に追加する
         * @param {string} accountTreeId 
         * @param {string} parentAccountId 
         * @param {CreateAndAddToTreeAccountParam} createAndAddToTreeAccountParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndAddToTree(accountTreeId: string, parentAccountId: string, createAndAddToTreeAccountParam: CreateAndAddToTreeAccountParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndAddToTree(accountTreeId, parentAccountId, createAndAddToTreeAccountParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.createAndAddToTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目を削除する。階層構造で子科目を持たず、実績や計画で使われていない場合のみ削除できる
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.deleteAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目一覧Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAccountsExcel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAccountsExcel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.downloadAccountsExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Excelアップロードし、科目を一括作成・更新する。
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUpload2(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUpload2(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.fileUpload2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目を取得する。補助科目の情報も返す
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.getAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 全ての科目を取得する。accountTypeを複数指定して絞り込める
         * @param {Array<ListAccountsAccountTypesEnum>} [accountTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccounts(accountTypes?: Array<ListAccountsAccountTypesEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccounts(accountTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.listAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS科目階層に含まれない科目一覧を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBsAccountsNotIncludedTree(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBsAccountsNotIncludedTree(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.listBsAccountsNotIncludedTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS科目階層の未設定科目一覧(階層に含まれないBS科目、未識別)を取得するAPI
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBsAccountsNotIncludedTreeAndUnknowns(searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBsAccountsNotIncludedTreeAndUnknowns(searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.listBsAccountsNotIncludedTreeAndUnknowns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目を更新する
         * @param {string} accountId 
         * @param {UpdateAccountRequestBody} updateAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccount(accountId: string, updateAccountRequestBody: UpdateAccountRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccount(accountId, updateAccountRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.updateAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目階層にある科目を更新
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {UpdateAccountRequestBody} updateAccountRequestBody 
         * @param {string} [insertDestinationParentAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountInTree(accountId: string, accountTreeId: string, updateAccountRequestBody: UpdateAccountRequestBody, insertDestinationParentAccountId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountInTree(accountId, accountTreeId, updateAccountRequestBody, insertDestinationParentAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.updateAccountInTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS科目階層に入っている科目を更新する
         * @param {string} accountId 
         * @param {PatchBSAccountRequestBody} patchBSAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBSAccount(accountId: string, patchBSAccountRequestBody: PatchBSAccountRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBSAccount(accountId, patchBSAccountRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountControllerApi.updateBSAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountControllerApi - factory interface
 */
export const AccountControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 科目の科目タイプを一括更新
         * @param {BulkUpdateAccountTypeRequestBody} bulkUpdateAccountTypeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateAccountType(bulkUpdateAccountTypeRequestBody: BulkUpdateAccountTypeRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<AccountsView> {
            return localVarFp.bulkUpdateAccountType(bulkUpdateAccountTypeRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目を作成する
         * @param {CreateAccountRequestBody} createAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(createAccountRequestBody: CreateAccountRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createAccount(createAccountRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目を作成し、科目階層に追加する
         * @param {string} accountTreeId 
         * @param {string} parentAccountId 
         * @param {CreateAndAddToTreeAccountParam} createAndAddToTreeAccountParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndAddToTree(accountTreeId: string, parentAccountId: string, createAndAddToTreeAccountParam: CreateAndAddToTreeAccountParam, options?: RawAxiosRequestConfig): AxiosPromise<AccountView> {
            return localVarFp.createAndAddToTree(accountTreeId, parentAccountId, createAndAddToTreeAccountParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目を削除する。階層構造で子科目を持たず、実績や計画で使われていない場合のみ削除できる
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目一覧Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountsExcel(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAccountsExcel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Excelアップロードし、科目を一括作成・更新する。
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload2(file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.fileUpload2(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目を取得する。補助科目の情報も返す
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountView> {
            return localVarFp.getAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 全ての科目を取得する。accountTypeを複数指定して絞り込める
         * @param {Array<ListAccountsAccountTypesEnum>} [accountTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts(accountTypes?: Array<ListAccountsAccountTypesEnum>, options?: RawAxiosRequestConfig): AxiosPromise<AccountsView> {
            return localVarFp.listAccounts(accountTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS科目階層に含まれない科目一覧を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBsAccountsNotIncludedTree(options?: RawAxiosRequestConfig): AxiosPromise<AccountsView> {
            return localVarFp.listBsAccountsNotIncludedTree(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS科目階層の未設定科目一覧(階層に含まれないBS科目、未識別)を取得するAPI
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBsAccountsNotIncludedTreeAndUnknowns(searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountsView> {
            return localVarFp.listBsAccountsNotIncludedTreeAndUnknowns(searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目を更新する
         * @param {string} accountId 
         * @param {UpdateAccountRequestBody} updateAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount(accountId: string, updateAccountRequestBody: UpdateAccountRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<AccountView> {
            return localVarFp.updateAccount(accountId, updateAccountRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目階層にある科目を更新
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {UpdateAccountRequestBody} updateAccountRequestBody 
         * @param {string} [insertDestinationParentAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountInTree(accountId: string, accountTreeId: string, updateAccountRequestBody: UpdateAccountRequestBody, insertDestinationParentAccountId?: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountView> {
            return localVarFp.updateAccountInTree(accountId, accountTreeId, updateAccountRequestBody, insertDestinationParentAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS科目階層に入っている科目を更新する
         * @param {string} accountId 
         * @param {PatchBSAccountRequestBody} patchBSAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBSAccount(accountId: string, patchBSAccountRequestBody: PatchBSAccountRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<AccountView> {
            return localVarFp.updateBSAccount(accountId, patchBSAccountRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountControllerApi - object-oriented interface
 */
export class AccountControllerApi extends BaseAPI {
    /**
     * 
     * @summary 科目の科目タイプを一括更新
     * @param {BulkUpdateAccountTypeRequestBody} bulkUpdateAccountTypeRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateAccountType(bulkUpdateAccountTypeRequestBody: BulkUpdateAccountTypeRequestBody, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).bulkUpdateAccountType(bulkUpdateAccountTypeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目を作成する
     * @param {CreateAccountRequestBody} createAccountRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAccount(createAccountRequestBody: CreateAccountRequestBody, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).createAccount(createAccountRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目を作成し、科目階層に追加する
     * @param {string} accountTreeId 
     * @param {string} parentAccountId 
     * @param {CreateAndAddToTreeAccountParam} createAndAddToTreeAccountParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAndAddToTree(accountTreeId: string, parentAccountId: string, createAndAddToTreeAccountParam: CreateAndAddToTreeAccountParam, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).createAndAddToTree(accountTreeId, parentAccountId, createAndAddToTreeAccountParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目を削除する。階層構造で子科目を持たず、実績や計画で使われていない場合のみ削除できる
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAccount(accountId: string, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).deleteAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目一覧Excelのダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAccountsExcel(options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).downloadAccountsExcel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Excelアップロードし、科目を一括作成・更新する。
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUpload2(file: File, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).fileUpload2(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目を取得する。補助科目の情報も返す
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAccount(accountId: string, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).getAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 全ての科目を取得する。accountTypeを複数指定して絞り込める
     * @param {Array<ListAccountsAccountTypesEnum>} [accountTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAccounts(accountTypes?: Array<ListAccountsAccountTypesEnum>, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).listAccounts(accountTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS科目階層に含まれない科目一覧を取得するAPI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listBsAccountsNotIncludedTree(options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).listBsAccountsNotIncludedTree(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS科目階層の未設定科目一覧(階層に含まれないBS科目、未識別)を取得するAPI
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listBsAccountsNotIncludedTreeAndUnknowns(searchWord?: string, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).listBsAccountsNotIncludedTreeAndUnknowns(searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目を更新する
     * @param {string} accountId 
     * @param {UpdateAccountRequestBody} updateAccountRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAccount(accountId: string, updateAccountRequestBody: UpdateAccountRequestBody, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).updateAccount(accountId, updateAccountRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目階層にある科目を更新
     * @param {string} accountId 
     * @param {string} accountTreeId 
     * @param {UpdateAccountRequestBody} updateAccountRequestBody 
     * @param {string} [insertDestinationParentAccountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAccountInTree(accountId: string, accountTreeId: string, updateAccountRequestBody: UpdateAccountRequestBody, insertDestinationParentAccountId?: string, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).updateAccountInTree(accountId, accountTreeId, updateAccountRequestBody, insertDestinationParentAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS科目階層に入っている科目を更新する
     * @param {string} accountId 
     * @param {PatchBSAccountRequestBody} patchBSAccountRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBSAccount(accountId: string, patchBSAccountRequestBody: PatchBSAccountRequestBody, options?: RawAxiosRequestConfig) {
        return AccountControllerApiFp(this.configuration).updateBSAccount(accountId, patchBSAccountRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListAccountsAccountTypesEnum = {
    Unknown: 'UNKNOWN',
    Expense: 'EXPENSE',
    Income: 'INCOME',
    BsAccount: 'BS_ACCOUNT',
    Assets: 'ASSETS',
    Liabilities: 'LIABILITIES',
    NetAssets: 'NET_ASSETS',
    NonFinancial: 'NON_FINANCIAL',
    StandardPlAggrExpense: 'STANDARD_PL_AGGR_EXPENSE',
    StandardPlAggrIncome: 'STANDARD_PL_AGGR_INCOME',
    CfAccount: 'CF_ACCOUNT',
} as const;
export type ListAccountsAccountTypesEnum = typeof ListAccountsAccountTypesEnum[keyof typeof ListAccountsAccountTypesEnum];


/**
 * AccountConversionStepsControllerApi - axios parameter creator
 */
export const AccountConversionStepsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 科目変換ステップ作成API
         * @param {CreateOrUpdateAccountConversionStepBody} createOrUpdateAccountConversionStepBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountConversionStep: async (createOrUpdateAccountConversionStepBody: CreateOrUpdateAccountConversionStepBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrUpdateAccountConversionStepBody' is not null or undefined
            assertParamExists('createAccountConversionStep', 'createOrUpdateAccountConversionStepBody', createOrUpdateAccountConversionStepBody)
            const localVarPath = `/api/account_conversion_steps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateAccountConversionStepBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目変換ステップ削除API
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountConversionStep: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('deleteAccountConversionStep', 'stepId', stepId)
            const localVarPath = `/api/account_conversion_steps/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目変換ステップ詳細取得API
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAccountConversionStep: async (stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('findAccountConversionStep', 'stepId', stepId)
            const localVarPath = `/api/account_conversion_steps/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目変換ステップ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountConversionSteps: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account_conversion_steps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目変換ステップ順序変更API
         * @param {Array<string>} stepIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderAccountConversionSteps: async (stepIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepIds' is not null or undefined
            assertParamExists('reorderAccountConversionSteps', 'stepIds', stepIds)
            const localVarPath = `/api/account_conversion_steps/step_order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (stepIds) {
                localVarQueryParameter['stepIds'] = stepIds;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目変換ステップ更新API
         * @param {string} stepId 
         * @param {CreateOrUpdateAccountConversionStepBody} createOrUpdateAccountConversionStepBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountConversionStep: async (stepId: string, createOrUpdateAccountConversionStepBody: CreateOrUpdateAccountConversionStepBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('updateAccountConversionStep', 'stepId', stepId)
            // verify required parameter 'createOrUpdateAccountConversionStepBody' is not null or undefined
            assertParamExists('updateAccountConversionStep', 'createOrUpdateAccountConversionStepBody', createOrUpdateAccountConversionStepBody)
            const localVarPath = `/api/account_conversion_steps/{stepId}`
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateAccountConversionStepBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountConversionStepsControllerApi - functional programming interface
 */
export const AccountConversionStepsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountConversionStepsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 科目変換ステップ作成API
         * @param {CreateOrUpdateAccountConversionStepBody} createOrUpdateAccountConversionStepBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccountConversionStep(createOrUpdateAccountConversionStepBody: CreateOrUpdateAccountConversionStepBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccountConversionStep(createOrUpdateAccountConversionStepBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountConversionStepsControllerApi.createAccountConversionStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目変換ステップ削除API
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccountConversionStep(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccountConversionStep(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountConversionStepsControllerApi.deleteAccountConversionStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目変換ステップ詳細取得API
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAccountConversionStep(stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountConversionStepDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAccountConversionStep(stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountConversionStepsControllerApi.findAccountConversionStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目変換ステップ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountConversionSteps(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountConversionStepsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountConversionSteps(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountConversionStepsControllerApi.listAccountConversionSteps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目変換ステップ順序変更API
         * @param {Array<string>} stepIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderAccountConversionSteps(stepIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderAccountConversionSteps(stepIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountConversionStepsControllerApi.reorderAccountConversionSteps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目変換ステップ更新API
         * @param {string} stepId 
         * @param {CreateOrUpdateAccountConversionStepBody} createOrUpdateAccountConversionStepBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountConversionStep(stepId: string, createOrUpdateAccountConversionStepBody: CreateOrUpdateAccountConversionStepBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountConversionStep(stepId, createOrUpdateAccountConversionStepBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountConversionStepsControllerApi.updateAccountConversionStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountConversionStepsControllerApi - factory interface
 */
export const AccountConversionStepsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountConversionStepsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 科目変換ステップ作成API
         * @param {CreateOrUpdateAccountConversionStepBody} createOrUpdateAccountConversionStepBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountConversionStep(createOrUpdateAccountConversionStepBody: CreateOrUpdateAccountConversionStepBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createAccountConversionStep(createOrUpdateAccountConversionStepBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目変換ステップ削除API
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountConversionStep(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteAccountConversionStep(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目変換ステップ詳細取得API
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAccountConversionStep(stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountConversionStepDetailView> {
            return localVarFp.findAccountConversionStep(stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目変換ステップ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountConversionSteps(options?: RawAxiosRequestConfig): AxiosPromise<AccountConversionStepsView> {
            return localVarFp.listAccountConversionSteps(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目変換ステップ順序変更API
         * @param {Array<string>} stepIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderAccountConversionSteps(stepIds: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.reorderAccountConversionSteps(stepIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目変換ステップ更新API
         * @param {string} stepId 
         * @param {CreateOrUpdateAccountConversionStepBody} createOrUpdateAccountConversionStepBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountConversionStep(stepId: string, createOrUpdateAccountConversionStepBody: CreateOrUpdateAccountConversionStepBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateAccountConversionStep(stepId, createOrUpdateAccountConversionStepBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountConversionStepsControllerApi - object-oriented interface
 */
export class AccountConversionStepsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 科目変換ステップ作成API
     * @param {CreateOrUpdateAccountConversionStepBody} createOrUpdateAccountConversionStepBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAccountConversionStep(createOrUpdateAccountConversionStepBody: CreateOrUpdateAccountConversionStepBody, options?: RawAxiosRequestConfig) {
        return AccountConversionStepsControllerApiFp(this.configuration).createAccountConversionStep(createOrUpdateAccountConversionStepBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目変換ステップ削除API
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAccountConversionStep(stepId: string, options?: RawAxiosRequestConfig) {
        return AccountConversionStepsControllerApiFp(this.configuration).deleteAccountConversionStep(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目変換ステップ詳細取得API
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAccountConversionStep(stepId: string, options?: RawAxiosRequestConfig) {
        return AccountConversionStepsControllerApiFp(this.configuration).findAccountConversionStep(stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目変換ステップ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAccountConversionSteps(options?: RawAxiosRequestConfig) {
        return AccountConversionStepsControllerApiFp(this.configuration).listAccountConversionSteps(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目変換ステップ順序変更API
     * @param {Array<string>} stepIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reorderAccountConversionSteps(stepIds: Array<string>, options?: RawAxiosRequestConfig) {
        return AccountConversionStepsControllerApiFp(this.configuration).reorderAccountConversionSteps(stepIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目変換ステップ更新API
     * @param {string} stepId 
     * @param {CreateOrUpdateAccountConversionStepBody} createOrUpdateAccountConversionStepBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAccountConversionStep(stepId: string, createOrUpdateAccountConversionStepBody: CreateOrUpdateAccountConversionStepBody, options?: RawAxiosRequestConfig) {
        return AccountConversionStepsControllerApiFp(this.configuration).updateAccountConversionStep(stepId, createOrUpdateAccountConversionStepBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccountGroupsControllerApi - axios parameter creator
 */
export const AccountGroupsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary グループを削除する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} accountGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountGroup: async (nonFinancialAccountTreeId: string, accountGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('deleteAccountGroup', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'accountGroupId' is not null or undefined
            assertParamExists('deleteAccountGroup', 'accountGroupId', accountGroupId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/account_groups/{accountGroupId}`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)))
                .replace('{accountGroupId}', encodeURIComponent(String(accountGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グループ一括作成・更新 Excel のダウンロード API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountGroupsExcel: async (nonFinancialAccountTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('downloadAccountGroupsExcel', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/account_groups/excel`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グループを更新する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} accountGroupId 
         * @param {UpdateAccountGroupRequestBody} updateAccountGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountGroup: async (nonFinancialAccountTreeId: string, accountGroupId: string, updateAccountGroupRequestBody: UpdateAccountGroupRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('updateAccountGroup', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'accountGroupId' is not null or undefined
            assertParamExists('updateAccountGroup', 'accountGroupId', accountGroupId)
            // verify required parameter 'updateAccountGroupRequestBody' is not null or undefined
            assertParamExists('updateAccountGroup', 'updateAccountGroupRequestBody', updateAccountGroupRequestBody)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/account_groups/{accountGroupId}`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)))
                .replace('{accountGroupId}', encodeURIComponent(String(accountGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountGroupRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グループ一括作成・更新 Excel アップロード API
         * @param {string} nonFinancialAccountTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAccountGroupsExcel: async (nonFinancialAccountTreeId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('uploadAccountGroupsExcel', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadAccountGroupsExcel', 'file', file)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/account_groups/excel`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountGroupsControllerApi - functional programming interface
 */
export const AccountGroupsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountGroupsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary グループを削除する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} accountGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccountGroup(nonFinancialAccountTreeId: string, accountGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccountGroup(nonFinancialAccountTreeId, accountGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountGroupsControllerApi.deleteAccountGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グループ一括作成・更新 Excel のダウンロード API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAccountGroupsExcel(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAccountGroupsExcel(nonFinancialAccountTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountGroupsControllerApi.downloadAccountGroupsExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グループを更新する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} accountGroupId 
         * @param {UpdateAccountGroupRequestBody} updateAccountGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountGroup(nonFinancialAccountTreeId: string, accountGroupId: string, updateAccountGroupRequestBody: UpdateAccountGroupRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountGroupView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountGroup(nonFinancialAccountTreeId, accountGroupId, updateAccountGroupRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountGroupsControllerApi.updateAccountGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グループ一括作成・更新 Excel アップロード API
         * @param {string} nonFinancialAccountTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAccountGroupsExcel(nonFinancialAccountTreeId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAccountGroupsExcel(nonFinancialAccountTreeId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountGroupsControllerApi.uploadAccountGroupsExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountGroupsControllerApi - factory interface
 */
export const AccountGroupsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountGroupsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary グループを削除する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} accountGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountGroup(nonFinancialAccountTreeId: string, accountGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteAccountGroup(nonFinancialAccountTreeId, accountGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グループ一括作成・更新 Excel のダウンロード API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountGroupsExcel(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAccountGroupsExcel(nonFinancialAccountTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グループを更新する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} accountGroupId 
         * @param {UpdateAccountGroupRequestBody} updateAccountGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountGroup(nonFinancialAccountTreeId: string, accountGroupId: string, updateAccountGroupRequestBody: UpdateAccountGroupRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<AccountGroupView> {
            return localVarFp.updateAccountGroup(nonFinancialAccountTreeId, accountGroupId, updateAccountGroupRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グループ一括作成・更新 Excel アップロード API
         * @param {string} nonFinancialAccountTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAccountGroupsExcel(nonFinancialAccountTreeId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadAccountGroupsExcel(nonFinancialAccountTreeId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountGroupsControllerApi - object-oriented interface
 */
export class AccountGroupsControllerApi extends BaseAPI {
    /**
     * 
     * @summary グループを削除する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {string} accountGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAccountGroup(nonFinancialAccountTreeId: string, accountGroupId: string, options?: RawAxiosRequestConfig) {
        return AccountGroupsControllerApiFp(this.configuration).deleteAccountGroup(nonFinancialAccountTreeId, accountGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グループ一括作成・更新 Excel のダウンロード API
     * @param {string} nonFinancialAccountTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAccountGroupsExcel(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig) {
        return AccountGroupsControllerApiFp(this.configuration).downloadAccountGroupsExcel(nonFinancialAccountTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グループを更新する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {string} accountGroupId 
     * @param {UpdateAccountGroupRequestBody} updateAccountGroupRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAccountGroup(nonFinancialAccountTreeId: string, accountGroupId: string, updateAccountGroupRequestBody: UpdateAccountGroupRequestBody, options?: RawAxiosRequestConfig) {
        return AccountGroupsControllerApiFp(this.configuration).updateAccountGroup(nonFinancialAccountTreeId, accountGroupId, updateAccountGroupRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グループ一括作成・更新 Excel アップロード API
     * @param {string} nonFinancialAccountTreeId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadAccountGroupsExcel(nonFinancialAccountTreeId: string, file: File, options?: RawAxiosRequestConfig) {
        return AccountGroupsControllerApiFp(this.configuration).uploadAccountGroupsExcel(nonFinancialAccountTreeId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccountTreeControllerApi - axios parameter creator
 */
export const AccountTreeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 科目ツリーから科目をアーカイブする
         * @param {string} treeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAccount: async (treeId: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('archiveAccount', 'treeId', treeId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('archiveAccount', 'requestBody', requestBody)
            const localVarPath = `/api/account-trees/{treeId}/archive-account`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目階層を削除する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountTree: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('deleteAccountTree', 'treeId', treeId)
            const localVarPath = `/api/account-trees/{treeId}`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定された科目を科目階層から外す
         * @param {string} treeId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachSubTree: async (treeId: string, accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('detachSubTree', 'treeId', treeId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('detachSubTree', 'accountId', accountId)
            const localVarPath = `/api/account-trees/{treeId}/detach/{accountId}`
                .replace('{treeId}', encodeURIComponent(String(treeId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目階層のExcelダウンロード
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileDownload1: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('fileDownload1', 'treeId', treeId)
            const localVarPath = `/api/account-trees/{treeId}/excel`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Excelファイルをもとに、科目階層の一括更新を行う
         * @param {string} treeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload3: async (treeId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('fileUpload3', 'treeId', treeId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('fileUpload3', 'file', file)
            const localVarPath = `/api/account-trees/{treeId}/bulk-update`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 選択させるために本体値を表示するPL科目階層を取得するAPI
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTreeForSelection: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getAccountTreeForSelection', 'treeId', treeId)
            const localVarPath = `/api/account-trees/{treeId}/for-selection`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PL科目階層を取得するAPI
         * @param {string} treeId 
         * @param {boolean} isOnePLTree 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTrees: async (treeId: string, isOnePLTree: boolean, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getAccountTrees', 'treeId', treeId)
            // verify required parameter 'isOnePLTree' is not null or undefined
            assertParamExists('getAccountTrees', 'isOnePLTree', isOnePLTree)
            const localVarPath = `/api/account-trees/{treeId}`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (isOnePLTree !== undefined) {
                localVarQueryParameter['isOnePLTree'] = isOnePLTree;
            }

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 頂点科目変更のための科目リストを取得
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsForReplaceRootNodeSelection: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getAccountsForReplaceRootNodeSelection', 'treeId', treeId)
            const localVarPath = `/api/account-trees/{treeId}/for-replace-root-node-selection`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 親科目の科目タイプに基づいて追加可能な未設定科目のみを返却
         * @summary 指定した親科目に追加可能な未設定科目一覧を取得
         * @param {string} treeId 
         * @param {string} parentAccountId 
         * @param {boolean} [requireExSubAccount] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddableNotIncludedAccounts: async (treeId: string, parentAccountId: string, requireExSubAccount?: boolean, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getAddableNotIncludedAccounts', 'treeId', treeId)
            // verify required parameter 'parentAccountId' is not null or undefined
            assertParamExists('getAddableNotIncludedAccounts', 'parentAccountId', parentAccountId)
            const localVarPath = `/api/account-trees/{treeId}/addable-not-included-accounts`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (parentAccountId !== undefined) {
                localVarQueryParameter['parentAccountId'] = parentAccountId;
            }

            if (requireExSubAccount !== undefined) {
                localVarQueryParameter['requireExSubAccount'] = requireExSubAccount;
            }

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS科目階層の未設定科目一覧(階層に含まれないBS科目、未識別)の科目を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBsNotIncluded: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account-trees/bs-not-included`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目の階層構造に含まれない、AccountType=BS_ACCOUNTと集計科目以外の科目を取得
         * @param {string} treeId 
         * @param {boolean} requireExSubAccount 
         * @param {boolean} requireArchivedAccount 
         * @param {number} limit 
         * @param {number} [offset] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncluded1: async (treeId: string, requireExSubAccount: boolean, requireArchivedAccount: boolean, limit: number, offset?: number, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getNotIncluded1', 'treeId', treeId)
            // verify required parameter 'requireExSubAccount' is not null or undefined
            assertParamExists('getNotIncluded1', 'requireExSubAccount', requireExSubAccount)
            // verify required parameter 'requireArchivedAccount' is not null or undefined
            assertParamExists('getNotIncluded1', 'requireArchivedAccount', requireArchivedAccount)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getNotIncluded1', 'limit', limit)
            const localVarPath = `/api/account-trees/{treeId}/not-included`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (requireExSubAccount !== undefined) {
                localVarQueryParameter['requireExSubAccount'] = requireExSubAccount;
            }

            if (requireArchivedAccount !== undefined) {
                localVarQueryParameter['requireArchivedAccount'] = requireArchivedAccount;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目の階層構造に含まれない、AccountType=BS_ACCOUNTと集計科目以外の科目の総数を取得（アーカイブ済み科目は含まない）
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncludedCount1: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getNotIncludedCount1', 'treeId', treeId)
            const localVarPath = `/api/account-trees/{treeId}/not-included-count`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PL科目階層内の科目移動において移動先候補を取得するAPI
         * @param {string} treeId 
         * @param {string} targetAccountId 
         * @param {boolean} isOnePLTree 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPLAccountMoveCandidates: async (treeId: string, targetAccountId: string, isOnePLTree: boolean, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getPLAccountMoveCandidates', 'treeId', treeId)
            // verify required parameter 'targetAccountId' is not null or undefined
            assertParamExists('getPLAccountMoveCandidates', 'targetAccountId', targetAccountId)
            // verify required parameter 'isOnePLTree' is not null or undefined
            assertParamExists('getPLAccountMoveCandidates', 'isOnePLTree', isOnePLTree)
            const localVarPath = `/api/account-trees/{treeId}/{targetAccountId}/move-candidate`
                .replace('{treeId}', encodeURIComponent(String(treeId)))
                .replace('{targetAccountId}', encodeURIComponent(String(targetAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (isOnePLTree !== undefined) {
                localVarQueryParameter['isOnePLTree'] = isOnePLTree;
            }

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目階層の一覧を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountTrees: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/account-trees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 既存の科目階層のコピーを作成する
         * @param {string} treeId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeCopyOfAccountTree: async (treeId: string, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('makeCopyOfAccountTree', 'treeId', treeId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('makeCopyOfAccountTree', 'name', name)
            const localVarPath = `/api/account-trees/{treeId}/make-copy`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 未設定科目の内、親科目がすでに科目階層にある外部システム補助科目を科目階層に、親科目がBS科目のものをBS科目に、自動で移動する
         * @param {string} accountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNodeAutomatically: async (accountTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('moveNodeAutomatically', 'accountTreeId', accountTreeId)
            const localVarPath = `/api/account-trees/not-included-accounts/auto-move`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ノードを移動する
         * @param {string} treeId 
         * @param {MoveNodesRequestBody} moveNodesRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNodes1: async (treeId: string, moveNodesRequestBody: MoveNodesRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('moveNodes1', 'treeId', treeId)
            // verify required parameter 'moveNodesRequestBody' is not null or undefined
            assertParamExists('moveNodes1', 'moveNodesRequestBody', moveNodesRequestBody)
            const localVarPath = `/api/account-trees/{treeId}/move-node`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveNodesRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目階層の名前を変更する
         * @param {string} treeId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rename: async (treeId: string, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('rename', 'treeId', treeId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('rename', 'name', name)
            const localVarPath = `/api/account-trees/{treeId}/name`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 頂点科目の変更
         * @param {string} treeId 
         * @param {ReplaceRootNodeRequestBody} replaceRootNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceRootNode: async (treeId: string, replaceRootNodeRequestBody: ReplaceRootNodeRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('replaceRootNode', 'treeId', treeId)
            // verify required parameter 'replaceRootNodeRequestBody' is not null or undefined
            assertParamExists('replaceRootNode', 'replaceRootNodeRequestBody', replaceRootNodeRequestBody)
            const localVarPath = `/api/account-trees/{treeId}/replace-root-node`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceRootNodeRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目階層をプライマリに設定する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimary1: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('setPrimary1', 'treeId', treeId)
            const localVarPath = `/api/account-trees/{treeId}/set-primary`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目階層のアーカイブ済みの科目を戻す
         * @param {string} treeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveAccount: async (treeId: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('unarchiveAccount', 'treeId', treeId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('unarchiveAccount', 'requestBody', requestBody)
            const localVarPath = `/api/account-trees/{treeId}/unarchive-account`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountTreeControllerApi - functional programming interface
 */
export const AccountTreeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountTreeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 科目ツリーから科目をアーカイブする
         * @param {string} treeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveAccount(treeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveAccount(treeId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.archiveAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目階層を削除する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccountTree(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccountTree(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.deleteAccountTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定された科目を科目階層から外す
         * @param {string} treeId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachSubTree(treeId: string, accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachSubTree(treeId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.detachSubTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目階層のExcelダウンロード
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileDownload1(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileDownload1(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.fileDownload1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Excelファイルをもとに、科目階層の一括更新を行う
         * @param {string} treeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUpload3(treeId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUpload3(treeId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.fileUpload3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 選択させるために本体値を表示するPL科目階層を取得するAPI
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountTreeForSelection(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountFlatTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountTreeForSelection(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.getAccountTreeForSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary PL科目階層を取得するAPI
         * @param {string} treeId 
         * @param {boolean} isOnePLTree 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountTrees(treeId: string, isOnePLTree: boolean, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountFlatTreeWithMatchedNodesView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountTrees(treeId, isOnePLTree, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.getAccountTrees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 頂点科目変更のための科目リストを取得
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountsForReplaceRootNodeSelection(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountsForReplaceRootNodeSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountsForReplaceRootNodeSelection(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.getAccountsForReplaceRootNodeSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 親科目の科目タイプに基づいて追加可能な未設定科目のみを返却
         * @summary 指定した親科目に追加可能な未設定科目一覧を取得
         * @param {string} treeId 
         * @param {string} parentAccountId 
         * @param {boolean} [requireExSubAccount] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddableNotIncludedAccounts(treeId: string, parentAccountId: string, requireExSubAccount?: boolean, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddableNotIncludedAccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddableNotIncludedAccounts(treeId, parentAccountId, requireExSubAccount, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.getAddableNotIncludedAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS科目階層の未設定科目一覧(階層に含まれないBS科目、未識別)の科目を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBsNotIncluded(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BsNotIncludedAccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBsNotIncluded(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.getBsNotIncluded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目の階層構造に含まれない、AccountType=BS_ACCOUNTと集計科目以外の科目を取得
         * @param {string} treeId 
         * @param {boolean} requireExSubAccount 
         * @param {boolean} requireArchivedAccount 
         * @param {number} limit 
         * @param {number} [offset] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotIncluded1(treeId: string, requireExSubAccount: boolean, requireArchivedAccount: boolean, limit: number, offset?: number, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotIncludedAccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotIncluded1(treeId, requireExSubAccount, requireArchivedAccount, limit, offset, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.getNotIncluded1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目の階層構造に含まれない、AccountType=BS_ACCOUNTと集計科目以外の科目の総数を取得（アーカイブ済み科目は含まない）
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotIncludedCount1(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotIncludedAccountCountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotIncludedCount1(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.getNotIncludedCount1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary PL科目階層内の科目移動において移動先候補を取得するAPI
         * @param {string} treeId 
         * @param {string} targetAccountId 
         * @param {boolean} isOnePLTree 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPLAccountMoveCandidates(treeId: string, targetAccountId: string, isOnePLTree: boolean, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PLAccountFlatTreeViewForCandidate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPLAccountMoveCandidates(treeId, targetAccountId, isOnePLTree, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.getPLAccountMoveCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目階層の一覧を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountTrees(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountTreeListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountTrees(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.listAccountTrees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 既存の科目階層のコピーを作成する
         * @param {string} treeId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async makeCopyOfAccountTree(treeId: string, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountFlatTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.makeCopyOfAccountTree(treeId, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.makeCopyOfAccountTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 未設定科目の内、親科目がすでに科目階層にある外部システム補助科目を科目階層に、親科目がBS科目のものをBS科目に、自動で移動する
         * @param {string} accountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveNodeAutomatically(accountTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MovedNotIncludedAccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveNodeAutomatically(accountTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.moveNodeAutomatically']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ノードを移動する
         * @param {string} treeId 
         * @param {MoveNodesRequestBody} moveNodesRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveNodes1(treeId: string, moveNodesRequestBody: MoveNodesRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountFlatTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveNodes1(treeId, moveNodesRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.moveNodes1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目階層の名前を変更する
         * @param {string} treeId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rename(treeId: string, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountFlatTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rename(treeId, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.rename']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 頂点科目の変更
         * @param {string} treeId 
         * @param {ReplaceRootNodeRequestBody} replaceRootNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceRootNode(treeId: string, replaceRootNodeRequestBody: ReplaceRootNodeRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceRootNode(treeId, replaceRootNodeRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.replaceRootNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目階層をプライマリに設定する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimary1(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimary1(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.setPrimary1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目階層のアーカイブ済みの科目を戻す
         * @param {string} treeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unarchiveAccount(treeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unarchiveAccount(treeId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTreeControllerApi.unarchiveAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountTreeControllerApi - factory interface
 */
export const AccountTreeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountTreeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 科目ツリーから科目をアーカイブする
         * @param {string} treeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAccount(treeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.archiveAccount(treeId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目階層を削除する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountTree(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteAccountTree(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定された科目を科目階層から外す
         * @param {string} treeId 
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachSubTree(treeId: string, accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.detachSubTree(treeId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目階層のExcelダウンロード
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileDownload1(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.fileDownload1(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Excelファイルをもとに、科目階層の一括更新を行う
         * @param {string} treeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload3(treeId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.fileUpload3(treeId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 選択させるために本体値を表示するPL科目階層を取得するAPI
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTreeForSelection(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountFlatTreeForSelectionView> {
            return localVarFp.getAccountTreeForSelection(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PL科目階層を取得するAPI
         * @param {string} treeId 
         * @param {boolean} isOnePLTree 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountTrees(treeId: string, isOnePLTree: boolean, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountFlatTreeWithMatchedNodesView> {
            return localVarFp.getAccountTrees(treeId, isOnePLTree, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 頂点科目変更のための科目リストを取得
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsForReplaceRootNodeSelection(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountsForReplaceRootNodeSelectionView> {
            return localVarFp.getAccountsForReplaceRootNodeSelection(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 親科目の科目タイプに基づいて追加可能な未設定科目のみを返却
         * @summary 指定した親科目に追加可能な未設定科目一覧を取得
         * @param {string} treeId 
         * @param {string} parentAccountId 
         * @param {boolean} [requireExSubAccount] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddableNotIncludedAccounts(treeId: string, parentAccountId: string, requireExSubAccount?: boolean, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<AddableNotIncludedAccountsView> {
            return localVarFp.getAddableNotIncludedAccounts(treeId, parentAccountId, requireExSubAccount, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS科目階層の未設定科目一覧(階層に含まれないBS科目、未識別)の科目を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBsNotIncluded(options?: RawAxiosRequestConfig): AxiosPromise<BsNotIncludedAccountsView> {
            return localVarFp.getBsNotIncluded(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目の階層構造に含まれない、AccountType=BS_ACCOUNTと集計科目以外の科目を取得
         * @param {string} treeId 
         * @param {boolean} requireExSubAccount 
         * @param {boolean} requireArchivedAccount 
         * @param {number} limit 
         * @param {number} [offset] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncluded1(treeId: string, requireExSubAccount: boolean, requireArchivedAccount: boolean, limit: number, offset?: number, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotIncludedAccountsView> {
            return localVarFp.getNotIncluded1(treeId, requireExSubAccount, requireArchivedAccount, limit, offset, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目の階層構造に含まれない、AccountType=BS_ACCOUNTと集計科目以外の科目の総数を取得（アーカイブ済み科目は含まない）
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncludedCount1(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<NotIncludedAccountCountView> {
            return localVarFp.getNotIncludedCount1(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PL科目階層内の科目移動において移動先候補を取得するAPI
         * @param {string} treeId 
         * @param {string} targetAccountId 
         * @param {boolean} isOnePLTree 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPLAccountMoveCandidates(treeId: string, targetAccountId: string, isOnePLTree: boolean, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<PLAccountFlatTreeViewForCandidate> {
            return localVarFp.getPLAccountMoveCandidates(treeId, targetAccountId, isOnePLTree, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目階層の一覧を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountTrees(options?: RawAxiosRequestConfig): AxiosPromise<AccountTreeListView> {
            return localVarFp.listAccountTrees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 既存の科目階層のコピーを作成する
         * @param {string} treeId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeCopyOfAccountTree(treeId: string, name: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountFlatTreeView> {
            return localVarFp.makeCopyOfAccountTree(treeId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 未設定科目の内、親科目がすでに科目階層にある外部システム補助科目を科目階層に、親科目がBS科目のものをBS科目に、自動で移動する
         * @param {string} accountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNodeAutomatically(accountTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<MovedNotIncludedAccountsView> {
            return localVarFp.moveNodeAutomatically(accountTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ノードを移動する
         * @param {string} treeId 
         * @param {MoveNodesRequestBody} moveNodesRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNodes1(treeId: string, moveNodesRequestBody: MoveNodesRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<AccountFlatTreeView> {
            return localVarFp.moveNodes1(treeId, moveNodesRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目階層の名前を変更する
         * @param {string} treeId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rename(treeId: string, name: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountFlatTreeView> {
            return localVarFp.rename(treeId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 頂点科目の変更
         * @param {string} treeId 
         * @param {ReplaceRootNodeRequestBody} replaceRootNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceRootNode(treeId: string, replaceRootNodeRequestBody: ReplaceRootNodeRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.replaceRootNode(treeId, replaceRootNodeRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目階層をプライマリに設定する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimary1(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.setPrimary1(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目階層のアーカイブ済みの科目を戻す
         * @param {string} treeId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveAccount(treeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.unarchiveAccount(treeId, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountTreeControllerApi - object-oriented interface
 */
export class AccountTreeControllerApi extends BaseAPI {
    /**
     * 
     * @summary 科目ツリーから科目をアーカイブする
     * @param {string} treeId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archiveAccount(treeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).archiveAccount(treeId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目階層を削除する
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAccountTree(treeId: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).deleteAccountTree(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定された科目を科目階層から外す
     * @param {string} treeId 
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public detachSubTree(treeId: string, accountId: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).detachSubTree(treeId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目階層のExcelダウンロード
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileDownload1(treeId: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).fileDownload1(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Excelファイルをもとに、科目階層の一括更新を行う
     * @param {string} treeId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUpload3(treeId: string, file: File, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).fileUpload3(treeId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 選択させるために本体値を表示するPL科目階層を取得するAPI
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAccountTreeForSelection(treeId: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).getAccountTreeForSelection(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PL科目階層を取得するAPI
     * @param {string} treeId 
     * @param {boolean} isOnePLTree 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAccountTrees(treeId: string, isOnePLTree: boolean, searchWord?: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).getAccountTrees(treeId, isOnePLTree, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 頂点科目変更のための科目リストを取得
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAccountsForReplaceRootNodeSelection(treeId: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).getAccountsForReplaceRootNodeSelection(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 親科目の科目タイプに基づいて追加可能な未設定科目のみを返却
     * @summary 指定した親科目に追加可能な未設定科目一覧を取得
     * @param {string} treeId 
     * @param {string} parentAccountId 
     * @param {boolean} [requireExSubAccount] 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAddableNotIncludedAccounts(treeId: string, parentAccountId: string, requireExSubAccount?: boolean, searchWord?: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).getAddableNotIncludedAccounts(treeId, parentAccountId, requireExSubAccount, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS科目階層の未設定科目一覧(階層に含まれないBS科目、未識別)の科目を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBsNotIncluded(options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).getBsNotIncluded(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目の階層構造に含まれない、AccountType=BS_ACCOUNTと集計科目以外の科目を取得
     * @param {string} treeId 
     * @param {boolean} requireExSubAccount 
     * @param {boolean} requireArchivedAccount 
     * @param {number} limit 
     * @param {number} [offset] 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotIncluded1(treeId: string, requireExSubAccount: boolean, requireArchivedAccount: boolean, limit: number, offset?: number, searchWord?: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).getNotIncluded1(treeId, requireExSubAccount, requireArchivedAccount, limit, offset, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目の階層構造に含まれない、AccountType=BS_ACCOUNTと集計科目以外の科目の総数を取得（アーカイブ済み科目は含まない）
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotIncludedCount1(treeId: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).getNotIncludedCount1(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PL科目階層内の科目移動において移動先候補を取得するAPI
     * @param {string} treeId 
     * @param {string} targetAccountId 
     * @param {boolean} isOnePLTree 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPLAccountMoveCandidates(treeId: string, targetAccountId: string, isOnePLTree: boolean, searchWord?: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).getPLAccountMoveCandidates(treeId, targetAccountId, isOnePLTree, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目階層の一覧を取得するAPI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAccountTrees(options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).listAccountTrees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 既存の科目階層のコピーを作成する
     * @param {string} treeId 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public makeCopyOfAccountTree(treeId: string, name: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).makeCopyOfAccountTree(treeId, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 未設定科目の内、親科目がすでに科目階層にある外部システム補助科目を科目階層に、親科目がBS科目のものをBS科目に、自動で移動する
     * @param {string} accountTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveNodeAutomatically(accountTreeId: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).moveNodeAutomatically(accountTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ノードを移動する
     * @param {string} treeId 
     * @param {MoveNodesRequestBody} moveNodesRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveNodes1(treeId: string, moveNodesRequestBody: MoveNodesRequestBody, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).moveNodes1(treeId, moveNodesRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目階層の名前を変更する
     * @param {string} treeId 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rename(treeId: string, name: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).rename(treeId, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 頂点科目の変更
     * @param {string} treeId 
     * @param {ReplaceRootNodeRequestBody} replaceRootNodeRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replaceRootNode(treeId: string, replaceRootNodeRequestBody: ReplaceRootNodeRequestBody, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).replaceRootNode(treeId, replaceRootNodeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目階層をプライマリに設定する
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setPrimary1(treeId: string, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).setPrimary1(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目階層のアーカイブ済みの科目を戻す
     * @param {string} treeId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unarchiveAccount(treeId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return AccountTreeControllerApiFp(this.configuration).unarchiveAccount(treeId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActualControllerApi - axios parameter creator
 */
export const ActualControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 対比表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountNodeFromComparison: async (accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountNodeFromComparison', 'accountId', accountId)
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('accountNodeFromComparison', 'accountTreeId', accountTreeId)
            // verify required parameter 'fetchActualRequestBody' is not null or undefined
            assertParamExists('accountNodeFromComparison', 'fetchActualRequestBody', fetchActualRequestBody)
            const localVarPath = `/api/actual/comparison/accounts/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchActualRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署別表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountNodeFromEachDepartment: async (accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountNodeFromEachDepartment', 'accountId', accountId)
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('accountNodeFromEachDepartment', 'accountTreeId', accountTreeId)
            // verify required parameter 'fetchActualRequestBody' is not null or undefined
            assertParamExists('accountNodeFromEachDepartment', 'fetchActualRequestBody', fetchActualRequestBody)
            const localVarPath = `/api/actual/each-department/accounts/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchActualRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署別対比表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountNodeFromEachDepartmentComparison: async (accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountNodeFromEachDepartmentComparison', 'accountId', accountId)
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('accountNodeFromEachDepartmentComparison', 'accountTreeId', accountTreeId)
            // verify required parameter 'fetchActualRequestBody' is not null or undefined
            assertParamExists('accountNodeFromEachDepartmentComparison', 'fetchActualRequestBody', fetchActualRequestBody)
            const localVarPath = `/api/actual/each-department-comparison/accounts/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchActualRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 推移表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountNodeFromHistory: async (accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('accountNodeFromHistory', 'accountId', accountId)
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('accountNodeFromHistory', 'accountTreeId', accountTreeId)
            // verify required parameter 'fetchActualRequestBody' is not null or undefined
            assertParamExists('accountNodeFromHistory', 'fetchActualRequestBody', fetchActualRequestBody)
            const localVarPath = `/api/actual/history/accounts/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchActualRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountNodeExcelFromComparison: async (accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromComparison', 'accountId', accountId)
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromComparison', 'accountTreeId', accountTreeId)
            // verify required parameter 'downloadActualExcelRequestBody' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromComparison', 'downloadActualExcelRequestBody', downloadActualExcelRequestBody)
            const localVarPath = `/api/actual/comparison/accounts/{accountId}/excel`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadActualExcelRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署別表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountNodeExcelFromEachDepartment: async (accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromEachDepartment', 'accountId', accountId)
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromEachDepartment', 'accountTreeId', accountTreeId)
            // verify required parameter 'downloadActualExcelRequestBody' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromEachDepartment', 'downloadActualExcelRequestBody', downloadActualExcelRequestBody)
            const localVarPath = `/api/actual/each-department/accounts/{accountId}/excel`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadActualExcelRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署別対比表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountNodeExcelFromEachDepartmentComparison: async (accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromEachDepartmentComparison', 'accountId', accountId)
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromEachDepartmentComparison', 'accountTreeId', accountTreeId)
            // verify required parameter 'downloadActualExcelRequestBody' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromEachDepartmentComparison', 'downloadActualExcelRequestBody', downloadActualExcelRequestBody)
            const localVarPath = `/api/actual/each-department-comparison/accounts/{accountId}/excel`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadActualExcelRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 推移表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountNodeExcelFromHistory: async (accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromHistory', 'accountId', accountId)
            // verify required parameter 'accountTreeId' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromHistory', 'accountTreeId', accountTreeId)
            // verify required parameter 'downloadActualExcelRequestBody' is not null or undefined
            assertParamExists('downloadAccountNodeExcelFromHistory', 'downloadActualExcelRequestBody', downloadActualExcelRequestBody)
            const localVarPath = `/api/actual/history/accounts/{accountId}/excel`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountTreeId !== undefined) {
                localVarQueryParameter['accountTreeId'] = accountTreeId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadActualExcelRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary テナントの実績範囲（現状は最新実績月）を取得する。実績が無い場合はnullを返す。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActualMonthRange: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/actual/month-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActualControllerApi - functional programming interface
 */
export const ActualControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActualControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 対比表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountNodeFromComparison(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalDescriptionsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountNodeFromComparison(accountId, accountTreeId, fetchActualRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualControllerApi.accountNodeFromComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署別表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountNodeFromEachDepartment(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalDescriptionsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountNodeFromEachDepartment(accountId, accountTreeId, fetchActualRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualControllerApi.accountNodeFromEachDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署別対比表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountNodeFromEachDepartmentComparison(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalDescriptionsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountNodeFromEachDepartmentComparison(accountId, accountTreeId, fetchActualRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualControllerApi.accountNodeFromEachDepartmentComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 推移表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountNodeFromHistory(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JournalDescriptionsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountNodeFromHistory(accountId, accountTreeId, fetchActualRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualControllerApi.accountNodeFromHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAccountNodeExcelFromComparison(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAccountNodeExcelFromComparison(accountId, accountTreeId, downloadActualExcelRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualControllerApi.downloadAccountNodeExcelFromComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署別表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAccountNodeExcelFromEachDepartment(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAccountNodeExcelFromEachDepartment(accountId, accountTreeId, downloadActualExcelRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualControllerApi.downloadAccountNodeExcelFromEachDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署別対比表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAccountNodeExcelFromEachDepartmentComparison(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAccountNodeExcelFromEachDepartmentComparison(accountId, accountTreeId, downloadActualExcelRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualControllerApi.downloadAccountNodeExcelFromEachDepartmentComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 推移表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAccountNodeExcelFromHistory(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAccountNodeExcelFromHistory(accountId, accountTreeId, downloadActualExcelRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualControllerApi.downloadAccountNodeExcelFromHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary テナントの実績範囲（現状は最新実績月）を取得する。実績が無い場合はnullを返す。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActualMonthRange(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActualMonthRangeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActualMonthRange(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualControllerApi.getActualMonthRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActualControllerApi - factory interface
 */
export const ActualControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActualControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 対比表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountNodeFromComparison(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<JournalDescriptionsView> {
            return localVarFp.accountNodeFromComparison(accountId, accountTreeId, fetchActualRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署別表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountNodeFromEachDepartment(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<JournalDescriptionsView> {
            return localVarFp.accountNodeFromEachDepartment(accountId, accountTreeId, fetchActualRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署別対比表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountNodeFromEachDepartmentComparison(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<JournalDescriptionsView> {
            return localVarFp.accountNodeFromEachDepartmentComparison(accountId, accountTreeId, fetchActualRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 推移表の会計実績仕訳の出力。科目とその配下の科目。
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {FetchActualRequestBody} fetchActualRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountNodeFromHistory(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<JournalDescriptionsView> {
            return localVarFp.accountNodeFromHistory(accountId, accountTreeId, fetchActualRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountNodeExcelFromComparison(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadAccountNodeExcelFromComparison(accountId, accountTreeId, downloadActualExcelRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署別表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountNodeExcelFromEachDepartment(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadAccountNodeExcelFromEachDepartment(accountId, accountTreeId, downloadActualExcelRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署別対比表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountNodeExcelFromEachDepartmentComparison(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadAccountNodeExcelFromEachDepartmentComparison(accountId, accountTreeId, downloadActualExcelRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 推移表の会計実績仕訳の出力をExcelでダウンロードする
         * @param {string} accountId 
         * @param {string} accountTreeId 
         * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAccountNodeExcelFromHistory(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadAccountNodeExcelFromHistory(accountId, accountTreeId, downloadActualExcelRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary テナントの実績範囲（現状は最新実績月）を取得する。実績が無い場合はnullを返す。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActualMonthRange(options?: RawAxiosRequestConfig): AxiosPromise<ActualMonthRangeView> {
            return localVarFp.getActualMonthRange(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActualControllerApi - object-oriented interface
 */
export class ActualControllerApi extends BaseAPI {
    /**
     * 
     * @summary 対比表の会計実績仕訳の出力。科目とその配下の科目。
     * @param {string} accountId 
     * @param {string} accountTreeId 
     * @param {FetchActualRequestBody} fetchActualRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public accountNodeFromComparison(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig) {
        return ActualControllerApiFp(this.configuration).accountNodeFromComparison(accountId, accountTreeId, fetchActualRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署別表の会計実績仕訳の出力。科目とその配下の科目。
     * @param {string} accountId 
     * @param {string} accountTreeId 
     * @param {FetchActualRequestBody} fetchActualRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public accountNodeFromEachDepartment(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig) {
        return ActualControllerApiFp(this.configuration).accountNodeFromEachDepartment(accountId, accountTreeId, fetchActualRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署別対比表の会計実績仕訳の出力。科目とその配下の科目。
     * @param {string} accountId 
     * @param {string} accountTreeId 
     * @param {FetchActualRequestBody} fetchActualRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public accountNodeFromEachDepartmentComparison(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig) {
        return ActualControllerApiFp(this.configuration).accountNodeFromEachDepartmentComparison(accountId, accountTreeId, fetchActualRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 推移表の会計実績仕訳の出力。科目とその配下の科目。
     * @param {string} accountId 
     * @param {string} accountTreeId 
     * @param {FetchActualRequestBody} fetchActualRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public accountNodeFromHistory(accountId: string, accountTreeId: string, fetchActualRequestBody: FetchActualRequestBody, options?: RawAxiosRequestConfig) {
        return ActualControllerApiFp(this.configuration).accountNodeFromHistory(accountId, accountTreeId, fetchActualRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比表の会計実績仕訳の出力をExcelでダウンロードする
     * @param {string} accountId 
     * @param {string} accountTreeId 
     * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAccountNodeExcelFromComparison(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig) {
        return ActualControllerApiFp(this.configuration).downloadAccountNodeExcelFromComparison(accountId, accountTreeId, downloadActualExcelRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署別表の会計実績仕訳の出力をExcelでダウンロードする
     * @param {string} accountId 
     * @param {string} accountTreeId 
     * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAccountNodeExcelFromEachDepartment(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig) {
        return ActualControllerApiFp(this.configuration).downloadAccountNodeExcelFromEachDepartment(accountId, accountTreeId, downloadActualExcelRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署別対比表の会計実績仕訳の出力をExcelでダウンロードする
     * @param {string} accountId 
     * @param {string} accountTreeId 
     * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAccountNodeExcelFromEachDepartmentComparison(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig) {
        return ActualControllerApiFp(this.configuration).downloadAccountNodeExcelFromEachDepartmentComparison(accountId, accountTreeId, downloadActualExcelRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 推移表の会計実績仕訳の出力をExcelでダウンロードする
     * @param {string} accountId 
     * @param {string} accountTreeId 
     * @param {DownloadActualExcelRequestBody} downloadActualExcelRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAccountNodeExcelFromHistory(accountId: string, accountTreeId: string, downloadActualExcelRequestBody: DownloadActualExcelRequestBody, options?: RawAxiosRequestConfig) {
        return ActualControllerApiFp(this.configuration).downloadAccountNodeExcelFromHistory(accountId, accountTreeId, downloadActualExcelRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary テナントの実績範囲（現状は最新実績月）を取得する。実績が無い場合はnullを返す。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getActualMonthRange(options?: RawAxiosRequestConfig) {
        return ActualControllerApiFp(this.configuration).getActualMonthRange(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActualsImportControllerApi - axios parameter creator
 */
export const ActualsImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 科目変換ルールを適用し明細を作成する
         * @param {ApplyAccountConversionRuleBody} applyAccountConversionRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAccountConversionRule: async (applyAccountConversionRuleBody: ApplyAccountConversionRuleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyAccountConversionRuleBody' is not null or undefined
            assertParamExists('applyAccountConversionRule', 'applyAccountConversionRuleBody', applyAccountConversionRuleBody)
            const localVarPath = `/api/upload-actual/apply-account-conversion-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyAccountConversionRuleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImportEvent: async (importEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importEventId' is not null or undefined
            assertParamExists('deleteImportEvent', 'importEventId', importEventId)
            const localVarPath = `/api/upload-actual/history/{importEventId}`
                .replace('{importEventId}', encodeURIComponent(String(importEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadActualImportFile: async (importEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importEventId' is not null or undefined
            assertParamExists('downloadActualImportFile', 'importEventId', importEventId)
            const localVarPath = `/api/upload-actual/{importEventId}/file`
                .replace('{importEventId}', encodeURIComponent(String(importEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadErrorExcel: async (importEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importEventId' is not null or undefined
            assertParamExists('downloadErrorExcel', 'importEventId', importEventId)
            const localVarPath = `/api/upload-actual/{importEventId}/error_excel`
                .replace('{importEventId}', encodeURIComponent(String(importEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActualsImports: async (importEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importEventId' is not null or undefined
            assertParamExists('findActualsImports', 'importEventId', importEventId)
            const localVarPath = `/api/upload-actual/history/{importEventId}`
                .replace('{importEventId}', encodeURIComponent(String(importEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取込設定を用いた財務実績アップロードで利用する型生成用
         * @param {ForOpenApiGeneratorRequest} [forOpenApiGeneratorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forOpenApiGenerator: async (forOpenApiGeneratorRequest?: ForOpenApiGeneratorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/upload-actual/forOnlyOpenApiGenerator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forOpenApiGeneratorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} offset 
         * @param {ListActualsImportsSortKeyEnum} sortKey 
         * @param {boolean} isAsc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActualsImports: async (limit: number, offset: number, sortKey: ListActualsImportsSortKeyEnum, isAsc: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('listActualsImports', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('listActualsImports', 'offset', offset)
            // verify required parameter 'sortKey' is not null or undefined
            assertParamExists('listActualsImports', 'sortKey', sortKey)
            // verify required parameter 'isAsc' is not null or undefined
            assertParamExists('listActualsImports', 'isAsc', isAsc)
            const localVarPath = `/api/upload-actual/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }

            if (isAsc !== undefined) {
                localVarQueryParameter['isAsc'] = isAsc;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {UploadActualByMappingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadActualByMapping: async (file: File, params: UploadActualByMappingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadActualByMapping', 'file', file)
            // verify required parameter 'params' is not null or undefined
            assertParamExists('uploadActualByMapping', 'params', params)
            const localVarPath = `/api/upload-actual/mapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (params !== undefined) { 
                localVarFormParams.append('params', new Blob([JSON.stringify(params, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UploadActualCSVAccountingSystemTypeEnum} accountingSystemType 
         * @param {string} [subsidiaryCode] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadActualCSV: async (accountingSystemType: UploadActualCSVAccountingSystemTypeEnum, subsidiaryCode?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountingSystemType' is not null or undefined
            assertParamExists('uploadActualCSV', 'accountingSystemType', accountingSystemType)
            const localVarPath = `/api/upload-actual/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (accountingSystemType !== undefined) {
                localVarQueryParameter['accountingSystemType'] = accountingSystemType;
            }

            if (subsidiaryCode !== undefined) {
                localVarQueryParameter['subsidiaryCode'] = subsidiaryCode;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActualsImportControllerApi - functional programming interface
 */
export const ActualsImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActualsImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 科目変換ルールを適用し明細を作成する
         * @param {ApplyAccountConversionRuleBody} applyAccountConversionRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyAccountConversionRule(applyAccountConversionRuleBody: ApplyAccountConversionRuleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActualImportEventView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyAccountConversionRule(applyAccountConversionRuleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportControllerApi.applyAccountConversionRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteImportEvent(importEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteImportEvent(importEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportControllerApi.deleteImportEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadActualImportFile(importEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadActualImportFile(importEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportControllerApi.downloadActualImportFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadErrorExcel(importEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadErrorExcel(importEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportControllerApi.downloadErrorExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findActualsImports(importEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActualImportEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findActualsImports(importEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportControllerApi.findActualsImports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 取込設定を用いた財務実績アップロードで利用する型生成用
         * @param {ForOpenApiGeneratorRequest} [forOpenApiGeneratorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forOpenApiGenerator(forOpenApiGeneratorRequest?: ForOpenApiGeneratorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forOpenApiGenerator(forOpenApiGeneratorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportControllerApi.forOpenApiGenerator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} offset 
         * @param {ListActualsImportsSortKeyEnum} sortKey 
         * @param {boolean} isAsc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActualsImports(limit: number, offset: number, sortKey: ListActualsImportsSortKeyEnum, isAsc: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoActualImportEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActualsImports(limit, offset, sortKey, isAsc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportControllerApi.listActualsImports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {UploadActualByMappingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadActualByMapping(file: File, params: UploadActualByMappingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActualImportEventView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadActualByMapping(file, params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportControllerApi.uploadActualByMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UploadActualCSVAccountingSystemTypeEnum} accountingSystemType 
         * @param {string} [subsidiaryCode] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadActualCSV(accountingSystemType: UploadActualCSVAccountingSystemTypeEnum, subsidiaryCode?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActualImportEventView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadActualCSV(accountingSystemType, subsidiaryCode, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportControllerApi.uploadActualCSV']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActualsImportControllerApi - factory interface
 */
export const ActualsImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActualsImportControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 科目変換ルールを適用し明細を作成する
         * @param {ApplyAccountConversionRuleBody} applyAccountConversionRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAccountConversionRule(applyAccountConversionRuleBody: ApplyAccountConversionRuleBody, options?: RawAxiosRequestConfig): AxiosPromise<ActualImportEventView> {
            return localVarFp.applyAccountConversionRule(applyAccountConversionRuleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImportEvent(importEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteImportEvent(importEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadActualImportFile(importEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadActualImportFile(importEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadErrorExcel(importEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadErrorExcel(importEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActualsImports(importEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<ActualImportEventDto> {
            return localVarFp.findActualsImports(importEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取込設定を用いた財務実績アップロードで利用する型生成用
         * @param {ForOpenApiGeneratorRequest} [forOpenApiGeneratorRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forOpenApiGenerator(forOpenApiGeneratorRequest?: ForOpenApiGeneratorRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forOpenApiGenerator(forOpenApiGeneratorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} offset 
         * @param {ListActualsImportsSortKeyEnum} sortKey 
         * @param {boolean} isAsc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActualsImports(limit: number, offset: number, sortKey: ListActualsImportsSortKeyEnum, isAsc: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoActualImportEventDto> {
            return localVarFp.listActualsImports(limit, offset, sortKey, isAsc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} file 
         * @param {UploadActualByMappingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadActualByMapping(file: File, params: UploadActualByMappingParams, options?: RawAxiosRequestConfig): AxiosPromise<ActualImportEventView> {
            return localVarFp.uploadActualByMapping(file, params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UploadActualCSVAccountingSystemTypeEnum} accountingSystemType 
         * @param {string} [subsidiaryCode] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadActualCSV(accountingSystemType: UploadActualCSVAccountingSystemTypeEnum, subsidiaryCode?: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<ActualImportEventView> {
            return localVarFp.uploadActualCSV(accountingSystemType, subsidiaryCode, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActualsImportControllerApi - object-oriented interface
 */
export class ActualsImportControllerApi extends BaseAPI {
    /**
     * 
     * @summary 科目変換ルールを適用し明細を作成する
     * @param {ApplyAccountConversionRuleBody} applyAccountConversionRuleBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public applyAccountConversionRule(applyAccountConversionRuleBody: ApplyAccountConversionRuleBody, options?: RawAxiosRequestConfig) {
        return ActualsImportControllerApiFp(this.configuration).applyAccountConversionRule(applyAccountConversionRuleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} importEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteImportEvent(importEventId: string, options?: RawAxiosRequestConfig) {
        return ActualsImportControllerApiFp(this.configuration).deleteImportEvent(importEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} importEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadActualImportFile(importEventId: string, options?: RawAxiosRequestConfig) {
        return ActualsImportControllerApiFp(this.configuration).downloadActualImportFile(importEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} importEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadErrorExcel(importEventId: string, options?: RawAxiosRequestConfig) {
        return ActualsImportControllerApiFp(this.configuration).downloadErrorExcel(importEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} importEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findActualsImports(importEventId: string, options?: RawAxiosRequestConfig) {
        return ActualsImportControllerApiFp(this.configuration).findActualsImports(importEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取込設定を用いた財務実績アップロードで利用する型生成用
     * @param {ForOpenApiGeneratorRequest} [forOpenApiGeneratorRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forOpenApiGenerator(forOpenApiGeneratorRequest?: ForOpenApiGeneratorRequest, options?: RawAxiosRequestConfig) {
        return ActualsImportControllerApiFp(this.configuration).forOpenApiGenerator(forOpenApiGeneratorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} limit 
     * @param {number} offset 
     * @param {ListActualsImportsSortKeyEnum} sortKey 
     * @param {boolean} isAsc 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listActualsImports(limit: number, offset: number, sortKey: ListActualsImportsSortKeyEnum, isAsc: boolean, options?: RawAxiosRequestConfig) {
        return ActualsImportControllerApiFp(this.configuration).listActualsImports(limit, offset, sortKey, isAsc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} file 
     * @param {UploadActualByMappingParams} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadActualByMapping(file: File, params: UploadActualByMappingParams, options?: RawAxiosRequestConfig) {
        return ActualsImportControllerApiFp(this.configuration).uploadActualByMapping(file, params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UploadActualCSVAccountingSystemTypeEnum} accountingSystemType 
     * @param {string} [subsidiaryCode] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadActualCSV(accountingSystemType: UploadActualCSVAccountingSystemTypeEnum, subsidiaryCode?: string, file?: File, options?: RawAxiosRequestConfig) {
        return ActualsImportControllerApiFp(this.configuration).uploadActualCSV(accountingSystemType, subsidiaryCode, file, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListActualsImportsSortKeyEnum = {
    FileName: 'FILE_NAME',
    MinFiscalMonth: 'MIN_FISCAL_MONTH',
    ImportedAt: 'IMPORTED_AT',
} as const;
export type ListActualsImportsSortKeyEnum = typeof ListActualsImportsSortKeyEnum[keyof typeof ListActualsImportsSortKeyEnum];
export const UploadActualCSVAccountingSystemTypeEnum = {
    Miroku: 'MIROKU',
    KanjoBugyo: 'KANJO_BUGYO',
    MoneyForward: 'MONEY_FORWARD',
    MoneyForwardPlus: 'MONEY_FORWARD_PLUS',
    Freee: 'FREEE',
    FreeeV2: 'FREEE_V2',
    Obic7: 'OBIC7',
    Yayoi: 'YAYOI',
    Sap: 'SAP',
    SapSalesReport: 'SAP_SALES_REPORT',
    Pca: 'PCA',
    NetSuite: 'NET_SUITE',
    Fx4: 'FX4',
    Fx5: 'FX5',
    BizIntegral: 'BIZ_INTEGRAL',
    Ai21: 'AI21',
    LoglassDepartments: 'LOGLASS_DEPARTMENTS',
    LoglassDetail: 'LOGLASS_DETAIL',
    SuperStream: 'SUPER_STREAM',
    LoglassJournal: 'LOGLASS_JOURNAL',
    Loglass: 'LOGLASS',
    Mapping: 'MAPPING',
    AccountConversion: 'ACCOUNT_CONVERSION',
} as const;
export type UploadActualCSVAccountingSystemTypeEnum = typeof UploadActualCSVAccountingSystemTypeEnum[keyof typeof UploadActualCSVAccountingSystemTypeEnum];


/**
 * ActualsImportMappingControllerApi - axios parameter creator
 */
export const ActualsImportMappingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 実績取込設定新規作成
         * @param {CreateActualsImportMappingParams} createActualsImportMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActualsImportMapping: async (createActualsImportMappingParams: CreateActualsImportMappingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createActualsImportMappingParams' is not null or undefined
            assertParamExists('createActualsImportMapping', 'createActualsImportMappingParams', createActualsImportMappingParams)
            const localVarPath = `/api/actualsImportMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createActualsImportMappingParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 実績取込設定削除
         * @param {string} actualsImportMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActualsImportMapping: async (actualsImportMappingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actualsImportMappingId' is not null or undefined
            assertParamExists('deleteActualsImportMapping', 'actualsImportMappingId', actualsImportMappingId)
            const localVarPath = `/api/actualsImportMappings/{actualsImportMappingId}`
                .replace('{actualsImportMappingId}', encodeURIComponent(String(actualsImportMappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 実績取込設定
         * @param {string} actualsImportMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActualsImportMapping: async (actualsImportMappingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actualsImportMappingId' is not null or undefined
            assertParamExists('findActualsImportMapping', 'actualsImportMappingId', actualsImportMappingId)
            const localVarPath = `/api/actualsImportMappings/{actualsImportMappingId}`
                .replace('{actualsImportMappingId}', encodeURIComponent(String(actualsImportMappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 実績取込設定一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActualsImportMappings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/actualsImportMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 実績取込設定更新
         * @param {string} actualsImportMappingId 
         * @param {UpdateActualsImportMappingParams} updateActualsImportMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActualsImportMapping: async (actualsImportMappingId: string, updateActualsImportMappingParams: UpdateActualsImportMappingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actualsImportMappingId' is not null or undefined
            assertParamExists('updateActualsImportMapping', 'actualsImportMappingId', actualsImportMappingId)
            // verify required parameter 'updateActualsImportMappingParams' is not null or undefined
            assertParamExists('updateActualsImportMapping', 'updateActualsImportMappingParams', updateActualsImportMappingParams)
            const localVarPath = `/api/actualsImportMappings/{actualsImportMappingId}`
                .replace('{actualsImportMappingId}', encodeURIComponent(String(actualsImportMappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateActualsImportMappingParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActualsImportMappingControllerApi - functional programming interface
 */
export const ActualsImportMappingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActualsImportMappingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 実績取込設定新規作成
         * @param {CreateActualsImportMappingParams} createActualsImportMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActualsImportMapping(createActualsImportMappingParams: CreateActualsImportMappingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActualsImportMapping(createActualsImportMappingParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportMappingControllerApi.createActualsImportMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 実績取込設定削除
         * @param {string} actualsImportMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActualsImportMapping(actualsImportMappingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActualsImportMapping(actualsImportMappingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportMappingControllerApi.deleteActualsImportMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 実績取込設定
         * @param {string} actualsImportMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findActualsImportMapping(actualsImportMappingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActualImportMappingData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findActualsImportMapping(actualsImportMappingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportMappingControllerApi.findActualsImportMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 実績取込設定一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActualsImportMappings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActualsImportMappingView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActualsImportMappings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportMappingControllerApi.listActualsImportMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 実績取込設定更新
         * @param {string} actualsImportMappingId 
         * @param {UpdateActualsImportMappingParams} updateActualsImportMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateActualsImportMapping(actualsImportMappingId: string, updateActualsImportMappingParams: UpdateActualsImportMappingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateActualsImportMapping(actualsImportMappingId, updateActualsImportMappingParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActualsImportMappingControllerApi.updateActualsImportMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActualsImportMappingControllerApi - factory interface
 */
export const ActualsImportMappingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActualsImportMappingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 実績取込設定新規作成
         * @param {CreateActualsImportMappingParams} createActualsImportMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActualsImportMapping(createActualsImportMappingParams: CreateActualsImportMappingParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createActualsImportMapping(createActualsImportMappingParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 実績取込設定削除
         * @param {string} actualsImportMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActualsImportMapping(actualsImportMappingId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteActualsImportMapping(actualsImportMappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 実績取込設定
         * @param {string} actualsImportMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findActualsImportMapping(actualsImportMappingId: string, options?: RawAxiosRequestConfig): AxiosPromise<ActualImportMappingData> {
            return localVarFp.findActualsImportMapping(actualsImportMappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 実績取込設定一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActualsImportMappings(options?: RawAxiosRequestConfig): AxiosPromise<Array<ActualsImportMappingView>> {
            return localVarFp.listActualsImportMappings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 実績取込設定更新
         * @param {string} actualsImportMappingId 
         * @param {UpdateActualsImportMappingParams} updateActualsImportMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActualsImportMapping(actualsImportMappingId: string, updateActualsImportMappingParams: UpdateActualsImportMappingParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateActualsImportMapping(actualsImportMappingId, updateActualsImportMappingParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActualsImportMappingControllerApi - object-oriented interface
 */
export class ActualsImportMappingControllerApi extends BaseAPI {
    /**
     * 
     * @summary 実績取込設定新規作成
     * @param {CreateActualsImportMappingParams} createActualsImportMappingParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createActualsImportMapping(createActualsImportMappingParams: CreateActualsImportMappingParams, options?: RawAxiosRequestConfig) {
        return ActualsImportMappingControllerApiFp(this.configuration).createActualsImportMapping(createActualsImportMappingParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 実績取込設定削除
     * @param {string} actualsImportMappingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteActualsImportMapping(actualsImportMappingId: string, options?: RawAxiosRequestConfig) {
        return ActualsImportMappingControllerApiFp(this.configuration).deleteActualsImportMapping(actualsImportMappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 実績取込設定
     * @param {string} actualsImportMappingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findActualsImportMapping(actualsImportMappingId: string, options?: RawAxiosRequestConfig) {
        return ActualsImportMappingControllerApiFp(this.configuration).findActualsImportMapping(actualsImportMappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 実績取込設定一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listActualsImportMappings(options?: RawAxiosRequestConfig) {
        return ActualsImportMappingControllerApiFp(this.configuration).listActualsImportMappings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 実績取込設定更新
     * @param {string} actualsImportMappingId 
     * @param {UpdateActualsImportMappingParams} updateActualsImportMappingParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateActualsImportMapping(actualsImportMappingId: string, updateActualsImportMappingParams: UpdateActualsImportMappingParams, options?: RawAxiosRequestConfig) {
        return ActualsImportMappingControllerApiFp(this.configuration).updateActualsImportMapping(actualsImportMappingId, updateActualsImportMappingParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AiChatCustomPromptControllerApi - axios parameter creator
 */
export const AiChatCustomPromptControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary AIチャットカスタム指示を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAiChatCustomPrompt: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ai-chat-custom-prompts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AIチャットカスタム指示を保存
         * @param {SaveAiChatCustomPromptParam} saveAiChatCustomPromptParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAiChatCustomPrompt: async (saveAiChatCustomPromptParam: SaveAiChatCustomPromptParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveAiChatCustomPromptParam' is not null or undefined
            assertParamExists('saveAiChatCustomPrompt', 'saveAiChatCustomPromptParam', saveAiChatCustomPromptParam)
            const localVarPath = `/api/ai-chat-custom-prompts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAiChatCustomPromptParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiChatCustomPromptControllerApi - functional programming interface
 */
export const AiChatCustomPromptControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiChatCustomPromptControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary AIチャットカスタム指示を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAiChatCustomPrompt(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiChatCustomPromptView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAiChatCustomPrompt(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiChatCustomPromptControllerApi.fetchAiChatCustomPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AIチャットカスタム指示を保存
         * @param {SaveAiChatCustomPromptParam} saveAiChatCustomPromptParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAiChatCustomPrompt(saveAiChatCustomPromptParam: SaveAiChatCustomPromptParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAiChatCustomPrompt(saveAiChatCustomPromptParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiChatCustomPromptControllerApi.saveAiChatCustomPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AiChatCustomPromptControllerApi - factory interface
 */
export const AiChatCustomPromptControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiChatCustomPromptControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary AIチャットカスタム指示を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAiChatCustomPrompt(options?: RawAxiosRequestConfig): AxiosPromise<AiChatCustomPromptView> {
            return localVarFp.fetchAiChatCustomPrompt(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AIチャットカスタム指示を保存
         * @param {SaveAiChatCustomPromptParam} saveAiChatCustomPromptParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAiChatCustomPrompt(saveAiChatCustomPromptParam: SaveAiChatCustomPromptParam, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveAiChatCustomPrompt(saveAiChatCustomPromptParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiChatCustomPromptControllerApi - object-oriented interface
 */
export class AiChatCustomPromptControllerApi extends BaseAPI {
    /**
     * 
     * @summary AIチャットカスタム指示を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAiChatCustomPrompt(options?: RawAxiosRequestConfig) {
        return AiChatCustomPromptControllerApiFp(this.configuration).fetchAiChatCustomPrompt(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AIチャットカスタム指示を保存
     * @param {SaveAiChatCustomPromptParam} saveAiChatCustomPromptParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveAiChatCustomPrompt(saveAiChatCustomPromptParam: SaveAiChatCustomPromptParam, options?: RawAxiosRequestConfig) {
        return AiChatCustomPromptControllerApiFp(this.configuration).saveAiChatCustomPrompt(saveAiChatCustomPromptParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AiChatTermsConsentControllerApi - axios parameter creator
 */
export const AiChatTermsConsentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary AIチャット利用規約に同意する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentAiChatTerms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ai-chat-terms-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AIチャット利用規約の同意状態を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAiChatTermsConsent: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ai-chat-terms-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiChatTermsConsentControllerApi - functional programming interface
 */
export const AiChatTermsConsentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiChatTermsConsentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary AIチャット利用規約に同意する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consentAiChatTerms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consentAiChatTerms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiChatTermsConsentControllerApi.consentAiChatTerms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AIチャット利用規約の同意状態を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAiChatTermsConsent(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiChatTermsConsentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAiChatTermsConsent(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiChatTermsConsentControllerApi.fetchAiChatTermsConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AiChatTermsConsentControllerApi - factory interface
 */
export const AiChatTermsConsentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiChatTermsConsentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary AIチャット利用規約に同意する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentAiChatTerms(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.consentAiChatTerms(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AIチャット利用規約の同意状態を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAiChatTermsConsent(options?: RawAxiosRequestConfig): AxiosPromise<AiChatTermsConsentView> {
            return localVarFp.fetchAiChatTermsConsent(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiChatTermsConsentControllerApi - object-oriented interface
 */
export class AiChatTermsConsentControllerApi extends BaseAPI {
    /**
     * 
     * @summary AIチャット利用規約に同意する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public consentAiChatTerms(options?: RawAxiosRequestConfig) {
        return AiChatTermsConsentControllerApiFp(this.configuration).consentAiChatTerms(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AIチャット利用規約の同意状態を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAiChatTermsConsent(options?: RawAxiosRequestConfig) {
        return AiChatTermsConsentControllerApiFp(this.configuration).fetchAiChatTermsConsent(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AllocationExecuteControllerApi - axios parameter creator
 */
export const AllocationExecuteControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 振替・配賦を実行する
         * @param {ExecuteAllocationRequestBody} executeAllocationRequestBody 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeAllocation1: async (executeAllocationRequestBody: ExecuteAllocationRequestBody, planId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executeAllocationRequestBody' is not null or undefined
            assertParamExists('executeAllocation1', 'executeAllocationRequestBody', executeAllocationRequestBody)
            const localVarPath = `/api/allocation-execute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(executeAllocationRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦を非同期に実行する
         * @param {ExecuteAllocationRequestBody} executeAllocationRequestBody 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeAllocationAsync: async (executeAllocationRequestBody: ExecuteAllocationRequestBody, planId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executeAllocationRequestBody' is not null or undefined
            assertParamExists('executeAllocationAsync', 'executeAllocationRequestBody', executeAllocationRequestBody)
            const localVarPath = `/api/allocation-execute/async`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(executeAllocationRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllocationExecuteControllerApi - functional programming interface
 */
export const AllocationExecuteControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllocationExecuteControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 振替・配賦を実行する
         * @param {ExecuteAllocationRequestBody} executeAllocationRequestBody 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeAllocation1(executeAllocationRequestBody: ExecuteAllocationRequestBody, planId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeAllocation1(executeAllocationRequestBody, planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationExecuteControllerApi.executeAllocation1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦を非同期に実行する
         * @param {ExecuteAllocationRequestBody} executeAllocationRequestBody 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeAllocationAsync(executeAllocationRequestBody: ExecuteAllocationRequestBody, planId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeAllocationAsync(executeAllocationRequestBody, planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationExecuteControllerApi.executeAllocationAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllocationExecuteControllerApi - factory interface
 */
export const AllocationExecuteControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllocationExecuteControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 振替・配賦を実行する
         * @param {ExecuteAllocationRequestBody} executeAllocationRequestBody 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeAllocation1(executeAllocationRequestBody: ExecuteAllocationRequestBody, planId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.executeAllocation1(executeAllocationRequestBody, planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦を非同期に実行する
         * @param {ExecuteAllocationRequestBody} executeAllocationRequestBody 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeAllocationAsync(executeAllocationRequestBody: ExecuteAllocationRequestBody, planId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.executeAllocationAsync(executeAllocationRequestBody, planId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllocationExecuteControllerApi - object-oriented interface
 */
export class AllocationExecuteControllerApi extends BaseAPI {
    /**
     * 
     * @summary 振替・配賦を実行する
     * @param {ExecuteAllocationRequestBody} executeAllocationRequestBody 
     * @param {string} [planId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public executeAllocation1(executeAllocationRequestBody: ExecuteAllocationRequestBody, planId?: string, options?: RawAxiosRequestConfig) {
        return AllocationExecuteControllerApiFp(this.configuration).executeAllocation1(executeAllocationRequestBody, planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦を非同期に実行する
     * @param {ExecuteAllocationRequestBody} executeAllocationRequestBody 
     * @param {string} [planId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public executeAllocationAsync(executeAllocationRequestBody: ExecuteAllocationRequestBody, planId?: string, options?: RawAxiosRequestConfig) {
        return AllocationExecuteControllerApiFp(this.configuration).executeAllocationAsync(executeAllocationRequestBody, planId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AllocationResultsControllerApi - axios parameter creator
 */
export const AllocationResultsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 配賦実行結果をCSVでダウンロードする
         * @param {GetAllocationResultsCsvTargetTypeEnum} targetType 
         * @param {Array<string>} yearMonthSet 
         * @param {string} [planId] 
         * @param {string} [patternId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllocationResultsCsv: async (targetType: GetAllocationResultsCsvTargetTypeEnum, yearMonthSet: Array<string>, planId?: string, patternId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetType' is not null or undefined
            assertParamExists('getAllocationResultsCsv', 'targetType', targetType)
            // verify required parameter 'yearMonthSet' is not null or undefined
            assertParamExists('getAllocationResultsCsv', 'yearMonthSet', yearMonthSet)
            const localVarPath = `/api/allocation-results/strategies/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetType !== undefined) {
                localVarQueryParameter['targetType'] = targetType;
            }

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            if (yearMonthSet) {
                localVarQueryParameter['yearMonthSet'] = yearMonthSet;
            }

            if (patternId !== undefined) {
                localVarQueryParameter['patternId'] = patternId;
            }

            localVarHeaderParameter['Accept'] = 'text/csv; charset=utf-8,text/csv;charset=utf-8,*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllocationResultsControllerApi - functional programming interface
 */
export const AllocationResultsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllocationResultsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 配賦実行結果をCSVでダウンロードする
         * @param {GetAllocationResultsCsvTargetTypeEnum} targetType 
         * @param {Array<string>} yearMonthSet 
         * @param {string} [planId] 
         * @param {string} [patternId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllocationResultsCsv(targetType: GetAllocationResultsCsvTargetTypeEnum, yearMonthSet: Array<string>, planId?: string, patternId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllocationResultsCsv(targetType, yearMonthSet, planId, patternId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationResultsControllerApi.getAllocationResultsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllocationResultsControllerApi - factory interface
 */
export const AllocationResultsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllocationResultsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 配賦実行結果をCSVでダウンロードする
         * @param {GetAllocationResultsCsvTargetTypeEnum} targetType 
         * @param {Array<string>} yearMonthSet 
         * @param {string} [planId] 
         * @param {string} [patternId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllocationResultsCsv(targetType: GetAllocationResultsCsvTargetTypeEnum, yearMonthSet: Array<string>, planId?: string, patternId?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getAllocationResultsCsv(targetType, yearMonthSet, planId, patternId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllocationResultsControllerApi - object-oriented interface
 */
export class AllocationResultsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 配賦実行結果をCSVでダウンロードする
     * @param {GetAllocationResultsCsvTargetTypeEnum} targetType 
     * @param {Array<string>} yearMonthSet 
     * @param {string} [planId] 
     * @param {string} [patternId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllocationResultsCsv(targetType: GetAllocationResultsCsvTargetTypeEnum, yearMonthSet: Array<string>, planId?: string, patternId?: string, options?: RawAxiosRequestConfig) {
        return AllocationResultsControllerApiFp(this.configuration).getAllocationResultsCsv(targetType, yearMonthSet, planId, patternId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetAllocationResultsCsvTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;
export type GetAllocationResultsCsvTargetTypeEnum = typeof GetAllocationResultsCsvTargetTypeEnum[keyof typeof GetAllocationResultsCsvTargetTypeEnum];


/**
 * AllocationRuleControllerApi - axios parameter creator
 */
export const AllocationRuleControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 振替・配賦ルールの作成
         * @param {CreateAllocationRuleRequestBody} createAllocationRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRules: async (createAllocationRuleRequestBody: CreateAllocationRuleRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAllocationRuleRequestBody' is not null or undefined
            assertParamExists('createRules', 'createAllocationRuleRequestBody', createAllocationRuleRequestBody)
            const localVarPath = `/api/allocations/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAllocationRuleRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦ルールの削除
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRules: async (ruleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('deleteRules', 'ruleId', ruleId)
            const localVarPath = `/api/allocations/rules/{ruleId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替or配賦ステップの削除
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStep1: async (ruleId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('deleteStep1', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('deleteStep1', 'stepId', stepId)
            const localVarPath = `/api/allocations/rules/{ruleId}/steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 既存の振替・配賦ルールを複製
         * @param {string} ruleId 
         * @param {CreateAllocationRuleRequestBody} createAllocationRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicate: async (ruleId: string, createAllocationRuleRequestBody: CreateAllocationRuleRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('duplicate', 'ruleId', ruleId)
            // verify required parameter 'createAllocationRuleRequestBody' is not null or undefined
            assertParamExists('duplicate', 'createAllocationRuleRequestBody', createAllocationRuleRequestBody)
            const localVarPath = `/api/allocations/rules/{ruleId}/duplicate`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAllocationRuleRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦ルールの取得
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRule: async (ruleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('findRule', 'ruleId', ruleId)
            const localVarPath = `/api/allocations/rules/{ruleId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦ルール一覧の取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRules: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/allocations/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦ルールの更新
         * @param {string} ruleId 
         * @param {UpdateAllocationRuleRequestBody} updateAllocationRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRules: async (ruleId: string, updateAllocationRuleRequestBody: UpdateAllocationRuleRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateRules', 'ruleId', ruleId)
            // verify required parameter 'updateAllocationRuleRequestBody' is not null or undefined
            assertParamExists('updateRules', 'updateAllocationRuleRequestBody', updateAllocationRuleRequestBody)
            const localVarPath = `/api/allocations/rules/{ruleId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllocationRuleRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllocationRuleControllerApi - functional programming interface
 */
export const AllocationRuleControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllocationRuleControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 振替・配賦ルールの作成
         * @param {CreateAllocationRuleRequestBody} createAllocationRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRules(createAllocationRuleRequestBody: CreateAllocationRuleRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationRuleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRules(createAllocationRuleRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRuleControllerApi.createRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦ルールの削除
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRules(ruleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRules(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRuleControllerApi.deleteRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替or配賦ステップの削除
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStep1(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStep1(ruleId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRuleControllerApi.deleteStep1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 既存の振替・配賦ルールを複製
         * @param {string} ruleId 
         * @param {CreateAllocationRuleRequestBody} createAllocationRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicate(ruleId: string, createAllocationRuleRequestBody: CreateAllocationRuleRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicate(ruleId, createAllocationRuleRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRuleControllerApi.duplicate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦ルールの取得
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRule(ruleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationRuleDetailSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRule(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRuleControllerApi.findRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦ルール一覧の取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRules(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoAllocationRuleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRules(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRuleControllerApi.listRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦ルールの更新
         * @param {string} ruleId 
         * @param {UpdateAllocationRuleRequestBody} updateAllocationRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRules(ruleId: string, updateAllocationRuleRequestBody: UpdateAllocationRuleRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationRuleSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRules(ruleId, updateAllocationRuleRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationRuleControllerApi.updateRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllocationRuleControllerApi - factory interface
 */
export const AllocationRuleControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllocationRuleControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 振替・配賦ルールの作成
         * @param {CreateAllocationRuleRequestBody} createAllocationRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRules(createAllocationRuleRequestBody: CreateAllocationRuleRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<AllocationRuleSummaryDto> {
            return localVarFp.createRules(createAllocationRuleRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦ルールの削除
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRules(ruleId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteRules(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替or配賦ステップの削除
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStep1(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteStep1(ruleId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 既存の振替・配賦ルールを複製
         * @param {string} ruleId 
         * @param {CreateAllocationRuleRequestBody} createAllocationRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicate(ruleId: string, createAllocationRuleRequestBody: CreateAllocationRuleRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.duplicate(ruleId, createAllocationRuleRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦ルールの取得
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRule(ruleId: string, options?: RawAxiosRequestConfig): AxiosPromise<AllocationRuleDetailSummary> {
            return localVarFp.findRule(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦ルール一覧の取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRules(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoAllocationRuleSummaryDto> {
            return localVarFp.listRules(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦ルールの更新
         * @param {string} ruleId 
         * @param {UpdateAllocationRuleRequestBody} updateAllocationRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRules(ruleId: string, updateAllocationRuleRequestBody: UpdateAllocationRuleRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<AllocationRuleSummaryDto> {
            return localVarFp.updateRules(ruleId, updateAllocationRuleRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllocationRuleControllerApi - object-oriented interface
 */
export class AllocationRuleControllerApi extends BaseAPI {
    /**
     * 
     * @summary 振替・配賦ルールの作成
     * @param {CreateAllocationRuleRequestBody} createAllocationRuleRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createRules(createAllocationRuleRequestBody: CreateAllocationRuleRequestBody, options?: RawAxiosRequestConfig) {
        return AllocationRuleControllerApiFp(this.configuration).createRules(createAllocationRuleRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦ルールの削除
     * @param {string} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteRules(ruleId: string, options?: RawAxiosRequestConfig) {
        return AllocationRuleControllerApiFp(this.configuration).deleteRules(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替or配賦ステップの削除
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteStep1(ruleId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return AllocationRuleControllerApiFp(this.configuration).deleteStep1(ruleId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 既存の振替・配賦ルールを複製
     * @param {string} ruleId 
     * @param {CreateAllocationRuleRequestBody} createAllocationRuleRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public duplicate(ruleId: string, createAllocationRuleRequestBody: CreateAllocationRuleRequestBody, options?: RawAxiosRequestConfig) {
        return AllocationRuleControllerApiFp(this.configuration).duplicate(ruleId, createAllocationRuleRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦ルールの取得
     * @param {string} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findRule(ruleId: string, options?: RawAxiosRequestConfig) {
        return AllocationRuleControllerApiFp(this.configuration).findRule(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦ルール一覧の取得
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listRules(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AllocationRuleControllerApiFp(this.configuration).listRules(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦ルールの更新
     * @param {string} ruleId 
     * @param {UpdateAllocationRuleRequestBody} updateAllocationRuleRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRules(ruleId: string, updateAllocationRuleRequestBody: UpdateAllocationRuleRequestBody, options?: RawAxiosRequestConfig) {
        return AllocationRuleControllerApiFp(this.configuration).updateRules(ruleId, updateAllocationRuleRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AllocationStandardControllerApi - axios parameter creator
 */
export const AllocationStandardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Loglass内のデータを用いた全ての配賦基準に対して最新値を反映する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyLatestDataToAllAllocationStandards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/allocations/standards/apply-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 最新のLoglass内データを配賦基準に反映する
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyLatestDataToAllocationStandard: async (standardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'standardId' is not null or undefined
            assertParamExists('applyLatestDataToAllocationStandard', 'standardId', standardId)
            const localVarPath = `/api/allocations/standards/{standardId}/apply`
                .replace('{standardId}', encodeURIComponent(String(standardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準の作成
         * @param {CreateOrUpdateAllocationStandardRequestBody} createOrUpdateAllocationStandardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStandard: async (createOrUpdateAllocationStandardRequestBody: CreateOrUpdateAllocationStandardRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrUpdateAllocationStandardRequestBody' is not null or undefined
            assertParamExists('createStandard', 'createOrUpdateAllocationStandardRequestBody', createOrUpdateAllocationStandardRequestBody)
            const localVarPath = `/api/allocations/standards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateAllocationStandardRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準の削除
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStandard: async (standardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'standardId' is not null or undefined
            assertParamExists('deleteStandard', 'standardId', standardId)
            const localVarPath = `/api/allocations/standards/{standardId}`
                .replace('{standardId}', encodeURIComponent(String(standardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準Excelのダウンロード
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadStandardExcel: async (standardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'standardId' is not null or undefined
            assertParamExists('downloadStandardExcel', 'standardId', standardId)
            const localVarPath = `/api/allocations/standards/{standardId}/excel`
                .replace('{standardId}', encodeURIComponent(String(standardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準の取得
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStandard: async (standardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'standardId' is not null or undefined
            assertParamExists('findStandard', 'standardId', standardId)
            const localVarPath = `/api/allocations/standards/{standardId}`
                .replace('{standardId}', encodeURIComponent(String(standardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準一覧の取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStandards: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/allocations/standards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準の更新
         * @param {string} standardId 
         * @param {CreateOrUpdateAllocationStandardRequestBody} createOrUpdateAllocationStandardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStandard: async (standardId: string, createOrUpdateAllocationStandardRequestBody: CreateOrUpdateAllocationStandardRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'standardId' is not null or undefined
            assertParamExists('updateStandard', 'standardId', standardId)
            // verify required parameter 'createOrUpdateAllocationStandardRequestBody' is not null or undefined
            assertParamExists('updateStandard', 'createOrUpdateAllocationStandardRequestBody', createOrUpdateAllocationStandardRequestBody)
            const localVarPath = `/api/allocations/standards/{standardId}`
                .replace('{standardId}', encodeURIComponent(String(standardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateAllocationStandardRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準のExcelによる更新
         * @param {string} standardId 
         * @param {boolean} [isDimensionEnabled] 
         * @param {string} [dimensionId] 
         * @param {File} [excelFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateYearMonthAllocationStandard: async (standardId: string, isDimensionEnabled?: boolean, dimensionId?: string, excelFile?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'standardId' is not null or undefined
            assertParamExists('updateYearMonthAllocationStandard', 'standardId', standardId)
            const localVarPath = `/api/allocations/standards/{standardId}/excel`
                .replace('{standardId}', encodeURIComponent(String(standardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (isDimensionEnabled !== undefined) {
                localVarQueryParameter['isDimensionEnabled'] = isDimensionEnabled;
            }

            if (dimensionId !== undefined) {
                localVarQueryParameter['dimensionId'] = dimensionId;
            }


            if (excelFile !== undefined) { 
                localVarFormParams.append('excelFile', excelFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllocationStandardControllerApi - functional programming interface
 */
export const AllocationStandardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllocationStandardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Loglass内のデータを用いた全ての配賦基準に対して最新値を反映する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyLatestDataToAllAllocationStandards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyLatestDataToAllAllocationStandards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerApi.applyLatestDataToAllAllocationStandards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 最新のLoglass内データを配賦基準に反映する
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyLatestDataToAllocationStandard(standardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyLatestDataToAllocationStandard(standardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerApi.applyLatestDataToAllocationStandard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準の作成
         * @param {CreateOrUpdateAllocationStandardRequestBody} createOrUpdateAllocationStandardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStandard(createOrUpdateAllocationStandardRequestBody: CreateOrUpdateAllocationStandardRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationStandardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStandard(createOrUpdateAllocationStandardRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerApi.createStandard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準の削除
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStandard(standardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStandard(standardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerApi.deleteStandard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準Excelのダウンロード
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadStandardExcel(standardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadStandardExcel(standardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerApi.downloadStandardExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準の取得
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findStandard(standardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationStandardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findStandard(standardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerApi.findStandard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準一覧の取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStandards(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoAllocationStandardSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStandards(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerApi.listStandards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準の更新
         * @param {string} standardId 
         * @param {CreateOrUpdateAllocationStandardRequestBody} createOrUpdateAllocationStandardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStandard(standardId: string, createOrUpdateAllocationStandardRequestBody: CreateOrUpdateAllocationStandardRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStandard(standardId, createOrUpdateAllocationStandardRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerApi.updateStandard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準のExcelによる更新
         * @param {string} standardId 
         * @param {boolean} [isDimensionEnabled] 
         * @param {string} [dimensionId] 
         * @param {File} [excelFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateYearMonthAllocationStandard(standardId: string, isDimensionEnabled?: boolean, dimensionId?: string, excelFile?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateYearMonthAllocationStandard(standardId, isDimensionEnabled, dimensionId, excelFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerApi.updateYearMonthAllocationStandard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllocationStandardControllerApi - factory interface
 */
export const AllocationStandardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllocationStandardControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Loglass内のデータを用いた全ての配賦基準に対して最新値を反映する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyLatestDataToAllAllocationStandards(options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.applyLatestDataToAllAllocationStandards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 最新のLoglass内データを配賦基準に反映する
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyLatestDataToAllocationStandard(standardId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.applyLatestDataToAllocationStandard(standardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準の作成
         * @param {CreateOrUpdateAllocationStandardRequestBody} createOrUpdateAllocationStandardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStandard(createOrUpdateAllocationStandardRequestBody: CreateOrUpdateAllocationStandardRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<AllocationStandardDto> {
            return localVarFp.createStandard(createOrUpdateAllocationStandardRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準の削除
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStandard(standardId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteStandard(standardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準Excelのダウンロード
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadStandardExcel(standardId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadStandardExcel(standardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準の取得
         * @param {string} standardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStandard(standardId: string, options?: RawAxiosRequestConfig): AxiosPromise<AllocationStandardDto> {
            return localVarFp.findStandard(standardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準一覧の取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStandards(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoAllocationStandardSummaryDto> {
            return localVarFp.listStandards(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準の更新
         * @param {string} standardId 
         * @param {CreateOrUpdateAllocationStandardRequestBody} createOrUpdateAllocationStandardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStandard(standardId: string, createOrUpdateAllocationStandardRequestBody: CreateOrUpdateAllocationStandardRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateStandard(standardId, createOrUpdateAllocationStandardRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準のExcelによる更新
         * @param {string} standardId 
         * @param {boolean} [isDimensionEnabled] 
         * @param {string} [dimensionId] 
         * @param {File} [excelFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateYearMonthAllocationStandard(standardId: string, isDimensionEnabled?: boolean, dimensionId?: string, excelFile?: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateYearMonthAllocationStandard(standardId, isDimensionEnabled, dimensionId, excelFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllocationStandardControllerApi - object-oriented interface
 */
export class AllocationStandardControllerApi extends BaseAPI {
    /**
     * 
     * @summary Loglass内のデータを用いた全ての配賦基準に対して最新値を反映する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public applyLatestDataToAllAllocationStandards(options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerApiFp(this.configuration).applyLatestDataToAllAllocationStandards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 最新のLoglass内データを配賦基準に反映する
     * @param {string} standardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public applyLatestDataToAllocationStandard(standardId: string, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerApiFp(this.configuration).applyLatestDataToAllocationStandard(standardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準の作成
     * @param {CreateOrUpdateAllocationStandardRequestBody} createOrUpdateAllocationStandardRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createStandard(createOrUpdateAllocationStandardRequestBody: CreateOrUpdateAllocationStandardRequestBody, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerApiFp(this.configuration).createStandard(createOrUpdateAllocationStandardRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準の削除
     * @param {string} standardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteStandard(standardId: string, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerApiFp(this.configuration).deleteStandard(standardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準Excelのダウンロード
     * @param {string} standardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadStandardExcel(standardId: string, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerApiFp(this.configuration).downloadStandardExcel(standardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準の取得
     * @param {string} standardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findStandard(standardId: string, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerApiFp(this.configuration).findStandard(standardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準一覧の取得
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listStandards(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerApiFp(this.configuration).listStandards(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準の更新
     * @param {string} standardId 
     * @param {CreateOrUpdateAllocationStandardRequestBody} createOrUpdateAllocationStandardRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStandard(standardId: string, createOrUpdateAllocationStandardRequestBody: CreateOrUpdateAllocationStandardRequestBody, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerApiFp(this.configuration).updateStandard(standardId, createOrUpdateAllocationStandardRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準のExcelによる更新
     * @param {string} standardId 
     * @param {boolean} [isDimensionEnabled] 
     * @param {string} [dimensionId] 
     * @param {File} [excelFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateYearMonthAllocationStandard(standardId: string, isDimensionEnabled?: boolean, dimensionId?: string, excelFile?: File, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerApiFp(this.configuration).updateYearMonthAllocationStandard(standardId, isDimensionEnabled, dimensionId, excelFile, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AllocationStandardControllerV2Api - axios parameter creator
 */
export const AllocationStandardControllerV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 配賦基準Excelファイルの存在確認
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAllocationStandardExcelFileExists: async (ruleId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('checkAllocationStandardExcelFileExists', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('checkAllocationStandardExcelFileExists', 'stepId', stepId)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}/standard/excel/exists`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準Excelファイルのダウンロード
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllocationStandardExcel: async (ruleId: string, stepId: string, startYearMonth: string, endYearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('downloadAllocationStandardExcel', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('downloadAllocationStandardExcel', 'stepId', stepId)
            // verify required parameter 'startYearMonth' is not null or undefined
            assertParamExists('downloadAllocationStandardExcel', 'startYearMonth', startYearMonth)
            // verify required parameter 'endYearMonth' is not null or undefined
            assertParamExists('downloadAllocationStandardExcel', 'endYearMonth', endYearMonth)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}/standard/excel`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 全期間の配賦基準Excelファイルのダウンロード
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllocationStandardExcelAllPeriods: async (ruleId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('downloadAllocationStandardExcelAllPeriods', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('downloadAllocationStandardExcelAllPeriods', 'stepId', stepId)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}/standard/excel/all-periods`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準データの取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {string} [loopAxisTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleStepStandard: async (ruleId: string, stepId: string, startYearMonth: string, endYearMonth: string, loopAxisTag?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('getRuleStepStandard', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('getRuleStepStandard', 'stepId', stepId)
            // verify required parameter 'startYearMonth' is not null or undefined
            assertParamExists('getRuleStepStandard', 'startYearMonth', startYearMonth)
            // verify required parameter 'endYearMonth' is not null or undefined
            assertParamExists('getRuleStepStandard', 'endYearMonth', endYearMonth)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}/standard`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (loopAxisTag !== undefined) {
                localVarQueryParameter['loopAxisTag'] = loopAxisTag;
            }

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦基準Excelファイルのアップロード
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRuleStepStandardExcel: async (ruleId: string, stepId: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('uploadRuleStepStandardExcel', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('uploadRuleStepStandardExcel', 'stepId', stepId)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}/standard`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllocationStandardControllerV2Api - functional programming interface
 */
export const AllocationStandardControllerV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllocationStandardControllerV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 配賦基準Excelファイルの存在確認
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAllocationStandardExcelFileExists(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationStandardExcelFileExistsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAllocationStandardExcelFileExists(ruleId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerV2Api.checkAllocationStandardExcelFileExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準Excelファイルのダウンロード
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAllocationStandardExcel(ruleId: string, stepId: string, startYearMonth: string, endYearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAllocationStandardExcel(ruleId, stepId, startYearMonth, endYearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerV2Api.downloadAllocationStandardExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 全期間の配賦基準Excelファイルのダウンロード
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAllocationStandardExcelAllPeriods(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAllocationStandardExcelAllPeriods(ruleId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerV2Api.downloadAllocationStandardExcelAllPeriods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準データの取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {string} [loopAxisTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleStepStandard(ruleId: string, stepId: string, startYearMonth: string, endYearMonth: string, loopAxisTag?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationStandardView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRuleStepStandard(ruleId, stepId, startYearMonth, endYearMonth, loopAxisTag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerV2Api.getRuleStepStandard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦基準Excelファイルのアップロード
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadRuleStepStandardExcel(ruleId: string, stepId: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadRuleStepStandardExcel(ruleId, stepId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStandardControllerV2Api.uploadRuleStepStandardExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllocationStandardControllerV2Api - factory interface
 */
export const AllocationStandardControllerV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllocationStandardControllerV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary 配賦基準Excelファイルの存在確認
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAllocationStandardExcelFileExists(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<AllocationStandardExcelFileExistsResponse> {
            return localVarFp.checkAllocationStandardExcelFileExists(ruleId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準Excelファイルのダウンロード
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllocationStandardExcel(ruleId: string, stepId: string, startYearMonth: string, endYearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAllocationStandardExcel(ruleId, stepId, startYearMonth, endYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 全期間の配賦基準Excelファイルのダウンロード
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAllocationStandardExcelAllPeriods(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAllocationStandardExcelAllPeriods(ruleId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準データの取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {string} [loopAxisTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleStepStandard(ruleId: string, stepId: string, startYearMonth: string, endYearMonth: string, loopAxisTag?: string, options?: RawAxiosRequestConfig): AxiosPromise<AllocationStandardView> {
            return localVarFp.getRuleStepStandard(ruleId, stepId, startYearMonth, endYearMonth, loopAxisTag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦基準Excelファイルのアップロード
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRuleStepStandardExcel(ruleId: string, stepId: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadRuleStepStandardExcel(ruleId, stepId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllocationStandardControllerV2Api - object-oriented interface
 */
export class AllocationStandardControllerV2Api extends BaseAPI {
    /**
     * 
     * @summary 配賦基準Excelファイルの存在確認
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkAllocationStandardExcelFileExists(ruleId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerV2ApiFp(this.configuration).checkAllocationStandardExcelFileExists(ruleId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準Excelファイルのダウンロード
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {string} startYearMonth 
     * @param {string} endYearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAllocationStandardExcel(ruleId: string, stepId: string, startYearMonth: string, endYearMonth: string, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerV2ApiFp(this.configuration).downloadAllocationStandardExcel(ruleId, stepId, startYearMonth, endYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 全期間の配賦基準Excelファイルのダウンロード
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadAllocationStandardExcelAllPeriods(ruleId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerV2ApiFp(this.configuration).downloadAllocationStandardExcelAllPeriods(ruleId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準データの取得
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {string} startYearMonth 
     * @param {string} endYearMonth 
     * @param {string} [loopAxisTag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRuleStepStandard(ruleId: string, stepId: string, startYearMonth: string, endYearMonth: string, loopAxisTag?: string, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerV2ApiFp(this.configuration).getRuleStepStandard(ruleId, stepId, startYearMonth, endYearMonth, loopAxisTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦基準Excelファイルのアップロード
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadRuleStepStandardExcel(ruleId: string, stepId: string, file?: File, options?: RawAxiosRequestConfig) {
        return AllocationStandardControllerV2ApiFp(this.configuration).uploadRuleStepStandardExcel(ruleId, stepId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AllocationStepControllerApi - axios parameter creator
 */
export const AllocationStepControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 配賦ステップの作成
         * @param {string} ruleId 
         * @param {CreateAllocationStepRequestBody} createAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStep: async (ruleId: string, createAllocationStepRequestBody: CreateAllocationStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('createStep', 'ruleId', ruleId)
            // verify required parameter 'createAllocationStepRequestBody' is not null or undefined
            assertParamExists('createStep', 'createAllocationStepRequestBody', createAllocationStepRequestBody)
            const localVarPath = `/api/allocations/rules/{ruleId}/steps`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAllocationStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替or配賦ステップの順序の編集
         * @param {string} ruleId 
         * @param {UpdateAllocationStepOrderRequestBody} updateAllocationStepOrderRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOrderOfSteps: async (ruleId: string, updateAllocationStepOrderRequestBody: UpdateAllocationStepOrderRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('editOrderOfSteps', 'ruleId', ruleId)
            // verify required parameter 'updateAllocationStepOrderRequestBody' is not null or undefined
            assertParamExists('editOrderOfSteps', 'updateAllocationStepOrderRequestBody', updateAllocationStepOrderRequestBody)
            const localVarPath = `/api/allocations/rules/rules/{ruleId}/steps-order`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllocationStepOrderRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップの取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStep: async (ruleId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('findStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('findStep', 'stepId', stepId)
            const localVarPath = `/api/allocations/rules/{ruleId}/steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップの編集
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateAllocationStepRequestBody} updateAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStep: async (ruleId: string, stepId: string, updateAllocationStepRequestBody: UpdateAllocationStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('updateStep', 'stepId', stepId)
            // verify required parameter 'updateAllocationStepRequestBody' is not null or undefined
            assertParamExists('updateStep', 'updateAllocationStepRequestBody', updateAllocationStepRequestBody)
            const localVarPath = `/api/allocations/rules/{ruleId}/steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllocationStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllocationStepControllerApi - functional programming interface
 */
export const AllocationStepControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllocationStepControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 配賦ステップの作成
         * @param {string} ruleId 
         * @param {CreateAllocationStepRequestBody} createAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStep(ruleId: string, createAllocationStepRequestBody: CreateAllocationStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStep(ruleId, createAllocationStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStepControllerApi.createStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替or配賦ステップの順序の編集
         * @param {string} ruleId 
         * @param {UpdateAllocationStepOrderRequestBody} updateAllocationStepOrderRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editOrderOfSteps(ruleId: string, updateAllocationStepOrderRequestBody: UpdateAllocationStepOrderRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editOrderOfSteps(ruleId, updateAllocationStepOrderRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStepControllerApi.editOrderOfSteps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップの取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findStep(ruleId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStepControllerApi.findStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップの編集
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateAllocationStepRequestBody} updateAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStep(ruleId: string, stepId: string, updateAllocationStepRequestBody: UpdateAllocationStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStep(ruleId, stepId, updateAllocationStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStepControllerApi.updateStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllocationStepControllerApi - factory interface
 */
export const AllocationStepControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllocationStepControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 配賦ステップの作成
         * @param {string} ruleId 
         * @param {CreateAllocationStepRequestBody} createAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStep(ruleId: string, createAllocationStepRequestBody: CreateAllocationStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createStep(ruleId, createAllocationStepRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替or配賦ステップの順序の編集
         * @param {string} ruleId 
         * @param {UpdateAllocationStepOrderRequestBody} updateAllocationStepOrderRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOrderOfSteps(ruleId: string, updateAllocationStepOrderRequestBody: UpdateAllocationStepOrderRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.editOrderOfSteps(ruleId, updateAllocationStepOrderRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップの取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<AllocationStepView> {
            return localVarFp.findStep(ruleId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップの編集
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateAllocationStepRequestBody} updateAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStep(ruleId: string, stepId: string, updateAllocationStepRequestBody: UpdateAllocationStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateStep(ruleId, stepId, updateAllocationStepRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllocationStepControllerApi - object-oriented interface
 */
export class AllocationStepControllerApi extends BaseAPI {
    /**
     * 
     * @summary 配賦ステップの作成
     * @param {string} ruleId 
     * @param {CreateAllocationStepRequestBody} createAllocationStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createStep(ruleId: string, createAllocationStepRequestBody: CreateAllocationStepRequestBody, options?: RawAxiosRequestConfig) {
        return AllocationStepControllerApiFp(this.configuration).createStep(ruleId, createAllocationStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替or配賦ステップの順序の編集
     * @param {string} ruleId 
     * @param {UpdateAllocationStepOrderRequestBody} updateAllocationStepOrderRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editOrderOfSteps(ruleId: string, updateAllocationStepOrderRequestBody: UpdateAllocationStepOrderRequestBody, options?: RawAxiosRequestConfig) {
        return AllocationStepControllerApiFp(this.configuration).editOrderOfSteps(ruleId, updateAllocationStepOrderRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップの取得
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return AllocationStepControllerApiFp(this.configuration).findStep(ruleId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップの編集
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {UpdateAllocationStepRequestBody} updateAllocationStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStep(ruleId: string, stepId: string, updateAllocationStepRequestBody: UpdateAllocationStepRequestBody, options?: RawAxiosRequestConfig) {
        return AllocationStepControllerApiFp(this.configuration).updateStep(ruleId, stepId, updateAllocationStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AllocationStrategyControllerApi - axios parameter creator
 */
export const AllocationStrategyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 旧配賦の実行計画と配賦後明細との不整合を検知する
         * @param {CheckInconsistentAllocationExecutionTargetTypeEnum} targetType 
         * @param {string} patternId 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInconsistentAllocationExecution: async (targetType: CheckInconsistentAllocationExecutionTargetTypeEnum, patternId: string, planId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetType' is not null or undefined
            assertParamExists('checkInconsistentAllocationExecution', 'targetType', targetType)
            // verify required parameter 'patternId' is not null or undefined
            assertParamExists('checkInconsistentAllocationExecution', 'patternId', patternId)
            const localVarPath = `/api/allocations/strategies/{targetType}/inconsistent-execution-check`
                .replace('{targetType}', encodeURIComponent(String(targetType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            if (patternId !== undefined) {
                localVarQueryParameter['patternId'] = patternId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦実行計画の作成
         * @param {CreateAllocationStrategyRequestBody} createAllocationStrategyRequestBody 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStrategy: async (createAllocationStrategyRequestBody: CreateAllocationStrategyRequestBody, planId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAllocationStrategyRequestBody' is not null or undefined
            assertParamExists('createStrategy', 'createAllocationStrategyRequestBody', createAllocationStrategyRequestBody)
            const localVarPath = `/api/allocations/strategies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAllocationStrategyRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦実行計画の削除
         * @param {Array<string>} yearMonthSet 
         * @param {DeleteStrategyTargetTypeEnum} targetType 
         * @param {string} patternId 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStrategy: async (yearMonthSet: Array<string>, targetType: DeleteStrategyTargetTypeEnum, patternId: string, planId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearMonthSet' is not null or undefined
            assertParamExists('deleteStrategy', 'yearMonthSet', yearMonthSet)
            // verify required parameter 'targetType' is not null or undefined
            assertParamExists('deleteStrategy', 'targetType', targetType)
            // verify required parameter 'patternId' is not null or undefined
            assertParamExists('deleteStrategy', 'patternId', patternId)
            const localVarPath = `/api/allocations/strategies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (yearMonthSet) {
                localVarQueryParameter['yearMonthSet'] = Array.from(yearMonthSet);
            }

            if (targetType !== undefined) {
                localVarQueryParameter['targetType'] = targetType;
            }

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            if (patternId !== undefined) {
                localVarQueryParameter['patternId'] = patternId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦実行計画詳細取得
         * @param {FindStrategyTargetTypeEnum} targetType 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStrategy: async (targetType: FindStrategyTargetTypeEnum, planId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetType' is not null or undefined
            assertParamExists('findStrategy', 'targetType', targetType)
            const localVarPath = `/api/allocations/strategies/{targetType}`
                .replace('{targetType}', encodeURIComponent(String(targetType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦実行計画(実績)のスキップされたステップを一覧表示する
         * @param {string} fiscalMonthId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkippedStepsOfActual: async (fiscalMonthId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fiscalMonthId' is not null or undefined
            assertParamExists('listSkippedStepsOfActual', 'fiscalMonthId', fiscalMonthId)
            const localVarPath = `/api/allocations/strategies/actual/{fiscalMonthId}/skipped-steps`
                .replace('{fiscalMonthId}', encodeURIComponent(String(fiscalMonthId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦実行計画(予算)のスキップされたステップを一覧表示する
         * @param {string} planId 
         * @param {string} fiscalMonthId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkippedStepsOfPlan: async (planId: string, fiscalMonthId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('listSkippedStepsOfPlan', 'planId', planId)
            // verify required parameter 'fiscalMonthId' is not null or undefined
            assertParamExists('listSkippedStepsOfPlan', 'fiscalMonthId', fiscalMonthId)
            const localVarPath = `/api/allocations/strategies/plan/{planId}/{fiscalMonthId}/skipped-steps`
                .replace('{planId}', encodeURIComponent(String(planId)))
                .replace('{fiscalMonthId}', encodeURIComponent(String(fiscalMonthId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦実行計画一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStrategies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/allocations/strategies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替・配賦実行計画の編集
         * @param {UpdateAllocationStrategyRequestBody} updateAllocationStrategyRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrategy: async (updateAllocationStrategyRequestBody: UpdateAllocationStrategyRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAllocationStrategyRequestBody' is not null or undefined
            assertParamExists('updateStrategy', 'updateAllocationStrategyRequestBody', updateAllocationStrategyRequestBody)
            const localVarPath = `/api/allocations/strategies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllocationStrategyRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllocationStrategyControllerApi - functional programming interface
 */
export const AllocationStrategyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllocationStrategyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 旧配賦の実行計画と配賦後明細との不整合を検知する
         * @param {CheckInconsistentAllocationExecutionTargetTypeEnum} targetType 
         * @param {string} patternId 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkInconsistentAllocationExecution(targetType: CheckInconsistentAllocationExecutionTargetTypeEnum, patternId: string, planId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InconsistentAllocationExecutionCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkInconsistentAllocationExecution(targetType, patternId, planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStrategyControllerApi.checkInconsistentAllocationExecution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦実行計画の作成
         * @param {CreateAllocationStrategyRequestBody} createAllocationStrategyRequestBody 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStrategy(createAllocationStrategyRequestBody: CreateAllocationStrategyRequestBody, planId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateStrategyResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStrategy(createAllocationStrategyRequestBody, planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStrategyControllerApi.createStrategy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦実行計画の削除
         * @param {Array<string>} yearMonthSet 
         * @param {DeleteStrategyTargetTypeEnum} targetType 
         * @param {string} patternId 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStrategy(yearMonthSet: Array<string>, targetType: DeleteStrategyTargetTypeEnum, patternId: string, planId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStrategy(yearMonthSet, targetType, patternId, planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStrategyControllerApi.deleteStrategy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦実行計画詳細取得
         * @param {FindStrategyTargetTypeEnum} targetType 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findStrategy(targetType: FindStrategyTargetTypeEnum, planId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationStrategyDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findStrategy(targetType, planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStrategyControllerApi.findStrategy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦実行計画(実績)のスキップされたステップを一覧表示する
         * @param {string} fiscalMonthId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSkippedStepsOfActual(fiscalMonthId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkippedAllocationStepsSummaryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSkippedStepsOfActual(fiscalMonthId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStrategyControllerApi.listSkippedStepsOfActual']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦実行計画(予算)のスキップされたステップを一覧表示する
         * @param {string} planId 
         * @param {string} fiscalMonthId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSkippedStepsOfPlan(planId: string, fiscalMonthId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkippedAllocationStepsSummaryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSkippedStepsOfPlan(planId, fiscalMonthId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStrategyControllerApi.listSkippedStepsOfPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦実行計画一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStrategies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AllocationStrategySummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStrategies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStrategyControllerApi.listStrategies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替・配賦実行計画の編集
         * @param {UpdateAllocationStrategyRequestBody} updateAllocationStrategyRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStrategy(updateAllocationStrategyRequestBody: UpdateAllocationStrategyRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStrategy(updateAllocationStrategyRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllocationStrategyControllerApi.updateStrategy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllocationStrategyControllerApi - factory interface
 */
export const AllocationStrategyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllocationStrategyControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 旧配賦の実行計画と配賦後明細との不整合を検知する
         * @param {CheckInconsistentAllocationExecutionTargetTypeEnum} targetType 
         * @param {string} patternId 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInconsistentAllocationExecution(targetType: CheckInconsistentAllocationExecutionTargetTypeEnum, patternId: string, planId?: string, options?: RawAxiosRequestConfig): AxiosPromise<InconsistentAllocationExecutionCheckResponse> {
            return localVarFp.checkInconsistentAllocationExecution(targetType, patternId, planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦実行計画の作成
         * @param {CreateAllocationStrategyRequestBody} createAllocationStrategyRequestBody 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStrategy(createAllocationStrategyRequestBody: CreateAllocationStrategyRequestBody, planId?: string, options?: RawAxiosRequestConfig): AxiosPromise<CreateStrategyResultDto> {
            return localVarFp.createStrategy(createAllocationStrategyRequestBody, planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦実行計画の削除
         * @param {Array<string>} yearMonthSet 
         * @param {DeleteStrategyTargetTypeEnum} targetType 
         * @param {string} patternId 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStrategy(yearMonthSet: Array<string>, targetType: DeleteStrategyTargetTypeEnum, patternId: string, planId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteStrategy(yearMonthSet, targetType, patternId, planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦実行計画詳細取得
         * @param {FindStrategyTargetTypeEnum} targetType 
         * @param {string} [planId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStrategy(targetType: FindStrategyTargetTypeEnum, planId?: string, options?: RawAxiosRequestConfig): AxiosPromise<AllocationStrategyDto> {
            return localVarFp.findStrategy(targetType, planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦実行計画(実績)のスキップされたステップを一覧表示する
         * @param {string} fiscalMonthId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkippedStepsOfActual(fiscalMonthId: string, options?: RawAxiosRequestConfig): AxiosPromise<SkippedAllocationStepsSummaryView> {
            return localVarFp.listSkippedStepsOfActual(fiscalMonthId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦実行計画(予算)のスキップされたステップを一覧表示する
         * @param {string} planId 
         * @param {string} fiscalMonthId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkippedStepsOfPlan(planId: string, fiscalMonthId: string, options?: RawAxiosRequestConfig): AxiosPromise<SkippedAllocationStepsSummaryView> {
            return localVarFp.listSkippedStepsOfPlan(planId, fiscalMonthId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦実行計画一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStrategies(options?: RawAxiosRequestConfig): AxiosPromise<Array<AllocationStrategySummaryDto>> {
            return localVarFp.listStrategies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替・配賦実行計画の編集
         * @param {UpdateAllocationStrategyRequestBody} updateAllocationStrategyRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrategy(updateAllocationStrategyRequestBody: UpdateAllocationStrategyRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateStrategy(updateAllocationStrategyRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllocationStrategyControllerApi - object-oriented interface
 */
export class AllocationStrategyControllerApi extends BaseAPI {
    /**
     * 
     * @summary 旧配賦の実行計画と配賦後明細との不整合を検知する
     * @param {CheckInconsistentAllocationExecutionTargetTypeEnum} targetType 
     * @param {string} patternId 
     * @param {string} [planId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkInconsistentAllocationExecution(targetType: CheckInconsistentAllocationExecutionTargetTypeEnum, patternId: string, planId?: string, options?: RawAxiosRequestConfig) {
        return AllocationStrategyControllerApiFp(this.configuration).checkInconsistentAllocationExecution(targetType, patternId, planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦実行計画の作成
     * @param {CreateAllocationStrategyRequestBody} createAllocationStrategyRequestBody 
     * @param {string} [planId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createStrategy(createAllocationStrategyRequestBody: CreateAllocationStrategyRequestBody, planId?: string, options?: RawAxiosRequestConfig) {
        return AllocationStrategyControllerApiFp(this.configuration).createStrategy(createAllocationStrategyRequestBody, planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦実行計画の削除
     * @param {Array<string>} yearMonthSet 
     * @param {DeleteStrategyTargetTypeEnum} targetType 
     * @param {string} patternId 
     * @param {string} [planId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteStrategy(yearMonthSet: Array<string>, targetType: DeleteStrategyTargetTypeEnum, patternId: string, planId?: string, options?: RawAxiosRequestConfig) {
        return AllocationStrategyControllerApiFp(this.configuration).deleteStrategy(yearMonthSet, targetType, patternId, planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦実行計画詳細取得
     * @param {FindStrategyTargetTypeEnum} targetType 
     * @param {string} [planId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findStrategy(targetType: FindStrategyTargetTypeEnum, planId?: string, options?: RawAxiosRequestConfig) {
        return AllocationStrategyControllerApiFp(this.configuration).findStrategy(targetType, planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦実行計画(実績)のスキップされたステップを一覧表示する
     * @param {string} fiscalMonthId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSkippedStepsOfActual(fiscalMonthId: string, options?: RawAxiosRequestConfig) {
        return AllocationStrategyControllerApiFp(this.configuration).listSkippedStepsOfActual(fiscalMonthId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦実行計画(予算)のスキップされたステップを一覧表示する
     * @param {string} planId 
     * @param {string} fiscalMonthId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSkippedStepsOfPlan(planId: string, fiscalMonthId: string, options?: RawAxiosRequestConfig) {
        return AllocationStrategyControllerApiFp(this.configuration).listSkippedStepsOfPlan(planId, fiscalMonthId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦実行計画一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listStrategies(options?: RawAxiosRequestConfig) {
        return AllocationStrategyControllerApiFp(this.configuration).listStrategies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替・配賦実行計画の編集
     * @param {UpdateAllocationStrategyRequestBody} updateAllocationStrategyRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStrategy(updateAllocationStrategyRequestBody: UpdateAllocationStrategyRequestBody, options?: RawAxiosRequestConfig) {
        return AllocationStrategyControllerApiFp(this.configuration).updateStrategy(updateAllocationStrategyRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const CheckInconsistentAllocationExecutionTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;
export type CheckInconsistentAllocationExecutionTargetTypeEnum = typeof CheckInconsistentAllocationExecutionTargetTypeEnum[keyof typeof CheckInconsistentAllocationExecutionTargetTypeEnum];
export const DeleteStrategyTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;
export type DeleteStrategyTargetTypeEnum = typeof DeleteStrategyTargetTypeEnum[keyof typeof DeleteStrategyTargetTypeEnum];
export const FindStrategyTargetTypeEnum = {
    Actual: 'ACTUAL',
    Plan: 'PLAN',
} as const;
export type FindStrategyTargetTypeEnum = typeof FindStrategyTargetTypeEnum[keyof typeof FindStrategyTargetTypeEnum];


/**
 * AppliedNumberLimitsControllerApi - axios parameter creator
 */
export const AppliedNumberLimitsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 適用された件数制限の値を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNumberLimits: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/applied-number-limits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppliedNumberLimitsControllerApi - functional programming interface
 */
export const AppliedNumberLimitsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppliedNumberLimitsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 適用された件数制限の値を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNumberLimits(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppliedNumberLimitsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNumberLimits(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppliedNumberLimitsControllerApi.listNumberLimits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppliedNumberLimitsControllerApi - factory interface
 */
export const AppliedNumberLimitsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppliedNumberLimitsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 適用された件数制限の値を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNumberLimits(options?: RawAxiosRequestConfig): AxiosPromise<AppliedNumberLimitsView> {
            return localVarFp.listNumberLimits(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppliedNumberLimitsControllerApi - object-oriented interface
 */
export class AppliedNumberLimitsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 適用された件数制限の値を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listNumberLimits(options?: RawAxiosRequestConfig) {
        return AppliedNumberLimitsControllerApiFp(this.configuration).listNumberLimits(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthControllerApi - axios parameter creator
 */
export const AuthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultTenant: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/default-tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 利用可能なテナントリストを返す
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableTenants: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/available-tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthControllerApi - functional programming interface
 */
export const AuthControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultTenant(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultTenantView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultTenant(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthControllerApi.getDefaultTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 利用可能なテナントリストを返す
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAvailableTenants(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvailableTenantView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAvailableTenants(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthControllerApi.listAvailableTenants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthControllerApi - factory interface
 */
export const AuthControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultTenant(options?: RawAxiosRequestConfig): AxiosPromise<DefaultTenantView> {
            return localVarFp.getDefaultTenant(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 利用可能なテナントリストを返す
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableTenants(options?: RawAxiosRequestConfig): AxiosPromise<Array<AvailableTenantView>> {
            return localVarFp.listAvailableTenants(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthControllerApi - object-oriented interface
 */
export class AuthControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDefaultTenant(options?: RawAxiosRequestConfig) {
        return AuthControllerApiFp(this.configuration).getDefaultTenant(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 利用可能なテナントリストを返す
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAvailableTenants(options?: RawAxiosRequestConfig) {
        return AuthControllerApiFp(this.configuration).listAvailableTenants(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BoardControllerApi - axios parameter creator
 */
export const BoardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ボードコピー
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyBoard: async (dashboardId: string, boardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('copyBoard', 'dashboardId', dashboardId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('copyBoard', 'boardId', boardId)
            const localVarPath = `/api/dashboards/{dashboardId}/boards/{boardId}/copy`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)))
                .replace('{boardId}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ボード作成
         * @param {string} dashboardId 
         * @param {CreateBoardRequestBody} createBoardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoard: async (dashboardId: string, createBoardRequestBody: CreateBoardRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('createBoard', 'dashboardId', dashboardId)
            // verify required parameter 'createBoardRequestBody' is not null or undefined
            assertParamExists('createBoard', 'createBoardRequestBody', createBoardRequestBody)
            const localVarPath = `/api/dashboards/{dashboardId}/boards`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBoardRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ボード削除
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBoard: async (dashboardId: string, boardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('deleteBoard', 'dashboardId', dashboardId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('deleteBoard', 'boardId', boardId)
            const localVarPath = `/api/dashboards/{dashboardId}/boards/{boardId}`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)))
                .replace('{boardId}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ボード詳細取得
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoard: async (dashboardId: string, boardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getBoard', 'dashboardId', dashboardId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('getBoard', 'boardId', boardId)
            const localVarPath = `/api/dashboards/{dashboardId}/boards/{boardId}`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)))
                .replace('{boardId}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ボード一覧取得
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBoards: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('listBoards', 'dashboardId', dashboardId)
            const localVarPath = `/api/dashboards/{dashboardId}/boards`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ボードの並び替え
         * @param {string} dashboardId 
         * @param {ReorderBoardsRequestBody} reorderBoardsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderBoards: async (dashboardId: string, reorderBoardsRequestBody: ReorderBoardsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('reorderBoards', 'dashboardId', dashboardId)
            // verify required parameter 'reorderBoardsRequestBody' is not null or undefined
            assertParamExists('reorderBoards', 'reorderBoardsRequestBody', reorderBoardsRequestBody)
            const localVarPath = `/api/dashboards/{dashboardId}/boards/reorder`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderBoardsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ボードメタ情報更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {UpdateBoardRequestBody} updateBoardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBoard: async (dashboardId: string, boardId: string, updateBoardRequestBody: UpdateBoardRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateBoard', 'dashboardId', dashboardId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateBoard', 'boardId', boardId)
            // verify required parameter 'updateBoardRequestBody' is not null or undefined
            assertParamExists('updateBoard', 'updateBoardRequestBody', updateBoardRequestBody)
            const localVarPath = `/api/dashboards/{dashboardId}/boards/{boardId}`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)))
                .replace('{boardId}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBoardRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ボードフィルタ条件更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {UpdateBoardFilterConditionsRequestBody} updateBoardFilterConditionsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBoardFilterConditions: async (dashboardId: string, boardId: string, updateBoardFilterConditionsRequestBody: UpdateBoardFilterConditionsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateBoardFilterConditions', 'dashboardId', dashboardId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateBoardFilterConditions', 'boardId', boardId)
            // verify required parameter 'updateBoardFilterConditionsRequestBody' is not null or undefined
            assertParamExists('updateBoardFilterConditions', 'updateBoardFilterConditionsRequestBody', updateBoardFilterConditionsRequestBody)
            const localVarPath = `/api/dashboards/{dashboardId}/boards/{boardId}/filter`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)))
                .replace('{boardId}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBoardFilterConditionsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ボードレイアウト更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {UpdateBoardLayoutRequestBody} updateBoardLayoutRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBoardLayout: async (dashboardId: string, boardId: string, updateBoardLayoutRequestBody: UpdateBoardLayoutRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateBoardLayout', 'dashboardId', dashboardId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateBoardLayout', 'boardId', boardId)
            // verify required parameter 'updateBoardLayoutRequestBody' is not null or undefined
            assertParamExists('updateBoardLayout', 'updateBoardLayoutRequestBody', updateBoardLayoutRequestBody)
            const localVarPath = `/api/dashboards/{dashboardId}/boards/{boardId}/layout`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)))
                .replace('{boardId}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBoardLayoutRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary テキストウィジェット更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {string} textWidgetId 
         * @param {UpdateTextWidgetRequestBody} updateTextWidgetRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTextWidget: async (dashboardId: string, boardId: string, textWidgetId: string, updateTextWidgetRequestBody: UpdateTextWidgetRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateTextWidget', 'dashboardId', dashboardId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('updateTextWidget', 'boardId', boardId)
            // verify required parameter 'textWidgetId' is not null or undefined
            assertParamExists('updateTextWidget', 'textWidgetId', textWidgetId)
            // verify required parameter 'updateTextWidgetRequestBody' is not null or undefined
            assertParamExists('updateTextWidget', 'updateTextWidgetRequestBody', updateTextWidgetRequestBody)
            const localVarPath = `/api/dashboards/{dashboardId}/boards/{boardId}/text-widgets/{textWidgetId}`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)))
                .replace('{boardId}', encodeURIComponent(String(boardId)))
                .replace('{textWidgetId}', encodeURIComponent(String(textWidgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTextWidgetRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BoardControllerApi - functional programming interface
 */
export const BoardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BoardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ボードコピー
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyBoard(dashboardId: string, boardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopiedBoardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyBoard(dashboardId, boardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.copyBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ボード作成
         * @param {string} dashboardId 
         * @param {CreateBoardRequestBody} createBoardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBoard(dashboardId: string, createBoardRequestBody: CreateBoardRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedBoardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBoard(dashboardId, createBoardRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.createBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ボード削除
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBoard(dashboardId: string, boardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBoard(dashboardId, boardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.deleteBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ボード詳細取得
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoard(dashboardId: string, boardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoardView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoard(dashboardId, boardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.getBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ボード一覧取得
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBoards(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BoardView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBoards(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.listBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ボードの並び替え
         * @param {string} dashboardId 
         * @param {ReorderBoardsRequestBody} reorderBoardsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderBoards(dashboardId: string, reorderBoardsRequestBody: ReorderBoardsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderBoards(dashboardId, reorderBoardsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.reorderBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ボードメタ情報更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {UpdateBoardRequestBody} updateBoardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBoard(dashboardId: string, boardId: string, updateBoardRequestBody: UpdateBoardRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBoard(dashboardId, boardId, updateBoardRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.updateBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ボードフィルタ条件更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {UpdateBoardFilterConditionsRequestBody} updateBoardFilterConditionsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBoardFilterConditions(dashboardId: string, boardId: string, updateBoardFilterConditionsRequestBody: UpdateBoardFilterConditionsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBoardFilterConditions(dashboardId, boardId, updateBoardFilterConditionsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.updateBoardFilterConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ボードレイアウト更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {UpdateBoardLayoutRequestBody} updateBoardLayoutRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBoardLayout(dashboardId: string, boardId: string, updateBoardLayoutRequestBody: UpdateBoardLayoutRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBoardLayout(dashboardId, boardId, updateBoardLayoutRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.updateBoardLayout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary テキストウィジェット更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {string} textWidgetId 
         * @param {UpdateTextWidgetRequestBody} updateTextWidgetRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTextWidget(dashboardId: string, boardId: string, textWidgetId: string, updateTextWidgetRequestBody: UpdateTextWidgetRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTextWidget(dashboardId, boardId, textWidgetId, updateTextWidgetRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardControllerApi.updateTextWidget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BoardControllerApi - factory interface
 */
export const BoardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BoardControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ボードコピー
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyBoard(dashboardId: string, boardId: string, options?: RawAxiosRequestConfig): AxiosPromise<CopiedBoardDto> {
            return localVarFp.copyBoard(dashboardId, boardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ボード作成
         * @param {string} dashboardId 
         * @param {CreateBoardRequestBody} createBoardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoard(dashboardId: string, createBoardRequestBody: CreateBoardRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreatedBoardDto> {
            return localVarFp.createBoard(dashboardId, createBoardRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ボード削除
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBoard(dashboardId: string, boardId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBoard(dashboardId, boardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ボード詳細取得
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoard(dashboardId: string, boardId: string, options?: RawAxiosRequestConfig): AxiosPromise<BoardView> {
            return localVarFp.getBoard(dashboardId, boardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ボード一覧取得
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBoards(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BoardView>> {
            return localVarFp.listBoards(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ボードの並び替え
         * @param {string} dashboardId 
         * @param {ReorderBoardsRequestBody} reorderBoardsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderBoards(dashboardId: string, reorderBoardsRequestBody: ReorderBoardsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderBoards(dashboardId, reorderBoardsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ボードメタ情報更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {UpdateBoardRequestBody} updateBoardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBoard(dashboardId: string, boardId: string, updateBoardRequestBody: UpdateBoardRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBoard(dashboardId, boardId, updateBoardRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ボードフィルタ条件更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {UpdateBoardFilterConditionsRequestBody} updateBoardFilterConditionsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBoardFilterConditions(dashboardId: string, boardId: string, updateBoardFilterConditionsRequestBody: UpdateBoardFilterConditionsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBoardFilterConditions(dashboardId, boardId, updateBoardFilterConditionsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ボードレイアウト更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {UpdateBoardLayoutRequestBody} updateBoardLayoutRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBoardLayout(dashboardId: string, boardId: string, updateBoardLayoutRequestBody: UpdateBoardLayoutRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBoardLayout(dashboardId, boardId, updateBoardLayoutRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary テキストウィジェット更新
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {string} textWidgetId 
         * @param {UpdateTextWidgetRequestBody} updateTextWidgetRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTextWidget(dashboardId: string, boardId: string, textWidgetId: string, updateTextWidgetRequestBody: UpdateTextWidgetRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTextWidget(dashboardId, boardId, textWidgetId, updateTextWidgetRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BoardControllerApi - object-oriented interface
 */
export class BoardControllerApi extends BaseAPI {
    /**
     * 
     * @summary ボードコピー
     * @param {string} dashboardId 
     * @param {string} boardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyBoard(dashboardId: string, boardId: string, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).copyBoard(dashboardId, boardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ボード作成
     * @param {string} dashboardId 
     * @param {CreateBoardRequestBody} createBoardRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBoard(dashboardId: string, createBoardRequestBody: CreateBoardRequestBody, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).createBoard(dashboardId, createBoardRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ボード削除
     * @param {string} dashboardId 
     * @param {string} boardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteBoard(dashboardId: string, boardId: string, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).deleteBoard(dashboardId, boardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ボード詳細取得
     * @param {string} dashboardId 
     * @param {string} boardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBoard(dashboardId: string, boardId: string, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).getBoard(dashboardId, boardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ボード一覧取得
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listBoards(dashboardId: string, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).listBoards(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ボードの並び替え
     * @param {string} dashboardId 
     * @param {ReorderBoardsRequestBody} reorderBoardsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reorderBoards(dashboardId: string, reorderBoardsRequestBody: ReorderBoardsRequestBody, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).reorderBoards(dashboardId, reorderBoardsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ボードメタ情報更新
     * @param {string} dashboardId 
     * @param {string} boardId 
     * @param {UpdateBoardRequestBody} updateBoardRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBoard(dashboardId: string, boardId: string, updateBoardRequestBody: UpdateBoardRequestBody, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).updateBoard(dashboardId, boardId, updateBoardRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ボードフィルタ条件更新
     * @param {string} dashboardId 
     * @param {string} boardId 
     * @param {UpdateBoardFilterConditionsRequestBody} updateBoardFilterConditionsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBoardFilterConditions(dashboardId: string, boardId: string, updateBoardFilterConditionsRequestBody: UpdateBoardFilterConditionsRequestBody, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).updateBoardFilterConditions(dashboardId, boardId, updateBoardFilterConditionsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ボードレイアウト更新
     * @param {string} dashboardId 
     * @param {string} boardId 
     * @param {UpdateBoardLayoutRequestBody} updateBoardLayoutRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBoardLayout(dashboardId: string, boardId: string, updateBoardLayoutRequestBody: UpdateBoardLayoutRequestBody, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).updateBoardLayout(dashboardId, boardId, updateBoardLayoutRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary テキストウィジェット更新
     * @param {string} dashboardId 
     * @param {string} boardId 
     * @param {string} textWidgetId 
     * @param {UpdateTextWidgetRequestBody} updateTextWidgetRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTextWidget(dashboardId: string, boardId: string, textWidgetId: string, updateTextWidgetRequestBody: UpdateTextWidgetRequestBody, options?: RawAxiosRequestConfig) {
        return BoardControllerApiFp(this.configuration).updateTextWidget(dashboardId, boardId, textWidgetId, updateTextWidgetRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BoardFilterValidationControllerApi - axios parameter creator
 */
export const BoardFilterValidationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ボードフィルタバリデーション
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {ValidateBoardFilterRequest} validateBoardFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBoardFilter: async (dashboardId: string, boardId: string, validateBoardFilterRequest: ValidateBoardFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('validateBoardFilter', 'dashboardId', dashboardId)
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('validateBoardFilter', 'boardId', boardId)
            // verify required parameter 'validateBoardFilterRequest' is not null or undefined
            assertParamExists('validateBoardFilter', 'validateBoardFilterRequest', validateBoardFilterRequest)
            const localVarPath = `/api/dashboards/{dashboardId}/boards/{boardId}/filter/validate`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)))
                .replace('{boardId}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateBoardFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BoardFilterValidationControllerApi - functional programming interface
 */
export const BoardFilterValidationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BoardFilterValidationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ボードフィルタバリデーション
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {ValidateBoardFilterRequest} validateBoardFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBoardFilter(dashboardId: string, boardId: string, validateBoardFilterRequest: ValidateBoardFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoardFilterValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBoardFilter(dashboardId, boardId, validateBoardFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BoardFilterValidationControllerApi.validateBoardFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BoardFilterValidationControllerApi - factory interface
 */
export const BoardFilterValidationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BoardFilterValidationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ボードフィルタバリデーション
         * @param {string} dashboardId 
         * @param {string} boardId 
         * @param {ValidateBoardFilterRequest} validateBoardFilterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBoardFilter(dashboardId: string, boardId: string, validateBoardFilterRequest: ValidateBoardFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<BoardFilterValidationResponse> {
            return localVarFp.validateBoardFilter(dashboardId, boardId, validateBoardFilterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BoardFilterValidationControllerApi - object-oriented interface
 */
export class BoardFilterValidationControllerApi extends BaseAPI {
    /**
     * 
     * @summary ボードフィルタバリデーション
     * @param {string} dashboardId 
     * @param {string} boardId 
     * @param {ValidateBoardFilterRequest} validateBoardFilterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateBoardFilter(dashboardId: string, boardId: string, validateBoardFilterRequest: ValidateBoardFilterRequest, options?: RawAxiosRequestConfig) {
        return BoardFilterValidationControllerApiFp(this.configuration).validateBoardFilter(dashboardId, boardId, validateBoardFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BsAccountTreeControllerApi - axios parameter creator
 */
export const BsAccountTreeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary BS科目階層に科目を追加する
         * @param {AddBSAccountRequestBody} addBSAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNode: async (addBSAccountRequestBody: AddBSAccountRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addBSAccountRequestBody' is not null or undefined
            assertParamExists('addNode', 'addBSAccountRequestBody', addBSAccountRequestBody)
            const localVarPath = `/api/bs-account-tree/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addBSAccountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定された科目をBS科目階層から外す
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachNode: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('detachNode', 'accountId', accountId)
            const localVarPath = `/api/bs-account-tree/detach/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 一括作成更新用のBS科目階層Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileDownload: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bs-account-tree/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Excelファイルをもとに、BS科目階層の一括更新を行う
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload1: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('fileUpload1', 'file', file)
            const localVarPath = `/api/bs-account-tree/bulk-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS科目階層内の科目移動において移動先候補を取得するAPI
         * @param {string} targetAccountId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSAccountMoveCandidates: async (targetAccountId: string, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetAccountId' is not null or undefined
            assertParamExists('getBSAccountMoveCandidates', 'targetAccountId', targetAccountId)
            const localVarPath = `/api/bs-account-tree/{targetAccountId}/move-candidate`
                .replace('{targetAccountId}', encodeURIComponent(String(targetAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS科目を選択させるために本体値を表示するBS科目階層を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSAccountTreeForSelection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bs-account-tree/for-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS科目階層を取得するAPI
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSAccountTreeWithAccounts: async (searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bs-account-tree/with-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS科目階層名, IDを取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBsAccountTree: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bs-account-tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS科目階層内の科目の移動を行う
         * @param {MoveBSAccountTreeNodeRequestBody} moveBSAccountTreeNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNode: async (moveBSAccountTreeNodeRequestBody: MoveBSAccountTreeNodeRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moveBSAccountTreeNodeRequestBody' is not null or undefined
            assertParamExists('moveNode', 'moveBSAccountTreeNodeRequestBody', moveBSAccountTreeNodeRequestBody)
            const localVarPath = `/api/bs-account-tree/move-node`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveBSAccountTreeNodeRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BsAccountTreeControllerApi - functional programming interface
 */
export const BsAccountTreeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BsAccountTreeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary BS科目階層に科目を追加する
         * @param {AddBSAccountRequestBody} addBSAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNode(addBSAccountRequestBody: AddBSAccountRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNode(addBSAccountRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BsAccountTreeControllerApi.addNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定された科目をBS科目階層から外す
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachNode(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachNode(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BsAccountTreeControllerApi.detachNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 一括作成更新用のBS科目階層Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileDownload(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileDownload(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BsAccountTreeControllerApi.fileDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Excelファイルをもとに、BS科目階層の一括更新を行う
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUpload1(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUpload1(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BsAccountTreeControllerApi.fileUpload1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS科目階層内の科目移動において移動先候補を取得するAPI
         * @param {string} targetAccountId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBSAccountMoveCandidates(targetAccountId: string, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BSAccountFlatTreeViewForCandidate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBSAccountMoveCandidates(targetAccountId, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BsAccountTreeControllerApi.getBSAccountMoveCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS科目を選択させるために本体値を表示するBS科目階層を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBSAccountTreeForSelection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountFlatTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBSAccountTreeForSelection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BsAccountTreeControllerApi.getBSAccountTreeForSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS科目階層を取得するAPI
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBSAccountTreeWithAccounts(searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BSAccountFlatTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBSAccountTreeWithAccounts(searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BsAccountTreeControllerApi.getBSAccountTreeWithAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS科目階層名, IDを取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBsAccountTree(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BSAccountTreeNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBsAccountTree(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BsAccountTreeControllerApi.getBsAccountTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS科目階層内の科目の移動を行う
         * @param {MoveBSAccountTreeNodeRequestBody} moveBSAccountTreeNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveNode(moveBSAccountTreeNodeRequestBody: MoveBSAccountTreeNodeRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveNode(moveBSAccountTreeNodeRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BsAccountTreeControllerApi.moveNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BsAccountTreeControllerApi - factory interface
 */
export const BsAccountTreeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BsAccountTreeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary BS科目階層に科目を追加する
         * @param {AddBSAccountRequestBody} addBSAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNode(addBSAccountRequestBody: AddBSAccountRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.addNode(addBSAccountRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定された科目をBS科目階層から外す
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachNode(accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.detachNode(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 一括作成更新用のBS科目階層Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileDownload(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.fileDownload(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Excelファイルをもとに、BS科目階層の一括更新を行う
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload1(file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.fileUpload1(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS科目階層内の科目移動において移動先候補を取得するAPI
         * @param {string} targetAccountId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSAccountMoveCandidates(targetAccountId: string, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<BSAccountFlatTreeViewForCandidate> {
            return localVarFp.getBSAccountMoveCandidates(targetAccountId, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS科目を選択させるために本体値を表示するBS科目階層を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSAccountTreeForSelection(options?: RawAxiosRequestConfig): AxiosPromise<AccountFlatTreeForSelectionView> {
            return localVarFp.getBSAccountTreeForSelection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS科目階層を取得するAPI
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSAccountTreeWithAccounts(searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<BSAccountFlatTreeView> {
            return localVarFp.getBSAccountTreeWithAccounts(searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS科目階層名, IDを取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBsAccountTree(options?: RawAxiosRequestConfig): AxiosPromise<BSAccountTreeNameView> {
            return localVarFp.getBsAccountTree(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS科目階層内の科目の移動を行う
         * @param {MoveBSAccountTreeNodeRequestBody} moveBSAccountTreeNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNode(moveBSAccountTreeNodeRequestBody: MoveBSAccountTreeNodeRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveNode(moveBSAccountTreeNodeRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BsAccountTreeControllerApi - object-oriented interface
 */
export class BsAccountTreeControllerApi extends BaseAPI {
    /**
     * 
     * @summary BS科目階層に科目を追加する
     * @param {AddBSAccountRequestBody} addBSAccountRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addNode(addBSAccountRequestBody: AddBSAccountRequestBody, options?: RawAxiosRequestConfig) {
        return BsAccountTreeControllerApiFp(this.configuration).addNode(addBSAccountRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定された科目をBS科目階層から外す
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public detachNode(accountId: string, options?: RawAxiosRequestConfig) {
        return BsAccountTreeControllerApiFp(this.configuration).detachNode(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 一括作成更新用のBS科目階層Excelのダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileDownload(options?: RawAxiosRequestConfig) {
        return BsAccountTreeControllerApiFp(this.configuration).fileDownload(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Excelファイルをもとに、BS科目階層の一括更新を行う
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUpload1(file: File, options?: RawAxiosRequestConfig) {
        return BsAccountTreeControllerApiFp(this.configuration).fileUpload1(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS科目階層内の科目移動において移動先候補を取得するAPI
     * @param {string} targetAccountId 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBSAccountMoveCandidates(targetAccountId: string, searchWord?: string, options?: RawAxiosRequestConfig) {
        return BsAccountTreeControllerApiFp(this.configuration).getBSAccountMoveCandidates(targetAccountId, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS科目を選択させるために本体値を表示するBS科目階層を取得するAPI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBSAccountTreeForSelection(options?: RawAxiosRequestConfig) {
        return BsAccountTreeControllerApiFp(this.configuration).getBSAccountTreeForSelection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS科目階層を取得するAPI
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBSAccountTreeWithAccounts(searchWord?: string, options?: RawAxiosRequestConfig) {
        return BsAccountTreeControllerApiFp(this.configuration).getBSAccountTreeWithAccounts(searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS科目階層名, IDを取得するAPI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBsAccountTree(options?: RawAxiosRequestConfig) {
        return BsAccountTreeControllerApiFp(this.configuration).getBsAccountTree(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS科目階層内の科目の移動を行う
     * @param {MoveBSAccountTreeNodeRequestBody} moveBSAccountTreeNodeRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveNode(moveBSAccountTreeNodeRequestBody: MoveBSAccountTreeNodeRequestBody, options?: RawAxiosRequestConfig) {
        return BsAccountTreeControllerApiFp(this.configuration).moveNode(moveBSAccountTreeNodeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalculatedAccountControllerApi - axios parameter creator
 */
export const CalculatedAccountControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 計算科目の作成をする
         * @param {CreateCalculatedAccountRequestBody} createCalculatedAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalculatedAccount: async (createCalculatedAccountRequestBody: CreateCalculatedAccountRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCalculatedAccountRequestBody' is not null or undefined
            assertParamExists('createCalculatedAccount', 'createCalculatedAccountRequestBody', createCalculatedAccountRequestBody)
            const localVarPath = `/api/calculated-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCalculatedAccountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計算科目を削除する
         * @param {string} calculatedAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalculatedAccount: async (calculatedAccountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculatedAccountId' is not null or undefined
            assertParamExists('deleteCalculatedAccount', 'calculatedAccountId', calculatedAccountId)
            const localVarPath = `/api/calculated-accounts/{calculatedAccountId}`
                .replace('{calculatedAccountId}', encodeURIComponent(String(calculatedAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単一の計算科目を取得する
         * @param {string} calculatedAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculatedAccount: async (calculatedAccountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculatedAccountId' is not null or undefined
            assertParamExists('getCalculatedAccount', 'calculatedAccountId', calculatedAccountId)
            const localVarPath = `/api/calculated-accounts/{calculatedAccountId}`
                .replace('{calculatedAccountId}', encodeURIComponent(String(calculatedAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計算科目を全て取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalculatedAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/calculated-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計算科目を更新する
         * @param {UpdateCalculatedAccountRequestBody} updateCalculatedAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalculatedAccount: async (updateCalculatedAccountRequestBody: UpdateCalculatedAccountRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCalculatedAccountRequestBody' is not null or undefined
            assertParamExists('updateCalculatedAccount', 'updateCalculatedAccountRequestBody', updateCalculatedAccountRequestBody)
            const localVarPath = `/api/calculated-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCalculatedAccountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculatedAccountControllerApi - functional programming interface
 */
export const CalculatedAccountControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculatedAccountControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 計算科目の作成をする
         * @param {CreateCalculatedAccountRequestBody} createCalculatedAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalculatedAccount(createCalculatedAccountRequestBody: CreateCalculatedAccountRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalculatedAccount(createCalculatedAccountRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculatedAccountControllerApi.createCalculatedAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計算科目を削除する
         * @param {string} calculatedAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalculatedAccount(calculatedAccountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCalculatedAccount(calculatedAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculatedAccountControllerApi.deleteCalculatedAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単一の計算科目を取得する
         * @param {string} calculatedAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculatedAccount(calculatedAccountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculatedAccountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalculatedAccount(calculatedAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculatedAccountControllerApi.getCalculatedAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計算科目を全て取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCalculatedAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculatedAccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCalculatedAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculatedAccountControllerApi.listCalculatedAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計算科目を更新する
         * @param {UpdateCalculatedAccountRequestBody} updateCalculatedAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCalculatedAccount(updateCalculatedAccountRequestBody: UpdateCalculatedAccountRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCalculatedAccount(updateCalculatedAccountRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculatedAccountControllerApi.updateCalculatedAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculatedAccountControllerApi - factory interface
 */
export const CalculatedAccountControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculatedAccountControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 計算科目の作成をする
         * @param {CreateCalculatedAccountRequestBody} createCalculatedAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalculatedAccount(createCalculatedAccountRequestBody: CreateCalculatedAccountRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createCalculatedAccount(createCalculatedAccountRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計算科目を削除する
         * @param {string} calculatedAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalculatedAccount(calculatedAccountId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteCalculatedAccount(calculatedAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単一の計算科目を取得する
         * @param {string} calculatedAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculatedAccount(calculatedAccountId: string, options?: RawAxiosRequestConfig): AxiosPromise<CalculatedAccountView> {
            return localVarFp.getCalculatedAccount(calculatedAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計算科目を全て取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalculatedAccount(options?: RawAxiosRequestConfig): AxiosPromise<CalculatedAccountsView> {
            return localVarFp.listCalculatedAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計算科目を更新する
         * @param {UpdateCalculatedAccountRequestBody} updateCalculatedAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCalculatedAccount(updateCalculatedAccountRequestBody: UpdateCalculatedAccountRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateCalculatedAccount(updateCalculatedAccountRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculatedAccountControllerApi - object-oriented interface
 */
export class CalculatedAccountControllerApi extends BaseAPI {
    /**
     * 
     * @summary 計算科目の作成をする
     * @param {CreateCalculatedAccountRequestBody} createCalculatedAccountRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCalculatedAccount(createCalculatedAccountRequestBody: CreateCalculatedAccountRequestBody, options?: RawAxiosRequestConfig) {
        return CalculatedAccountControllerApiFp(this.configuration).createCalculatedAccount(createCalculatedAccountRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計算科目を削除する
     * @param {string} calculatedAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCalculatedAccount(calculatedAccountId: string, options?: RawAxiosRequestConfig) {
        return CalculatedAccountControllerApiFp(this.configuration).deleteCalculatedAccount(calculatedAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単一の計算科目を取得する
     * @param {string} calculatedAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCalculatedAccount(calculatedAccountId: string, options?: RawAxiosRequestConfig) {
        return CalculatedAccountControllerApiFp(this.configuration).getCalculatedAccount(calculatedAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計算科目を全て取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCalculatedAccount(options?: RawAxiosRequestConfig) {
        return CalculatedAccountControllerApiFp(this.configuration).listCalculatedAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計算科目を更新する
     * @param {UpdateCalculatedAccountRequestBody} updateCalculatedAccountRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCalculatedAccount(updateCalculatedAccountRequestBody: UpdateCalculatedAccountRequestBody, options?: RawAxiosRequestConfig) {
        return CalculatedAccountControllerApiFp(this.configuration).updateCalculatedAccount(updateCalculatedAccountRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CfAccountControllerApi - axios parameter creator
 */
export const CfAccountControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CF科目作成
         * @param {CreateCfAccountRequestBody} createCfAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCfAccount: async (createCfAccountRequestBody: CreateCfAccountRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCfAccountRequestBody' is not null or undefined
            assertParamExists('createCfAccount', 'createCfAccountRequestBody', createCfAccountRequestBody)
            const localVarPath = `/api/cf-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCfAccountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register default cash flow accounts
         * @param {DefaultCfAccountRegistrationRequest} defaultCfAccountRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultCfAccountRegistration: async (defaultCfAccountRegistrationRequest: DefaultCfAccountRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defaultCfAccountRegistrationRequest' is not null or undefined
            assertParamExists('defaultCfAccountRegistration', 'defaultCfAccountRegistrationRequest', defaultCfAccountRegistrationRequest)
            const localVarPath = `/api/cf-accounts/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(defaultCfAccountRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete CF account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCfAccount: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteCfAccount', 'accountId', accountId)
            const localVarPath = `/api/cf-accounts/{accountId}`
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BS accounts reference
         * @param {string} [excludedCfAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBsReferenceAccounts: async (excludedCfAccountId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cf-accounts/bs-reference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (excludedCfAccountId !== undefined) {
                localVarQueryParameter['excludedCfAccountId'] = excludedCfAccountId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目を更新する
         * @param {string} cfAccountId 
         * @param {UpdateCfAccountRequestBody} updateCfAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCfAccount: async (cfAccountId: string, updateCfAccountRequestBody: UpdateCfAccountRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cfAccountId' is not null or undefined
            assertParamExists('updateCfAccount', 'cfAccountId', cfAccountId)
            // verify required parameter 'updateCfAccountRequestBody' is not null or undefined
            assertParamExists('updateCfAccount', 'updateCfAccountRequestBody', updateCfAccountRequestBody)
            const localVarPath = `/api/cf-accounts/{cfAccountId}`
                .replace('{cfAccountId}', encodeURIComponent(String(cfAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCfAccountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CfAccountControllerApi - functional programming interface
 */
export const CfAccountControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CfAccountControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary CF科目作成
         * @param {CreateCfAccountRequestBody} createCfAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCfAccount(createCfAccountRequestBody: CreateCfAccountRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCfAccount(createCfAccountRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CfAccountControllerApi.createCfAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register default cash flow accounts
         * @param {DefaultCfAccountRegistrationRequest} defaultCfAccountRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async defaultCfAccountRegistration(defaultCfAccountRegistrationRequest: DefaultCfAccountRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultCfAccountRegistrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.defaultCfAccountRegistration(defaultCfAccountRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CfAccountControllerApi.defaultCfAccountRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete CF account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCfAccount(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCfAccount(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CfAccountControllerApi.deleteCfAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BS accounts reference
         * @param {string} [excludedCfAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBsReferenceAccounts(excludedCfAccountId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BsReferenceAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBsReferenceAccounts(excludedCfAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CfAccountControllerApi.getBsReferenceAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目を更新する
         * @param {string} cfAccountId 
         * @param {UpdateCfAccountRequestBody} updateCfAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCfAccount(cfAccountId: string, updateCfAccountRequestBody: UpdateCfAccountRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CfAccount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCfAccount(cfAccountId, updateCfAccountRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CfAccountControllerApi.updateCfAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CfAccountControllerApi - factory interface
 */
export const CfAccountControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CfAccountControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary CF科目作成
         * @param {CreateCfAccountRequestBody} createCfAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCfAccount(createCfAccountRequestBody: CreateCfAccountRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createCfAccount(createCfAccountRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register default cash flow accounts
         * @param {DefaultCfAccountRegistrationRequest} defaultCfAccountRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defaultCfAccountRegistration(defaultCfAccountRegistrationRequest: DefaultCfAccountRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DefaultCfAccountRegistrationResponse> {
            return localVarFp.defaultCfAccountRegistration(defaultCfAccountRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete CF account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCfAccount(accountId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteCfAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BS accounts reference
         * @param {string} [excludedCfAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBsReferenceAccounts(excludedCfAccountId?: string, options?: RawAxiosRequestConfig): AxiosPromise<BsReferenceAccountsResponse> {
            return localVarFp.getBsReferenceAccounts(excludedCfAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目を更新する
         * @param {string} cfAccountId 
         * @param {UpdateCfAccountRequestBody} updateCfAccountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCfAccount(cfAccountId: string, updateCfAccountRequestBody: UpdateCfAccountRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CfAccount> {
            return localVarFp.updateCfAccount(cfAccountId, updateCfAccountRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CfAccountControllerApi - object-oriented interface
 */
export class CfAccountControllerApi extends BaseAPI {
    /**
     * 
     * @summary CF科目作成
     * @param {CreateCfAccountRequestBody} createCfAccountRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCfAccount(createCfAccountRequestBody: CreateCfAccountRequestBody, options?: RawAxiosRequestConfig) {
        return CfAccountControllerApiFp(this.configuration).createCfAccount(createCfAccountRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register default cash flow accounts
     * @param {DefaultCfAccountRegistrationRequest} defaultCfAccountRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public defaultCfAccountRegistration(defaultCfAccountRegistrationRequest: DefaultCfAccountRegistrationRequest, options?: RawAxiosRequestConfig) {
        return CfAccountControllerApiFp(this.configuration).defaultCfAccountRegistration(defaultCfAccountRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete CF account
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCfAccount(accountId: string, options?: RawAxiosRequestConfig) {
        return CfAccountControllerApiFp(this.configuration).deleteCfAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BS accounts reference
     * @param {string} [excludedCfAccountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBsReferenceAccounts(excludedCfAccountId?: string, options?: RawAxiosRequestConfig) {
        return CfAccountControllerApiFp(this.configuration).getBsReferenceAccounts(excludedCfAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目を更新する
     * @param {string} cfAccountId 
     * @param {UpdateCfAccountRequestBody} updateCfAccountRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCfAccount(cfAccountId: string, updateCfAccountRequestBody: UpdateCfAccountRequestBody, options?: RawAxiosRequestConfig) {
        return CfAccountControllerApiFp(this.configuration).updateCfAccount(cfAccountId, updateCfAccountRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CfAccountTreeControllerApi - axios parameter creator
 */
export const CfAccountTreeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get CF Account move candidates
         * @param {string} targetAccountId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCFAccountMoveCandidates: async (targetAccountId: string, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetAccountId' is not null or undefined
            assertParamExists('getCFAccountMoveCandidates', 'targetAccountId', targetAccountId)
            const localVarPath = `/api/cf-account-trees/{targetAccountId}/move-candidate`
                .replace('{targetAccountId}', encodeURIComponent(String(targetAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Cash Flow Account Tree
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCfAccountTrees: async (searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cf-account-trees/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move CF Account API
         * @param {MoveNodesRequestBody} moveNodesRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCfAccountTreeNode: async (moveNodesRequestBody: MoveNodesRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moveNodesRequestBody' is not null or undefined
            assertParamExists('moveCfAccountTreeNode', 'moveNodesRequestBody', moveNodesRequestBody)
            const localVarPath = `/api/cf-account-trees/move-node`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveNodesRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update PL account tree for cash flow accounts
         * @param {UpdateCfAccountPlTreeRequest} updateCfAccountPlTreeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCfAccountPlTree: async (updateCfAccountPlTreeRequest: UpdateCfAccountPlTreeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCfAccountPlTreeRequest' is not null or undefined
            assertParamExists('updateCfAccountPlTree', 'updateCfAccountPlTreeRequest', updateCfAccountPlTreeRequest)
            const localVarPath = `/api/cf-account-trees/update-pl-tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCfAccountPlTreeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CfAccountTreeControllerApi - functional programming interface
 */
export const CfAccountTreeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CfAccountTreeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get CF Account move candidates
         * @param {string} targetAccountId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCFAccountMoveCandidates(targetAccountId: string, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CFAccountFlatTreeViewForCandidate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCFAccountMoveCandidates(targetAccountId, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CfAccountTreeControllerApi.getCFAccountMoveCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Cash Flow Account Tree
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCfAccountTrees(searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CfAccountFlatTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCfAccountTrees(searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CfAccountTreeControllerApi.listCfAccountTrees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Move CF Account API
         * @param {MoveNodesRequestBody} moveNodesRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveCfAccountTreeNode(moveNodesRequestBody: MoveNodesRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveCfAccountTreeNode(moveNodesRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CfAccountTreeControllerApi.moveCfAccountTreeNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update PL account tree for cash flow accounts
         * @param {UpdateCfAccountPlTreeRequest} updateCfAccountPlTreeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCfAccountPlTree(updateCfAccountPlTreeRequest: UpdateCfAccountPlTreeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCfAccountPlTree(updateCfAccountPlTreeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CfAccountTreeControllerApi.updateCfAccountPlTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CfAccountTreeControllerApi - factory interface
 */
export const CfAccountTreeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CfAccountTreeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get CF Account move candidates
         * @param {string} targetAccountId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCFAccountMoveCandidates(targetAccountId: string, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<CFAccountFlatTreeViewForCandidate> {
            return localVarFp.getCFAccountMoveCandidates(targetAccountId, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Cash Flow Account Tree
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCfAccountTrees(searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<CfAccountFlatTreeView> {
            return localVarFp.listCfAccountTrees(searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move CF Account API
         * @param {MoveNodesRequestBody} moveNodesRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCfAccountTreeNode(moveNodesRequestBody: MoveNodesRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveCfAccountTreeNode(moveNodesRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update PL account tree for cash flow accounts
         * @param {UpdateCfAccountPlTreeRequest} updateCfAccountPlTreeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCfAccountPlTree(updateCfAccountPlTreeRequest: UpdateCfAccountPlTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateCfAccountPlTree(updateCfAccountPlTreeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CfAccountTreeControllerApi - object-oriented interface
 */
export class CfAccountTreeControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get CF Account move candidates
     * @param {string} targetAccountId 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCFAccountMoveCandidates(targetAccountId: string, searchWord?: string, options?: RawAxiosRequestConfig) {
        return CfAccountTreeControllerApiFp(this.configuration).getCFAccountMoveCandidates(targetAccountId, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Cash Flow Account Tree
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCfAccountTrees(searchWord?: string, options?: RawAxiosRequestConfig) {
        return CfAccountTreeControllerApiFp(this.configuration).listCfAccountTrees(searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move CF Account API
     * @param {MoveNodesRequestBody} moveNodesRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveCfAccountTreeNode(moveNodesRequestBody: MoveNodesRequestBody, options?: RawAxiosRequestConfig) {
        return CfAccountTreeControllerApiFp(this.configuration).moveCfAccountTreeNode(moveNodesRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update PL account tree for cash flow accounts
     * @param {UpdateCfAccountPlTreeRequest} updateCfAccountPlTreeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCfAccountPlTree(updateCfAccountPlTreeRequest: UpdateCfAccountPlTreeRequest, options?: RawAxiosRequestConfig) {
        return CfAccountTreeControllerApiFp(this.configuration).updateCfAccountPlTree(updateCfAccountPlTreeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ComparisonControllerApi - axios parameter creator
 */
export const ComparisonControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 対比表をExcelでダウンロードする
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadComparisonExcel: async (fetchComparisonRequestBody: FetchComparisonRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchComparisonRequestBody' is not null or undefined
            assertParamExists('downloadComparisonExcel', 'fetchComparisonRequestBody', fetchComparisonRequestBody)
            const localVarPath = `/api/comparison/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchComparisonRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actual or PlanA vs Actual or PlanB
         * @summary 対比表API
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchComparison: async (fetchComparisonRequestBody: FetchComparisonRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchComparisonRequestBody' is not null or undefined
            assertParamExists('fetchComparison', 'fetchComparisonRequestBody', fetchComparisonRequestBody)
            const localVarPath = `/api/comparison`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchComparisonRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComparisonControllerApi - functional programming interface
 */
export const ComparisonControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComparisonControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 対比表をExcelでダウンロードする
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadComparisonExcel(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadComparisonExcel(fetchComparisonRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonControllerApi.downloadComparisonExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Actual or PlanA vs Actual or PlanB
         * @summary 対比表API
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchComparison(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonTableV3View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchComparison(fetchComparisonRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonControllerApi.fetchComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComparisonControllerApi - factory interface
 */
export const ComparisonControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComparisonControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 対比表をExcelでダウンロードする
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadComparisonExcel(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadComparisonExcel(fetchComparisonRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Actual or PlanA vs Actual or PlanB
         * @summary 対比表API
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchComparison(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonTableV3View> {
            return localVarFp.fetchComparison(fetchComparisonRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComparisonControllerApi - object-oriented interface
 */
export class ComparisonControllerApi extends BaseAPI {
    /**
     * 
     * @summary 対比表をExcelでダウンロードする
     * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadComparisonExcel(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig) {
        return ComparisonControllerApiFp(this.configuration).downloadComparisonExcel(fetchComparisonRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actual or PlanA vs Actual or PlanB
     * @summary 対比表API
     * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchComparison(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig) {
        return ComparisonControllerApiFp(this.configuration).fetchComparison(fetchComparisonRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ComparisonSheetSelectedConditionControllerApi - axios parameter creator
 */
export const ComparisonSheetSelectedConditionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 対比表選択条件保存の削除
         * @param {string} comparisonSheetSelectedConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparisonConditionDelete: async (comparisonSheetSelectedConditionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comparisonSheetSelectedConditionId' is not null or undefined
            assertParamExists('comparisonConditionDelete', 'comparisonSheetSelectedConditionId', comparisonSheetSelectedConditionId)
            const localVarPath = `/api/comparison-sheet-selected-conditions/{comparisonSheetSelectedConditionId}`
                .replace('{comparisonSheetSelectedConditionId}', encodeURIComponent(String(comparisonSheetSelectedConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比表選択条件の作成
         * @param {CreateOrUpdateComparisonSheetSelectedConditionRequestBody} createOrUpdateComparisonSheetSelectedConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparisonSheetSelectedCondition: async (createOrUpdateComparisonSheetSelectedConditionRequestBody: CreateOrUpdateComparisonSheetSelectedConditionRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrUpdateComparisonSheetSelectedConditionRequestBody' is not null or undefined
            assertParamExists('createComparisonSheetSelectedCondition', 'createOrUpdateComparisonSheetSelectedConditionRequestBody', createOrUpdateComparisonSheetSelectedConditionRequestBody)
            const localVarPath = `/api/comparison-sheet-selected-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateComparisonSheetSelectedConditionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比表選択条件一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComparisonSheetSelectedCondition: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/comparison-sheet-selected-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比表選択条件を別の選択条件グループへ移動
         * @param {string} comparisonSheetSelectedConditionId 
         * @param {MoveComparisonSheetSelectedConditionGroupRequestBody} moveComparisonSheetSelectedConditionGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveComparisonCondition: async (comparisonSheetSelectedConditionId: string, moveComparisonSheetSelectedConditionGroupRequestBody: MoveComparisonSheetSelectedConditionGroupRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comparisonSheetSelectedConditionId' is not null or undefined
            assertParamExists('moveComparisonCondition', 'comparisonSheetSelectedConditionId', comparisonSheetSelectedConditionId)
            // verify required parameter 'moveComparisonSheetSelectedConditionGroupRequestBody' is not null or undefined
            assertParamExists('moveComparisonCondition', 'moveComparisonSheetSelectedConditionGroupRequestBody', moveComparisonSheetSelectedConditionGroupRequestBody)
            const localVarPath = `/api/comparison-sheet-selected-conditions/{comparisonSheetSelectedConditionId}/move-group`
                .replace('{comparisonSheetSelectedConditionId}', encodeURIComponent(String(comparisonSheetSelectedConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveComparisonSheetSelectedConditionGroupRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比表選択条件の更新
         * @param {string} comparisonSheetSelectedConditionId 
         * @param {CreateOrUpdateComparisonSheetSelectedConditionRequestBody} createOrUpdateComparisonSheetSelectedConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComparisonCondition: async (comparisonSheetSelectedConditionId: string, createOrUpdateComparisonSheetSelectedConditionRequestBody: CreateOrUpdateComparisonSheetSelectedConditionRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comparisonSheetSelectedConditionId' is not null or undefined
            assertParamExists('updateComparisonCondition', 'comparisonSheetSelectedConditionId', comparisonSheetSelectedConditionId)
            // verify required parameter 'createOrUpdateComparisonSheetSelectedConditionRequestBody' is not null or undefined
            assertParamExists('updateComparisonCondition', 'createOrUpdateComparisonSheetSelectedConditionRequestBody', createOrUpdateComparisonSheetSelectedConditionRequestBody)
            const localVarPath = `/api/comparison-sheet-selected-conditions/{comparisonSheetSelectedConditionId}`
                .replace('{comparisonSheetSelectedConditionId}', encodeURIComponent(String(comparisonSheetSelectedConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateComparisonSheetSelectedConditionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComparisonSheetSelectedConditionControllerApi - functional programming interface
 */
export const ComparisonSheetSelectedConditionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComparisonSheetSelectedConditionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 対比表選択条件保存の削除
         * @param {string} comparisonSheetSelectedConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async comparisonConditionDelete(comparisonSheetSelectedConditionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.comparisonConditionDelete(comparisonSheetSelectedConditionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionControllerApi.comparisonConditionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比表選択条件の作成
         * @param {CreateOrUpdateComparisonSheetSelectedConditionRequestBody} createOrUpdateComparisonSheetSelectedConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComparisonSheetSelectedCondition(createOrUpdateComparisonSheetSelectedConditionRequestBody: CreateOrUpdateComparisonSheetSelectedConditionRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateComparisonSheetSelectedConditionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComparisonSheetSelectedCondition(createOrUpdateComparisonSheetSelectedConditionRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionControllerApi.createComparisonSheetSelectedCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比表選択条件一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listComparisonSheetSelectedCondition(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComparisonSheetSelectedConditionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listComparisonSheetSelectedCondition(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionControllerApi.listComparisonSheetSelectedCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比表選択条件を別の選択条件グループへ移動
         * @param {string} comparisonSheetSelectedConditionId 
         * @param {MoveComparisonSheetSelectedConditionGroupRequestBody} moveComparisonSheetSelectedConditionGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveComparisonCondition(comparisonSheetSelectedConditionId: string, moveComparisonSheetSelectedConditionGroupRequestBody: MoveComparisonSheetSelectedConditionGroupRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveComparisonCondition(comparisonSheetSelectedConditionId, moveComparisonSheetSelectedConditionGroupRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionControllerApi.moveComparisonCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比表選択条件の更新
         * @param {string} comparisonSheetSelectedConditionId 
         * @param {CreateOrUpdateComparisonSheetSelectedConditionRequestBody} createOrUpdateComparisonSheetSelectedConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComparisonCondition(comparisonSheetSelectedConditionId: string, createOrUpdateComparisonSheetSelectedConditionRequestBody: CreateOrUpdateComparisonSheetSelectedConditionRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComparisonCondition(comparisonSheetSelectedConditionId, createOrUpdateComparisonSheetSelectedConditionRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionControllerApi.updateComparisonCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComparisonSheetSelectedConditionControllerApi - factory interface
 */
export const ComparisonSheetSelectedConditionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComparisonSheetSelectedConditionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 対比表選択条件保存の削除
         * @param {string} comparisonSheetSelectedConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        comparisonConditionDelete(comparisonSheetSelectedConditionId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.comparisonConditionDelete(comparisonSheetSelectedConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比表選択条件の作成
         * @param {CreateOrUpdateComparisonSheetSelectedConditionRequestBody} createOrUpdateComparisonSheetSelectedConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparisonSheetSelectedCondition(createOrUpdateComparisonSheetSelectedConditionRequestBody: CreateOrUpdateComparisonSheetSelectedConditionRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreateComparisonSheetSelectedConditionResponse> {
            return localVarFp.createComparisonSheetSelectedCondition(createOrUpdateComparisonSheetSelectedConditionRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比表選択条件一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComparisonSheetSelectedCondition(options?: RawAxiosRequestConfig): AxiosPromise<Array<ComparisonSheetSelectedConditionDto>> {
            return localVarFp.listComparisonSheetSelectedCondition(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比表選択条件を別の選択条件グループへ移動
         * @param {string} comparisonSheetSelectedConditionId 
         * @param {MoveComparisonSheetSelectedConditionGroupRequestBody} moveComparisonSheetSelectedConditionGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveComparisonCondition(comparisonSheetSelectedConditionId: string, moveComparisonSheetSelectedConditionGroupRequestBody: MoveComparisonSheetSelectedConditionGroupRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveComparisonCondition(comparisonSheetSelectedConditionId, moveComparisonSheetSelectedConditionGroupRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比表選択条件の更新
         * @param {string} comparisonSheetSelectedConditionId 
         * @param {CreateOrUpdateComparisonSheetSelectedConditionRequestBody} createOrUpdateComparisonSheetSelectedConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComparisonCondition(comparisonSheetSelectedConditionId: string, createOrUpdateComparisonSheetSelectedConditionRequestBody: CreateOrUpdateComparisonSheetSelectedConditionRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateComparisonCondition(comparisonSheetSelectedConditionId, createOrUpdateComparisonSheetSelectedConditionRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComparisonSheetSelectedConditionControllerApi - object-oriented interface
 */
export class ComparisonSheetSelectedConditionControllerApi extends BaseAPI {
    /**
     * 
     * @summary 対比表選択条件保存の削除
     * @param {string} comparisonSheetSelectedConditionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public comparisonConditionDelete(comparisonSheetSelectedConditionId: string, options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionControllerApiFp(this.configuration).comparisonConditionDelete(comparisonSheetSelectedConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比表選択条件の作成
     * @param {CreateOrUpdateComparisonSheetSelectedConditionRequestBody} createOrUpdateComparisonSheetSelectedConditionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createComparisonSheetSelectedCondition(createOrUpdateComparisonSheetSelectedConditionRequestBody: CreateOrUpdateComparisonSheetSelectedConditionRequestBody, options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionControllerApiFp(this.configuration).createComparisonSheetSelectedCondition(createOrUpdateComparisonSheetSelectedConditionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比表選択条件一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listComparisonSheetSelectedCondition(options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionControllerApiFp(this.configuration).listComparisonSheetSelectedCondition(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比表選択条件を別の選択条件グループへ移動
     * @param {string} comparisonSheetSelectedConditionId 
     * @param {MoveComparisonSheetSelectedConditionGroupRequestBody} moveComparisonSheetSelectedConditionGroupRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveComparisonCondition(comparisonSheetSelectedConditionId: string, moveComparisonSheetSelectedConditionGroupRequestBody: MoveComparisonSheetSelectedConditionGroupRequestBody, options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionControllerApiFp(this.configuration).moveComparisonCondition(comparisonSheetSelectedConditionId, moveComparisonSheetSelectedConditionGroupRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比表選択条件の更新
     * @param {string} comparisonSheetSelectedConditionId 
     * @param {CreateOrUpdateComparisonSheetSelectedConditionRequestBody} createOrUpdateComparisonSheetSelectedConditionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateComparisonCondition(comparisonSheetSelectedConditionId: string, createOrUpdateComparisonSheetSelectedConditionRequestBody: CreateOrUpdateComparisonSheetSelectedConditionRequestBody, options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionControllerApiFp(this.configuration).updateComparisonCondition(comparisonSheetSelectedConditionId, createOrUpdateComparisonSheetSelectedConditionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ComparisonSheetSelectedConditionGroupControllerApi - axios parameter creator
 */
export const ComparisonSheetSelectedConditionGroupControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 対比表選択条件グループの作成API
         * @param {CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody} createOrUpdateComparisonSheetSelectedConditionGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparisonSheetSelectedConditionGroup: async (createOrUpdateComparisonSheetSelectedConditionGroupRequestBody: CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrUpdateComparisonSheetSelectedConditionGroupRequestBody' is not null or undefined
            assertParamExists('createComparisonSheetSelectedConditionGroup', 'createOrUpdateComparisonSheetSelectedConditionGroupRequestBody', createOrUpdateComparisonSheetSelectedConditionGroupRequestBody)
            const localVarPath = `/api/comparison-sheet-selected-condition-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateComparisonSheetSelectedConditionGroupRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比表選択条件グループの削除
         * @param {string} comparisonSheetSelectedConditionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComparisonSheetSelectedConditionGroup: async (comparisonSheetSelectedConditionGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comparisonSheetSelectedConditionGroupId' is not null or undefined
            assertParamExists('deleteComparisonSheetSelectedConditionGroup', 'comparisonSheetSelectedConditionGroupId', comparisonSheetSelectedConditionGroupId)
            const localVarPath = `/api/comparison-sheet-selected-condition-groups/{comparisonSheetSelectedConditionGroupId}`
                .replace('{comparisonSheetSelectedConditionGroupId}', encodeURIComponent(String(comparisonSheetSelectedConditionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比表選択条件グループの一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForSelection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/comparison-sheet-selected-condition-groups/for-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比表選択条件グループとその選択条件一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWithSelectedConditions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/comparison-sheet-selected-condition-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比表選択条件グループ名の更新
         * @param {string} comparisonSheetSelectedConditionGroupId 
         * @param {CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody} createOrUpdateComparisonSheetSelectedConditionGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComparisonSheetSelectedConditionGroup: async (comparisonSheetSelectedConditionGroupId: string, createOrUpdateComparisonSheetSelectedConditionGroupRequestBody: CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comparisonSheetSelectedConditionGroupId' is not null or undefined
            assertParamExists('updateComparisonSheetSelectedConditionGroup', 'comparisonSheetSelectedConditionGroupId', comparisonSheetSelectedConditionGroupId)
            // verify required parameter 'createOrUpdateComparisonSheetSelectedConditionGroupRequestBody' is not null or undefined
            assertParamExists('updateComparisonSheetSelectedConditionGroup', 'createOrUpdateComparisonSheetSelectedConditionGroupRequestBody', createOrUpdateComparisonSheetSelectedConditionGroupRequestBody)
            const localVarPath = `/api/comparison-sheet-selected-condition-groups/{comparisonSheetSelectedConditionGroupId}`
                .replace('{comparisonSheetSelectedConditionGroupId}', encodeURIComponent(String(comparisonSheetSelectedConditionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateComparisonSheetSelectedConditionGroupRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComparisonSheetSelectedConditionGroupControllerApi - functional programming interface
 */
export const ComparisonSheetSelectedConditionGroupControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComparisonSheetSelectedConditionGroupControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 対比表選択条件グループの作成API
         * @param {CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody} createOrUpdateComparisonSheetSelectedConditionGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComparisonSheetSelectedConditionGroup(createOrUpdateComparisonSheetSelectedConditionGroupRequestBody: CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComparisonSheetSelectedConditionGroup(createOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionGroupControllerApi.createComparisonSheetSelectedConditionGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比表選択条件グループの削除
         * @param {string} comparisonSheetSelectedConditionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionGroupControllerApi.deleteComparisonSheetSelectedConditionGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比表選択条件グループの一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listForSelection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComparisonSheetSelectedConditionForSelectionView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listForSelection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionGroupControllerApi.listForSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比表選択条件グループとその選択条件一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWithSelectedConditions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComparisonSheetSelectedConditionGroupView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWithSelectedConditions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionGroupControllerApi.listWithSelectedConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比表選択条件グループ名の更新
         * @param {string} comparisonSheetSelectedConditionGroupId 
         * @param {CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody} createOrUpdateComparisonSheetSelectedConditionGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId: string, createOrUpdateComparisonSheetSelectedConditionGroupRequestBody: CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId, createOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComparisonSheetSelectedConditionGroupControllerApi.updateComparisonSheetSelectedConditionGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComparisonSheetSelectedConditionGroupControllerApi - factory interface
 */
export const ComparisonSheetSelectedConditionGroupControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComparisonSheetSelectedConditionGroupControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 対比表選択条件グループの作成API
         * @param {CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody} createOrUpdateComparisonSheetSelectedConditionGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComparisonSheetSelectedConditionGroup(createOrUpdateComparisonSheetSelectedConditionGroupRequestBody: CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createComparisonSheetSelectedConditionGroup(createOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比表選択条件グループの削除
         * @param {string} comparisonSheetSelectedConditionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比表選択条件グループの一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForSelection(options?: RawAxiosRequestConfig): AxiosPromise<Array<ComparisonSheetSelectedConditionForSelectionView>> {
            return localVarFp.listForSelection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比表選択条件グループとその選択条件一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWithSelectedConditions(options?: RawAxiosRequestConfig): AxiosPromise<Array<ComparisonSheetSelectedConditionGroupView>> {
            return localVarFp.listWithSelectedConditions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比表選択条件グループ名の更新
         * @param {string} comparisonSheetSelectedConditionGroupId 
         * @param {CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody} createOrUpdateComparisonSheetSelectedConditionGroupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId: string, createOrUpdateComparisonSheetSelectedConditionGroupRequestBody: CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId, createOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComparisonSheetSelectedConditionGroupControllerApi - object-oriented interface
 */
export class ComparisonSheetSelectedConditionGroupControllerApi extends BaseAPI {
    /**
     * 
     * @summary 対比表選択条件グループの作成API
     * @param {CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody} createOrUpdateComparisonSheetSelectedConditionGroupRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createComparisonSheetSelectedConditionGroup(createOrUpdateComparisonSheetSelectedConditionGroupRequestBody: CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionGroupControllerApiFp(this.configuration).createComparisonSheetSelectedConditionGroup(createOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比表選択条件グループの削除
     * @param {string} comparisonSheetSelectedConditionGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId: string, options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionGroupControllerApiFp(this.configuration).deleteComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比表選択条件グループの一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listForSelection(options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionGroupControllerApiFp(this.configuration).listForSelection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比表選択条件グループとその選択条件一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWithSelectedConditions(options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionGroupControllerApiFp(this.configuration).listWithSelectedConditions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比表選択条件グループ名の更新
     * @param {string} comparisonSheetSelectedConditionGroupId 
     * @param {CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody} createOrUpdateComparisonSheetSelectedConditionGroupRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId: string, createOrUpdateComparisonSheetSelectedConditionGroupRequestBody: CreateOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options?: RawAxiosRequestConfig) {
        return ComparisonSheetSelectedConditionGroupControllerApiFp(this.configuration).updateComparisonSheetSelectedConditionGroup(comparisonSheetSelectedConditionGroupId, createOrUpdateComparisonSheetSelectedConditionGroupRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompositeReportTableControllerApi - axios parameter creator
 */
export const CompositeReportTableControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 複合表の表データをExcel形式で出力する
         * @param {GetCompositeReportTableValuesByReportIdsBody} getCompositeReportTableValuesByReportIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompositeReportTableExcel: async (getCompositeReportTableValuesByReportIdsBody: GetCompositeReportTableValuesByReportIdsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCompositeReportTableValuesByReportIdsBody' is not null or undefined
            assertParamExists('getCompositeReportTableExcel', 'getCompositeReportTableValuesByReportIdsBody', getCompositeReportTableValuesByReportIdsBody)
            const localVarPath = `/api/composite-report-tables/values/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCompositeReportTableValuesByReportIdsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 複合表の値を取得する（レポートID指定）
         * @param {GetCompositeReportTableValuesByReportIdsBody} getCompositeReportTableValuesByReportIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValuesByReportIds: async (getCompositeReportTableValuesByReportIdsBody: GetCompositeReportTableValuesByReportIdsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCompositeReportTableValuesByReportIdsBody' is not null or undefined
            assertParamExists('getValuesByReportIds', 'getCompositeReportTableValuesByReportIdsBody', getCompositeReportTableValuesByReportIdsBody)
            const localVarPath = `/api/composite-report-tables/values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCompositeReportTableValuesByReportIdsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 複合表のレイアウトバリデーションを実行する
         * @param {ValidateCompositeReportTableBody} validateCompositeReportTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: async (validateCompositeReportTableBody: ValidateCompositeReportTableBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateCompositeReportTableBody' is not null or undefined
            assertParamExists('validate', 'validateCompositeReportTableBody', validateCompositeReportTableBody)
            const localVarPath = `/api/composite-report-tables/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateCompositeReportTableBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompositeReportTableControllerApi - functional programming interface
 */
export const CompositeReportTableControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompositeReportTableControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 複合表の表データをExcel形式で出力する
         * @param {GetCompositeReportTableValuesByReportIdsBody} getCompositeReportTableValuesByReportIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompositeReportTableExcel(getCompositeReportTableValuesByReportIdsBody: GetCompositeReportTableValuesByReportIdsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompositeReportTableExcel(getCompositeReportTableValuesByReportIdsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompositeReportTableControllerApi.getCompositeReportTableExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 複合表の値を取得する（レポートID指定）
         * @param {GetCompositeReportTableValuesByReportIdsBody} getCompositeReportTableValuesByReportIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValuesByReportIds(getCompositeReportTableValuesByReportIdsBody: GetCompositeReportTableValuesByReportIdsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompositeReportTableValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValuesByReportIds(getCompositeReportTableValuesByReportIdsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompositeReportTableControllerApi.getValuesByReportIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 複合表のレイアウトバリデーションを実行する
         * @param {ValidateCompositeReportTableBody} validateCompositeReportTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validate(validateCompositeReportTableBody: ValidateCompositeReportTableBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validate(validateCompositeReportTableBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompositeReportTableControllerApi.validate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompositeReportTableControllerApi - factory interface
 */
export const CompositeReportTableControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompositeReportTableControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 複合表の表データをExcel形式で出力する
         * @param {GetCompositeReportTableValuesByReportIdsBody} getCompositeReportTableValuesByReportIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompositeReportTableExcel(getCompositeReportTableValuesByReportIdsBody: GetCompositeReportTableValuesByReportIdsBody, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getCompositeReportTableExcel(getCompositeReportTableValuesByReportIdsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 複合表の値を取得する（レポートID指定）
         * @param {GetCompositeReportTableValuesByReportIdsBody} getCompositeReportTableValuesByReportIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValuesByReportIds(getCompositeReportTableValuesByReportIdsBody: GetCompositeReportTableValuesByReportIdsBody, options?: RawAxiosRequestConfig): AxiosPromise<GetCompositeReportTableValuesResponse> {
            return localVarFp.getValuesByReportIds(getCompositeReportTableValuesByReportIdsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 複合表のレイアウトバリデーションを実行する
         * @param {ValidateCompositeReportTableBody} validateCompositeReportTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(validateCompositeReportTableBody: ValidateCompositeReportTableBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.validate(validateCompositeReportTableBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompositeReportTableControllerApi - object-oriented interface
 */
export class CompositeReportTableControllerApi extends BaseAPI {
    /**
     * 
     * @summary 複合表の表データをExcel形式で出力する
     * @param {GetCompositeReportTableValuesByReportIdsBody} getCompositeReportTableValuesByReportIdsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompositeReportTableExcel(getCompositeReportTableValuesByReportIdsBody: GetCompositeReportTableValuesByReportIdsBody, options?: RawAxiosRequestConfig) {
        return CompositeReportTableControllerApiFp(this.configuration).getCompositeReportTableExcel(getCompositeReportTableValuesByReportIdsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 複合表の値を取得する（レポートID指定）
     * @param {GetCompositeReportTableValuesByReportIdsBody} getCompositeReportTableValuesByReportIdsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getValuesByReportIds(getCompositeReportTableValuesByReportIdsBody: GetCompositeReportTableValuesByReportIdsBody, options?: RawAxiosRequestConfig) {
        return CompositeReportTableControllerApiFp(this.configuration).getValuesByReportIds(getCompositeReportTableValuesByReportIdsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 複合表のレイアウトバリデーションを実行する
     * @param {ValidateCompositeReportTableBody} validateCompositeReportTableBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validate(validateCompositeReportTableBody: ValidateCompositeReportTableBody, options?: RawAxiosRequestConfig) {
        return CompositeReportTableControllerApiFp(this.configuration).validate(validateCompositeReportTableBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardControllerApi - axios parameter creator
 */
export const DashboardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary tableauダッシュボード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTableauDashboard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard/tableau`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardControllerApi - functional programming interface
 */
export const DashboardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary tableauダッシュボード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTableauDashboard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TableauDashboardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTableauDashboard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getTableauDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardControllerApi - factory interface
 */
export const DashboardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary tableauダッシュボード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTableauDashboard(options?: RawAxiosRequestConfig): AxiosPromise<TableauDashboardDto> {
            return localVarFp.getTableauDashboard(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardControllerApi - object-oriented interface
 */
export class DashboardControllerApi extends BaseAPI {
    /**
     * 
     * @summary tableauダッシュボード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTableauDashboard(options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getTableauDashboard(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardFolderControllerApi - axios parameter creator
 */
export const DashboardFolderControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary フォルダを新規作成する
         * @param {CreateDashboardFolderBody} createDashboardFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboardFolder: async (createDashboardFolderBody: CreateDashboardFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDashboardFolderBody' is not null or undefined
            assertParamExists('createDashboardFolder', 'createDashboardFolderBody', createDashboardFolderBody)
            const localVarPath = `/api/dashboard_folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDashboardFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダを削除する
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboardFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteDashboardFolder', 'folderId', folderId)
            const localVarPath = `/api/dashboard_folders/{folderId}`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダ内のフォルダ・ダッシュボード一覧を取得する（searchWord指定時は全フォルダ横断検索）
         * @param {string} [folderId] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardFolderDetail: async (folderId?: string, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard_folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダ情報一覧の取得（選択用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardFolderTreeForSelection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboard_folders/for-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダを指定したフォルダへ移動する
         * @param {string} folderId 
         * @param {MoveDashboardFolderBody} moveDashboardFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveDashboardFolder: async (folderId: string, moveDashboardFolderBody: MoveDashboardFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('moveDashboardFolder', 'folderId', folderId)
            // verify required parameter 'moveDashboardFolderBody' is not null or undefined
            assertParamExists('moveDashboardFolder', 'moveDashboardFolderBody', moveDashboardFolderBody)
            const localVarPath = `/api/dashboard_folders/{folderId}/move`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveDashboardFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダの名称を更新する
         * @param {string} folderId 
         * @param {RenameDashboardFolderBody} renameDashboardFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameDashboardFolder: async (folderId: string, renameDashboardFolderBody: RenameDashboardFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('renameDashboardFolder', 'folderId', folderId)
            // verify required parameter 'renameDashboardFolderBody' is not null or undefined
            assertParamExists('renameDashboardFolder', 'renameDashboardFolderBody', renameDashboardFolderBody)
            const localVarPath = `/api/dashboard_folders/{folderId}/name`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameDashboardFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardFolderControllerApi - functional programming interface
 */
export const DashboardFolderControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardFolderControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary フォルダを新規作成する
         * @param {CreateDashboardFolderBody} createDashboardFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDashboardFolder(createDashboardFolderBody: CreateDashboardFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDashboardFolder(createDashboardFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardFolderControllerApi.createDashboardFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダを削除する
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDashboardFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDashboardFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardFolderControllerApi.deleteDashboardFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダ内のフォルダ・ダッシュボード一覧を取得する（searchWord指定時は全フォルダ横断検索）
         * @param {string} [folderId] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardFolderDetail(folderId?: string, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardFolderDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardFolderDetail(folderId, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardFolderControllerApi.getDashboardFolderDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダ情報一覧の取得（選択用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardFolderTreeForSelection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardFolderTreeForSelectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardFolderTreeForSelection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardFolderControllerApi.getDashboardFolderTreeForSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダを指定したフォルダへ移動する
         * @param {string} folderId 
         * @param {MoveDashboardFolderBody} moveDashboardFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveDashboardFolder(folderId: string, moveDashboardFolderBody: MoveDashboardFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveDashboardFolder(folderId, moveDashboardFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardFolderControllerApi.moveDashboardFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダの名称を更新する
         * @param {string} folderId 
         * @param {RenameDashboardFolderBody} renameDashboardFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameDashboardFolder(folderId: string, renameDashboardFolderBody: RenameDashboardFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameDashboardFolder(folderId, renameDashboardFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardFolderControllerApi.renameDashboardFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardFolderControllerApi - factory interface
 */
export const DashboardFolderControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardFolderControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary フォルダを新規作成する
         * @param {CreateDashboardFolderBody} createDashboardFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboardFolder(createDashboardFolderBody: CreateDashboardFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createDashboardFolder(createDashboardFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダを削除する
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboardFolder(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteDashboardFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダ内のフォルダ・ダッシュボード一覧を取得する（searchWord指定時は全フォルダ横断検索）
         * @param {string} [folderId] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardFolderDetail(folderId?: string, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardFolderDetailResponse> {
            return localVarFp.getDashboardFolderDetail(folderId, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダ情報一覧の取得（選択用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardFolderTreeForSelection(options?: RawAxiosRequestConfig): AxiosPromise<DashboardFolderTreeForSelectionResponse> {
            return localVarFp.getDashboardFolderTreeForSelection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダを指定したフォルダへ移動する
         * @param {string} folderId 
         * @param {MoveDashboardFolderBody} moveDashboardFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveDashboardFolder(folderId: string, moveDashboardFolderBody: MoveDashboardFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveDashboardFolder(folderId, moveDashboardFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダの名称を更新する
         * @param {string} folderId 
         * @param {RenameDashboardFolderBody} renameDashboardFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameDashboardFolder(folderId: string, renameDashboardFolderBody: RenameDashboardFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.renameDashboardFolder(folderId, renameDashboardFolderBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardFolderControllerApi - object-oriented interface
 */
export class DashboardFolderControllerApi extends BaseAPI {
    /**
     * 
     * @summary フォルダを新規作成する
     * @param {CreateDashboardFolderBody} createDashboardFolderBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDashboardFolder(createDashboardFolderBody: CreateDashboardFolderBody, options?: RawAxiosRequestConfig) {
        return DashboardFolderControllerApiFp(this.configuration).createDashboardFolder(createDashboardFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダを削除する
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDashboardFolder(folderId: string, options?: RawAxiosRequestConfig) {
        return DashboardFolderControllerApiFp(this.configuration).deleteDashboardFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダ内のフォルダ・ダッシュボード一覧を取得する（searchWord指定時は全フォルダ横断検索）
     * @param {string} [folderId] 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDashboardFolderDetail(folderId?: string, searchWord?: string, options?: RawAxiosRequestConfig) {
        return DashboardFolderControllerApiFp(this.configuration).getDashboardFolderDetail(folderId, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダ情報一覧の取得（選択用）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDashboardFolderTreeForSelection(options?: RawAxiosRequestConfig) {
        return DashboardFolderControllerApiFp(this.configuration).getDashboardFolderTreeForSelection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダを指定したフォルダへ移動する
     * @param {string} folderId 
     * @param {MoveDashboardFolderBody} moveDashboardFolderBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveDashboardFolder(folderId: string, moveDashboardFolderBody: MoveDashboardFolderBody, options?: RawAxiosRequestConfig) {
        return DashboardFolderControllerApiFp(this.configuration).moveDashboardFolder(folderId, moveDashboardFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダの名称を更新する
     * @param {string} folderId 
     * @param {RenameDashboardFolderBody} renameDashboardFolderBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public renameDashboardFolder(folderId: string, renameDashboardFolderBody: RenameDashboardFolderBody, options?: RawAxiosRequestConfig) {
        return DashboardFolderControllerApiFp(this.configuration).renameDashboardFolder(folderId, renameDashboardFolderBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataSourceControllerApi - axios parameter creator
 */
export const DataSourceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary データソース一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDataSources: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/allocation/v2/data-sources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataSourceControllerApi - functional programming interface
 */
export const DataSourceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataSourceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary データソース一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDataSources(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSourceView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDataSources(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.listDataSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataSourceControllerApi - factory interface
 */
export const DataSourceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataSourceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary データソース一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDataSources(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourceView>> {
            return localVarFp.listDataSources(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataSourceControllerApi - object-oriented interface
 */
export class DataSourceControllerApi extends BaseAPI {
    /**
     * 
     * @summary データソース一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDataSources(options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).listDataSources(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepartmentAssignmentControllerApi - axios parameter creator
 */
export const DepartmentAssignmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ユーザー一に紐づく部署を取得
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDepartmentAssignments: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listDepartmentAssignments', 'userId', userId)
            const localVarPath = `/api/user/{userId}/departments/assignments/list`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーの配属を一括更新する
         * @param {string} userId 
         * @param {UpdateAssignmentsParam} updateAssignmentsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignment: async (userId: string, updateAssignmentsParam: UpdateAssignmentsParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateAssignment', 'userId', userId)
            // verify required parameter 'updateAssignmentsParam' is not null or undefined
            assertParamExists('updateAssignment', 'updateAssignmentsParam', updateAssignmentsParam)
            const localVarPath = `/api/user/{userId}/departments/assignments`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssignmentsParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentAssignmentControllerApi - functional programming interface
 */
export const DepartmentAssignmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentAssignmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ユーザー一に紐づく部署を取得
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDepartmentAssignments(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignedDepartmentFlattenView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDepartmentAssignments(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentAssignmentControllerApi.listDepartmentAssignments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザーの配属を一括更新する
         * @param {string} userId 
         * @param {UpdateAssignmentsParam} updateAssignmentsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssignment(userId: string, updateAssignmentsParam: UpdateAssignmentsParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssignment(userId, updateAssignmentsParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentAssignmentControllerApi.updateAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DepartmentAssignmentControllerApi - factory interface
 */
export const DepartmentAssignmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentAssignmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ユーザー一に紐づく部署を取得
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDepartmentAssignments(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignedDepartmentFlattenView>> {
            return localVarFp.listDepartmentAssignments(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーの配属を一括更新する
         * @param {string} userId 
         * @param {UpdateAssignmentsParam} updateAssignmentsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignment(userId: string, updateAssignmentsParam: UpdateAssignmentsParam, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateAssignment(userId, updateAssignmentsParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentAssignmentControllerApi - object-oriented interface
 */
export class DepartmentAssignmentControllerApi extends BaseAPI {
    /**
     * 
     * @summary ユーザー一に紐づく部署を取得
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDepartmentAssignments(userId: string, options?: RawAxiosRequestConfig) {
        return DepartmentAssignmentControllerApiFp(this.configuration).listDepartmentAssignments(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーの配属を一括更新する
     * @param {string} userId 
     * @param {UpdateAssignmentsParam} updateAssignmentsParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAssignment(userId: string, updateAssignmentsParam: UpdateAssignmentsParam, options?: RawAxiosRequestConfig) {
        return DepartmentAssignmentControllerApiFp(this.configuration).updateAssignment(userId, updateAssignmentsParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepartmentComparisonSheetSelectedConditionControllerApi - axios parameter creator
 */
export const DepartmentComparisonSheetSelectedConditionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 部署別対比表選択条件の作成
         * @param {CreateDepartmentComparisonSheetSelectedConditionRequestBody} createDepartmentComparisonSheetSelectedConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartmentComparisonSheetSelectedCondition: async (createDepartmentComparisonSheetSelectedConditionRequestBody: CreateDepartmentComparisonSheetSelectedConditionRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDepartmentComparisonSheetSelectedConditionRequestBody' is not null or undefined
            assertParamExists('createDepartmentComparisonSheetSelectedCondition', 'createDepartmentComparisonSheetSelectedConditionRequestBody', createDepartmentComparisonSheetSelectedConditionRequestBody)
            const localVarPath = `/api/department-comparison-sheet-selected-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepartmentComparisonSheetSelectedConditionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署別対比表選択条件保存の削除
         * @param {string} departmentComparisonSheetSelectedConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepartmentComparisonSheetSelectedCondition: async (departmentComparisonSheetSelectedConditionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentComparisonSheetSelectedConditionId' is not null or undefined
            assertParamExists('deleteDepartmentComparisonSheetSelectedCondition', 'departmentComparisonSheetSelectedConditionId', departmentComparisonSheetSelectedConditionId)
            const localVarPath = `/api/department-comparison-sheet-selected-conditions/{departmentComparisonSheetSelectedConditionId}`
                .replace('{departmentComparisonSheetSelectedConditionId}', encodeURIComponent(String(departmentComparisonSheetSelectedConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署別対比表選択条件一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDepartmentComparisonSheetSelectedCondition: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/department-comparison-sheet-selected-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentComparisonSheetSelectedConditionControllerApi - functional programming interface
 */
export const DepartmentComparisonSheetSelectedConditionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentComparisonSheetSelectedConditionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 部署別対比表選択条件の作成
         * @param {CreateDepartmentComparisonSheetSelectedConditionRequestBody} createDepartmentComparisonSheetSelectedConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDepartmentComparisonSheetSelectedCondition(createDepartmentComparisonSheetSelectedConditionRequestBody: CreateDepartmentComparisonSheetSelectedConditionRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDepartmentComparisonSheetSelectedConditionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDepartmentComparisonSheetSelectedCondition(createDepartmentComparisonSheetSelectedConditionRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentComparisonSheetSelectedConditionControllerApi.createDepartmentComparisonSheetSelectedCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署別対比表選択条件保存の削除
         * @param {string} departmentComparisonSheetSelectedConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDepartmentComparisonSheetSelectedCondition(departmentComparisonSheetSelectedConditionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDepartmentComparisonSheetSelectedCondition(departmentComparisonSheetSelectedConditionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentComparisonSheetSelectedConditionControllerApi.deleteDepartmentComparisonSheetSelectedCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署別対比表選択条件一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDepartmentComparisonSheetSelectedCondition(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentComparisonSheetSelectedConditionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDepartmentComparisonSheetSelectedCondition(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentComparisonSheetSelectedConditionControllerApi.listDepartmentComparisonSheetSelectedCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DepartmentComparisonSheetSelectedConditionControllerApi - factory interface
 */
export const DepartmentComparisonSheetSelectedConditionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentComparisonSheetSelectedConditionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 部署別対比表選択条件の作成
         * @param {CreateDepartmentComparisonSheetSelectedConditionRequestBody} createDepartmentComparisonSheetSelectedConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartmentComparisonSheetSelectedCondition(createDepartmentComparisonSheetSelectedConditionRequestBody: CreateDepartmentComparisonSheetSelectedConditionRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreateDepartmentComparisonSheetSelectedConditionResponse> {
            return localVarFp.createDepartmentComparisonSheetSelectedCondition(createDepartmentComparisonSheetSelectedConditionRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署別対比表選択条件保存の削除
         * @param {string} departmentComparisonSheetSelectedConditionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepartmentComparisonSheetSelectedCondition(departmentComparisonSheetSelectedConditionId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteDepartmentComparisonSheetSelectedCondition(departmentComparisonSheetSelectedConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署別対比表選択条件一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDepartmentComparisonSheetSelectedCondition(options?: RawAxiosRequestConfig): AxiosPromise<Array<DepartmentComparisonSheetSelectedConditionDto>> {
            return localVarFp.listDepartmentComparisonSheetSelectedCondition(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentComparisonSheetSelectedConditionControllerApi - object-oriented interface
 */
export class DepartmentComparisonSheetSelectedConditionControllerApi extends BaseAPI {
    /**
     * 
     * @summary 部署別対比表選択条件の作成
     * @param {CreateDepartmentComparisonSheetSelectedConditionRequestBody} createDepartmentComparisonSheetSelectedConditionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDepartmentComparisonSheetSelectedCondition(createDepartmentComparisonSheetSelectedConditionRequestBody: CreateDepartmentComparisonSheetSelectedConditionRequestBody, options?: RawAxiosRequestConfig) {
        return DepartmentComparisonSheetSelectedConditionControllerApiFp(this.configuration).createDepartmentComparisonSheetSelectedCondition(createDepartmentComparisonSheetSelectedConditionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署別対比表選択条件保存の削除
     * @param {string} departmentComparisonSheetSelectedConditionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDepartmentComparisonSheetSelectedCondition(departmentComparisonSheetSelectedConditionId: string, options?: RawAxiosRequestConfig) {
        return DepartmentComparisonSheetSelectedConditionControllerApiFp(this.configuration).deleteDepartmentComparisonSheetSelectedCondition(departmentComparisonSheetSelectedConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署別対比表選択条件一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDepartmentComparisonSheetSelectedCondition(options?: RawAxiosRequestConfig) {
        return DepartmentComparisonSheetSelectedConditionControllerApiFp(this.configuration).listDepartmentComparisonSheetSelectedCondition(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepartmentControllerApi - axios parameter creator
 */
export const DepartmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 部署情報の作成
         * @param {CreateDepartmentParam} createDepartmentParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment: async (createDepartmentParam: CreateDepartmentParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDepartmentParam' is not null or undefined
            assertParamExists('createDepartment', 'createDepartmentParam', createDepartmentParam)
            const localVarPath = `/api/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepartmentParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署削除
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepartment: async (departmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('deleteDepartment', 'departmentId', departmentId)
            const localVarPath = `/api/departments/{departmentId}`
                .replace('{departmentId}', encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署情報とその部署に配属されたユーザー情報を合わせて取得する
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDepartmentWithAssignedActiveUsers: async (departmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findDepartmentWithAssignedActiveUsers', 'departmentId', departmentId)
            const localVarPath = `/api/departments/{departmentId}`
                .replace('{departmentId}', encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDepartments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定部署に配属されていないユーザー一覧を取得する
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnassignedActiveUsers: async (departmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('listUnassignedActiveUsers', 'departmentId', departmentId)
            const localVarPath = `/api/departments/{departmentId}/unassigned`
                .replace('{departmentId}', encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署情報と配属の更新
         * @param {string} departmentId 
         * @param {UpdateDepartmentParam} updateDepartmentParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartment: async (departmentId: string, updateDepartmentParam: UpdateDepartmentParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('updateDepartment', 'departmentId', departmentId)
            // verify required parameter 'updateDepartmentParam' is not null or undefined
            assertParamExists('updateDepartment', 'updateDepartmentParam', updateDepartmentParam)
            const localVarPath = `/api/departments/{departmentId}`
                .replace('{departmentId}', encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepartmentParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentControllerApi - functional programming interface
 */
export const DepartmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 部署情報の作成
         * @param {CreateDepartmentParam} createDepartmentParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDepartment(createDepartmentParam: CreateDepartmentParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDepartment(createDepartmentParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.createDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署削除
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDepartment(departmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDepartment(departmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.deleteDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署情報とその部署に配属されたユーザー情報を合わせて取得する
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDepartmentWithAssignedActiveUsers(departmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentWithAssignedActiveUsersView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findDepartmentWithAssignedActiveUsers(departmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.findDepartmentWithAssignedActiveUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDepartments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDepartments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.listDepartments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定部署に配属されていないユーザー一覧を取得する
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUnassignedActiveUsers(departmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListUnassignedActiveUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUnassignedActiveUsers(departmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.listUnassignedActiveUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署情報と配属の更新
         * @param {string} departmentId 
         * @param {UpdateDepartmentParam} updateDepartmentParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDepartment(departmentId: string, updateDepartmentParam: UpdateDepartmentParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentWithAssignmentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDepartment(departmentId, updateDepartmentParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepartmentControllerApi.updateDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DepartmentControllerApi - factory interface
 */
export const DepartmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 部署情報の作成
         * @param {CreateDepartmentParam} createDepartmentParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepartment(createDepartmentParam: CreateDepartmentParam, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createDepartment(createDepartmentParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署削除
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepartment(departmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteDepartment(departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署情報とその部署に配属されたユーザー情報を合わせて取得する
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDepartmentWithAssignedActiveUsers(departmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentWithAssignedActiveUsersView> {
            return localVarFp.findDepartmentWithAssignedActiveUsers(departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDepartments(options?: RawAxiosRequestConfig): AxiosPromise<DepartmentsView> {
            return localVarFp.listDepartments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定部署に配属されていないユーザー一覧を取得する
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnassignedActiveUsers(departmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ListUnassignedActiveUserDto>> {
            return localVarFp.listUnassignedActiveUsers(departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署情報と配属の更新
         * @param {string} departmentId 
         * @param {UpdateDepartmentParam} updateDepartmentParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepartment(departmentId: string, updateDepartmentParam: UpdateDepartmentParam, options?: RawAxiosRequestConfig): AxiosPromise<DepartmentWithAssignmentView> {
            return localVarFp.updateDepartment(departmentId, updateDepartmentParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentControllerApi - object-oriented interface
 */
export class DepartmentControllerApi extends BaseAPI {
    /**
     * 
     * @summary 部署情報の作成
     * @param {CreateDepartmentParam} createDepartmentParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDepartment(createDepartmentParam: CreateDepartmentParam, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).createDepartment(createDepartmentParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署削除
     * @param {string} departmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDepartment(departmentId: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).deleteDepartment(departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署情報とその部署に配属されたユーザー情報を合わせて取得する
     * @param {string} departmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findDepartmentWithAssignedActiveUsers(departmentId: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).findDepartmentWithAssignedActiveUsers(departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDepartments(options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).listDepartments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定部署に配属されていないユーザー一覧を取得する
     * @param {string} departmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listUnassignedActiveUsers(departmentId: string, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).listUnassignedActiveUsers(departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署情報と配属の更新
     * @param {string} departmentId 
     * @param {UpdateDepartmentParam} updateDepartmentParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDepartment(departmentId: string, updateDepartmentParam: UpdateDepartmentParam, options?: RawAxiosRequestConfig) {
        return DepartmentControllerApiFp(this.configuration).updateDepartment(departmentId, updateDepartmentParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeprecatedSimulatingWorkforceSlotControllerApi - axios parameter creator
 */
export const DeprecatedSimulatingWorkforceSlotControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} simulationId 
         * @param {WorkforceSimulationSlotBody} workforceSimulationSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforceSimulatingSlot: async (simulationId: string, workforceSimulationSlotBody: WorkforceSimulationSlotBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('createWorkforceSimulatingSlot', 'simulationId', simulationId)
            // verify required parameter 'workforceSimulationSlotBody' is not null or undefined
            assertParamExists('createWorkforceSimulatingSlot', 'workforceSimulationSlotBody', workforceSimulationSlotBody)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/simulating-slots/create`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workforceSimulationSlotBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceSimulatingSlot: async (simulationId: string, simulatingSlotId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deleteWorkforceSimulatingSlot', 'simulationId', simulationId)
            // verify required parameter 'simulatingSlotId' is not null or undefined
            assertParamExists('deleteWorkforceSimulatingSlot', 'simulatingSlotId', simulatingSlotId)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/simulating-slots/{simulatingSlotId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)))
                .replace('{simulatingSlotId}', encodeURIComponent(String(simulatingSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {SimulatingWorkforceSlotBody} simulatingWorkforceSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatingSlots: async (simulationId: string, simulatingWorkforceSlotBody: SimulatingWorkforceSlotBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulatingSlots', 'simulationId', simulationId)
            // verify required parameter 'simulatingWorkforceSlotBody' is not null or undefined
            assertParamExists('getSimulatingSlots', 'simulatingWorkforceSlotBody', simulatingWorkforceSlotBody)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/simulating-slots`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulatingWorkforceSlotBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {UpdateWorkforceSimulationSlotBody} updateWorkforceSimulationSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforceSimulatingSlot: async (simulationId: string, simulatingSlotId: string, updateWorkforceSimulationSlotBody: UpdateWorkforceSimulationSlotBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateWorkforceSimulatingSlot', 'simulationId', simulationId)
            // verify required parameter 'simulatingSlotId' is not null or undefined
            assertParamExists('updateWorkforceSimulatingSlot', 'simulatingSlotId', simulatingSlotId)
            // verify required parameter 'updateWorkforceSimulationSlotBody' is not null or undefined
            assertParamExists('updateWorkforceSimulatingSlot', 'updateWorkforceSimulationSlotBody', updateWorkforceSimulationSlotBody)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/simulating-slots/{simulatingSlotId}/update`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)))
                .replace('{simulatingSlotId}', encodeURIComponent(String(simulatingSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkforceSimulationSlotBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeprecatedSimulatingWorkforceSlotControllerApi - functional programming interface
 */
export const DeprecatedSimulatingWorkforceSlotControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeprecatedSimulatingWorkforceSlotControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} simulationId 
         * @param {WorkforceSimulationSlotBody} workforceSimulationSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkforceSimulatingSlot(simulationId: string, workforceSimulationSlotBody: WorkforceSimulationSlotBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkforceSimulatingSlot(simulationId, workforceSimulationSlotBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedSimulatingWorkforceSlotControllerApi.createWorkforceSimulatingSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkforceSimulatingSlot(simulationId: string, simulatingSlotId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkforceSimulatingSlot(simulationId, simulatingSlotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedSimulatingWorkforceSlotControllerApi.deleteWorkforceSimulatingSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {SimulatingWorkforceSlotBody} simulatingWorkforceSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulatingSlots(simulationId: string, simulatingWorkforceSlotBody: SimulatingWorkforceSlotBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeprecatedSimulatingWorkforceSlotListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulatingSlots(simulationId, simulatingWorkforceSlotBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedSimulatingWorkforceSlotControllerApi.getSimulatingSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {UpdateWorkforceSimulationSlotBody} updateWorkforceSimulationSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkforceSimulatingSlot(simulationId: string, simulatingSlotId: string, updateWorkforceSimulationSlotBody: UpdateWorkforceSimulationSlotBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkforceSimulatingSlot(simulationId, simulatingSlotId, updateWorkforceSimulationSlotBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedSimulatingWorkforceSlotControllerApi.updateWorkforceSimulatingSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeprecatedSimulatingWorkforceSlotControllerApi - factory interface
 */
export const DeprecatedSimulatingWorkforceSlotControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeprecatedSimulatingWorkforceSlotControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} simulationId 
         * @param {WorkforceSimulationSlotBody} workforceSimulationSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforceSimulatingSlot(simulationId: string, workforceSimulationSlotBody: WorkforceSimulationSlotBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createWorkforceSimulatingSlot(simulationId, workforceSimulationSlotBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceSimulatingSlot(simulationId: string, simulatingSlotId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWorkforceSimulatingSlot(simulationId, simulatingSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {SimulatingWorkforceSlotBody} simulatingWorkforceSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatingSlots(simulationId: string, simulatingWorkforceSlotBody: SimulatingWorkforceSlotBody, options?: RawAxiosRequestConfig): AxiosPromise<DeprecatedSimulatingWorkforceSlotListView> {
            return localVarFp.getSimulatingSlots(simulationId, simulatingWorkforceSlotBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {UpdateWorkforceSimulationSlotBody} updateWorkforceSimulationSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforceSimulatingSlot(simulationId: string, simulatingSlotId: string, updateWorkforceSimulationSlotBody: UpdateWorkforceSimulationSlotBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateWorkforceSimulatingSlot(simulationId, simulatingSlotId, updateWorkforceSimulationSlotBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeprecatedSimulatingWorkforceSlotControllerApi - object-oriented interface
 */
export class DeprecatedSimulatingWorkforceSlotControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} simulationId 
     * @param {WorkforceSimulationSlotBody} workforceSimulationSlotBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createWorkforceSimulatingSlot(simulationId: string, workforceSimulationSlotBody: WorkforceSimulationSlotBody, options?: RawAxiosRequestConfig) {
        return DeprecatedSimulatingWorkforceSlotControllerApiFp(this.configuration).createWorkforceSimulatingSlot(simulationId, workforceSimulationSlotBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {string} simulatingSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWorkforceSimulatingSlot(simulationId: string, simulatingSlotId: string, options?: RawAxiosRequestConfig) {
        return DeprecatedSimulatingWorkforceSlotControllerApiFp(this.configuration).deleteWorkforceSimulatingSlot(simulationId, simulatingSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {SimulatingWorkforceSlotBody} simulatingWorkforceSlotBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulatingSlots(simulationId: string, simulatingWorkforceSlotBody: SimulatingWorkforceSlotBody, options?: RawAxiosRequestConfig) {
        return DeprecatedSimulatingWorkforceSlotControllerApiFp(this.configuration).getSimulatingSlots(simulationId, simulatingWorkforceSlotBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {string} simulatingSlotId 
     * @param {UpdateWorkforceSimulationSlotBody} updateWorkforceSimulationSlotBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWorkforceSimulatingSlot(simulationId: string, simulatingSlotId: string, updateWorkforceSimulationSlotBody: UpdateWorkforceSimulationSlotBody, options?: RawAxiosRequestConfig) {
        return DeprecatedSimulatingWorkforceSlotControllerApiFp(this.configuration).updateWorkforceSimulatingSlot(simulationId, simulatingSlotId, updateWorkforceSimulationSlotBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeprecatedWorkforcePlanningSimulationControllerApi - axios parameter creator
 */
export const DeprecatedWorkforcePlanningSimulationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} simulationId 
         * @param {AssignSimulationConversionRulesetBody} assignSimulationConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignConversionRuleset: async (simulationId: string, assignSimulationConversionRulesetBody: AssignSimulationConversionRulesetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('assignConversionRuleset', 'simulationId', simulationId)
            // verify required parameter 'assignSimulationConversionRulesetBody' is not null or undefined
            assertParamExists('assignConversionRuleset', 'assignSimulationConversionRulesetBody', assignSimulationConversionRulesetBody)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/conversion-ruleset`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignSimulationConversionRulesetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSimulatingWorkforceSlot: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('cancelSimulatingWorkforceSlot', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/editing-start`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSimulation: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deleteSimulation', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeprecatedCreateSimulationBody} deprecatedCreateSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecatedCreateSimulation: async (deprecatedCreateSimulationBody: DeprecatedCreateSimulationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deprecatedCreateSimulationBody' is not null or undefined
            assertParamExists('deprecatedCreateSimulation', 'deprecatedCreateSimulationBody', deprecatedCreateSimulationBody)
            const localVarPath = `/api/workforce-plannings/simulations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deprecatedCreateSimulationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecatedGetUsingDimensions: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deprecatedGetUsingDimensions', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/using-dimensions`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecatedListSimulations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-plannings/simulations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editingStartSimulation: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('editingStartSimulation', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/editing-start`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationDetail: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulationDetail', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/detail`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} plAccountTreeId 
         * @param {SimulationWorkforcePlanningBody} simulationWorkforcePlanningBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationPL: async (simulationId: string, plAccountTreeId: string, simulationWorkforcePlanningBody: SimulationWorkforcePlanningBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulationPL', 'simulationId', simulationId)
            // verify required parameter 'plAccountTreeId' is not null or undefined
            assertParamExists('getSimulationPL', 'plAccountTreeId', plAccountTreeId)
            // verify required parameter 'simulationWorkforcePlanningBody' is not null or undefined
            assertParamExists('getSimulationPL', 'simulationWorkforcePlanningBody', simulationWorkforcePlanningBody)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/pl/{plAccountTreeId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)))
                .replace('{plAccountTreeId}', encodeURIComponent(String(plAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulationWorkforcePlanningBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {SimulationWorkforcePlanningBody} simulationWorkforcePlanningBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationWorkforcePlanning: async (simulationId: string, simulationWorkforcePlanningBody: SimulationWorkforcePlanningBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulationWorkforcePlanning', 'simulationId', simulationId)
            // verify required parameter 'simulationWorkforcePlanningBody' is not null or undefined
            assertParamExists('getSimulationWorkforcePlanning', 'simulationWorkforcePlanningBody', simulationWorkforcePlanningBody)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/workforce-planning`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulationWorkforcePlanningBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetDepartmentIds: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getTargetDepartmentIds', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/target-departments`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSimulationDetail: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('saveSimulationDetail', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/detail`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {UpdateSimulationBody} updateSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimulation: async (simulationId: string, updateSimulationBody: UpdateSimulationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateSimulation', 'simulationId', simulationId)
            // verify required parameter 'updateSimulationBody' is not null or undefined
            assertParamExists('updateSimulation', 'updateSimulationBody', updateSimulationBody)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSimulationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeprecatedWorkforcePlanningSimulationControllerApi - functional programming interface
 */
export const DeprecatedWorkforcePlanningSimulationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeprecatedWorkforcePlanningSimulationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} simulationId 
         * @param {AssignSimulationConversionRulesetBody} assignSimulationConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignConversionRuleset(simulationId: string, assignSimulationConversionRulesetBody: AssignSimulationConversionRulesetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignConversionRuleset(simulationId, assignSimulationConversionRulesetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.assignConversionRuleset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSimulatingWorkforceSlot(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSimulatingWorkforceSlot(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.cancelSimulatingWorkforceSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSimulation(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSimulation(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.deleteSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeprecatedCreateSimulationBody} deprecatedCreateSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deprecatedCreateSimulation(deprecatedCreateSimulationBody: DeprecatedCreateSimulationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeprecatedCreatedSimulationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deprecatedCreateSimulation(deprecatedCreateSimulationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.deprecatedCreateSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deprecatedGetUsingDimensions(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchWorkforcePlanningSimulationUsingDimensionUseCaseReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deprecatedGetUsingDimensions(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.deprecatedGetUsingDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deprecatedListSimulations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeprecatedListSimulationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deprecatedListSimulations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.deprecatedListSimulations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editingStartSimulation(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editingStartSimulation(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.editingStartSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulationDetail(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningSimulationMetaView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulationDetail(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.getSimulationDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} plAccountTreeId 
         * @param {SimulationWorkforcePlanningBody} simulationWorkforcePlanningBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulationPL(simulationId: string, plAccountTreeId: string, simulationWorkforcePlanningBody: SimulationWorkforcePlanningBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulationPLTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulationPL(simulationId, plAccountTreeId, simulationWorkforcePlanningBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.getSimulationPL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {SimulationWorkforcePlanningBody} simulationWorkforcePlanningBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulationWorkforcePlanning(simulationId: string, simulationWorkforcePlanningBody: SimulationWorkforcePlanningBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningSimulationCalculateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulationWorkforcePlanning(simulationId, simulationWorkforcePlanningBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.getSimulationWorkforcePlanning']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTargetDepartmentIds(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenWorkforcePlanUpdateRequestTargetDepartments>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTargetDepartmentIds(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.getTargetDepartmentIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSimulationDetail(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSimulationDetail(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.saveSimulationDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {UpdateSimulationBody} updateSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSimulation(simulationId: string, updateSimulationBody: UpdateSimulationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSimulation(simulationId, updateSimulationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeprecatedWorkforcePlanningSimulationControllerApi.updateSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeprecatedWorkforcePlanningSimulationControllerApi - factory interface
 */
export const DeprecatedWorkforcePlanningSimulationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeprecatedWorkforcePlanningSimulationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} simulationId 
         * @param {AssignSimulationConversionRulesetBody} assignSimulationConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignConversionRuleset(simulationId: string, assignSimulationConversionRulesetBody: AssignSimulationConversionRulesetBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.assignConversionRuleset(simulationId, assignSimulationConversionRulesetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSimulatingWorkforceSlot(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.cancelSimulatingWorkforceSlot(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSimulation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSimulation(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeprecatedCreateSimulationBody} deprecatedCreateSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecatedCreateSimulation(deprecatedCreateSimulationBody: DeprecatedCreateSimulationBody, options?: RawAxiosRequestConfig): AxiosPromise<DeprecatedCreatedSimulationView> {
            return localVarFp.deprecatedCreateSimulation(deprecatedCreateSimulationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecatedGetUsingDimensions(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchWorkforcePlanningSimulationUsingDimensionUseCaseReturn> {
            return localVarFp.deprecatedGetUsingDimensions(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprecatedListSimulations(options?: RawAxiosRequestConfig): AxiosPromise<DeprecatedListSimulationView> {
            return localVarFp.deprecatedListSimulations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editingStartSimulation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.editingStartSimulation(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationDetail(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningSimulationMetaView> {
            return localVarFp.getSimulationDetail(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} plAccountTreeId 
         * @param {SimulationWorkforcePlanningBody} simulationWorkforcePlanningBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationPL(simulationId: string, plAccountTreeId: string, simulationWorkforcePlanningBody: SimulationWorkforcePlanningBody, options?: RawAxiosRequestConfig): AxiosPromise<SimulationPLTableView> {
            return localVarFp.getSimulationPL(simulationId, plAccountTreeId, simulationWorkforcePlanningBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {SimulationWorkforcePlanningBody} simulationWorkforcePlanningBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationWorkforcePlanning(simulationId: string, simulationWorkforcePlanningBody: SimulationWorkforcePlanningBody, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningSimulationCalculateResult> {
            return localVarFp.getSimulationWorkforcePlanning(simulationId, simulationWorkforcePlanningBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetDepartmentIds(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OpenWorkforcePlanUpdateRequestTargetDepartments> {
            return localVarFp.getTargetDepartmentIds(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSimulationDetail(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.saveSimulationDetail(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {UpdateSimulationBody} updateSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimulation(simulationId: string, updateSimulationBody: UpdateSimulationBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSimulation(simulationId, updateSimulationBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeprecatedWorkforcePlanningSimulationControllerApi - object-oriented interface
 */
export class DeprecatedWorkforcePlanningSimulationControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} simulationId 
     * @param {AssignSimulationConversionRulesetBody} assignSimulationConversionRulesetBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignConversionRuleset(simulationId: string, assignSimulationConversionRulesetBody: AssignSimulationConversionRulesetBody, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).assignConversionRuleset(simulationId, assignSimulationConversionRulesetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelSimulatingWorkforceSlot(simulationId: string, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).cancelSimulatingWorkforceSlot(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSimulation(simulationId: string, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).deleteSimulation(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeprecatedCreateSimulationBody} deprecatedCreateSimulationBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecatedCreateSimulation(deprecatedCreateSimulationBody: DeprecatedCreateSimulationBody, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).deprecatedCreateSimulation(deprecatedCreateSimulationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecatedGetUsingDimensions(simulationId: string, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).deprecatedGetUsingDimensions(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deprecatedListSimulations(options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).deprecatedListSimulations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editingStartSimulation(simulationId: string, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).editingStartSimulation(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulationDetail(simulationId: string, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).getSimulationDetail(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {string} plAccountTreeId 
     * @param {SimulationWorkforcePlanningBody} simulationWorkforcePlanningBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulationPL(simulationId: string, plAccountTreeId: string, simulationWorkforcePlanningBody: SimulationWorkforcePlanningBody, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).getSimulationPL(simulationId, plAccountTreeId, simulationWorkforcePlanningBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {SimulationWorkforcePlanningBody} simulationWorkforcePlanningBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulationWorkforcePlanning(simulationId: string, simulationWorkforcePlanningBody: SimulationWorkforcePlanningBody, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).getSimulationWorkforcePlanning(simulationId, simulationWorkforcePlanningBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTargetDepartmentIds(simulationId: string, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).getTargetDepartmentIds(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveSimulationDetail(simulationId: string, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).saveSimulationDetail(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {UpdateSimulationBody} updateSimulationBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSimulation(simulationId: string, updateSimulationBody: UpdateSimulationBody, options?: RawAxiosRequestConfig) {
        return DeprecatedWorkforcePlanningSimulationControllerApiFp(this.configuration).updateSimulation(simulationId, updateSimulationBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DimensionTagControllerApi - axios parameter creator
 */
export const DimensionTagControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 分析軸タグの作成
         * @param {CreateDimensionTagsRequestBody} createDimensionTagsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTags: async (createDimensionTagsRequestBody: CreateDimensionTagsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDimensionTagsRequestBody' is not null or undefined
            assertParamExists('createTags', 'createDimensionTagsRequestBody', createDimensionTagsRequestBody)
            const localVarPath = `/api/dimension-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDimensionTagsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸タグの削除
         * @param {string} dimensionTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDimensionTag: async (dimensionTagId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionTagId' is not null or undefined
            assertParamExists('deleteDimensionTag', 'dimensionTagId', dimensionTagId)
            const localVarPath = `/api/dimension-tags/{dimensionTagId}`
                .replace('{dimensionTagId}', encodeURIComponent(String(dimensionTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸タグIDから分析軸タグを取得
         * @param {string} dimensionTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionTag: async (dimensionTagId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionTagId' is not null or undefined
            assertParamExists('getDimensionTag', 'dimensionTagId', dimensionTagId)
            const localVarPath = `/api/dimension-tags/{dimensionTagId}`
                .replace('{dimensionTagId}', encodeURIComponent(String(dimensionTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸タグの更新
         * @param {string} dimensionTagId 
         * @param {UpdateDimensionTagsRequestBody} updateDimensionTagsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDimensionTag: async (dimensionTagId: string, updateDimensionTagsRequestBody: UpdateDimensionTagsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionTagId' is not null or undefined
            assertParamExists('updateDimensionTag', 'dimensionTagId', dimensionTagId)
            // verify required parameter 'updateDimensionTagsRequestBody' is not null or undefined
            assertParamExists('updateDimensionTag', 'updateDimensionTagsRequestBody', updateDimensionTagsRequestBody)
            const localVarPath = `/api/dimension-tags/{dimensionTagId}`
                .replace('{dimensionTagId}', encodeURIComponent(String(dimensionTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDimensionTagsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DimensionTagControllerApi - functional programming interface
 */
export const DimensionTagControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DimensionTagControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 分析軸タグの作成
         * @param {CreateDimensionTagsRequestBody} createDimensionTagsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTags(createDimensionTagsRequestBody: CreateDimensionTagsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTags(createDimensionTagsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTagControllerApi.createTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸タグの削除
         * @param {string} dimensionTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDimensionTag(dimensionTagId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDimensionTag(dimensionTagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTagControllerApi.deleteDimensionTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸タグIDから分析軸タグを取得
         * @param {string} dimensionTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDimensionTag(dimensionTagId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DimensionTagView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDimensionTag(dimensionTagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTagControllerApi.getDimensionTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸タグの更新
         * @param {string} dimensionTagId 
         * @param {UpdateDimensionTagsRequestBody} updateDimensionTagsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDimensionTag(dimensionTagId: string, updateDimensionTagsRequestBody: UpdateDimensionTagsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDimensionTag(dimensionTagId, updateDimensionTagsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTagControllerApi.updateDimensionTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DimensionTagControllerApi - factory interface
 */
export const DimensionTagControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DimensionTagControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 分析軸タグの作成
         * @param {CreateDimensionTagsRequestBody} createDimensionTagsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTags(createDimensionTagsRequestBody: CreateDimensionTagsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createTags(createDimensionTagsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸タグの削除
         * @param {string} dimensionTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDimensionTag(dimensionTagId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteDimensionTag(dimensionTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸タグIDから分析軸タグを取得
         * @param {string} dimensionTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionTag(dimensionTagId: string, options?: RawAxiosRequestConfig): AxiosPromise<DimensionTagView> {
            return localVarFp.getDimensionTag(dimensionTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸タグの更新
         * @param {string} dimensionTagId 
         * @param {UpdateDimensionTagsRequestBody} updateDimensionTagsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDimensionTag(dimensionTagId: string, updateDimensionTagsRequestBody: UpdateDimensionTagsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateDimensionTag(dimensionTagId, updateDimensionTagsRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DimensionTagControllerApi - object-oriented interface
 */
export class DimensionTagControllerApi extends BaseAPI {
    /**
     * 
     * @summary 分析軸タグの作成
     * @param {CreateDimensionTagsRequestBody} createDimensionTagsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTags(createDimensionTagsRequestBody: CreateDimensionTagsRequestBody, options?: RawAxiosRequestConfig) {
        return DimensionTagControllerApiFp(this.configuration).createTags(createDimensionTagsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸タグの削除
     * @param {string} dimensionTagId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDimensionTag(dimensionTagId: string, options?: RawAxiosRequestConfig) {
        return DimensionTagControllerApiFp(this.configuration).deleteDimensionTag(dimensionTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸タグIDから分析軸タグを取得
     * @param {string} dimensionTagId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDimensionTag(dimensionTagId: string, options?: RawAxiosRequestConfig) {
        return DimensionTagControllerApiFp(this.configuration).getDimensionTag(dimensionTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸タグの更新
     * @param {string} dimensionTagId 
     * @param {UpdateDimensionTagsRequestBody} updateDimensionTagsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDimensionTag(dimensionTagId: string, updateDimensionTagsRequestBody: UpdateDimensionTagsRequestBody, options?: RawAxiosRequestConfig) {
        return DimensionTagControllerApiFp(this.configuration).updateDimensionTag(dimensionTagId, updateDimensionTagsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DimensionTreeControllerApi - axios parameter creator
 */
export const DimensionTreeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 分析軸階層に分析軸タグを追加するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {AddDimensionTreeNodeRequestBody} addDimensionTreeNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDimensionTreeNode: async (dimensionId: string, dimensionTreeId: string, addDimensionTreeNodeRequestBody: AddDimensionTreeNodeRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('addDimensionTreeNode', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('addDimensionTreeNode', 'dimensionTreeId', dimensionTreeId)
            // verify required parameter 'addDimensionTreeNodeRequestBody' is not null or undefined
            assertParamExists('addDimensionTreeNode', 'addDimensionTreeNodeRequestBody', addDimensionTreeNodeRequestBody)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/add`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDimensionTreeNodeRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸階層をコピーするAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {CopyDimensionTreeBody} copyDimensionTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyDimensionTree: async (dimensionId: string, dimensionTreeId: string, copyDimensionTreeBody: CopyDimensionTreeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('copyDimensionTree', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('copyDimensionTree', 'dimensionTreeId', dimensionTreeId)
            // verify required parameter 'copyDimensionTreeBody' is not null or undefined
            assertParamExists('copyDimensionTree', 'copyDimensionTreeBody', copyDimensionTreeBody)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/make-copy`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyDimensionTreeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸タグを作成し、分析軸階層に分析軸タグを追加するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {CreateAndAddDimensionTagsRequestBody} createAndAddDimensionTagsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndAddDimensionTreeNode: async (dimensionId: string, dimensionTreeId: string, createAndAddDimensionTagsRequestBody: CreateAndAddDimensionTagsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('createAndAddDimensionTreeNode', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('createAndAddDimensionTreeNode', 'dimensionTreeId', dimensionTreeId)
            // verify required parameter 'createAndAddDimensionTagsRequestBody' is not null or undefined
            assertParamExists('createAndAddDimensionTreeNode', 'createAndAddDimensionTagsRequestBody', createAndAddDimensionTagsRequestBody)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/create-and-add-tree`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAndAddDimensionTagsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸階層を削除するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDimensionTree: async (dimensionId: string, dimensionTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('deleteDimensionTree', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('deleteDimensionTree', 'dimensionTreeId', dimensionTreeId)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸タグを階層から外すAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {string} dimensionTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachDimensionTreeNode: async (dimensionId: string, dimensionTreeId: string, dimensionTagId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('detachDimensionTreeNode', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('detachDimensionTreeNode', 'dimensionTreeId', dimensionTreeId)
            // verify required parameter 'dimensionTagId' is not null or undefined
            assertParamExists('detachDimensionTreeNode', 'dimensionTagId', dimensionTagId)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/detach/{dimensionTagId}`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)))
                .replace('{dimensionTagId}', encodeURIComponent(String(dimensionTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Excelファイルをもとに分析軸階層を更新するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dimensionTreeFileUpload: async (dimensionId: string, dimensionTreeId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('dimensionTreeFileUpload', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('dimensionTreeFileUpload', 'dimensionTreeId', dimensionTreeId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('dimensionTreeFileUpload', 'file', file)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/bulk-update`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸階層Excelファイルを取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDimensionTreeFile: async (dimensionId: string, dimensionTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('downloadDimensionTreeFile', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('downloadDimensionTreeFile', 'dimensionTreeId', dimensionTreeId)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/excel`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸階層を取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionTree: async (dimensionId: string, dimensionTreeId: string, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('getDimensionTree', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('getDimensionTree', 'dimensionTreeId', dimensionTreeId)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 階層名昇順の最初の階層を取得する
         * @summary 分析軸階層(本体値付き)を取得するAPI
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionTreeForSelection: async (dimensionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('getDimensionTreeForSelection', 'dimensionId', dimensionId)
            const localVarPath = `/api/dimension-tree/{dimensionId}/for-selection`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 階層パターンを指定して、分析軸階層(本体値付き)を取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionTreeForSelectionByTreeId: async (dimensionId: string, dimensionTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('getDimensionTreeForSelectionByTreeId', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('getDimensionTreeForSelectionByTreeId', 'dimensionTreeId', dimensionTreeId)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/for-selection`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸階層に含まれない分析軸タグ一覧を取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncludedDimensionTags: async (dimensionId: string, dimensionTreeId: string, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('getNotIncludedDimensionTags', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('getNotIncludedDimensionTags', 'dimensionTreeId', dimensionTreeId)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/not-included`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸階層のリストを取得するAPI
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDimensionTree: async (dimensionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('listDimensionTree', 'dimensionId', dimensionId)
            const localVarPath = `/api/dimension-tree/{dimensionId}`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 階層内の分析軸タグを移動するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {MoveDimensionTreeNodeRequestBody} moveDimensionTreeNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveDimensionTreeNode: async (dimensionId: string, dimensionTreeId: string, moveDimensionTreeNodeRequestBody: MoveDimensionTreeNodeRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('moveDimensionTreeNode', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('moveDimensionTreeNode', 'dimensionTreeId', dimensionTreeId)
            // verify required parameter 'moveDimensionTreeNodeRequestBody' is not null or undefined
            assertParamExists('moveDimensionTreeNode', 'moveDimensionTreeNodeRequestBody', moveDimensionTreeNodeRequestBody)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/move`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveDimensionTreeNodeRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸階層名を更新するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {UpdateDimensionTreeNameBody} updateDimensionTreeNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDimensionTreeName: async (dimensionId: string, dimensionTreeId: string, updateDimensionTreeNameBody: UpdateDimensionTreeNameBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('updateDimensionTreeName', 'dimensionId', dimensionId)
            // verify required parameter 'dimensionTreeId' is not null or undefined
            assertParamExists('updateDimensionTreeName', 'dimensionTreeId', dimensionTreeId)
            // verify required parameter 'updateDimensionTreeNameBody' is not null or undefined
            assertParamExists('updateDimensionTreeName', 'updateDimensionTreeNameBody', updateDimensionTreeNameBody)
            const localVarPath = `/api/dimension-tree/{dimensionId}/{dimensionTreeId}/name`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)))
                .replace('{dimensionTreeId}', encodeURIComponent(String(dimensionTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDimensionTreeNameBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DimensionTreeControllerApi - functional programming interface
 */
export const DimensionTreeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DimensionTreeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 分析軸階層に分析軸タグを追加するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {AddDimensionTreeNodeRequestBody} addDimensionTreeNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDimensionTreeNode(dimensionId: string, dimensionTreeId: string, addDimensionTreeNodeRequestBody: AddDimensionTreeNodeRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDimensionTreeNode(dimensionId, dimensionTreeId, addDimensionTreeNodeRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.addDimensionTreeNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸階層をコピーするAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {CopyDimensionTreeBody} copyDimensionTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyDimensionTree(dimensionId: string, dimensionTreeId: string, copyDimensionTreeBody: CopyDimensionTreeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DimensionTreeMetaView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyDimensionTree(dimensionId, dimensionTreeId, copyDimensionTreeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.copyDimensionTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸タグを作成し、分析軸階層に分析軸タグを追加するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {CreateAndAddDimensionTagsRequestBody} createAndAddDimensionTagsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndAddDimensionTreeNode(dimensionId: string, dimensionTreeId: string, createAndAddDimensionTagsRequestBody: CreateAndAddDimensionTagsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndAddDimensionTreeNode(dimensionId, dimensionTreeId, createAndAddDimensionTagsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.createAndAddDimensionTreeNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸階層を削除するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDimensionTree(dimensionId: string, dimensionTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDimensionTree(dimensionId, dimensionTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.deleteDimensionTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸タグを階層から外すAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {string} dimensionTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachDimensionTreeNode(dimensionId: string, dimensionTreeId: string, dimensionTagId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachDimensionTreeNode(dimensionId, dimensionTreeId, dimensionTagId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.detachDimensionTreeNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Excelファイルをもとに分析軸階層を更新するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dimensionTreeFileUpload(dimensionId: string, dimensionTreeId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dimensionTreeFileUpload(dimensionId, dimensionTreeId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.dimensionTreeFileUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸階層Excelファイルを取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDimensionTreeFile(dimensionId: string, dimensionTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDimensionTreeFile(dimensionId, dimensionTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.downloadDimensionTreeFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸階層を取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDimensionTree(dimensionId: string, dimensionTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DimensionTagFlatTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDimensionTree(dimensionId, dimensionTreeId, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.getDimensionTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 階層名昇順の最初の階層を取得する
         * @summary 分析軸階層(本体値付き)を取得するAPI
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDimensionTreeForSelection(dimensionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DimensionTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDimensionTreeForSelection(dimensionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.getDimensionTreeForSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 階層パターンを指定して、分析軸階層(本体値付き)を取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDimensionTreeForSelectionByTreeId(dimensionId: string, dimensionTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DimensionTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDimensionTreeForSelectionByTreeId(dimensionId, dimensionTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.getDimensionTreeForSelectionByTreeId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸階層に含まれない分析軸タグ一覧を取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotIncludedDimensionTags(dimensionId: string, dimensionTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotIncludedDimensionTagsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotIncludedDimensionTags(dimensionId, dimensionTreeId, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.getNotIncludedDimensionTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸階層のリストを取得するAPI
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDimensionTree(dimensionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DimensionTreeListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDimensionTree(dimensionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.listDimensionTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 階層内の分析軸タグを移動するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {MoveDimensionTreeNodeRequestBody} moveDimensionTreeNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveDimensionTreeNode(dimensionId: string, dimensionTreeId: string, moveDimensionTreeNodeRequestBody: MoveDimensionTreeNodeRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveDimensionTreeNode(dimensionId, dimensionTreeId, moveDimensionTreeNodeRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.moveDimensionTreeNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸階層名を更新するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {UpdateDimensionTreeNameBody} updateDimensionTreeNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDimensionTreeName(dimensionId: string, dimensionTreeId: string, updateDimensionTreeNameBody: UpdateDimensionTreeNameBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDimensionTreeName(dimensionId, dimensionTreeId, updateDimensionTreeNameBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionTreeControllerApi.updateDimensionTreeName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DimensionTreeControllerApi - factory interface
 */
export const DimensionTreeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DimensionTreeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 分析軸階層に分析軸タグを追加するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {AddDimensionTreeNodeRequestBody} addDimensionTreeNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDimensionTreeNode(dimensionId: string, dimensionTreeId: string, addDimensionTreeNodeRequestBody: AddDimensionTreeNodeRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.addDimensionTreeNode(dimensionId, dimensionTreeId, addDimensionTreeNodeRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸階層をコピーするAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {CopyDimensionTreeBody} copyDimensionTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyDimensionTree(dimensionId: string, dimensionTreeId: string, copyDimensionTreeBody: CopyDimensionTreeBody, options?: RawAxiosRequestConfig): AxiosPromise<DimensionTreeMetaView> {
            return localVarFp.copyDimensionTree(dimensionId, dimensionTreeId, copyDimensionTreeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸タグを作成し、分析軸階層に分析軸タグを追加するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {CreateAndAddDimensionTagsRequestBody} createAndAddDimensionTagsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndAddDimensionTreeNode(dimensionId: string, dimensionTreeId: string, createAndAddDimensionTagsRequestBody: CreateAndAddDimensionTagsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createAndAddDimensionTreeNode(dimensionId, dimensionTreeId, createAndAddDimensionTagsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸階層を削除するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDimensionTree(dimensionId: string, dimensionTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteDimensionTree(dimensionId, dimensionTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸タグを階層から外すAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {string} dimensionTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachDimensionTreeNode(dimensionId: string, dimensionTreeId: string, dimensionTagId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.detachDimensionTreeNode(dimensionId, dimensionTreeId, dimensionTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Excelファイルをもとに分析軸階層を更新するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dimensionTreeFileUpload(dimensionId: string, dimensionTreeId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.dimensionTreeFileUpload(dimensionId, dimensionTreeId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸階層Excelファイルを取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDimensionTreeFile(dimensionId: string, dimensionTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadDimensionTreeFile(dimensionId, dimensionTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸階層を取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionTree(dimensionId: string, dimensionTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<DimensionTagFlatTreeView> {
            return localVarFp.getDimensionTree(dimensionId, dimensionTreeId, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 階層名昇順の最初の階層を取得する
         * @summary 分析軸階層(本体値付き)を取得するAPI
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionTreeForSelection(dimensionId: string, options?: RawAxiosRequestConfig): AxiosPromise<DimensionTreeForSelectionView> {
            return localVarFp.getDimensionTreeForSelection(dimensionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 階層パターンを指定して、分析軸階層(本体値付き)を取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDimensionTreeForSelectionByTreeId(dimensionId: string, dimensionTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<DimensionTreeForSelectionView> {
            return localVarFp.getDimensionTreeForSelectionByTreeId(dimensionId, dimensionTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸階層に含まれない分析軸タグ一覧を取得するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncludedDimensionTags(dimensionId: string, dimensionTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotIncludedDimensionTagsView> {
            return localVarFp.getNotIncludedDimensionTags(dimensionId, dimensionTreeId, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸階層のリストを取得するAPI
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDimensionTree(dimensionId: string, options?: RawAxiosRequestConfig): AxiosPromise<DimensionTreeListView> {
            return localVarFp.listDimensionTree(dimensionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 階層内の分析軸タグを移動するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {MoveDimensionTreeNodeRequestBody} moveDimensionTreeNodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveDimensionTreeNode(dimensionId: string, dimensionTreeId: string, moveDimensionTreeNodeRequestBody: MoveDimensionTreeNodeRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveDimensionTreeNode(dimensionId, dimensionTreeId, moveDimensionTreeNodeRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸階層名を更新するAPI
         * @param {string} dimensionId 
         * @param {string} dimensionTreeId 
         * @param {UpdateDimensionTreeNameBody} updateDimensionTreeNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDimensionTreeName(dimensionId: string, dimensionTreeId: string, updateDimensionTreeNameBody: UpdateDimensionTreeNameBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateDimensionTreeName(dimensionId, dimensionTreeId, updateDimensionTreeNameBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DimensionTreeControllerApi - object-oriented interface
 */
export class DimensionTreeControllerApi extends BaseAPI {
    /**
     * 
     * @summary 分析軸階層に分析軸タグを追加するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {AddDimensionTreeNodeRequestBody} addDimensionTreeNodeRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addDimensionTreeNode(dimensionId: string, dimensionTreeId: string, addDimensionTreeNodeRequestBody: AddDimensionTreeNodeRequestBody, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).addDimensionTreeNode(dimensionId, dimensionTreeId, addDimensionTreeNodeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸階層をコピーするAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {CopyDimensionTreeBody} copyDimensionTreeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyDimensionTree(dimensionId: string, dimensionTreeId: string, copyDimensionTreeBody: CopyDimensionTreeBody, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).copyDimensionTree(dimensionId, dimensionTreeId, copyDimensionTreeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸タグを作成し、分析軸階層に分析軸タグを追加するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {CreateAndAddDimensionTagsRequestBody} createAndAddDimensionTagsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAndAddDimensionTreeNode(dimensionId: string, dimensionTreeId: string, createAndAddDimensionTagsRequestBody: CreateAndAddDimensionTagsRequestBody, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).createAndAddDimensionTreeNode(dimensionId, dimensionTreeId, createAndAddDimensionTagsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸階層を削除するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDimensionTree(dimensionId: string, dimensionTreeId: string, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).deleteDimensionTree(dimensionId, dimensionTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸タグを階層から外すAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {string} dimensionTagId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public detachDimensionTreeNode(dimensionId: string, dimensionTreeId: string, dimensionTagId: string, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).detachDimensionTreeNode(dimensionId, dimensionTreeId, dimensionTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Excelファイルをもとに分析軸階層を更新するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dimensionTreeFileUpload(dimensionId: string, dimensionTreeId: string, file: File, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).dimensionTreeFileUpload(dimensionId, dimensionTreeId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸階層Excelファイルを取得するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadDimensionTreeFile(dimensionId: string, dimensionTreeId: string, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).downloadDimensionTreeFile(dimensionId, dimensionTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸階層を取得するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDimensionTree(dimensionId: string, dimensionTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).getDimensionTree(dimensionId, dimensionTreeId, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 階層名昇順の最初の階層を取得する
     * @summary 分析軸階層(本体値付き)を取得するAPI
     * @param {string} dimensionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDimensionTreeForSelection(dimensionId: string, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).getDimensionTreeForSelection(dimensionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 階層パターンを指定して、分析軸階層(本体値付き)を取得するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDimensionTreeForSelectionByTreeId(dimensionId: string, dimensionTreeId: string, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).getDimensionTreeForSelectionByTreeId(dimensionId, dimensionTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸階層に含まれない分析軸タグ一覧を取得するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotIncludedDimensionTags(dimensionId: string, dimensionTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).getNotIncludedDimensionTags(dimensionId, dimensionTreeId, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸階層のリストを取得するAPI
     * @param {string} dimensionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDimensionTree(dimensionId: string, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).listDimensionTree(dimensionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 階層内の分析軸タグを移動するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {MoveDimensionTreeNodeRequestBody} moveDimensionTreeNodeRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveDimensionTreeNode(dimensionId: string, dimensionTreeId: string, moveDimensionTreeNodeRequestBody: MoveDimensionTreeNodeRequestBody, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).moveDimensionTreeNode(dimensionId, dimensionTreeId, moveDimensionTreeNodeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸階層名を更新するAPI
     * @param {string} dimensionId 
     * @param {string} dimensionTreeId 
     * @param {UpdateDimensionTreeNameBody} updateDimensionTreeNameBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDimensionTreeName(dimensionId: string, dimensionTreeId: string, updateDimensionTreeNameBody: UpdateDimensionTreeNameBody, options?: RawAxiosRequestConfig) {
        return DimensionTreeControllerApiFp(this.configuration).updateDimensionTreeName(dimensionId, dimensionTreeId, updateDimensionTreeNameBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DimensionsControllerApi - axios parameter creator
 */
export const DimensionsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 分析軸の追加
         * @param {UpsertDimensionRequestBody} upsertDimensionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1: async (upsertDimensionRequestBody: UpsertDimensionRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertDimensionRequestBody' is not null or undefined
            assertParamExists('create1', 'upsertDimensionRequestBody', upsertDimensionRequestBody)
            const localVarPath = `/api/dimensions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertDimensionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸の削除
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDimension: async (dimensionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('deleteDimension', 'dimensionId', dimensionId)
            const localVarPath = `/api/dimensions/{dimensionId}`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸から分析軸タグ一覧を取得
         * @param {string} dimensionId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find: async (dimensionId: string, limit?: number, offset?: number, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('find', 'dimensionId', dimensionId)
            const localVarPath = `/api/dimensions/{dimensionId}`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸タグ一覧のExcelダウンロード
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find1: async (dimensionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('find1', 'dimensionId', dimensionId)
            const localVarPath = `/api/dimensions/{dimensionId}/excel`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸タグの取得
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDimensionTagsByDimensionId: async (dimensionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('findDimensionTagsByDimensionId', 'dimensionId', dimensionId)
            const localVarPath = `/api/dimensions/{dimensionId}/dimension-tags`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDimensions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dimensions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸の修正
         * @param {string} dimensionId 
         * @param {UpsertDimensionRequestBody} upsertDimensionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1: async (dimensionId: string, upsertDimensionRequestBody: UpsertDimensionRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('update1', 'dimensionId', dimensionId)
            // verify required parameter 'upsertDimensionRequestBody' is not null or undefined
            assertParamExists('update1', 'upsertDimensionRequestBody', upsertDimensionRequestBody)
            const localVarPath = `/api/dimensions/{dimensionId}`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertDimensionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸タグのExcel一括アップロード
         * @param {string} dimensionId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: async (dimensionId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dimensionId' is not null or undefined
            assertParamExists('upload', 'dimensionId', dimensionId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('upload', 'file', file)
            const localVarPath = `/api/dimensions/{dimensionId}/excel/upload`
                .replace('{dimensionId}', encodeURIComponent(String(dimensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DimensionsControllerApi - functional programming interface
 */
export const DimensionsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DimensionsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 分析軸の追加
         * @param {UpsertDimensionRequestBody} upsertDimensionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create1(upsertDimensionRequestBody: UpsertDimensionRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create1(upsertDimensionRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionsControllerApi.create1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸の削除
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDimension(dimensionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDimension(dimensionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionsControllerApi.deleteDimension']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸から分析軸タグ一覧を取得
         * @param {string} dimensionId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async find(dimensionId: string, limit?: number, offset?: number, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DimensionTagListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.find(dimensionId, limit, offset, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionsControllerApi.find']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸タグ一覧のExcelダウンロード
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async find1(dimensionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.find1(dimensionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionsControllerApi.find1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸タグの取得
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDimensionTagsByDimensionId(dimensionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DimensionTagsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findDimensionTagsByDimensionId(dimensionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionsControllerApi.findDimensionTagsByDimensionId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDimensions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DimensionView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDimensions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionsControllerApi.listDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸の修正
         * @param {string} dimensionId 
         * @param {UpsertDimensionRequestBody} upsertDimensionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update1(dimensionId: string, upsertDimensionRequestBody: UpsertDimensionRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update1(dimensionId, upsertDimensionRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionsControllerApi.update1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸タグのExcel一括アップロード
         * @param {string} dimensionId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upload(dimensionId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upload(dimensionId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DimensionsControllerApi.upload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DimensionsControllerApi - factory interface
 */
export const DimensionsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DimensionsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 分析軸の追加
         * @param {UpsertDimensionRequestBody} upsertDimensionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1(upsertDimensionRequestBody: UpsertDimensionRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.create1(upsertDimensionRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸の削除
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDimension(dimensionId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteDimension(dimensionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸から分析軸タグ一覧を取得
         * @param {string} dimensionId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find(dimensionId: string, limit?: number, offset?: number, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<DimensionTagListView> {
            return localVarFp.find(dimensionId, limit, offset, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸タグ一覧のExcelダウンロード
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find1(dimensionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.find1(dimensionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸タグの取得
         * @param {string} dimensionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDimensionTagsByDimensionId(dimensionId: string, options?: RawAxiosRequestConfig): AxiosPromise<DimensionTagsView> {
            return localVarFp.findDimensionTagsByDimensionId(dimensionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDimensions(options?: RawAxiosRequestConfig): AxiosPromise<Array<DimensionView>> {
            return localVarFp.listDimensions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸の修正
         * @param {string} dimensionId 
         * @param {UpsertDimensionRequestBody} upsertDimensionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1(dimensionId: string, upsertDimensionRequestBody: UpsertDimensionRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.update1(dimensionId, upsertDimensionRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸タグのExcel一括アップロード
         * @param {string} dimensionId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(dimensionId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.upload(dimensionId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DimensionsControllerApi - object-oriented interface
 */
export class DimensionsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 分析軸の追加
     * @param {UpsertDimensionRequestBody} upsertDimensionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create1(upsertDimensionRequestBody: UpsertDimensionRequestBody, options?: RawAxiosRequestConfig) {
        return DimensionsControllerApiFp(this.configuration).create1(upsertDimensionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸の削除
     * @param {string} dimensionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDimension(dimensionId: string, options?: RawAxiosRequestConfig) {
        return DimensionsControllerApiFp(this.configuration).deleteDimension(dimensionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸から分析軸タグ一覧を取得
     * @param {string} dimensionId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public find(dimensionId: string, limit?: number, offset?: number, searchWord?: string, options?: RawAxiosRequestConfig) {
        return DimensionsControllerApiFp(this.configuration).find(dimensionId, limit, offset, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸タグ一覧のExcelダウンロード
     * @param {string} dimensionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public find1(dimensionId: string, options?: RawAxiosRequestConfig) {
        return DimensionsControllerApiFp(this.configuration).find1(dimensionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸タグの取得
     * @param {string} dimensionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findDimensionTagsByDimensionId(dimensionId: string, options?: RawAxiosRequestConfig) {
        return DimensionsControllerApiFp(this.configuration).findDimensionTagsByDimensionId(dimensionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDimensions(options?: RawAxiosRequestConfig) {
        return DimensionsControllerApiFp(this.configuration).listDimensions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸の修正
     * @param {string} dimensionId 
     * @param {UpsertDimensionRequestBody} upsertDimensionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public update1(dimensionId: string, upsertDimensionRequestBody: UpsertDimensionRequestBody, options?: RawAxiosRequestConfig) {
        return DimensionsControllerApiFp(this.configuration).update1(dimensionId, upsertDimensionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸タグのExcel一括アップロード
     * @param {string} dimensionId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upload(dimensionId: string, file: File, options?: RawAxiosRequestConfig) {
        return DimensionsControllerApiFp(this.configuration).upload(dimensionId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DownloadExcelControllerApi - axios parameter creator
 */
export const DownloadExcelControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 分析データダウンロード(Excel)
         * @param {DownloadRequestBody} downloadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download: async (downloadRequestBody: DownloadRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadRequestBody' is not null or undefined
            assertParamExists('download', 'downloadRequestBody', downloadRequestBody)
            const localVarPath = `/api/analytics/download/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadExcelControllerApi - functional programming interface
 */
export const DownloadExcelControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadExcelControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 分析データダウンロード(Excel)
         * @param {DownloadRequestBody} downloadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async download(downloadRequestBody: DownloadRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.download(downloadRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DownloadExcelControllerApi.download']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DownloadExcelControllerApi - factory interface
 */
export const DownloadExcelControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadExcelControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 分析データダウンロード(Excel)
         * @param {DownloadRequestBody} downloadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download(downloadRequestBody: DownloadRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.download(downloadRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadExcelControllerApi - object-oriented interface
 */
export class DownloadExcelControllerApi extends BaseAPI {
    /**
     * 
     * @summary 分析データダウンロード(Excel)
     * @param {DownloadRequestBody} downloadRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public download(downloadRequestBody: DownloadRequestBody, options?: RawAxiosRequestConfig) {
        return DownloadExcelControllerApiFp(this.configuration).download(downloadRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DownloadManagementControllerApi - axios parameter creator
 */
export const DownloadManagementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ダウンロード管理削除
         * @param {string} downloadManagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDownloadManagement: async (downloadManagementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadManagementId' is not null or undefined
            assertParamExists('deleteDownloadManagement', 'downloadManagementId', downloadManagementId)
            const localVarPath = `/api/download_managements/{downloadManagementId}`
                .replace('{downloadManagementId}', encodeURIComponent(String(downloadManagementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダウンロード管理ファイルURL取得
         * @param {string} downloadManagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadManagementFileUrl: async (downloadManagementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadManagementId' is not null or undefined
            assertParamExists('getDownloadManagementFileUrl', 'downloadManagementId', downloadManagementId)
            const localVarPath = `/api/download_managements/{downloadManagementId}`
                .replace('{downloadManagementId}', encodeURIComponent(String(downloadManagementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダウンロード管理一覧取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDownloadManagements: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/download_managements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadManagementControllerApi - functional programming interface
 */
export const DownloadManagementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadManagementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ダウンロード管理削除
         * @param {string} downloadManagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDownloadManagement(downloadManagementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDownloadManagement(downloadManagementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DownloadManagementControllerApi.deleteDownloadManagement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダウンロード管理ファイルURL取得
         * @param {string} downloadManagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadManagementFileUrl(downloadManagementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDownloadManagementFileUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadManagementFileUrl(downloadManagementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DownloadManagementControllerApi.getDownloadManagementFileUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダウンロード管理一覧取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDownloadManagements(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoDownloadManagementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDownloadManagements(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DownloadManagementControllerApi.listDownloadManagements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DownloadManagementControllerApi - factory interface
 */
export const DownloadManagementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadManagementControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ダウンロード管理削除
         * @param {string} downloadManagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDownloadManagement(downloadManagementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDownloadManagement(downloadManagementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダウンロード管理ファイルURL取得
         * @param {string} downloadManagementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadManagementFileUrl(downloadManagementId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDownloadManagementFileUrlDto> {
            return localVarFp.getDownloadManagementFileUrl(downloadManagementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダウンロード管理一覧取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDownloadManagements(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoDownloadManagementDto> {
            return localVarFp.listDownloadManagements(limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadManagementControllerApi - object-oriented interface
 */
export class DownloadManagementControllerApi extends BaseAPI {
    /**
     * 
     * @summary ダウンロード管理削除
     * @param {string} downloadManagementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDownloadManagement(downloadManagementId: string, options?: RawAxiosRequestConfig) {
        return DownloadManagementControllerApiFp(this.configuration).deleteDownloadManagement(downloadManagementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダウンロード管理ファイルURL取得
     * @param {string} downloadManagementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDownloadManagementFileUrl(downloadManagementId: string, options?: RawAxiosRequestConfig) {
        return DownloadManagementControllerApiFp(this.configuration).getDownloadManagementFileUrl(downloadManagementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダウンロード管理一覧取得
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDownloadManagements(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DownloadManagementControllerApiFp(this.configuration).listDownloadManagements(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EachDepartmentComparisonControllerApi - axios parameter creator
 */
export const EachDepartmentComparisonControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 部署別対比表をExcelでダウンロードする
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEachDepartmentComparisonExcel: async (fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchEachDepartmentComparisonV2RequestBody' is not null or undefined
            assertParamExists('downloadEachDepartmentComparisonExcel', 'fetchEachDepartmentComparisonV2RequestBody', fetchEachDepartmentComparisonV2RequestBody)
            const localVarPath = `/api/each-department-comparison/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchEachDepartmentComparisonV2RequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署別対比表API
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEachDepartmentComparison: async (fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchEachDepartmentComparisonV2RequestBody' is not null or undefined
            assertParamExists('fetchEachDepartmentComparison', 'fetchEachDepartmentComparisonV2RequestBody', fetchEachDepartmentComparisonV2RequestBody)
            const localVarPath = `/api/each-department-comparison`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchEachDepartmentComparisonV2RequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EachDepartmentComparisonControllerApi - functional programming interface
 */
export const EachDepartmentComparisonControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EachDepartmentComparisonControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 部署別対比表をExcelでダウンロードする
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEachDepartmentComparisonExcel(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEachDepartmentComparisonExcel(fetchEachDepartmentComparisonV2RequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EachDepartmentComparisonControllerApi.downloadEachDepartmentComparisonExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署別対比表API
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchEachDepartmentComparison(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EachDepartmentComparisonV2View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchEachDepartmentComparison(fetchEachDepartmentComparisonV2RequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EachDepartmentComparisonControllerApi.fetchEachDepartmentComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EachDepartmentComparisonControllerApi - factory interface
 */
export const EachDepartmentComparisonControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EachDepartmentComparisonControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 部署別対比表をExcelでダウンロードする
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEachDepartmentComparisonExcel(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadEachDepartmentComparisonExcel(fetchEachDepartmentComparisonV2RequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署別対比表API
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEachDepartmentComparison(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig): AxiosPromise<EachDepartmentComparisonV2View> {
            return localVarFp.fetchEachDepartmentComparison(fetchEachDepartmentComparisonV2RequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EachDepartmentComparisonControllerApi - object-oriented interface
 */
export class EachDepartmentComparisonControllerApi extends BaseAPI {
    /**
     * 
     * @summary 部署別対比表をExcelでダウンロードする
     * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadEachDepartmentComparisonExcel(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig) {
        return EachDepartmentComparisonControllerApiFp(this.configuration).downloadEachDepartmentComparisonExcel(fetchEachDepartmentComparisonV2RequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署別対比表API
     * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchEachDepartmentComparison(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig) {
        return EachDepartmentComparisonControllerApiFp(this.configuration).fetchEachDepartmentComparison(fetchEachDepartmentComparisonV2RequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EachDepartmentControllerApi - axios parameter creator
 */
export const EachDepartmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 部署別表をExcelでダウンロードする
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEachDepartmentExcel: async (fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchEachDepartmentComparisonV2RequestBody' is not null or undefined
            assertParamExists('downloadEachDepartmentExcel', 'fetchEachDepartmentComparisonV2RequestBody', fetchEachDepartmentComparisonV2RequestBody)
            const localVarPath = `/api/each-department/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchEachDepartmentComparisonV2RequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署別表API
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEachDepartment: async (fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchEachDepartmentComparisonV2RequestBody' is not null or undefined
            assertParamExists('fetchEachDepartment', 'fetchEachDepartmentComparisonV2RequestBody', fetchEachDepartmentComparisonV2RequestBody)
            const localVarPath = `/api/each-department`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchEachDepartmentComparisonV2RequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EachDepartmentControllerApi - functional programming interface
 */
export const EachDepartmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EachDepartmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 部署別表をExcelでダウンロードする
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEachDepartmentExcel(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEachDepartmentExcel(fetchEachDepartmentComparisonV2RequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EachDepartmentControllerApi.downloadEachDepartmentExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署別表API
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchEachDepartment(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EachDepartmentComparisonV2View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchEachDepartment(fetchEachDepartmentComparisonV2RequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EachDepartmentControllerApi.fetchEachDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EachDepartmentControllerApi - factory interface
 */
export const EachDepartmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EachDepartmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 部署別表をExcelでダウンロードする
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEachDepartmentExcel(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadEachDepartmentExcel(fetchEachDepartmentComparisonV2RequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署別表API
         * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchEachDepartment(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig): AxiosPromise<EachDepartmentComparisonV2View> {
            return localVarFp.fetchEachDepartment(fetchEachDepartmentComparisonV2RequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EachDepartmentControllerApi - object-oriented interface
 */
export class EachDepartmentControllerApi extends BaseAPI {
    /**
     * 
     * @summary 部署別表をExcelでダウンロードする
     * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadEachDepartmentExcel(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig) {
        return EachDepartmentControllerApiFp(this.configuration).downloadEachDepartmentExcel(fetchEachDepartmentComparisonV2RequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署別表API
     * @param {FetchEachDepartmentComparisonV2RequestBody} fetchEachDepartmentComparisonV2RequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchEachDepartment(fetchEachDepartmentComparisonV2RequestBody: FetchEachDepartmentComparisonV2RequestBody, options?: RawAxiosRequestConfig) {
        return EachDepartmentControllerApiFp(this.configuration).fetchEachDepartment(fetchEachDepartmentComparisonV2RequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EnabledFeatureControllerApi - axios parameter creator
 */
export const EnabledFeatureControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary フィーチャートグル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnabledFeatures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnabledFeatureControllerApi - functional programming interface
 */
export const EnabledFeatureControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnabledFeatureControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary フィーチャートグル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEnabledFeatures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnabledFeaturesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEnabledFeatures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnabledFeatureControllerApi.listEnabledFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnabledFeatureControllerApi - factory interface
 */
export const EnabledFeatureControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnabledFeatureControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary フィーチャートグル
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnabledFeatures(options?: RawAxiosRequestConfig): AxiosPromise<EnabledFeaturesDto> {
            return localVarFp.listEnabledFeatures(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnabledFeatureControllerApi - object-oriented interface
 */
export class EnabledFeatureControllerApi extends BaseAPI {
    /**
     * 
     * @summary フィーチャートグル
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listEnabledFeatures(options?: RawAxiosRequestConfig) {
        return EnabledFeatureControllerApiFp(this.configuration).listEnabledFeatures(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExchangeRateControllerApi - axios parameter creator
 */
export const ExchangeRateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Copy exchange rate
         * @param {string} exchangeRateId 
         * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyExchangeRate: async (exchangeRateId: string, exchangeRateRequestParam: ExchangeRateRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeRateId' is not null or undefined
            assertParamExists('copyExchangeRate', 'exchangeRateId', exchangeRateId)
            // verify required parameter 'exchangeRateRequestParam' is not null or undefined
            assertParamExists('copyExchangeRate', 'exchangeRateRequestParam', exchangeRateRequestParam)
            const localVarPath = `/api/exchange_rate/{exchangeRateId}/copy`
                .replace('{exchangeRateId}', encodeURIComponent(String(exchangeRateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeRateRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create exchange rate
         * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExchangeRate: async (exchangeRateRequestParam: ExchangeRateRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeRateRequestParam' is not null or undefined
            assertParamExists('createExchangeRate', 'exchangeRateRequestParam', exchangeRateRequestParam)
            const localVarPath = `/api/exchange_rate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeRateRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete exchange rate
         * @param {string} exchangeRateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExchangeRate: async (exchangeRateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeRateId' is not null or undefined
            assertParamExists('deleteExchangeRate', 'exchangeRateId', exchangeRateId)
            const localVarPath = `/api/exchange_rate/{exchangeRateId}`
                .replace('{exchangeRateId}', encodeURIComponent(String(exchangeRateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GET exchange rate detail.
         * @param {string} exchangeRateId 
         * @param {string} financialReportType 
         * @param {string} fromFiscalMonthId 
         * @param {string} toFiscalMonthId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRateDetail: async (exchangeRateId: string, financialReportType: string, fromFiscalMonthId: string, toFiscalMonthId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeRateId' is not null or undefined
            assertParamExists('getExchangeRateDetail', 'exchangeRateId', exchangeRateId)
            // verify required parameter 'financialReportType' is not null or undefined
            assertParamExists('getExchangeRateDetail', 'financialReportType', financialReportType)
            // verify required parameter 'fromFiscalMonthId' is not null or undefined
            assertParamExists('getExchangeRateDetail', 'fromFiscalMonthId', fromFiscalMonthId)
            // verify required parameter 'toFiscalMonthId' is not null or undefined
            assertParamExists('getExchangeRateDetail', 'toFiscalMonthId', toFiscalMonthId)
            const localVarPath = `/api/exchange_rate/{exchangeRateId}`
                .replace('{exchangeRateId}', encodeURIComponent(String(exchangeRateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (financialReportType !== undefined) {
                localVarQueryParameter['financialReportType'] = financialReportType;
            }

            if (fromFiscalMonthId !== undefined) {
                localVarQueryParameter['fromFiscalMonthId'] = fromFiscalMonthId;
            }

            if (toFiscalMonthId !== undefined) {
                localVarQueryParameter['toFiscalMonthId'] = toFiscalMonthId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List exchange rate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRateList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/exchange_rate/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update exchange rate
         * @param {string} exchangeRateId 
         * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExchangeRate: async (exchangeRateId: string, exchangeRateRequestParam: ExchangeRateRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeRateId' is not null or undefined
            assertParamExists('updateExchangeRate', 'exchangeRateId', exchangeRateId)
            // verify required parameter 'exchangeRateRequestParam' is not null or undefined
            assertParamExists('updateExchangeRate', 'exchangeRateRequestParam', exchangeRateRequestParam)
            const localVarPath = `/api/exchange_rate/{exchangeRateId}`
                .replace('{exchangeRateId}', encodeURIComponent(String(exchangeRateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeRateRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update exchange rate value.
         * @param {string} exchangeRateId 
         * @param {UpdateExchangeRateValueRequestParam} updateExchangeRateValueRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExchangeRateValue: async (exchangeRateId: string, updateExchangeRateValueRequestParam: UpdateExchangeRateValueRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeRateId' is not null or undefined
            assertParamExists('updateExchangeRateValue', 'exchangeRateId', exchangeRateId)
            // verify required parameter 'updateExchangeRateValueRequestParam' is not null or undefined
            assertParamExists('updateExchangeRateValue', 'updateExchangeRateValueRequestParam', updateExchangeRateValueRequestParam)
            const localVarPath = `/api/exchange_rate/{exchangeRateId}/value`
                .replace('{exchangeRateId}', encodeURIComponent(String(exchangeRateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExchangeRateValueRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExchangeRateControllerApi - functional programming interface
 */
export const ExchangeRateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExchangeRateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Copy exchange rate
         * @param {string} exchangeRateId 
         * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyExchangeRate(exchangeRateId: string, exchangeRateRequestParam: ExchangeRateRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeRateData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyExchangeRate(exchangeRateId, exchangeRateRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeRateControllerApi.copyExchangeRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create exchange rate
         * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExchangeRate(exchangeRateRequestParam: ExchangeRateRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeRateData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExchangeRate(exchangeRateRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeRateControllerApi.createExchangeRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete exchange rate
         * @param {string} exchangeRateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExchangeRate(exchangeRateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExchangeRate(exchangeRateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeRateControllerApi.deleteExchangeRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GET exchange rate detail.
         * @param {string} exchangeRateId 
         * @param {string} financialReportType 
         * @param {string} fromFiscalMonthId 
         * @param {string} toFiscalMonthId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExchangeRateDetail(exchangeRateId: string, financialReportType: string, fromFiscalMonthId: string, toFiscalMonthId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeRateDetailData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExchangeRateDetail(exchangeRateId, financialReportType, fromFiscalMonthId, toFiscalMonthId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeRateControllerApi.getExchangeRateDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List exchange rate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExchangeRateList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExchangeRateData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExchangeRateList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeRateControllerApi.getExchangeRateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update exchange rate
         * @param {string} exchangeRateId 
         * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExchangeRate(exchangeRateId: string, exchangeRateRequestParam: ExchangeRateRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeRateData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExchangeRate(exchangeRateId, exchangeRateRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeRateControllerApi.updateExchangeRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update exchange rate value.
         * @param {string} exchangeRateId 
         * @param {UpdateExchangeRateValueRequestParam} updateExchangeRateValueRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExchangeRateValue(exchangeRateId: string, updateExchangeRateValueRequestParam: UpdateExchangeRateValueRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExchangeRateValue(exchangeRateId, updateExchangeRateValueRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeRateControllerApi.updateExchangeRateValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExchangeRateControllerApi - factory interface
 */
export const ExchangeRateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExchangeRateControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Copy exchange rate
         * @param {string} exchangeRateId 
         * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyExchangeRate(exchangeRateId: string, exchangeRateRequestParam: ExchangeRateRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<ExchangeRateData> {
            return localVarFp.copyExchangeRate(exchangeRateId, exchangeRateRequestParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create exchange rate
         * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExchangeRate(exchangeRateRequestParam: ExchangeRateRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<ExchangeRateData> {
            return localVarFp.createExchangeRate(exchangeRateRequestParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete exchange rate
         * @param {string} exchangeRateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExchangeRate(exchangeRateId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteExchangeRate(exchangeRateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GET exchange rate detail.
         * @param {string} exchangeRateId 
         * @param {string} financialReportType 
         * @param {string} fromFiscalMonthId 
         * @param {string} toFiscalMonthId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRateDetail(exchangeRateId: string, financialReportType: string, fromFiscalMonthId: string, toFiscalMonthId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExchangeRateDetailData> {
            return localVarFp.getExchangeRateDetail(exchangeRateId, financialReportType, fromFiscalMonthId, toFiscalMonthId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List exchange rate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchangeRateList(options?: RawAxiosRequestConfig): AxiosPromise<Array<ExchangeRateData>> {
            return localVarFp.getExchangeRateList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update exchange rate
         * @param {string} exchangeRateId 
         * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExchangeRate(exchangeRateId: string, exchangeRateRequestParam: ExchangeRateRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<ExchangeRateData> {
            return localVarFp.updateExchangeRate(exchangeRateId, exchangeRateRequestParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update exchange rate value.
         * @param {string} exchangeRateId 
         * @param {UpdateExchangeRateValueRequestParam} updateExchangeRateValueRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExchangeRateValue(exchangeRateId: string, updateExchangeRateValueRequestParam: UpdateExchangeRateValueRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateExchangeRateValue(exchangeRateId, updateExchangeRateValueRequestParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExchangeRateControllerApi - object-oriented interface
 */
export class ExchangeRateControllerApi extends BaseAPI {
    /**
     * 
     * @summary Copy exchange rate
     * @param {string} exchangeRateId 
     * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyExchangeRate(exchangeRateId: string, exchangeRateRequestParam: ExchangeRateRequestParam, options?: RawAxiosRequestConfig) {
        return ExchangeRateControllerApiFp(this.configuration).copyExchangeRate(exchangeRateId, exchangeRateRequestParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create exchange rate
     * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createExchangeRate(exchangeRateRequestParam: ExchangeRateRequestParam, options?: RawAxiosRequestConfig) {
        return ExchangeRateControllerApiFp(this.configuration).createExchangeRate(exchangeRateRequestParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete exchange rate
     * @param {string} exchangeRateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteExchangeRate(exchangeRateId: string, options?: RawAxiosRequestConfig) {
        return ExchangeRateControllerApiFp(this.configuration).deleteExchangeRate(exchangeRateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GET exchange rate detail.
     * @param {string} exchangeRateId 
     * @param {string} financialReportType 
     * @param {string} fromFiscalMonthId 
     * @param {string} toFiscalMonthId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExchangeRateDetail(exchangeRateId: string, financialReportType: string, fromFiscalMonthId: string, toFiscalMonthId: string, options?: RawAxiosRequestConfig) {
        return ExchangeRateControllerApiFp(this.configuration).getExchangeRateDetail(exchangeRateId, financialReportType, fromFiscalMonthId, toFiscalMonthId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List exchange rate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExchangeRateList(options?: RawAxiosRequestConfig) {
        return ExchangeRateControllerApiFp(this.configuration).getExchangeRateList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update exchange rate
     * @param {string} exchangeRateId 
     * @param {ExchangeRateRequestParam} exchangeRateRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateExchangeRate(exchangeRateId: string, exchangeRateRequestParam: ExchangeRateRequestParam, options?: RawAxiosRequestConfig) {
        return ExchangeRateControllerApiFp(this.configuration).updateExchangeRate(exchangeRateId, exchangeRateRequestParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update exchange rate value.
     * @param {string} exchangeRateId 
     * @param {UpdateExchangeRateValueRequestParam} updateExchangeRateValueRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateExchangeRateValue(exchangeRateId: string, updateExchangeRateValueRequestParam: UpdateExchangeRateValueRequestParam, options?: RawAxiosRequestConfig) {
        return ExchangeRateControllerApiFp(this.configuration).updateExchangeRateValue(exchangeRateId, updateExchangeRateValueRequestParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExchangeRatePrimaryControllerApi - axios parameter creator
 */
export const ExchangeRatePrimaryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create exchange rate primary
         * @param {ExchangeRatePrimaryRequestParam} exchangeRatePrimaryRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExchangeRatePrimary: async (exchangeRatePrimaryRequestParam: ExchangeRatePrimaryRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeRatePrimaryRequestParam' is not null or undefined
            assertParamExists('createExchangeRatePrimary', 'exchangeRatePrimaryRequestParam', exchangeRatePrimaryRequestParam)
            const localVarPath = `/api/exchange_rate_primary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeRatePrimaryRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExchangeRatePrimaryControllerApi - functional programming interface
 */
export const ExchangeRatePrimaryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExchangeRatePrimaryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create exchange rate primary
         * @param {ExchangeRatePrimaryRequestParam} exchangeRatePrimaryRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExchangeRatePrimary(exchangeRatePrimaryRequestParam: ExchangeRatePrimaryRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExchangeRatePrimaryData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExchangeRatePrimary(exchangeRatePrimaryRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExchangeRatePrimaryControllerApi.createExchangeRatePrimary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExchangeRatePrimaryControllerApi - factory interface
 */
export const ExchangeRatePrimaryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExchangeRatePrimaryControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create exchange rate primary
         * @param {ExchangeRatePrimaryRequestParam} exchangeRatePrimaryRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExchangeRatePrimary(exchangeRatePrimaryRequestParam: ExchangeRatePrimaryRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<ExchangeRatePrimaryData> {
            return localVarFp.createExchangeRatePrimary(exchangeRatePrimaryRequestParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExchangeRatePrimaryControllerApi - object-oriented interface
 */
export class ExchangeRatePrimaryControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create exchange rate primary
     * @param {ExchangeRatePrimaryRequestParam} exchangeRatePrimaryRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createExchangeRatePrimary(exchangeRatePrimaryRequestParam: ExchangeRatePrimaryRequestParam, options?: RawAxiosRequestConfig) {
        return ExchangeRatePrimaryControllerApiFp(this.configuration).createExchangeRatePrimary(exchangeRatePrimaryRequestParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExecutionSettingsControllerApi - axios parameter creator
 */
export const ExecutionSettingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DeleteExecutionsRequest} deleteExecutionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecution: async (deleteExecutionsRequest: DeleteExecutionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteExecutionsRequest' is not null or undefined
            assertParamExists('deleteExecution', 'deleteExecutionsRequest', deleteExecutionsRequest)
            const localVarPath = `/api/allocation/v2/execution-settings/executions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteExecutionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 複数の配賦結果をダウンロード
         * @param {DownloadMultipleAllocationResultsRequest} downloadMultipleAllocationResultsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMultipleAllocationResults: async (downloadMultipleAllocationResultsRequest: DownloadMultipleAllocationResultsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadMultipleAllocationResultsRequest' is not null or undefined
            assertParamExists('downloadMultipleAllocationResults', 'downloadMultipleAllocationResultsRequest', downloadMultipleAllocationResultsRequest)
            const localVarPath = `/api/allocation/v2/execution-settings/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadMultipleAllocationResultsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦を実行する（非同期実行）
         * @param {ExecuteAllocationRequest} executeAllocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeAllocation: async (executeAllocationRequest: ExecuteAllocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'executeAllocationRequest' is not null or undefined
            assertParamExists('executeAllocation', 'executeAllocationRequest', executeAllocationRequest)
            const localVarPath = `/api/allocation/v2/execution-settings/execute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(executeAllocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSources: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/allocation/v2/execution-settings/data-sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦実行結果を取得
         * @param {string} dataSourceId 
         * @param {string} yearMonth 
         * @param {string} patternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionResult: async (dataSourceId: string, yearMonth: string, patternId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists('getExecutionResult', 'dataSourceId', dataSourceId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getExecutionResult', 'yearMonth', yearMonth)
            // verify required parameter 'patternId' is not null or undefined
            assertParamExists('getExecutionResult', 'patternId', patternId)
            const localVarPath = `/api/allocation/v2/execution-settings/executions/{dataSourceId}/{yearMonth}/{patternId}/result`
                .replace('{dataSourceId}', encodeURIComponent(String(dataSourceId)))
                .replace('{yearMonth}', encodeURIComponent(String(yearMonth)))
                .replace('{patternId}', encodeURIComponent(String(patternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} start 
         * @param {string} end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutions: async (start: string, end: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getExecutions', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getExecutions', 'end', end)
            const localVarPath = `/api/allocation/v2/execution-settings/executions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 変更されたステップの一覧を取得
         * @param {string} dataSourceId 
         * @param {string} yearMonth 
         * @param {string} patternId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiedSteps: async (dataSourceId: string, yearMonth: string, patternId: string, offset: number, limit: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists('getModifiedSteps', 'dataSourceId', dataSourceId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getModifiedSteps', 'yearMonth', yearMonth)
            // verify required parameter 'patternId' is not null or undefined
            assertParamExists('getModifiedSteps', 'patternId', patternId)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getModifiedSteps', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getModifiedSteps', 'limit', limit)
            const localVarPath = `/api/allocation/v2/execution-settings/executions/{dataSourceId}/{yearMonth}/{patternId}/modified-steps`
                .replace('{dataSourceId}', encodeURIComponent(String(dataSourceId)))
                .replace('{yearMonth}', encodeURIComponent(String(yearMonth)))
                .replace('{patternId}', encodeURIComponent(String(patternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ピン留めデータソースの更新
         * @param {UpdatePinnedDataSourcesRequest} updatePinnedDataSourcesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePinnedDataSources: async (updatePinnedDataSourcesRequest: UpdatePinnedDataSourcesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePinnedDataSourcesRequest' is not null or undefined
            assertParamExists('updatePinnedDataSources', 'updatePinnedDataSourcesRequest', updatePinnedDataSourcesRequest)
            const localVarPath = `/api/allocation/v2/execution-settings/pinned-data-sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePinnedDataSourcesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExecutionSettingsControllerApi - functional programming interface
 */
export const ExecutionSettingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExecutionSettingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DeleteExecutionsRequest} deleteExecutionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExecution(deleteExecutionsRequest: DeleteExecutionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExecution(deleteExecutionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutionSettingsControllerApi.deleteExecution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 複数の配賦結果をダウンロード
         * @param {DownloadMultipleAllocationResultsRequest} downloadMultipleAllocationResultsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMultipleAllocationResults(downloadMultipleAllocationResultsRequest: DownloadMultipleAllocationResultsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMultipleAllocationResults(downloadMultipleAllocationResultsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutionSettingsControllerApi.downloadMultipleAllocationResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦を実行する（非同期実行）
         * @param {ExecuteAllocationRequest} executeAllocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeAllocation(executeAllocationRequest: ExecuteAllocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeAllocation(executeAllocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutionSettingsControllerApi.executeAllocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSources(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSources(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutionSettingsControllerApi.getDataSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦実行結果を取得
         * @param {string} dataSourceId 
         * @param {string} yearMonth 
         * @param {string} patternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutionResult(dataSourceId: string, yearMonth: string, patternId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutionResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutionResult(dataSourceId, yearMonth, patternId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutionSettingsControllerApi.getExecutionResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} start 
         * @param {string} end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutions(start: string, end: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutions(start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutionSettingsControllerApi.getExecutions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 変更されたステップの一覧を取得
         * @param {string} dataSourceId 
         * @param {string} yearMonth 
         * @param {string} patternId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModifiedSteps(dataSourceId: string, yearMonth: string, patternId: string, offset: number, limit: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageViewModifiedStepSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModifiedSteps(dataSourceId, yearMonth, patternId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutionSettingsControllerApi.getModifiedSteps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ピン留めデータソースの更新
         * @param {UpdatePinnedDataSourcesRequest} updatePinnedDataSourcesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePinnedDataSources(updatePinnedDataSourcesRequest: UpdatePinnedDataSourcesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePinnedDataSources(updatePinnedDataSourcesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExecutionSettingsControllerApi.updatePinnedDataSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExecutionSettingsControllerApi - factory interface
 */
export const ExecutionSettingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExecutionSettingsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DeleteExecutionsRequest} deleteExecutionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExecution(deleteExecutionsRequest: DeleteExecutionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteExecution(deleteExecutionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 複数の配賦結果をダウンロード
         * @param {DownloadMultipleAllocationResultsRequest} downloadMultipleAllocationResultsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMultipleAllocationResults(downloadMultipleAllocationResultsRequest: DownloadMultipleAllocationResultsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadMultipleAllocationResults(downloadMultipleAllocationResultsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦を実行する（非同期実行）
         * @param {ExecuteAllocationRequest} executeAllocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeAllocation(executeAllocationRequest: ExecuteAllocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.executeAllocation(executeAllocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSources(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourceResponse>> {
            return localVarFp.getDataSources(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦実行結果を取得
         * @param {string} dataSourceId 
         * @param {string} yearMonth 
         * @param {string} patternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionResult(dataSourceId: string, yearMonth: string, patternId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExecutionResultResponse> {
            return localVarFp.getExecutionResult(dataSourceId, yearMonth, patternId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} start 
         * @param {string} end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutions(start: string, end: string, options?: RawAxiosRequestConfig): AxiosPromise<ExecutionsResponse> {
            return localVarFp.getExecutions(start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 変更されたステップの一覧を取得
         * @param {string} dataSourceId 
         * @param {string} yearMonth 
         * @param {string} patternId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiedSteps(dataSourceId: string, yearMonth: string, patternId: string, offset: number, limit: number, options?: RawAxiosRequestConfig): AxiosPromise<PageViewModifiedStepSummary> {
            return localVarFp.getModifiedSteps(dataSourceId, yearMonth, patternId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ピン留めデータソースの更新
         * @param {UpdatePinnedDataSourcesRequest} updatePinnedDataSourcesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePinnedDataSources(updatePinnedDataSourcesRequest: UpdatePinnedDataSourcesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePinnedDataSources(updatePinnedDataSourcesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExecutionSettingsControllerApi - object-oriented interface
 */
export class ExecutionSettingsControllerApi extends BaseAPI {
    /**
     * 
     * @param {DeleteExecutionsRequest} deleteExecutionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteExecution(deleteExecutionsRequest: DeleteExecutionsRequest, options?: RawAxiosRequestConfig) {
        return ExecutionSettingsControllerApiFp(this.configuration).deleteExecution(deleteExecutionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 複数の配賦結果をダウンロード
     * @param {DownloadMultipleAllocationResultsRequest} downloadMultipleAllocationResultsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadMultipleAllocationResults(downloadMultipleAllocationResultsRequest: DownloadMultipleAllocationResultsRequest, options?: RawAxiosRequestConfig) {
        return ExecutionSettingsControllerApiFp(this.configuration).downloadMultipleAllocationResults(downloadMultipleAllocationResultsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦を実行する（非同期実行）
     * @param {ExecuteAllocationRequest} executeAllocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public executeAllocation(executeAllocationRequest: ExecuteAllocationRequest, options?: RawAxiosRequestConfig) {
        return ExecutionSettingsControllerApiFp(this.configuration).executeAllocation(executeAllocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDataSources(options?: RawAxiosRequestConfig) {
        return ExecutionSettingsControllerApiFp(this.configuration).getDataSources(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦実行結果を取得
     * @param {string} dataSourceId 
     * @param {string} yearMonth 
     * @param {string} patternId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExecutionResult(dataSourceId: string, yearMonth: string, patternId: string, options?: RawAxiosRequestConfig) {
        return ExecutionSettingsControllerApiFp(this.configuration).getExecutionResult(dataSourceId, yearMonth, patternId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} start 
     * @param {string} end 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExecutions(start: string, end: string, options?: RawAxiosRequestConfig) {
        return ExecutionSettingsControllerApiFp(this.configuration).getExecutions(start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 変更されたステップの一覧を取得
     * @param {string} dataSourceId 
     * @param {string} yearMonth 
     * @param {string} patternId 
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getModifiedSteps(dataSourceId: string, yearMonth: string, patternId: string, offset: number, limit: number, options?: RawAxiosRequestConfig) {
        return ExecutionSettingsControllerApiFp(this.configuration).getModifiedSteps(dataSourceId, yearMonth, patternId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ピン留めデータソースの更新
     * @param {UpdatePinnedDataSourcesRequest} updatePinnedDataSourcesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePinnedDataSources(updatePinnedDataSourcesRequest: UpdatePinnedDataSourcesRequest, options?: RawAxiosRequestConfig) {
        return ExecutionSettingsControllerApiFp(this.configuration).updatePinnedDataSources(updatePinnedDataSourcesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FinancialModelControllerApi - axios parameter creator
 */
export const FinancialModelControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 財務モデル作成
         * @param {string} simulationId 
         * @param {string} scenarioId 
         * @param {UpdateFinancialModelDetailRequest} updateFinancialModelDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFinancialModel: async (simulationId: string, scenarioId: string, updateFinancialModelDetailRequest: UpdateFinancialModelDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('createFinancialModel', 'simulationId', simulationId)
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('createFinancialModel', 'scenarioId', scenarioId)
            // verify required parameter 'updateFinancialModelDetailRequest' is not null or undefined
            assertParamExists('createFinancialModel', 'updateFinancialModelDetailRequest', updateFinancialModelDetailRequest)
            const localVarPath = `/api/financial-model`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (simulationId !== undefined) {
                localVarQueryParameter['simulationId'] = simulationId;
            }

            if (scenarioId !== undefined) {
                localVarQueryParameter['scenarioId'] = scenarioId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFinancialModelDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務モデル削除
         * @param {string} financialModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFinancialModel: async (financialModelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'financialModelId' is not null or undefined
            assertParamExists('deleteFinancialModel', 'financialModelId', financialModelId)
            const localVarPath = `/api/financial-model/{financialModelId}`
                .replace('{financialModelId}', encodeURIComponent(String(financialModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務モデル詳細取得
         * @param {string} financialModelId 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialModelDetail: async (financialModelId: string, simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'financialModelId' is not null or undefined
            assertParamExists('fetchFinancialModelDetail', 'financialModelId', financialModelId)
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('fetchFinancialModelDetail', 'simulationId', simulationId)
            const localVarPath = `/api/financial-model/{financialModelId}`
                .replace('{financialModelId}', encodeURIComponent(String(financialModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (simulationId !== undefined) {
                localVarQueryParameter['simulationId'] = simulationId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務モデル一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFinancialModels: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/financial-model`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務モデル更新
         * @param {string} financialModelId 
         * @param {string} simulationId 
         * @param {UpdateFinancialModelDetailRequest} updateFinancialModelDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinancialModel: async (financialModelId: string, simulationId: string, updateFinancialModelDetailRequest: UpdateFinancialModelDetailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'financialModelId' is not null or undefined
            assertParamExists('updateFinancialModel', 'financialModelId', financialModelId)
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateFinancialModel', 'simulationId', simulationId)
            // verify required parameter 'updateFinancialModelDetailRequest' is not null or undefined
            assertParamExists('updateFinancialModel', 'updateFinancialModelDetailRequest', updateFinancialModelDetailRequest)
            const localVarPath = `/api/financial-model/{financialModelId}`
                .replace('{financialModelId}', encodeURIComponent(String(financialModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (simulationId !== undefined) {
                localVarQueryParameter['simulationId'] = simulationId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFinancialModelDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務モデル編集制限更新
         * @param {string} financialModelId 
         * @param {UpdateFinancialModelEditRestrictionRequest} updateFinancialModelEditRestrictionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinancialModelEditRestriction: async (financialModelId: string, updateFinancialModelEditRestrictionRequest: UpdateFinancialModelEditRestrictionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'financialModelId' is not null or undefined
            assertParamExists('updateFinancialModelEditRestriction', 'financialModelId', financialModelId)
            // verify required parameter 'updateFinancialModelEditRestrictionRequest' is not null or undefined
            assertParamExists('updateFinancialModelEditRestriction', 'updateFinancialModelEditRestrictionRequest', updateFinancialModelEditRestrictionRequest)
            const localVarPath = `/api/financial-model/{financialModelId}/edit-restriction`
                .replace('{financialModelId}', encodeURIComponent(String(financialModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFinancialModelEditRestrictionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinancialModelControllerApi - functional programming interface
 */
export const FinancialModelControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinancialModelControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 財務モデル作成
         * @param {string} simulationId 
         * @param {string} scenarioId 
         * @param {UpdateFinancialModelDetailRequest} updateFinancialModelDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFinancialModel(simulationId: string, scenarioId: string, updateFinancialModelDetailRequest: UpdateFinancialModelDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFinancialModelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFinancialModel(simulationId, scenarioId, updateFinancialModelDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialModelControllerApi.createFinancialModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務モデル削除
         * @param {string} financialModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFinancialModel(financialModelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFinancialModel(financialModelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialModelControllerApi.deleteFinancialModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務モデル詳細取得
         * @param {string} financialModelId 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchFinancialModelDetail(financialModelId: string, simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialModelDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchFinancialModelDetail(financialModelId, simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialModelControllerApi.fetchFinancialModelDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務モデル一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFinancialModels(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancialModelView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFinancialModels(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialModelControllerApi.listFinancialModels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務モデル更新
         * @param {string} financialModelId 
         * @param {string} simulationId 
         * @param {UpdateFinancialModelDetailRequest} updateFinancialModelDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFinancialModel(financialModelId: string, simulationId: string, updateFinancialModelDetailRequest: UpdateFinancialModelDetailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFinancialModel(financialModelId, simulationId, updateFinancialModelDetailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialModelControllerApi.updateFinancialModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務モデル編集制限更新
         * @param {string} financialModelId 
         * @param {UpdateFinancialModelEditRestrictionRequest} updateFinancialModelEditRestrictionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFinancialModelEditRestriction(financialModelId: string, updateFinancialModelEditRestrictionRequest: UpdateFinancialModelEditRestrictionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFinancialModelEditRestriction(financialModelId, updateFinancialModelEditRestrictionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialModelControllerApi.updateFinancialModelEditRestriction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FinancialModelControllerApi - factory interface
 */
export const FinancialModelControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinancialModelControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 財務モデル作成
         * @param {string} simulationId 
         * @param {string} scenarioId 
         * @param {UpdateFinancialModelDetailRequest} updateFinancialModelDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFinancialModel(simulationId: string, scenarioId: string, updateFinancialModelDetailRequest: UpdateFinancialModelDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFinancialModelResponse> {
            return localVarFp.createFinancialModel(simulationId, scenarioId, updateFinancialModelDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務モデル削除
         * @param {string} financialModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFinancialModel(financialModelId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFinancialModel(financialModelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務モデル詳細取得
         * @param {string} financialModelId 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialModelDetail(financialModelId: string, simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<FinancialModelDetailView> {
            return localVarFp.fetchFinancialModelDetail(financialModelId, simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務モデル一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFinancialModels(options?: RawAxiosRequestConfig): AxiosPromise<Array<FinancialModelView>> {
            return localVarFp.listFinancialModels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務モデル更新
         * @param {string} financialModelId 
         * @param {string} simulationId 
         * @param {UpdateFinancialModelDetailRequest} updateFinancialModelDetailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinancialModel(financialModelId: string, simulationId: string, updateFinancialModelDetailRequest: UpdateFinancialModelDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateFinancialModel(financialModelId, simulationId, updateFinancialModelDetailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務モデル編集制限更新
         * @param {string} financialModelId 
         * @param {UpdateFinancialModelEditRestrictionRequest} updateFinancialModelEditRestrictionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinancialModelEditRestriction(financialModelId: string, updateFinancialModelEditRestrictionRequest: UpdateFinancialModelEditRestrictionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateFinancialModelEditRestriction(financialModelId, updateFinancialModelEditRestrictionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinancialModelControllerApi - object-oriented interface
 */
export class FinancialModelControllerApi extends BaseAPI {
    /**
     * 
     * @summary 財務モデル作成
     * @param {string} simulationId 
     * @param {string} scenarioId 
     * @param {UpdateFinancialModelDetailRequest} updateFinancialModelDetailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFinancialModel(simulationId: string, scenarioId: string, updateFinancialModelDetailRequest: UpdateFinancialModelDetailRequest, options?: RawAxiosRequestConfig) {
        return FinancialModelControllerApiFp(this.configuration).createFinancialModel(simulationId, scenarioId, updateFinancialModelDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務モデル削除
     * @param {string} financialModelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFinancialModel(financialModelId: string, options?: RawAxiosRequestConfig) {
        return FinancialModelControllerApiFp(this.configuration).deleteFinancialModel(financialModelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務モデル詳細取得
     * @param {string} financialModelId 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchFinancialModelDetail(financialModelId: string, simulationId: string, options?: RawAxiosRequestConfig) {
        return FinancialModelControllerApiFp(this.configuration).fetchFinancialModelDetail(financialModelId, simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務モデル一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listFinancialModels(options?: RawAxiosRequestConfig) {
        return FinancialModelControllerApiFp(this.configuration).listFinancialModels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務モデル更新
     * @param {string} financialModelId 
     * @param {string} simulationId 
     * @param {UpdateFinancialModelDetailRequest} updateFinancialModelDetailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFinancialModel(financialModelId: string, simulationId: string, updateFinancialModelDetailRequest: UpdateFinancialModelDetailRequest, options?: RawAxiosRequestConfig) {
        return FinancialModelControllerApiFp(this.configuration).updateFinancialModel(financialModelId, simulationId, updateFinancialModelDetailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務モデル編集制限更新
     * @param {string} financialModelId 
     * @param {UpdateFinancialModelEditRestrictionRequest} updateFinancialModelEditRestrictionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFinancialModelEditRestriction(financialModelId: string, updateFinancialModelEditRestrictionRequest: UpdateFinancialModelEditRestrictionRequest, options?: RawAxiosRequestConfig) {
        return FinancialModelControllerApiFp(this.configuration).updateFinancialModelEditRestriction(financialModelId, updateFinancialModelEditRestrictionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FinancialSheetCommentControllerApi - axios parameter creator
 */
export const FinancialSheetCommentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 財務シートコメントの作成
         * @param {CreateFinancialSheetCommentRequestBody} createFinancialSheetCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFinancialSheetComment: async (createFinancialSheetCommentRequestBody: CreateFinancialSheetCommentRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFinancialSheetCommentRequestBody' is not null or undefined
            assertParamExists('createFinancialSheetComment', 'createFinancialSheetCommentRequestBody', createFinancialSheetCommentRequestBody)
            const localVarPath = `/api/financial-sheet-comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFinancialSheetCommentRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シートコメント削除
         * @param {string} financialSheetCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFinancialSheetComment: async (financialSheetCommentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'financialSheetCommentId' is not null or undefined
            assertParamExists('deleteFinancialSheetComment', 'financialSheetCommentId', financialSheetCommentId)
            const localVarPath = `/api/financial-sheet-comments/{financialSheetCommentId}`
                .replace('{financialSheetCommentId}', encodeURIComponent(String(financialSheetCommentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary セルごとの財務シートのコメント一覧(AMOUNT)
         * @param {ListAmountTypeCommentRequestBody} listAmountTypeCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAmountTypeCommentsByCell: async (listAmountTypeCommentRequestBody: ListAmountTypeCommentRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listAmountTypeCommentRequestBody' is not null or undefined
            assertParamExists('listAmountTypeCommentsByCell', 'listAmountTypeCommentRequestBody', listAmountTypeCommentRequestBody)
            const localVarPath = `/api/financial-sheet-comments/amount-type-comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listAmountTypeCommentRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ページ単位の財務シートのコメント一覧
         * @param {ListCommentsRequestBody} listCommentsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComments: async (listCommentsRequestBody: ListCommentsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listCommentsRequestBody' is not null or undefined
            assertParamExists('listComments', 'listCommentsRequestBody', listCommentsRequestBody)
            const localVarPath = `/api/financial-sheet-comments/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listCommentsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary セルごとの財務シートのコメント一覧(DIFF_RATIO, DIFF_AMOUNT)
         * @param {ListDiffTypeCommentRequestBody} listDiffTypeCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiffTypeCommentsByCell: async (listDiffTypeCommentRequestBody: ListDiffTypeCommentRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listDiffTypeCommentRequestBody' is not null or undefined
            assertParamExists('listDiffTypeCommentsByCell', 'listDiffTypeCommentRequestBody', listDiffTypeCommentRequestBody)
            const localVarPath = `/api/financial-sheet-comments/diff-type-comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listDiffTypeCommentRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinancialSheetCommentControllerApi - functional programming interface
 */
export const FinancialSheetCommentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinancialSheetCommentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 財務シートコメントの作成
         * @param {CreateFinancialSheetCommentRequestBody} createFinancialSheetCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFinancialSheetComment(createFinancialSheetCommentRequestBody: CreateFinancialSheetCommentRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFinancialSheetCommentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFinancialSheetComment(createFinancialSheetCommentRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSheetCommentControllerApi.createFinancialSheetComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シートコメント削除
         * @param {string} financialSheetCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFinancialSheetComment(financialSheetCommentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFinancialSheetComment(financialSheetCommentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSheetCommentControllerApi.deleteFinancialSheetComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary セルごとの財務シートのコメント一覧(AMOUNT)
         * @param {ListAmountTypeCommentRequestBody} listAmountTypeCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAmountTypeCommentsByCell(listAmountTypeCommentRequestBody: ListAmountTypeCommentRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSheetCommentsByCellView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAmountTypeCommentsByCell(listAmountTypeCommentRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSheetCommentControllerApi.listAmountTypeCommentsByCell']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ページ単位の財務シートのコメント一覧
         * @param {ListCommentsRequestBody} listCommentsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listComments(listCommentsRequestBody: ListCommentsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancialSheetCommentListItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listComments(listCommentsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSheetCommentControllerApi.listComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary セルごとの財務シートのコメント一覧(DIFF_RATIO, DIFF_AMOUNT)
         * @param {ListDiffTypeCommentRequestBody} listDiffTypeCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDiffTypeCommentsByCell(listDiffTypeCommentRequestBody: ListDiffTypeCommentRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSheetCommentsByCellView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDiffTypeCommentsByCell(listDiffTypeCommentRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSheetCommentControllerApi.listDiffTypeCommentsByCell']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FinancialSheetCommentControllerApi - factory interface
 */
export const FinancialSheetCommentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinancialSheetCommentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 財務シートコメントの作成
         * @param {CreateFinancialSheetCommentRequestBody} createFinancialSheetCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFinancialSheetComment(createFinancialSheetCommentRequestBody: CreateFinancialSheetCommentRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreateFinancialSheetCommentView> {
            return localVarFp.createFinancialSheetComment(createFinancialSheetCommentRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シートコメント削除
         * @param {string} financialSheetCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFinancialSheetComment(financialSheetCommentId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteFinancialSheetComment(financialSheetCommentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary セルごとの財務シートのコメント一覧(AMOUNT)
         * @param {ListAmountTypeCommentRequestBody} listAmountTypeCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAmountTypeCommentsByCell(listAmountTypeCommentRequestBody: ListAmountTypeCommentRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FinancialSheetCommentsByCellView> {
            return localVarFp.listAmountTypeCommentsByCell(listAmountTypeCommentRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ページ単位の財務シートのコメント一覧
         * @param {ListCommentsRequestBody} listCommentsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComments(listCommentsRequestBody: ListCommentsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<Array<FinancialSheetCommentListItemDto>> {
            return localVarFp.listComments(listCommentsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary セルごとの財務シートのコメント一覧(DIFF_RATIO, DIFF_AMOUNT)
         * @param {ListDiffTypeCommentRequestBody} listDiffTypeCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiffTypeCommentsByCell(listDiffTypeCommentRequestBody: ListDiffTypeCommentRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FinancialSheetCommentsByCellView> {
            return localVarFp.listDiffTypeCommentsByCell(listDiffTypeCommentRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinancialSheetCommentControllerApi - object-oriented interface
 */
export class FinancialSheetCommentControllerApi extends BaseAPI {
    /**
     * 
     * @summary 財務シートコメントの作成
     * @param {CreateFinancialSheetCommentRequestBody} createFinancialSheetCommentRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFinancialSheetComment(createFinancialSheetCommentRequestBody: CreateFinancialSheetCommentRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSheetCommentControllerApiFp(this.configuration).createFinancialSheetComment(createFinancialSheetCommentRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シートコメント削除
     * @param {string} financialSheetCommentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFinancialSheetComment(financialSheetCommentId: string, options?: RawAxiosRequestConfig) {
        return FinancialSheetCommentControllerApiFp(this.configuration).deleteFinancialSheetComment(financialSheetCommentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary セルごとの財務シートのコメント一覧(AMOUNT)
     * @param {ListAmountTypeCommentRequestBody} listAmountTypeCommentRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAmountTypeCommentsByCell(listAmountTypeCommentRequestBody: ListAmountTypeCommentRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSheetCommentControllerApiFp(this.configuration).listAmountTypeCommentsByCell(listAmountTypeCommentRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ページ単位の財務シートのコメント一覧
     * @param {ListCommentsRequestBody} listCommentsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listComments(listCommentsRequestBody: ListCommentsRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSheetCommentControllerApiFp(this.configuration).listComments(listCommentsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary セルごとの財務シートのコメント一覧(DIFF_RATIO, DIFF_AMOUNT)
     * @param {ListDiffTypeCommentRequestBody} listDiffTypeCommentRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listDiffTypeCommentsByCell(listDiffTypeCommentRequestBody: ListDiffTypeCommentRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSheetCommentControllerApiFp(this.configuration).listDiffTypeCommentsByCell(listDiffTypeCommentRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FinancialSimulationControllerApi - axios parameter creator
 */
export const FinancialSimulationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 財務シミュレーション期間計の追加
         * @param {string} simulationId 
         * @param {AddPeriodSumFormulaRequestBody} addPeriodSumFormulaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPeriodSumFormula: async (simulationId: string, addPeriodSumFormulaRequestBody: AddPeriodSumFormulaRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('addPeriodSumFormula', 'simulationId', simulationId)
            // verify required parameter 'addPeriodSumFormulaRequestBody' is not null or undefined
            assertParamExists('addPeriodSumFormula', 'addPeriodSumFormulaRequestBody', addPeriodSumFormulaRequestBody)
            const localVarPath = `/api/financial-simulation/{simulationId}/period-sum-formulas`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPeriodSumFormulaRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーション作成
         * @param {CreateFinancialSimulationRequestBody} createFinancialSimulationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFinancialSimulation: async (createFinancialSimulationRequestBody: CreateFinancialSimulationRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFinancialSimulationRequestBody' is not null or undefined
            assertParamExists('createFinancialSimulation', 'createFinancialSimulationRequestBody', createFinancialSimulationRequestBody)
            const localVarPath = `/api/financial-simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFinancialSimulationRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式を作成
         * @param {string} simulationId 
         * @param {UpsertFinancialSimulationDatasetFormulaRequestBody} upsertFinancialSimulationDatasetFormulaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFinancialSimulationDatasetFormula: async (simulationId: string, upsertFinancialSimulationDatasetFormulaRequestBody: UpsertFinancialSimulationDatasetFormulaRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('createFinancialSimulationDatasetFormula', 'simulationId', simulationId)
            // verify required parameter 'upsertFinancialSimulationDatasetFormulaRequestBody' is not null or undefined
            assertParamExists('createFinancialSimulationDatasetFormula', 'upsertFinancialSimulationDatasetFormulaRequestBody', upsertFinancialSimulationDatasetFormulaRequestBody)
            const localVarPath = `/api/financial-simulation/{simulationId}/dataset-formulas`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertFinancialSimulationDatasetFormulaRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFinancialSimulation: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deleteFinancialSimulation', 'simulationId', simulationId)
            const localVarPath = `/api/financial-simulation/{simulationId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式を削除
         * @param {string} simulationId 
         * @param {string} formulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFinancialSimulationDatasetFormula: async (simulationId: string, formulaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deleteFinancialSimulationDatasetFormula', 'simulationId', simulationId)
            // verify required parameter 'formulaId' is not null or undefined
            assertParamExists('deleteFinancialSimulationDatasetFormula', 'formulaId', formulaId)
            const localVarPath = `/api/financial-simulation/{simulationId}/dataset-formulas/{formulaId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)))
                .replace('{formulaId}', encodeURIComponent(String(formulaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーション詳細取得
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialSimulation: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('fetchFinancialSimulation', 'simulationId', simulationId)
            const localVarPath = `/api/financial-simulation/{simulationId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目階層の形式で科目ごとに表示非表示の計算式を返す
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialSimulationDatasetFormulaHiddenAccountIds: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('fetchFinancialSimulationDatasetFormulaHiddenAccountIds', 'simulationId', simulationId)
            const localVarPath = `/api/financial-simulation/{simulationId}/dataset-formulas/hidden-account-ids`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務モデルを参照しているシミュレーション一覧取得
         * @param {string} financialModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialSimulationsByFinancialModelId: async (financialModelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'financialModelId' is not null or undefined
            assertParamExists('fetchFinancialSimulationsByFinancialModelId', 'financialModelId', financialModelId)
            const localVarPath = `/api/financial-simulation/by-financial-model/{financialModelId}`
                .replace('{financialModelId}', encodeURIComponent(String(financialModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary データセット計算式用の売上科目を取得
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSalesAccountForDatasetFormula: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('fetchSalesAccountForDatasetFormula', 'simulationId', simulationId)
            const localVarPath = `/api/financial-simulation/{simulationId}/dataset-formulas/sales-account`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーションフォルダ・シミュレーション統合一覧取得
         * @param {string} [parentFolderId] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFinancialSimulationFoldersAndSimulations: async (parentFolderId?: string, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/financial-simulation/folders-and-simulations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (parentFolderId !== undefined) {
                localVarQueryParameter['parentFolderId'] = parentFolderId;
            }

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーション一覧取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFinancialSimulations: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/financial-simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーションを指定したフォルダへ移動する
         * @param {string} simulationId 
         * @param {MoveFinancialSimulationBody} moveFinancialSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSimulation: async (simulationId: string, moveFinancialSimulationBody: MoveFinancialSimulationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('moveSimulation', 'simulationId', simulationId)
            // verify required parameter 'moveFinancialSimulationBody' is not null or undefined
            assertParamExists('moveSimulation', 'moveFinancialSimulationBody', moveFinancialSimulationBody)
            const localVarPath = `/api/financial-simulation/{simulationId}/move`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveFinancialSimulationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーション期間計の削除
         * @param {string} simulationId 
         * @param {string} periodSumFormulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePeriodSumFormula: async (simulationId: string, periodSumFormulaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('removePeriodSumFormula', 'simulationId', simulationId)
            // verify required parameter 'periodSumFormulaId' is not null or undefined
            assertParamExists('removePeriodSumFormula', 'periodSumFormulaId', periodSumFormulaId)
            const localVarPath = `/api/financial-simulation/{simulationId}/period-sum-formulas/{periodSumFormulaId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)))
                .replace('{periodSumFormulaId}', encodeURIComponent(String(periodSumFormulaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーションの編集制限を更新
         * @param {string} simulationId 
         * @param {UpdateFinancialSimulationEditRestrictionRequestBody} updateFinancialSimulationEditRestrictionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEditRestriction: async (simulationId: string, updateFinancialSimulationEditRestrictionRequestBody: UpdateFinancialSimulationEditRestrictionRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateEditRestriction', 'simulationId', simulationId)
            // verify required parameter 'updateFinancialSimulationEditRestrictionRequestBody' is not null or undefined
            assertParamExists('updateEditRestriction', 'updateFinancialSimulationEditRestrictionRequestBody', updateFinancialSimulationEditRestrictionRequestBody)
            const localVarPath = `/api/financial-simulation/{simulationId}/edit-restriction`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFinancialSimulationEditRestrictionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式を更新
         * @param {string} simulationId 
         * @param {string} formulaId 
         * @param {UpsertFinancialSimulationDatasetFormulaRequestBody} upsertFinancialSimulationDatasetFormulaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinancialSimulationDatasetFormula: async (simulationId: string, formulaId: string, upsertFinancialSimulationDatasetFormulaRequestBody: UpsertFinancialSimulationDatasetFormulaRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateFinancialSimulationDatasetFormula', 'simulationId', simulationId)
            // verify required parameter 'formulaId' is not null or undefined
            assertParamExists('updateFinancialSimulationDatasetFormula', 'formulaId', formulaId)
            // verify required parameter 'upsertFinancialSimulationDatasetFormulaRequestBody' is not null or undefined
            assertParamExists('updateFinancialSimulationDatasetFormula', 'upsertFinancialSimulationDatasetFormulaRequestBody', upsertFinancialSimulationDatasetFormulaRequestBody)
            const localVarPath = `/api/financial-simulation/{simulationId}/dataset-formulas/{formulaId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)))
                .replace('{formulaId}', encodeURIComponent(String(formulaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertFinancialSimulationDatasetFormulaRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式の表示しない科目を更新
         * @param {string} simulationId 
         * @param {UpdateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody} updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinancialSimulationDatasetFormulaHiddenAccountIds: async (simulationId: string, updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody: UpdateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateFinancialSimulationDatasetFormulaHiddenAccountIds', 'simulationId', simulationId)
            // verify required parameter 'updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody' is not null or undefined
            assertParamExists('updateFinancialSimulationDatasetFormulaHiddenAccountIds', 'updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody', updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody)
            const localVarPath = `/api/financial-simulation/{simulationId}/dataset-formulas/hidden-account-ids`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーション名の更新
         * @param {string} simulationId 
         * @param {UpdateFinancialSimulationNameRequestBody} updateFinancialSimulationNameRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimulationName: async (simulationId: string, updateFinancialSimulationNameRequestBody: UpdateFinancialSimulationNameRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateSimulationName', 'simulationId', simulationId)
            // verify required parameter 'updateFinancialSimulationNameRequestBody' is not null or undefined
            assertParamExists('updateSimulationName', 'updateFinancialSimulationNameRequestBody', updateFinancialSimulationNameRequestBody)
            const localVarPath = `/api/financial-simulation/{simulationId}/name`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFinancialSimulationNameRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーションの条件を保存
         * @param {string} simulationId 
         * @param {UpsertFinancialSimulationConditionRequestBody} upsertFinancialSimulationConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFinancialSimulationCondition: async (simulationId: string, upsertFinancialSimulationConditionRequestBody: UpsertFinancialSimulationConditionRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('upsertFinancialSimulationCondition', 'simulationId', simulationId)
            // verify required parameter 'upsertFinancialSimulationConditionRequestBody' is not null or undefined
            assertParamExists('upsertFinancialSimulationCondition', 'upsertFinancialSimulationConditionRequestBody', upsertFinancialSimulationConditionRequestBody)
            const localVarPath = `/api/financial-simulation/{simulationId}/condition`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertFinancialSimulationConditionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinancialSimulationControllerApi - functional programming interface
 */
export const FinancialSimulationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinancialSimulationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 財務シミュレーション期間計の追加
         * @param {string} simulationId 
         * @param {AddPeriodSumFormulaRequestBody} addPeriodSumFormulaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPeriodSumFormula(simulationId: string, addPeriodSumFormulaRequestBody: AddPeriodSumFormulaRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSimulationPeriodSumFormulaIdView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPeriodSumFormula(simulationId, addPeriodSumFormulaRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.addPeriodSumFormula']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーション作成
         * @param {CreateFinancialSimulationRequestBody} createFinancialSimulationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFinancialSimulation(createFinancialSimulationRequestBody: CreateFinancialSimulationRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedFinancialSimulationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFinancialSimulation(createFinancialSimulationRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.createFinancialSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式を作成
         * @param {string} simulationId 
         * @param {UpsertFinancialSimulationDatasetFormulaRequestBody} upsertFinancialSimulationDatasetFormulaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFinancialSimulationDatasetFormula(simulationId: string, upsertFinancialSimulationDatasetFormulaRequestBody: UpsertFinancialSimulationDatasetFormulaRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSimulationDatasetFormulaDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFinancialSimulationDatasetFormula(simulationId, upsertFinancialSimulationDatasetFormulaRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.createFinancialSimulationDatasetFormula']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFinancialSimulation(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFinancialSimulation(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.deleteFinancialSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式を削除
         * @param {string} simulationId 
         * @param {string} formulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFinancialSimulationDatasetFormula(simulationId: string, formulaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFinancialSimulationDatasetFormula(simulationId, formulaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.deleteFinancialSimulationDatasetFormula']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーション詳細取得
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchFinancialSimulation(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSimulationDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchFinancialSimulation(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.fetchFinancialSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目階層の形式で科目ごとに表示非表示の計算式を返す
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountTreeWithHiddenFinancialSimulationDatasetFormulaIdsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.fetchFinancialSimulationDatasetFormulaHiddenAccountIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務モデルを参照しているシミュレーション一覧取得
         * @param {string} financialModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchFinancialSimulationsByFinancialModelId(financialModelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancialSimulationReferenceView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchFinancialSimulationsByFinancialModelId(financialModelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.fetchFinancialSimulationsByFinancialModelId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary データセット計算式用の売上科目を取得
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchSalesAccountForDatasetFormula(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesAccountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchSalesAccountForDatasetFormula(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.fetchSalesAccountForDatasetFormula']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーションフォルダ・シミュレーション統合一覧取得
         * @param {string} [parentFolderId] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFinancialSimulationFoldersAndSimulations(parentFolderId?: string, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancialSimulationFolderListItemView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFinancialSimulationFoldersAndSimulations(parentFolderId, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.listFinancialSimulationFoldersAndSimulations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーション一覧取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFinancialSimulations(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoFinancialSimulationListItemView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFinancialSimulations(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.listFinancialSimulations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーションを指定したフォルダへ移動する
         * @param {string} simulationId 
         * @param {MoveFinancialSimulationBody} moveFinancialSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveSimulation(simulationId: string, moveFinancialSimulationBody: MoveFinancialSimulationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveSimulation(simulationId, moveFinancialSimulationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.moveSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーション期間計の削除
         * @param {string} simulationId 
         * @param {string} periodSumFormulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePeriodSumFormula(simulationId: string, periodSumFormulaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePeriodSumFormula(simulationId, periodSumFormulaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.removePeriodSumFormula']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーションの編集制限を更新
         * @param {string} simulationId 
         * @param {UpdateFinancialSimulationEditRestrictionRequestBody} updateFinancialSimulationEditRestrictionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEditRestriction(simulationId: string, updateFinancialSimulationEditRestrictionRequestBody: UpdateFinancialSimulationEditRestrictionRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateFinancialSimulationEditRestrictionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEditRestriction(simulationId, updateFinancialSimulationEditRestrictionRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.updateEditRestriction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式を更新
         * @param {string} simulationId 
         * @param {string} formulaId 
         * @param {UpsertFinancialSimulationDatasetFormulaRequestBody} upsertFinancialSimulationDatasetFormulaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFinancialSimulationDatasetFormula(simulationId: string, formulaId: string, upsertFinancialSimulationDatasetFormulaRequestBody: UpsertFinancialSimulationDatasetFormulaRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSimulationDatasetFormulaDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFinancialSimulationDatasetFormula(simulationId, formulaId, upsertFinancialSimulationDatasetFormulaRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.updateFinancialSimulationDatasetFormula']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式の表示しない科目を更新
         * @param {string} simulationId 
         * @param {UpdateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody} updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId: string, updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody: UpdateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId, updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.updateFinancialSimulationDatasetFormulaHiddenAccountIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーション名の更新
         * @param {string} simulationId 
         * @param {UpdateFinancialSimulationNameRequestBody} updateFinancialSimulationNameRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSimulationName(simulationId: string, updateFinancialSimulationNameRequestBody: UpdateFinancialSimulationNameRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSimulationName(simulationId, updateFinancialSimulationNameRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.updateSimulationName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーションの条件を保存
         * @param {string} simulationId 
         * @param {UpsertFinancialSimulationConditionRequestBody} upsertFinancialSimulationConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertFinancialSimulationCondition(simulationId: string, upsertFinancialSimulationConditionRequestBody: UpsertFinancialSimulationConditionRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertFinancialSimulationConditionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertFinancialSimulationCondition(simulationId, upsertFinancialSimulationConditionRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationControllerApi.upsertFinancialSimulationCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FinancialSimulationControllerApi - factory interface
 */
export const FinancialSimulationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinancialSimulationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 財務シミュレーション期間計の追加
         * @param {string} simulationId 
         * @param {AddPeriodSumFormulaRequestBody} addPeriodSumFormulaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPeriodSumFormula(simulationId: string, addPeriodSumFormulaRequestBody: AddPeriodSumFormulaRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FinancialSimulationPeriodSumFormulaIdView> {
            return localVarFp.addPeriodSumFormula(simulationId, addPeriodSumFormulaRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーション作成
         * @param {CreateFinancialSimulationRequestBody} createFinancialSimulationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFinancialSimulation(createFinancialSimulationRequestBody: CreateFinancialSimulationRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreatedFinancialSimulationDto> {
            return localVarFp.createFinancialSimulation(createFinancialSimulationRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式を作成
         * @param {string} simulationId 
         * @param {UpsertFinancialSimulationDatasetFormulaRequestBody} upsertFinancialSimulationDatasetFormulaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFinancialSimulationDatasetFormula(simulationId: string, upsertFinancialSimulationDatasetFormulaRequestBody: UpsertFinancialSimulationDatasetFormulaRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FinancialSimulationDatasetFormulaDetailView> {
            return localVarFp.createFinancialSimulationDatasetFormula(simulationId, upsertFinancialSimulationDatasetFormulaRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFinancialSimulation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteFinancialSimulation(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式を削除
         * @param {string} simulationId 
         * @param {string} formulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFinancialSimulationDatasetFormula(simulationId: string, formulaId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteFinancialSimulationDatasetFormula(simulationId, formulaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーション詳細取得
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialSimulation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<FinancialSimulationDetailView> {
            return localVarFp.fetchFinancialSimulation(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目階層の形式で科目ごとに表示非表示の計算式を返す
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountTreeWithHiddenFinancialSimulationDatasetFormulaIdsView> {
            return localVarFp.fetchFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務モデルを参照しているシミュレーション一覧取得
         * @param {string} financialModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialSimulationsByFinancialModelId(financialModelId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FinancialSimulationReferenceView>> {
            return localVarFp.fetchFinancialSimulationsByFinancialModelId(financialModelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary データセット計算式用の売上科目を取得
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSalesAccountForDatasetFormula(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<SalesAccountView> {
            return localVarFp.fetchSalesAccountForDatasetFormula(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーションフォルダ・シミュレーション統合一覧取得
         * @param {string} [parentFolderId] 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFinancialSimulationFoldersAndSimulations(parentFolderId?: string, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FinancialSimulationFolderListItemView>> {
            return localVarFp.listFinancialSimulationFoldersAndSimulations(parentFolderId, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーション一覧取得
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFinancialSimulations(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoFinancialSimulationListItemView> {
            return localVarFp.listFinancialSimulations(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーションを指定したフォルダへ移動する
         * @param {string} simulationId 
         * @param {MoveFinancialSimulationBody} moveFinancialSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSimulation(simulationId: string, moveFinancialSimulationBody: MoveFinancialSimulationBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveSimulation(simulationId, moveFinancialSimulationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーション期間計の削除
         * @param {string} simulationId 
         * @param {string} periodSumFormulaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePeriodSumFormula(simulationId: string, periodSumFormulaId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.removePeriodSumFormula(simulationId, periodSumFormulaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーションの編集制限を更新
         * @param {string} simulationId 
         * @param {UpdateFinancialSimulationEditRestrictionRequestBody} updateFinancialSimulationEditRestrictionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEditRestriction(simulationId: string, updateFinancialSimulationEditRestrictionRequestBody: UpdateFinancialSimulationEditRestrictionRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<UpdateFinancialSimulationEditRestrictionView> {
            return localVarFp.updateEditRestriction(simulationId, updateFinancialSimulationEditRestrictionRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式を更新
         * @param {string} simulationId 
         * @param {string} formulaId 
         * @param {UpsertFinancialSimulationDatasetFormulaRequestBody} upsertFinancialSimulationDatasetFormulaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinancialSimulationDatasetFormula(simulationId: string, formulaId: string, upsertFinancialSimulationDatasetFormulaRequestBody: UpsertFinancialSimulationDatasetFormulaRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FinancialSimulationDatasetFormulaDetailView> {
            return localVarFp.updateFinancialSimulationDatasetFormula(simulationId, formulaId, upsertFinancialSimulationDatasetFormulaRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーションのデータセット計算式の表示しない科目を更新
         * @param {string} simulationId 
         * @param {UpdateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody} updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId: string, updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody: UpdateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId, updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーション名の更新
         * @param {string} simulationId 
         * @param {UpdateFinancialSimulationNameRequestBody} updateFinancialSimulationNameRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimulationName(simulationId: string, updateFinancialSimulationNameRequestBody: UpdateFinancialSimulationNameRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateSimulationName(simulationId, updateFinancialSimulationNameRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーションの条件を保存
         * @param {string} simulationId 
         * @param {UpsertFinancialSimulationConditionRequestBody} upsertFinancialSimulationConditionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFinancialSimulationCondition(simulationId: string, upsertFinancialSimulationConditionRequestBody: UpsertFinancialSimulationConditionRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<UpsertFinancialSimulationConditionResponse> {
            return localVarFp.upsertFinancialSimulationCondition(simulationId, upsertFinancialSimulationConditionRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinancialSimulationControllerApi - object-oriented interface
 */
export class FinancialSimulationControllerApi extends BaseAPI {
    /**
     * 
     * @summary 財務シミュレーション期間計の追加
     * @param {string} simulationId 
     * @param {AddPeriodSumFormulaRequestBody} addPeriodSumFormulaRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addPeriodSumFormula(simulationId: string, addPeriodSumFormulaRequestBody: AddPeriodSumFormulaRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).addPeriodSumFormula(simulationId, addPeriodSumFormulaRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーション作成
     * @param {CreateFinancialSimulationRequestBody} createFinancialSimulationRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFinancialSimulation(createFinancialSimulationRequestBody: CreateFinancialSimulationRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).createFinancialSimulation(createFinancialSimulationRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーションのデータセット計算式を作成
     * @param {string} simulationId 
     * @param {UpsertFinancialSimulationDatasetFormulaRequestBody} upsertFinancialSimulationDatasetFormulaRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFinancialSimulationDatasetFormula(simulationId: string, upsertFinancialSimulationDatasetFormulaRequestBody: UpsertFinancialSimulationDatasetFormulaRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).createFinancialSimulationDatasetFormula(simulationId, upsertFinancialSimulationDatasetFormulaRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFinancialSimulation(simulationId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).deleteFinancialSimulation(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーションのデータセット計算式を削除
     * @param {string} simulationId 
     * @param {string} formulaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFinancialSimulationDatasetFormula(simulationId: string, formulaId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).deleteFinancialSimulationDatasetFormula(simulationId, formulaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーション詳細取得
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchFinancialSimulation(simulationId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).fetchFinancialSimulation(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目階層の形式で科目ごとに表示非表示の計算式を返す
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).fetchFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務モデルを参照しているシミュレーション一覧取得
     * @param {string} financialModelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchFinancialSimulationsByFinancialModelId(financialModelId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).fetchFinancialSimulationsByFinancialModelId(financialModelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary データセット計算式用の売上科目を取得
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchSalesAccountForDatasetFormula(simulationId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).fetchSalesAccountForDatasetFormula(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーションフォルダ・シミュレーション統合一覧取得
     * @param {string} [parentFolderId] 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listFinancialSimulationFoldersAndSimulations(parentFolderId?: string, searchWord?: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).listFinancialSimulationFoldersAndSimulations(parentFolderId, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーション一覧取得
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listFinancialSimulations(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).listFinancialSimulations(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーションを指定したフォルダへ移動する
     * @param {string} simulationId 
     * @param {MoveFinancialSimulationBody} moveFinancialSimulationBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveSimulation(simulationId: string, moveFinancialSimulationBody: MoveFinancialSimulationBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).moveSimulation(simulationId, moveFinancialSimulationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーション期間計の削除
     * @param {string} simulationId 
     * @param {string} periodSumFormulaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removePeriodSumFormula(simulationId: string, periodSumFormulaId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).removePeriodSumFormula(simulationId, periodSumFormulaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーションの編集制限を更新
     * @param {string} simulationId 
     * @param {UpdateFinancialSimulationEditRestrictionRequestBody} updateFinancialSimulationEditRestrictionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEditRestriction(simulationId: string, updateFinancialSimulationEditRestrictionRequestBody: UpdateFinancialSimulationEditRestrictionRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).updateEditRestriction(simulationId, updateFinancialSimulationEditRestrictionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーションのデータセット計算式を更新
     * @param {string} simulationId 
     * @param {string} formulaId 
     * @param {UpsertFinancialSimulationDatasetFormulaRequestBody} upsertFinancialSimulationDatasetFormulaRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFinancialSimulationDatasetFormula(simulationId: string, formulaId: string, upsertFinancialSimulationDatasetFormulaRequestBody: UpsertFinancialSimulationDatasetFormulaRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).updateFinancialSimulationDatasetFormula(simulationId, formulaId, upsertFinancialSimulationDatasetFormulaRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーションのデータセット計算式の表示しない科目を更新
     * @param {string} simulationId 
     * @param {UpdateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody} updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId: string, updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody: UpdateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).updateFinancialSimulationDatasetFormulaHiddenAccountIds(simulationId, updateFinancialSimulationDatasetFormulaHiddenAccountIdsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーション名の更新
     * @param {string} simulationId 
     * @param {UpdateFinancialSimulationNameRequestBody} updateFinancialSimulationNameRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSimulationName(simulationId: string, updateFinancialSimulationNameRequestBody: UpdateFinancialSimulationNameRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).updateSimulationName(simulationId, updateFinancialSimulationNameRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーションの条件を保存
     * @param {string} simulationId 
     * @param {UpsertFinancialSimulationConditionRequestBody} upsertFinancialSimulationConditionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upsertFinancialSimulationCondition(simulationId: string, upsertFinancialSimulationConditionRequestBody: UpsertFinancialSimulationConditionRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationControllerApiFp(this.configuration).upsertFinancialSimulationCondition(simulationId, upsertFinancialSimulationConditionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FinancialSimulationDescriptionControllerApi - axios parameter creator
 */
export const FinancialSimulationDescriptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 財務シミュレーション備考を取得する
         * @param {string} financialSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFinancialSimulationDescription: async (financialSimulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'financialSimulationId' is not null or undefined
            assertParamExists('findFinancialSimulationDescription', 'financialSimulationId', financialSimulationId)
            const localVarPath = `/api/financial-simulation/{financialSimulationId}/description`
                .replace('{financialSimulationId}', encodeURIComponent(String(financialSimulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 財務シミュレーション備考を作成または更新する
         * @param {string} financialSimulationId 
         * @param {UpsertFinancialSimulationDescriptionBody} upsertFinancialSimulationDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFinancialSimulationDescription: async (financialSimulationId: string, upsertFinancialSimulationDescriptionBody: UpsertFinancialSimulationDescriptionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'financialSimulationId' is not null or undefined
            assertParamExists('upsertFinancialSimulationDescription', 'financialSimulationId', financialSimulationId)
            // verify required parameter 'upsertFinancialSimulationDescriptionBody' is not null or undefined
            assertParamExists('upsertFinancialSimulationDescription', 'upsertFinancialSimulationDescriptionBody', upsertFinancialSimulationDescriptionBody)
            const localVarPath = `/api/financial-simulation/{financialSimulationId}/description`
                .replace('{financialSimulationId}', encodeURIComponent(String(financialSimulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertFinancialSimulationDescriptionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinancialSimulationDescriptionControllerApi - functional programming interface
 */
export const FinancialSimulationDescriptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinancialSimulationDescriptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 財務シミュレーション備考を取得する
         * @param {string} financialSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findFinancialSimulationDescription(financialSimulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSimulationDescriptionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findFinancialSimulationDescription(financialSimulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationDescriptionControllerApi.findFinancialSimulationDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 財務シミュレーション備考を作成または更新する
         * @param {string} financialSimulationId 
         * @param {UpsertFinancialSimulationDescriptionBody} upsertFinancialSimulationDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertFinancialSimulationDescription(financialSimulationId: string, upsertFinancialSimulationDescriptionBody: UpsertFinancialSimulationDescriptionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertFinancialSimulationDescription(financialSimulationId, upsertFinancialSimulationDescriptionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationDescriptionControllerApi.upsertFinancialSimulationDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FinancialSimulationDescriptionControllerApi - factory interface
 */
export const FinancialSimulationDescriptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinancialSimulationDescriptionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 財務シミュレーション備考を取得する
         * @param {string} financialSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findFinancialSimulationDescription(financialSimulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<FinancialSimulationDescriptionView> {
            return localVarFp.findFinancialSimulationDescription(financialSimulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 財務シミュレーション備考を作成または更新する
         * @param {string} financialSimulationId 
         * @param {UpsertFinancialSimulationDescriptionBody} upsertFinancialSimulationDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFinancialSimulationDescription(financialSimulationId: string, upsertFinancialSimulationDescriptionBody: UpsertFinancialSimulationDescriptionBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.upsertFinancialSimulationDescription(financialSimulationId, upsertFinancialSimulationDescriptionBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinancialSimulationDescriptionControllerApi - object-oriented interface
 */
export class FinancialSimulationDescriptionControllerApi extends BaseAPI {
    /**
     * 
     * @summary 財務シミュレーション備考を取得する
     * @param {string} financialSimulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findFinancialSimulationDescription(financialSimulationId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationDescriptionControllerApiFp(this.configuration).findFinancialSimulationDescription(financialSimulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 財務シミュレーション備考を作成または更新する
     * @param {string} financialSimulationId 
     * @param {UpsertFinancialSimulationDescriptionBody} upsertFinancialSimulationDescriptionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upsertFinancialSimulationDescription(financialSimulationId: string, upsertFinancialSimulationDescriptionBody: UpsertFinancialSimulationDescriptionBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationDescriptionControllerApiFp(this.configuration).upsertFinancialSimulationDescription(financialSimulationId, upsertFinancialSimulationDescriptionBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FinancialSimulationFolderControllerApi - axios parameter creator
 */
export const FinancialSimulationFolderControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary フォルダを新規作成する
         * @param {CreateFinancialSimulationFolderBody} createFinancialSimulationFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder: async (createFinancialSimulationFolderBody: CreateFinancialSimulationFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFinancialSimulationFolderBody' is not null or undefined
            assertParamExists('createFolder', 'createFinancialSimulationFolderBody', createFinancialSimulationFolderBody)
            const localVarPath = `/api/financial_simulation_folder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFinancialSimulationFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダを削除する
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteFolder', 'folderId', folderId)
            const localVarPath = `/api/financial_simulation_folder/{folderId}`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダのパンくずリスト取得
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderBreadcrumbs: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('getFolderBreadcrumbs', 'folderId', folderId)
            const localVarPath = `/api/financial_simulation_folder/{folderId}/breadcrumbs`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダ情報一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderTreeForSelection1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/financial_simulation_folder/for-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダを指定したフォルダへ移動する
         * @param {string} folderId 
         * @param {MoveFinancialSimulationFolderBody} moveFinancialSimulationFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveFolder: async (folderId: string, moveFinancialSimulationFolderBody: MoveFinancialSimulationFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('moveFolder', 'folderId', folderId)
            // verify required parameter 'moveFinancialSimulationFolderBody' is not null or undefined
            assertParamExists('moveFolder', 'moveFinancialSimulationFolderBody', moveFinancialSimulationFolderBody)
            const localVarPath = `/api/financial_simulation_folder/{folderId}/move`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveFinancialSimulationFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダの名称を更新する
         * @param {string} folderId 
         * @param {RenameFinancialSimulationFolderBody} renameFinancialSimulationFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFolder: async (folderId: string, renameFinancialSimulationFolderBody: RenameFinancialSimulationFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('renameFolder', 'folderId', folderId)
            // verify required parameter 'renameFinancialSimulationFolderBody' is not null or undefined
            assertParamExists('renameFolder', 'renameFinancialSimulationFolderBody', renameFinancialSimulationFolderBody)
            const localVarPath = `/api/financial_simulation_folder/{folderId}/name`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameFinancialSimulationFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinancialSimulationFolderControllerApi - functional programming interface
 */
export const FinancialSimulationFolderControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinancialSimulationFolderControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary フォルダを新規作成する
         * @param {CreateFinancialSimulationFolderBody} createFinancialSimulationFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolder(createFinancialSimulationFolderBody: CreateFinancialSimulationFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolder(createFinancialSimulationFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationFolderControllerApi.createFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダを削除する
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationFolderControllerApi.deleteFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダのパンくずリスト取得
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFolderBreadcrumbs(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancialSimulationFolderBreadcrumbView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFolderBreadcrumbs(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationFolderControllerApi.getFolderBreadcrumbs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダ情報一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFolderTreeForSelection1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSimulationFolderTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFolderTreeForSelection1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationFolderControllerApi.getFolderTreeForSelection1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダを指定したフォルダへ移動する
         * @param {string} folderId 
         * @param {MoveFinancialSimulationFolderBody} moveFinancialSimulationFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveFolder(folderId: string, moveFinancialSimulationFolderBody: MoveFinancialSimulationFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveFolder(folderId, moveFinancialSimulationFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationFolderControllerApi.moveFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダの名称を更新する
         * @param {string} folderId 
         * @param {RenameFinancialSimulationFolderBody} renameFinancialSimulationFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameFolder(folderId: string, renameFinancialSimulationFolderBody: RenameFinancialSimulationFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameFolder(folderId, renameFinancialSimulationFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationFolderControllerApi.renameFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FinancialSimulationFolderControllerApi - factory interface
 */
export const FinancialSimulationFolderControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinancialSimulationFolderControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary フォルダを新規作成する
         * @param {CreateFinancialSimulationFolderBody} createFinancialSimulationFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(createFinancialSimulationFolderBody: CreateFinancialSimulationFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createFolder(createFinancialSimulationFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダを削除する
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダのパンくずリスト取得
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderBreadcrumbs(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FinancialSimulationFolderBreadcrumbView>> {
            return localVarFp.getFolderBreadcrumbs(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダ情報一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderTreeForSelection1(options?: RawAxiosRequestConfig): AxiosPromise<FinancialSimulationFolderTreeForSelectionView> {
            return localVarFp.getFolderTreeForSelection1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダを指定したフォルダへ移動する
         * @param {string} folderId 
         * @param {MoveFinancialSimulationFolderBody} moveFinancialSimulationFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveFolder(folderId: string, moveFinancialSimulationFolderBody: MoveFinancialSimulationFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveFolder(folderId, moveFinancialSimulationFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダの名称を更新する
         * @param {string} folderId 
         * @param {RenameFinancialSimulationFolderBody} renameFinancialSimulationFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFolder(folderId: string, renameFinancialSimulationFolderBody: RenameFinancialSimulationFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.renameFolder(folderId, renameFinancialSimulationFolderBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinancialSimulationFolderControllerApi - object-oriented interface
 */
export class FinancialSimulationFolderControllerApi extends BaseAPI {
    /**
     * 
     * @summary フォルダを新規作成する
     * @param {CreateFinancialSimulationFolderBody} createFinancialSimulationFolderBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFolder(createFinancialSimulationFolderBody: CreateFinancialSimulationFolderBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationFolderControllerApiFp(this.configuration).createFolder(createFinancialSimulationFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダを削除する
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFolder(folderId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationFolderControllerApiFp(this.configuration).deleteFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダのパンくずリスト取得
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFolderBreadcrumbs(folderId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationFolderControllerApiFp(this.configuration).getFolderBreadcrumbs(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダ情報一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFolderTreeForSelection1(options?: RawAxiosRequestConfig) {
        return FinancialSimulationFolderControllerApiFp(this.configuration).getFolderTreeForSelection1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダを指定したフォルダへ移動する
     * @param {string} folderId 
     * @param {MoveFinancialSimulationFolderBody} moveFinancialSimulationFolderBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveFolder(folderId: string, moveFinancialSimulationFolderBody: MoveFinancialSimulationFolderBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationFolderControllerApiFp(this.configuration).moveFolder(folderId, moveFinancialSimulationFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダの名称を更新する
     * @param {string} folderId 
     * @param {RenameFinancialSimulationFolderBody} renameFinancialSimulationFolderBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public renameFolder(folderId: string, renameFinancialSimulationFolderBody: RenameFinancialSimulationFolderBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationFolderControllerApiFp(this.configuration).renameFolder(folderId, renameFinancialSimulationFolderBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FinancialSimulationScenarioTableControllerApi - axios parameter creator
 */
export const FinancialSimulationScenarioTableControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シナリオを計画として保存
         * @param {string} scenarioId 
         * @param {ConvertScenarioTableToPlanRequestBody} convertScenarioTableToPlanRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertScenarioTableToPlan: async (scenarioId: string, convertScenarioTableToPlanRequestBody: ConvertScenarioTableToPlanRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('convertScenarioTableToPlan', 'scenarioId', scenarioId)
            // verify required parameter 'convertScenarioTableToPlanRequestBody' is not null or undefined
            assertParamExists('convertScenarioTableToPlan', 'convertScenarioTableToPlanRequestBody', convertScenarioTableToPlanRequestBody)
            const localVarPath = `/api/financial-simulation-scenarios/{scenarioId}/convert`
                .replace('{scenarioId}', encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(convertScenarioTableToPlanRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シナリオテーブルのExcelダウンロード
         * @param {string} scenarioId 
         * @param {FetchFinancialSimulationScenarioRequestBody} fetchFinancialSimulationScenarioRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadScenarioTableExcel: async (scenarioId: string, fetchFinancialSimulationScenarioRequestBody: FetchFinancialSimulationScenarioRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('downloadScenarioTableExcel', 'scenarioId', scenarioId)
            // verify required parameter 'fetchFinancialSimulationScenarioRequestBody' is not null or undefined
            assertParamExists('downloadScenarioTableExcel', 'fetchFinancialSimulationScenarioRequestBody', fetchFinancialSimulationScenarioRequestBody)
            const localVarPath = `/api/financial-simulation-scenarios/{scenarioId}/excel`
                .replace('{scenarioId}', encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchFinancialSimulationScenarioRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シナリオのパラメータテーブルを取得
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScenarioParameterTable: async (scenarioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('fetchScenarioParameterTable', 'scenarioId', scenarioId)
            const localVarPath = `/api/financial-simulation-scenarios/{scenarioId}/parameter-table`
                .replace('{scenarioId}', encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シナリオについてシミュレーションを行い、シナリオを取得
         * @param {string} scenarioId 
         * @param {FetchFinancialSimulationScenarioRequestBody} fetchFinancialSimulationScenarioRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScenarioTable: async (scenarioId: string, fetchFinancialSimulationScenarioRequestBody: FetchFinancialSimulationScenarioRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('fetchScenarioTable', 'scenarioId', scenarioId)
            // verify required parameter 'fetchFinancialSimulationScenarioRequestBody' is not null or undefined
            assertParamExists('fetchScenarioTable', 'fetchFinancialSimulationScenarioRequestBody', fetchFinancialSimulationScenarioRequestBody)
            const localVarPath = `/api/financial-simulation-scenarios/{scenarioId}`
                .replace('{scenarioId}', encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchFinancialSimulationScenarioRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シナリオ保存
         * @param {string} scenarioId 
         * @param {SaveFinancialSimulationScenarioRequestBody} saveFinancialSimulationScenarioRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveScenarioTable: async (scenarioId: string, saveFinancialSimulationScenarioRequestBody: SaveFinancialSimulationScenarioRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('saveScenarioTable', 'scenarioId', scenarioId)
            // verify required parameter 'saveFinancialSimulationScenarioRequestBody' is not null or undefined
            assertParamExists('saveScenarioTable', 'saveFinancialSimulationScenarioRequestBody', saveFinancialSimulationScenarioRequestBody)
            const localVarPath = `/api/financial-simulation-scenarios/{scenarioId}/save`
                .replace('{scenarioId}', encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveFinancialSimulationScenarioRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FinancialSimulationScenarioTableControllerApi - functional programming interface
 */
export const FinancialSimulationScenarioTableControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FinancialSimulationScenarioTableControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シナリオを計画として保存
         * @param {string} scenarioId 
         * @param {ConvertScenarioTableToPlanRequestBody} convertScenarioTableToPlanRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertScenarioTableToPlan(scenarioId: string, convertScenarioTableToPlanRequestBody: ConvertScenarioTableToPlanRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertScenarioTableToPlan(scenarioId, convertScenarioTableToPlanRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationScenarioTableControllerApi.convertScenarioTableToPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シナリオテーブルのExcelダウンロード
         * @param {string} scenarioId 
         * @param {FetchFinancialSimulationScenarioRequestBody} fetchFinancialSimulationScenarioRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadScenarioTableExcel(scenarioId: string, fetchFinancialSimulationScenarioRequestBody: FetchFinancialSimulationScenarioRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadScenarioTableExcel(scenarioId, fetchFinancialSimulationScenarioRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationScenarioTableControllerApi.downloadScenarioTableExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シナリオのパラメータテーブルを取得
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchScenarioParameterTable(scenarioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSimulationScenarioParameterTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchScenarioParameterTable(scenarioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationScenarioTableControllerApi.fetchScenarioParameterTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シナリオについてシミュレーションを行い、シナリオを取得
         * @param {string} scenarioId 
         * @param {FetchFinancialSimulationScenarioRequestBody} fetchFinancialSimulationScenarioRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchScenarioTable(scenarioId: string, fetchFinancialSimulationScenarioRequestBody: FetchFinancialSimulationScenarioRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinancialSimulationScenarioTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchScenarioTable(scenarioId, fetchFinancialSimulationScenarioRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationScenarioTableControllerApi.fetchScenarioTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シナリオ保存
         * @param {string} scenarioId 
         * @param {SaveFinancialSimulationScenarioRequestBody} saveFinancialSimulationScenarioRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveScenarioTable(scenarioId: string, saveFinancialSimulationScenarioRequestBody: SaveFinancialSimulationScenarioRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveScenarioTable(scenarioId, saveFinancialSimulationScenarioRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinancialSimulationScenarioTableControllerApi.saveScenarioTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FinancialSimulationScenarioTableControllerApi - factory interface
 */
export const FinancialSimulationScenarioTableControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FinancialSimulationScenarioTableControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary シナリオを計画として保存
         * @param {string} scenarioId 
         * @param {ConvertScenarioTableToPlanRequestBody} convertScenarioTableToPlanRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertScenarioTableToPlan(scenarioId: string, convertScenarioTableToPlanRequestBody: ConvertScenarioTableToPlanRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.convertScenarioTableToPlan(scenarioId, convertScenarioTableToPlanRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シナリオテーブルのExcelダウンロード
         * @param {string} scenarioId 
         * @param {FetchFinancialSimulationScenarioRequestBody} fetchFinancialSimulationScenarioRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadScenarioTableExcel(scenarioId: string, fetchFinancialSimulationScenarioRequestBody: FetchFinancialSimulationScenarioRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadScenarioTableExcel(scenarioId, fetchFinancialSimulationScenarioRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シナリオのパラメータテーブルを取得
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScenarioParameterTable(scenarioId: string, options?: RawAxiosRequestConfig): AxiosPromise<FinancialSimulationScenarioParameterTableView> {
            return localVarFp.fetchScenarioParameterTable(scenarioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シナリオについてシミュレーションを行い、シナリオを取得
         * @param {string} scenarioId 
         * @param {FetchFinancialSimulationScenarioRequestBody} fetchFinancialSimulationScenarioRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScenarioTable(scenarioId: string, fetchFinancialSimulationScenarioRequestBody: FetchFinancialSimulationScenarioRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FinancialSimulationScenarioTableView> {
            return localVarFp.fetchScenarioTable(scenarioId, fetchFinancialSimulationScenarioRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シナリオ保存
         * @param {string} scenarioId 
         * @param {SaveFinancialSimulationScenarioRequestBody} saveFinancialSimulationScenarioRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveScenarioTable(scenarioId: string, saveFinancialSimulationScenarioRequestBody: SaveFinancialSimulationScenarioRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveScenarioTable(scenarioId, saveFinancialSimulationScenarioRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FinancialSimulationScenarioTableControllerApi - object-oriented interface
 */
export class FinancialSimulationScenarioTableControllerApi extends BaseAPI {
    /**
     * 
     * @summary シナリオを計画として保存
     * @param {string} scenarioId 
     * @param {ConvertScenarioTableToPlanRequestBody} convertScenarioTableToPlanRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public convertScenarioTableToPlan(scenarioId: string, convertScenarioTableToPlanRequestBody: ConvertScenarioTableToPlanRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationScenarioTableControllerApiFp(this.configuration).convertScenarioTableToPlan(scenarioId, convertScenarioTableToPlanRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シナリオテーブルのExcelダウンロード
     * @param {string} scenarioId 
     * @param {FetchFinancialSimulationScenarioRequestBody} fetchFinancialSimulationScenarioRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadScenarioTableExcel(scenarioId: string, fetchFinancialSimulationScenarioRequestBody: FetchFinancialSimulationScenarioRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationScenarioTableControllerApiFp(this.configuration).downloadScenarioTableExcel(scenarioId, fetchFinancialSimulationScenarioRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シナリオのパラメータテーブルを取得
     * @param {string} scenarioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchScenarioParameterTable(scenarioId: string, options?: RawAxiosRequestConfig) {
        return FinancialSimulationScenarioTableControllerApiFp(this.configuration).fetchScenarioParameterTable(scenarioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シナリオについてシミュレーションを行い、シナリオを取得
     * @param {string} scenarioId 
     * @param {FetchFinancialSimulationScenarioRequestBody} fetchFinancialSimulationScenarioRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchScenarioTable(scenarioId: string, fetchFinancialSimulationScenarioRequestBody: FetchFinancialSimulationScenarioRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationScenarioTableControllerApiFp(this.configuration).fetchScenarioTable(scenarioId, fetchFinancialSimulationScenarioRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シナリオ保存
     * @param {string} scenarioId 
     * @param {SaveFinancialSimulationScenarioRequestBody} saveFinancialSimulationScenarioRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveScenarioTable(scenarioId: string, saveFinancialSimulationScenarioRequestBody: SaveFinancialSimulationScenarioRequestBody, options?: RawAxiosRequestConfig) {
        return FinancialSimulationScenarioTableControllerApiFp(this.configuration).saveScenarioTable(scenarioId, saveFinancialSimulationScenarioRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GSheetCustomFunctionControllerApi - axios parameter creator
 */
export const GSheetCustomFunctionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary スプレッドシート独自関数用に明細の計画または実績の合算値を取得する
         * @param {string} fetchItemType 
         * @param {string} startYearMonth 
         * @param {MaybeOwnValueAccountCode} accountCode 
         * @param {MaybeOwnValueDepartmentCode} departmentCode 
         * @param {string} [sourceName] 
         * @param {string} [endYearMonth] 
         * @param {string} [accountTreeName] 
         * @param {string} [orgTreeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoglassPLValue: async (fetchItemType: string, startYearMonth: string, accountCode: MaybeOwnValueAccountCode, departmentCode: MaybeOwnValueDepartmentCode, sourceName?: string, endYearMonth?: string, accountTreeName?: string, orgTreeName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchItemType' is not null or undefined
            assertParamExists('getLoglassPLValue', 'fetchItemType', fetchItemType)
            // verify required parameter 'startYearMonth' is not null or undefined
            assertParamExists('getLoglassPLValue', 'startYearMonth', startYearMonth)
            // verify required parameter 'accountCode' is not null or undefined
            assertParamExists('getLoglassPLValue', 'accountCode', accountCode)
            // verify required parameter 'departmentCode' is not null or undefined
            assertParamExists('getLoglassPLValue', 'departmentCode', departmentCode)
            const localVarPath = `/api/v1/gsheets-custom-function/loglass-pl-value`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (fetchItemType !== undefined) {
                localVarQueryParameter['fetchItemType'] = fetchItemType;
            }

            if (sourceName !== undefined) {
                localVarQueryParameter['sourceName'] = sourceName;
            }

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }

            if (accountTreeName !== undefined) {
                localVarQueryParameter['accountTreeName'] = accountTreeName;
            }

            if (accountCode !== undefined) {
                for (const [key, value] of Object.entries(accountCode)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (departmentCode !== undefined) {
                for (const [key, value] of Object.entries(departmentCode)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (orgTreeName !== undefined) {
                localVarQueryParameter['orgTreeName'] = orgTreeName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary スプレッドシート独自関数用に明細の計画または実績の合算値を一括で取得する
         * @param {GetLoglassPLValueBulkRequest} getLoglassPLValueBulkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoglassPLValueBulk: async (getLoglassPLValueBulkRequest: GetLoglassPLValueBulkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getLoglassPLValueBulkRequest' is not null or undefined
            assertParamExists('getLoglassPLValueBulk', 'getLoglassPLValueBulkRequest', getLoglassPLValueBulkRequest)
            const localVarPath = `/api/v1/gsheets-custom-function/loglass-pl-value-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getLoglassPLValueBulkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GSheetCustomFunctionControllerApi - functional programming interface
 */
export const GSheetCustomFunctionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GSheetCustomFunctionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary スプレッドシート独自関数用に明細の計画または実績の合算値を取得する
         * @param {string} fetchItemType 
         * @param {string} startYearMonth 
         * @param {MaybeOwnValueAccountCode} accountCode 
         * @param {MaybeOwnValueDepartmentCode} departmentCode 
         * @param {string} [sourceName] 
         * @param {string} [endYearMonth] 
         * @param {string} [accountTreeName] 
         * @param {string} [orgTreeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoglassPLValue(fetchItemType: string, startYearMonth: string, accountCode: MaybeOwnValueAccountCode, departmentCode: MaybeOwnValueDepartmentCode, sourceName?: string, endYearMonth?: string, accountTreeName?: string, orgTreeName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLoglassPLValueResponseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoglassPLValue(fetchItemType, startYearMonth, accountCode, departmentCode, sourceName, endYearMonth, accountTreeName, orgTreeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GSheetCustomFunctionControllerApi.getLoglassPLValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary スプレッドシート独自関数用に明細の計画または実績の合算値を一括で取得する
         * @param {GetLoglassPLValueBulkRequest} getLoglassPLValueBulkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoglassPLValueBulk(getLoglassPLValueBulkRequest: GetLoglassPLValueBulkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLoglassPLValueBulkResponseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoglassPLValueBulk(getLoglassPLValueBulkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GSheetCustomFunctionControllerApi.getLoglassPLValueBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GSheetCustomFunctionControllerApi - factory interface
 */
export const GSheetCustomFunctionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GSheetCustomFunctionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary スプレッドシート独自関数用に明細の計画または実績の合算値を取得する
         * @param {string} fetchItemType 
         * @param {string} startYearMonth 
         * @param {MaybeOwnValueAccountCode} accountCode 
         * @param {MaybeOwnValueDepartmentCode} departmentCode 
         * @param {string} [sourceName] 
         * @param {string} [endYearMonth] 
         * @param {string} [accountTreeName] 
         * @param {string} [orgTreeName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoglassPLValue(fetchItemType: string, startYearMonth: string, accountCode: MaybeOwnValueAccountCode, departmentCode: MaybeOwnValueDepartmentCode, sourceName?: string, endYearMonth?: string, accountTreeName?: string, orgTreeName?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetLoglassPLValueResponseView> {
            return localVarFp.getLoglassPLValue(fetchItemType, startYearMonth, accountCode, departmentCode, sourceName, endYearMonth, accountTreeName, orgTreeName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary スプレッドシート独自関数用に明細の計画または実績の合算値を一括で取得する
         * @param {GetLoglassPLValueBulkRequest} getLoglassPLValueBulkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoglassPLValueBulk(getLoglassPLValueBulkRequest: GetLoglassPLValueBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetLoglassPLValueBulkResponseView> {
            return localVarFp.getLoglassPLValueBulk(getLoglassPLValueBulkRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GSheetCustomFunctionControllerApi - object-oriented interface
 */
export class GSheetCustomFunctionControllerApi extends BaseAPI {
    /**
     * 
     * @summary スプレッドシート独自関数用に明細の計画または実績の合算値を取得する
     * @param {string} fetchItemType 
     * @param {string} startYearMonth 
     * @param {MaybeOwnValueAccountCode} accountCode 
     * @param {MaybeOwnValueDepartmentCode} departmentCode 
     * @param {string} [sourceName] 
     * @param {string} [endYearMonth] 
     * @param {string} [accountTreeName] 
     * @param {string} [orgTreeName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoglassPLValue(fetchItemType: string, startYearMonth: string, accountCode: MaybeOwnValueAccountCode, departmentCode: MaybeOwnValueDepartmentCode, sourceName?: string, endYearMonth?: string, accountTreeName?: string, orgTreeName?: string, options?: RawAxiosRequestConfig) {
        return GSheetCustomFunctionControllerApiFp(this.configuration).getLoglassPLValue(fetchItemType, startYearMonth, accountCode, departmentCode, sourceName, endYearMonth, accountTreeName, orgTreeName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary スプレッドシート独自関数用に明細の計画または実績の合算値を一括で取得する
     * @param {GetLoglassPLValueBulkRequest} getLoglassPLValueBulkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoglassPLValueBulk(getLoglassPLValueBulkRequest: GetLoglassPLValueBulkRequest, options?: RawAxiosRequestConfig) {
        return GSheetCustomFunctionControllerApiFp(this.configuration).getLoglassPLValueBulk(getLoglassPLValueBulkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GSheetsControllerApi - axios parameter creator
 */
export const GSheetsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 取込設定の一覧を取得する
         * @param {string} xEmail 
         * @param {string} [xLoglassTenantId] 
         * @param {string} [xLoglassGoogleIdToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMappings: async (xEmail: string, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xEmail' is not null or undefined
            assertParamExists('listMappings', 'xEmail', xEmail)
            const localVarPath = `/api/gsheets/mappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            if (xEmail != null) {
                localVarHeaderParameter['X-Email'] = String(xEmail);
            }
            if (xLoglassTenantId != null) {
                localVarHeaderParameter['X-Loglass-Tenant-Id'] = String(xLoglassTenantId);
            }
            if (xLoglassGoogleIdToken != null) {
                localVarHeaderParameter['X-Loglass-Google-Id-Token'] = String(xLoglassGoogleIdToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成プロジェクトの一覧を取得する
         * @param {string} xEmail 
         * @param {string} [xLoglassTenantId] 
         * @param {string} [xLoglassGoogleIdToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanningProjects: async (xEmail: string, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xEmail' is not null or undefined
            assertParamExists('listPlanningProjects', 'xEmail', xEmail)
            const localVarPath = `/api/gsheets/planning-projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            if (xEmail != null) {
                localVarHeaderParameter['X-Email'] = String(xEmail);
            }
            if (xLoglassTenantId != null) {
                localVarHeaderParameter['X-Loglass-Tenant-Id'] = String(xLoglassTenantId);
            }
            if (xLoglassGoogleIdToken != null) {
                localVarHeaderParameter['X-Loglass-Google-Id-Token'] = String(xLoglassGoogleIdToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請をアップロードする
         * @param {string} xEmail 
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {string} sheetUrl 
         * @param {UploadRuleStepStandardExcelRequest} uploadRuleStepStandardExcelRequest 
         * @param {string} [xLoglassTenantId] 
         * @param {string} [xLoglassGoogleIdToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPlanUpdateRequests: async (xEmail: string, planningProjectId: string, mappingId: string, sheetUrl: string, uploadRuleStepStandardExcelRequest: UploadRuleStepStandardExcelRequest, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xEmail' is not null or undefined
            assertParamExists('uploadPlanUpdateRequests', 'xEmail', xEmail)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('uploadPlanUpdateRequests', 'planningProjectId', planningProjectId)
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('uploadPlanUpdateRequests', 'mappingId', mappingId)
            // verify required parameter 'sheetUrl' is not null or undefined
            assertParamExists('uploadPlanUpdateRequests', 'sheetUrl', sheetUrl)
            // verify required parameter 'uploadRuleStepStandardExcelRequest' is not null or undefined
            assertParamExists('uploadPlanUpdateRequests', 'uploadRuleStepStandardExcelRequest', uploadRuleStepStandardExcelRequest)
            const localVarPath = `/api/gsheets/upload-plan-update-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planningProjectId !== undefined) {
                localVarQueryParameter['planningProjectId'] = planningProjectId;
            }

            if (mappingId !== undefined) {
                localVarQueryParameter['mappingId'] = mappingId;
            }

            if (sheetUrl !== undefined) {
                localVarQueryParameter['sheetUrl'] = sheetUrl;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            if (xEmail != null) {
                localVarHeaderParameter['X-Email'] = String(xEmail);
            }
            if (xLoglassTenantId != null) {
                localVarHeaderParameter['X-Loglass-Tenant-Id'] = String(xLoglassTenantId);
            }
            if (xLoglassGoogleIdToken != null) {
                localVarHeaderParameter['X-Loglass-Google-Id-Token'] = String(xLoglassGoogleIdToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadRuleStepStandardExcelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GSheetsControllerApi - functional programming interface
 */
export const GSheetsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GSheetsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 取込設定の一覧を取得する
         * @param {string} xEmail 
         * @param {string} [xLoglassTenantId] 
         * @param {string} [xLoglassGoogleIdToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMappings(xEmail: string, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanUpdateRequestMappingView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMappings(xEmail, xLoglassTenantId, xLoglassGoogleIdToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GSheetsControllerApi.listMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成プロジェクトの一覧を取得する
         * @param {string} xEmail 
         * @param {string} [xLoglassTenantId] 
         * @param {string} [xLoglassGoogleIdToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlanningProjects(xEmail: string, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningProjectListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanningProjects(xEmail, xLoglassTenantId, xLoglassGoogleIdToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GSheetsControllerApi.listPlanningProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請をアップロードする
         * @param {string} xEmail 
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {string} sheetUrl 
         * @param {UploadRuleStepStandardExcelRequest} uploadRuleStepStandardExcelRequest 
         * @param {string} [xLoglassTenantId] 
         * @param {string} [xLoglassGoogleIdToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPlanUpdateRequests(xEmail: string, planningProjectId: string, mappingId: string, sheetUrl: string, uploadRuleStepStandardExcelRequest: UploadRuleStepStandardExcelRequest, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPlanUpdateRequests(xEmail, planningProjectId, mappingId, sheetUrl, uploadRuleStepStandardExcelRequest, xLoglassTenantId, xLoglassGoogleIdToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GSheetsControllerApi.uploadPlanUpdateRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GSheetsControllerApi - factory interface
 */
export const GSheetsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GSheetsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 取込設定の一覧を取得する
         * @param {string} xEmail 
         * @param {string} [xLoglassTenantId] 
         * @param {string} [xLoglassGoogleIdToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMappings(xEmail: string, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanUpdateRequestMappingView>> {
            return localVarFp.listMappings(xEmail, xLoglassTenantId, xLoglassGoogleIdToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成プロジェクトの一覧を取得する
         * @param {string} xEmail 
         * @param {string} [xLoglassTenantId] 
         * @param {string} [xLoglassGoogleIdToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanningProjects(xEmail: string, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanningProjectListView> {
            return localVarFp.listPlanningProjects(xEmail, xLoglassTenantId, xLoglassGoogleIdToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請をアップロードする
         * @param {string} xEmail 
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {string} sheetUrl 
         * @param {UploadRuleStepStandardExcelRequest} uploadRuleStepStandardExcelRequest 
         * @param {string} [xLoglassTenantId] 
         * @param {string} [xLoglassGoogleIdToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPlanUpdateRequests(xEmail: string, planningProjectId: string, mappingId: string, sheetUrl: string, uploadRuleStepStandardExcelRequest: UploadRuleStepStandardExcelRequest, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadPlanUpdateRequests(xEmail, planningProjectId, mappingId, sheetUrl, uploadRuleStepStandardExcelRequest, xLoglassTenantId, xLoglassGoogleIdToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GSheetsControllerApi - object-oriented interface
 */
export class GSheetsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 取込設定の一覧を取得する
     * @param {string} xEmail 
     * @param {string} [xLoglassTenantId] 
     * @param {string} [xLoglassGoogleIdToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listMappings(xEmail: string, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options?: RawAxiosRequestConfig) {
        return GSheetsControllerApiFp(this.configuration).listMappings(xEmail, xLoglassTenantId, xLoglassGoogleIdToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成プロジェクトの一覧を取得する
     * @param {string} xEmail 
     * @param {string} [xLoglassTenantId] 
     * @param {string} [xLoglassGoogleIdToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlanningProjects(xEmail: string, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options?: RawAxiosRequestConfig) {
        return GSheetsControllerApiFp(this.configuration).listPlanningProjects(xEmail, xLoglassTenantId, xLoglassGoogleIdToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請をアップロードする
     * @param {string} xEmail 
     * @param {string} planningProjectId 
     * @param {string} mappingId 
     * @param {string} sheetUrl 
     * @param {UploadRuleStepStandardExcelRequest} uploadRuleStepStandardExcelRequest 
     * @param {string} [xLoglassTenantId] 
     * @param {string} [xLoglassGoogleIdToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPlanUpdateRequests(xEmail: string, planningProjectId: string, mappingId: string, sheetUrl: string, uploadRuleStepStandardExcelRequest: UploadRuleStepStandardExcelRequest, xLoglassTenantId?: string, xLoglassGoogleIdToken?: string, options?: RawAxiosRequestConfig) {
        return GSheetsControllerApiFp(this.configuration).uploadPlanUpdateRequests(xEmail, planningProjectId, mappingId, sheetUrl, uploadRuleStepStandardExcelRequest, xLoglassTenantId, xLoglassGoogleIdToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthCheckControllerApi - axios parameter creator
 */
export const HealthCheckControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthcheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthCheckControllerApi - functional programming interface
 */
export const HealthCheckControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthCheckControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthcheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthcheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthCheckControllerApi.healthcheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthCheckControllerApi - factory interface
 */
export const HealthCheckControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthCheckControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthcheck(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.healthcheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthCheckControllerApi - object-oriented interface
 */
export class HealthCheckControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public healthcheck(options?: RawAxiosRequestConfig) {
        return HealthCheckControllerApiFp(this.configuration).healthcheck(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HistoryControllerApi - axios parameter creator
 */
export const HistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 推移表をExcelでダウンロードする
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadHistoryExcel: async (fetchComparisonRequestBody: FetchComparisonRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchComparisonRequestBody' is not null or undefined
            assertParamExists('downloadHistoryExcel', 'fetchComparisonRequestBody', fetchComparisonRequestBody)
            const localVarPath = `/api/history/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchComparisonRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Actual or PlanA vs Actual or PlanB
         * @summary 推移表API
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHistory: async (fetchComparisonRequestBody: FetchComparisonRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchComparisonRequestBody' is not null or undefined
            assertParamExists('fetchHistory', 'fetchComparisonRequestBody', fetchComparisonRequestBody)
            const localVarPath = `/api/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchComparisonRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HistoryControllerApi - functional programming interface
 */
export const HistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 推移表をExcelでダウンロードする
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadHistoryExcel(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadHistoryExcel(fetchComparisonRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryControllerApi.downloadHistoryExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Actual or PlanA vs Actual or PlanB
         * @summary 推移表API
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchHistory(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonTableV3View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchHistory(fetchComparisonRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryControllerApi.fetchHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HistoryControllerApi - factory interface
 */
export const HistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HistoryControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 推移表をExcelでダウンロードする
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadHistoryExcel(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadHistoryExcel(fetchComparisonRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Actual or PlanA vs Actual or PlanB
         * @summary 推移表API
         * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchHistory(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonTableV3View> {
            return localVarFp.fetchHistory(fetchComparisonRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HistoryControllerApi - object-oriented interface
 */
export class HistoryControllerApi extends BaseAPI {
    /**
     * 
     * @summary 推移表をExcelでダウンロードする
     * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadHistoryExcel(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig) {
        return HistoryControllerApiFp(this.configuration).downloadHistoryExcel(fetchComparisonRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Actual or PlanA vs Actual or PlanB
     * @summary 推移表API
     * @param {FetchComparisonRequestBody} fetchComparisonRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchHistory(fetchComparisonRequestBody: FetchComparisonRequestBody, options?: RawAxiosRequestConfig) {
        return HistoryControllerApiFp(this.configuration).fetchHistory(fetchComparisonRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IpRestrictionSettingControllerApi - axios parameter creator
 */
export const IpRestrictionSettingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary IP制限設定のドライラン実行
         * @param {IpRestrictionDryRunRequest} ipRestrictionDryRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunIpRestriction: async (ipRestrictionDryRunRequest: IpRestrictionDryRunRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ipRestrictionDryRunRequest' is not null or undefined
            assertParamExists('dryRunIpRestriction', 'ipRestrictionDryRunRequest', ipRestrictionDryRunRequest)
            const localVarPath = `/api/ip-restriction-setting/dry-run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ipRestrictionDryRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 現在のIPアドレスを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentIp: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ip-restriction-setting/current-ip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary IP制限設定の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIpRestrictionSetting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ip-restriction-setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IpRestrictionSettingControllerApi - functional programming interface
 */
export const IpRestrictionSettingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IpRestrictionSettingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary IP制限設定のドライラン実行
         * @param {IpRestrictionDryRunRequest} ipRestrictionDryRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRunIpRestriction(ipRestrictionDryRunRequest: IpRestrictionDryRunRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRunIpRestriction(ipRestrictionDryRunRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IpRestrictionSettingControllerApi.dryRunIpRestriction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 現在のIPアドレスを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentIp(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentIpView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentIp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IpRestrictionSettingControllerApi.getCurrentIp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary IP制限設定の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIpRestrictionSetting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IpRestrictionSettingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIpRestrictionSetting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IpRestrictionSettingControllerApi.getIpRestrictionSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IpRestrictionSettingControllerApi - factory interface
 */
export const IpRestrictionSettingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IpRestrictionSettingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary IP制限設定のドライラン実行
         * @param {IpRestrictionDryRunRequest} ipRestrictionDryRunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunIpRestriction(ipRestrictionDryRunRequest: IpRestrictionDryRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.dryRunIpRestriction(ipRestrictionDryRunRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 現在のIPアドレスを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentIp(options?: RawAxiosRequestConfig): AxiosPromise<CurrentIpView> {
            return localVarFp.getCurrentIp(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary IP制限設定の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIpRestrictionSetting(options?: RawAxiosRequestConfig): AxiosPromise<IpRestrictionSettingView> {
            return localVarFp.getIpRestrictionSetting(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IpRestrictionSettingControllerApi - object-oriented interface
 */
export class IpRestrictionSettingControllerApi extends BaseAPI {
    /**
     * 
     * @summary IP制限設定のドライラン実行
     * @param {IpRestrictionDryRunRequest} ipRestrictionDryRunRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dryRunIpRestriction(ipRestrictionDryRunRequest: IpRestrictionDryRunRequest, options?: RawAxiosRequestConfig) {
        return IpRestrictionSettingControllerApiFp(this.configuration).dryRunIpRestriction(ipRestrictionDryRunRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 現在のIPアドレスを取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentIp(options?: RawAxiosRequestConfig) {
        return IpRestrictionSettingControllerApiFp(this.configuration).getCurrentIp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary IP制限設定の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getIpRestrictionSetting(options?: RawAxiosRequestConfig) {
        return IpRestrictionSettingControllerApiFp(this.configuration).getIpRestrictionSetting(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LatestPlanningProjectControllerApi - axios parameter creator
 */
export const LatestPlanningProjectControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 計画マスタに紐づく最新の編成プロジェクトの概要
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPlanningProject: async (planMasterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('getLatestPlanningProject', 'planMasterId', planMasterId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/latest-planningProjects`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LatestPlanningProjectControllerApi - functional programming interface
 */
export const LatestPlanningProjectControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LatestPlanningProjectControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 計画マスタに紐づく最新の編成プロジェクトの概要
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestPlanningProject(planMasterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LatestPlanningProjectNodeMetaView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestPlanningProject(planMasterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LatestPlanningProjectControllerApi.getLatestPlanningProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LatestPlanningProjectControllerApi - factory interface
 */
export const LatestPlanningProjectControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LatestPlanningProjectControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 計画マスタに紐づく最新の編成プロジェクトの概要
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPlanningProject(planMasterId: string, options?: RawAxiosRequestConfig): AxiosPromise<LatestPlanningProjectNodeMetaView> {
            return localVarFp.getLatestPlanningProject(planMasterId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LatestPlanningProjectControllerApi - object-oriented interface
 */
export class LatestPlanningProjectControllerApi extends BaseAPI {
    /**
     * 
     * @summary 計画マスタに紐づく最新の編成プロジェクトの概要
     * @param {string} planMasterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestPlanningProject(planMasterId: string, options?: RawAxiosRequestConfig) {
        return LatestPlanningProjectControllerApiFp(this.configuration).getLatestPlanningProject(planMasterId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LinkedGoogleSheetsControllerApi - axios parameter creator
 */
export const LinkedGoogleSheetsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateLinkedGSheetParam} createLinkedGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkedGSheet: async (createLinkedGSheetParam: CreateLinkedGSheetParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLinkedGSheetParam' is not null or undefined
            assertParamExists('createLinkedGSheet', 'createLinkedGSheetParam', createLinkedGSheetParam)
            const localVarPath = `/api/linked-gsheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLinkedGSheetParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLinkedGSheet: async (sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('deleteLinkedGSheet', 'sheetId', sheetId)
            const localVarPath = `/api/linked-gsheets/{sheetId}`
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLinkedGSheets: async (departmentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/linked-gsheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LinkedGoogleSheetsControllerApi - functional programming interface
 */
export const LinkedGoogleSheetsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LinkedGoogleSheetsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateLinkedGSheetParam} createLinkedGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLinkedGSheet(createLinkedGSheetParam: CreateLinkedGSheetParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedGoogleSheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLinkedGSheet(createLinkedGSheetParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedGoogleSheetsControllerApi.createLinkedGSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLinkedGSheet(sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLinkedGSheet(sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedGoogleSheetsControllerApi.deleteLinkedGSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLinkedGSheets(departmentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedGSheetsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLinkedGSheets(departmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedGoogleSheetsControllerApi.listLinkedGSheets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LinkedGoogleSheetsControllerApi - factory interface
 */
export const LinkedGoogleSheetsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LinkedGoogleSheetsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateLinkedGSheetParam} createLinkedGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkedGSheet(createLinkedGSheetParam: CreateLinkedGSheetParam, options?: RawAxiosRequestConfig): AxiosPromise<LinkedGoogleSheetView> {
            return localVarFp.createLinkedGSheet(createLinkedGSheetParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLinkedGSheet(sheetId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteLinkedGSheet(sheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLinkedGSheets(departmentId?: string, options?: RawAxiosRequestConfig): AxiosPromise<LinkedGSheetsView> {
            return localVarFp.listLinkedGSheets(departmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LinkedGoogleSheetsControllerApi - object-oriented interface
 */
export class LinkedGoogleSheetsControllerApi extends BaseAPI {
    /**
     * 
     * @param {CreateLinkedGSheetParam} createLinkedGSheetParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLinkedGSheet(createLinkedGSheetParam: CreateLinkedGSheetParam, options?: RawAxiosRequestConfig) {
        return LinkedGoogleSheetsControllerApiFp(this.configuration).createLinkedGSheet(createLinkedGSheetParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sheetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteLinkedGSheet(sheetId: string, options?: RawAxiosRequestConfig) {
        return LinkedGoogleSheetsControllerApiFp(this.configuration).deleteLinkedGSheet(sheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [departmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listLinkedGSheets(departmentId?: string, options?: RawAxiosRequestConfig) {
        return LinkedGoogleSheetsControllerApiFp(this.configuration).listLinkedGSheets(departmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocalCurrencyControllerApi - axios parameter creator
 */
export const LocalCurrencyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 新しい現地通貨を作成します。
         * @param {LocalCurrencyRequestParam} localCurrencyRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocalCurrency: async (localCurrencyRequestParam: LocalCurrencyRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'localCurrencyRequestParam' is not null or undefined
            assertParamExists('createLocalCurrency', 'localCurrencyRequestParam', localCurrencyRequestParam)
            const localVarPath = `/api/currency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(localCurrencyRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete local currency
         * @param {string} currencyLocalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocalCurrency: async (currencyLocalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currencyLocalId' is not null or undefined
            assertParamExists('deleteLocalCurrency', 'currencyLocalId', currencyLocalId)
            const localVarPath = `/api/currency/{currencyLocalId}`
                .replace('{currencyLocalId}', encodeURIComponent(String(currencyLocalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 現地通貨リストを取得します。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/currency/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 通貨マスターデータを取得します。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyMaster: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/currency/master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 特定の部門IDに基づいて通貨マスターデータを取得します。
         * @param {CurrencyMasterByDepartmentsRequestParam} currencyMasterByDepartmentsRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyMasterByDepartments: async (currencyMasterByDepartmentsRequestParam: CurrencyMasterByDepartmentsRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currencyMasterByDepartmentsRequestParam' is not null or undefined
            assertParamExists('getCurrencyMasterByDepartments', 'currencyMasterByDepartmentsRequestParam', currencyMasterByDepartmentsRequestParam)
            const localVarPath = `/api/currency/master/department`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(currencyMasterByDepartmentsRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 現地通貨を削除します。
         * @param {ReorderLocalCurrencyRequestParam} reorderLocalCurrencyRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderLocalCurrencies: async (reorderLocalCurrencyRequestParam: ReorderLocalCurrencyRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reorderLocalCurrencyRequestParam' is not null or undefined
            assertParamExists('reorderLocalCurrencies', 'reorderLocalCurrencyRequestParam', reorderLocalCurrencyRequestParam)
            const localVarPath = `/api/currency/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderLocalCurrencyRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 現地通貨を更新します。
         * @param {string} currencyLocalId 
         * @param {LocalCurrencyRequestParam} localCurrencyRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocalCurrency: async (currencyLocalId: string, localCurrencyRequestParam: LocalCurrencyRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currencyLocalId' is not null or undefined
            assertParamExists('updateLocalCurrency', 'currencyLocalId', currencyLocalId)
            // verify required parameter 'localCurrencyRequestParam' is not null or undefined
            assertParamExists('updateLocalCurrency', 'localCurrencyRequestParam', localCurrencyRequestParam)
            const localVarPath = `/api/currency/{currencyLocalId}`
                .replace('{currencyLocalId}', encodeURIComponent(String(currencyLocalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(localCurrencyRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify if departments have associated project data
         * @param {VerifyDepartmentDataRequestParam} verifyDepartmentDataRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDepartmentData: async (verifyDepartmentDataRequestParam: VerifyDepartmentDataRequestParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyDepartmentDataRequestParam' is not null or undefined
            assertParamExists('verifyDepartmentData', 'verifyDepartmentDataRequestParam', verifyDepartmentDataRequestParam)
            const localVarPath = `/api/currency/verifyData/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyDepartmentDataRequestParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocalCurrencyControllerApi - functional programming interface
 */
export const LocalCurrencyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocalCurrencyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 新しい現地通貨を作成します。
         * @param {LocalCurrencyRequestParam} localCurrencyRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocalCurrency(localCurrencyRequestParam: LocalCurrencyRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocalCurrencyData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocalCurrency(localCurrencyRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalCurrencyControllerApi.createLocalCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete local currency
         * @param {string} currencyLocalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocalCurrency(currencyLocalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocalCurrency(currencyLocalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalCurrencyControllerApi.deleteLocalCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 現地通貨リストを取得します。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencyList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocalCurrencyData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencyList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalCurrencyControllerApi.getCurrencyList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 通貨マスターデータを取得します。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencyMaster(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrencyMaster>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencyMaster(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalCurrencyControllerApi.getCurrencyMaster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 特定の部門IDに基づいて通貨マスターデータを取得します。
         * @param {CurrencyMasterByDepartmentsRequestParam} currencyMasterByDepartmentsRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencyMasterByDepartments(currencyMasterByDepartmentsRequestParam: CurrencyMasterByDepartmentsRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CurrencyMaster>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencyMasterByDepartments(currencyMasterByDepartmentsRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalCurrencyControllerApi.getCurrencyMasterByDepartments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 現地通貨を削除します。
         * @param {ReorderLocalCurrencyRequestParam} reorderLocalCurrencyRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderLocalCurrencies(reorderLocalCurrencyRequestParam: ReorderLocalCurrencyRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderLocalCurrencies(reorderLocalCurrencyRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalCurrencyControllerApi.reorderLocalCurrencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 現地通貨を更新します。
         * @param {string} currencyLocalId 
         * @param {LocalCurrencyRequestParam} localCurrencyRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocalCurrency(currencyLocalId: string, localCurrencyRequestParam: LocalCurrencyRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocalCurrencyData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocalCurrency(currencyLocalId, localCurrencyRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalCurrencyControllerApi.updateLocalCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify if departments have associated project data
         * @param {VerifyDepartmentDataRequestParam} verifyDepartmentDataRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyDepartmentData(verifyDepartmentDataRequestParam: VerifyDepartmentDataRequestParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyDepartmentDataResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyDepartmentData(verifyDepartmentDataRequestParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalCurrencyControllerApi.verifyDepartmentData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocalCurrencyControllerApi - factory interface
 */
export const LocalCurrencyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocalCurrencyControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 新しい現地通貨を作成します。
         * @param {LocalCurrencyRequestParam} localCurrencyRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocalCurrency(localCurrencyRequestParam: LocalCurrencyRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<LocalCurrencyData> {
            return localVarFp.createLocalCurrency(localCurrencyRequestParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete local currency
         * @param {string} currencyLocalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocalCurrency(currencyLocalId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLocalCurrency(currencyLocalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 現地通貨リストを取得します。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyList(options?: RawAxiosRequestConfig): AxiosPromise<Array<LocalCurrencyData>> {
            return localVarFp.getCurrencyList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 通貨マスターデータを取得します。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyMaster(options?: RawAxiosRequestConfig): AxiosPromise<Array<CurrencyMaster>> {
            return localVarFp.getCurrencyMaster(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 特定の部門IDに基づいて通貨マスターデータを取得します。
         * @param {CurrencyMasterByDepartmentsRequestParam} currencyMasterByDepartmentsRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyMasterByDepartments(currencyMasterByDepartmentsRequestParam: CurrencyMasterByDepartmentsRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<Array<CurrencyMaster>> {
            return localVarFp.getCurrencyMasterByDepartments(currencyMasterByDepartmentsRequestParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 現地通貨を削除します。
         * @param {ReorderLocalCurrencyRequestParam} reorderLocalCurrencyRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderLocalCurrencies(reorderLocalCurrencyRequestParam: ReorderLocalCurrencyRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderLocalCurrencies(reorderLocalCurrencyRequestParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 現地通貨を更新します。
         * @param {string} currencyLocalId 
         * @param {LocalCurrencyRequestParam} localCurrencyRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocalCurrency(currencyLocalId: string, localCurrencyRequestParam: LocalCurrencyRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<LocalCurrencyData> {
            return localVarFp.updateLocalCurrency(currencyLocalId, localCurrencyRequestParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify if departments have associated project data
         * @param {VerifyDepartmentDataRequestParam} verifyDepartmentDataRequestParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDepartmentData(verifyDepartmentDataRequestParam: VerifyDepartmentDataRequestParam, options?: RawAxiosRequestConfig): AxiosPromise<VerifyDepartmentDataResult> {
            return localVarFp.verifyDepartmentData(verifyDepartmentDataRequestParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocalCurrencyControllerApi - object-oriented interface
 */
export class LocalCurrencyControllerApi extends BaseAPI {
    /**
     * 
     * @summary 新しい現地通貨を作成します。
     * @param {LocalCurrencyRequestParam} localCurrencyRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLocalCurrency(localCurrencyRequestParam: LocalCurrencyRequestParam, options?: RawAxiosRequestConfig) {
        return LocalCurrencyControllerApiFp(this.configuration).createLocalCurrency(localCurrencyRequestParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete local currency
     * @param {string} currencyLocalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteLocalCurrency(currencyLocalId: string, options?: RawAxiosRequestConfig) {
        return LocalCurrencyControllerApiFp(this.configuration).deleteLocalCurrency(currencyLocalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 現地通貨リストを取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrencyList(options?: RawAxiosRequestConfig) {
        return LocalCurrencyControllerApiFp(this.configuration).getCurrencyList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 通貨マスターデータを取得します。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrencyMaster(options?: RawAxiosRequestConfig) {
        return LocalCurrencyControllerApiFp(this.configuration).getCurrencyMaster(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 特定の部門IDに基づいて通貨マスターデータを取得します。
     * @param {CurrencyMasterByDepartmentsRequestParam} currencyMasterByDepartmentsRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrencyMasterByDepartments(currencyMasterByDepartmentsRequestParam: CurrencyMasterByDepartmentsRequestParam, options?: RawAxiosRequestConfig) {
        return LocalCurrencyControllerApiFp(this.configuration).getCurrencyMasterByDepartments(currencyMasterByDepartmentsRequestParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 現地通貨を削除します。
     * @param {ReorderLocalCurrencyRequestParam} reorderLocalCurrencyRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reorderLocalCurrencies(reorderLocalCurrencyRequestParam: ReorderLocalCurrencyRequestParam, options?: RawAxiosRequestConfig) {
        return LocalCurrencyControllerApiFp(this.configuration).reorderLocalCurrencies(reorderLocalCurrencyRequestParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 現地通貨を更新します。
     * @param {string} currencyLocalId 
     * @param {LocalCurrencyRequestParam} localCurrencyRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLocalCurrency(currencyLocalId: string, localCurrencyRequestParam: LocalCurrencyRequestParam, options?: RawAxiosRequestConfig) {
        return LocalCurrencyControllerApiFp(this.configuration).updateLocalCurrency(currencyLocalId, localCurrencyRequestParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify if departments have associated project data
     * @param {VerifyDepartmentDataRequestParam} verifyDepartmentDataRequestParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public verifyDepartmentData(verifyDepartmentDataRequestParam: VerifyDepartmentDataRequestParam, options?: RawAxiosRequestConfig) {
        return LocalCurrencyControllerApiFp(this.configuration).verifyDepartmentData(verifyDepartmentDataRequestParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NonFinancialAccountTreesControllerApi - axios parameter creator
 */
export const NonFinancialAccountTreesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 未設定科目・グループを非財務科目階層に追加する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {AddNodeToNonFinancialAccountTreeBody} addNodeToNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNodeToNonFinancialAccountTree: async (nonFinancialAccountTreeId: string, addNodeToNonFinancialAccountTreeBody: AddNodeToNonFinancialAccountTreeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('addNodeToNonFinancialAccountTree', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'addNodeToNonFinancialAccountTreeBody' is not null or undefined
            assertParamExists('addNodeToNonFinancialAccountTree', 'addNodeToNonFinancialAccountTreeBody', addNodeToNonFinancialAccountTreeBody)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/add-node`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addNodeToNonFinancialAccountTreeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目をアーカイブする API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} targetAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveNonFinancialAccount: async (nonFinancialAccountTreeId: string, targetAccountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('archiveNonFinancialAccount', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'targetAccountId' is not null or undefined
            assertParamExists('archiveNonFinancialAccount', 'targetAccountId', targetAccountId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/archive-account`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetAccountId !== undefined) {
                localVarQueryParameter['targetAccountId'] = targetAccountId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目階層内にグループを作成する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {CreateGroupAndAddToNonFinancialAccountTreeBody} createGroupAndAddToNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNonFinancialAccountGroup: async (nonFinancialAccountTreeId: string, createGroupAndAddToNonFinancialAccountTreeBody: CreateGroupAndAddToNonFinancialAccountTreeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('createNonFinancialAccountGroup', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'createGroupAndAddToNonFinancialAccountTreeBody' is not null or undefined
            assertParamExists('createNonFinancialAccountGroup', 'createGroupAndAddToNonFinancialAccountTreeBody', createGroupAndAddToNonFinancialAccountTreeBody)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/create-group-and-add-tree`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupAndAddToNonFinancialAccountTreeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目階層を削除する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNonFinancialAccountTree: async (nonFinancialAccountTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('deleteNonFinancialAccountTree', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務階層内の科目を指定して子階層ごと外す API
         * @param {string} nonFinancialAccountTreeId 
         * @param {DetachNonFinancialAccountTreeNodeBody} detachNonFinancialAccountTreeNodeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachNonFinancialAccountTreeNode: async (nonFinancialAccountTreeId: string, detachNonFinancialAccountTreeNodeBody: DetachNonFinancialAccountTreeNodeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('detachNonFinancialAccountTreeNode', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'detachNonFinancialAccountTreeNodeBody' is not null or undefined
            assertParamExists('detachNonFinancialAccountTreeNode', 'detachNonFinancialAccountTreeNodeBody', detachNonFinancialAccountTreeNodeBody)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/detach`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detachNonFinancialAccountTreeNodeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目階層の Excel ファイルを取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadNonFinancialAccountTreesExcel: async (nonFinancialAccountTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('downloadNonFinancialAccountTreesExcel', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/excel`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目階層を取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNonFinancialAccountTree: async (nonFinancialAccountTreeId: string, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('getNonFinancialAccountTree', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 選択用の本体値を含めた非財務科目階層を取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNonFinancialAccountTreeForSelection: async (nonFinancialAccountTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('getNonFinancialAccountTreeForSelection', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/for-selection`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目階層に含まれない未設定科目の総数を取得する API（アーカイブ済み科目は含まない）
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncludedNonFinancialAccountCount: async (nonFinancialAccountTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('getNotIncludedNonFinancialAccountCount', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/not-included-count`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 選択用の本体値を含めたプライマリ非財務科目階層と未設定一覧を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryNonFinancialAccountTreeForSelection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/non-financial-account-trees/for-primary-selection-with-not-included`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目階層の一覧を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNonFinancialAccountTrees: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/non-financial-account-trees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 未設定の非財務科目一覧を取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotIncludedNonFinancialAccounts: async (nonFinancialAccountTreeId: string, searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('listNotIncludedNonFinancialAccounts', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/not-included`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 既存の非財務科目階層のコピーを作成する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {CopyNonFinancialAccountTreeBody} copyNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeCopyNonFinancialAccountTree: async (nonFinancialAccountTreeId: string, copyNonFinancialAccountTreeBody: CopyNonFinancialAccountTreeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('makeCopyNonFinancialAccountTree', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'copyNonFinancialAccountTreeBody' is not null or undefined
            assertParamExists('makeCopyNonFinancialAccountTree', 'copyNonFinancialAccountTreeBody', copyNonFinancialAccountTreeBody)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/make-copy`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyNonFinancialAccountTreeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目階層内の非財務科目・グループを移動させる API
         * @param {string} nonFinancialAccountTreeId 
         * @param {MoveNonFinancialAccountTreeNodeBody} moveNonFinancialAccountTreeNodeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNonFinancialAccountTreeNode: async (nonFinancialAccountTreeId: string, moveNonFinancialAccountTreeNodeBody: MoveNonFinancialAccountTreeNodeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('moveNonFinancialAccountTreeNode', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'moveNonFinancialAccountTreeNodeBody' is not null or undefined
            assertParamExists('moveNonFinancialAccountTreeNode', 'moveNonFinancialAccountTreeNodeBody', moveNonFinancialAccountTreeNodeBody)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/move-node`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveNonFinancialAccountTreeNodeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目階層の名前を変更する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {PutNonFinancialAccountTreeNameBody} putNonFinancialAccountTreeNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putName: async (nonFinancialAccountTreeId: string, putNonFinancialAccountTreeNameBody: PutNonFinancialAccountTreeNameBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('putName', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'putNonFinancialAccountTreeNameBody' is not null or undefined
            assertParamExists('putName', 'putNonFinancialAccountTreeNameBody', putNonFinancialAccountTreeNameBody)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/name`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putNonFinancialAccountTreeNameBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定した非財務科目階層をプライマリに設定する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryNonFinancialAccountTree: async (nonFinancialAccountTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('setPrimaryNonFinancialAccountTree', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/set-primary`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目をアーカイブ解除する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} targetAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unArchiveNonFinancialAccount: async (nonFinancialAccountTreeId: string, targetAccountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('unArchiveNonFinancialAccount', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'targetAccountId' is not null or undefined
            assertParamExists('unArchiveNonFinancialAccount', 'targetAccountId', targetAccountId)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/unarchive-account`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetAccountId !== undefined) {
                localVarQueryParameter['targetAccountId'] = targetAccountId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Excel ファイルをもとに非財務科目階層を更新する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNonFinancialAccountTreesExcel: async (nonFinancialAccountTreeId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialAccountTreeId' is not null or undefined
            assertParamExists('uploadNonFinancialAccountTreesExcel', 'nonFinancialAccountTreeId', nonFinancialAccountTreeId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadNonFinancialAccountTreesExcel', 'file', file)
            const localVarPath = `/api/non-financial-account-trees/{nonFinancialAccountTreeId}/bulk-update`
                .replace('{nonFinancialAccountTreeId}', encodeURIComponent(String(nonFinancialAccountTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NonFinancialAccountTreesControllerApi - functional programming interface
 */
export const NonFinancialAccountTreesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NonFinancialAccountTreesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 未設定科目・グループを非財務科目階層に追加する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {AddNodeToNonFinancialAccountTreeBody} addNodeToNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNodeToNonFinancialAccountTree(nonFinancialAccountTreeId: string, addNodeToNonFinancialAccountTreeBody: AddNodeToNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNodeToNonFinancialAccountTree(nonFinancialAccountTreeId, addNodeToNonFinancialAccountTreeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.addNodeToNonFinancialAccountTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目をアーカイブする API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} targetAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveNonFinancialAccount(nonFinancialAccountTreeId: string, targetAccountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveNonFinancialAccount(nonFinancialAccountTreeId, targetAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.archiveNonFinancialAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目階層内にグループを作成する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {CreateGroupAndAddToNonFinancialAccountTreeBody} createGroupAndAddToNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNonFinancialAccountGroup(nonFinancialAccountTreeId: string, createGroupAndAddToNonFinancialAccountTreeBody: CreateGroupAndAddToNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNonFinancialAccountGroup(nonFinancialAccountTreeId, createGroupAndAddToNonFinancialAccountTreeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.createNonFinancialAccountGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目階層を削除する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNonFinancialAccountTree(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNonFinancialAccountTree(nonFinancialAccountTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.deleteNonFinancialAccountTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務階層内の科目を指定して子階層ごと外す API
         * @param {string} nonFinancialAccountTreeId 
         * @param {DetachNonFinancialAccountTreeNodeBody} detachNonFinancialAccountTreeNodeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detachNonFinancialAccountTreeNode(nonFinancialAccountTreeId: string, detachNonFinancialAccountTreeNodeBody: DetachNonFinancialAccountTreeNodeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detachNonFinancialAccountTreeNode(nonFinancialAccountTreeId, detachNonFinancialAccountTreeNodeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.detachNonFinancialAccountTreeNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目階層の Excel ファイルを取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.downloadNonFinancialAccountTreesExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目階層を取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNonFinancialAccountTree(nonFinancialAccountTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonFinancialAccountFlatTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNonFinancialAccountTree(nonFinancialAccountTreeId, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.getNonFinancialAccountTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 選択用の本体値を含めた非財務科目階層を取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNonFinancialAccountTreeForSelection(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonFinancialAccountFlatTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNonFinancialAccountTreeForSelection(nonFinancialAccountTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.getNonFinancialAccountTreeForSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目階層に含まれない未設定科目の総数を取得する API（アーカイブ済み科目は含まない）
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotIncludedNonFinancialAccountCount(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotIncludedNonFinancialAccountCountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotIncludedNonFinancialAccountCount(nonFinancialAccountTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.getNotIncludedNonFinancialAccountCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 選択用の本体値を含めたプライマリ非財務科目階層と未設定一覧を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrimaryNonFinancialAccountTreeForSelection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonFinancialAccountFlatTreeWithNotIncludedForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrimaryNonFinancialAccountTreeForSelection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.getPrimaryNonFinancialAccountTreeForSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目階層の一覧を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNonFinancialAccountTrees(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonFinancialAccountTreeListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNonFinancialAccountTrees(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.listNonFinancialAccountTrees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 未設定の非財務科目一覧を取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotIncludedNonFinancialAccounts(nonFinancialAccountTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotIncludedNonFinancialAccountsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotIncludedNonFinancialAccounts(nonFinancialAccountTreeId, searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.listNotIncludedNonFinancialAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 既存の非財務科目階層のコピーを作成する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {CopyNonFinancialAccountTreeBody} copyNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async makeCopyNonFinancialAccountTree(nonFinancialAccountTreeId: string, copyNonFinancialAccountTreeBody: CopyNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonFinancialAccountTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.makeCopyNonFinancialAccountTree(nonFinancialAccountTreeId, copyNonFinancialAccountTreeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.makeCopyNonFinancialAccountTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目階層内の非財務科目・グループを移動させる API
         * @param {string} nonFinancialAccountTreeId 
         * @param {MoveNonFinancialAccountTreeNodeBody} moveNonFinancialAccountTreeNodeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveNonFinancialAccountTreeNode(nonFinancialAccountTreeId: string, moveNonFinancialAccountTreeNodeBody: MoveNonFinancialAccountTreeNodeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveNonFinancialAccountTreeNode(nonFinancialAccountTreeId, moveNonFinancialAccountTreeNodeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.moveNonFinancialAccountTreeNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目階層の名前を変更する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {PutNonFinancialAccountTreeNameBody} putNonFinancialAccountTreeNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putName(nonFinancialAccountTreeId: string, putNonFinancialAccountTreeNameBody: PutNonFinancialAccountTreeNameBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NonFinancialAccountTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putName(nonFinancialAccountTreeId, putNonFinancialAccountTreeNameBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.putName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定した非財務科目階層をプライマリに設定する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimaryNonFinancialAccountTree(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimaryNonFinancialAccountTree(nonFinancialAccountTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.setPrimaryNonFinancialAccountTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目をアーカイブ解除する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} targetAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unArchiveNonFinancialAccount(nonFinancialAccountTreeId: string, targetAccountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unArchiveNonFinancialAccount(nonFinancialAccountTreeId, targetAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.unArchiveNonFinancialAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Excel ファイルをもとに非財務科目階層を更新する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountTreesControllerApi.uploadNonFinancialAccountTreesExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NonFinancialAccountTreesControllerApi - factory interface
 */
export const NonFinancialAccountTreesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NonFinancialAccountTreesControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 未設定科目・グループを非財務科目階層に追加する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {AddNodeToNonFinancialAccountTreeBody} addNodeToNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNodeToNonFinancialAccountTree(nonFinancialAccountTreeId: string, addNodeToNonFinancialAccountTreeBody: AddNodeToNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.addNodeToNonFinancialAccountTree(nonFinancialAccountTreeId, addNodeToNonFinancialAccountTreeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目をアーカイブする API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} targetAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveNonFinancialAccount(nonFinancialAccountTreeId: string, targetAccountId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.archiveNonFinancialAccount(nonFinancialAccountTreeId, targetAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目階層内にグループを作成する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {CreateGroupAndAddToNonFinancialAccountTreeBody} createGroupAndAddToNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNonFinancialAccountGroup(nonFinancialAccountTreeId: string, createGroupAndAddToNonFinancialAccountTreeBody: CreateGroupAndAddToNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createNonFinancialAccountGroup(nonFinancialAccountTreeId, createGroupAndAddToNonFinancialAccountTreeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目階層を削除する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNonFinancialAccountTree(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteNonFinancialAccountTree(nonFinancialAccountTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務階層内の科目を指定して子階層ごと外す API
         * @param {string} nonFinancialAccountTreeId 
         * @param {DetachNonFinancialAccountTreeNodeBody} detachNonFinancialAccountTreeNodeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachNonFinancialAccountTreeNode(nonFinancialAccountTreeId: string, detachNonFinancialAccountTreeNodeBody: DetachNonFinancialAccountTreeNodeBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.detachNonFinancialAccountTreeNode(nonFinancialAccountTreeId, detachNonFinancialAccountTreeNodeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目階層の Excel ファイルを取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目階層を取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNonFinancialAccountTree(nonFinancialAccountTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<NonFinancialAccountFlatTreeView> {
            return localVarFp.getNonFinancialAccountTree(nonFinancialAccountTreeId, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 選択用の本体値を含めた非財務科目階層を取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNonFinancialAccountTreeForSelection(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<NonFinancialAccountFlatTreeForSelectionView> {
            return localVarFp.getNonFinancialAccountTreeForSelection(nonFinancialAccountTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目階層に含まれない未設定科目の総数を取得する API（アーカイブ済み科目は含まない）
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncludedNonFinancialAccountCount(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<NotIncludedNonFinancialAccountCountView> {
            return localVarFp.getNotIncludedNonFinancialAccountCount(nonFinancialAccountTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 選択用の本体値を含めたプライマリ非財務科目階層と未設定一覧を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryNonFinancialAccountTreeForSelection(options?: RawAxiosRequestConfig): AxiosPromise<NonFinancialAccountFlatTreeWithNotIncludedForSelectionView> {
            return localVarFp.getPrimaryNonFinancialAccountTreeForSelection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目階層の一覧を取得する API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNonFinancialAccountTrees(options?: RawAxiosRequestConfig): AxiosPromise<NonFinancialAccountTreeListView> {
            return localVarFp.listNonFinancialAccountTrees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 未設定の非財務科目一覧を取得する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotIncludedNonFinancialAccounts(nonFinancialAccountTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<NotIncludedNonFinancialAccountsView> {
            return localVarFp.listNotIncludedNonFinancialAccounts(nonFinancialAccountTreeId, searchWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 既存の非財務科目階層のコピーを作成する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {CopyNonFinancialAccountTreeBody} copyNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeCopyNonFinancialAccountTree(nonFinancialAccountTreeId: string, copyNonFinancialAccountTreeBody: CopyNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig): AxiosPromise<NonFinancialAccountTreeView> {
            return localVarFp.makeCopyNonFinancialAccountTree(nonFinancialAccountTreeId, copyNonFinancialAccountTreeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目階層内の非財務科目・グループを移動させる API
         * @param {string} nonFinancialAccountTreeId 
         * @param {MoveNonFinancialAccountTreeNodeBody} moveNonFinancialAccountTreeNodeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNonFinancialAccountTreeNode(nonFinancialAccountTreeId: string, moveNonFinancialAccountTreeNodeBody: MoveNonFinancialAccountTreeNodeBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveNonFinancialAccountTreeNode(nonFinancialAccountTreeId, moveNonFinancialAccountTreeNodeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目階層の名前を変更する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {PutNonFinancialAccountTreeNameBody} putNonFinancialAccountTreeNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putName(nonFinancialAccountTreeId: string, putNonFinancialAccountTreeNameBody: PutNonFinancialAccountTreeNameBody, options?: RawAxiosRequestConfig): AxiosPromise<NonFinancialAccountTreeView> {
            return localVarFp.putName(nonFinancialAccountTreeId, putNonFinancialAccountTreeNameBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定した非財務科目階層をプライマリに設定する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryNonFinancialAccountTree(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.setPrimaryNonFinancialAccountTree(nonFinancialAccountTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目をアーカイブ解除する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {string} targetAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unArchiveNonFinancialAccount(nonFinancialAccountTreeId: string, targetAccountId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.unArchiveNonFinancialAccount(nonFinancialAccountTreeId, targetAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Excel ファイルをもとに非財務科目階層を更新する API
         * @param {string} nonFinancialAccountTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NonFinancialAccountTreesControllerApi - object-oriented interface
 */
export class NonFinancialAccountTreesControllerApi extends BaseAPI {
    /**
     * 
     * @summary 未設定科目・グループを非財務科目階層に追加する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {AddNodeToNonFinancialAccountTreeBody} addNodeToNonFinancialAccountTreeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addNodeToNonFinancialAccountTree(nonFinancialAccountTreeId: string, addNodeToNonFinancialAccountTreeBody: AddNodeToNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).addNodeToNonFinancialAccountTree(nonFinancialAccountTreeId, addNodeToNonFinancialAccountTreeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目をアーカイブする API
     * @param {string} nonFinancialAccountTreeId 
     * @param {string} targetAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archiveNonFinancialAccount(nonFinancialAccountTreeId: string, targetAccountId: string, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).archiveNonFinancialAccount(nonFinancialAccountTreeId, targetAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目階層内にグループを作成する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {CreateGroupAndAddToNonFinancialAccountTreeBody} createGroupAndAddToNonFinancialAccountTreeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNonFinancialAccountGroup(nonFinancialAccountTreeId: string, createGroupAndAddToNonFinancialAccountTreeBody: CreateGroupAndAddToNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).createNonFinancialAccountGroup(nonFinancialAccountTreeId, createGroupAndAddToNonFinancialAccountTreeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目階層を削除する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteNonFinancialAccountTree(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).deleteNonFinancialAccountTree(nonFinancialAccountTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務階層内の科目を指定して子階層ごと外す API
     * @param {string} nonFinancialAccountTreeId 
     * @param {DetachNonFinancialAccountTreeNodeBody} detachNonFinancialAccountTreeNodeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public detachNonFinancialAccountTreeNode(nonFinancialAccountTreeId: string, detachNonFinancialAccountTreeNodeBody: DetachNonFinancialAccountTreeNodeBody, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).detachNonFinancialAccountTreeNode(nonFinancialAccountTreeId, detachNonFinancialAccountTreeNodeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目階層の Excel ファイルを取得する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).downloadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目階層を取得する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNonFinancialAccountTree(nonFinancialAccountTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).getNonFinancialAccountTree(nonFinancialAccountTreeId, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 選択用の本体値を含めた非財務科目階層を取得する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNonFinancialAccountTreeForSelection(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).getNonFinancialAccountTreeForSelection(nonFinancialAccountTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目階層に含まれない未設定科目の総数を取得する API（アーカイブ済み科目は含まない）
     * @param {string} nonFinancialAccountTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotIncludedNonFinancialAccountCount(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).getNotIncludedNonFinancialAccountCount(nonFinancialAccountTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 選択用の本体値を含めたプライマリ非財務科目階層と未設定一覧を取得する API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPrimaryNonFinancialAccountTreeForSelection(options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).getPrimaryNonFinancialAccountTreeForSelection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目階層の一覧を取得する API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listNonFinancialAccountTrees(options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).listNonFinancialAccountTrees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 未設定の非財務科目一覧を取得する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listNotIncludedNonFinancialAccounts(nonFinancialAccountTreeId: string, searchWord?: string, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).listNotIncludedNonFinancialAccounts(nonFinancialAccountTreeId, searchWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 既存の非財務科目階層のコピーを作成する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {CopyNonFinancialAccountTreeBody} copyNonFinancialAccountTreeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public makeCopyNonFinancialAccountTree(nonFinancialAccountTreeId: string, copyNonFinancialAccountTreeBody: CopyNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).makeCopyNonFinancialAccountTree(nonFinancialAccountTreeId, copyNonFinancialAccountTreeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目階層内の非財務科目・グループを移動させる API
     * @param {string} nonFinancialAccountTreeId 
     * @param {MoveNonFinancialAccountTreeNodeBody} moveNonFinancialAccountTreeNodeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveNonFinancialAccountTreeNode(nonFinancialAccountTreeId: string, moveNonFinancialAccountTreeNodeBody: MoveNonFinancialAccountTreeNodeBody, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).moveNonFinancialAccountTreeNode(nonFinancialAccountTreeId, moveNonFinancialAccountTreeNodeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目階層の名前を変更する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {PutNonFinancialAccountTreeNameBody} putNonFinancialAccountTreeNameBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putName(nonFinancialAccountTreeId: string, putNonFinancialAccountTreeNameBody: PutNonFinancialAccountTreeNameBody, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).putName(nonFinancialAccountTreeId, putNonFinancialAccountTreeNameBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定した非財務科目階層をプライマリに設定する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setPrimaryNonFinancialAccountTree(nonFinancialAccountTreeId: string, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).setPrimaryNonFinancialAccountTree(nonFinancialAccountTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目をアーカイブ解除する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {string} targetAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unArchiveNonFinancialAccount(nonFinancialAccountTreeId: string, targetAccountId: string, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).unArchiveNonFinancialAccount(nonFinancialAccountTreeId, targetAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Excel ファイルをもとに非財務科目階層を更新する API
     * @param {string} nonFinancialAccountTreeId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId: string, file: File, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountTreesControllerApiFp(this.configuration).uploadNonFinancialAccountTreesExcel(nonFinancialAccountTreeId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NonFinancialAccountsControllerApi - axios parameter creator
 */
export const NonFinancialAccountsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 非財務科目を作成し、非財務科目階層に追加する API
         * @param {CreateAccountAndAddNonFinancialAccountTreeBody} createAccountAndAddNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountAndAddNonFinancialAccountTree: async (createAccountAndAddNonFinancialAccountTreeBody: CreateAccountAndAddNonFinancialAccountTreeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAccountAndAddNonFinancialAccountTreeBody' is not null or undefined
            assertParamExists('createAccountAndAddNonFinancialAccountTree', 'createAccountAndAddNonFinancialAccountTreeBody', createAccountAndAddNonFinancialAccountTreeBody)
            const localVarPath = `/api/non-financial-accounts/create-and-add-tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccountAndAddNonFinancialAccountTreeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目一覧Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadNonFinancialAccountsExcel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/non-financial-accounts/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 全ての非財務科目を取得する。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNonFinancialAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/non-financial-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Excelアップロードし、非財務科目を一括作成・更新する
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNonFinancialAccountsExcel: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadNonFinancialAccountsExcel', 'file', file)
            const localVarPath = `/api/non-financial-accounts/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NonFinancialAccountsControllerApi - functional programming interface
 */
export const NonFinancialAccountsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NonFinancialAccountsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 非財務科目を作成し、非財務科目階層に追加する API
         * @param {CreateAccountAndAddNonFinancialAccountTreeBody} createAccountAndAddNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccountAndAddNonFinancialAccountTree(createAccountAndAddNonFinancialAccountTreeBody: CreateAccountAndAddNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccountAndAddNonFinancialAccountTree(createAccountAndAddNonFinancialAccountTreeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountsControllerApi.createAccountAndAddNonFinancialAccountTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目一覧Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadNonFinancialAccountsExcel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadNonFinancialAccountsExcel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountsControllerApi.downloadNonFinancialAccountsExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 全ての非財務科目を取得する。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNonFinancialAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NonFinancialAccountView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNonFinancialAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountsControllerApi.listNonFinancialAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Excelアップロードし、非財務科目を一括作成・更新する
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadNonFinancialAccountsExcel(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadNonFinancialAccountsExcel(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialAccountsControllerApi.uploadNonFinancialAccountsExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NonFinancialAccountsControllerApi - factory interface
 */
export const NonFinancialAccountsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NonFinancialAccountsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 非財務科目を作成し、非財務科目階層に追加する API
         * @param {CreateAccountAndAddNonFinancialAccountTreeBody} createAccountAndAddNonFinancialAccountTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountAndAddNonFinancialAccountTree(createAccountAndAddNonFinancialAccountTreeBody: CreateAccountAndAddNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createAccountAndAddNonFinancialAccountTree(createAccountAndAddNonFinancialAccountTreeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目一覧Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadNonFinancialAccountsExcel(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadNonFinancialAccountsExcel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 全ての非財務科目を取得する。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNonFinancialAccounts(options?: RawAxiosRequestConfig): AxiosPromise<Array<NonFinancialAccountView>> {
            return localVarFp.listNonFinancialAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Excelアップロードし、非財務科目を一括作成・更新する
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNonFinancialAccountsExcel(file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadNonFinancialAccountsExcel(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NonFinancialAccountsControllerApi - object-oriented interface
 */
export class NonFinancialAccountsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 非財務科目を作成し、非財務科目階層に追加する API
     * @param {CreateAccountAndAddNonFinancialAccountTreeBody} createAccountAndAddNonFinancialAccountTreeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAccountAndAddNonFinancialAccountTree(createAccountAndAddNonFinancialAccountTreeBody: CreateAccountAndAddNonFinancialAccountTreeBody, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountsControllerApiFp(this.configuration).createAccountAndAddNonFinancialAccountTree(createAccountAndAddNonFinancialAccountTreeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目一覧Excelのダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadNonFinancialAccountsExcel(options?: RawAxiosRequestConfig) {
        return NonFinancialAccountsControllerApiFp(this.configuration).downloadNonFinancialAccountsExcel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 全ての非財務科目を取得する。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listNonFinancialAccounts(options?: RawAxiosRequestConfig) {
        return NonFinancialAccountsControllerApiFp(this.configuration).listNonFinancialAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Excelアップロードし、非財務科目を一括作成・更新する
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadNonFinancialAccountsExcel(file: File, options?: RawAxiosRequestConfig) {
        return NonFinancialAccountsControllerApiFp(this.configuration).uploadNonFinancialAccountsExcel(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NonFinancialItemsControllerApi - axios parameter creator
 */
export const NonFinancialItemsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 非財務科目明細フォーマットのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFormat: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/non-financial-items/format`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務科目明細フォーマット(Excel)のダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFormatExcel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/non-financial-items/format/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取込設定・加工設定を使った非財務実績アップロードで利用する型生成用
         * @param {ForOpenApiGenerator3Request} [forOpenApiGenerator3Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forOpenApiGenerator3: async (forOpenApiGenerator3Request?: ForOpenApiGenerator3Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/non-financial-items/forOnlyOpenApiGenerator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forOpenApiGenerator3Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Excelによる非財務科目明細の作成更新
         * @param {File} [excelFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExcel: async (excelFile?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/non-financial-items/upload/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (excelFile !== undefined) { 
                localVarFormParams.append('excelFile', excelFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取込設定・加工設定を使った非財務実績アップロード
         * @param {File} file 
         * @param {UploadNonFinancialItemsParams} uploadParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNonFinancialItemsByMapping: async (file: File, uploadParams: UploadNonFinancialItemsParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadNonFinancialItemsByMapping', 'file', file)
            // verify required parameter 'uploadParams' is not null or undefined
            assertParamExists('uploadNonFinancialItemsByMapping', 'uploadParams', uploadParams)
            const localVarPath = `/api/non-financial-items/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (uploadParams !== undefined) { 
                localVarFormParams.append('uploadParams', new Blob([JSON.stringify(uploadParams, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CSVによる非財務科目明細の作成更新
         * @param {File} [csvFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsert: async (csvFile?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/non-financial-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (csvFile !== undefined) { 
                localVarFormParams.append('csvFile', csvFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NonFinancialItemsControllerApi - functional programming interface
 */
export const NonFinancialItemsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NonFinancialItemsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 非財務科目明細フォーマットのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFormat(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFormat(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialItemsControllerApi.downloadFormat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務科目明細フォーマット(Excel)のダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFormatExcel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFormatExcel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialItemsControllerApi.downloadFormatExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 取込設定・加工設定を使った非財務実績アップロードで利用する型生成用
         * @param {ForOpenApiGenerator3Request} [forOpenApiGenerator3Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forOpenApiGenerator3(forOpenApiGenerator3Request?: ForOpenApiGenerator3Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forOpenApiGenerator3(forOpenApiGenerator3Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialItemsControllerApi.forOpenApiGenerator3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Excelによる非財務科目明細の作成更新
         * @param {File} [excelFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadExcel(excelFile?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadExcel(excelFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialItemsControllerApi.uploadExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 取込設定・加工設定を使った非財務実績アップロード
         * @param {File} file 
         * @param {UploadNonFinancialItemsParams} uploadParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadNonFinancialItemsByMapping(file: File, uploadParams: UploadNonFinancialItemsParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadNonFinancialItemsByMapping(file, uploadParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialItemsControllerApi.uploadNonFinancialItemsByMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary CSVによる非財務科目明細の作成更新
         * @param {File} [csvFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsert(csvFile?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsert(csvFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialItemsControllerApi.upsert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NonFinancialItemsControllerApi - factory interface
 */
export const NonFinancialItemsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NonFinancialItemsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 非財務科目明細フォーマットのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFormat(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadFormat(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務科目明細フォーマット(Excel)のダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFormatExcel(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadFormatExcel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取込設定・加工設定を使った非財務実績アップロードで利用する型生成用
         * @param {ForOpenApiGenerator3Request} [forOpenApiGenerator3Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forOpenApiGenerator3(forOpenApiGenerator3Request?: ForOpenApiGenerator3Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forOpenApiGenerator3(forOpenApiGenerator3Request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Excelによる非財務科目明細の作成更新
         * @param {File} [excelFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExcel(excelFile?: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadExcel(excelFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取込設定・加工設定を使った非財務実績アップロード
         * @param {File} file 
         * @param {UploadNonFinancialItemsParams} uploadParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNonFinancialItemsByMapping(file: File, uploadParams: UploadNonFinancialItemsParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadNonFinancialItemsByMapping(file, uploadParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CSVによる非財務科目明細の作成更新
         * @param {File} [csvFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsert(csvFile?: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.upsert(csvFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NonFinancialItemsControllerApi - object-oriented interface
 */
export class NonFinancialItemsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 非財務科目明細フォーマットのダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadFormat(options?: RawAxiosRequestConfig) {
        return NonFinancialItemsControllerApiFp(this.configuration).downloadFormat(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務科目明細フォーマット(Excel)のダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadFormatExcel(options?: RawAxiosRequestConfig) {
        return NonFinancialItemsControllerApiFp(this.configuration).downloadFormatExcel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取込設定・加工設定を使った非財務実績アップロードで利用する型生成用
     * @param {ForOpenApiGenerator3Request} [forOpenApiGenerator3Request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forOpenApiGenerator3(forOpenApiGenerator3Request?: ForOpenApiGenerator3Request, options?: RawAxiosRequestConfig) {
        return NonFinancialItemsControllerApiFp(this.configuration).forOpenApiGenerator3(forOpenApiGenerator3Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Excelによる非財務科目明細の作成更新
     * @param {File} [excelFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadExcel(excelFile?: File, options?: RawAxiosRequestConfig) {
        return NonFinancialItemsControllerApiFp(this.configuration).uploadExcel(excelFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取込設定・加工設定を使った非財務実績アップロード
     * @param {File} file 
     * @param {UploadNonFinancialItemsParams} uploadParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadNonFinancialItemsByMapping(file: File, uploadParams: UploadNonFinancialItemsParams, options?: RawAxiosRequestConfig) {
        return NonFinancialItemsControllerApiFp(this.configuration).uploadNonFinancialItemsByMapping(file, uploadParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CSVによる非財務科目明細の作成更新
     * @param {File} [csvFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upsert(csvFile?: File, options?: RawAxiosRequestConfig) {
        return NonFinancialItemsControllerApiFp(this.configuration).upsert(csvFile, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NonFinancialItemsUploadEventsControllerApi - axios parameter creator
 */
export const NonFinancialItemsUploadEventsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 非財務明細アップロードイベントの削除
         * @param {string} nonFinancialItemsUploadEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (nonFinancialItemsUploadEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonFinancialItemsUploadEventId' is not null or undefined
            assertParamExists('_delete', 'nonFinancialItemsUploadEventId', nonFinancialItemsUploadEventId)
            const localVarPath = `/api/non-financial-items-upload-events/{nonFinancialItemsUploadEventId}`
                .replace('{nonFinancialItemsUploadEventId}', encodeURIComponent(String(nonFinancialItemsUploadEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uploadEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadNonFinancialUploadedRaw: async (uploadEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadEventId' is not null or undefined
            assertParamExists('downloadNonFinancialUploadedRaw', 'uploadEventId', uploadEventId)
            const localVarPath = `/api/non-financial-items-upload-events/{uploadEventId}/raw`
                .replace('{uploadEventId}', encodeURIComponent(String(uploadEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非財務明細アップロードイベント一覧
         * @param {number} limit 
         * @param {number} offset 
         * @param {ListNonFinancialItemsUploadEventsSortKeyEnum} sortKey 
         * @param {boolean} isAsc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNonFinancialItemsUploadEvents: async (limit: number, offset: number, sortKey: ListNonFinancialItemsUploadEventsSortKeyEnum, isAsc: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('listNonFinancialItemsUploadEvents', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('listNonFinancialItemsUploadEvents', 'offset', offset)
            // verify required parameter 'sortKey' is not null or undefined
            assertParamExists('listNonFinancialItemsUploadEvents', 'sortKey', sortKey)
            // verify required parameter 'isAsc' is not null or undefined
            assertParamExists('listNonFinancialItemsUploadEvents', 'isAsc', isAsc)
            const localVarPath = `/api/non-financial-items-upload-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }

            if (isAsc !== undefined) {
                localVarQueryParameter['isAsc'] = isAsc;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NonFinancialItemsUploadEventsControllerApi - functional programming interface
 */
export const NonFinancialItemsUploadEventsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NonFinancialItemsUploadEventsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 非財務明細アップロードイベントの削除
         * @param {string} nonFinancialItemsUploadEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(nonFinancialItemsUploadEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(nonFinancialItemsUploadEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialItemsUploadEventsControllerApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uploadEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadNonFinancialUploadedRaw(uploadEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadNonFinancialUploadedRaw(uploadEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialItemsUploadEventsControllerApi.downloadNonFinancialUploadedRaw']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非財務明細アップロードイベント一覧
         * @param {number} limit 
         * @param {number} offset 
         * @param {ListNonFinancialItemsUploadEventsSortKeyEnum} sortKey 
         * @param {boolean} isAsc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNonFinancialItemsUploadEvents(limit: number, offset: number, sortKey: ListNonFinancialItemsUploadEventsSortKeyEnum, isAsc: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoNonFinancialItemsUploadEventsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNonFinancialItemsUploadEvents(limit, offset, sortKey, isAsc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NonFinancialItemsUploadEventsControllerApi.listNonFinancialItemsUploadEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NonFinancialItemsUploadEventsControllerApi - factory interface
 */
export const NonFinancialItemsUploadEventsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NonFinancialItemsUploadEventsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 非財務明細アップロードイベントの削除
         * @param {string} nonFinancialItemsUploadEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(nonFinancialItemsUploadEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp._delete(nonFinancialItemsUploadEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uploadEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadNonFinancialUploadedRaw(uploadEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadNonFinancialUploadedRaw(uploadEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非財務明細アップロードイベント一覧
         * @param {number} limit 
         * @param {number} offset 
         * @param {ListNonFinancialItemsUploadEventsSortKeyEnum} sortKey 
         * @param {boolean} isAsc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNonFinancialItemsUploadEvents(limit: number, offset: number, sortKey: ListNonFinancialItemsUploadEventsSortKeyEnum, isAsc: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoNonFinancialItemsUploadEventsDto> {
            return localVarFp.listNonFinancialItemsUploadEvents(limit, offset, sortKey, isAsc, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NonFinancialItemsUploadEventsControllerApi - object-oriented interface
 */
export class NonFinancialItemsUploadEventsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 非財務明細アップロードイベントの削除
     * @param {string} nonFinancialItemsUploadEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public _delete(nonFinancialItemsUploadEventId: string, options?: RawAxiosRequestConfig) {
        return NonFinancialItemsUploadEventsControllerApiFp(this.configuration)._delete(nonFinancialItemsUploadEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uploadEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadNonFinancialUploadedRaw(uploadEventId: string, options?: RawAxiosRequestConfig) {
        return NonFinancialItemsUploadEventsControllerApiFp(this.configuration).downloadNonFinancialUploadedRaw(uploadEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非財務明細アップロードイベント一覧
     * @param {number} limit 
     * @param {number} offset 
     * @param {ListNonFinancialItemsUploadEventsSortKeyEnum} sortKey 
     * @param {boolean} isAsc 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listNonFinancialItemsUploadEvents(limit: number, offset: number, sortKey: ListNonFinancialItemsUploadEventsSortKeyEnum, isAsc: boolean, options?: RawAxiosRequestConfig) {
        return NonFinancialItemsUploadEventsControllerApiFp(this.configuration).listNonFinancialItemsUploadEvents(limit, offset, sortKey, isAsc, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListNonFinancialItemsUploadEventsSortKeyEnum = {
    FileName: 'FILE_NAME',
    MinFiscalMonth: 'MIN_FISCAL_MONTH',
    ImportedAt: 'IMPORTED_AT',
} as const;
export type ListNonFinancialItemsUploadEventsSortKeyEnum = typeof ListNonFinancialItemsUploadEventsSortKeyEnum[keyof typeof ListNonFinancialItemsUploadEventsSortKeyEnum];


/**
 * OAuthControllerApi - axios parameter creator
 */
export const OAuthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary oauth-callback
         * @param {string} state 
         * @param {string} code 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback: async (state: string, code: string, errorDescription?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('callback', 'state', state)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('callback', 'code', code)
            const localVarPath = `/oauth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (errorDescription !== undefined) {
                localVarQueryParameter['error_description'] = errorDescription;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get-grant-code-of-oauth
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCode: async (state: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('getCode', 'state', state)
            const localVarPath = `/oauth/code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OAuthControllerApi - functional programming interface
 */
export const OAuthControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OAuthControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary oauth-callback
         * @param {string} state 
         * @param {string} code 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callback(state: string, code: string, errorDescription?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callback(state, code, errorDescription, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthControllerApi.callback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get-grant-code-of-oauth
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCode(state: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCode(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthControllerApi.getCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OAuthControllerApi - factory interface
 */
export const OAuthControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OAuthControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary oauth-callback
         * @param {string} state 
         * @param {string} code 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback(state: string, code: string, errorDescription?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.callback(state, code, errorDescription, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get-grant-code-of-oauth
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCode(state: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getCode(state, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OAuthControllerApi - object-oriented interface
 */
export class OAuthControllerApi extends BaseAPI {
    /**
     * 
     * @summary oauth-callback
     * @param {string} state 
     * @param {string} code 
     * @param {string} [errorDescription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public callback(state: string, code: string, errorDescription?: string, options?: RawAxiosRequestConfig) {
        return OAuthControllerApiFp(this.configuration).callback(state, code, errorDescription, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get-grant-code-of-oauth
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCode(state: string, options?: RawAxiosRequestConfig) {
        return OAuthControllerApiFp(this.configuration).getCode(state, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationTreeV2ControllerApi - axios parameter creator
 */
export const OrganizationTreeV2ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 組織図に未設定部署を追加する
         * @param {string} treeId 
         * @param {Array<string>} targetDepartmentIds 
         * @param {string} [newParentDepartmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDepartments: async (treeId: string, targetDepartmentIds: Array<string>, newParentDepartmentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('addDepartments', 'treeId', treeId)
            // verify required parameter 'targetDepartmentIds' is not null or undefined
            assertParamExists('addDepartments', 'targetDepartmentIds', targetDepartmentIds)
            const localVarPath = `/api/v2/organization-trees/{treeId}/adddepartments`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetDepartmentIds) {
                localVarQueryParameter['targetDepartmentIds'] = Array.from(targetDepartmentIds);
            }

            if (newParentDepartmentId !== undefined) {
                localVarQueryParameter['newParentDepartmentId'] = newParentDepartmentId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図の部署をアーカイブする
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveDepartment: async (treeId: string, targetDepartmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('archiveDepartment', 'treeId', treeId)
            // verify required parameter 'targetDepartmentId' is not null or undefined
            assertParamExists('archiveDepartment', 'targetDepartmentId', targetDepartmentId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/archive-department`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetDepartmentId !== undefined) {
                localVarQueryParameter['targetDepartmentId'] = targetDepartmentId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図構造で選択させるために本体値のある部署が存在するかチェックする。
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistsDepartment: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('checkExistsDepartment', 'treeId', treeId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/checkExists`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 新規組織図を作成する
         * @param {CreateOrganizationTreeParam} createOrganizationTreeParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationTree: async (createOrganizationTreeParam: CreateOrganizationTreeParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrganizationTreeParam' is not null or undefined
            assertParamExists('createOrganizationTree', 'createOrganizationTreeParam', createOrganizationTreeParam)
            const localVarPath = `/api/v2/organization-trees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrganizationTreeParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary サブツリーを削除する
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubTree: async (treeId: string, targetDepartmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('deleteSubTree', 'treeId', treeId)
            // verify required parameter 'targetDepartmentId' is not null or undefined
            assertParamExists('deleteSubTree', 'targetDepartmentId', targetDepartmentId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/subtree`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetDepartmentId !== undefined) {
                localVarQueryParameter['targetDepartmentId'] = targetDepartmentId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図を削除する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTree: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('deleteTree', 'treeId', treeId)
            const localVarPath = `/api/v2/organization-trees/{treeId}`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 部署一覧Excelのダウンロード
         * @param {string} orgTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrgDepartmentsExcel: async (orgTreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgTreeId' is not null or undefined
            assertParamExists('downloadOrgDepartmentsExcel', 'orgTreeId', orgTreeId)
            const localVarPath = `/api/v2/organization-trees/{orgTreeId}/departments/excel`
                .replace('{orgTreeId}', encodeURIComponent(String(orgTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Excelアップロードし、組織階層を一括作成・更新・削除する。
         * @param {string} orgTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload: async (orgTreeId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgTreeId' is not null or undefined
            assertParamExists('fileUpload', 'orgTreeId', orgTreeId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('fileUpload', 'file', file)
            const localVarPath = `/api/v2/organization-trees/{orgTreeId}/departments/excel`
                .replace('{orgTreeId}', encodeURIComponent(String(orgTreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 選択させるために本体値を表示するアクセス権限用組織図を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorityTreeForSelect: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/organization-trees/authority/for-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 特定のユーザーに選択させるために本体値を表示するアクセス権限用組織図を取得するAPI
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorityTreeForSelectionForUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAuthorityTreeForSelectionForUser', 'userId', userId)
            const localVarPath = `/api/v2/organization-trees/authority/for-selection/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図に含まれる部署一覧と未設定部署とアーカイブ部署の一覧の取得
         * @param {string} treeId 
         * @param {boolean} onlyNotIncluded 
         * @param {string} [searchWord] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList: async (treeId: string, onlyNotIncluded: boolean, searchWord?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList', 'treeId', treeId)
            // verify required parameter 'onlyNotIncluded' is not null or undefined
            assertParamExists('getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList', 'onlyNotIncluded', onlyNotIncluded)
            const localVarPath = `/api/v2/organization-trees/{treeId}/departments`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            if (onlyNotIncluded !== undefined) {
                localVarQueryParameter['onlyNotIncluded'] = onlyNotIncluded;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図に含まれない部署一覧を取得, 0件の場合は空のListを返す
         * @param {string} treeId 
         * @param {boolean} includingArchive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncluded: async (treeId: string, includingArchive: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getNotIncluded', 'treeId', treeId)
            // verify required parameter 'includingArchive' is not null or undefined
            assertParamExists('getNotIncluded', 'includingArchive', includingArchive)
            const localVarPath = `/api/v2/organization-trees/{treeId}/not-included`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (includingArchive !== undefined) {
                localVarQueryParameter['includingArchive'] = includingArchive;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図に含まれない部署数を取得
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncludedCount: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getNotIncludedCount', 'treeId', treeId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/not-included/count`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図構造で選択させるために本体値のある科目階層を取得する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTreeForSelect: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getOrganizationTreeForSelect', 'treeId', treeId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/for-selection`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図を取得するAPI
         * @param {string} treeId 
         * @param {string} [departmentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTrees: async (treeId: string, departmentName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('getOrganizationTrees', 'treeId', treeId)
            const localVarPath = `/api/v2/organization-trees/{treeId}`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (departmentName !== undefined) {
                localVarQueryParameter['departmentName'] = departmentName;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 選択させるために本体値を表示するプライマリ組織図を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryTreeForSelect: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/organization-trees/primary/for-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図の一覧を取得するAPI
         * @param {number} limit 
         * @param {number} offset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationTrees: async (limit: number, offset: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('listOrganizationTrees', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('listOrganizationTrees', 'offset', offset)
            const localVarPath = `/api/v2/organization-trees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ノードの移動先、部署の移動先の部署IDの候補（組織図に存在する部署ID一覧）
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParentDepartmentCandidates: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('listParentDepartmentCandidates', 'treeId', treeId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/parentdepartmentcandidates`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 既存の組織図のコピーを作成する
         * @param {string} treeId 
         * @param {CopyOrganizationTreeParam} copyOrganizationTreeParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeCopy: async (treeId: string, copyOrganizationTreeParam: CopyOrganizationTreeParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('makeCopy', 'treeId', treeId)
            // verify required parameter 'copyOrganizationTreeParam' is not null or undefined
            assertParamExists('makeCopy', 'copyOrganizationTreeParam', copyOrganizationTreeParam)
            const localVarPath = `/api/v2/organization-trees/{treeId}/makecopy`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyOrganizationTreeParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ノードを移動する
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {string} [newParentDepartmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNodes: async (treeId: string, targetDepartmentId: string, newParentDepartmentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('moveNodes', 'treeId', treeId)
            // verify required parameter 'targetDepartmentId' is not null or undefined
            assertParamExists('moveNodes', 'targetDepartmentId', targetDepartmentId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/movenode`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetDepartmentId !== undefined) {
                localVarQueryParameter['targetDepartmentId'] = targetDepartmentId;
            }

            if (newParentDepartmentId !== undefined) {
                localVarQueryParameter['newParentDepartmentId'] = newParentDepartmentId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図をアクセス権限用に設定する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAuthority: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('setAuthority', 'treeId', treeId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/set-authority`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図をプライマリに設定する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimary: async (treeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('setPrimary', 'treeId', treeId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/set-primary`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図のアーカイブ済の部署を戻す
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveDepartment: async (treeId: string, targetDepartmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('unarchiveDepartment', 'treeId', treeId)
            // verify required parameter 'targetDepartmentId' is not null or undefined
            assertParamExists('unarchiveDepartment', 'targetDepartmentId', targetDepartmentId)
            const localVarPath = `/api/v2/organization-trees/{treeId}/unarchive-department`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetDepartmentId !== undefined) {
                localVarQueryParameter['targetDepartmentId'] = targetDepartmentId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 組織図名の変更
         * @param {string} treeId 
         * @param {UpdateOrgTreeNameBody} updateOrgTreeNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationTreeName: async (treeId: string, updateOrgTreeNameBody: UpdateOrgTreeNameBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'treeId' is not null or undefined
            assertParamExists('updateOrganizationTreeName', 'treeId', treeId)
            // verify required parameter 'updateOrgTreeNameBody' is not null or undefined
            assertParamExists('updateOrganizationTreeName', 'updateOrgTreeNameBody', updateOrgTreeNameBody)
            const localVarPath = `/api/v2/organization-trees/{treeId}/treename`
                .replace('{treeId}', encodeURIComponent(String(treeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrgTreeNameBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationTreeV2ControllerApi - functional programming interface
 */
export const OrganizationTreeV2ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationTreeV2ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 組織図に未設定部署を追加する
         * @param {string} treeId 
         * @param {Array<string>} targetDepartmentIds 
         * @param {string} [newParentDepartmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDepartments(treeId: string, targetDepartmentIds: Array<string>, newParentDepartmentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDepartments(treeId, targetDepartmentIds, newParentDepartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.addDepartments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図の部署をアーカイブする
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveDepartment(treeId: string, targetDepartmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeV2View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveDepartment(treeId, targetDepartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.archiveDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図構造で選択させるために本体値のある部署が存在するかチェックする。
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkExistsDepartment(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkExistsDepartment(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.checkExistsDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 新規組織図を作成する
         * @param {CreateOrganizationTreeParam} createOrganizationTreeParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationTree(createOrganizationTreeParam: CreateOrganizationTreeParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationTree(createOrganizationTreeParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.createOrganizationTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary サブツリーを削除する
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubTree(treeId: string, targetDepartmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubTree(treeId, targetDepartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.deleteSubTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図を削除する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTree(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTree(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.deleteTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 部署一覧Excelのダウンロード
         * @param {string} orgTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOrgDepartmentsExcel(orgTreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOrgDepartmentsExcel(orgTreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.downloadOrgDepartmentsExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Excelアップロードし、組織階層を一括作成・更新・削除する。
         * @param {string} orgTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUpload(orgTreeId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUpload(orgTreeId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.fileUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 選択させるために本体値を表示するアクセス権限用組織図を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorityTreeForSelect(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorityTreeForSelect(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.getAuthorityTreeForSelect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 特定のユーザーに選択させるために本体値を表示するアクセス権限用組織図を取得するAPI
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorityTreeForSelectionForUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorityTreeForSelectionForUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.getAuthorityTreeForSelectionForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図に含まれる部署一覧と未設定部署とアーカイブ部署の一覧の取得
         * @param {string} treeId 
         * @param {boolean} onlyNotIncluded 
         * @param {string} [searchWord] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList(treeId: string, onlyNotIncluded: boolean, searchWord?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoDepartmentViewWithIsAssignedAndIsArchived>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList(treeId, onlyNotIncluded, searchWord, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図に含まれない部署一覧を取得, 0件の場合は空のListを返す
         * @param {string} treeId 
         * @param {boolean} includingArchive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotIncluded(treeId: string, includingArchive: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotIncluded(treeId, includingArchive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.getNotIncluded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図に含まれない部署数を取得
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotIncludedCount(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountDepartmentsNotIncludedInOrgDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotIncludedCount(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.getNotIncludedCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図構造で選択させるために本体値のある科目階層を取得する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationTreeForSelect(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationTreeForSelect(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.getOrganizationTreeForSelect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図を取得するAPI
         * @param {string} treeId 
         * @param {string} [departmentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationTrees(treeId: string, departmentName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationTrees(treeId, departmentName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.getOrganizationTrees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 選択させるために本体値を表示するプライマリ組織図を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrimaryTreeForSelect(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrimaryTreeForSelect(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.getPrimaryTreeForSelect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図の一覧を取得するAPI
         * @param {number} limit 
         * @param {number} offset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizationTrees(limit: number, offset: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationTreeListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizationTrees(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.listOrganizationTrees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ノードの移動先、部署の移動先の部署IDの候補（組織図に存在する部署ID一覧）
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listParentDepartmentCandidates(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listParentDepartmentCandidates(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.listParentDepartmentCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 既存の組織図のコピーを作成する
         * @param {string} treeId 
         * @param {CopyOrganizationTreeParam} copyOrganizationTreeParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async makeCopy(treeId: string, copyOrganizationTreeParam: CopyOrganizationTreeParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.makeCopy(treeId, copyOrganizationTreeParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.makeCopy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ノードを移動する
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {string} [newParentDepartmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveNodes(treeId: string, targetDepartmentId: string, newParentDepartmentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveNodes(treeId, targetDepartmentId, newParentDepartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.moveNodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図をアクセス権限用に設定する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAuthority(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAuthority(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.setAuthority']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図をプライマリに設定する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimary(treeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimary(treeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.setPrimary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図のアーカイブ済の部署を戻す
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unarchiveDepartment(treeId: string, targetDepartmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTreeV2View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unarchiveDepartment(treeId, targetDepartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.unarchiveDepartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 組織図名の変更
         * @param {string} treeId 
         * @param {UpdateOrgTreeNameBody} updateOrgTreeNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationTreeName(treeId: string, updateOrgTreeNameBody: UpdateOrgTreeNameBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationTreeName(treeId, updateOrgTreeNameBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationTreeV2ControllerApi.updateOrganizationTreeName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationTreeV2ControllerApi - factory interface
 */
export const OrganizationTreeV2ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationTreeV2ControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 組織図に未設定部署を追加する
         * @param {string} treeId 
         * @param {Array<string>} targetDepartmentIds 
         * @param {string} [newParentDepartmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDepartments(treeId: string, targetDepartmentIds: Array<string>, newParentDepartmentId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeView> {
            return localVarFp.addDepartments(treeId, targetDepartmentIds, newParentDepartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図の部署をアーカイブする
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveDepartment(treeId: string, targetDepartmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeV2View> {
            return localVarFp.archiveDepartment(treeId, targetDepartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図構造で選択させるために本体値のある部署が存在するかチェックする。
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistsDepartment(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkExistsDepartment(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 新規組織図を作成する
         * @param {CreateOrganizationTreeParam} createOrganizationTreeParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationTree(createOrganizationTreeParam: CreateOrganizationTreeParam, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeView> {
            return localVarFp.createOrganizationTree(createOrganizationTreeParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary サブツリーを削除する
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubTree(treeId: string, targetDepartmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeView> {
            return localVarFp.deleteSubTree(treeId, targetDepartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図を削除する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTree(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteTree(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 部署一覧Excelのダウンロード
         * @param {string} orgTreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrgDepartmentsExcel(orgTreeId: string, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadOrgDepartmentsExcel(orgTreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Excelアップロードし、組織階層を一括作成・更新・削除する。
         * @param {string} orgTreeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload(orgTreeId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.fileUpload(orgTreeId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 選択させるために本体値を表示するアクセス権限用組織図を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorityTreeForSelect(options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeForSelectionView> {
            return localVarFp.getAuthorityTreeForSelect(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 特定のユーザーに選択させるために本体値を表示するアクセス権限用組織図を取得するAPI
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorityTreeForSelectionForUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeForSelectionView> {
            return localVarFp.getAuthorityTreeForSelectionForUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図に含まれる部署一覧と未設定部署とアーカイブ部署の一覧の取得
         * @param {string} treeId 
         * @param {boolean} onlyNotIncluded 
         * @param {string} [searchWord] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList(treeId: string, onlyNotIncluded: boolean, searchWord?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoDepartmentViewWithIsAssignedAndIsArchived> {
            return localVarFp.getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList(treeId, onlyNotIncluded, searchWord, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図に含まれない部署一覧を取得, 0件の場合は空のListを返す
         * @param {string} treeId 
         * @param {boolean} includingArchive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncluded(treeId: string, includingArchive: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<DepartmentView>> {
            return localVarFp.getNotIncluded(treeId, includingArchive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図に含まれない部署数を取得
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotIncludedCount(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<CountDepartmentsNotIncludedInOrgDto> {
            return localVarFp.getNotIncludedCount(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図構造で選択させるために本体値のある科目階層を取得する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTreeForSelect(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeForSelectionView> {
            return localVarFp.getOrganizationTreeForSelect(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図を取得するAPI
         * @param {string} treeId 
         * @param {string} [departmentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationTrees(treeId: string, departmentName?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeView> {
            return localVarFp.getOrganizationTrees(treeId, departmentName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 選択させるために本体値を表示するプライマリ組織図を取得するAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryTreeForSelect(options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeForSelectionView> {
            return localVarFp.getPrimaryTreeForSelect(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図の一覧を取得するAPI
         * @param {number} limit 
         * @param {number} offset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationTrees(limit: number, offset: number, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationTreeListView> {
            return localVarFp.listOrganizationTrees(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ノードの移動先、部署の移動先の部署IDの候補（組織図に存在する部署ID一覧）
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParentDepartmentCandidates(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DepartmentView>> {
            return localVarFp.listParentDepartmentCandidates(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 既存の組織図のコピーを作成する
         * @param {string} treeId 
         * @param {CopyOrganizationTreeParam} copyOrganizationTreeParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeCopy(treeId: string, copyOrganizationTreeParam: CopyOrganizationTreeParam, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeView> {
            return localVarFp.makeCopy(treeId, copyOrganizationTreeParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ノードを移動する
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {string} [newParentDepartmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveNodes(treeId: string, targetDepartmentId: string, newParentDepartmentId?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeView> {
            return localVarFp.moveNodes(treeId, targetDepartmentId, newParentDepartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図をアクセス権限用に設定する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAuthority(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.setAuthority(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図をプライマリに設定する
         * @param {string} treeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimary(treeId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeView> {
            return localVarFp.setPrimary(treeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図のアーカイブ済の部署を戻す
         * @param {string} treeId 
         * @param {string} targetDepartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveDepartment(treeId: string, targetDepartmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrgTreeV2View> {
            return localVarFp.unarchiveDepartment(treeId, targetDepartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 組織図名の変更
         * @param {string} treeId 
         * @param {UpdateOrgTreeNameBody} updateOrgTreeNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationTreeName(treeId: string, updateOrgTreeNameBody: UpdateOrgTreeNameBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateOrganizationTreeName(treeId, updateOrgTreeNameBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationTreeV2ControllerApi - object-oriented interface
 */
export class OrganizationTreeV2ControllerApi extends BaseAPI {
    /**
     * 
     * @summary 組織図に未設定部署を追加する
     * @param {string} treeId 
     * @param {Array<string>} targetDepartmentIds 
     * @param {string} [newParentDepartmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addDepartments(treeId: string, targetDepartmentIds: Array<string>, newParentDepartmentId?: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).addDepartments(treeId, targetDepartmentIds, newParentDepartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図の部署をアーカイブする
     * @param {string} treeId 
     * @param {string} targetDepartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archiveDepartment(treeId: string, targetDepartmentId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).archiveDepartment(treeId, targetDepartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図構造で選択させるために本体値のある部署が存在するかチェックする。
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkExistsDepartment(treeId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).checkExistsDepartment(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 新規組織図を作成する
     * @param {CreateOrganizationTreeParam} createOrganizationTreeParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrganizationTree(createOrganizationTreeParam: CreateOrganizationTreeParam, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).createOrganizationTree(createOrganizationTreeParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary サブツリーを削除する
     * @param {string} treeId 
     * @param {string} targetDepartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSubTree(treeId: string, targetDepartmentId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).deleteSubTree(treeId, targetDepartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図を削除する
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTree(treeId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).deleteTree(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 部署一覧Excelのダウンロード
     * @param {string} orgTreeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadOrgDepartmentsExcel(orgTreeId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).downloadOrgDepartmentsExcel(orgTreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Excelアップロードし、組織階層を一括作成・更新・削除する。
     * @param {string} orgTreeId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUpload(orgTreeId: string, file: File, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).fileUpload(orgTreeId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 選択させるために本体値を表示するアクセス権限用組織図を取得するAPI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAuthorityTreeForSelect(options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).getAuthorityTreeForSelect(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 特定のユーザーに選択させるために本体値を表示するアクセス権限用組織図を取得するAPI
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAuthorityTreeForSelectionForUser(userId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).getAuthorityTreeForSelectionForUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図に含まれる部署一覧と未設定部署とアーカイブ部署の一覧の取得
     * @param {string} treeId 
     * @param {boolean} onlyNotIncluded 
     * @param {string} [searchWord] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList(treeId: string, onlyNotIncluded: boolean, searchWord?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).getDepartmentsInOrganizationTreeAndNotIncludedAndArchivedDepartmentsList(treeId, onlyNotIncluded, searchWord, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図に含まれない部署一覧を取得, 0件の場合は空のListを返す
     * @param {string} treeId 
     * @param {boolean} includingArchive 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotIncluded(treeId: string, includingArchive: boolean, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).getNotIncluded(treeId, includingArchive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図に含まれない部署数を取得
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotIncludedCount(treeId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).getNotIncludedCount(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図構造で選択させるために本体値のある科目階層を取得する
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationTreeForSelect(treeId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).getOrganizationTreeForSelect(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図を取得するAPI
     * @param {string} treeId 
     * @param {string} [departmentName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationTrees(treeId: string, departmentName?: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).getOrganizationTrees(treeId, departmentName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 選択させるために本体値を表示するプライマリ組織図を取得するAPI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPrimaryTreeForSelect(options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).getPrimaryTreeForSelect(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図の一覧を取得するAPI
     * @param {number} limit 
     * @param {number} offset 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listOrganizationTrees(limit: number, offset: number, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).listOrganizationTrees(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ノードの移動先、部署の移動先の部署IDの候補（組織図に存在する部署ID一覧）
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listParentDepartmentCandidates(treeId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).listParentDepartmentCandidates(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 既存の組織図のコピーを作成する
     * @param {string} treeId 
     * @param {CopyOrganizationTreeParam} copyOrganizationTreeParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public makeCopy(treeId: string, copyOrganizationTreeParam: CopyOrganizationTreeParam, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).makeCopy(treeId, copyOrganizationTreeParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ノードを移動する
     * @param {string} treeId 
     * @param {string} targetDepartmentId 
     * @param {string} [newParentDepartmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveNodes(treeId: string, targetDepartmentId: string, newParentDepartmentId?: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).moveNodes(treeId, targetDepartmentId, newParentDepartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図をアクセス権限用に設定する
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setAuthority(treeId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).setAuthority(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図をプライマリに設定する
     * @param {string} treeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setPrimary(treeId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).setPrimary(treeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図のアーカイブ済の部署を戻す
     * @param {string} treeId 
     * @param {string} targetDepartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unarchiveDepartment(treeId: string, targetDepartmentId: string, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).unarchiveDepartment(treeId, targetDepartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 組織図名の変更
     * @param {string} treeId 
     * @param {UpdateOrgTreeNameBody} updateOrgTreeNameBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrganizationTreeName(treeId: string, updateOrgTreeNameBody: UpdateOrgTreeNameBody, options?: RawAxiosRequestConfig) {
        return OrganizationTreeV2ControllerApiFp(this.configuration).updateOrganizationTreeName(treeId, updateOrgTreeNameBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PatternControllerApi - axios parameter creator
 */
export const PatternControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary パターンの作成
         * @param {CreatePatternRequestBody} createPatternRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPattern: async (createPatternRequestBody: CreatePatternRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPatternRequestBody' is not null or undefined
            assertParamExists('createPattern', 'createPatternRequestBody', createPatternRequestBody)
            const localVarPath = `/api/allocation/v2/patterns/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPatternRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パターンの削除
         * @param {string} patternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePattern: async (patternId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patternId' is not null or undefined
            assertParamExists('deletePattern', 'patternId', patternId)
            const localVarPath = `/api/allocation/v2/patterns/{patternId}`
                .replace('{patternId}', encodeURIComponent(String(patternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パターン詳細の取得
         * @param {string} patternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatternDetail: async (patternId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patternId' is not null or undefined
            assertParamExists('getPatternDetail', 'patternId', patternId)
            const localVarPath = `/api/allocation/v2/patterns/{patternId}`
                .replace('{patternId}', encodeURIComponent(String(patternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パターン概要一覧の取得（レポート用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatternSummaries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/allocation/v2/patterns/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パターン一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatterns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/allocation/v2/patterns/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パターンの更新
         * @param {string} patternId 
         * @param {UpdatePatternRequestBody} updatePatternRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePattern: async (patternId: string, updatePatternRequestBody: UpdatePatternRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patternId' is not null or undefined
            assertParamExists('updatePattern', 'patternId', patternId)
            // verify required parameter 'updatePatternRequestBody' is not null or undefined
            assertParamExists('updatePattern', 'updatePatternRequestBody', updatePatternRequestBody)
            const localVarPath = `/api/allocation/v2/patterns/{patternId}`
                .replace('{patternId}', encodeURIComponent(String(patternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePatternRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatternControllerApi - functional programming interface
 */
export const PatternControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatternControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary パターンの作成
         * @param {CreatePatternRequestBody} createPatternRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPattern(createPatternRequestBody: CreatePatternRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePatternView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPattern(createPatternRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatternControllerApi.createPattern']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary パターンの削除
         * @param {string} patternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePattern(patternId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePattern(patternId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatternControllerApi.deletePattern']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary パターン詳細の取得
         * @param {string} patternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPatternDetail(patternId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatternDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPatternDetail(patternId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatternControllerApi.getPatternDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary パターン概要一覧の取得（レポート用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPatternSummaries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatternSummaryView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPatternSummaries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatternControllerApi.listPatternSummaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary パターン一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPatterns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PatternSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPatterns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatternControllerApi.listPatterns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary パターンの更新
         * @param {string} patternId 
         * @param {UpdatePatternRequestBody} updatePatternRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePattern(patternId: string, updatePatternRequestBody: UpdatePatternRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePattern(patternId, updatePatternRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PatternControllerApi.updatePattern']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PatternControllerApi - factory interface
 */
export const PatternControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatternControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary パターンの作成
         * @param {CreatePatternRequestBody} createPatternRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPattern(createPatternRequestBody: CreatePatternRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreatePatternView> {
            return localVarFp.createPattern(createPatternRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パターンの削除
         * @param {string} patternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePattern(patternId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePattern(patternId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パターン詳細の取得
         * @param {string} patternId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatternDetail(patternId: string, options?: RawAxiosRequestConfig): AxiosPromise<PatternDetailDto> {
            return localVarFp.getPatternDetail(patternId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パターン概要一覧の取得（レポート用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatternSummaries(options?: RawAxiosRequestConfig): AxiosPromise<Array<PatternSummaryView>> {
            return localVarFp.listPatternSummaries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パターン一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPatterns(options?: RawAxiosRequestConfig): AxiosPromise<Array<PatternSummary>> {
            return localVarFp.listPatterns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パターンの更新
         * @param {string} patternId 
         * @param {UpdatePatternRequestBody} updatePatternRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePattern(patternId: string, updatePatternRequestBody: UpdatePatternRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePattern(patternId, updatePatternRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatternControllerApi - object-oriented interface
 */
export class PatternControllerApi extends BaseAPI {
    /**
     * 
     * @summary パターンの作成
     * @param {CreatePatternRequestBody} createPatternRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPattern(createPatternRequestBody: CreatePatternRequestBody, options?: RawAxiosRequestConfig) {
        return PatternControllerApiFp(this.configuration).createPattern(createPatternRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パターンの削除
     * @param {string} patternId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePattern(patternId: string, options?: RawAxiosRequestConfig) {
        return PatternControllerApiFp(this.configuration).deletePattern(patternId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パターン詳細の取得
     * @param {string} patternId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPatternDetail(patternId: string, options?: RawAxiosRequestConfig) {
        return PatternControllerApiFp(this.configuration).getPatternDetail(patternId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パターン概要一覧の取得（レポート用）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPatternSummaries(options?: RawAxiosRequestConfig) {
        return PatternControllerApiFp(this.configuration).listPatternSummaries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パターン一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPatterns(options?: RawAxiosRequestConfig) {
        return PatternControllerApiFp(this.configuration).listPatterns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パターンの更新
     * @param {string} patternId 
     * @param {UpdatePatternRequestBody} updatePatternRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePattern(patternId: string, updatePatternRequestBody: UpdatePatternRequestBody, options?: RawAxiosRequestConfig) {
        return PatternControllerApiFp(this.configuration).updatePattern(patternId, updatePatternRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PermissionGroupControllerApi - axios parameter creator
 */
export const PermissionGroupControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 権限グループを作成する
         * @param {SavePermissionGroupBody} savePermissionGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermissionGroup: async (savePermissionGroupBody: SavePermissionGroupBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savePermissionGroupBody' is not null or undefined
            assertParamExists('createPermissionGroup', 'savePermissionGroupBody', savePermissionGroupBody)
            const localVarPath = `/api/workforce-planning/permission-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePermissionGroupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限グループを削除する
         * @param {string} permissionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionGroup: async (permissionGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionGroupId' is not null or undefined
            assertParamExists('deletePermissionGroup', 'permissionGroupId', permissionGroupId)
            const localVarPath = `/api/workforce-planning/permission-groups/{permissionGroupId}`
                .replace('{permissionGroupId}', encodeURIComponent(String(permissionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限グループを取得する
         * @param {string} permissionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionGroup: async (permissionGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionGroupId' is not null or undefined
            assertParamExists('getPermissionGroup', 'permissionGroupId', permissionGroupId)
            const localVarPath = `/api/workforce-planning/permission-groups/{permissionGroupId}`
                .replace('{permissionGroupId}', encodeURIComponent(String(permissionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限グループ一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissionGroup: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/permission-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限グループに割り当てる対象のユーザを取得する
         * @param {string} [permissionGroupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissionGroupAssignTargetUsers: async (permissionGroupId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/permission-groups/assign-target-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (permissionGroupId !== undefined) {
                localVarQueryParameter['permissionGroupId'] = permissionGroupId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限グループの名称を更新する
         * @param {string} permissionGroupId 
         * @param {RenamePermissionGroupNameBody} renamePermissionGroupNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renamePermissionGroup: async (permissionGroupId: string, renamePermissionGroupNameBody: RenamePermissionGroupNameBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionGroupId' is not null or undefined
            assertParamExists('renamePermissionGroup', 'permissionGroupId', permissionGroupId)
            // verify required parameter 'renamePermissionGroupNameBody' is not null or undefined
            assertParamExists('renamePermissionGroup', 'renamePermissionGroupNameBody', renamePermissionGroupNameBody)
            const localVarPath = `/api/workforce-planning/permission-groups/{permissionGroupId}/name`
                .replace('{permissionGroupId}', encodeURIComponent(String(permissionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renamePermissionGroupNameBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 権限グループを更新する
         * @param {string} permissionGroupId 
         * @param {SavePermissionGroupBody} savePermissionGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionGroup: async (permissionGroupId: string, savePermissionGroupBody: SavePermissionGroupBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionGroupId' is not null or undefined
            assertParamExists('updatePermissionGroup', 'permissionGroupId', permissionGroupId)
            // verify required parameter 'savePermissionGroupBody' is not null or undefined
            assertParamExists('updatePermissionGroup', 'savePermissionGroupBody', savePermissionGroupBody)
            const localVarPath = `/api/workforce-planning/permission-groups/{permissionGroupId}`
                .replace('{permissionGroupId}', encodeURIComponent(String(permissionGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePermissionGroupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionGroupControllerApi - functional programming interface
 */
export const PermissionGroupControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionGroupControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 権限グループを作成する
         * @param {SavePermissionGroupBody} savePermissionGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPermissionGroup(savePermissionGroupBody: SavePermissionGroupBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedPermissionGroupView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPermissionGroup(savePermissionGroupBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionGroupControllerApi.createPermissionGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 権限グループを削除する
         * @param {string} permissionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePermissionGroup(permissionGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePermissionGroup(permissionGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionGroupControllerApi.deletePermissionGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 権限グループを取得する
         * @param {string} permissionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionGroup(permissionGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchWorkforcePlanningPermissionGroupReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionGroup(permissionGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionGroupControllerApi.getPermissionGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 権限グループ一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPermissionGroup(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionItemView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPermissionGroup(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionGroupControllerApi.listPermissionGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 権限グループに割り当てる対象のユーザを取得する
         * @param {string} [permissionGroupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPermissionGroupAssignTargetUsers(permissionGroupId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchPermissionGroupAssignTargetUsersView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPermissionGroupAssignTargetUsers(permissionGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionGroupControllerApi.listPermissionGroupAssignTargetUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 権限グループの名称を更新する
         * @param {string} permissionGroupId 
         * @param {RenamePermissionGroupNameBody} renamePermissionGroupNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renamePermissionGroup(permissionGroupId: string, renamePermissionGroupNameBody: RenamePermissionGroupNameBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renamePermissionGroup(permissionGroupId, renamePermissionGroupNameBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionGroupControllerApi.renamePermissionGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 権限グループを更新する
         * @param {string} permissionGroupId 
         * @param {SavePermissionGroupBody} savePermissionGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePermissionGroup(permissionGroupId: string, savePermissionGroupBody: SavePermissionGroupBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePermissionGroup(permissionGroupId, savePermissionGroupBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionGroupControllerApi.updatePermissionGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PermissionGroupControllerApi - factory interface
 */
export const PermissionGroupControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionGroupControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 権限グループを作成する
         * @param {SavePermissionGroupBody} savePermissionGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermissionGroup(savePermissionGroupBody: SavePermissionGroupBody, options?: RawAxiosRequestConfig): AxiosPromise<CreatedPermissionGroupView> {
            return localVarFp.createPermissionGroup(savePermissionGroupBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 権限グループを削除する
         * @param {string} permissionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePermissionGroup(permissionGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePermissionGroup(permissionGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 権限グループを取得する
         * @param {string} permissionGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionGroup(permissionGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchWorkforcePlanningPermissionGroupReturn> {
            return localVarFp.getPermissionGroup(permissionGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 権限グループ一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissionGroup(options?: RawAxiosRequestConfig): AxiosPromise<PermissionItemView> {
            return localVarFp.listPermissionGroup(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 権限グループに割り当てる対象のユーザを取得する
         * @param {string} [permissionGroupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissionGroupAssignTargetUsers(permissionGroupId?: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchPermissionGroupAssignTargetUsersView> {
            return localVarFp.listPermissionGroupAssignTargetUsers(permissionGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 権限グループの名称を更新する
         * @param {string} permissionGroupId 
         * @param {RenamePermissionGroupNameBody} renamePermissionGroupNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renamePermissionGroup(permissionGroupId: string, renamePermissionGroupNameBody: RenamePermissionGroupNameBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.renamePermissionGroup(permissionGroupId, renamePermissionGroupNameBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 権限グループを更新する
         * @param {string} permissionGroupId 
         * @param {SavePermissionGroupBody} savePermissionGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionGroup(permissionGroupId: string, savePermissionGroupBody: SavePermissionGroupBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePermissionGroup(permissionGroupId, savePermissionGroupBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionGroupControllerApi - object-oriented interface
 */
export class PermissionGroupControllerApi extends BaseAPI {
    /**
     * 
     * @summary 権限グループを作成する
     * @param {SavePermissionGroupBody} savePermissionGroupBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPermissionGroup(savePermissionGroupBody: SavePermissionGroupBody, options?: RawAxiosRequestConfig) {
        return PermissionGroupControllerApiFp(this.configuration).createPermissionGroup(savePermissionGroupBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 権限グループを削除する
     * @param {string} permissionGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePermissionGroup(permissionGroupId: string, options?: RawAxiosRequestConfig) {
        return PermissionGroupControllerApiFp(this.configuration).deletePermissionGroup(permissionGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 権限グループを取得する
     * @param {string} permissionGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPermissionGroup(permissionGroupId: string, options?: RawAxiosRequestConfig) {
        return PermissionGroupControllerApiFp(this.configuration).getPermissionGroup(permissionGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 権限グループ一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPermissionGroup(options?: RawAxiosRequestConfig) {
        return PermissionGroupControllerApiFp(this.configuration).listPermissionGroup(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 権限グループに割り当てる対象のユーザを取得する
     * @param {string} [permissionGroupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPermissionGroupAssignTargetUsers(permissionGroupId?: string, options?: RawAxiosRequestConfig) {
        return PermissionGroupControllerApiFp(this.configuration).listPermissionGroupAssignTargetUsers(permissionGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 権限グループの名称を更新する
     * @param {string} permissionGroupId 
     * @param {RenamePermissionGroupNameBody} renamePermissionGroupNameBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public renamePermissionGroup(permissionGroupId: string, renamePermissionGroupNameBody: RenamePermissionGroupNameBody, options?: RawAxiosRequestConfig) {
        return PermissionGroupControllerApiFp(this.configuration).renamePermissionGroup(permissionGroupId, renamePermissionGroupNameBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 権限グループを更新する
     * @param {string} permissionGroupId 
     * @param {SavePermissionGroupBody} savePermissionGroupBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePermissionGroup(permissionGroupId: string, savePermissionGroupBody: SavePermissionGroupBody, options?: RawAxiosRequestConfig) {
        return PermissionGroupControllerApiFp(this.configuration).updatePermissionGroup(permissionGroupId, savePermissionGroupBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PersonListControllerApi - axios parameter creator
 */
export const PersonListControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人員情報を削除する
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePerson: async (workforceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceId' is not null or undefined
            assertParamExists('deletePerson', 'workforceId', workforceId)
            const localVarPath = `/api/workforce-planning/person-list/{workforceId}`
                .replace('{workforceId}', encodeURIComponent(String(workforceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員の一括登録・更新をするフォーマットをダウンロードする
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBulkUpsertPeopleExcel: async (yearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('downloadBulkUpsertPeopleExcel', 'yearMonth', yearMonth)
            const localVarPath = `/api/workforce-planning/person-list/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員の一括登録/更新の Excel ファイルをダウンロードする
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadWorkforceActualImportEventFile: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('downloadWorkforceActualImportEventFile', 'eventId', eventId)
            const localVarPath = `/api/workforce-planning/person-list/upload-event/{eventId}/excel`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員情報を取得する
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPerson: async (workforceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceId' is not null or undefined
            assertParamExists('findPerson', 'workforceId', workforceId)
            const localVarPath = `/api/workforce-planning/person-list/{workforceId}`
                .replace('{workforceId}', encodeURIComponent(String(workforceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員実績で利用している分析軸のリストを取得する
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listUsingDimensions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/person-list/using-dimensions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員一覧を検索する
         * @param {SearchPersonListRequestBody} searchPersonListRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPersonList: async (searchPersonListRequestBody: SearchPersonListRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchPersonListRequestBody' is not null or undefined
            assertParamExists('searchPersonList', 'searchPersonListRequestBody', searchPersonListRequestBody)
            const localVarPath = `/api/workforce-planning/person-list/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchPersonListRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員の姓名とコードを変更する
         * @param {string} workforceId 
         * @param {UpdatePersonNameAndCodeRequestBody} updatePersonNameAndCodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonNameAndCode: async (workforceId: string, updatePersonNameAndCodeRequestBody: UpdatePersonNameAndCodeRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceId' is not null or undefined
            assertParamExists('updatePersonNameAndCode', 'workforceId', workforceId)
            // verify required parameter 'updatePersonNameAndCodeRequestBody' is not null or undefined
            assertParamExists('updatePersonNameAndCode', 'updatePersonNameAndCodeRequestBody', updatePersonNameAndCodeRequestBody)
            const localVarPath = `/api/workforce-planning/person-list/{workforceId}`
                .replace('{workforceId}', encodeURIComponent(String(workforceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePersonNameAndCodeRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員の一括登録/更新の Excel ファイルを取込設定を指定してアップロードする
         * @param {string} mappingSettingId 
         * @param {File} file 
         * @param {string} [effectiveYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWorkforceActual: async (mappingSettingId: string, file: File, effectiveYearMonth?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingSettingId' is not null or undefined
            assertParamExists('upsertWorkforceActual', 'mappingSettingId', mappingSettingId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('upsertWorkforceActual', 'file', file)
            const localVarPath = `/api/workforce-planning/person-list/upsert-workforce-actual/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (mappingSettingId !== undefined) {
                localVarQueryParameter['mappingSettingId'] = mappingSettingId;
            }

            if (effectiveYearMonth !== undefined) {
                localVarQueryParameter['effectiveYearMonth'] = effectiveYearMonth;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonListControllerApi - functional programming interface
 */
export const PersonListControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonListControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人員情報を削除する
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePerson(workforceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePerson(workforceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonListControllerApi.deletePerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員の一括登録・更新をするフォーマットをダウンロードする
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBulkUpsertPeopleExcel(yearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBulkUpsertPeopleExcel(yearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonListControllerApi.downloadBulkUpsertPeopleExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員の一括登録/更新の Excel ファイルをダウンロードする
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadWorkforceActualImportEventFile(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadWorkforceActualImportEventFile(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonListControllerApi.downloadWorkforceActualImportEventFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員情報を取得する
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPerson(workforceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPerson(workforceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonListControllerApi.findPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員実績で利用している分析軸のリストを取得する
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listUsingDimensions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DimensionView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsingDimensions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonListControllerApi.listUsingDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員一覧を検索する
         * @param {SearchPersonListRequestBody} searchPersonListRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPersonList(searchPersonListRequestBody: SearchPersonListRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoPersonListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPersonList(searchPersonListRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonListControllerApi.searchPersonList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員の姓名とコードを変更する
         * @param {string} workforceId 
         * @param {UpdatePersonNameAndCodeRequestBody} updatePersonNameAndCodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonNameAndCode(workforceId: string, updatePersonNameAndCodeRequestBody: UpdatePersonNameAndCodeRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonNameAndCode(workforceId, updatePersonNameAndCodeRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonListControllerApi.updatePersonNameAndCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員の一括登録/更新の Excel ファイルを取込設定を指定してアップロードする
         * @param {string} mappingSettingId 
         * @param {File} file 
         * @param {string} [effectiveYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertWorkforceActual(mappingSettingId: string, file: File, effectiveYearMonth?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertWorkforceActual(mappingSettingId, file, effectiveYearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonListControllerApi.upsertWorkforceActual']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PersonListControllerApi - factory interface
 */
export const PersonListControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonListControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人員情報を削除する
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePerson(workforceId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deletePerson(workforceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員の一括登録・更新をするフォーマットをダウンロードする
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBulkUpsertPeopleExcel(yearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadBulkUpsertPeopleExcel(yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員の一括登録/更新の Excel ファイルをダウンロードする
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadWorkforceActualImportEventFile(eventId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadWorkforceActualImportEventFile(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員情報を取得する
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPerson(workforceId: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonView> {
            return localVarFp.findPerson(workforceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員実績で利用している分析軸のリストを取得する
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listUsingDimensions(options?: RawAxiosRequestConfig): AxiosPromise<Array<DimensionView>> {
            return localVarFp.listUsingDimensions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員一覧を検索する
         * @param {SearchPersonListRequestBody} searchPersonListRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPersonList(searchPersonListRequestBody: SearchPersonListRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoPersonListItem> {
            return localVarFp.searchPersonList(searchPersonListRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員の姓名とコードを変更する
         * @param {string} workforceId 
         * @param {UpdatePersonNameAndCodeRequestBody} updatePersonNameAndCodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonNameAndCode(workforceId: string, updatePersonNameAndCodeRequestBody: UpdatePersonNameAndCodeRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updatePersonNameAndCode(workforceId, updatePersonNameAndCodeRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員の一括登録/更新の Excel ファイルを取込設定を指定してアップロードする
         * @param {string} mappingSettingId 
         * @param {File} file 
         * @param {string} [effectiveYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWorkforceActual(mappingSettingId: string, file: File, effectiveYearMonth?: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.upsertWorkforceActual(mappingSettingId, file, effectiveYearMonth, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonListControllerApi - object-oriented interface
 */
export class PersonListControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人員情報を削除する
     * @param {string} workforceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePerson(workforceId: string, options?: RawAxiosRequestConfig) {
        return PersonListControllerApiFp(this.configuration).deletePerson(workforceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員の一括登録・更新をするフォーマットをダウンロードする
     * @param {string} yearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadBulkUpsertPeopleExcel(yearMonth: string, options?: RawAxiosRequestConfig) {
        return PersonListControllerApiFp(this.configuration).downloadBulkUpsertPeopleExcel(yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員の一括登録/更新の Excel ファイルをダウンロードする
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadWorkforceActualImportEventFile(eventId: string, options?: RawAxiosRequestConfig) {
        return PersonListControllerApiFp(this.configuration).downloadWorkforceActualImportEventFile(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員情報を取得する
     * @param {string} workforceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findPerson(workforceId: string, options?: RawAxiosRequestConfig) {
        return PersonListControllerApiFp(this.configuration).findPerson(workforceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員実績で利用している分析軸のリストを取得する
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public listUsingDimensions(options?: RawAxiosRequestConfig) {
        return PersonListControllerApiFp(this.configuration).listUsingDimensions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員一覧を検索する
     * @param {SearchPersonListRequestBody} searchPersonListRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchPersonList(searchPersonListRequestBody: SearchPersonListRequestBody, options?: RawAxiosRequestConfig) {
        return PersonListControllerApiFp(this.configuration).searchPersonList(searchPersonListRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員の姓名とコードを変更する
     * @param {string} workforceId 
     * @param {UpdatePersonNameAndCodeRequestBody} updatePersonNameAndCodeRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePersonNameAndCode(workforceId: string, updatePersonNameAndCodeRequestBody: UpdatePersonNameAndCodeRequestBody, options?: RawAxiosRequestConfig) {
        return PersonListControllerApiFp(this.configuration).updatePersonNameAndCode(workforceId, updatePersonNameAndCodeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員の一括登録/更新の Excel ファイルを取込設定を指定してアップロードする
     * @param {string} mappingSettingId 
     * @param {File} file 
     * @param {string} [effectiveYearMonth] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upsertWorkforceActual(mappingSettingId: string, file: File, effectiveYearMonth?: string, options?: RawAxiosRequestConfig) {
        return PersonListControllerApiFp(this.configuration).upsertWorkforceActual(mappingSettingId, file, effectiveYearMonth, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanActualDetailControllerApi - axios parameter creator
 */
export const PlanActualDetailControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FetchDetailRequestBody} fetchDetailRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchResult: async (fetchDetailRequestBody: FetchDetailRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchDetailRequestBody' is not null or undefined
            assertParamExists('fetchResult', 'fetchDetailRequestBody', fetchDetailRequestBody)
            const localVarPath = `/api/plan-actual-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchDetailRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanActualDetailControllerApi - functional programming interface
 */
export const PlanActualDetailControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanActualDetailControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FetchDetailRequestBody} fetchDetailRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchResult(fetchDetailRequestBody: FetchDetailRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchPlanActualDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchResult(fetchDetailRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanActualDetailControllerApi.fetchResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanActualDetailControllerApi - factory interface
 */
export const PlanActualDetailControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanActualDetailControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {FetchDetailRequestBody} fetchDetailRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchResult(fetchDetailRequestBody: FetchDetailRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FetchPlanActualDetailView> {
            return localVarFp.fetchResult(fetchDetailRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanActualDetailControllerApi - object-oriented interface
 */
export class PlanActualDetailControllerApi extends BaseAPI {
    /**
     * 
     * @param {FetchDetailRequestBody} fetchDetailRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchResult(fetchDetailRequestBody: FetchDetailRequestBody, options?: RawAxiosRequestConfig) {
        return PlanActualDetailControllerApiFp(this.configuration).fetchResult(fetchDetailRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanBulkExcelPublishControllerApi - axios parameter creator
 */
export const PlanBulkExcelPublishControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 一括更新申請のためのExcelを作成
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanBulkExcel: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createPlanBulkExcel', 'projectId', projectId)
            const localVarPath = `/api/plans/planningProjects/{projectId}/bulk-format/excel`
                .replace('{projectId}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanBulkExcelPublishControllerApi - functional programming interface
 */
export const PlanBulkExcelPublishControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanBulkExcelPublishControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 一括更新申請のためのExcelを作成
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlanBulkExcel(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanBulkExcel(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanBulkExcelPublishControllerApi.createPlanBulkExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanBulkExcelPublishControllerApi - factory interface
 */
export const PlanBulkExcelPublishControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanBulkExcelPublishControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 一括更新申請のためのExcelを作成
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanBulkExcel(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.createPlanBulkExcel(projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanBulkExcelPublishControllerApi - object-oriented interface
 */
export class PlanBulkExcelPublishControllerApi extends BaseAPI {
    /**
     * 
     * @summary 一括更新申請のためのExcelを作成
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPlanBulkExcel(projectId: string, options?: RawAxiosRequestConfig) {
        return PlanBulkExcelPublishControllerApiFp(this.configuration).createPlanBulkExcel(projectId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanExcelPublishControllerApi - axios parameter creator
 */
export const PlanExcelPublishControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 明細単位の更新申請のためのExcelを作成
         * @param {string} planningProjectId 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanDetailFormat: async (planningProjectId: string, departmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('createPlanDetailFormat', 'planningProjectId', planningProjectId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('createPlanDetailFormat', 'departmentId', departmentId)
            const localVarPath = `/api/plans/planningProjects/{planningProjectId}/departments/{departmentId}/excel/plan-detail`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{departmentId}', encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請のためのExcelを作成
         * @param {string} planningProjectId 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanExcel: async (planningProjectId: string, departmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('createPlanExcel', 'planningProjectId', planningProjectId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('createPlanExcel', 'departmentId', departmentId)
            const localVarPath = `/api/plans/planningProjects/{planningProjectId}/departments/{departmentId}/excel`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{departmentId}', encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanExcelPublishControllerApi - functional programming interface
 */
export const PlanExcelPublishControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanExcelPublishControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 明細単位の更新申請のためのExcelを作成
         * @param {string} planningProjectId 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlanDetailFormat(planningProjectId: string, departmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanDetailFormat(planningProjectId, departmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanExcelPublishControllerApi.createPlanDetailFormat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請のためのExcelを作成
         * @param {string} planningProjectId 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlanExcel(planningProjectId: string, departmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanExcel(planningProjectId, departmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanExcelPublishControllerApi.createPlanExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanExcelPublishControllerApi - factory interface
 */
export const PlanExcelPublishControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanExcelPublishControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 明細単位の更新申請のためのExcelを作成
         * @param {string} planningProjectId 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanDetailFormat(planningProjectId: string, departmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.createPlanDetailFormat(planningProjectId, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請のためのExcelを作成
         * @param {string} planningProjectId 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanExcel(planningProjectId: string, departmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.createPlanExcel(planningProjectId, departmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanExcelPublishControllerApi - object-oriented interface
 */
export class PlanExcelPublishControllerApi extends BaseAPI {
    /**
     * 
     * @summary 明細単位の更新申請のためのExcelを作成
     * @param {string} planningProjectId 
     * @param {string} departmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPlanDetailFormat(planningProjectId: string, departmentId: string, options?: RawAxiosRequestConfig) {
        return PlanExcelPublishControllerApiFp(this.configuration).createPlanDetailFormat(planningProjectId, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請のためのExcelを作成
     * @param {string} planningProjectId 
     * @param {string} departmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPlanExcel(planningProjectId: string, departmentId: string, options?: RawAxiosRequestConfig) {
        return PlanExcelPublishControllerApiFp(this.configuration).createPlanExcel(planningProjectId, departmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanGSheetPublishControllerApi - axios parameter creator
 */
export const PlanGSheetPublishControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 編成プロジェクトのGoogle Sheetsを作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateGSheetParam} createGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (planMasterId: string, planningProjectId: string, createGSheetParam: CreateGSheetParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('create', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('create', 'planningProjectId', planningProjectId)
            // verify required parameter 'createGSheetParam' is not null or undefined
            assertParamExists('create', 'createGSheetParam', createGSheetParam)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/gsheets/publish`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGSheetParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 一括更新申請のGoogle Sheetsを作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateBulkPlanUpdateRequestGSheetParam} createBulkPlanUpdateRequestGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkPlanUpdateRequest: async (planMasterId: string, planningProjectId: string, createBulkPlanUpdateRequestGSheetParam: CreateBulkPlanUpdateRequestGSheetParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('createBulkPlanUpdateRequest', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('createBulkPlanUpdateRequest', 'planningProjectId', planningProjectId)
            // verify required parameter 'createBulkPlanUpdateRequestGSheetParam' is not null or undefined
            assertParamExists('createBulkPlanUpdateRequest', 'createBulkPlanUpdateRequestGSheetParam', createBulkPlanUpdateRequestGSheetParam)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/gsheets/publish/plan-update-requests`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBulkPlanUpdateRequestGSheetParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分析軸単位の更新申請のGoogle Sheetsを作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateGSheetParam} createGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetail: async (planMasterId: string, planningProjectId: string, createGSheetParam: CreateGSheetParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('createDetail', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('createDetail', 'planningProjectId', planningProjectId)
            // verify required parameter 'createGSheetParam' is not null or undefined
            assertParamExists('createDetail', 'createGSheetParam', createGSheetParam)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/gsheets/publish/plan-detail`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGSheetParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanGSheetPublishControllerApi - functional programming interface
 */
export const PlanGSheetPublishControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanGSheetPublishControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 編成プロジェクトのGoogle Sheetsを作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateGSheetParam} createGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(planMasterId: string, planningProjectId: string, createGSheetParam: CreateGSheetParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedGSheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(planMasterId, planningProjectId, createGSheetParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanGSheetPublishControllerApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 一括更新申請のGoogle Sheetsを作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateBulkPlanUpdateRequestGSheetParam} createBulkPlanUpdateRequestGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBulkPlanUpdateRequest(planMasterId: string, planningProjectId: string, createBulkPlanUpdateRequestGSheetParam: CreateBulkPlanUpdateRequestGSheetParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedGSheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBulkPlanUpdateRequest(planMasterId, planningProjectId, createBulkPlanUpdateRequestGSheetParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanGSheetPublishControllerApi.createBulkPlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 分析軸単位の更新申請のGoogle Sheetsを作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateGSheetParam} createGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDetail(planMasterId: string, planningProjectId: string, createGSheetParam: CreateGSheetParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedGSheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDetail(planMasterId, planningProjectId, createGSheetParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanGSheetPublishControllerApi.createDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanGSheetPublishControllerApi - factory interface
 */
export const PlanGSheetPublishControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanGSheetPublishControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 編成プロジェクトのGoogle Sheetsを作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateGSheetParam} createGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(planMasterId: string, planningProjectId: string, createGSheetParam: CreateGSheetParam, options?: RawAxiosRequestConfig): AxiosPromise<CreatedGSheetView> {
            return localVarFp.create(planMasterId, planningProjectId, createGSheetParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 一括更新申請のGoogle Sheetsを作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateBulkPlanUpdateRequestGSheetParam} createBulkPlanUpdateRequestGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkPlanUpdateRequest(planMasterId: string, planningProjectId: string, createBulkPlanUpdateRequestGSheetParam: CreateBulkPlanUpdateRequestGSheetParam, options?: RawAxiosRequestConfig): AxiosPromise<CreatedGSheetView> {
            return localVarFp.createBulkPlanUpdateRequest(planMasterId, planningProjectId, createBulkPlanUpdateRequestGSheetParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分析軸単位の更新申請のGoogle Sheetsを作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateGSheetParam} createGSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetail(planMasterId: string, planningProjectId: string, createGSheetParam: CreateGSheetParam, options?: RawAxiosRequestConfig): AxiosPromise<CreatedGSheetView> {
            return localVarFp.createDetail(planMasterId, planningProjectId, createGSheetParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanGSheetPublishControllerApi - object-oriented interface
 */
export class PlanGSheetPublishControllerApi extends BaseAPI {
    /**
     * 
     * @summary 編成プロジェクトのGoogle Sheetsを作成
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {CreateGSheetParam} createGSheetParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create(planMasterId: string, planningProjectId: string, createGSheetParam: CreateGSheetParam, options?: RawAxiosRequestConfig) {
        return PlanGSheetPublishControllerApiFp(this.configuration).create(planMasterId, planningProjectId, createGSheetParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 一括更新申請のGoogle Sheetsを作成
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {CreateBulkPlanUpdateRequestGSheetParam} createBulkPlanUpdateRequestGSheetParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createBulkPlanUpdateRequest(planMasterId: string, planningProjectId: string, createBulkPlanUpdateRequestGSheetParam: CreateBulkPlanUpdateRequestGSheetParam, options?: RawAxiosRequestConfig) {
        return PlanGSheetPublishControllerApiFp(this.configuration).createBulkPlanUpdateRequest(planMasterId, planningProjectId, createBulkPlanUpdateRequestGSheetParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分析軸単位の更新申請のGoogle Sheetsを作成
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {CreateGSheetParam} createGSheetParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDetail(planMasterId: string, planningProjectId: string, createGSheetParam: CreateGSheetParam, options?: RawAxiosRequestConfig) {
        return PlanGSheetPublishControllerApiFp(this.configuration).createDetail(planMasterId, planningProjectId, createGSheetParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanMasterControllerApi - axios parameter creator
 */
export const PlanMasterControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 計画マスタアーカイブ
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveMaster: async (planMasterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('archiveMaster', 'planMasterId', planMasterId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/archive`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計画マスタアーカイブ取消
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelArchiveMaster: async (planMasterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('cancelArchiveMaster', 'planMasterId', planMasterId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/cancelArchive`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計画マスタ新規作成
         * @param {CreatePlanMaster} createPlanMaster 
         * @param {string} [originId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaster: async (createPlanMaster: CreatePlanMaster, originId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPlanMaster' is not null or undefined
            assertParamExists('createMaster', 'createPlanMaster', createPlanMaster)
            const localVarPath = `/api/plans/planmasters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (originId !== undefined) {
                localVarQueryParameter['originId'] = originId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPlanMaster, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計画マスタ削除
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaster: async (planMasterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('deleteMaster', 'planMasterId', planMasterId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計画マスタの一覧
         * @param {boolean} isArchived 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanMasters: async (isArchived: boolean, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isArchived' is not null or undefined
            assertParamExists('listPlanMasters', 'isArchived', isArchived)
            const localVarPath = `/api/plans/planmasters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計画マスタ編集
         * @param {string} planMasterId 
         * @param {UpdatePlanMaster} updatePlanMaster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaster: async (planMasterId: string, updatePlanMaster: UpdatePlanMaster, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('updateMaster', 'planMasterId', planMasterId)
            // verify required parameter 'updatePlanMaster' is not null or undefined
            assertParamExists('updateMaster', 'updatePlanMaster', updatePlanMaster)
            const localVarPath = `/api/plans/planmasters/{planMasterId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlanMaster, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanMasterControllerApi - functional programming interface
 */
export const PlanMasterControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanMasterControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 計画マスタアーカイブ
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveMaster(planMasterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveMaster(planMasterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanMasterControllerApi.archiveMaster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計画マスタアーカイブ取消
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelArchiveMaster(planMasterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelArchiveMaster(planMasterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanMasterControllerApi.cancelArchiveMaster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計画マスタ新規作成
         * @param {CreatePlanMaster} createPlanMaster 
         * @param {string} [originId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMaster(createPlanMaster: CreatePlanMaster, originId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanMasterMetaView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMaster(createPlanMaster, originId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanMasterControllerApi.createMaster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計画マスタ削除
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMaster(planMasterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMaster(planMasterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanMasterControllerApi.deleteMaster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計画マスタの一覧
         * @param {boolean} isArchived 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlanMasters(isArchived: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanMastersView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanMasters(isArchived, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanMasterControllerApi.listPlanMasters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計画マスタ編集
         * @param {string} planMasterId 
         * @param {UpdatePlanMaster} updatePlanMaster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaster(planMasterId: string, updatePlanMaster: UpdatePlanMaster, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanMasterMetaView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMaster(planMasterId, updatePlanMaster, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanMasterControllerApi.updateMaster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanMasterControllerApi - factory interface
 */
export const PlanMasterControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanMasterControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 計画マスタアーカイブ
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveMaster(planMasterId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.archiveMaster(planMasterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計画マスタアーカイブ取消
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelArchiveMaster(planMasterId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.cancelArchiveMaster(planMasterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計画マスタ新規作成
         * @param {CreatePlanMaster} createPlanMaster 
         * @param {string} [originId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaster(createPlanMaster: CreatePlanMaster, originId?: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanMasterMetaView> {
            return localVarFp.createMaster(createPlanMaster, originId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計画マスタ削除
         * @param {string} planMasterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMaster(planMasterId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteMaster(planMasterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計画マスタの一覧
         * @param {boolean} isArchived 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanMasters(isArchived: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PlanMastersView> {
            return localVarFp.listPlanMasters(isArchived, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計画マスタ編集
         * @param {string} planMasterId 
         * @param {UpdatePlanMaster} updatePlanMaster 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaster(planMasterId: string, updatePlanMaster: UpdatePlanMaster, options?: RawAxiosRequestConfig): AxiosPromise<PlanMasterMetaView> {
            return localVarFp.updateMaster(planMasterId, updatePlanMaster, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanMasterControllerApi - object-oriented interface
 */
export class PlanMasterControllerApi extends BaseAPI {
    /**
     * 
     * @summary 計画マスタアーカイブ
     * @param {string} planMasterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archiveMaster(planMasterId: string, options?: RawAxiosRequestConfig) {
        return PlanMasterControllerApiFp(this.configuration).archiveMaster(planMasterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計画マスタアーカイブ取消
     * @param {string} planMasterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelArchiveMaster(planMasterId: string, options?: RawAxiosRequestConfig) {
        return PlanMasterControllerApiFp(this.configuration).cancelArchiveMaster(planMasterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計画マスタ新規作成
     * @param {CreatePlanMaster} createPlanMaster 
     * @param {string} [originId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMaster(createPlanMaster: CreatePlanMaster, originId?: string, options?: RawAxiosRequestConfig) {
        return PlanMasterControllerApiFp(this.configuration).createMaster(createPlanMaster, originId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計画マスタ削除
     * @param {string} planMasterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMaster(planMasterId: string, options?: RawAxiosRequestConfig) {
        return PlanMasterControllerApiFp(this.configuration).deleteMaster(planMasterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計画マスタの一覧
     * @param {boolean} isArchived 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlanMasters(isArchived: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return PlanMasterControllerApiFp(this.configuration).listPlanMasters(isArchived, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計画マスタ編集
     * @param {string} planMasterId 
     * @param {UpdatePlanMaster} updatePlanMaster 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMaster(planMasterId: string, updatePlanMaster: UpdatePlanMaster, options?: RawAxiosRequestConfig) {
        return PlanMasterControllerApiFp(this.configuration).updateMaster(planMasterId, updatePlanMaster, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanSheetControllerApi - axios parameter creator
 */
export const PlanSheetControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シート設定をコピー
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyPlanSheet: async (planMasterId: string, planningProjectId: string, sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('copyPlanSheet', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('copyPlanSheet', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('copyPlanSheet', 'sheetId', sheetId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}/copy`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シート設定を新規作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreatePlanSheetParam} createPlanSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanSheet: async (planMasterId: string, planningProjectId: string, createPlanSheetParam: CreatePlanSheetParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('createPlanSheet', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('createPlanSheet', 'planningProjectId', planningProjectId)
            // verify required parameter 'createPlanSheetParam' is not null or undefined
            assertParamExists('createPlanSheet', 'createPlanSheetParam', createPlanSheetParam)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPlanSheetParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シート設定を削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanSheet: async (planMasterId: string, planningProjectId: string, sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('deletePlanSheet', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('deletePlanSheet', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('deletePlanSheet', 'sheetId', sheetId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シート設定を参照
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanSheet: async (planMasterId: string, planningProjectId: string, sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('getPlanSheet', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getPlanSheet', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('getPlanSheet', 'sheetId', sheetId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シート設定一覧を参照
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanSheets: async (planMasterId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('listPlanSheets', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('listPlanSheets', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シート設定を複数再利用
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {ReuseSheetsParam} reuseSheetsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reusePlanSheets: async (planMasterId: string, planningProjectId: string, reuseSheetsParam: ReuseSheetsParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('reusePlanSheets', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('reusePlanSheets', 'planningProjectId', planningProjectId)
            // verify required parameter 'reuseSheetsParam' is not null or undefined
            assertParamExists('reusePlanSheets', 'reuseSheetsParam', reuseSheetsParam)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/reuse`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reuseSheetsParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シート設定を更新
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {UpdatePlanSheetParam} updatePlanSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanSheet: async (planMasterId: string, planningProjectId: string, sheetId: string, updatePlanSheetParam: UpdatePlanSheetParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('updatePlanSheet', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('updatePlanSheet', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('updatePlanSheet', 'sheetId', sheetId)
            // verify required parameter 'updatePlanSheetParam' is not null or undefined
            assertParamExists('updatePlanSheet', 'updatePlanSheetParam', updatePlanSheetParam)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlanSheetParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanSheetControllerApi - functional programming interface
 */
export const PlanSheetControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanSheetControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シート設定をコピー
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyPlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanSheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyPlanSheet(planMasterId, planningProjectId, sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetControllerApi.copyPlanSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シート設定を新規作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreatePlanSheetParam} createPlanSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlanSheet(planMasterId: string, planningProjectId: string, createPlanSheetParam: CreatePlanSheetParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanSheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanSheet(planMasterId, planningProjectId, createPlanSheetParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetControllerApi.createPlanSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シート設定を削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlanSheet(planMasterId, planningProjectId, sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetControllerApi.deletePlanSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シート設定を参照
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanSheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanSheet(planMasterId, planningProjectId, sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetControllerApi.getPlanSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シート設定一覧を参照
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlanSheets(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanSheetView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanSheets(planMasterId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetControllerApi.listPlanSheets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シート設定を複数再利用
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {ReuseSheetsParam} reuseSheetsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reusePlanSheets(planMasterId: string, planningProjectId: string, reuseSheetsParam: ReuseSheetsParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanSheetView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reusePlanSheets(planMasterId, planningProjectId, reuseSheetsParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetControllerApi.reusePlanSheets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シート設定を更新
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {UpdatePlanSheetParam} updatePlanSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, updatePlanSheetParam: UpdatePlanSheetParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanSheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanSheet(planMasterId, planningProjectId, sheetId, updatePlanSheetParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetControllerApi.updatePlanSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanSheetControllerApi - factory interface
 */
export const PlanSheetControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanSheetControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary シート設定をコピー
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyPlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanSheetView> {
            return localVarFp.copyPlanSheet(planMasterId, planningProjectId, sheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シート設定を新規作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreatePlanSheetParam} createPlanSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanSheet(planMasterId: string, planningProjectId: string, createPlanSheetParam: CreatePlanSheetParam, options?: RawAxiosRequestConfig): AxiosPromise<PlanSheetView> {
            return localVarFp.createPlanSheet(planMasterId, planningProjectId, createPlanSheetParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シート設定を削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePlanSheet(planMasterId, planningProjectId, sheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シート設定を参照
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanSheetView> {
            return localVarFp.getPlanSheet(planMasterId, planningProjectId, sheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シート設定一覧を参照
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanSheets(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanSheetView>> {
            return localVarFp.listPlanSheets(planMasterId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シート設定を複数再利用
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {ReuseSheetsParam} reuseSheetsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reusePlanSheets(planMasterId: string, planningProjectId: string, reuseSheetsParam: ReuseSheetsParam, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanSheetView>> {
            return localVarFp.reusePlanSheets(planMasterId, planningProjectId, reuseSheetsParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シート設定を更新
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {UpdatePlanSheetParam} updatePlanSheetParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, updatePlanSheetParam: UpdatePlanSheetParam, options?: RawAxiosRequestConfig): AxiosPromise<PlanSheetView> {
            return localVarFp.updatePlanSheet(planMasterId, planningProjectId, sheetId, updatePlanSheetParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanSheetControllerApi - object-oriented interface
 */
export class PlanSheetControllerApi extends BaseAPI {
    /**
     * 
     * @summary シート設定をコピー
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyPlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig) {
        return PlanSheetControllerApiFp(this.configuration).copyPlanSheet(planMasterId, planningProjectId, sheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シート設定を新規作成
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {CreatePlanSheetParam} createPlanSheetParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPlanSheet(planMasterId: string, planningProjectId: string, createPlanSheetParam: CreatePlanSheetParam, options?: RawAxiosRequestConfig) {
        return PlanSheetControllerApiFp(this.configuration).createPlanSheet(planMasterId, planningProjectId, createPlanSheetParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シート設定を削除
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig) {
        return PlanSheetControllerApiFp(this.configuration).deletePlanSheet(planMasterId, planningProjectId, sheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シート設定を参照
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig) {
        return PlanSheetControllerApiFp(this.configuration).getPlanSheet(planMasterId, planningProjectId, sheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シート設定一覧を参照
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlanSheets(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return PlanSheetControllerApiFp(this.configuration).listPlanSheets(planMasterId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シート設定を複数再利用
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {ReuseSheetsParam} reuseSheetsParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reusePlanSheets(planMasterId: string, planningProjectId: string, reuseSheetsParam: ReuseSheetsParam, options?: RawAxiosRequestConfig) {
        return PlanSheetControllerApiFp(this.configuration).reusePlanSheets(planMasterId, planningProjectId, reuseSheetsParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シート設定を更新
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {UpdatePlanSheetParam} updatePlanSheetParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePlanSheet(planMasterId: string, planningProjectId: string, sheetId: string, updatePlanSheetParam: UpdatePlanSheetParam, options?: RawAxiosRequestConfig) {
        return PlanSheetControllerApiFp(this.configuration).updatePlanSheet(planMasterId, planningProjectId, sheetId, updatePlanSheetParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanSheetDetailControllerApi - axios parameter creator
 */
export const PlanSheetDetailControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 更新申請ドラフトExcelフォーマットファイルのダウンロード
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExcel: async (planMasterId: string, planningProjectId: string, sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('downloadExcel', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('downloadExcel', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('downloadExcel', 'sheetId', sheetId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}/detail/excel`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シートの明細一覧をExcel形式でアップロードする
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {File} file 
         * @param {UploadExcelParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDraftExcel: async (planMasterId: string, planningProjectId: string, sheetId: string, file: File, params: UploadExcelParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('uploadDraftExcel', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('uploadDraftExcel', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('uploadDraftExcel', 'sheetId', sheetId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadDraftExcel', 'file', file)
            // verify required parameter 'params' is not null or undefined
            assertParamExists('uploadDraftExcel', 'params', params)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}/detail/excel`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (params !== undefined) { 
                localVarFormParams.append('params', new Blob([JSON.stringify(params, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanSheetDetailControllerApi - functional programming interface
 */
export const PlanSheetDetailControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanSheetDetailControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 更新申請ドラフトExcelフォーマットファイルのダウンロード
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadExcel(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadExcel(planMasterId, planningProjectId, sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetDetailControllerApi.downloadExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シートの明細一覧をExcel形式でアップロードする
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {File} file 
         * @param {UploadExcelParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDraftExcel(planMasterId: string, planningProjectId: string, sheetId: string, file: File, params: UploadExcelParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDraftExcel(planMasterId, planningProjectId, sheetId, file, params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetDetailControllerApi.uploadDraftExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanSheetDetailControllerApi - factory interface
 */
export const PlanSheetDetailControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanSheetDetailControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 更新申請ドラフトExcelフォーマットファイルのダウンロード
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExcel(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadExcel(planMasterId, planningProjectId, sheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シートの明細一覧をExcel形式でアップロードする
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {File} file 
         * @param {UploadExcelParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDraftExcel(planMasterId: string, planningProjectId: string, sheetId: string, file: File, params: UploadExcelParams, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadDraftExcel(planMasterId, planningProjectId, sheetId, file, params, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanSheetDetailControllerApi - object-oriented interface
 */
export class PlanSheetDetailControllerApi extends BaseAPI {
    /**
     * 
     * @summary 更新申請ドラフトExcelフォーマットファイルのダウンロード
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadExcel(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig) {
        return PlanSheetDetailControllerApiFp(this.configuration).downloadExcel(planMasterId, planningProjectId, sheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シートの明細一覧をExcel形式でアップロードする
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {File} file 
     * @param {UploadExcelParams} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadDraftExcel(planMasterId: string, planningProjectId: string, sheetId: string, file: File, params: UploadExcelParams, options?: RawAxiosRequestConfig) {
        return PlanSheetDetailControllerApiFp(this.configuration).uploadDraftExcel(planMasterId, planningProjectId, sheetId, file, params, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanSheetTableControllerApi - axios parameter creator
 */
export const PlanSheetTableControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シートに保存済みの条件で明細テーブルデータを取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanSheetTable: async (planMasterId: string, planningProjectId: string, sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('getPlanSheetTable', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getPlanSheetTable', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('getPlanSheetTable', 'sheetId', sheetId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}/table`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定された条件で明細テーブルデータを取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {SheetConditionSchema} sheetConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPlanSheetTable: async (planMasterId: string, planningProjectId: string, sheetConditionSchema: SheetConditionSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('previewPlanSheetTable', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('previewPlanSheetTable', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetConditionSchema' is not null or undefined
            assertParamExists('previewPlanSheetTable', 'sheetConditionSchema', sheetConditionSchema)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/table/preview`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sheetConditionSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanSheetTableControllerApi - functional programming interface
 */
export const PlanSheetTableControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanSheetTableControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シートに保存済みの条件で明細テーブルデータを取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanSheetTable(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlanSheetTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanSheetTable(planMasterId, planningProjectId, sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetTableControllerApi.getPlanSheetTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定された条件で明細テーブルデータを取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {SheetConditionSchema} sheetConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewPlanSheetTable(planMasterId: string, planningProjectId: string, sheetConditionSchema: SheetConditionSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPlanSheetTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewPlanSheetTable(planMasterId, planningProjectId, sheetConditionSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetTableControllerApi.previewPlanSheetTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanSheetTableControllerApi - factory interface
 */
export const PlanSheetTableControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanSheetTableControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary シートに保存済みの条件で明細テーブルデータを取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanSheetTable(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPlanSheetTableView> {
            return localVarFp.getPlanSheetTable(planMasterId, planningProjectId, sheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定された条件で明細テーブルデータを取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {SheetConditionSchema} sheetConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPlanSheetTable(planMasterId: string, planningProjectId: string, sheetConditionSchema: SheetConditionSchema, options?: RawAxiosRequestConfig): AxiosPromise<GetPlanSheetTableView> {
            return localVarFp.previewPlanSheetTable(planMasterId, planningProjectId, sheetConditionSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanSheetTableControllerApi - object-oriented interface
 */
export class PlanSheetTableControllerApi extends BaseAPI {
    /**
     * 
     * @summary シートに保存済みの条件で明細テーブルデータを取得する
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlanSheetTable(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig) {
        return PlanSheetTableControllerApiFp(this.configuration).getPlanSheetTable(planMasterId, planningProjectId, sheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定された条件で明細テーブルデータを取得する
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {SheetConditionSchema} sheetConditionSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewPlanSheetTable(planMasterId: string, planningProjectId: string, sheetConditionSchema: SheetConditionSchema, options?: RawAxiosRequestConfig) {
        return PlanSheetTableControllerApiFp(this.configuration).previewPlanSheetTable(planMasterId, planningProjectId, sheetConditionSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanSheetTemplateControllerApi - axios parameter creator
 */
export const PlanSheetTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シートに登録されたテンプレートの情報を取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanSheetTemplate: async (planMasterId: string, planningProjectId: string, sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('getPlanSheetTemplate', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getPlanSheetTemplate', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('getPlanSheetTemplate', 'sheetId', sheetId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}/template`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary カスタマイズした Excel をテンプレートとして登録する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlanSheetTemplate: async (planMasterId: string, planningProjectId: string, sheetId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('registerPlanSheetTemplate', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('registerPlanSheetTemplate', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('registerPlanSheetTemplate', 'sheetId', sheetId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('registerPlanSheetTemplate', 'file', file)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}/template`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シートに登録されたテンプレートを登録解除する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterPlanSheetTemplate: async (planMasterId: string, planningProjectId: string, sheetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('unregisterPlanSheetTemplate', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('unregisterPlanSheetTemplate', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('unregisterPlanSheetTemplate', 'sheetId', sheetId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}/template`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanSheetTemplateControllerApi - functional programming interface
 */
export const PlanSheetTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanSheetTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シートに登録されたテンプレートの情報を取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanSheetTemplate(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanSheetTemplateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanSheetTemplate(planMasterId, planningProjectId, sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetTemplateControllerApi.getPlanSheetTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary カスタマイズした Excel をテンプレートとして登録する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerPlanSheetTemplate(planMasterId: string, planningProjectId: string, sheetId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerPlanSheetTemplate(planMasterId, planningProjectId, sheetId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetTemplateControllerApi.registerPlanSheetTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シートに登録されたテンプレートを登録解除する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unregisterPlanSheetTemplate(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unregisterPlanSheetTemplate(planMasterId, planningProjectId, sheetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetTemplateControllerApi.unregisterPlanSheetTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanSheetTemplateControllerApi - factory interface
 */
export const PlanSheetTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanSheetTemplateControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary シートに登録されたテンプレートの情報を取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanSheetTemplate(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanSheetTemplateView> {
            return localVarFp.getPlanSheetTemplate(planMasterId, planningProjectId, sheetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary カスタマイズした Excel をテンプレートとして登録する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlanSheetTemplate(planMasterId: string, planningProjectId: string, sheetId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerPlanSheetTemplate(planMasterId, planningProjectId, sheetId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シートに登録されたテンプレートを登録解除する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterPlanSheetTemplate(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unregisterPlanSheetTemplate(planMasterId, planningProjectId, sheetId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanSheetTemplateControllerApi - object-oriented interface
 */
export class PlanSheetTemplateControllerApi extends BaseAPI {
    /**
     * 
     * @summary シートに登録されたテンプレートの情報を取得する
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlanSheetTemplate(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig) {
        return PlanSheetTemplateControllerApiFp(this.configuration).getPlanSheetTemplate(planMasterId, planningProjectId, sheetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary カスタマイズした Excel をテンプレートとして登録する
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerPlanSheetTemplate(planMasterId: string, planningProjectId: string, sheetId: string, file: File, options?: RawAxiosRequestConfig) {
        return PlanSheetTemplateControllerApiFp(this.configuration).registerPlanSheetTemplate(planMasterId, planningProjectId, sheetId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シートに登録されたテンプレートを登録解除する
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unregisterPlanSheetTemplate(planMasterId: string, planningProjectId: string, sheetId: string, options?: RawAxiosRequestConfig) {
        return PlanSheetTemplateControllerApiFp(this.configuration).unregisterPlanSheetTemplate(planMasterId, planningProjectId, sheetId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanSheetUploadEventControllerApi - axios parameter creator
 */
export const PlanSheetUploadEventControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary アップロード履歴のファイル（ユーザーがアップロードしたままの Excel）をダウンロードする
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {string} uploadEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPlanSheetUploadEventFile: async (planMasterId: string, planningProjectId: string, sheetId: string, uploadEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('downloadPlanSheetUploadEventFile', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('downloadPlanSheetUploadEventFile', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('downloadPlanSheetUploadEventFile', 'sheetId', sheetId)
            // verify required parameter 'uploadEventId' is not null or undefined
            assertParamExists('downloadPlanSheetUploadEventFile', 'uploadEventId', uploadEventId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}/upload-events/{uploadEventId}/download`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)))
                .replace('{uploadEventId}', encodeURIComponent(String(uploadEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シートのアップロード履歴一覧を取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanSheetUploadEvents: async (planMasterId: string, planningProjectId: string, sheetId: string, offset: number, limit: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('listPlanSheetUploadEvents', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('listPlanSheetUploadEvents', 'planningProjectId', planningProjectId)
            // verify required parameter 'sheetId' is not null or undefined
            assertParamExists('listPlanSheetUploadEvents', 'sheetId', sheetId)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('listPlanSheetUploadEvents', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('listPlanSheetUploadEvents', 'limit', limit)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planning-projects/{planningProjectId}/sheets/{sheetId}/upload-events`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{sheetId}', encodeURIComponent(String(sheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanSheetUploadEventControllerApi - functional programming interface
 */
export const PlanSheetUploadEventControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanSheetUploadEventControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary アップロード履歴のファイル（ユーザーがアップロードしたままの Excel）をダウンロードする
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {string} uploadEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPlanSheetUploadEventFile(planMasterId: string, planningProjectId: string, sheetId: string, uploadEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPlanSheetUploadEventFile(planMasterId, planningProjectId, sheetId, uploadEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetUploadEventControllerApi.downloadPlanSheetUploadEventFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シートのアップロード履歴一覧を取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlanSheetUploadEvents(planMasterId: string, planningProjectId: string, sheetId: string, offset: number, limit: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanSheetUploadEventListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanSheetUploadEvents(planMasterId, planningProjectId, sheetId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetUploadEventControllerApi.listPlanSheetUploadEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanSheetUploadEventControllerApi - factory interface
 */
export const PlanSheetUploadEventControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanSheetUploadEventControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary アップロード履歴のファイル（ユーザーがアップロードしたままの Excel）をダウンロードする
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {string} uploadEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPlanSheetUploadEventFile(planMasterId: string, planningProjectId: string, sheetId: string, uploadEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadPlanSheetUploadEventFile(planMasterId, planningProjectId, sheetId, uploadEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シートのアップロード履歴一覧を取得する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} sheetId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanSheetUploadEvents(planMasterId: string, planningProjectId: string, sheetId: string, offset: number, limit: number, options?: RawAxiosRequestConfig): AxiosPromise<PlanSheetUploadEventListView> {
            return localVarFp.listPlanSheetUploadEvents(planMasterId, planningProjectId, sheetId, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanSheetUploadEventControllerApi - object-oriented interface
 */
export class PlanSheetUploadEventControllerApi extends BaseAPI {
    /**
     * 
     * @summary アップロード履歴のファイル（ユーザーがアップロードしたままの Excel）をダウンロードする
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {string} uploadEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadPlanSheetUploadEventFile(planMasterId: string, planningProjectId: string, sheetId: string, uploadEventId: string, options?: RawAxiosRequestConfig) {
        return PlanSheetUploadEventControllerApiFp(this.configuration).downloadPlanSheetUploadEventFile(planMasterId, planningProjectId, sheetId, uploadEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シートのアップロード履歴一覧を取得する
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} sheetId 
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlanSheetUploadEvents(planMasterId: string, planningProjectId: string, sheetId: string, offset: number, limit: number, options?: RawAxiosRequestConfig) {
        return PlanSheetUploadEventControllerApiFp(this.configuration).listPlanSheetUploadEvents(planMasterId, planningProjectId, sheetId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanSheetsControllerApi - axios parameter creator
 */
export const PlanSheetsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary テナント内の全計画シートを階層構造で一覧取得（再利用ポップオーバー向け）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllPlanSheets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/plans/all-plan-sheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanSheetsControllerApi - functional programming interface
 */
export const PlanSheetsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanSheetsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary テナント内の全計画シートを階層構造で一覧取得（再利用ポップオーバー向け）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllPlanSheets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllPlanSheetsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllPlanSheets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSheetsControllerApi.listAllPlanSheets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanSheetsControllerApi - factory interface
 */
export const PlanSheetsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanSheetsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary テナント内の全計画シートを階層構造で一覧取得（再利用ポップオーバー向け）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllPlanSheets(options?: RawAxiosRequestConfig): AxiosPromise<AllPlanSheetsView> {
            return localVarFp.listAllPlanSheets(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanSheetsControllerApi - object-oriented interface
 */
export class PlanSheetsControllerApi extends BaseAPI {
    /**
     * 
     * @summary テナント内の全計画シートを階層構造で一覧取得（再利用ポップオーバー向け）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAllPlanSheets(options?: RawAxiosRequestConfig) {
        return PlanSheetsControllerApiFp(this.configuration).listAllPlanSheets(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanUpdateRequestAggControllerApi - axios parameter creator
 */
export const PlanUpdateRequestAggControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOpenPlanUpdateRequestDepartmentIds: async (planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('fetchOpenPlanUpdateRequestDepartmentIds', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/planUpdateRequests/openPlanUpdateRequestDepartmentIds`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planningProjectId 
         * @param {FetchAggregatePlanUpdateRequestRequestBody} fetchAggregatePlanUpdateRequestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPlanUpdateRequestAggregate: async (planningProjectId: string, fetchAggregatePlanUpdateRequestRequestBody: FetchAggregatePlanUpdateRequestRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('fetchPlanUpdateRequestAggregate', 'planningProjectId', planningProjectId)
            // verify required parameter 'fetchAggregatePlanUpdateRequestRequestBody' is not null or undefined
            assertParamExists('fetchPlanUpdateRequestAggregate', 'fetchAggregatePlanUpdateRequestRequestBody', fetchAggregatePlanUpdateRequestRequestBody)
            const localVarPath = `/api/planningProjects/{planningProjectId}/planUpdateRequests`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchAggregatePlanUpdateRequestRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanUpdateRequestAggControllerApi - functional programming interface
 */
export const PlanUpdateRequestAggControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanUpdateRequestAggControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchOpenPlanUpdateRequestDepartmentIds(planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchOpenPlanUpdateRequestDepartmentIds(planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestAggControllerApi.fetchOpenPlanUpdateRequestDepartmentIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planningProjectId 
         * @param {FetchAggregatePlanUpdateRequestRequestBody} fetchAggregatePlanUpdateRequestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchPlanUpdateRequestAggregate(planningProjectId: string, fetchAggregatePlanUpdateRequestRequestBody: FetchAggregatePlanUpdateRequestRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanUpdateRequestAggregateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchPlanUpdateRequestAggregate(planningProjectId, fetchAggregatePlanUpdateRequestRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestAggControllerApi.fetchPlanUpdateRequestAggregate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanUpdateRequestAggControllerApi - factory interface
 */
export const PlanUpdateRequestAggControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanUpdateRequestAggControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOpenPlanUpdateRequestDepartmentIds(planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.fetchOpenPlanUpdateRequestDepartmentIds(planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planningProjectId 
         * @param {FetchAggregatePlanUpdateRequestRequestBody} fetchAggregatePlanUpdateRequestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPlanUpdateRequestAggregate(planningProjectId: string, fetchAggregatePlanUpdateRequestRequestBody: FetchAggregatePlanUpdateRequestRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<PlanUpdateRequestAggregateView> {
            return localVarFp.fetchPlanUpdateRequestAggregate(planningProjectId, fetchAggregatePlanUpdateRequestRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanUpdateRequestAggControllerApi - object-oriented interface
 */
export class PlanUpdateRequestAggControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchOpenPlanUpdateRequestDepartmentIds(planningProjectId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestAggControllerApiFp(this.configuration).fetchOpenPlanUpdateRequestDepartmentIds(planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planningProjectId 
     * @param {FetchAggregatePlanUpdateRequestRequestBody} fetchAggregatePlanUpdateRequestRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchPlanUpdateRequestAggregate(planningProjectId: string, fetchAggregatePlanUpdateRequestRequestBody: FetchAggregatePlanUpdateRequestRequestBody, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestAggControllerApiFp(this.configuration).fetchPlanUpdateRequestAggregate(planningProjectId, fetchAggregatePlanUpdateRequestRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanUpdateRequestControllerApi - axios parameter creator
 */
export const PlanUpdateRequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 現在は承認即、編成プロジェクトにマージされる
         * @summary 更新申請の承認
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {ApprovePlanUpdateRequestBody} approvePlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePlanUpdateRequest: async (planMasterId: string, planningProjectId: string, planUpdateRequestId: string, approvePlanUpdateRequestBody: ApprovePlanUpdateRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('approvePlanUpdateRequest', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('approvePlanUpdateRequest', 'planningProjectId', planningProjectId)
            // verify required parameter 'planUpdateRequestId' is not null or undefined
            assertParamExists('approvePlanUpdateRequest', 'planUpdateRequestId', planUpdateRequestId)
            // verify required parameter 'approvePlanUpdateRequestBody' is not null or undefined
            assertParamExists('approvePlanUpdateRequest', 'approvePlanUpdateRequestBody', approvePlanUpdateRequestBody)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests/{planUpdateRequestId}/approve`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{planUpdateRequestId}', encodeURIComponent(String(planUpdateRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approvePlanUpdateRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象の進行中の編成プロジェクトの更新申請のうち、未承認の更新申請の一括削除
         * @summary 更新申請の一括削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {BulkPlanUpdateRequestBody} bulkPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeletePlanUpdateRequest: async (planMasterId: string, planningProjectId: string, bulkPlanUpdateRequestBody: BulkPlanUpdateRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('bulkDeletePlanUpdateRequest', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('bulkDeletePlanUpdateRequest', 'planningProjectId', planningProjectId)
            // verify required parameter 'bulkPlanUpdateRequestBody' is not null or undefined
            assertParamExists('bulkDeletePlanUpdateRequest', 'bulkPlanUpdateRequestBody', bulkPlanUpdateRequestBody)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests/bulk-delete`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkPlanUpdateRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 差分なし更新申請の作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateNoDiffPlanUpdateRequestBody} createNoDiffPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNoDiffPlanUpdateRequest: async (planMasterId: string, planningProjectId: string, createNoDiffPlanUpdateRequestBody: CreateNoDiffPlanUpdateRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('createNoDiffPlanUpdateRequest', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('createNoDiffPlanUpdateRequest', 'planningProjectId', planningProjectId)
            // verify required parameter 'createNoDiffPlanUpdateRequestBody' is not null or undefined
            assertParamExists('createNoDiffPlanUpdateRequest', 'createNoDiffPlanUpdateRequestBody', createNoDiffPlanUpdateRequestBody)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests/no-diff`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNoDiffPlanUpdateRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 進行中の編成プロジェクトの更新申請のうち、最新の更新申請（承認、未承認を問わない）の削除
         * @summary 更新申請の削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanUpdateRequest: async (planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('deletePlanUpdateRequest', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('deletePlanUpdateRequest', 'planningProjectId', planningProjectId)
            // verify required parameter 'planUpdateRequestId' is not null or undefined
            assertParamExists('deletePlanUpdateRequest', 'planUpdateRequestId', planUpdateRequestId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests/{planUpdateRequestId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{planUpdateRequestId}', encodeURIComponent(String(planUpdateRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成プロジェクトへの更新申請一覧
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanUpdateRequests: async (planMasterId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('listPlanUpdateRequests', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('listPlanUpdateRequests', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請の一括承認の開始
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {BulkPlanUpdateRequestBody} bulkPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startBulkApprovingPlanUpdateRequests: async (planMasterId: string, planningProjectId: string, bulkPlanUpdateRequestBody: BulkPlanUpdateRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('startBulkApprovingPlanUpdateRequests', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('startBulkApprovingPlanUpdateRequests', 'planningProjectId', planningProjectId)
            // verify required parameter 'bulkPlanUpdateRequestBody' is not null or undefined
            assertParamExists('startBulkApprovingPlanUpdateRequests', 'bulkPlanUpdateRequestBody', bulkPlanUpdateRequestBody)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests/start-bulk-approving`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkPlanUpdateRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanUpdateRequestControllerApi - functional programming interface
 */
export const PlanUpdateRequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanUpdateRequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 現在は承認即、編成プロジェクトにマージされる
         * @summary 更新申請の承認
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {ApprovePlanUpdateRequestBody} approvePlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approvePlanUpdateRequest(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, approvePlanUpdateRequestBody: ApprovePlanUpdateRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approvePlanUpdateRequest(planMasterId, planningProjectId, planUpdateRequestId, approvePlanUpdateRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestControllerApi.approvePlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 対象の進行中の編成プロジェクトの更新申請のうち、未承認の更新申請の一括削除
         * @summary 更新申請の一括削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {BulkPlanUpdateRequestBody} bulkPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeletePlanUpdateRequest(planMasterId: string, planningProjectId: string, bulkPlanUpdateRequestBody: BulkPlanUpdateRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeletePlanUpdateRequest(planMasterId, planningProjectId, bulkPlanUpdateRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestControllerApi.bulkDeletePlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 差分なし更新申請の作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateNoDiffPlanUpdateRequestBody} createNoDiffPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNoDiffPlanUpdateRequest(planMasterId: string, planningProjectId: string, createNoDiffPlanUpdateRequestBody: CreateNoDiffPlanUpdateRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNoDiffPlanUpdateRequest(planMasterId, planningProjectId, createNoDiffPlanUpdateRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestControllerApi.createNoDiffPlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 進行中の編成プロジェクトの更新申請のうち、最新の更新申請（承認、未承認を問わない）の削除
         * @summary 更新申請の削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlanUpdateRequest(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlanUpdateRequest(planMasterId, planningProjectId, planUpdateRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestControllerApi.deletePlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成プロジェクトへの更新申請一覧
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlanUpdateRequests(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanUpdateRequestsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanUpdateRequests(planMasterId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestControllerApi.listPlanUpdateRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請の一括承認の開始
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {BulkPlanUpdateRequestBody} bulkPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startBulkApprovingPlanUpdateRequests(planMasterId: string, planningProjectId: string, bulkPlanUpdateRequestBody: BulkPlanUpdateRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startBulkApprovingPlanUpdateRequests(planMasterId, planningProjectId, bulkPlanUpdateRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestControllerApi.startBulkApprovingPlanUpdateRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanUpdateRequestControllerApi - factory interface
 */
export const PlanUpdateRequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanUpdateRequestControllerApiFp(configuration)
    return {
        /**
         * 現在は承認即、編成プロジェクトにマージされる
         * @summary 更新申請の承認
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {ApprovePlanUpdateRequestBody} approvePlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePlanUpdateRequest(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, approvePlanUpdateRequestBody: ApprovePlanUpdateRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.approvePlanUpdateRequest(planMasterId, planningProjectId, planUpdateRequestId, approvePlanUpdateRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象の進行中の編成プロジェクトの更新申請のうち、未承認の更新申請の一括削除
         * @summary 更新申請の一括削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {BulkPlanUpdateRequestBody} bulkPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeletePlanUpdateRequest(planMasterId: string, planningProjectId: string, bulkPlanUpdateRequestBody: BulkPlanUpdateRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.bulkDeletePlanUpdateRequest(planMasterId, planningProjectId, bulkPlanUpdateRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 差分なし更新申請の作成
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {CreateNoDiffPlanUpdateRequestBody} createNoDiffPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNoDiffPlanUpdateRequest(planMasterId: string, planningProjectId: string, createNoDiffPlanUpdateRequestBody: CreateNoDiffPlanUpdateRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createNoDiffPlanUpdateRequest(planMasterId, planningProjectId, createNoDiffPlanUpdateRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 進行中の編成プロジェクトの更新申請のうち、最新の更新申請（承認、未承認を問わない）の削除
         * @summary 更新申請の削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanUpdateRequest(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deletePlanUpdateRequest(planMasterId, planningProjectId, planUpdateRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成プロジェクトへの更新申請一覧
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanUpdateRequests(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanUpdateRequestsView> {
            return localVarFp.listPlanUpdateRequests(planMasterId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請の一括承認の開始
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {BulkPlanUpdateRequestBody} bulkPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startBulkApprovingPlanUpdateRequests(planMasterId: string, planningProjectId: string, bulkPlanUpdateRequestBody: BulkPlanUpdateRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.startBulkApprovingPlanUpdateRequests(planMasterId, planningProjectId, bulkPlanUpdateRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanUpdateRequestControllerApi - object-oriented interface
 */
export class PlanUpdateRequestControllerApi extends BaseAPI {
    /**
     * 現在は承認即、編成プロジェクトにマージされる
     * @summary 更新申請の承認
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} planUpdateRequestId 
     * @param {ApprovePlanUpdateRequestBody} approvePlanUpdateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public approvePlanUpdateRequest(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, approvePlanUpdateRequestBody: ApprovePlanUpdateRequestBody, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestControllerApiFp(this.configuration).approvePlanUpdateRequest(planMasterId, planningProjectId, planUpdateRequestId, approvePlanUpdateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象の進行中の編成プロジェクトの更新申請のうち、未承認の更新申請の一括削除
     * @summary 更新申請の一括削除
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {BulkPlanUpdateRequestBody} bulkPlanUpdateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkDeletePlanUpdateRequest(planMasterId: string, planningProjectId: string, bulkPlanUpdateRequestBody: BulkPlanUpdateRequestBody, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestControllerApiFp(this.configuration).bulkDeletePlanUpdateRequest(planMasterId, planningProjectId, bulkPlanUpdateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 差分なし更新申請の作成
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {CreateNoDiffPlanUpdateRequestBody} createNoDiffPlanUpdateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNoDiffPlanUpdateRequest(planMasterId: string, planningProjectId: string, createNoDiffPlanUpdateRequestBody: CreateNoDiffPlanUpdateRequestBody, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestControllerApiFp(this.configuration).createNoDiffPlanUpdateRequest(planMasterId, planningProjectId, createNoDiffPlanUpdateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 進行中の編成プロジェクトの更新申請のうち、最新の更新申請（承認、未承認を問わない）の削除
     * @summary 更新申請の削除
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} planUpdateRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePlanUpdateRequest(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestControllerApiFp(this.configuration).deletePlanUpdateRequest(planMasterId, planningProjectId, planUpdateRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成プロジェクトへの更新申請一覧
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlanUpdateRequests(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestControllerApiFp(this.configuration).listPlanUpdateRequests(planMasterId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請の一括承認の開始
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {BulkPlanUpdateRequestBody} bulkPlanUpdateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startBulkApprovingPlanUpdateRequests(planMasterId: string, planningProjectId: string, bulkPlanUpdateRequestBody: BulkPlanUpdateRequestBody, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestControllerApiFp(this.configuration).startBulkApprovingPlanUpdateRequests(planMasterId, planningProjectId, bulkPlanUpdateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanUpdateRequestFileControllerApi - axios parameter creator
 */
export const PlanUpdateRequestFileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 反映できない実績の存在を確認する
         * @param {string} planUpdateRequestFileId 
         * @param {string} mappingId 
         * @param {string} actualDownloadPeriodStart 
         * @param {string} actualDownloadPeriodEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistsUnreflectableActualPlanUpdateRequestFile: async (planUpdateRequestFileId: string, mappingId: string, actualDownloadPeriodStart: string, actualDownloadPeriodEnd: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestFileId' is not null or undefined
            assertParamExists('checkExistsUnreflectableActualPlanUpdateRequestFile', 'planUpdateRequestFileId', planUpdateRequestFileId)
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('checkExistsUnreflectableActualPlanUpdateRequestFile', 'mappingId', mappingId)
            // verify required parameter 'actualDownloadPeriodStart' is not null or undefined
            assertParamExists('checkExistsUnreflectableActualPlanUpdateRequestFile', 'actualDownloadPeriodStart', actualDownloadPeriodStart)
            // verify required parameter 'actualDownloadPeriodEnd' is not null or undefined
            assertParamExists('checkExistsUnreflectableActualPlanUpdateRequestFile', 'actualDownloadPeriodEnd', actualDownloadPeriodEnd)
            const localVarPath = `/api/planUpdateRequestFiles/{planUpdateRequestFileId}/checkExistsUnreflectableActual`
                .replace('{planUpdateRequestFileId}', encodeURIComponent(String(planUpdateRequestFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (mappingId !== undefined) {
                localVarQueryParameter['mappingId'] = mappingId;
            }

            if (actualDownloadPeriodStart !== undefined) {
                localVarQueryParameter['actualDownloadPeriodStart'] = actualDownloadPeriodStart;
            }

            if (actualDownloadPeriodEnd !== undefined) {
                localVarQueryParameter['actualDownloadPeriodEnd'] = actualDownloadPeriodEnd;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 実績反映された更新申請ファイルのダウンロード
         * @param {string} planUpdateRequestFileId 
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadActualPlanUpdateRequestFile: async (planUpdateRequestFileId: string, planningProjectId: string, mappingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestFileId' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFile', 'planUpdateRequestFileId', planUpdateRequestFileId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFile', 'planningProjectId', planningProjectId)
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFile', 'mappingId', mappingId)
            const localVarPath = `/api/planUpdateRequestFiles/{planUpdateRequestFileId}/downloadActual`
                .replace('{planUpdateRequestFileId}', encodeURIComponent(String(planUpdateRequestFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planningProjectId !== undefined) {
                localVarQueryParameter['planningProjectId'] = planningProjectId;
            }

            if (mappingId !== undefined) {
                localVarQueryParameter['mappingId'] = mappingId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 実績反映された申請済ファイルを期間指定でダウンロード
         * @param {string} planUpdateRequestFileId 
         * @param {string} mappingId 
         * @param {string} actualDownloadPeriodStart 
         * @param {string} actualDownloadPeriodEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadActualPlanUpdateRequestFileByDownloadPeriod: async (planUpdateRequestFileId: string, mappingId: string, actualDownloadPeriodStart: string, actualDownloadPeriodEnd: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestFileId' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFileByDownloadPeriod', 'planUpdateRequestFileId', planUpdateRequestFileId)
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFileByDownloadPeriod', 'mappingId', mappingId)
            // verify required parameter 'actualDownloadPeriodStart' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFileByDownloadPeriod', 'actualDownloadPeriodStart', actualDownloadPeriodStart)
            // verify required parameter 'actualDownloadPeriodEnd' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFileByDownloadPeriod', 'actualDownloadPeriodEnd', actualDownloadPeriodEnd)
            const localVarPath = `/api/planUpdateRequestFiles/{planUpdateRequestFileId}/downloadActualByDownloadPeriod`
                .replace('{planUpdateRequestFileId}', encodeURIComponent(String(planUpdateRequestFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (mappingId !== undefined) {
                localVarQueryParameter['mappingId'] = mappingId;
            }

            if (actualDownloadPeriodStart !== undefined) {
                localVarQueryParameter['actualDownloadPeriodStart'] = actualDownloadPeriodStart;
            }

            if (actualDownloadPeriodEnd !== undefined) {
                localVarQueryParameter['actualDownloadPeriodEnd'] = actualDownloadPeriodEnd;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請ファイルのダウンロード
         * @param {string} planUpdateRequestFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPlanUpdateRequestFile: async (planUpdateRequestFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestFileId' is not null or undefined
            assertParamExists('downloadPlanUpdateRequestFile', 'planUpdateRequestFileId', planUpdateRequestFileId)
            const localVarPath = `/api/planUpdateRequestFiles/{planUpdateRequestFileId}/download`
                .replace('{planUpdateRequestFileId}', encodeURIComponent(String(planUpdateRequestFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請ファイルの検索
         * @param {SearchPlanUpdateRequestFilesParams} searchPlanUpdateRequestFilesParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlanUpdateRequestFiles: async (searchPlanUpdateRequestFilesParams: SearchPlanUpdateRequestFilesParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchPlanUpdateRequestFilesParams' is not null or undefined
            assertParamExists('searchPlanUpdateRequestFiles', 'searchPlanUpdateRequestFilesParams', searchPlanUpdateRequestFilesParams)
            const localVarPath = `/api/planUpdateRequestFiles/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchPlanUpdateRequestFilesParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanUpdateRequestFileControllerApi - functional programming interface
 */
export const PlanUpdateRequestFileControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanUpdateRequestFileControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 反映できない実績の存在を確認する
         * @param {string} planUpdateRequestFileId 
         * @param {string} mappingId 
         * @param {string} actualDownloadPeriodStart 
         * @param {string} actualDownloadPeriodEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkExistsUnreflectableActualPlanUpdateRequestFile(planUpdateRequestFileId: string, mappingId: string, actualDownloadPeriodStart: string, actualDownloadPeriodEnd: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanUpdateRequestFileUnreflectableActualCheckResultView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkExistsUnreflectableActualPlanUpdateRequestFile(planUpdateRequestFileId, mappingId, actualDownloadPeriodStart, actualDownloadPeriodEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFileControllerApi.checkExistsUnreflectableActualPlanUpdateRequestFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 実績反映された更新申請ファイルのダウンロード
         * @param {string} planUpdateRequestFileId 
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadActualPlanUpdateRequestFile(planUpdateRequestFileId: string, planningProjectId: string, mappingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadActualPlanUpdateRequestFile(planUpdateRequestFileId, planningProjectId, mappingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFileControllerApi.downloadActualPlanUpdateRequestFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 実績反映された申請済ファイルを期間指定でダウンロード
         * @param {string} planUpdateRequestFileId 
         * @param {string} mappingId 
         * @param {string} actualDownloadPeriodStart 
         * @param {string} actualDownloadPeriodEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadActualPlanUpdateRequestFileByDownloadPeriod(planUpdateRequestFileId: string, mappingId: string, actualDownloadPeriodStart: string, actualDownloadPeriodEnd: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadActualPlanUpdateRequestFileByDownloadPeriod(planUpdateRequestFileId, mappingId, actualDownloadPeriodStart, actualDownloadPeriodEnd, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFileControllerApi.downloadActualPlanUpdateRequestFileByDownloadPeriod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請ファイルのダウンロード
         * @param {string} planUpdateRequestFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPlanUpdateRequestFile(planUpdateRequestFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPlanUpdateRequestFile(planUpdateRequestFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFileControllerApi.downloadPlanUpdateRequestFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請ファイルの検索
         * @param {SearchPlanUpdateRequestFilesParams} searchPlanUpdateRequestFilesParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPlanUpdateRequestFiles(searchPlanUpdateRequestFilesParams: SearchPlanUpdateRequestFilesParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanUpdateRequestFileListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPlanUpdateRequestFiles(searchPlanUpdateRequestFilesParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFileControllerApi.searchPlanUpdateRequestFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanUpdateRequestFileControllerApi - factory interface
 */
export const PlanUpdateRequestFileControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanUpdateRequestFileControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 反映できない実績の存在を確認する
         * @param {string} planUpdateRequestFileId 
         * @param {string} mappingId 
         * @param {string} actualDownloadPeriodStart 
         * @param {string} actualDownloadPeriodEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistsUnreflectableActualPlanUpdateRequestFile(planUpdateRequestFileId: string, mappingId: string, actualDownloadPeriodStart: string, actualDownloadPeriodEnd: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanUpdateRequestFileUnreflectableActualCheckResultView> {
            return localVarFp.checkExistsUnreflectableActualPlanUpdateRequestFile(planUpdateRequestFileId, mappingId, actualDownloadPeriodStart, actualDownloadPeriodEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 実績反映された更新申請ファイルのダウンロード
         * @param {string} planUpdateRequestFileId 
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadActualPlanUpdateRequestFile(planUpdateRequestFileId: string, planningProjectId: string, mappingId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadActualPlanUpdateRequestFile(planUpdateRequestFileId, planningProjectId, mappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 実績反映された申請済ファイルを期間指定でダウンロード
         * @param {string} planUpdateRequestFileId 
         * @param {string} mappingId 
         * @param {string} actualDownloadPeriodStart 
         * @param {string} actualDownloadPeriodEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadActualPlanUpdateRequestFileByDownloadPeriod(planUpdateRequestFileId: string, mappingId: string, actualDownloadPeriodStart: string, actualDownloadPeriodEnd: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadActualPlanUpdateRequestFileByDownloadPeriod(planUpdateRequestFileId, mappingId, actualDownloadPeriodStart, actualDownloadPeriodEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請ファイルのダウンロード
         * @param {string} planUpdateRequestFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPlanUpdateRequestFile(planUpdateRequestFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadPlanUpdateRequestFile(planUpdateRequestFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請ファイルの検索
         * @param {SearchPlanUpdateRequestFilesParams} searchPlanUpdateRequestFilesParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlanUpdateRequestFiles(searchPlanUpdateRequestFilesParams: SearchPlanUpdateRequestFilesParams, options?: RawAxiosRequestConfig): AxiosPromise<PlanUpdateRequestFileListView> {
            return localVarFp.searchPlanUpdateRequestFiles(searchPlanUpdateRequestFilesParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanUpdateRequestFileControllerApi - object-oriented interface
 */
export class PlanUpdateRequestFileControllerApi extends BaseAPI {
    /**
     * 
     * @summary 反映できない実績の存在を確認する
     * @param {string} planUpdateRequestFileId 
     * @param {string} mappingId 
     * @param {string} actualDownloadPeriodStart 
     * @param {string} actualDownloadPeriodEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkExistsUnreflectableActualPlanUpdateRequestFile(planUpdateRequestFileId: string, mappingId: string, actualDownloadPeriodStart: string, actualDownloadPeriodEnd: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFileControllerApiFp(this.configuration).checkExistsUnreflectableActualPlanUpdateRequestFile(planUpdateRequestFileId, mappingId, actualDownloadPeriodStart, actualDownloadPeriodEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 実績反映された更新申請ファイルのダウンロード
     * @param {string} planUpdateRequestFileId 
     * @param {string} planningProjectId 
     * @param {string} mappingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadActualPlanUpdateRequestFile(planUpdateRequestFileId: string, planningProjectId: string, mappingId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFileControllerApiFp(this.configuration).downloadActualPlanUpdateRequestFile(planUpdateRequestFileId, planningProjectId, mappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 実績反映された申請済ファイルを期間指定でダウンロード
     * @param {string} planUpdateRequestFileId 
     * @param {string} mappingId 
     * @param {string} actualDownloadPeriodStart 
     * @param {string} actualDownloadPeriodEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadActualPlanUpdateRequestFileByDownloadPeriod(planUpdateRequestFileId: string, mappingId: string, actualDownloadPeriodStart: string, actualDownloadPeriodEnd: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFileControllerApiFp(this.configuration).downloadActualPlanUpdateRequestFileByDownloadPeriod(planUpdateRequestFileId, mappingId, actualDownloadPeriodStart, actualDownloadPeriodEnd, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請ファイルのダウンロード
     * @param {string} planUpdateRequestFileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadPlanUpdateRequestFile(planUpdateRequestFileId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFileControllerApiFp(this.configuration).downloadPlanUpdateRequestFile(planUpdateRequestFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請ファイルの検索
     * @param {SearchPlanUpdateRequestFilesParams} searchPlanUpdateRequestFilesParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchPlanUpdateRequestFiles(searchPlanUpdateRequestFilesParams: SearchPlanUpdateRequestFilesParams, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFileControllerApiFp(this.configuration).searchPlanUpdateRequestFiles(searchPlanUpdateRequestFilesParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanUpdateRequestFormatControllerApi - axios parameter creator
 */
export const PlanUpdateRequestFormatControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 更新申請フォーマット新規作成
         * @param {File} file 
         * @param {CreatePlanUpdateRequestFormatParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanUpdateRequestFormat: async (file: File, params: CreatePlanUpdateRequestFormatParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createPlanUpdateRequestFormat', 'file', file)
            // verify required parameter 'params' is not null or undefined
            assertParamExists('createPlanUpdateRequestFormat', 'params', params)
            const localVarPath = `/api/planUpdateRequestFormats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (params !== undefined) { 
                localVarFormParams.append('params', new Blob([JSON.stringify(params, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請フォーマット削除
         * @param {string} planUpdateRequestFormatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanUpdateRequestFormat: async (planUpdateRequestFormatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestFormatId' is not null or undefined
            assertParamExists('deletePlanUpdateRequestFormat', 'planUpdateRequestFormatId', planUpdateRequestFormatId)
            const localVarPath = `/api/planUpdateRequestFormats/{planUpdateRequestFormatId}`
                .replace('{planUpdateRequestFormatId}', encodeURIComponent(String(planUpdateRequestFormatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 実績反映された更新申請フォーマットダウンロード
         * @param {string} planUpdateRequestFormatId 
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadActualPlanUpdateRequestFormat: async (planUpdateRequestFormatId: string, planningProjectId: string, mappingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestFormatId' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFormat', 'planUpdateRequestFormatId', planUpdateRequestFormatId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFormat', 'planningProjectId', planningProjectId)
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('downloadActualPlanUpdateRequestFormat', 'mappingId', mappingId)
            const localVarPath = `/api/planUpdateRequestFormats/{planUpdateRequestFormatId}/downloadActual`
                .replace('{planUpdateRequestFormatId}', encodeURIComponent(String(planUpdateRequestFormatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planningProjectId !== undefined) {
                localVarQueryParameter['planningProjectId'] = planningProjectId;
            }

            if (mappingId !== undefined) {
                localVarQueryParameter['mappingId'] = mappingId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請フォーマットダウンロード
         * @param {string} planUpdateRequestFormatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPlanUpdateRequestFormat: async (planUpdateRequestFormatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestFormatId' is not null or undefined
            assertParamExists('downloadPlanUpdateRequestFormat', 'planUpdateRequestFormatId', planUpdateRequestFormatId)
            const localVarPath = `/api/planUpdateRequestFormats/{planUpdateRequestFormatId}/download`
                .replace('{planUpdateRequestFormatId}', encodeURIComponent(String(planUpdateRequestFormatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請フォーマットで利用する型生成用
         * @param {ForOpenApiGenerator2Request} [forOpenApiGenerator2Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forOpenApiGenerator2: async (forOpenApiGenerator2Request?: ForOpenApiGenerator2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/planUpdateRequestFormats/forOnlyOpenApiGenerator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forOpenApiGenerator2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請フォーマット一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanUpdateRequestFormats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/planUpdateRequestFormats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請フォーマットの検索
         * @param {SearchPlanUpdateRequestFormatsParams} searchPlanUpdateRequestFormatsParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlanUpdateRequestFormats: async (searchPlanUpdateRequestFormatsParams: SearchPlanUpdateRequestFormatsParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchPlanUpdateRequestFormatsParams' is not null or undefined
            assertParamExists('searchPlanUpdateRequestFormats', 'searchPlanUpdateRequestFormatsParams', searchPlanUpdateRequestFormatsParams)
            const localVarPath = `/api/planUpdateRequestFormats/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchPlanUpdateRequestFormatsParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請フォーマット更新
         * @param {string} planUpdateRequestFormatId 
         * @param {UpdatePlanUpdateRequestFormatParams} params 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanUpdateRequestFormat: async (planUpdateRequestFormatId: string, params: UpdatePlanUpdateRequestFormatParams, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestFormatId' is not null or undefined
            assertParamExists('updatePlanUpdateRequestFormat', 'planUpdateRequestFormatId', planUpdateRequestFormatId)
            // verify required parameter 'params' is not null or undefined
            assertParamExists('updatePlanUpdateRequestFormat', 'params', params)
            const localVarPath = `/api/planUpdateRequestFormats/{planUpdateRequestFormatId}`
                .replace('{planUpdateRequestFormatId}', encodeURIComponent(String(planUpdateRequestFormatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (params !== undefined) { 
                localVarFormParams.append('params', new Blob([JSON.stringify(params, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanUpdateRequestFormatControllerApi - functional programming interface
 */
export const PlanUpdateRequestFormatControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanUpdateRequestFormatControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 更新申請フォーマット新規作成
         * @param {File} file 
         * @param {CreatePlanUpdateRequestFormatParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlanUpdateRequestFormat(file: File, params: CreatePlanUpdateRequestFormatParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanUpdateRequestFormat(file, params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFormatControllerApi.createPlanUpdateRequestFormat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請フォーマット削除
         * @param {string} planUpdateRequestFormatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlanUpdateRequestFormat(planUpdateRequestFormatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlanUpdateRequestFormat(planUpdateRequestFormatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFormatControllerApi.deletePlanUpdateRequestFormat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 実績反映された更新申請フォーマットダウンロード
         * @param {string} planUpdateRequestFormatId 
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadActualPlanUpdateRequestFormat(planUpdateRequestFormatId: string, planningProjectId: string, mappingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadActualPlanUpdateRequestFormat(planUpdateRequestFormatId, planningProjectId, mappingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFormatControllerApi.downloadActualPlanUpdateRequestFormat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請フォーマットダウンロード
         * @param {string} planUpdateRequestFormatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPlanUpdateRequestFormat(planUpdateRequestFormatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPlanUpdateRequestFormat(planUpdateRequestFormatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFormatControllerApi.downloadPlanUpdateRequestFormat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請フォーマットで利用する型生成用
         * @param {ForOpenApiGenerator2Request} [forOpenApiGenerator2Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forOpenApiGenerator2(forOpenApiGenerator2Request?: ForOpenApiGenerator2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forOpenApiGenerator2(forOpenApiGenerator2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFormatControllerApi.forOpenApiGenerator2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請フォーマット一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlanUpdateRequestFormats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanUpdateRequestFormatView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanUpdateRequestFormats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFormatControllerApi.listPlanUpdateRequestFormats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請フォーマットの検索
         * @param {SearchPlanUpdateRequestFormatsParams} searchPlanUpdateRequestFormatsParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPlanUpdateRequestFormats(searchPlanUpdateRequestFormatsParams: SearchPlanUpdateRequestFormatsParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanUpdateRequestFormatListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPlanUpdateRequestFormats(searchPlanUpdateRequestFormatsParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFormatControllerApi.searchPlanUpdateRequestFormats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請フォーマット更新
         * @param {string} planUpdateRequestFormatId 
         * @param {UpdatePlanUpdateRequestFormatParams} params 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlanUpdateRequestFormat(planUpdateRequestFormatId: string, params: UpdatePlanUpdateRequestFormatParams, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanUpdateRequestFormat(planUpdateRequestFormatId, params, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestFormatControllerApi.updatePlanUpdateRequestFormat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanUpdateRequestFormatControllerApi - factory interface
 */
export const PlanUpdateRequestFormatControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanUpdateRequestFormatControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 更新申請フォーマット新規作成
         * @param {File} file 
         * @param {CreatePlanUpdateRequestFormatParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanUpdateRequestFormat(file: File, params: CreatePlanUpdateRequestFormatParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createPlanUpdateRequestFormat(file, params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請フォーマット削除
         * @param {string} planUpdateRequestFormatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanUpdateRequestFormat(planUpdateRequestFormatId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deletePlanUpdateRequestFormat(planUpdateRequestFormatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 実績反映された更新申請フォーマットダウンロード
         * @param {string} planUpdateRequestFormatId 
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadActualPlanUpdateRequestFormat(planUpdateRequestFormatId: string, planningProjectId: string, mappingId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadActualPlanUpdateRequestFormat(planUpdateRequestFormatId, planningProjectId, mappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請フォーマットダウンロード
         * @param {string} planUpdateRequestFormatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPlanUpdateRequestFormat(planUpdateRequestFormatId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadPlanUpdateRequestFormat(planUpdateRequestFormatId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請フォーマットで利用する型生成用
         * @param {ForOpenApiGenerator2Request} [forOpenApiGenerator2Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forOpenApiGenerator2(forOpenApiGenerator2Request?: ForOpenApiGenerator2Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forOpenApiGenerator2(forOpenApiGenerator2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請フォーマット一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanUpdateRequestFormats(options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanUpdateRequestFormatView>> {
            return localVarFp.listPlanUpdateRequestFormats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請フォーマットの検索
         * @param {SearchPlanUpdateRequestFormatsParams} searchPlanUpdateRequestFormatsParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlanUpdateRequestFormats(searchPlanUpdateRequestFormatsParams: SearchPlanUpdateRequestFormatsParams, options?: RawAxiosRequestConfig): AxiosPromise<PlanUpdateRequestFormatListView> {
            return localVarFp.searchPlanUpdateRequestFormats(searchPlanUpdateRequestFormatsParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請フォーマット更新
         * @param {string} planUpdateRequestFormatId 
         * @param {UpdatePlanUpdateRequestFormatParams} params 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanUpdateRequestFormat(planUpdateRequestFormatId: string, params: UpdatePlanUpdateRequestFormatParams, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updatePlanUpdateRequestFormat(planUpdateRequestFormatId, params, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanUpdateRequestFormatControllerApi - object-oriented interface
 */
export class PlanUpdateRequestFormatControllerApi extends BaseAPI {
    /**
     * 
     * @summary 更新申請フォーマット新規作成
     * @param {File} file 
     * @param {CreatePlanUpdateRequestFormatParams} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPlanUpdateRequestFormat(file: File, params: CreatePlanUpdateRequestFormatParams, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFormatControllerApiFp(this.configuration).createPlanUpdateRequestFormat(file, params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請フォーマット削除
     * @param {string} planUpdateRequestFormatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePlanUpdateRequestFormat(planUpdateRequestFormatId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFormatControllerApiFp(this.configuration).deletePlanUpdateRequestFormat(planUpdateRequestFormatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 実績反映された更新申請フォーマットダウンロード
     * @param {string} planUpdateRequestFormatId 
     * @param {string} planningProjectId 
     * @param {string} mappingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadActualPlanUpdateRequestFormat(planUpdateRequestFormatId: string, planningProjectId: string, mappingId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFormatControllerApiFp(this.configuration).downloadActualPlanUpdateRequestFormat(planUpdateRequestFormatId, planningProjectId, mappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請フォーマットダウンロード
     * @param {string} planUpdateRequestFormatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadPlanUpdateRequestFormat(planUpdateRequestFormatId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFormatControllerApiFp(this.configuration).downloadPlanUpdateRequestFormat(planUpdateRequestFormatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請フォーマットで利用する型生成用
     * @param {ForOpenApiGenerator2Request} [forOpenApiGenerator2Request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forOpenApiGenerator2(forOpenApiGenerator2Request?: ForOpenApiGenerator2Request, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFormatControllerApiFp(this.configuration).forOpenApiGenerator2(forOpenApiGenerator2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請フォーマット一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlanUpdateRequestFormats(options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFormatControllerApiFp(this.configuration).listPlanUpdateRequestFormats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請フォーマットの検索
     * @param {SearchPlanUpdateRequestFormatsParams} searchPlanUpdateRequestFormatsParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchPlanUpdateRequestFormats(searchPlanUpdateRequestFormatsParams: SearchPlanUpdateRequestFormatsParams, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFormatControllerApiFp(this.configuration).searchPlanUpdateRequestFormats(searchPlanUpdateRequestFormatsParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請フォーマット更新
     * @param {string} planUpdateRequestFormatId 
     * @param {UpdatePlanUpdateRequestFormatParams} params 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePlanUpdateRequestFormat(planUpdateRequestFormatId: string, params: UpdatePlanUpdateRequestFormatParams, file?: File, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestFormatControllerApiFp(this.configuration).updatePlanUpdateRequestFormat(planUpdateRequestFormatId, params, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanUpdateRequestMappingControllerApi - axios parameter creator
 */
export const PlanUpdateRequestMappingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 更新申請マッピング新規作成
         * @param {CreatePlanUpdateRequestMappingParams} createPlanUpdateRequestMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanUpdateRequestMapping: async (createPlanUpdateRequestMappingParams: CreatePlanUpdateRequestMappingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPlanUpdateRequestMappingParams' is not null or undefined
            assertParamExists('createPlanUpdateRequestMapping', 'createPlanUpdateRequestMappingParams', createPlanUpdateRequestMappingParams)
            const localVarPath = `/api/planUpdateRequestMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPlanUpdateRequestMappingParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請マッピング削除
         * @param {string} planUpdateRequestMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanUpdateRequestMapping: async (planUpdateRequestMappingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestMappingId' is not null or undefined
            assertParamExists('deletePlanUpdateRequestMapping', 'planUpdateRequestMappingId', planUpdateRequestMappingId)
            const localVarPath = `/api/planUpdateRequestMappings/{planUpdateRequestMappingId}`
                .replace('{planUpdateRequestMappingId}', encodeURIComponent(String(planUpdateRequestMappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請マッピング
         * @param {string} planUpdateRequestMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPlanUpdateRequestMapping: async (planUpdateRequestMappingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestMappingId' is not null or undefined
            assertParamExists('findPlanUpdateRequestMapping', 'planUpdateRequestMappingId', planUpdateRequestMappingId)
            const localVarPath = `/api/planUpdateRequestMappings/{planUpdateRequestMappingId}`
                .replace('{planUpdateRequestMappingId}', encodeURIComponent(String(planUpdateRequestMappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請マッピング一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanUpdateRequestMappings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/planUpdateRequestMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請マッピング更新
         * @param {string} planUpdateRequestMappingId 
         * @param {UpdatePlanUpdateRequestMappingParams} updatePlanUpdateRequestMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanUpdateRequestMapping: async (planUpdateRequestMappingId: string, updatePlanUpdateRequestMappingParams: UpdatePlanUpdateRequestMappingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUpdateRequestMappingId' is not null or undefined
            assertParamExists('updatePlanUpdateRequestMapping', 'planUpdateRequestMappingId', planUpdateRequestMappingId)
            // verify required parameter 'updatePlanUpdateRequestMappingParams' is not null or undefined
            assertParamExists('updatePlanUpdateRequestMapping', 'updatePlanUpdateRequestMappingParams', updatePlanUpdateRequestMappingParams)
            const localVarPath = `/api/planUpdateRequestMappings/{planUpdateRequestMappingId}`
                .replace('{planUpdateRequestMappingId}', encodeURIComponent(String(planUpdateRequestMappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlanUpdateRequestMappingParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanUpdateRequestMappingControllerApi - functional programming interface
 */
export const PlanUpdateRequestMappingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanUpdateRequestMappingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 更新申請マッピング新規作成
         * @param {CreatePlanUpdateRequestMappingParams} createPlanUpdateRequestMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlanUpdateRequestMapping(createPlanUpdateRequestMappingParams: CreatePlanUpdateRequestMappingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlanUpdateRequestMapping(createPlanUpdateRequestMappingParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestMappingControllerApi.createPlanUpdateRequestMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請マッピング削除
         * @param {string} planUpdateRequestMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlanUpdateRequestMapping(planUpdateRequestMappingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlanUpdateRequestMapping(planUpdateRequestMappingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestMappingControllerApi.deletePlanUpdateRequestMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請マッピング
         * @param {string} planUpdateRequestMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPlanUpdateRequestMapping(planUpdateRequestMappingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanUpdateRequestMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPlanUpdateRequestMapping(planUpdateRequestMappingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestMappingControllerApi.findPlanUpdateRequestMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請マッピング一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlanUpdateRequestMappings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanUpdateRequestMappingView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanUpdateRequestMappings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestMappingControllerApi.listPlanUpdateRequestMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請マッピング更新
         * @param {string} planUpdateRequestMappingId 
         * @param {UpdatePlanUpdateRequestMappingParams} updatePlanUpdateRequestMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlanUpdateRequestMapping(planUpdateRequestMappingId: string, updatePlanUpdateRequestMappingParams: UpdatePlanUpdateRequestMappingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanUpdateRequestMapping(planUpdateRequestMappingId, updatePlanUpdateRequestMappingParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestMappingControllerApi.updatePlanUpdateRequestMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanUpdateRequestMappingControllerApi - factory interface
 */
export const PlanUpdateRequestMappingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanUpdateRequestMappingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 更新申請マッピング新規作成
         * @param {CreatePlanUpdateRequestMappingParams} createPlanUpdateRequestMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlanUpdateRequestMapping(createPlanUpdateRequestMappingParams: CreatePlanUpdateRequestMappingParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createPlanUpdateRequestMapping(createPlanUpdateRequestMappingParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請マッピング削除
         * @param {string} planUpdateRequestMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanUpdateRequestMapping(planUpdateRequestMappingId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deletePlanUpdateRequestMapping(planUpdateRequestMappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請マッピング
         * @param {string} planUpdateRequestMappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPlanUpdateRequestMapping(planUpdateRequestMappingId: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanUpdateRequestMapping> {
            return localVarFp.findPlanUpdateRequestMapping(planUpdateRequestMappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請マッピング一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanUpdateRequestMappings(options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanUpdateRequestMappingView>> {
            return localVarFp.listPlanUpdateRequestMappings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請マッピング更新
         * @param {string} planUpdateRequestMappingId 
         * @param {UpdatePlanUpdateRequestMappingParams} updatePlanUpdateRequestMappingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanUpdateRequestMapping(planUpdateRequestMappingId: string, updatePlanUpdateRequestMappingParams: UpdatePlanUpdateRequestMappingParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updatePlanUpdateRequestMapping(planUpdateRequestMappingId, updatePlanUpdateRequestMappingParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanUpdateRequestMappingControllerApi - object-oriented interface
 */
export class PlanUpdateRequestMappingControllerApi extends BaseAPI {
    /**
     * 
     * @summary 更新申請マッピング新規作成
     * @param {CreatePlanUpdateRequestMappingParams} createPlanUpdateRequestMappingParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPlanUpdateRequestMapping(createPlanUpdateRequestMappingParams: CreatePlanUpdateRequestMappingParams, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestMappingControllerApiFp(this.configuration).createPlanUpdateRequestMapping(createPlanUpdateRequestMappingParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請マッピング削除
     * @param {string} planUpdateRequestMappingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePlanUpdateRequestMapping(planUpdateRequestMappingId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestMappingControllerApiFp(this.configuration).deletePlanUpdateRequestMapping(planUpdateRequestMappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請マッピング
     * @param {string} planUpdateRequestMappingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findPlanUpdateRequestMapping(planUpdateRequestMappingId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestMappingControllerApiFp(this.configuration).findPlanUpdateRequestMapping(planUpdateRequestMappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請マッピング一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlanUpdateRequestMappings(options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestMappingControllerApiFp(this.configuration).listPlanUpdateRequestMappings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請マッピング更新
     * @param {string} planUpdateRequestMappingId 
     * @param {UpdatePlanUpdateRequestMappingParams} updatePlanUpdateRequestMappingParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePlanUpdateRequestMapping(planUpdateRequestMappingId: string, updatePlanUpdateRequestMappingParams: UpdatePlanUpdateRequestMappingParams, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestMappingControllerApiFp(this.configuration).updatePlanUpdateRequestMapping(planUpdateRequestMappingId, updatePlanUpdateRequestMappingParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanUpdateRequestV2ControllerApi - axios parameter creator
 */
export const PlanUpdateRequestV2ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentIdByPlanUpdateRequestId: async (planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('getDepartmentIdByPlanUpdateRequestId', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getDepartmentIdByPlanUpdateRequestId', 'planningProjectId', planningProjectId)
            // verify required parameter 'planUpdateRequestId' is not null or undefined
            assertParamExists('getDepartmentIdByPlanUpdateRequestId', 'planUpdateRequestId', planUpdateRequestId)
            const localVarPath = `/api/v2/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests/{planUpdateRequestId}/departmentId`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{planUpdateRequestId}', encodeURIComponent(String(planUpdateRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 更新申請は一部署のみのデータしか持たない為、部署Idの指定はない
         * @summary 編成プロジェクトへの更新申請取得API V2
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {GetPlanUpdateRequestTargetEnum} target 
         * @param {GetPlanUpdateRequestAggregateEnum} aggregate 
         * @param {GetPlanUpdateRequestShowInEnum} [showIn] 
         * @param {string} [currencyCode] 
         * @param {string} [planExchangeRateId] 
         * @param {string} [actualExchangeRateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanUpdateRequest: async (planMasterId: string, planningProjectId: string, planUpdateRequestId: string, target: GetPlanUpdateRequestTargetEnum, aggregate: GetPlanUpdateRequestAggregateEnum, showIn?: GetPlanUpdateRequestShowInEnum, currencyCode?: string, planExchangeRateId?: string, actualExchangeRateId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('getPlanUpdateRequest', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getPlanUpdateRequest', 'planningProjectId', planningProjectId)
            // verify required parameter 'planUpdateRequestId' is not null or undefined
            assertParamExists('getPlanUpdateRequest', 'planUpdateRequestId', planUpdateRequestId)
            // verify required parameter 'target' is not null or undefined
            assertParamExists('getPlanUpdateRequest', 'target', target)
            // verify required parameter 'aggregate' is not null or undefined
            assertParamExists('getPlanUpdateRequest', 'aggregate', aggregate)
            const localVarPath = `/api/v2/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests/{planUpdateRequestId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{planUpdateRequestId}', encodeURIComponent(String(planUpdateRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            if (aggregate !== undefined) {
                localVarQueryParameter['aggregate'] = aggregate;
            }

            if (showIn !== undefined) {
                localVarQueryParameter['showIn'] = showIn;
            }

            if (currencyCode !== undefined) {
                localVarQueryParameter['currencyCode'] = currencyCode;
            }

            if (planExchangeRateId !== undefined) {
                localVarQueryParameter['planExchangeRateId'] = planExchangeRateId;
            }

            if (actualExchangeRateId !== undefined) {
                localVarQueryParameter['actualExchangeRateId'] = actualExchangeRateId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新申請のOriginFileを取得します
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanUpdateRequestOriginFile: async (planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('getPlanUpdateRequestOriginFile', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getPlanUpdateRequestOriginFile', 'planningProjectId', planningProjectId)
            // verify required parameter 'planUpdateRequestId' is not null or undefined
            assertParamExists('getPlanUpdateRequestOriginFile', 'planUpdateRequestId', planUpdateRequestId)
            const localVarPath = `/api/v2/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests/{planUpdateRequestId}/file`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{planUpdateRequestId}', encodeURIComponent(String(planUpdateRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanUpdateRequestStatuses: async (planMasterId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('getPlanUpdateRequestStatuses', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getPlanUpdateRequestStatuses', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/v2/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/planUpdateRequests/statuses`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanUpdateRequestV2ControllerApi - functional programming interface
 */
export const PlanUpdateRequestV2ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanUpdateRequestV2ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepartmentIdByPlanUpdateRequestId(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IDImpl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepartmentIdByPlanUpdateRequestId(planMasterId, planningProjectId, planUpdateRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestV2ControllerApi.getDepartmentIdByPlanUpdateRequestId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 更新申請は一部署のみのデータしか持たない為、部署Idの指定はない
         * @summary 編成プロジェクトへの更新申請取得API V2
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {GetPlanUpdateRequestTargetEnum} target 
         * @param {GetPlanUpdateRequestAggregateEnum} aggregate 
         * @param {GetPlanUpdateRequestShowInEnum} [showIn] 
         * @param {string} [currencyCode] 
         * @param {string} [planExchangeRateId] 
         * @param {string} [actualExchangeRateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanUpdateRequest(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, target: GetPlanUpdateRequestTargetEnum, aggregate: GetPlanUpdateRequestAggregateEnum, showIn?: GetPlanUpdateRequestShowInEnum, currencyCode?: string, planExchangeRateId?: string, actualExchangeRateId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanUpdateRequestV2View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanUpdateRequest(planMasterId, planningProjectId, planUpdateRequestId, target, aggregate, showIn, currencyCode, planExchangeRateId, actualExchangeRateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestV2ControllerApi.getPlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 更新申請のOriginFileを取得します
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanUpdateRequestOriginFile(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanUpdateRequestOriginFile(planMasterId, planningProjectId, planUpdateRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestV2ControllerApi.getPlanUpdateRequestOriginFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanUpdateRequestStatuses(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanUpdateRequestStatusesView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanUpdateRequestStatuses(planMasterId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestV2ControllerApi.getPlanUpdateRequestStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanUpdateRequestV2ControllerApi - factory interface
 */
export const PlanUpdateRequestV2ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanUpdateRequestV2ControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartmentIdByPlanUpdateRequestId(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<IDImpl> {
            return localVarFp.getDepartmentIdByPlanUpdateRequestId(planMasterId, planningProjectId, planUpdateRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 更新申請は一部署のみのデータしか持たない為、部署Idの指定はない
         * @summary 編成プロジェクトへの更新申請取得API V2
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {GetPlanUpdateRequestTargetEnum} target 
         * @param {GetPlanUpdateRequestAggregateEnum} aggregate 
         * @param {GetPlanUpdateRequestShowInEnum} [showIn] 
         * @param {string} [currencyCode] 
         * @param {string} [planExchangeRateId] 
         * @param {string} [actualExchangeRateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanUpdateRequest(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, target: GetPlanUpdateRequestTargetEnum, aggregate: GetPlanUpdateRequestAggregateEnum, showIn?: GetPlanUpdateRequestShowInEnum, currencyCode?: string, planExchangeRateId?: string, actualExchangeRateId?: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanUpdateRequestV2View> {
            return localVarFp.getPlanUpdateRequest(planMasterId, planningProjectId, planUpdateRequestId, target, aggregate, showIn, currencyCode, planExchangeRateId, actualExchangeRateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新申請のOriginFileを取得します
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {string} planUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanUpdateRequestOriginFile(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getPlanUpdateRequestOriginFile(planMasterId, planningProjectId, planUpdateRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanUpdateRequestStatuses(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanUpdateRequestStatusesView> {
            return localVarFp.getPlanUpdateRequestStatuses(planMasterId, planningProjectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanUpdateRequestV2ControllerApi - object-oriented interface
 */
export class PlanUpdateRequestV2ControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} planUpdateRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDepartmentIdByPlanUpdateRequestId(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestV2ControllerApiFp(this.configuration).getDepartmentIdByPlanUpdateRequestId(planMasterId, planningProjectId, planUpdateRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 更新申請は一部署のみのデータしか持たない為、部署Idの指定はない
     * @summary 編成プロジェクトへの更新申請取得API V2
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} planUpdateRequestId 
     * @param {GetPlanUpdateRequestTargetEnum} target 
     * @param {GetPlanUpdateRequestAggregateEnum} aggregate 
     * @param {GetPlanUpdateRequestShowInEnum} [showIn] 
     * @param {string} [currencyCode] 
     * @param {string} [planExchangeRateId] 
     * @param {string} [actualExchangeRateId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlanUpdateRequest(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, target: GetPlanUpdateRequestTargetEnum, aggregate: GetPlanUpdateRequestAggregateEnum, showIn?: GetPlanUpdateRequestShowInEnum, currencyCode?: string, planExchangeRateId?: string, actualExchangeRateId?: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestV2ControllerApiFp(this.configuration).getPlanUpdateRequest(planMasterId, planningProjectId, planUpdateRequestId, target, aggregate, showIn, currencyCode, planExchangeRateId, actualExchangeRateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新申請のOriginFileを取得します
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {string} planUpdateRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlanUpdateRequestOriginFile(planMasterId: string, planningProjectId: string, planUpdateRequestId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestV2ControllerApiFp(this.configuration).getPlanUpdateRequestOriginFile(planMasterId, planningProjectId, planUpdateRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlanUpdateRequestStatuses(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestV2ControllerApiFp(this.configuration).getPlanUpdateRequestStatuses(planMasterId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetPlanUpdateRequestTargetEnum = {
    Pl: 'PL',
    Bs: 'BS',
} as const;
export type GetPlanUpdateRequestTargetEnum = typeof GetPlanUpdateRequestTargetEnum[keyof typeof GetPlanUpdateRequestTargetEnum];
export const GetPlanUpdateRequestAggregateEnum = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    FiscalYear: 'FISCAL_YEAR',
    FiscalHalfYear: 'FISCAL_HALF_YEAR',
} as const;
export type GetPlanUpdateRequestAggregateEnum = typeof GetPlanUpdateRequestAggregateEnum[keyof typeof GetPlanUpdateRequestAggregateEnum];
export const GetPlanUpdateRequestShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;
export type GetPlanUpdateRequestShowInEnum = typeof GetPlanUpdateRequestShowInEnum[keyof typeof GetPlanUpdateRequestShowInEnum];


/**
 * PlanUpdateRequestV3ControllerApi - axios parameter creator
 */
export const PlanUpdateRequestV3ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ドラフト明細から更新申請を作成する
         * @param {CreateFromDraftRequest} createFromDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromDraft: async (createFromDraftRequest: CreateFromDraftRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFromDraftRequest' is not null or undefined
            assertParamExists('createFromDraft', 'createFromDraftRequest', createFromDraftRequest)
            const localVarPath = `/api/planUpdateRequests/from-draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFromDraftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取込設定を用いた財務実績アップロードで利用する型生成用
         * @param {ForOpenApiGenerator1Request} [forOpenApiGenerator1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forOpenApiGenerator1: async (forOpenApiGenerator1Request?: ForOpenApiGenerator1Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/planUpdateRequests/forOnlyOpenApiGenerator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forOpenApiGenerator1Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Loglassからエクセルの更新申請ファイルをアップロードし、シート名とインデックスの組み合わせを取得する
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExcelSheetNames: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('getExcelSheetNames', 'file', file)
            const localVarPath = `/api/planUpdateRequests/sheet-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Loglassからエクセルの更新申請ファイルをアップロードし、更新申請を作成する
         * @param {File} file 
         * @param {UploadExcelPlanUpdateParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExcelPlanUpdateRequest: async (file: File, params: UploadExcelPlanUpdateParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadExcelPlanUpdateRequest', 'file', file)
            // verify required parameter 'params' is not null or undefined
            assertParamExists('uploadExcelPlanUpdateRequest', 'params', params)
            const localVarPath = `/api/planUpdateRequests/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (params !== undefined) { 
                localVarFormParams.append('params', new Blob([JSON.stringify(params, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary スプシからエクセルの更新申請ファイルをアップロードし、更新申請を作成する
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {string} sheetUrl 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExcelPlanUpdateRequestByGSheet: async (planningProjectId: string, mappingId: string, sheetUrl: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('uploadExcelPlanUpdateRequestByGSheet', 'planningProjectId', planningProjectId)
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('uploadExcelPlanUpdateRequestByGSheet', 'mappingId', mappingId)
            // verify required parameter 'sheetUrl' is not null or undefined
            assertParamExists('uploadExcelPlanUpdateRequestByGSheet', 'sheetUrl', sheetUrl)
            const localVarPath = `/api/planUpdateRequests/upload-gsheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planningProjectId !== undefined) {
                localVarQueryParameter['planningProjectId'] = planningProjectId;
            }

            if (mappingId !== undefined) {
                localVarQueryParameter['mappingId'] = mappingId;
            }

            if (sheetUrl !== undefined) {
                localVarQueryParameter['sheetUrl'] = sheetUrl;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanUpdateRequestV3ControllerApi - functional programming interface
 */
export const PlanUpdateRequestV3ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanUpdateRequestV3ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ドラフト明細から更新申請を作成する
         * @param {CreateFromDraftRequest} createFromDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFromDraft(createFromDraftRequest: CreateFromDraftRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFromDraftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFromDraft(createFromDraftRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestV3ControllerApi.createFromDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 取込設定を用いた財務実績アップロードで利用する型生成用
         * @param {ForOpenApiGenerator1Request} [forOpenApiGenerator1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forOpenApiGenerator1(forOpenApiGenerator1Request?: ForOpenApiGenerator1Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forOpenApiGenerator1(forOpenApiGenerator1Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestV3ControllerApi.forOpenApiGenerator1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Loglassからエクセルの更新申請ファイルをアップロードし、シート名とインデックスの組み合わせを取得する
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExcelSheetNames(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SheetInfoView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExcelSheetNames(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestV3ControllerApi.getExcelSheetNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Loglassからエクセルの更新申請ファイルをアップロードし、更新申請を作成する
         * @param {File} file 
         * @param {UploadExcelPlanUpdateParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadExcelPlanUpdateRequest(file: File, params: UploadExcelPlanUpdateParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadExcelPlanUpdateRequest(file, params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestV3ControllerApi.uploadExcelPlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary スプシからエクセルの更新申請ファイルをアップロードし、更新申請を作成する
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {string} sheetUrl 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadExcelPlanUpdateRequestByGSheet(planningProjectId: string, mappingId: string, sheetUrl: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadExcelPlanUpdateRequestByGSheet(planningProjectId, mappingId, sheetUrl, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanUpdateRequestV3ControllerApi.uploadExcelPlanUpdateRequestByGSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanUpdateRequestV3ControllerApi - factory interface
 */
export const PlanUpdateRequestV3ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanUpdateRequestV3ControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ドラフト明細から更新申請を作成する
         * @param {CreateFromDraftRequest} createFromDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromDraft(createFromDraftRequest: CreateFromDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFromDraftResponse> {
            return localVarFp.createFromDraft(createFromDraftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取込設定を用いた財務実績アップロードで利用する型生成用
         * @param {ForOpenApiGenerator1Request} [forOpenApiGenerator1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forOpenApiGenerator1(forOpenApiGenerator1Request?: ForOpenApiGenerator1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forOpenApiGenerator1(forOpenApiGenerator1Request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Loglassからエクセルの更新申請ファイルをアップロードし、シート名とインデックスの組み合わせを取得する
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExcelSheetNames(file: File, options?: RawAxiosRequestConfig): AxiosPromise<Array<SheetInfoView>> {
            return localVarFp.getExcelSheetNames(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Loglassからエクセルの更新申請ファイルをアップロードし、更新申請を作成する
         * @param {File} file 
         * @param {UploadExcelPlanUpdateParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExcelPlanUpdateRequest(file: File, params: UploadExcelPlanUpdateParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadExcelPlanUpdateRequest(file, params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary スプシからエクセルの更新申請ファイルをアップロードし、更新申請を作成する
         * @param {string} planningProjectId 
         * @param {string} mappingId 
         * @param {string} sheetUrl 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExcelPlanUpdateRequestByGSheet(planningProjectId: string, mappingId: string, sheetUrl: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadExcelPlanUpdateRequestByGSheet(planningProjectId, mappingId, sheetUrl, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanUpdateRequestV3ControllerApi - object-oriented interface
 */
export class PlanUpdateRequestV3ControllerApi extends BaseAPI {
    /**
     * 
     * @summary ドラフト明細から更新申請を作成する
     * @param {CreateFromDraftRequest} createFromDraftRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createFromDraft(createFromDraftRequest: CreateFromDraftRequest, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestV3ControllerApiFp(this.configuration).createFromDraft(createFromDraftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取込設定を用いた財務実績アップロードで利用する型生成用
     * @param {ForOpenApiGenerator1Request} [forOpenApiGenerator1Request] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forOpenApiGenerator1(forOpenApiGenerator1Request?: ForOpenApiGenerator1Request, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestV3ControllerApiFp(this.configuration).forOpenApiGenerator1(forOpenApiGenerator1Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Loglassからエクセルの更新申請ファイルをアップロードし、シート名とインデックスの組み合わせを取得する
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExcelSheetNames(file: File, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestV3ControllerApiFp(this.configuration).getExcelSheetNames(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Loglassからエクセルの更新申請ファイルをアップロードし、更新申請を作成する
     * @param {File} file 
     * @param {UploadExcelPlanUpdateParams} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadExcelPlanUpdateRequest(file: File, params: UploadExcelPlanUpdateParams, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestV3ControllerApiFp(this.configuration).uploadExcelPlanUpdateRequest(file, params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary スプシからエクセルの更新申請ファイルをアップロードし、更新申請を作成する
     * @param {string} planningProjectId 
     * @param {string} mappingId 
     * @param {string} sheetUrl 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadExcelPlanUpdateRequestByGSheet(planningProjectId: string, mappingId: string, sheetUrl: string, file?: File, options?: RawAxiosRequestConfig) {
        return PlanUpdateRequestV3ControllerApiFp(this.configuration).uploadExcelPlanUpdateRequestByGSheet(planningProjectId, mappingId, sheetUrl, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanningProjectControllerApi - axios parameter creator
 */
export const PlanningProjectControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 編成プロジェクトをアーカイブする
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivedPlanningProject: async (planMasterId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('archivedPlanningProject', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('archivedPlanningProject', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/archive`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成プロジェクトのアーカイブを取消する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelArchivedPlanningProject: async (planMasterId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('cancelArchivedPlanningProject', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('cancelArchivedPlanningProject', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/cancelArchive`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成プロジェクト削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanningProject: async (planMasterId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('deletePlanningProject', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('deletePlanningProject', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成プロジェクト編成完了
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixPlanningProject: async (planMasterId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('fixPlanningProject', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('fixPlanningProject', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}/fix`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成プロジェクト最新値
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {GetPlanningProjectAggregateEnum} aggregate 
         * @param {Array<string>} [departmentIds] 
         * @param {GetPlanningProjectShowInEnum} [showIn] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanningProject: async (planMasterId: string, planningProjectId: string, aggregate: GetPlanningProjectAggregateEnum, departmentIds?: Array<string>, showIn?: GetPlanningProjectShowInEnum, start?: string, end?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('getPlanningProject', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getPlanningProject', 'planningProjectId', planningProjectId)
            // verify required parameter 'aggregate' is not null or undefined
            assertParamExists('getPlanningProject', 'aggregate', aggregate)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (departmentIds) {
                localVarQueryParameter['departmentIds'] = departmentIds;
            }

            if (aggregate !== undefined) {
                localVarQueryParameter['aggregate'] = aggregate;
            }

            if (showIn !== undefined) {
                localVarQueryParameter['showIn'] = showIn;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成プロジェクト作成開始
         * @param {string} planMasterId 
         * @param {CreatePlanningProjectParam} createPlanningProjectParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCreatingPlanningProject: async (planMasterId: string, createPlanningProjectParam: CreatePlanningProjectParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('startCreatingPlanningProject', 'planMasterId', planMasterId)
            // verify required parameter 'createPlanningProjectParam' is not null or undefined
            assertParamExists('startCreatingPlanningProject', 'createPlanningProjectParam', createPlanningProjectParam)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/start-creating`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPlanningProjectParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成プロジェクト編集
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {UpdatePlanningProjectParam} updatePlanningProjectParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanningProject: async (planMasterId: string, planningProjectId: string, updatePlanningProjectParam: UpdatePlanningProjectParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planMasterId' is not null or undefined
            assertParamExists('updatePlanningProject', 'planMasterId', planMasterId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('updatePlanningProject', 'planningProjectId', planningProjectId)
            // verify required parameter 'updatePlanningProjectParam' is not null or undefined
            assertParamExists('updatePlanningProject', 'updatePlanningProjectParam', updatePlanningProjectParam)
            const localVarPath = `/api/plans/planmasters/{planMasterId}/planningProjects/{planningProjectId}`
                .replace('{planMasterId}', encodeURIComponent(String(planMasterId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlanningProjectParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanningProjectControllerApi - functional programming interface
 */
export const PlanningProjectControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanningProjectControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 編成プロジェクトをアーカイブする
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archivedPlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archivedPlanningProject(planMasterId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectControllerApi.archivedPlanningProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成プロジェクトのアーカイブを取消する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelArchivedPlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelArchivedPlanningProject(planMasterId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectControllerApi.cancelArchivedPlanningProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成プロジェクト削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlanningProject(planMasterId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectControllerApi.deletePlanningProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成プロジェクト編成完了
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fixPlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fixPlanningProject(planMasterId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectControllerApi.fixPlanningProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成プロジェクト最新値
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {GetPlanningProjectAggregateEnum} aggregate 
         * @param {Array<string>} [departmentIds] 
         * @param {GetPlanningProjectShowInEnum} [showIn] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanningProject(planMasterId: string, planningProjectId: string, aggregate: GetPlanningProjectAggregateEnum, departmentIds?: Array<string>, showIn?: GetPlanningProjectShowInEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningProjectView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanningProject(planMasterId, planningProjectId, aggregate, departmentIds, showIn, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectControllerApi.getPlanningProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成プロジェクト作成開始
         * @param {string} planMasterId 
         * @param {CreatePlanningProjectParam} createPlanningProjectParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startCreatingPlanningProject(planMasterId: string, createPlanningProjectParam: CreatePlanningProjectParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startCreatingPlanningProject(planMasterId, createPlanningProjectParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectControllerApi.startCreatingPlanningProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成プロジェクト編集
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {UpdatePlanningProjectParam} updatePlanningProjectParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlanningProject(planMasterId: string, planningProjectId: string, updatePlanningProjectParam: UpdatePlanningProjectParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlanningProject(planMasterId, planningProjectId, updatePlanningProjectParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectControllerApi.updatePlanningProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanningProjectControllerApi - factory interface
 */
export const PlanningProjectControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanningProjectControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 編成プロジェクトをアーカイブする
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivedPlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.archivedPlanningProject(planMasterId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成プロジェクトのアーカイブを取消する
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelArchivedPlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.cancelArchivedPlanningProject(planMasterId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成プロジェクト削除
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deletePlanningProject(planMasterId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成プロジェクト編成完了
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixPlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.fixPlanningProject(planMasterId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成プロジェクト最新値
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {GetPlanningProjectAggregateEnum} aggregate 
         * @param {Array<string>} [departmentIds] 
         * @param {GetPlanningProjectShowInEnum} [showIn] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanningProject(planMasterId: string, planningProjectId: string, aggregate: GetPlanningProjectAggregateEnum, departmentIds?: Array<string>, showIn?: GetPlanningProjectShowInEnum, start?: string, end?: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanningProjectView> {
            return localVarFp.getPlanningProject(planMasterId, planningProjectId, aggregate, departmentIds, showIn, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成プロジェクト作成開始
         * @param {string} planMasterId 
         * @param {CreatePlanningProjectParam} createPlanningProjectParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCreatingPlanningProject(planMasterId: string, createPlanningProjectParam: CreatePlanningProjectParam, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.startCreatingPlanningProject(planMasterId, createPlanningProjectParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成プロジェクト編集
         * @param {string} planMasterId 
         * @param {string} planningProjectId 
         * @param {UpdatePlanningProjectParam} updatePlanningProjectParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlanningProject(planMasterId: string, planningProjectId: string, updatePlanningProjectParam: UpdatePlanningProjectParam, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updatePlanningProject(planMasterId, planningProjectId, updatePlanningProjectParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanningProjectControllerApi - object-oriented interface
 */
export class PlanningProjectControllerApi extends BaseAPI {
    /**
     * 
     * @summary 編成プロジェクトをアーカイブする
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archivedPlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return PlanningProjectControllerApiFp(this.configuration).archivedPlanningProject(planMasterId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成プロジェクトのアーカイブを取消する
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelArchivedPlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return PlanningProjectControllerApiFp(this.configuration).cancelArchivedPlanningProject(planMasterId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成プロジェクト削除
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return PlanningProjectControllerApiFp(this.configuration).deletePlanningProject(planMasterId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成プロジェクト編成完了
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fixPlanningProject(planMasterId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return PlanningProjectControllerApiFp(this.configuration).fixPlanningProject(planMasterId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成プロジェクト最新値
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {GetPlanningProjectAggregateEnum} aggregate 
     * @param {Array<string>} [departmentIds] 
     * @param {GetPlanningProjectShowInEnum} [showIn] 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlanningProject(planMasterId: string, planningProjectId: string, aggregate: GetPlanningProjectAggregateEnum, departmentIds?: Array<string>, showIn?: GetPlanningProjectShowInEnum, start?: string, end?: string, options?: RawAxiosRequestConfig) {
        return PlanningProjectControllerApiFp(this.configuration).getPlanningProject(planMasterId, planningProjectId, aggregate, departmentIds, showIn, start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成プロジェクト作成開始
     * @param {string} planMasterId 
     * @param {CreatePlanningProjectParam} createPlanningProjectParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startCreatingPlanningProject(planMasterId: string, createPlanningProjectParam: CreatePlanningProjectParam, options?: RawAxiosRequestConfig) {
        return PlanningProjectControllerApiFp(this.configuration).startCreatingPlanningProject(planMasterId, createPlanningProjectParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成プロジェクト編集
     * @param {string} planMasterId 
     * @param {string} planningProjectId 
     * @param {UpdatePlanningProjectParam} updatePlanningProjectParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePlanningProject(planMasterId: string, planningProjectId: string, updatePlanningProjectParam: UpdatePlanningProjectParam, options?: RawAxiosRequestConfig) {
        return PlanningProjectControllerApiFp(this.configuration).updatePlanningProject(planMasterId, planningProjectId, updatePlanningProjectParam, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetPlanningProjectAggregateEnum = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    FiscalYear: 'FISCAL_YEAR',
    FiscalHalfYear: 'FISCAL_HALF_YEAR',
} as const;
export type GetPlanningProjectAggregateEnum = typeof GetPlanningProjectAggregateEnum[keyof typeof GetPlanningProjectAggregateEnum];
export const GetPlanningProjectShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;
export type GetPlanningProjectShowInEnum = typeof GetPlanningProjectShowInEnum[keyof typeof GetPlanningProjectShowInEnum];


/**
 * PlanningProjectDepartmentCommentsControllerApi - axios parameter creator
 */
export const PlanningProjectDepartmentCommentsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 編成プロジェクト内の部署に紐づくコメントを作成する
         * @summary 編成プロジェクト部署コメント作成
         * @param {CreatePlanningProjectDepartmentCommentBody} createPlanningProjectDepartmentCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment: async (createPlanningProjectDepartmentCommentBody: CreatePlanningProjectDepartmentCommentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPlanningProjectDepartmentCommentBody' is not null or undefined
            assertParamExists('createComment', 'createPlanningProjectDepartmentCommentBody', createPlanningProjectDepartmentCommentBody)
            const localVarPath = `/api/planningProjectDepartmentComments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPlanningProjectDepartmentCommentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 編成プロジェクト内の部署に紐づくコメントを削除する
         * @summary 編成プロジェクト部署コメント削除
         * @param {string} planningProjectDepartmentCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment: async (planningProjectDepartmentCommentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectDepartmentCommentId' is not null or undefined
            assertParamExists('deleteComment', 'planningProjectDepartmentCommentId', planningProjectDepartmentCommentId)
            const localVarPath = `/api/planningProjectDepartmentComments/{planningProjectDepartmentCommentId}`
                .replace('{planningProjectDepartmentCommentId}', encodeURIComponent(String(planningProjectDepartmentCommentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 編成プロジェクト内の部署に紐づくコメントを一覧で取得する
         * @summary 編成プロジェクト部署コメント一覧
         * @param {string} planningProjectId 
         * @param {string} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComment: async (planningProjectId: string, departmentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('listComment', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjectDepartmentComments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planningProjectId !== undefined) {
                localVarQueryParameter['planningProjectId'] = planningProjectId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanningProjectDepartmentCommentsControllerApi - functional programming interface
 */
export const PlanningProjectDepartmentCommentsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanningProjectDepartmentCommentsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 編成プロジェクト内の部署に紐づくコメントを作成する
         * @summary 編成プロジェクト部署コメント作成
         * @param {CreatePlanningProjectDepartmentCommentBody} createPlanningProjectDepartmentCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComment(createPlanningProjectDepartmentCommentBody: CreatePlanningProjectDepartmentCommentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComment(createPlanningProjectDepartmentCommentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectDepartmentCommentsControllerApi.createComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 編成プロジェクト内の部署に紐づくコメントを削除する
         * @summary 編成プロジェクト部署コメント削除
         * @param {string} planningProjectDepartmentCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComment(planningProjectDepartmentCommentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComment(planningProjectDepartmentCommentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectDepartmentCommentsControllerApi.deleteComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 編成プロジェクト内の部署に紐づくコメントを一覧で取得する
         * @summary 編成プロジェクト部署コメント一覧
         * @param {string} planningProjectId 
         * @param {string} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listComment(planningProjectId: string, departmentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningProjectDepartmentCommentMapView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listComment(planningProjectId, departmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectDepartmentCommentsControllerApi.listComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanningProjectDepartmentCommentsControllerApi - factory interface
 */
export const PlanningProjectDepartmentCommentsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanningProjectDepartmentCommentsControllerApiFp(configuration)
    return {
        /**
         * 編成プロジェクト内の部署に紐づくコメントを作成する
         * @summary 編成プロジェクト部署コメント作成
         * @param {CreatePlanningProjectDepartmentCommentBody} createPlanningProjectDepartmentCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(createPlanningProjectDepartmentCommentBody: CreatePlanningProjectDepartmentCommentBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createComment(createPlanningProjectDepartmentCommentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 編成プロジェクト内の部署に紐づくコメントを削除する
         * @summary 編成プロジェクト部署コメント削除
         * @param {string} planningProjectDepartmentCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(planningProjectDepartmentCommentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteComment(planningProjectDepartmentCommentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 編成プロジェクト内の部署に紐づくコメントを一覧で取得する
         * @summary 編成プロジェクト部署コメント一覧
         * @param {string} planningProjectId 
         * @param {string} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComment(planningProjectId: string, departmentId?: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanningProjectDepartmentCommentMapView> {
            return localVarFp.listComment(planningProjectId, departmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanningProjectDepartmentCommentsControllerApi - object-oriented interface
 */
export class PlanningProjectDepartmentCommentsControllerApi extends BaseAPI {
    /**
     * 編成プロジェクト内の部署に紐づくコメントを作成する
     * @summary 編成プロジェクト部署コメント作成
     * @param {CreatePlanningProjectDepartmentCommentBody} createPlanningProjectDepartmentCommentBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createComment(createPlanningProjectDepartmentCommentBody: CreatePlanningProjectDepartmentCommentBody, options?: RawAxiosRequestConfig) {
        return PlanningProjectDepartmentCommentsControllerApiFp(this.configuration).createComment(createPlanningProjectDepartmentCommentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 編成プロジェクト内の部署に紐づくコメントを削除する
     * @summary 編成プロジェクト部署コメント削除
     * @param {string} planningProjectDepartmentCommentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteComment(planningProjectDepartmentCommentId: string, options?: RawAxiosRequestConfig) {
        return PlanningProjectDepartmentCommentsControllerApiFp(this.configuration).deleteComment(planningProjectDepartmentCommentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 編成プロジェクト内の部署に紐づくコメントを一覧で取得する
     * @summary 編成プロジェクト部署コメント一覧
     * @param {string} planningProjectId 
     * @param {string} [departmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listComment(planningProjectId: string, departmentId?: string, options?: RawAxiosRequestConfig) {
        return PlanningProjectDepartmentCommentsControllerApiFp(this.configuration).listComment(planningProjectId, departmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanningProjectsControllerApi - axios parameter creator
 */
export const PlanningProjectsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 編成プロジェクト一覧
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllPlanningProjects: async (limit?: number, offset?: number, isArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/plans/all-plannings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanningProjectsControllerApi - functional programming interface
 */
export const PlanningProjectsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanningProjectsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 編成プロジェクト一覧
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllPlanningProjects(limit?: number, offset?: number, isArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningProjectListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllPlanningProjects(limit, offset, isArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningProjectsControllerApi.listAllPlanningProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanningProjectsControllerApi - factory interface
 */
export const PlanningProjectsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanningProjectsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 編成プロジェクト一覧
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllPlanningProjects(limit?: number, offset?: number, isArchived?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PlanningProjectListView> {
            return localVarFp.listAllPlanningProjects(limit, offset, isArchived, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanningProjectsControllerApi - object-oriented interface
 */
export class PlanningProjectsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 編成プロジェクト一覧
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {boolean} [isArchived] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAllPlanningProjects(limit?: number, offset?: number, isArchived?: boolean, options?: RawAxiosRequestConfig) {
        return PlanningProjectsControllerApiFp(this.configuration).listAllPlanningProjects(limit, offset, isArchived, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlansControllerApi - axios parameter creator
 */
export const PlansControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 計画マスタと編成プロジェクトの一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlans: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlansControllerApi - functional programming interface
 */
export const PlansControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlansControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 計画マスタと編成プロジェクトの一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlans(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanMastersPlanningProjectsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlans(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansControllerApi.listPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlansControllerApi - factory interface
 */
export const PlansControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlansControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 計画マスタと編成プロジェクトの一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlans(options?: RawAxiosRequestConfig): AxiosPromise<PlanMastersPlanningProjectsView> {
            return localVarFp.listPlans(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlansControllerApi - object-oriented interface
 */
export class PlansControllerApi extends BaseAPI {
    /**
     * 
     * @summary 計画マスタと編成プロジェクトの一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlans(options?: RawAxiosRequestConfig) {
        return PlansControllerApiFp(this.configuration).listPlans(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessSettingControllerApi - axios parameter creator
 */
export const ProcessSettingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 加工設定作成
         * @param {ProcessSettingParams} processSettingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessSetting: async (processSettingParams: ProcessSettingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processSettingParams' is not null or undefined
            assertParamExists('createProcessSetting', 'processSettingParams', processSettingParams)
            const localVarPath = `/api/processSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processSettingParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加工設定削除
         * @param {string} processSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessSetting: async (processSettingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processSettingId' is not null or undefined
            assertParamExists('deleteProcessSetting', 'processSettingId', processSettingId)
            const localVarPath = `/api/processSettings/{processSettingId}`
                .replace('{processSettingId}', encodeURIComponent(String(processSettingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加工設定
         * @param {string} processSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcessSetting: async (processSettingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processSettingId' is not null or undefined
            assertParamExists('findProcessSetting', 'processSettingId', processSettingId)
            const localVarPath = `/api/processSettings/{processSettingId}`
                .replace('{processSettingId}', encodeURIComponent(String(processSettingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加工設定一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProcessSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/processSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 実績取込マッピングプレビュー取得
         * @param {File} file 
         * @param {ProcessSettingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMapping: async (file: File, params: ProcessSettingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('previewMapping', 'file', file)
            // verify required parameter 'params' is not null or undefined
            assertParamExists('previewMapping', 'params', params)
            const localVarPath = `/api/processSettings/preview/mapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (params !== undefined) { 
                localVarFormParams.append('params', new Blob([JSON.stringify(params, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加工前ファイルプレビュー取得
         * @param {File} file 
         * @param {ProcessSettingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOriginal: async (file: File, params: ProcessSettingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('previewOriginal', 'file', file)
            // verify required parameter 'params' is not null or undefined
            assertParamExists('previewOriginal', 'params', params)
            const localVarPath = `/api/processSettings/preview/original`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (params !== undefined) { 
                localVarFormParams.append('params', new Blob([JSON.stringify(params, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加工後ファイルプレビュー取得
         * @param {File} file 
         * @param {ProcessSettingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewTransformed: async (file: File, params: ProcessSettingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('previewTransformed', 'file', file)
            // verify required parameter 'params' is not null or undefined
            assertParamExists('previewTransformed', 'params', params)
            const localVarPath = `/api/processSettings/preview/transformed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (params !== undefined) { 
                localVarFormParams.append('params', new Blob([JSON.stringify(params, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加工設定更新
         * @param {string} processSettingId 
         * @param {ProcessSettingParams} processSettingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessSetting: async (processSettingId: string, processSettingParams: ProcessSettingParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processSettingId' is not null or undefined
            assertParamExists('updateProcessSetting', 'processSettingId', processSettingId)
            // verify required parameter 'processSettingParams' is not null or undefined
            assertParamExists('updateProcessSetting', 'processSettingParams', processSettingParams)
            const localVarPath = `/api/processSettings/{processSettingId}`
                .replace('{processSettingId}', encodeURIComponent(String(processSettingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processSettingParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessSettingControllerApi - functional programming interface
 */
export const ProcessSettingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessSettingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 加工設定作成
         * @param {ProcessSettingParams} processSettingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcessSetting(processSettingParams: ProcessSettingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcessSetting(processSettingParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessSettingControllerApi.createProcessSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加工設定削除
         * @param {string} processSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProcessSetting(processSettingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProcessSetting(processSettingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessSettingControllerApi.deleteProcessSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加工設定
         * @param {string} processSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProcessSetting(processSettingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindProcessSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findProcessSetting(processSettingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessSettingControllerApi.findProcessSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加工設定一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProcessSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessSettingView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProcessSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessSettingControllerApi.listProcessSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 実績取込マッピングプレビュー取得
         * @param {File} file 
         * @param {ProcessSettingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewMapping(file: File, params: ProcessSettingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessSettingPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewMapping(file, params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessSettingControllerApi.previewMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加工前ファイルプレビュー取得
         * @param {File} file 
         * @param {ProcessSettingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewOriginal(file: File, params: ProcessSettingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessSettingPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewOriginal(file, params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessSettingControllerApi.previewOriginal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加工後ファイルプレビュー取得
         * @param {File} file 
         * @param {ProcessSettingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewTransformed(file: File, params: ProcessSettingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessSettingPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewTransformed(file, params, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessSettingControllerApi.previewTransformed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加工設定更新
         * @param {string} processSettingId 
         * @param {ProcessSettingParams} processSettingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessSetting(processSettingId: string, processSettingParams: ProcessSettingParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessSetting(processSettingId, processSettingParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessSettingControllerApi.updateProcessSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessSettingControllerApi - factory interface
 */
export const ProcessSettingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessSettingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 加工設定作成
         * @param {ProcessSettingParams} processSettingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessSetting(processSettingParams: ProcessSettingParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createProcessSetting(processSettingParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加工設定削除
         * @param {string} processSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessSetting(processSettingId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteProcessSetting(processSettingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加工設定
         * @param {string} processSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcessSetting(processSettingId: string, options?: RawAxiosRequestConfig): AxiosPromise<FindProcessSettingDto> {
            return localVarFp.findProcessSetting(processSettingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加工設定一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProcessSettings(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessSettingView>> {
            return localVarFp.listProcessSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 実績取込マッピングプレビュー取得
         * @param {File} file 
         * @param {ProcessSettingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMapping(file: File, params: ProcessSettingParams, options?: RawAxiosRequestConfig): AxiosPromise<ProcessSettingPreview> {
            return localVarFp.previewMapping(file, params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加工前ファイルプレビュー取得
         * @param {File} file 
         * @param {ProcessSettingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOriginal(file: File, params: ProcessSettingParams, options?: RawAxiosRequestConfig): AxiosPromise<ProcessSettingPreview> {
            return localVarFp.previewOriginal(file, params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加工後ファイルプレビュー取得
         * @param {File} file 
         * @param {ProcessSettingParams} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewTransformed(file: File, params: ProcessSettingParams, options?: RawAxiosRequestConfig): AxiosPromise<ProcessSettingPreview> {
            return localVarFp.previewTransformed(file, params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加工設定更新
         * @param {string} processSettingId 
         * @param {ProcessSettingParams} processSettingParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessSetting(processSettingId: string, processSettingParams: ProcessSettingParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateProcessSetting(processSettingId, processSettingParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessSettingControllerApi - object-oriented interface
 */
export class ProcessSettingControllerApi extends BaseAPI {
    /**
     * 
     * @summary 加工設定作成
     * @param {ProcessSettingParams} processSettingParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcessSetting(processSettingParams: ProcessSettingParams, options?: RawAxiosRequestConfig) {
        return ProcessSettingControllerApiFp(this.configuration).createProcessSetting(processSettingParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加工設定削除
     * @param {string} processSettingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProcessSetting(processSettingId: string, options?: RawAxiosRequestConfig) {
        return ProcessSettingControllerApiFp(this.configuration).deleteProcessSetting(processSettingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加工設定
     * @param {string} processSettingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findProcessSetting(processSettingId: string, options?: RawAxiosRequestConfig) {
        return ProcessSettingControllerApiFp(this.configuration).findProcessSetting(processSettingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加工設定一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listProcessSettings(options?: RawAxiosRequestConfig) {
        return ProcessSettingControllerApiFp(this.configuration).listProcessSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 実績取込マッピングプレビュー取得
     * @param {File} file 
     * @param {ProcessSettingParams} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewMapping(file: File, params: ProcessSettingParams, options?: RawAxiosRequestConfig) {
        return ProcessSettingControllerApiFp(this.configuration).previewMapping(file, params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加工前ファイルプレビュー取得
     * @param {File} file 
     * @param {ProcessSettingParams} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewOriginal(file: File, params: ProcessSettingParams, options?: RawAxiosRequestConfig) {
        return ProcessSettingControllerApiFp(this.configuration).previewOriginal(file, params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加工後ファイルプレビュー取得
     * @param {File} file 
     * @param {ProcessSettingParams} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewTransformed(file: File, params: ProcessSettingParams, options?: RawAxiosRequestConfig) {
        return ProcessSettingControllerApiFp(this.configuration).previewTransformed(file, params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加工設定更新
     * @param {string} processSettingId 
     * @param {ProcessSettingParams} processSettingParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessSetting(processSettingId: string, processSettingParams: ProcessSettingParams, options?: RawAxiosRequestConfig) {
        return ProcessSettingControllerApiFp(this.configuration).updateProcessSetting(processSettingId, processSettingParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportCellCommentControllerApi - axios parameter creator
 */
export const ReportCellCommentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary レポートコメントを新規投稿する（集約 + 始点セルコメントを作成）
         * @param {CreateReportCommentRequestBody} createReportCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportComment: async (createReportCommentRequestBody: CreateReportCommentRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReportCommentRequestBody' is not null or undefined
            assertParamExists('createReportComment', 'createReportCommentRequestBody', createReportCommentRequestBody)
            const localVarPath = `/api/report-cell-comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReportCommentRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コメント（投稿1件）を削除する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {string} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportComment: async (cellCommentId: string, threadId: string, commentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cellCommentId' is not null or undefined
            assertParamExists('deleteReportComment', 'cellCommentId', cellCommentId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('deleteReportComment', 'threadId', threadId)
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('deleteReportComment', 'commentId', commentId)
            const localVarPath = `/api/report-cell-comments/{cellCommentId}/threads/{threadId}/comments/{commentId}`
                .replace('{cellCommentId}', encodeURIComponent(String(cellCommentId)))
                .replace('{threadId}', encodeURIComponent(String(threadId)))
                .replace('{commentId}', encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary セル位置に対応する表示ラベル（コメントパネル用3行＋ツールチップ）を解決する
         * @param {GetReportCellLabelRequestBody} getReportCellLabelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportCellLabel: async (getReportCellLabelRequestBody: GetReportCellLabelRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getReportCellLabelRequestBody' is not null or undefined
            assertParamExists('getReportCellLabel', 'getReportCellLabelRequestBody', getReportCellLabelRequestBody)
            const localVarPath = `/api/report-cell-comments/cell-label`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getReportCellLabelRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary テナント内の全レポートのコメントをスレッド単位で一覧する
         * @param {number} offset 
         * @param {number} limit 
         * @param {boolean} [participatedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllReportComments: async (offset: number, limit: number, participatedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('listAllReportComments', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('listAllReportComments', 'limit', limit)
            const localVarPath = `/api/report-cell-comments/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (participatedOnly !== undefined) {
                localVarQueryParameter['participatedOnly'] = participatedOnly;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コメントの公開範囲の公開先に指定できるユーザー一覧を取得する
         * @param {string} [cellCommentId] 
         * @param {string} [threadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportCommentVisibilitySelectableUsers: async (cellCommentId?: string, threadId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report-cell-comments/visibility/selectable-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (cellCommentId !== undefined) {
                localVarQueryParameter['cellCommentId'] = cellCommentId;
            }

            if (threadId !== undefined) {
                localVarQueryParameter['threadId'] = threadId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コメントパネル用にレポート内のコメント一覧を取得する
         * @param {ListReportCommentsRequestBody} listReportCommentsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportComments: async (listReportCommentsRequestBody: ListReportCommentsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listReportCommentsRequestBody' is not null or undefined
            assertParamExists('listReportComments', 'listReportCommentsRequestBody', listReportCommentsRequestBody)
            const localVarPath = `/api/report-cell-comments/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listReportCommentsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 既存スレッドへ返信（コメント）を1件追加する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {ReplyToReportCommentThreadRequestBody} replyToReportCommentThreadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyToReportCommentThread: async (cellCommentId: string, threadId: string, replyToReportCommentThreadRequestBody: ReplyToReportCommentThreadRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cellCommentId' is not null or undefined
            assertParamExists('replyToReportCommentThread', 'cellCommentId', cellCommentId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('replyToReportCommentThread', 'threadId', threadId)
            // verify required parameter 'replyToReportCommentThreadRequestBody' is not null or undefined
            assertParamExists('replyToReportCommentThread', 'replyToReportCommentThreadRequestBody', replyToReportCommentThreadRequestBody)
            const localVarPath = `/api/report-cell-comments/{cellCommentId}/threads/{threadId}/comments`
                .replace('{cellCommentId}', encodeURIComponent(String(cellCommentId)))
                .replace('{threadId}', encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replyToReportCommentThreadRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary コメントの本文を編集する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {string} commentId 
         * @param {UpdateReportCommentRequestBody} updateReportCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportComment: async (cellCommentId: string, threadId: string, commentId: string, updateReportCommentRequestBody: UpdateReportCommentRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cellCommentId' is not null or undefined
            assertParamExists('updateReportComment', 'cellCommentId', cellCommentId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('updateReportComment', 'threadId', threadId)
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('updateReportComment', 'commentId', commentId)
            // verify required parameter 'updateReportCommentRequestBody' is not null or undefined
            assertParamExists('updateReportComment', 'updateReportCommentRequestBody', updateReportCommentRequestBody)
            const localVarPath = `/api/report-cell-comments/{cellCommentId}/threads/{threadId}/comments/{commentId}`
                .replace('{cellCommentId}', encodeURIComponent(String(cellCommentId)))
                .replace('{threadId}', encodeURIComponent(String(threadId)))
                .replace('{commentId}', encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportCommentRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary スレッドの閲覧権限（公開範囲）を設定する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {UpdateReportCommentPermissionRequestBody} updateReportCommentPermissionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportCommentPermission: async (cellCommentId: string, threadId: string, updateReportCommentPermissionRequestBody: UpdateReportCommentPermissionRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cellCommentId' is not null or undefined
            assertParamExists('updateReportCommentPermission', 'cellCommentId', cellCommentId)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('updateReportCommentPermission', 'threadId', threadId)
            // verify required parameter 'updateReportCommentPermissionRequestBody' is not null or undefined
            assertParamExists('updateReportCommentPermission', 'updateReportCommentPermissionRequestBody', updateReportCommentPermissionRequestBody)
            const localVarPath = `/api/report-cell-comments/{cellCommentId}/threads/{threadId}/permission`
                .replace('{cellCommentId}', encodeURIComponent(String(cellCommentId)))
                .replace('{threadId}', encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportCommentPermissionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportCellCommentControllerApi - functional programming interface
 */
export const ReportCellCommentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportCellCommentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary レポートコメントを新規投稿する（集約 + 始点セルコメントを作成）
         * @param {CreateReportCommentRequestBody} createReportCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportComment(createReportCommentRequestBody: CreateReportCommentRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReportCommentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportComment(createReportCommentRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportCellCommentControllerApi.createReportComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コメント（投稿1件）を削除する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {string} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReportComment(cellCommentId: string, threadId: string, commentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReportComment(cellCommentId, threadId, commentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportCellCommentControllerApi.deleteReportComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary セル位置に対応する表示ラベル（コメントパネル用3行＋ツールチップ）を解決する
         * @param {GetReportCellLabelRequestBody} getReportCellLabelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportCellLabel(getReportCellLabelRequestBody: GetReportCellLabelRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportCellLabelView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportCellLabel(getReportCellLabelRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportCellCommentControllerApi.getReportCellLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary テナント内の全レポートのコメントをスレッド単位で一覧する
         * @param {number} offset 
         * @param {number} limit 
         * @param {boolean} [participatedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllReportComments(offset: number, limit: number, participatedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAllReportCommentsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllReportComments(offset, limit, participatedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportCellCommentControllerApi.listAllReportComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コメントの公開範囲の公開先に指定できるユーザー一覧を取得する
         * @param {string} [cellCommentId] 
         * @param {string} [threadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReportCommentVisibilitySelectableUsers(cellCommentId?: string, threadId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReportCommentVisibilitySelectableUsersView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReportCommentVisibilitySelectableUsers(cellCommentId, threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportCellCommentControllerApi.listReportCommentVisibilitySelectableUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コメントパネル用にレポート内のコメント一覧を取得する
         * @param {ListReportCommentsRequestBody} listReportCommentsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReportComments(listReportCommentsRequestBody: ListReportCommentsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReportCommentsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReportComments(listReportCommentsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportCellCommentControllerApi.listReportComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 既存スレッドへ返信（コメント）を1件追加する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {ReplyToReportCommentThreadRequestBody} replyToReportCommentThreadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replyToReportCommentThread(cellCommentId: string, threadId: string, replyToReportCommentThreadRequestBody: ReplyToReportCommentThreadRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplyToReportCommentThreadView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replyToReportCommentThread(cellCommentId, threadId, replyToReportCommentThreadRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportCellCommentControllerApi.replyToReportCommentThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary コメントの本文を編集する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {string} commentId 
         * @param {UpdateReportCommentRequestBody} updateReportCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportComment(cellCommentId: string, threadId: string, commentId: string, updateReportCommentRequestBody: UpdateReportCommentRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportComment(cellCommentId, threadId, commentId, updateReportCommentRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportCellCommentControllerApi.updateReportComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary スレッドの閲覧権限（公開範囲）を設定する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {UpdateReportCommentPermissionRequestBody} updateReportCommentPermissionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportCommentPermission(cellCommentId: string, threadId: string, updateReportCommentPermissionRequestBody: UpdateReportCommentPermissionRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportCommentPermission(cellCommentId, threadId, updateReportCommentPermissionRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportCellCommentControllerApi.updateReportCommentPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportCellCommentControllerApi - factory interface
 */
export const ReportCellCommentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportCellCommentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary レポートコメントを新規投稿する（集約 + 始点セルコメントを作成）
         * @param {CreateReportCommentRequestBody} createReportCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportComment(createReportCommentRequestBody: CreateReportCommentRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreateReportCommentView> {
            return localVarFp.createReportComment(createReportCommentRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コメント（投稿1件）を削除する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {string} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportComment(cellCommentId: string, threadId: string, commentId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteReportComment(cellCommentId, threadId, commentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary セル位置に対応する表示ラベル（コメントパネル用3行＋ツールチップ）を解決する
         * @param {GetReportCellLabelRequestBody} getReportCellLabelRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportCellLabel(getReportCellLabelRequestBody: GetReportCellLabelRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<GetReportCellLabelView> {
            return localVarFp.getReportCellLabel(getReportCellLabelRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary テナント内の全レポートのコメントをスレッド単位で一覧する
         * @param {number} offset 
         * @param {number} limit 
         * @param {boolean} [participatedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllReportComments(offset: number, limit: number, participatedOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ListAllReportCommentsView> {
            return localVarFp.listAllReportComments(offset, limit, participatedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コメントの公開範囲の公開先に指定できるユーザー一覧を取得する
         * @param {string} [cellCommentId] 
         * @param {string} [threadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportCommentVisibilitySelectableUsers(cellCommentId?: string, threadId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListReportCommentVisibilitySelectableUsersView> {
            return localVarFp.listReportCommentVisibilitySelectableUsers(cellCommentId, threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コメントパネル用にレポート内のコメント一覧を取得する
         * @param {ListReportCommentsRequestBody} listReportCommentsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportComments(listReportCommentsRequestBody: ListReportCommentsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ListReportCommentsView> {
            return localVarFp.listReportComments(listReportCommentsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 既存スレッドへ返信（コメント）を1件追加する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {ReplyToReportCommentThreadRequestBody} replyToReportCommentThreadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyToReportCommentThread(cellCommentId: string, threadId: string, replyToReportCommentThreadRequestBody: ReplyToReportCommentThreadRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ReplyToReportCommentThreadView> {
            return localVarFp.replyToReportCommentThread(cellCommentId, threadId, replyToReportCommentThreadRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary コメントの本文を編集する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {string} commentId 
         * @param {UpdateReportCommentRequestBody} updateReportCommentRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportComment(cellCommentId: string, threadId: string, commentId: string, updateReportCommentRequestBody: UpdateReportCommentRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateReportComment(cellCommentId, threadId, commentId, updateReportCommentRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary スレッドの閲覧権限（公開範囲）を設定する
         * @param {string} cellCommentId 
         * @param {string} threadId 
         * @param {UpdateReportCommentPermissionRequestBody} updateReportCommentPermissionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportCommentPermission(cellCommentId: string, threadId: string, updateReportCommentPermissionRequestBody: UpdateReportCommentPermissionRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateReportCommentPermission(cellCommentId, threadId, updateReportCommentPermissionRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportCellCommentControllerApi - object-oriented interface
 */
export class ReportCellCommentControllerApi extends BaseAPI {
    /**
     * 
     * @summary レポートコメントを新規投稿する（集約 + 始点セルコメントを作成）
     * @param {CreateReportCommentRequestBody} createReportCommentRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createReportComment(createReportCommentRequestBody: CreateReportCommentRequestBody, options?: RawAxiosRequestConfig) {
        return ReportCellCommentControllerApiFp(this.configuration).createReportComment(createReportCommentRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コメント（投稿1件）を削除する
     * @param {string} cellCommentId 
     * @param {string} threadId 
     * @param {string} commentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteReportComment(cellCommentId: string, threadId: string, commentId: string, options?: RawAxiosRequestConfig) {
        return ReportCellCommentControllerApiFp(this.configuration).deleteReportComment(cellCommentId, threadId, commentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary セル位置に対応する表示ラベル（コメントパネル用3行＋ツールチップ）を解決する
     * @param {GetReportCellLabelRequestBody} getReportCellLabelRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportCellLabel(getReportCellLabelRequestBody: GetReportCellLabelRequestBody, options?: RawAxiosRequestConfig) {
        return ReportCellCommentControllerApiFp(this.configuration).getReportCellLabel(getReportCellLabelRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary テナント内の全レポートのコメントをスレッド単位で一覧する
     * @param {number} offset 
     * @param {number} limit 
     * @param {boolean} [participatedOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAllReportComments(offset: number, limit: number, participatedOnly?: boolean, options?: RawAxiosRequestConfig) {
        return ReportCellCommentControllerApiFp(this.configuration).listAllReportComments(offset, limit, participatedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コメントの公開範囲の公開先に指定できるユーザー一覧を取得する
     * @param {string} [cellCommentId] 
     * @param {string} [threadId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listReportCommentVisibilitySelectableUsers(cellCommentId?: string, threadId?: string, options?: RawAxiosRequestConfig) {
        return ReportCellCommentControllerApiFp(this.configuration).listReportCommentVisibilitySelectableUsers(cellCommentId, threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コメントパネル用にレポート内のコメント一覧を取得する
     * @param {ListReportCommentsRequestBody} listReportCommentsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listReportComments(listReportCommentsRequestBody: ListReportCommentsRequestBody, options?: RawAxiosRequestConfig) {
        return ReportCellCommentControllerApiFp(this.configuration).listReportComments(listReportCommentsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 既存スレッドへ返信（コメント）を1件追加する
     * @param {string} cellCommentId 
     * @param {string} threadId 
     * @param {ReplyToReportCommentThreadRequestBody} replyToReportCommentThreadRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replyToReportCommentThread(cellCommentId: string, threadId: string, replyToReportCommentThreadRequestBody: ReplyToReportCommentThreadRequestBody, options?: RawAxiosRequestConfig) {
        return ReportCellCommentControllerApiFp(this.configuration).replyToReportCommentThread(cellCommentId, threadId, replyToReportCommentThreadRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary コメントの本文を編集する
     * @param {string} cellCommentId 
     * @param {string} threadId 
     * @param {string} commentId 
     * @param {UpdateReportCommentRequestBody} updateReportCommentRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateReportComment(cellCommentId: string, threadId: string, commentId: string, updateReportCommentRequestBody: UpdateReportCommentRequestBody, options?: RawAxiosRequestConfig) {
        return ReportCellCommentControllerApiFp(this.configuration).updateReportComment(cellCommentId, threadId, commentId, updateReportCommentRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary スレッドの閲覧権限（公開範囲）を設定する
     * @param {string} cellCommentId 
     * @param {string} threadId 
     * @param {UpdateReportCommentPermissionRequestBody} updateReportCommentPermissionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateReportCommentPermission(cellCommentId: string, threadId: string, updateReportCommentPermissionRequestBody: UpdateReportCommentPermissionRequestBody, options?: RawAxiosRequestConfig) {
        return ReportCellCommentControllerApiFp(this.configuration).updateReportCommentPermission(cellCommentId, threadId, updateReportCommentPermissionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportControllerApi - axios parameter creator
 */
export const ReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary レポートをコピーする
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyReport: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('copyReport', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}/copy`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートを新規作成する
         * @param {CreateReportBody} createReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport: async (createReportBody: CreateReportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReportBody' is not null or undefined
            assertParamExists('createReport', 'createReportBody', createReportBody)
            const localVarPath = `/api/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートをテンプレートを元に新規作成する
         * @param {CreateReportFromTemplateBody} createReportFromTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportFromTemplate: async (createReportFromTemplateBody: CreateReportFromTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReportFromTemplateBody' is not null or undefined
            assertParamExists('createReportFromTemplate', 'createReportFromTemplateBody', createReportFromTemplateBody)
            const localVarPath = `/api/reports/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReportFromTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートを削除する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReport: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('deleteReport', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グラフ新規作成時のデフォルトvisibleIdsを取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphDefaultVisibleIds: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getGraphDefaultVisibleIds', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}/graph-default-visible-ids`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートを取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReport', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ウォーターフォールグラフの初期値を取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterfallInitialValues: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getWaterfallInitialValues', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}/waterfall/initial-values`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポート概要を一括取得する（チャットツール向けに軽量化したレスポンス）
         * @param {ListReportBriefsRequestBody} listReportBriefsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportBriefs: async (listReportBriefsRequestBody: ListReportBriefsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listReportBriefsRequestBody' is not null or undefined
            assertParamExists('listReportBriefs', 'listReportBriefsRequestBody', listReportBriefsRequestBody)
            const localVarPath = `/api/reports/briefs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listReportBriefsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートの利用先ダッシュボード一覧取得
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportDashboardUsages: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('listReportDashboardUsages', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}/dashboard-usages`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートを指定したフォルダへ移動する
         * @param {string} reportId 
         * @param {MoveReportBody} moveReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveReport: async (reportId: string, moveReportBody: MoveReportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('moveReport', 'reportId', reportId)
            // verify required parameter 'moveReportBody' is not null or undefined
            assertParamExists('moveReport', 'moveReportBody', moveReportBody)
            const localVarPath = `/api/reports/{reportId}/move`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveReportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 選択された複数のレポート・フォルダを指定したフォルダへ移動する
         * @param {MoveReportsBody} moveReportsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveReports: async (moveReportsBody: MoveReportsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moveReportsBody' is not null or undefined
            assertParamExists('moveReports', 'moveReportsBody', moveReportsBody)
            const localVarPath = `/api/reports/move`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveReportsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BSレポートの条件を更新する
         * @param {string} reportId 
         * @param {UpdateBSReportConditionBody} updateBSReportConditionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBSReportCondition: async (reportId: string, updateBSReportConditionBody: UpdateBSReportConditionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('updateBSReportCondition', 'reportId', reportId)
            // verify required parameter 'updateBSReportConditionBody' is not null or undefined
            assertParamExists('updateBSReportCondition', 'updateBSReportConditionBody', updateBSReportConditionBody)
            const localVarPath = `/api/reports/bs/{reportId}/condition`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBSReportConditionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CFレポートの条件を更新する
         * @param {string} reportId 
         * @param {UpdateCFReportConditionBody} updateCFReportConditionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCFReportCondition: async (reportId: string, updateCFReportConditionBody: UpdateCFReportConditionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('updateCFReportCondition', 'reportId', reportId)
            // verify required parameter 'updateCFReportConditionBody' is not null or undefined
            assertParamExists('updateCFReportCondition', 'updateCFReportConditionBody', updateCFReportConditionBody)
            const localVarPath = `/api/reports/cf/{reportId}/condition`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCFReportConditionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PLレポートの条件を更新する
         * @param {string} reportId 
         * @param {UpdateReportConditionBody} updateReportConditionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportCondition: async (reportId: string, updateReportConditionBody: UpdateReportConditionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('updateReportCondition', 'reportId', reportId)
            // verify required parameter 'updateReportConditionBody' is not null or undefined
            assertParamExists('updateReportCondition', 'updateReportConditionBody', updateReportConditionBody)
            const localVarPath = `/api/reports/{reportId}/condition`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportConditionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートの編集制限を更新する
         * @param {string} reportId 
         * @param {UpdateReportEditRestrictedBody} updateReportEditRestrictedBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportEditRestricted: async (reportId: string, updateReportEditRestrictedBody: UpdateReportEditRestrictedBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('updateReportEditRestricted', 'reportId', reportId)
            // verify required parameter 'updateReportEditRestrictedBody' is not null or undefined
            assertParamExists('updateReportEditRestricted', 'updateReportEditRestrictedBody', updateReportEditRestrictedBody)
            const localVarPath = `/api/reports/{reportId}/edit-restricted`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportEditRestrictedBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートの名称を更新する
         * @param {string} reportId 
         * @param {UpdateReportNameBody} updateReportNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportName: async (reportId: string, updateReportNameBody: UpdateReportNameBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('updateReportName', 'reportId', reportId)
            // verify required parameter 'updateReportNameBody' is not null or undefined
            assertParamExists('updateReportName', 'updateReportNameBody', updateReportNameBody)
            const localVarPath = `/api/reports/{reportId}/name`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReportNameBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportControllerApi - functional programming interface
 */
export const ReportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary レポートをコピーする
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyReport(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.copyReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートを新規作成する
         * @param {CreateReportBody} createReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReport(createReportBody: CreateReportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReport(createReportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.createReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートをテンプレートを元に新規作成する
         * @param {CreateReportFromTemplateBody} createReportFromTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportFromTemplate(createReportFromTemplateBody: CreateReportFromTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportFromTemplate(createReportFromTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.createReportFromTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートを削除する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReport(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.deleteReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グラフ新規作成時のデフォルトvisibleIdsを取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraphDefaultVisibleIds(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphDefaultVisibleIds>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraphDefaultVisibleIds(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.getGraphDefaultVisibleIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートを取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReport(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.getReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ウォーターフォールグラフの初期値を取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterfallInitialValues(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterfallInitialValuesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterfallInitialValues(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.getWaterfallInitialValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポート概要を一括取得する（チャットツール向けに軽量化したレスポンス）
         * @param {ListReportBriefsRequestBody} listReportBriefsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReportBriefs(listReportBriefsRequestBody: ListReportBriefsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReportBriefsReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReportBriefs(listReportBriefsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.listReportBriefs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートの利用先ダッシュボード一覧取得
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReportDashboardUsages(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDashboardUsagesView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReportDashboardUsages(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.listReportDashboardUsages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートを指定したフォルダへ移動する
         * @param {string} reportId 
         * @param {MoveReportBody} moveReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveReport(reportId: string, moveReportBody: MoveReportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveReport(reportId, moveReportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.moveReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 選択された複数のレポート・フォルダを指定したフォルダへ移動する
         * @param {MoveReportsBody} moveReportsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveReports(moveReportsBody: MoveReportsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveReports(moveReportsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.moveReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BSレポートの条件を更新する
         * @param {string} reportId 
         * @param {UpdateBSReportConditionBody} updateBSReportConditionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBSReportCondition(reportId: string, updateBSReportConditionBody: UpdateBSReportConditionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBSReportCondition(reportId, updateBSReportConditionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.updateBSReportCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary CFレポートの条件を更新する
         * @param {string} reportId 
         * @param {UpdateCFReportConditionBody} updateCFReportConditionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCFReportCondition(reportId: string, updateCFReportConditionBody: UpdateCFReportConditionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCFReportCondition(reportId, updateCFReportConditionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.updateCFReportCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary PLレポートの条件を更新する
         * @param {string} reportId 
         * @param {UpdateReportConditionBody} updateReportConditionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportCondition(reportId: string, updateReportConditionBody: UpdateReportConditionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportCondition(reportId, updateReportConditionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.updateReportCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートの編集制限を更新する
         * @param {string} reportId 
         * @param {UpdateReportEditRestrictedBody} updateReportEditRestrictedBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportEditRestricted(reportId: string, updateReportEditRestrictedBody: UpdateReportEditRestrictedBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportEditRestricted(reportId, updateReportEditRestrictedBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.updateReportEditRestricted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートの名称を更新する
         * @param {string} reportId 
         * @param {UpdateReportNameBody} updateReportNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportName(reportId: string, updateReportNameBody: UpdateReportNameBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportName(reportId, updateReportNameBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportControllerApi.updateReportName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportControllerApi - factory interface
 */
export const ReportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary レポートをコピーする
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyReport(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportView> {
            return localVarFp.copyReport(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートを新規作成する
         * @param {CreateReportBody} createReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(createReportBody: CreateReportBody, options?: RawAxiosRequestConfig): AxiosPromise<ReportView> {
            return localVarFp.createReport(createReportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートをテンプレートを元に新規作成する
         * @param {CreateReportFromTemplateBody} createReportFromTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportFromTemplate(createReportFromTemplateBody: CreateReportFromTemplateBody, options?: RawAxiosRequestConfig): AxiosPromise<ReportView> {
            return localVarFp.createReportFromTemplate(createReportFromTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートを削除する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReport(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteReport(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グラフ新規作成時のデフォルトvisibleIdsを取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphDefaultVisibleIds(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<GraphDefaultVisibleIds> {
            return localVarFp.getGraphDefaultVisibleIds(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートを取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportView> {
            return localVarFp.getReport(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ウォーターフォールグラフの初期値を取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterfallInitialValues(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<WaterfallInitialValuesResult> {
            return localVarFp.getWaterfallInitialValues(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポート概要を一括取得する（チャットツール向けに軽量化したレスポンス）
         * @param {ListReportBriefsRequestBody} listReportBriefsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportBriefs(listReportBriefsRequestBody: ListReportBriefsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ListReportBriefsReturn> {
            return localVarFp.listReportBriefs(listReportBriefsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートの利用先ダッシュボード一覧取得
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportDashboardUsages(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportDashboardUsagesView> {
            return localVarFp.listReportDashboardUsages(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートを指定したフォルダへ移動する
         * @param {string} reportId 
         * @param {MoveReportBody} moveReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveReport(reportId: string, moveReportBody: MoveReportBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveReport(reportId, moveReportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 選択された複数のレポート・フォルダを指定したフォルダへ移動する
         * @param {MoveReportsBody} moveReportsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveReports(moveReportsBody: MoveReportsBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveReports(moveReportsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BSレポートの条件を更新する
         * @param {string} reportId 
         * @param {UpdateBSReportConditionBody} updateBSReportConditionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBSReportCondition(reportId: string, updateBSReportConditionBody: UpdateBSReportConditionBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateBSReportCondition(reportId, updateBSReportConditionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CFレポートの条件を更新する
         * @param {string} reportId 
         * @param {UpdateCFReportConditionBody} updateCFReportConditionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCFReportCondition(reportId: string, updateCFReportConditionBody: UpdateCFReportConditionBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCFReportCondition(reportId, updateCFReportConditionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PLレポートの条件を更新する
         * @param {string} reportId 
         * @param {UpdateReportConditionBody} updateReportConditionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportCondition(reportId: string, updateReportConditionBody: UpdateReportConditionBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateReportCondition(reportId, updateReportConditionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートの編集制限を更新する
         * @param {string} reportId 
         * @param {UpdateReportEditRestrictedBody} updateReportEditRestrictedBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportEditRestricted(reportId: string, updateReportEditRestrictedBody: UpdateReportEditRestrictedBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateReportEditRestricted(reportId, updateReportEditRestrictedBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートの名称を更新する
         * @param {string} reportId 
         * @param {UpdateReportNameBody} updateReportNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportName(reportId: string, updateReportNameBody: UpdateReportNameBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateReportName(reportId, updateReportNameBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportControllerApi - object-oriented interface
 */
export class ReportControllerApi extends BaseAPI {
    /**
     * 
     * @summary レポートをコピーする
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyReport(reportId: string, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).copyReport(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートを新規作成する
     * @param {CreateReportBody} createReportBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createReport(createReportBody: CreateReportBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).createReport(createReportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートをテンプレートを元に新規作成する
     * @param {CreateReportFromTemplateBody} createReportFromTemplateBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createReportFromTemplate(createReportFromTemplateBody: CreateReportFromTemplateBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).createReportFromTemplate(createReportFromTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートを削除する
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteReport(reportId: string, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).deleteReport(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グラフ新規作成時のデフォルトvisibleIdsを取得する
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGraphDefaultVisibleIds(reportId: string, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).getGraphDefaultVisibleIds(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートを取得する
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReport(reportId: string, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).getReport(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ウォーターフォールグラフの初期値を取得する
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWaterfallInitialValues(reportId: string, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).getWaterfallInitialValues(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポート概要を一括取得する（チャットツール向けに軽量化したレスポンス）
     * @param {ListReportBriefsRequestBody} listReportBriefsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listReportBriefs(listReportBriefsRequestBody: ListReportBriefsRequestBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).listReportBriefs(listReportBriefsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートの利用先ダッシュボード一覧取得
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listReportDashboardUsages(reportId: string, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).listReportDashboardUsages(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートを指定したフォルダへ移動する
     * @param {string} reportId 
     * @param {MoveReportBody} moveReportBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveReport(reportId: string, moveReportBody: MoveReportBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).moveReport(reportId, moveReportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 選択された複数のレポート・フォルダを指定したフォルダへ移動する
     * @param {MoveReportsBody} moveReportsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveReports(moveReportsBody: MoveReportsBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).moveReports(moveReportsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BSレポートの条件を更新する
     * @param {string} reportId 
     * @param {UpdateBSReportConditionBody} updateBSReportConditionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateBSReportCondition(reportId: string, updateBSReportConditionBody: UpdateBSReportConditionBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).updateBSReportCondition(reportId, updateBSReportConditionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CFレポートの条件を更新する
     * @param {string} reportId 
     * @param {UpdateCFReportConditionBody} updateCFReportConditionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCFReportCondition(reportId: string, updateCFReportConditionBody: UpdateCFReportConditionBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).updateCFReportCondition(reportId, updateCFReportConditionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PLレポートの条件を更新する
     * @param {string} reportId 
     * @param {UpdateReportConditionBody} updateReportConditionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateReportCondition(reportId: string, updateReportConditionBody: UpdateReportConditionBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).updateReportCondition(reportId, updateReportConditionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートの編集制限を更新する
     * @param {string} reportId 
     * @param {UpdateReportEditRestrictedBody} updateReportEditRestrictedBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateReportEditRestricted(reportId: string, updateReportEditRestrictedBody: UpdateReportEditRestrictedBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).updateReportEditRestricted(reportId, updateReportEditRestrictedBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートの名称を更新する
     * @param {string} reportId 
     * @param {UpdateReportNameBody} updateReportNameBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateReportName(reportId: string, updateReportNameBody: UpdateReportNameBody, options?: RawAxiosRequestConfig) {
        return ReportControllerApiFp(this.configuration).updateReportName(reportId, updateReportNameBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportDescriptionControllerApi - axios parameter creator
 */
export const ReportDescriptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary レポート備考を新規作成する
         * @param {string} reportId 
         * @param {CreateReportDescriptionBody} createReportDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportDescription: async (reportId: string, createReportDescriptionBody: CreateReportDescriptionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('createReportDescription', 'reportId', reportId)
            // verify required parameter 'createReportDescriptionBody' is not null or undefined
            assertParamExists('createReportDescription', 'createReportDescriptionBody', createReportDescriptionBody)
            const localVarPath = `/api/reports/{reportId}/description`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReportDescriptionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポート備考を編集する
         * @param {string} reportId 
         * @param {EditReportDescriptionBody} editReportDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReportDescription: async (reportId: string, editReportDescriptionBody: EditReportDescriptionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('editReportDescription', 'reportId', reportId)
            // verify required parameter 'editReportDescriptionBody' is not null or undefined
            assertParamExists('editReportDescription', 'editReportDescriptionBody', editReportDescriptionBody)
            const localVarPath = `/api/reports/{reportId}/description`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editReportDescriptionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポート備考を取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReportDescription: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('findReportDescription', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}/description`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportDescriptionControllerApi - functional programming interface
 */
export const ReportDescriptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportDescriptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary レポート備考を新規作成する
         * @param {string} reportId 
         * @param {CreateReportDescriptionBody} createReportDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportDescription(reportId: string, createReportDescriptionBody: CreateReportDescriptionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportDescription(reportId, createReportDescriptionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportDescriptionControllerApi.createReportDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポート備考を編集する
         * @param {string} reportId 
         * @param {EditReportDescriptionBody} editReportDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editReportDescription(reportId: string, editReportDescriptionBody: EditReportDescriptionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editReportDescription(reportId, editReportDescriptionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportDescriptionControllerApi.editReportDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポート備考を取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReportDescription(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDescriptionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findReportDescription(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportDescriptionControllerApi.findReportDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportDescriptionControllerApi - factory interface
 */
export const ReportDescriptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportDescriptionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary レポート備考を新規作成する
         * @param {string} reportId 
         * @param {CreateReportDescriptionBody} createReportDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportDescription(reportId: string, createReportDescriptionBody: CreateReportDescriptionBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createReportDescription(reportId, createReportDescriptionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポート備考を編集する
         * @param {string} reportId 
         * @param {EditReportDescriptionBody} editReportDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editReportDescription(reportId: string, editReportDescriptionBody: EditReportDescriptionBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.editReportDescription(reportId, editReportDescriptionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポート備考を取得する
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReportDescription(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportDescriptionView> {
            return localVarFp.findReportDescription(reportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportDescriptionControllerApi - object-oriented interface
 */
export class ReportDescriptionControllerApi extends BaseAPI {
    /**
     * 
     * @summary レポート備考を新規作成する
     * @param {string} reportId 
     * @param {CreateReportDescriptionBody} createReportDescriptionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createReportDescription(reportId: string, createReportDescriptionBody: CreateReportDescriptionBody, options?: RawAxiosRequestConfig) {
        return ReportDescriptionControllerApiFp(this.configuration).createReportDescription(reportId, createReportDescriptionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポート備考を編集する
     * @param {string} reportId 
     * @param {EditReportDescriptionBody} editReportDescriptionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editReportDescription(reportId: string, editReportDescriptionBody: EditReportDescriptionBody, options?: RawAxiosRequestConfig) {
        return ReportDescriptionControllerApiFp(this.configuration).editReportDescription(reportId, editReportDescriptionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポート備考を取得する
     * @param {string} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findReportDescription(reportId: string, options?: RawAxiosRequestConfig) {
        return ReportDescriptionControllerApiFp(this.configuration).findReportDescription(reportId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportFolderControllerApi - axios parameter creator
 */
export const ReportFolderControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary フォルダを新規作成する
         * @param {CreateReportFolderBody} createReportFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportFolder: async (createReportFolderBody: CreateReportFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReportFolderBody' is not null or undefined
            assertParamExists('createReportFolder', 'createReportFolderBody', createReportFolderBody)
            const localVarPath = `/api/report_folder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReportFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダを削除する
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteReportFolder', 'folderId', folderId)
            const localVarPath = `/api/report_folder/{folderId}`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダ内のフォルダ・レポート一覧を取得する
         * @param {string} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderDetail: async (folderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report_folder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダ情報一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderTreeForSelection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report_folder/for-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PLレポート一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlReports: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report_folder/reports/pl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダを指定したフォルダへ移動する
         * @param {string} folderId 
         * @param {MoveReportFolderBody} moveReportFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveReportFolder: async (folderId: string, moveReportFolderBody: MoveReportFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('moveReportFolder', 'folderId', folderId)
            // verify required parameter 'moveReportFolderBody' is not null or undefined
            assertParamExists('moveReportFolder', 'moveReportFolderBody', moveReportFolderBody)
            const localVarPath = `/api/report_folder/{folderId}/move`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveReportFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダの名称を更新する
         * @param {string} folderId 
         * @param {RenameReportFolderBody} renameReportFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameReportFolder: async (folderId: string, renameReportFolderBody: RenameReportFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('renameReportFolder', 'folderId', folderId)
            // verify required parameter 'renameReportFolderBody' is not null or undefined
            assertParamExists('renameReportFolder', 'renameReportFolderBody', renameReportFolderBody)
            const localVarPath = `/api/report_folder/{folderId}/name`
                .replace('{folderId}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameReportFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary フォルダ・レポートを検索する
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFolderDetail: async (searchWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report_folder/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportFolderControllerApi - functional programming interface
 */
export const ReportFolderControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportFolderControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary フォルダを新規作成する
         * @param {CreateReportFolderBody} createReportFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportFolder(createReportFolderBody: CreateReportFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportFolder(createReportFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportFolderControllerApi.createReportFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダを削除する
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReportFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReportFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportFolderControllerApi.deleteReportFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダ内のフォルダ・レポート一覧を取得する
         * @param {string} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFolderDetail(folderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportFolderDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFolderDetail(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportFolderControllerApi.getFolderDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダ情報一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFolderTreeForSelection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportFolderTreeForSelectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFolderTreeForSelection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportFolderControllerApi.getFolderTreeForSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary PLレポート一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlReports(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlReports(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportFolderControllerApi.listPlReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダを指定したフォルダへ移動する
         * @param {string} folderId 
         * @param {MoveReportFolderBody} moveReportFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveReportFolder(folderId: string, moveReportFolderBody: MoveReportFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveReportFolder(folderId, moveReportFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportFolderControllerApi.moveReportFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダの名称を更新する
         * @param {string} folderId 
         * @param {RenameReportFolderBody} renameReportFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameReportFolder(folderId: string, renameReportFolderBody: RenameReportFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameReportFolder(folderId, renameReportFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportFolderControllerApi.renameReportFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary フォルダ・レポートを検索する
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFolderDetail(searchWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportFolderDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFolderDetail(searchWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportFolderControllerApi.searchFolderDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportFolderControllerApi - factory interface
 */
export const ReportFolderControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportFolderControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary フォルダを新規作成する
         * @param {CreateReportFolderBody} createReportFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportFolder(createReportFolderBody: CreateReportFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createReportFolder(createReportFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダを削除する
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportFolder(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteReportFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダ内のフォルダ・レポート一覧を取得する
         * @param {string} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderDetail(folderId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportFolderDetailView> {
            return localVarFp.getFolderDetail(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダ情報一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderTreeForSelection(options?: RawAxiosRequestConfig): AxiosPromise<ReportFolderTreeForSelectionView> {
            return localVarFp.getFolderTreeForSelection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PLレポート一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlReports(options?: RawAxiosRequestConfig): AxiosPromise<ReportListView> {
            return localVarFp.listPlReports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダを指定したフォルダへ移動する
         * @param {string} folderId 
         * @param {MoveReportFolderBody} moveReportFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveReportFolder(folderId: string, moveReportFolderBody: MoveReportFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.moveReportFolder(folderId, moveReportFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダの名称を更新する
         * @param {string} folderId 
         * @param {RenameReportFolderBody} renameReportFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameReportFolder(folderId: string, renameReportFolderBody: RenameReportFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.renameReportFolder(folderId, renameReportFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary フォルダ・レポートを検索する
         * @param {string} [searchWord] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFolderDetail(searchWord?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportFolderDetailView> {
            return localVarFp.searchFolderDetail(searchWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportFolderControllerApi - object-oriented interface
 */
export class ReportFolderControllerApi extends BaseAPI {
    /**
     * 
     * @summary フォルダを新規作成する
     * @param {CreateReportFolderBody} createReportFolderBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createReportFolder(createReportFolderBody: CreateReportFolderBody, options?: RawAxiosRequestConfig) {
        return ReportFolderControllerApiFp(this.configuration).createReportFolder(createReportFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダを削除する
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteReportFolder(folderId: string, options?: RawAxiosRequestConfig) {
        return ReportFolderControllerApiFp(this.configuration).deleteReportFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダ内のフォルダ・レポート一覧を取得する
     * @param {string} [folderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFolderDetail(folderId?: string, options?: RawAxiosRequestConfig) {
        return ReportFolderControllerApiFp(this.configuration).getFolderDetail(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダ情報一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFolderTreeForSelection(options?: RawAxiosRequestConfig) {
        return ReportFolderControllerApiFp(this.configuration).getFolderTreeForSelection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PLレポート一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlReports(options?: RawAxiosRequestConfig) {
        return ReportFolderControllerApiFp(this.configuration).listPlReports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダを指定したフォルダへ移動する
     * @param {string} folderId 
     * @param {MoveReportFolderBody} moveReportFolderBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveReportFolder(folderId: string, moveReportFolderBody: MoveReportFolderBody, options?: RawAxiosRequestConfig) {
        return ReportFolderControllerApiFp(this.configuration).moveReportFolder(folderId, moveReportFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダの名称を更新する
     * @param {string} folderId 
     * @param {RenameReportFolderBody} renameReportFolderBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public renameReportFolder(folderId: string, renameReportFolderBody: RenameReportFolderBody, options?: RawAxiosRequestConfig) {
        return ReportFolderControllerApiFp(this.configuration).renameReportFolder(folderId, renameReportFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary フォルダ・レポートを検索する
     * @param {string} [searchWord] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchFolderDetail(searchWord?: string, options?: RawAxiosRequestConfig) {
        return ReportFolderControllerApiFp(this.configuration).searchFolderDetail(searchWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportGraphControllerApi - axios parameter creator
 */
export const ReportGraphControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary グラフをコピー
         * @param {string} graphId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyGraph: async (graphId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('copyGraph', 'graphId', graphId)
            const localVarPath = `/api/report_graphs/{graphId}/copy`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グラフ作成
         * @param {CreateGraphRequestBody} createGraphRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGraph: async (createGraphRequestBody: CreateGraphRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGraphRequestBody' is not null or undefined
            assertParamExists('createGraph', 'createGraphRequestBody', createGraphRequestBody)
            const localVarPath = `/api/report_graphs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGraphRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グラフ削除
         * @param {string} graphId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGraph: async (graphId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('deleteGraph', 'graphId', graphId)
            const localVarPath = `/api/report_graphs/{graphId}`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グラフ詳細取得
         * @param {string} graphId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraph: async (graphId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('getGraph', 'graphId', graphId)
            const localVarPath = `/api/report_graphs/{graphId}`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートの複合グラフ描画用データを取得
         * @param {FetchComboChartDataRequestBody} fetchComboChartDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportComboChartData: async (fetchComboChartDataRequestBody: FetchComboChartDataRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchComboChartDataRequestBody' is not null or undefined
            assertParamExists('getReportComboChartData', 'fetchComboChartDataRequestBody', fetchComboChartDataRequestBody)
            const localVarPath = `/api/report_graphs/combo-chart-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchComboChartDataRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートのグラフ描画用データを取得
         * @param {FetchGraphDataRequestBody} fetchGraphDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportGraphData: async (fetchGraphDataRequestBody: FetchGraphDataRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchGraphDataRequestBody' is not null or undefined
            assertParamExists('getReportGraphData', 'fetchGraphDataRequestBody', fetchGraphDataRequestBody)
            const localVarPath = `/api/report_graphs/graph-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchGraphDataRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ウォーターフォール選択可能科目取得
         * @param {string} reportId 
         * @param {string} startAccountId 
         * @param {string} [endAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterfallSelectableAccounts: async (reportId: string, startAccountId: string, endAccountId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getWaterfallSelectableAccounts', 'reportId', reportId)
            // verify required parameter 'startAccountId' is not null or undefined
            assertParamExists('getWaterfallSelectableAccounts', 'startAccountId', startAccountId)
            const localVarPath = `/api/report_graphs/waterfall/selectable-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (reportId !== undefined) {
                localVarQueryParameter['reportId'] = reportId;
            }

            if (startAccountId !== undefined) {
                localVarQueryParameter['startAccountId'] = startAccountId;
            }

            if (endAccountId !== undefined) {
                localVarQueryParameter['endAccountId'] = endAccountId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グラフ一覧取得
         * @param {string} [reportId] 
         * @param {ListGraphsGraphTypeEnum} [graphType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGraphs: async (reportId?: string, graphType?: ListGraphsGraphTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report_graphs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (reportId !== undefined) {
                localVarQueryParameter['reportId'] = reportId;
            }

            if (graphType !== undefined) {
                localVarQueryParameter['graphType'] = graphType;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 複合グラフIDから複合グラフ描画用データを取得（ボードフィルタ対応）
         * @param {string} graphId 
         * @param {GetComboChartDataBody} [getComboChartDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComboChartDataByGraphId: async (graphId: string, getComboChartDataBody?: GetComboChartDataBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('postComboChartDataByGraphId', 'graphId', graphId)
            const localVarPath = `/api/report_graphs/{graphId}/combo-chart-data`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getComboChartDataBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 保存済み対比型ウォーターフォールグラフのデータを取得
         * @param {string} graphId 
         * @param {GetWaterfallDataBody} [getWaterfallDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComparisonWaterfallDataByGraphId: async (graphId: string, getWaterfallDataBody?: GetWaterfallDataBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('postComparisonWaterfallDataByGraphId', 'graphId', graphId)
            const localVarPath = `/api/report_graphs/{graphId}/comparison-waterfall-data`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getWaterfallDataBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比型ウォーターフォール 初期値取得
         * @param {GetComparisonWaterfallInitialValuesBody} getComparisonWaterfallInitialValuesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComparisonWaterfallInitialValues: async (getComparisonWaterfallInitialValuesBody: GetComparisonWaterfallInitialValuesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getComparisonWaterfallInitialValuesBody' is not null or undefined
            assertParamExists('postComparisonWaterfallInitialValues', 'getComparisonWaterfallInitialValuesBody', getComparisonWaterfallInitialValuesBody)
            const localVarPath = `/api/report_graphs/waterfall/comparison/initial-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getComparisonWaterfallInitialValuesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比型ウォーターフォール 選択可能な列グループ取得
         * @param {GetComparisonWaterfallPeriodColumnGroupsBody} getComparisonWaterfallPeriodColumnGroupsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComparisonWaterfallPeriodColumnGroups: async (getComparisonWaterfallPeriodColumnGroupsBody: GetComparisonWaterfallPeriodColumnGroupsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getComparisonWaterfallPeriodColumnGroupsBody' is not null or undefined
            assertParamExists('postComparisonWaterfallPeriodColumnGroups', 'getComparisonWaterfallPeriodColumnGroupsBody', getComparisonWaterfallPeriodColumnGroupsBody)
            const localVarPath = `/api/report_graphs/waterfall/comparison/period-column-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getComparisonWaterfallPeriodColumnGroupsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対比型ウォーターフォールグラフプレビューデータ取得
         * @param {ComparisonWaterfallPreviewRequest} comparisonWaterfallPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComparisonWaterfallPreview: async (comparisonWaterfallPreviewRequest: ComparisonWaterfallPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'comparisonWaterfallPreviewRequest' is not null or undefined
            assertParamExists('postComparisonWaterfallPreview', 'comparisonWaterfallPreviewRequest', comparisonWaterfallPreviewRequest)
            const localVarPath = `/api/report_graphs/waterfall/comparison/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comparisonWaterfallPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グラフIDからグラフ描画用データを取得（ボードフィルタ対応）
         * @param {string} graphId 
         * @param {GetGraphDataBody} [getGraphDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGraphDataByGraphId: async (graphId: string, getGraphDataBody?: GetGraphDataBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('postGraphDataByGraphId', 'graphId', graphId)
            const localVarPath = `/api/report_graphs/{graphId}/graph-data`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getGraphDataBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary KPIカードデータ取得（ボードフィルタ対応）
         * @param {string} graphId 
         * @param {GetKpiCardDataBody} [getKpiCardDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKpiCardData: async (graphId: string, getKpiCardDataBody?: GetKpiCardDataBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('postKpiCardData', 'graphId', graphId)
            const localVarPath = `/api/report_graphs/{graphId}/kpi-card-data`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getKpiCardDataBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary KPIカードプレビューデータ取得
         * @param {BySpec} bySpec 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKpiCardPreview: async (bySpec: BySpec, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bySpec' is not null or undefined
            assertParamExists('postKpiCardPreview', 'bySpec', bySpec)
            const localVarPath = `/api/report_graphs/kpi-card-data/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bySpec, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 保存済み円グラフのデータを取得
         * @param {string} graphId 
         * @param {GetPieChartDataBody} [getPieChartDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPieChartDataByGraphId: async (graphId: string, getPieChartDataBody?: GetPieChartDataBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('postPieChartDataByGraphId', 'graphId', graphId)
            const localVarPath = `/api/report_graphs/{graphId}/pie-chart-data`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPieChartDataBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 円グラフプレビューデータ取得
         * @param {FetchPieChartDataRequestBody} fetchPieChartDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPieChartPreview: async (fetchPieChartDataRequestBody: FetchPieChartDataRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchPieChartDataRequestBody' is not null or undefined
            assertParamExists('postPieChartPreview', 'fetchPieChartDataRequestBody', fetchPieChartDataRequestBody)
            const localVarPath = `/api/report_graphs/pie-chart/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchPieChartDataRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 保存済みウォーターフォールグラフのデータを取得
         * @param {string} graphId 
         * @param {GetWaterfallDataBody} [getWaterfallDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWaterfallDataByGraphId: async (graphId: string, getWaterfallDataBody?: GetWaterfallDataBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('postWaterfallDataByGraphId', 'graphId', graphId)
            const localVarPath = `/api/report_graphs/{graphId}/waterfall-data`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getWaterfallDataBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 推移型ウォーターフォールグラフプレビューデータ取得
         * @param {WaterfallPreviewRequest} waterfallPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWaterfallPreview: async (waterfallPreviewRequest: WaterfallPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterfallPreviewRequest' is not null or undefined
            assertParamExists('postWaterfallPreview', 'waterfallPreviewRequest', waterfallPreviewRequest)
            const localVarPath = `/api/report_graphs/waterfall/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waterfallPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グラフの並び替え
         * @param {ReorderGraphsRequestBody} reorderGraphsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderGraphs: async (reorderGraphsRequestBody: ReorderGraphsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reorderGraphsRequestBody' is not null or undefined
            assertParamExists('reorderGraphs', 'reorderGraphsRequestBody', reorderGraphsRequestBody)
            const localVarPath = `/api/report_graphs/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderGraphsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グラフ更新
         * @param {string} graphId 
         * @param {UpdateGraphRequestBody} updateGraphRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGraph: async (graphId: string, updateGraphRequestBody: UpdateGraphRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('updateGraph', 'graphId', graphId)
            // verify required parameter 'updateGraphRequestBody' is not null or undefined
            assertParamExists('updateGraph', 'updateGraphRequestBody', updateGraphRequestBody)
            const localVarPath = `/api/report_graphs/{graphId}`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGraphRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary グラフタイトル更新
         * @param {string} graphId 
         * @param {UpdateGraphTitleRequestBody} updateGraphTitleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGraphTitle: async (graphId: string, updateGraphTitleRequestBody: UpdateGraphTitleRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'graphId' is not null or undefined
            assertParamExists('updateGraphTitle', 'graphId', graphId)
            // verify required parameter 'updateGraphTitleRequestBody' is not null or undefined
            assertParamExists('updateGraphTitle', 'updateGraphTitleRequestBody', updateGraphTitleRequestBody)
            const localVarPath = `/api/report_graphs/{graphId}/title`
                .replace('{graphId}', encodeURIComponent(String(graphId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGraphTitleRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportGraphControllerApi - functional programming interface
 */
export const ReportGraphControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportGraphControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary グラフをコピー
         * @param {string} graphId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyGraph(graphId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopiedGraphDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyGraph(graphId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.copyGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グラフ作成
         * @param {CreateGraphRequestBody} createGraphRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGraph(createGraphRequestBody: CreateGraphRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedGraphDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGraph(createGraphRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.createGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グラフ削除
         * @param {string} graphId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGraph(graphId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGraph(graphId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.deleteGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グラフ詳細取得
         * @param {string} graphId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraph(graphId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportGraphView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraph(graphId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.getGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートの複合グラフ描画用データを取得
         * @param {FetchComboChartDataRequestBody} fetchComboChartDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportComboChartData(fetchComboChartDataRequestBody: FetchComboChartDataRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComboChartDataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportComboChartData(fetchComboChartDataRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.getReportComboChartData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートのグラフ描画用データを取得
         * @param {FetchGraphDataRequestBody} fetchGraphDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportGraphData(fetchGraphDataRequestBody: FetchGraphDataRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphDataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportGraphData(fetchGraphDataRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.getReportGraphData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ウォーターフォール選択可能科目取得
         * @param {string} reportId 
         * @param {string} startAccountId 
         * @param {string} [endAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterfallSelectableAccounts(reportId: string, startAccountId: string, endAccountId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterfallSelectableAccountsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterfallSelectableAccounts(reportId, startAccountId, endAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.getWaterfallSelectableAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グラフ一覧取得
         * @param {string} [reportId] 
         * @param {ListGraphsGraphTypeEnum} [graphType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGraphs(reportId?: string, graphType?: ListGraphsGraphTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportGraphView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGraphs(reportId, graphType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.listGraphs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 複合グラフIDから複合グラフ描画用データを取得（ボードフィルタ対応）
         * @param {string} graphId 
         * @param {GetComboChartDataBody} [getComboChartDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postComboChartDataByGraphId(graphId: string, getComboChartDataBody?: GetComboChartDataBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComboChartDataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postComboChartDataByGraphId(graphId, getComboChartDataBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postComboChartDataByGraphId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 保存済み対比型ウォーターフォールグラフのデータを取得
         * @param {string} graphId 
         * @param {GetWaterfallDataBody} [getWaterfallDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postComparisonWaterfallDataByGraphId(graphId: string, getWaterfallDataBody?: GetWaterfallDataBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonWaterfallPreviewResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postComparisonWaterfallDataByGraphId(graphId, getWaterfallDataBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postComparisonWaterfallDataByGraphId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比型ウォーターフォール 初期値取得
         * @param {GetComparisonWaterfallInitialValuesBody} getComparisonWaterfallInitialValuesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postComparisonWaterfallInitialValues(getComparisonWaterfallInitialValuesBody: GetComparisonWaterfallInitialValuesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonWaterfallInitialValuesResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postComparisonWaterfallInitialValues(getComparisonWaterfallInitialValuesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postComparisonWaterfallInitialValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比型ウォーターフォール 選択可能な列グループ取得
         * @param {GetComparisonWaterfallPeriodColumnGroupsBody} getComparisonWaterfallPeriodColumnGroupsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postComparisonWaterfallPeriodColumnGroups(getComparisonWaterfallPeriodColumnGroupsBody: GetComparisonWaterfallPeriodColumnGroupsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PeriodColumnGroup>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postComparisonWaterfallPeriodColumnGroups(getComparisonWaterfallPeriodColumnGroupsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postComparisonWaterfallPeriodColumnGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対比型ウォーターフォールグラフプレビューデータ取得
         * @param {ComparisonWaterfallPreviewRequest} comparisonWaterfallPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postComparisonWaterfallPreview(comparisonWaterfallPreviewRequest: ComparisonWaterfallPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComparisonWaterfallPreviewResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postComparisonWaterfallPreview(comparisonWaterfallPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postComparisonWaterfallPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グラフIDからグラフ描画用データを取得（ボードフィルタ対応）
         * @param {string} graphId 
         * @param {GetGraphDataBody} [getGraphDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postGraphDataByGraphId(graphId: string, getGraphDataBody?: GetGraphDataBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GraphDataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postGraphDataByGraphId(graphId, getGraphDataBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postGraphDataByGraphId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary KPIカードデータ取得（ボードフィルタ対応）
         * @param {string} graphId 
         * @param {GetKpiCardDataBody} [getKpiCardDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postKpiCardData(graphId: string, getKpiCardDataBody?: GetKpiCardDataBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postKpiCardData(graphId, getKpiCardDataBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postKpiCardData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary KPIカードプレビューデータ取得
         * @param {BySpec} bySpec 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postKpiCardPreview(bySpec: BySpec, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<View>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postKpiCardPreview(bySpec, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postKpiCardPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 保存済み円グラフのデータを取得
         * @param {string} graphId 
         * @param {GetPieChartDataBody} [getPieChartDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPieChartDataByGraphId(graphId: string, getPieChartDataBody?: GetPieChartDataBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieChartDataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPieChartDataByGraphId(graphId, getPieChartDataBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postPieChartDataByGraphId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 円グラフプレビューデータ取得
         * @param {FetchPieChartDataRequestBody} fetchPieChartDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPieChartPreview(fetchPieChartDataRequestBody: FetchPieChartDataRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PieChartDataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPieChartPreview(fetchPieChartDataRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postPieChartPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 保存済みウォーターフォールグラフのデータを取得
         * @param {string} graphId 
         * @param {GetWaterfallDataBody} [getWaterfallDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postWaterfallDataByGraphId(graphId: string, getWaterfallDataBody?: GetWaterfallDataBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterfallDataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postWaterfallDataByGraphId(graphId, getWaterfallDataBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postWaterfallDataByGraphId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 推移型ウォーターフォールグラフプレビューデータ取得
         * @param {WaterfallPreviewRequest} waterfallPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postWaterfallPreview(waterfallPreviewRequest: WaterfallPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterfallDataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postWaterfallPreview(waterfallPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.postWaterfallPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グラフの並び替え
         * @param {ReorderGraphsRequestBody} reorderGraphsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderGraphs(reorderGraphsRequestBody: ReorderGraphsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderGraphs(reorderGraphsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.reorderGraphs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グラフ更新
         * @param {string} graphId 
         * @param {UpdateGraphRequestBody} updateGraphRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGraph(graphId: string, updateGraphRequestBody: UpdateGraphRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGraph(graphId, updateGraphRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.updateGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary グラフタイトル更新
         * @param {string} graphId 
         * @param {UpdateGraphTitleRequestBody} updateGraphTitleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGraphTitle(graphId: string, updateGraphTitleRequestBody: UpdateGraphTitleRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGraphTitle(graphId, updateGraphTitleRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportGraphControllerApi.updateGraphTitle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportGraphControllerApi - factory interface
 */
export const ReportGraphControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportGraphControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary グラフをコピー
         * @param {string} graphId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyGraph(graphId: string, options?: RawAxiosRequestConfig): AxiosPromise<CopiedGraphDto> {
            return localVarFp.copyGraph(graphId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グラフ作成
         * @param {CreateGraphRequestBody} createGraphRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGraph(createGraphRequestBody: CreateGraphRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreatedGraphDto> {
            return localVarFp.createGraph(createGraphRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グラフ削除
         * @param {string} graphId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGraph(graphId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteGraph(graphId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グラフ詳細取得
         * @param {string} graphId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraph(graphId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportGraphView> {
            return localVarFp.getGraph(graphId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートの複合グラフ描画用データを取得
         * @param {FetchComboChartDataRequestBody} fetchComboChartDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportComboChartData(fetchComboChartDataRequestBody: FetchComboChartDataRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ComboChartDataView> {
            return localVarFp.getReportComboChartData(fetchComboChartDataRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートのグラフ描画用データを取得
         * @param {FetchGraphDataRequestBody} fetchGraphDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportGraphData(fetchGraphDataRequestBody: FetchGraphDataRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<GraphDataView> {
            return localVarFp.getReportGraphData(fetchGraphDataRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ウォーターフォール選択可能科目取得
         * @param {string} reportId 
         * @param {string} startAccountId 
         * @param {string} [endAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterfallSelectableAccounts(reportId: string, startAccountId: string, endAccountId?: string, options?: RawAxiosRequestConfig): AxiosPromise<WaterfallSelectableAccountsResult> {
            return localVarFp.getWaterfallSelectableAccounts(reportId, startAccountId, endAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グラフ一覧取得
         * @param {string} [reportId] 
         * @param {ListGraphsGraphTypeEnum} [graphType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGraphs(reportId?: string, graphType?: ListGraphsGraphTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportGraphView>> {
            return localVarFp.listGraphs(reportId, graphType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 複合グラフIDから複合グラフ描画用データを取得（ボードフィルタ対応）
         * @param {string} graphId 
         * @param {GetComboChartDataBody} [getComboChartDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComboChartDataByGraphId(graphId: string, getComboChartDataBody?: GetComboChartDataBody, options?: RawAxiosRequestConfig): AxiosPromise<ComboChartDataView> {
            return localVarFp.postComboChartDataByGraphId(graphId, getComboChartDataBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 保存済み対比型ウォーターフォールグラフのデータを取得
         * @param {string} graphId 
         * @param {GetWaterfallDataBody} [getWaterfallDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComparisonWaterfallDataByGraphId(graphId: string, getWaterfallDataBody?: GetWaterfallDataBody, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonWaterfallPreviewResult> {
            return localVarFp.postComparisonWaterfallDataByGraphId(graphId, getWaterfallDataBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比型ウォーターフォール 初期値取得
         * @param {GetComparisonWaterfallInitialValuesBody} getComparisonWaterfallInitialValuesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComparisonWaterfallInitialValues(getComparisonWaterfallInitialValuesBody: GetComparisonWaterfallInitialValuesBody, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonWaterfallInitialValuesResult> {
            return localVarFp.postComparisonWaterfallInitialValues(getComparisonWaterfallInitialValuesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比型ウォーターフォール 選択可能な列グループ取得
         * @param {GetComparisonWaterfallPeriodColumnGroupsBody} getComparisonWaterfallPeriodColumnGroupsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComparisonWaterfallPeriodColumnGroups(getComparisonWaterfallPeriodColumnGroupsBody: GetComparisonWaterfallPeriodColumnGroupsBody, options?: RawAxiosRequestConfig): AxiosPromise<Array<PeriodColumnGroup>> {
            return localVarFp.postComparisonWaterfallPeriodColumnGroups(getComparisonWaterfallPeriodColumnGroupsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対比型ウォーターフォールグラフプレビューデータ取得
         * @param {ComparisonWaterfallPreviewRequest} comparisonWaterfallPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postComparisonWaterfallPreview(comparisonWaterfallPreviewRequest: ComparisonWaterfallPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ComparisonWaterfallPreviewResult> {
            return localVarFp.postComparisonWaterfallPreview(comparisonWaterfallPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グラフIDからグラフ描画用データを取得（ボードフィルタ対応）
         * @param {string} graphId 
         * @param {GetGraphDataBody} [getGraphDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGraphDataByGraphId(graphId: string, getGraphDataBody?: GetGraphDataBody, options?: RawAxiosRequestConfig): AxiosPromise<GraphDataView> {
            return localVarFp.postGraphDataByGraphId(graphId, getGraphDataBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary KPIカードデータ取得（ボードフィルタ対応）
         * @param {string} graphId 
         * @param {GetKpiCardDataBody} [getKpiCardDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKpiCardData(graphId: string, getKpiCardDataBody?: GetKpiCardDataBody, options?: RawAxiosRequestConfig): AxiosPromise<View> {
            return localVarFp.postKpiCardData(graphId, getKpiCardDataBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary KPIカードプレビューデータ取得
         * @param {BySpec} bySpec 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKpiCardPreview(bySpec: BySpec, options?: RawAxiosRequestConfig): AxiosPromise<View> {
            return localVarFp.postKpiCardPreview(bySpec, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 保存済み円グラフのデータを取得
         * @param {string} graphId 
         * @param {GetPieChartDataBody} [getPieChartDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPieChartDataByGraphId(graphId: string, getPieChartDataBody?: GetPieChartDataBody, options?: RawAxiosRequestConfig): AxiosPromise<PieChartDataView> {
            return localVarFp.postPieChartDataByGraphId(graphId, getPieChartDataBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 円グラフプレビューデータ取得
         * @param {FetchPieChartDataRequestBody} fetchPieChartDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPieChartPreview(fetchPieChartDataRequestBody: FetchPieChartDataRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<PieChartDataView> {
            return localVarFp.postPieChartPreview(fetchPieChartDataRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 保存済みウォーターフォールグラフのデータを取得
         * @param {string} graphId 
         * @param {GetWaterfallDataBody} [getWaterfallDataBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWaterfallDataByGraphId(graphId: string, getWaterfallDataBody?: GetWaterfallDataBody, options?: RawAxiosRequestConfig): AxiosPromise<WaterfallDataView> {
            return localVarFp.postWaterfallDataByGraphId(graphId, getWaterfallDataBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 推移型ウォーターフォールグラフプレビューデータ取得
         * @param {WaterfallPreviewRequest} waterfallPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postWaterfallPreview(waterfallPreviewRequest: WaterfallPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<WaterfallDataView> {
            return localVarFp.postWaterfallPreview(waterfallPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グラフの並び替え
         * @param {ReorderGraphsRequestBody} reorderGraphsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderGraphs(reorderGraphsRequestBody: ReorderGraphsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderGraphs(reorderGraphsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グラフ更新
         * @param {string} graphId 
         * @param {UpdateGraphRequestBody} updateGraphRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGraph(graphId: string, updateGraphRequestBody: UpdateGraphRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateGraph(graphId, updateGraphRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary グラフタイトル更新
         * @param {string} graphId 
         * @param {UpdateGraphTitleRequestBody} updateGraphTitleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGraphTitle(graphId: string, updateGraphTitleRequestBody: UpdateGraphTitleRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateGraphTitle(graphId, updateGraphTitleRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportGraphControllerApi - object-oriented interface
 */
export class ReportGraphControllerApi extends BaseAPI {
    /**
     * 
     * @summary グラフをコピー
     * @param {string} graphId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyGraph(graphId: string, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).copyGraph(graphId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グラフ作成
     * @param {CreateGraphRequestBody} createGraphRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createGraph(createGraphRequestBody: CreateGraphRequestBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).createGraph(createGraphRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グラフ削除
     * @param {string} graphId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteGraph(graphId: string, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).deleteGraph(graphId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グラフ詳細取得
     * @param {string} graphId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGraph(graphId: string, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).getGraph(graphId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートの複合グラフ描画用データを取得
     * @param {FetchComboChartDataRequestBody} fetchComboChartDataRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportComboChartData(fetchComboChartDataRequestBody: FetchComboChartDataRequestBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).getReportComboChartData(fetchComboChartDataRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートのグラフ描画用データを取得
     * @param {FetchGraphDataRequestBody} fetchGraphDataRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportGraphData(fetchGraphDataRequestBody: FetchGraphDataRequestBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).getReportGraphData(fetchGraphDataRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ウォーターフォール選択可能科目取得
     * @param {string} reportId 
     * @param {string} startAccountId 
     * @param {string} [endAccountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWaterfallSelectableAccounts(reportId: string, startAccountId: string, endAccountId?: string, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).getWaterfallSelectableAccounts(reportId, startAccountId, endAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グラフ一覧取得
     * @param {string} [reportId] 
     * @param {ListGraphsGraphTypeEnum} [graphType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listGraphs(reportId?: string, graphType?: ListGraphsGraphTypeEnum, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).listGraphs(reportId, graphType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 複合グラフIDから複合グラフ描画用データを取得（ボードフィルタ対応）
     * @param {string} graphId 
     * @param {GetComboChartDataBody} [getComboChartDataBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postComboChartDataByGraphId(graphId: string, getComboChartDataBody?: GetComboChartDataBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postComboChartDataByGraphId(graphId, getComboChartDataBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 保存済み対比型ウォーターフォールグラフのデータを取得
     * @param {string} graphId 
     * @param {GetWaterfallDataBody} [getWaterfallDataBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postComparisonWaterfallDataByGraphId(graphId: string, getWaterfallDataBody?: GetWaterfallDataBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postComparisonWaterfallDataByGraphId(graphId, getWaterfallDataBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比型ウォーターフォール 初期値取得
     * @param {GetComparisonWaterfallInitialValuesBody} getComparisonWaterfallInitialValuesBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postComparisonWaterfallInitialValues(getComparisonWaterfallInitialValuesBody: GetComparisonWaterfallInitialValuesBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postComparisonWaterfallInitialValues(getComparisonWaterfallInitialValuesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比型ウォーターフォール 選択可能な列グループ取得
     * @param {GetComparisonWaterfallPeriodColumnGroupsBody} getComparisonWaterfallPeriodColumnGroupsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postComparisonWaterfallPeriodColumnGroups(getComparisonWaterfallPeriodColumnGroupsBody: GetComparisonWaterfallPeriodColumnGroupsBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postComparisonWaterfallPeriodColumnGroups(getComparisonWaterfallPeriodColumnGroupsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対比型ウォーターフォールグラフプレビューデータ取得
     * @param {ComparisonWaterfallPreviewRequest} comparisonWaterfallPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postComparisonWaterfallPreview(comparisonWaterfallPreviewRequest: ComparisonWaterfallPreviewRequest, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postComparisonWaterfallPreview(comparisonWaterfallPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グラフIDからグラフ描画用データを取得（ボードフィルタ対応）
     * @param {string} graphId 
     * @param {GetGraphDataBody} [getGraphDataBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postGraphDataByGraphId(graphId: string, getGraphDataBody?: GetGraphDataBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postGraphDataByGraphId(graphId, getGraphDataBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary KPIカードデータ取得（ボードフィルタ対応）
     * @param {string} graphId 
     * @param {GetKpiCardDataBody} [getKpiCardDataBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postKpiCardData(graphId: string, getKpiCardDataBody?: GetKpiCardDataBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postKpiCardData(graphId, getKpiCardDataBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary KPIカードプレビューデータ取得
     * @param {BySpec} bySpec 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postKpiCardPreview(bySpec: BySpec, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postKpiCardPreview(bySpec, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 保存済み円グラフのデータを取得
     * @param {string} graphId 
     * @param {GetPieChartDataBody} [getPieChartDataBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postPieChartDataByGraphId(graphId: string, getPieChartDataBody?: GetPieChartDataBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postPieChartDataByGraphId(graphId, getPieChartDataBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 円グラフプレビューデータ取得
     * @param {FetchPieChartDataRequestBody} fetchPieChartDataRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postPieChartPreview(fetchPieChartDataRequestBody: FetchPieChartDataRequestBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postPieChartPreview(fetchPieChartDataRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 保存済みウォーターフォールグラフのデータを取得
     * @param {string} graphId 
     * @param {GetWaterfallDataBody} [getWaterfallDataBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postWaterfallDataByGraphId(graphId: string, getWaterfallDataBody?: GetWaterfallDataBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postWaterfallDataByGraphId(graphId, getWaterfallDataBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 推移型ウォーターフォールグラフプレビューデータ取得
     * @param {WaterfallPreviewRequest} waterfallPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postWaterfallPreview(waterfallPreviewRequest: WaterfallPreviewRequest, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).postWaterfallPreview(waterfallPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グラフの並び替え
     * @param {ReorderGraphsRequestBody} reorderGraphsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reorderGraphs(reorderGraphsRequestBody: ReorderGraphsRequestBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).reorderGraphs(reorderGraphsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グラフ更新
     * @param {string} graphId 
     * @param {UpdateGraphRequestBody} updateGraphRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGraph(graphId: string, updateGraphRequestBody: UpdateGraphRequestBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).updateGraph(graphId, updateGraphRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary グラフタイトル更新
     * @param {string} graphId 
     * @param {UpdateGraphTitleRequestBody} updateGraphTitleRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGraphTitle(graphId: string, updateGraphTitleRequestBody: UpdateGraphTitleRequestBody, options?: RawAxiosRequestConfig) {
        return ReportGraphControllerApiFp(this.configuration).updateGraphTitle(graphId, updateGraphTitleRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListGraphsGraphTypeEnum = {
    Bar: 'BAR',
    HorizontalBar: 'HORIZONTAL_BAR',
    Line: 'LINE',
    Kpi: 'KPI',
    Combo: 'COMBO',
    Waterfall: 'WATERFALL',
    Pie: 'PIE',
} as const;
export type ListGraphsGraphTypeEnum = typeof ListGraphsGraphTypeEnum[keyof typeof ListGraphsGraphTypeEnum];


/**
 * ReportTableControllerApi - axios parameter creator
 */
export const ReportTableControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary レポートの明細データを指定された形式で出力開始
         * @param {string} reportId 
         * @param {GenerateReportTableDetailDownloadBody} generateReportTableDetailDownloadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReportTableDetailDownloadAsync: async (reportId: string, generateReportTableDetailDownloadBody: GenerateReportTableDetailDownloadBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('generateReportTableDetailDownloadAsync', 'reportId', reportId)
            // verify required parameter 'generateReportTableDetailDownloadBody' is not null or undefined
            assertParamExists('generateReportTableDetailDownloadAsync', 'generateReportTableDetailDownloadBody', generateReportTableDetailDownloadBody)
            const localVarPath = `/api/reports/{reportId}/table/detail/download/async`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateReportTableDetailDownloadBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BSレポートの表データをExcel形式で出力
         * @param {string} reportId 
         * @param {BSReportConditionSchema} bSReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSReportExcel: async (reportId: string, bSReportConditionSchema: BSReportConditionSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getBSReportExcel', 'reportId', reportId)
            // verify required parameter 'bSReportConditionSchema' is not null or undefined
            assertParamExists('getBSReportExcel', 'bSReportConditionSchema', bSReportConditionSchema)
            const localVarPath = `/api/reports/bs/{reportId}/table/excel`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bSReportConditionSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BSレポートの表データを取得する
         * @param {string} reportId 
         * @param {BSReportConditionSchema} bSReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSReportTable: async (reportId: string, bSReportConditionSchema: BSReportConditionSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getBSReportTable', 'reportId', reportId)
            // verify required parameter 'bSReportConditionSchema' is not null or undefined
            assertParamExists('getBSReportTable', 'bSReportConditionSchema', bSReportConditionSchema)
            const localVarPath = `/api/reports/bs/{reportId}/table`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bSReportConditionSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary BSレポートの表データをボードフィルタ適用して取得する
         * @param {string} reportId 
         * @param {GetBSReportTableWithBoardFilterBody} getBSReportTableWithBoardFilterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSReportTableWithBoardFilter: async (reportId: string, getBSReportTableWithBoardFilterBody: GetBSReportTableWithBoardFilterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getBSReportTableWithBoardFilter', 'reportId', reportId)
            // verify required parameter 'getBSReportTableWithBoardFilterBody' is not null or undefined
            assertParamExists('getBSReportTableWithBoardFilter', 'getBSReportTableWithBoardFilterBody', getBSReportTableWithBoardFilterBody)
            const localVarPath = `/api/reports/bs/{reportId}/table/with-board-filter`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBSReportTableWithBoardFilterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CFレポートの表データをExcel形式で出力
         * @param {string} reportId 
         * @param {CFReportConditionSchema} cFReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCFReportExcel: async (reportId: string, cFReportConditionSchema: CFReportConditionSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getCFReportExcel', 'reportId', reportId)
            // verify required parameter 'cFReportConditionSchema' is not null or undefined
            assertParamExists('getCFReportExcel', 'cFReportConditionSchema', cFReportConditionSchema)
            const localVarPath = `/api/reports/cf/{reportId}/table/excel`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cFReportConditionSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CFレポートの表データを取得する
         * @param {string} reportId 
         * @param {CFReportConditionSchema} cFReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCFReportTable: async (reportId: string, cFReportConditionSchema: CFReportConditionSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getCFReportTable', 'reportId', reportId)
            // verify required parameter 'cFReportConditionSchema' is not null or undefined
            assertParamExists('getCFReportTable', 'cFReportConditionSchema', cFReportConditionSchema)
            const localVarPath = `/api/reports/cf/{reportId}/table`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cFReportConditionSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CFレポートの表データをボードフィルタ適用して取得する
         * @param {string} reportId 
         * @param {GetCFReportTableWithBoardFilterBody} getCFReportTableWithBoardFilterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCFReportTableWithBoardFilter: async (reportId: string, getCFReportTableWithBoardFilterBody: GetCFReportTableWithBoardFilterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getCFReportTableWithBoardFilter', 'reportId', reportId)
            // verify required parameter 'getCFReportTableWithBoardFilterBody' is not null or undefined
            assertParamExists('getCFReportTableWithBoardFilter', 'getCFReportTableWithBoardFilterBody', getCFReportTableWithBoardFilterBody)
            const localVarPath = `/api/reports/cf/{reportId}/table/with-board-filter`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCFReportTableWithBoardFilterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 期間列情報のみを取得する（ウォーターフォールチャート用）
         * @param {string} reportId 
         * @param {GetPeriodColumnsBody} getPeriodColumnsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodColumns: async (reportId: string, getPeriodColumnsBody: GetPeriodColumnsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getPeriodColumns', 'reportId', reportId)
            // verify required parameter 'getPeriodColumnsBody' is not null or undefined
            assertParamExists('getPeriodColumns', 'getPeriodColumnsBody', getPeriodColumnsBody)
            const localVarPath = `/api/reports/{reportId}/period-columns`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPeriodColumnsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PLレポートの表データをExcel形式で出力
         * @param {string} reportId 
         * @param {PLReportConditionSchema} pLReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportExcel: async (reportId: string, pLReportConditionSchema: PLReportConditionSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReportExcel', 'reportId', reportId)
            // verify required parameter 'pLReportConditionSchema' is not null or undefined
            assertParamExists('getReportExcel', 'pLReportConditionSchema', pLReportConditionSchema)
            const localVarPath = `/api/reports/{reportId}/table/excel`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pLReportConditionSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PLレポートの表データを取得する
         * @param {string} reportId 
         * @param {PLReportConditionSchema} pLReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTable: async (reportId: string, pLReportConditionSchema: PLReportConditionSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReportTable', 'reportId', reportId)
            // verify required parameter 'pLReportConditionSchema' is not null or undefined
            assertParamExists('getReportTable', 'pLReportConditionSchema', pLReportConditionSchema)
            const localVarPath = `/api/reports/{reportId}/table`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pLReportConditionSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートの実績明細データを取得する
         * @param {string} reportId 
         * @param {GetReportTableDetailBody} getReportTableDetailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTableActualDetail: async (reportId: string, getReportTableDetailBody: GetReportTableDetailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReportTableActualDetail', 'reportId', reportId)
            // verify required parameter 'getReportTableDetailBody' is not null or undefined
            assertParamExists('getReportTableActualDetail', 'getReportTableDetailBody', getReportTableDetailBody)
            const localVarPath = `/api/reports/{reportId}/table/detail`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getReportTableDetailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートのメタデータのみを取得する（保存済み条件を使用）
         * @param {string} reportId 
         * @param {string} [periodAggregation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTableMetadata: async (reportId: string, periodAggregation?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReportTableMetadata', 'reportId', reportId)
            const localVarPath = `/api/reports/{reportId}/table/metadata`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (periodAggregation !== undefined) {
                localVarQueryParameter['periodAggregation'] = periodAggregation;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary レポートの計画明細データを取得する
         * @param {string} reportId 
         * @param {GetReportTableDetailBody} getReportTableDetailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTablePlanDetail: async (reportId: string, getReportTableDetailBody: GetReportTableDetailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReportTablePlanDetail', 'reportId', reportId)
            // verify required parameter 'getReportTableDetailBody' is not null or undefined
            assertParamExists('getReportTablePlanDetail', 'getReportTableDetailBody', getReportTableDetailBody)
            const localVarPath = `/api/reports/{reportId}/table/detail/plan`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getReportTableDetailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PLレポートの表データをボードフィルタ適用して取得する
         * @param {string} reportId 
         * @param {GetReportTableWithBoardFilterBody} getReportTableWithBoardFilterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTableWithBoardFilter: async (reportId: string, getReportTableWithBoardFilterBody: GetReportTableWithBoardFilterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getReportTableWithBoardFilter', 'reportId', reportId)
            // verify required parameter 'getReportTableWithBoardFilterBody' is not null or undefined
            assertParamExists('getReportTableWithBoardFilter', 'getReportTableWithBoardFilterBody', getReportTableWithBoardFilterBody)
            const localVarPath = `/api/reports/{reportId}/table/with-board-filter`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getReportTableWithBoardFilterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportTableControllerApi - functional programming interface
 */
export const ReportTableControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportTableControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary レポートの明細データを指定された形式で出力開始
         * @param {string} reportId 
         * @param {GenerateReportTableDetailDownloadBody} generateReportTableDetailDownloadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateReportTableDetailDownloadAsync(reportId: string, generateReportTableDetailDownloadBody: GenerateReportTableDetailDownloadBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateReportTableDetailDownloadAsync(reportId, generateReportTableDetailDownloadBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.generateReportTableDetailDownloadAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BSレポートの表データをExcel形式で出力
         * @param {string} reportId 
         * @param {BSReportConditionSchema} bSReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBSReportExcel(reportId: string, bSReportConditionSchema: BSReportConditionSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBSReportExcel(reportId, bSReportConditionSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getBSReportExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BSレポートの表データを取得する
         * @param {string} reportId 
         * @param {BSReportConditionSchema} bSReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBSReportTable(reportId: string, bSReportConditionSchema: BSReportConditionSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBSReportTable(reportId, bSReportConditionSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getBSReportTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary BSレポートの表データをボードフィルタ適用して取得する
         * @param {string} reportId 
         * @param {GetBSReportTableWithBoardFilterBody} getBSReportTableWithBoardFilterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBSReportTableWithBoardFilter(reportId: string, getBSReportTableWithBoardFilterBody: GetBSReportTableWithBoardFilterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBSReportTableWithBoardFilter(reportId, getBSReportTableWithBoardFilterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getBSReportTableWithBoardFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary CFレポートの表データをExcel形式で出力
         * @param {string} reportId 
         * @param {CFReportConditionSchema} cFReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCFReportExcel(reportId: string, cFReportConditionSchema: CFReportConditionSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCFReportExcel(reportId, cFReportConditionSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getCFReportExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary CFレポートの表データを取得する
         * @param {string} reportId 
         * @param {CFReportConditionSchema} cFReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCFReportTable(reportId: string, cFReportConditionSchema: CFReportConditionSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCFReportTable(reportId, cFReportConditionSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getCFReportTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary CFレポートの表データをボードフィルタ適用して取得する
         * @param {string} reportId 
         * @param {GetCFReportTableWithBoardFilterBody} getCFReportTableWithBoardFilterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCFReportTableWithBoardFilter(reportId: string, getCFReportTableWithBoardFilterBody: GetCFReportTableWithBoardFilterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCFReportTableWithBoardFilter(reportId, getCFReportTableWithBoardFilterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getCFReportTableWithBoardFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 期間列情報のみを取得する（ウォーターフォールチャート用）
         * @param {string} reportId 
         * @param {GetPeriodColumnsBody} getPeriodColumnsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeriodColumns(reportId: string, getPeriodColumnsBody: GetPeriodColumnsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PeriodColumn>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeriodColumns(reportId, getPeriodColumnsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getPeriodColumns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary PLレポートの表データをExcel形式で出力
         * @param {string} reportId 
         * @param {PLReportConditionSchema} pLReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportExcel(reportId: string, pLReportConditionSchema: PLReportConditionSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportExcel(reportId, pLReportConditionSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getReportExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary PLレポートの表データを取得する
         * @param {string} reportId 
         * @param {PLReportConditionSchema} pLReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportTable(reportId: string, pLReportConditionSchema: PLReportConditionSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportTable(reportId, pLReportConditionSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getReportTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートの実績明細データを取得する
         * @param {string} reportId 
         * @param {GetReportTableDetailBody} getReportTableDetailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportTableActualDetail(reportId: string, getReportTableDetailBody: GetReportTableDetailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportTableDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportTableActualDetail(reportId, getReportTableDetailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getReportTableActualDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートのメタデータのみを取得する（保存済み条件を使用）
         * @param {string} reportId 
         * @param {string} [periodAggregation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportTableMetadata(reportId: string, periodAggregation?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportTableMetadataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportTableMetadata(reportId, periodAggregation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getReportTableMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary レポートの計画明細データを取得する
         * @param {string} reportId 
         * @param {GetReportTableDetailBody} getReportTableDetailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportTablePlanDetail(reportId: string, getReportTableDetailBody: GetReportTableDetailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportTableDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportTablePlanDetail(reportId, getReportTableDetailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getReportTablePlanDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary PLレポートの表データをボードフィルタ適用して取得する
         * @param {string} reportId 
         * @param {GetReportTableWithBoardFilterBody} getReportTableWithBoardFilterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportTableWithBoardFilter(reportId: string, getReportTableWithBoardFilterBody: GetReportTableWithBoardFilterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReportTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportTableWithBoardFilter(reportId, getReportTableWithBoardFilterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTableControllerApi.getReportTableWithBoardFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportTableControllerApi - factory interface
 */
export const ReportTableControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportTableControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary レポートの明細データを指定された形式で出力開始
         * @param {string} reportId 
         * @param {GenerateReportTableDetailDownloadBody} generateReportTableDetailDownloadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReportTableDetailDownloadAsync(reportId: string, generateReportTableDetailDownloadBody: GenerateReportTableDetailDownloadBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.generateReportTableDetailDownloadAsync(reportId, generateReportTableDetailDownloadBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BSレポートの表データをExcel形式で出力
         * @param {string} reportId 
         * @param {BSReportConditionSchema} bSReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSReportExcel(reportId: string, bSReportConditionSchema: BSReportConditionSchema, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getBSReportExcel(reportId, bSReportConditionSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BSレポートの表データを取得する
         * @param {string} reportId 
         * @param {BSReportConditionSchema} bSReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSReportTable(reportId: string, bSReportConditionSchema: BSReportConditionSchema, options?: RawAxiosRequestConfig): AxiosPromise<GetReportTableView> {
            return localVarFp.getBSReportTable(reportId, bSReportConditionSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary BSレポートの表データをボードフィルタ適用して取得する
         * @param {string} reportId 
         * @param {GetBSReportTableWithBoardFilterBody} getBSReportTableWithBoardFilterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBSReportTableWithBoardFilter(reportId: string, getBSReportTableWithBoardFilterBody: GetBSReportTableWithBoardFilterBody, options?: RawAxiosRequestConfig): AxiosPromise<GetReportTableView> {
            return localVarFp.getBSReportTableWithBoardFilter(reportId, getBSReportTableWithBoardFilterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CFレポートの表データをExcel形式で出力
         * @param {string} reportId 
         * @param {CFReportConditionSchema} cFReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCFReportExcel(reportId: string, cFReportConditionSchema: CFReportConditionSchema, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getCFReportExcel(reportId, cFReportConditionSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CFレポートの表データを取得する
         * @param {string} reportId 
         * @param {CFReportConditionSchema} cFReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCFReportTable(reportId: string, cFReportConditionSchema: CFReportConditionSchema, options?: RawAxiosRequestConfig): AxiosPromise<GetReportTableView> {
            return localVarFp.getCFReportTable(reportId, cFReportConditionSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CFレポートの表データをボードフィルタ適用して取得する
         * @param {string} reportId 
         * @param {GetCFReportTableWithBoardFilterBody} getCFReportTableWithBoardFilterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCFReportTableWithBoardFilter(reportId: string, getCFReportTableWithBoardFilterBody: GetCFReportTableWithBoardFilterBody, options?: RawAxiosRequestConfig): AxiosPromise<GetReportTableView> {
            return localVarFp.getCFReportTableWithBoardFilter(reportId, getCFReportTableWithBoardFilterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 期間列情報のみを取得する（ウォーターフォールチャート用）
         * @param {string} reportId 
         * @param {GetPeriodColumnsBody} getPeriodColumnsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodColumns(reportId: string, getPeriodColumnsBody: GetPeriodColumnsBody, options?: RawAxiosRequestConfig): AxiosPromise<Array<PeriodColumn>> {
            return localVarFp.getPeriodColumns(reportId, getPeriodColumnsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PLレポートの表データをExcel形式で出力
         * @param {string} reportId 
         * @param {PLReportConditionSchema} pLReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportExcel(reportId: string, pLReportConditionSchema: PLReportConditionSchema, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getReportExcel(reportId, pLReportConditionSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PLレポートの表データを取得する
         * @param {string} reportId 
         * @param {PLReportConditionSchema} pLReportConditionSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTable(reportId: string, pLReportConditionSchema: PLReportConditionSchema, options?: RawAxiosRequestConfig): AxiosPromise<GetReportTableView> {
            return localVarFp.getReportTable(reportId, pLReportConditionSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートの実績明細データを取得する
         * @param {string} reportId 
         * @param {GetReportTableDetailBody} getReportTableDetailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTableActualDetail(reportId: string, getReportTableDetailBody: GetReportTableDetailBody, options?: RawAxiosRequestConfig): AxiosPromise<GetReportTableDetailView> {
            return localVarFp.getReportTableActualDetail(reportId, getReportTableDetailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートのメタデータのみを取得する（保存済み条件を使用）
         * @param {string} reportId 
         * @param {string} [periodAggregation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTableMetadata(reportId: string, periodAggregation?: string, options?: RawAxiosRequestConfig): AxiosPromise<ReportTableMetadataView> {
            return localVarFp.getReportTableMetadata(reportId, periodAggregation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary レポートの計画明細データを取得する
         * @param {string} reportId 
         * @param {GetReportTableDetailBody} getReportTableDetailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTablePlanDetail(reportId: string, getReportTableDetailBody: GetReportTableDetailBody, options?: RawAxiosRequestConfig): AxiosPromise<GetReportTableDetailView> {
            return localVarFp.getReportTablePlanDetail(reportId, getReportTableDetailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PLレポートの表データをボードフィルタ適用して取得する
         * @param {string} reportId 
         * @param {GetReportTableWithBoardFilterBody} getReportTableWithBoardFilterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportTableWithBoardFilter(reportId: string, getReportTableWithBoardFilterBody: GetReportTableWithBoardFilterBody, options?: RawAxiosRequestConfig): AxiosPromise<GetReportTableView> {
            return localVarFp.getReportTableWithBoardFilter(reportId, getReportTableWithBoardFilterBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportTableControllerApi - object-oriented interface
 */
export class ReportTableControllerApi extends BaseAPI {
    /**
     * 
     * @summary レポートの明細データを指定された形式で出力開始
     * @param {string} reportId 
     * @param {GenerateReportTableDetailDownloadBody} generateReportTableDetailDownloadBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateReportTableDetailDownloadAsync(reportId: string, generateReportTableDetailDownloadBody: GenerateReportTableDetailDownloadBody, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).generateReportTableDetailDownloadAsync(reportId, generateReportTableDetailDownloadBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BSレポートの表データをExcel形式で出力
     * @param {string} reportId 
     * @param {BSReportConditionSchema} bSReportConditionSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBSReportExcel(reportId: string, bSReportConditionSchema: BSReportConditionSchema, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getBSReportExcel(reportId, bSReportConditionSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BSレポートの表データを取得する
     * @param {string} reportId 
     * @param {BSReportConditionSchema} bSReportConditionSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBSReportTable(reportId: string, bSReportConditionSchema: BSReportConditionSchema, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getBSReportTable(reportId, bSReportConditionSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary BSレポートの表データをボードフィルタ適用して取得する
     * @param {string} reportId 
     * @param {GetBSReportTableWithBoardFilterBody} getBSReportTableWithBoardFilterBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBSReportTableWithBoardFilter(reportId: string, getBSReportTableWithBoardFilterBody: GetBSReportTableWithBoardFilterBody, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getBSReportTableWithBoardFilter(reportId, getBSReportTableWithBoardFilterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CFレポートの表データをExcel形式で出力
     * @param {string} reportId 
     * @param {CFReportConditionSchema} cFReportConditionSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCFReportExcel(reportId: string, cFReportConditionSchema: CFReportConditionSchema, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getCFReportExcel(reportId, cFReportConditionSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CFレポートの表データを取得する
     * @param {string} reportId 
     * @param {CFReportConditionSchema} cFReportConditionSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCFReportTable(reportId: string, cFReportConditionSchema: CFReportConditionSchema, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getCFReportTable(reportId, cFReportConditionSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CFレポートの表データをボードフィルタ適用して取得する
     * @param {string} reportId 
     * @param {GetCFReportTableWithBoardFilterBody} getCFReportTableWithBoardFilterBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCFReportTableWithBoardFilter(reportId: string, getCFReportTableWithBoardFilterBody: GetCFReportTableWithBoardFilterBody, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getCFReportTableWithBoardFilter(reportId, getCFReportTableWithBoardFilterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 期間列情報のみを取得する（ウォーターフォールチャート用）
     * @param {string} reportId 
     * @param {GetPeriodColumnsBody} getPeriodColumnsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPeriodColumns(reportId: string, getPeriodColumnsBody: GetPeriodColumnsBody, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getPeriodColumns(reportId, getPeriodColumnsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PLレポートの表データをExcel形式で出力
     * @param {string} reportId 
     * @param {PLReportConditionSchema} pLReportConditionSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportExcel(reportId: string, pLReportConditionSchema: PLReportConditionSchema, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getReportExcel(reportId, pLReportConditionSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PLレポートの表データを取得する
     * @param {string} reportId 
     * @param {PLReportConditionSchema} pLReportConditionSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportTable(reportId: string, pLReportConditionSchema: PLReportConditionSchema, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getReportTable(reportId, pLReportConditionSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートの実績明細データを取得する
     * @param {string} reportId 
     * @param {GetReportTableDetailBody} getReportTableDetailBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportTableActualDetail(reportId: string, getReportTableDetailBody: GetReportTableDetailBody, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getReportTableActualDetail(reportId, getReportTableDetailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートのメタデータのみを取得する（保存済み条件を使用）
     * @param {string} reportId 
     * @param {string} [periodAggregation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportTableMetadata(reportId: string, periodAggregation?: string, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getReportTableMetadata(reportId, periodAggregation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary レポートの計画明細データを取得する
     * @param {string} reportId 
     * @param {GetReportTableDetailBody} getReportTableDetailBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportTablePlanDetail(reportId: string, getReportTableDetailBody: GetReportTableDetailBody, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getReportTablePlanDetail(reportId, getReportTableDetailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PLレポートの表データをボードフィルタ適用して取得する
     * @param {string} reportId 
     * @param {GetReportTableWithBoardFilterBody} getReportTableWithBoardFilterBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportTableWithBoardFilter(reportId: string, getReportTableWithBoardFilterBody: GetReportTableWithBoardFilterBody, options?: RawAxiosRequestConfig) {
        return ReportTableControllerApiFp(this.configuration).getReportTableWithBoardFilter(reportId, getReportTableWithBoardFilterBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RuleControllerApi - axios parameter creator
 */
export const RuleControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ステップのコピー
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {CopyStepRequestBody} copyStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyStep: async (ruleId: string, stepId: string, copyStepRequestBody: CopyStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('copyStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('copyStep', 'stepId', stepId)
            // verify required parameter 'copyStepRequestBody' is not null or undefined
            assertParamExists('copyStep', 'copyStepRequestBody', copyStepRequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}/copy`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ルールの作成
         * @param {CreateRuleRequestBody} createRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRule: async (createRuleRequestBody: CreateRuleRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRuleRequestBody' is not null or undefined
            assertParamExists('createRule', 'createRuleRequestBody', createRuleRequestBody)
            const localVarPath = `/api/allocation/v2/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRuleRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップの作成
         * @param {string} ruleId 
         * @param {CreateStepRequestBody} createStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStep1: async (ruleId: string, createStepRequestBody: CreateStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('createStep1', 'ruleId', ruleId)
            // verify required parameter 'createStepRequestBody' is not null or undefined
            assertParamExists('createStep1', 'createStepRequestBody', createStepRequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替ステップの作成
         * @param {string} ruleId 
         * @param {CreateTransferStepV2RequestBody} createTransferStepV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransferStepV2: async (ruleId: string, createTransferStepV2RequestBody: CreateTransferStepV2RequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('createTransferStepV2', 'ruleId', ruleId)
            // verify required parameter 'createTransferStepV2RequestBody' is not null or undefined
            assertParamExists('createTransferStepV2', 'createTransferStepV2RequestBody', createTransferStepV2RequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/transfer-steps`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTransferStepV2RequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルールの削除
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRule: async (ruleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('deleteRule', 'ruleId', ruleId)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップの削除
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStep: async (ruleId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('deleteStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('deleteStep', 'stepId', stepId)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ルールの複製
         * @param {string} ruleId 
         * @param {DuplicateRuleRequestBody} duplicateRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateRule: async (ruleId: string, duplicateRuleRequestBody: DuplicateRuleRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('duplicateRule', 'ruleId', ruleId)
            // verify required parameter 'duplicateRuleRequestBody' is not null or undefined
            assertParamExists('duplicateRule', 'duplicateRuleRequestBody', duplicateRuleRequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/duplicate`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicateRuleRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップの制約違反部分を空にして取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {SanitizedAllocationStepRequestBody} sanitizedAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSanitizedAllocationStep: async (ruleId: string, stepId: string, sanitizedAllocationStepRequestBody: SanitizedAllocationStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('fetchSanitizedAllocationStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('fetchSanitizedAllocationStep', 'stepId', stepId)
            // verify required parameter 'sanitizedAllocationStepRequestBody' is not null or undefined
            assertParamExists('fetchSanitizedAllocationStep', 'sanitizedAllocationStepRequestBody', sanitizedAllocationStepRequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}/sanitized-step`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sanitizedAllocationStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替ステップの制約違反部分を空にして取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {SanitizedTransferStepRequestBody} sanitizedTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSanitizedTransferStep: async (ruleId: string, stepId: string, sanitizedTransferStepRequestBody: SanitizedTransferStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('fetchSanitizedTransferStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('fetchSanitizedTransferStep', 'stepId', stepId)
            // verify required parameter 'sanitizedTransferStepRequestBody' is not null or undefined
            assertParamExists('fetchSanitizedTransferStep', 'sanitizedTransferStepRequestBody', sanitizedTransferStepRequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}/sanitized-transfer-step`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sanitizedTransferStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップの設定値取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStep: async (ruleId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('fetchStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('fetchStep', 'stepId', stepId)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替ステップの設定値取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransferStep: async (ruleId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('fetchTransferStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('fetchTransferStep', 'stepId', stepId)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/transfer-steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルールの取得
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRule1: async (ruleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('findRule1', 'ruleId', ruleId)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップサマリを取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStepSummary: async (ruleId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('findStepSummary', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('findStepSummary', 'stepId', stepId)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}/summary`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ルール一覧の取得
         * @param {ListRulesRequest} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRules1: async (request: ListRulesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('listRules1', 'request', request)
            const localVarPath = `/api/allocation/v2/rules/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (request !== undefined) {
                for (const [key, value] of Object.entries(request)) {
                    localVarQueryParameter[key] = value;
                }
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パターン作成時の選択用ルール一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRulesForSelect: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/allocation/v2/rules/for-select`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップの更新
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateStepRequestBody} updateStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllocationStep: async (ruleId: string, stepId: string, updateStepRequestBody: UpdateStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateAllocationStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('updateAllocationStep', 'stepId', stepId)
            // verify required parameter 'updateStepRequestBody' is not null or undefined
            assertParamExists('updateAllocationStep', 'updateStepRequestBody', updateStepRequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ルールの更新
         * @param {string} ruleId 
         * @param {UpdateRuleRequestBody} updateRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRule: async (ruleId: string, updateRuleRequestBody: UpdateRuleRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateRule', 'ruleId', ruleId)
            // verify required parameter 'updateRuleRequestBody' is not null or undefined
            assertParamExists('updateRule', 'updateRuleRequestBody', updateRuleRequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRuleRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップの順序更新
         * @param {string} ruleId 
         * @param {UpdateStepOrderRequestBody} updateStepOrderRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStepOrder: async (ruleId: string, updateStepOrderRequestBody: UpdateStepOrderRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateStepOrder', 'ruleId', ruleId)
            // verify required parameter 'updateStepOrderRequestBody' is not null or undefined
            assertParamExists('updateStepOrder', 'updateStepOrderRequestBody', updateStepOrderRequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/steps/order`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStepOrderRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替ステップの更新
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateTransferStepV2RequestBody} updateTransferStepV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferStepV2: async (ruleId: string, stepId: string, updateTransferStepV2RequestBody: UpdateTransferStepV2RequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateTransferStepV2', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('updateTransferStepV2', 'stepId', stepId)
            // verify required parameter 'updateTransferStepV2RequestBody' is not null or undefined
            assertParamExists('updateTransferStepV2', 'updateTransferStepV2RequestBody', updateTransferStepV2RequestBody)
            const localVarPath = `/api/allocation/v2/rules/{ruleId}/transfer-steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTransferStepV2RequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 配賦ステップの制約違反チェック
         * @param {ValidateAllocationStepRequestBody} validateAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAllocationStep: async (validateAllocationStepRequestBody: ValidateAllocationStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateAllocationStepRequestBody' is not null or undefined
            assertParamExists('validateAllocationStep', 'validateAllocationStepRequestBody', validateAllocationStepRequestBody)
            const localVarPath = `/api/allocation/v2/rules/step/validated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateAllocationStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替ステップの制約違反チェック
         * @param {ValidateTransferStepRequestBody} validateTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTransferStep: async (validateTransferStepRequestBody: ValidateTransferStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateTransferStepRequestBody' is not null or undefined
            assertParamExists('validateTransferStep', 'validateTransferStepRequestBody', validateTransferStepRequestBody)
            const localVarPath = `/api/allocation/v2/rules/transfer-step/validated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateTransferStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RuleControllerApi - functional programming interface
 */
export const RuleControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RuleControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ステップのコピー
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {CopyStepRequestBody} copyStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyStep(ruleId: string, stepId: string, copyStepRequestBody: CopyStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopyStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyStep(ruleId, stepId, copyStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.copyStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ルールの作成
         * @param {CreateRuleRequestBody} createRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRule(createRuleRequestBody: CreateRuleRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRuleView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRule(createRuleRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.createRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップの作成
         * @param {string} ruleId 
         * @param {CreateStepRequestBody} createStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStep1(ruleId: string, createStepRequestBody: CreateStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStep1(ruleId, createStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.createStep1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替ステップの作成
         * @param {string} ruleId 
         * @param {CreateTransferStepV2RequestBody} createTransferStepV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransferStepV2(ruleId: string, createTransferStepV2RequestBody: CreateTransferStepV2RequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransferStepV2(ruleId, createTransferStepV2RequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.createTransferStepV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ルールの削除
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRule(ruleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRule(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.deleteRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップの削除
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStep(ruleId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.deleteStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ルールの複製
         * @param {string} ruleId 
         * @param {DuplicateRuleRequestBody} duplicateRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateRule(ruleId: string, duplicateRuleRequestBody: DuplicateRuleRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DuplicateRuleView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateRule(ruleId, duplicateRuleRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.duplicateRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップの制約違反部分を空にして取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {SanitizedAllocationStepRequestBody} sanitizedAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchSanitizedAllocationStep(ruleId: string, stepId: string, sanitizedAllocationStepRequestBody: SanitizedAllocationStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchAllocationSanitizedStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchSanitizedAllocationStep(ruleId, stepId, sanitizedAllocationStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.fetchSanitizedAllocationStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替ステップの制約違反部分を空にして取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {SanitizedTransferStepRequestBody} sanitizedTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchSanitizedTransferStep(ruleId: string, stepId: string, sanitizedTransferStepRequestBody: SanitizedTransferStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchTransferSanitizedStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchSanitizedTransferStep(ruleId, stepId, sanitizedTransferStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.fetchSanitizedTransferStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップの設定値取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchAllocationStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchStep(ruleId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.fetchStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替ステップの設定値取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchTransferStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchTransferStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchTransferStep(ruleId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.fetchTransferStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ルールの取得
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRule1(ruleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRule1(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.findRule1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップサマリを取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findStepSummary(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationStepSummaryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findStepSummary(ruleId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.findStepSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ルール一覧の取得
         * @param {ListRulesRequest} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRules1(request: ListRulesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageViewRuleSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRules1(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.listRules1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary パターン作成時の選択用ルール一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRulesForSelect(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RuleForSelectView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRulesForSelect(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.listRulesForSelect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップの更新
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateStepRequestBody} updateStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAllocationStep(ruleId: string, stepId: string, updateStepRequestBody: UpdateStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAllocationStep(ruleId, stepId, updateStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.updateAllocationStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ルールの更新
         * @param {string} ruleId 
         * @param {UpdateRuleRequestBody} updateRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRule(ruleId: string, updateRuleRequestBody: UpdateRuleRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleUpdateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRule(ruleId, updateRuleRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.updateRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップの順序更新
         * @param {string} ruleId 
         * @param {UpdateStepOrderRequestBody} updateStepOrderRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStepOrder(ruleId: string, updateStepOrderRequestBody: UpdateStepOrderRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleUpdateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStepOrder(ruleId, updateStepOrderRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.updateStepOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替ステップの更新
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateTransferStepV2RequestBody} updateTransferStepV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransferStepV2(ruleId: string, stepId: string, updateTransferStepV2RequestBody: UpdateTransferStepV2RequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransferStepV2(ruleId, stepId, updateTransferStepV2RequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.updateTransferStepV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 配賦ステップの制約違反チェック
         * @param {ValidateAllocationStepRequestBody} validateAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAllocationStep(validateAllocationStepRequestBody: ValidateAllocationStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateAllocationStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAllocationStep(validateAllocationStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.validateAllocationStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替ステップの制約違反チェック
         * @param {ValidateTransferStepRequestBody} validateTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateTransferStep(validateTransferStepRequestBody: ValidateTransferStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateTransferStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateTransferStep(validateTransferStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RuleControllerApi.validateTransferStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RuleControllerApi - factory interface
 */
export const RuleControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RuleControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ステップのコピー
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {CopyStepRequestBody} copyStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyStep(ruleId: string, stepId: string, copyStepRequestBody: CopyStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CopyStepView> {
            return localVarFp.copyStep(ruleId, stepId, copyStepRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ルールの作成
         * @param {CreateRuleRequestBody} createRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRule(createRuleRequestBody: CreateRuleRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreateRuleView> {
            return localVarFp.createRule(createRuleRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップの作成
         * @param {string} ruleId 
         * @param {CreateStepRequestBody} createStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStep1(ruleId: string, createStepRequestBody: CreateStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreateStepView> {
            return localVarFp.createStep1(ruleId, createStepRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替ステップの作成
         * @param {string} ruleId 
         * @param {CreateTransferStepV2RequestBody} createTransferStepV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransferStepV2(ruleId: string, createTransferStepV2RequestBody: CreateTransferStepV2RequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreateStepView> {
            return localVarFp.createTransferStepV2(ruleId, createTransferStepV2RequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルールの削除
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRule(ruleId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRule(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップの削除
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStep(ruleId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ルールの複製
         * @param {string} ruleId 
         * @param {DuplicateRuleRequestBody} duplicateRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateRule(ruleId: string, duplicateRuleRequestBody: DuplicateRuleRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<DuplicateRuleView> {
            return localVarFp.duplicateRule(ruleId, duplicateRuleRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップの制約違反部分を空にして取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {SanitizedAllocationStepRequestBody} sanitizedAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSanitizedAllocationStep(ruleId: string, stepId: string, sanitizedAllocationStepRequestBody: SanitizedAllocationStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FetchAllocationSanitizedStepView> {
            return localVarFp.fetchSanitizedAllocationStep(ruleId, stepId, sanitizedAllocationStepRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替ステップの制約違反部分を空にして取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {SanitizedTransferStepRequestBody} sanitizedTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSanitizedTransferStep(ruleId: string, stepId: string, sanitizedTransferStepRequestBody: SanitizedTransferStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FetchTransferSanitizedStepView> {
            return localVarFp.fetchSanitizedTransferStep(ruleId, stepId, sanitizedTransferStepRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップの設定値取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchAllocationStepView> {
            return localVarFp.fetchStep(ruleId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替ステップの設定値取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTransferStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchTransferStepView> {
            return localVarFp.fetchTransferStep(ruleId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルールの取得
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRule1(ruleId: string, options?: RawAxiosRequestConfig): AxiosPromise<RuleDetailDto> {
            return localVarFp.findRule1(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップサマリを取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStepSummary(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<AllocationStepSummaryView> {
            return localVarFp.findStepSummary(ruleId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ルール一覧の取得
         * @param {ListRulesRequest} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRules1(request: ListRulesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageViewRuleSummary> {
            return localVarFp.listRules1(request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パターン作成時の選択用ルール一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRulesForSelect(options?: RawAxiosRequestConfig): AxiosPromise<Array<RuleForSelectView>> {
            return localVarFp.listRulesForSelect(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップの更新
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateStepRequestBody} updateStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllocationStep(ruleId: string, stepId: string, updateStepRequestBody: UpdateStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAllocationStep(ruleId, stepId, updateStepRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ルールの更新
         * @param {string} ruleId 
         * @param {UpdateRuleRequestBody} updateRuleRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRule(ruleId: string, updateRuleRequestBody: UpdateRuleRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<RuleUpdateView> {
            return localVarFp.updateRule(ruleId, updateRuleRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップの順序更新
         * @param {string} ruleId 
         * @param {UpdateStepOrderRequestBody} updateStepOrderRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStepOrder(ruleId: string, updateStepOrderRequestBody: UpdateStepOrderRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<RuleUpdateView> {
            return localVarFp.updateStepOrder(ruleId, updateStepOrderRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替ステップの更新
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateTransferStepV2RequestBody} updateTransferStepV2RequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferStepV2(ruleId: string, stepId: string, updateTransferStepV2RequestBody: UpdateTransferStepV2RequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTransferStepV2(ruleId, stepId, updateTransferStepV2RequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 配賦ステップの制約違反チェック
         * @param {ValidateAllocationStepRequestBody} validateAllocationStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAllocationStep(validateAllocationStepRequestBody: ValidateAllocationStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ValidateAllocationStepView> {
            return localVarFp.validateAllocationStep(validateAllocationStepRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替ステップの制約違反チェック
         * @param {ValidateTransferStepRequestBody} validateTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTransferStep(validateTransferStepRequestBody: ValidateTransferStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ValidateTransferStepView> {
            return localVarFp.validateTransferStep(validateTransferStepRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RuleControllerApi - object-oriented interface
 */
export class RuleControllerApi extends BaseAPI {
    /**
     * 
     * @summary ステップのコピー
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {CopyStepRequestBody} copyStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyStep(ruleId: string, stepId: string, copyStepRequestBody: CopyStepRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).copyStep(ruleId, stepId, copyStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ルールの作成
     * @param {CreateRuleRequestBody} createRuleRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createRule(createRuleRequestBody: CreateRuleRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).createRule(createRuleRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップの作成
     * @param {string} ruleId 
     * @param {CreateStepRequestBody} createStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createStep1(ruleId: string, createStepRequestBody: CreateStepRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).createStep1(ruleId, createStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替ステップの作成
     * @param {string} ruleId 
     * @param {CreateTransferStepV2RequestBody} createTransferStepV2RequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTransferStepV2(ruleId: string, createTransferStepV2RequestBody: CreateTransferStepV2RequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).createTransferStepV2(ruleId, createTransferStepV2RequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルールの削除
     * @param {string} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteRule(ruleId: string, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).deleteRule(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップの削除
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).deleteStep(ruleId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ルールの複製
     * @param {string} ruleId 
     * @param {DuplicateRuleRequestBody} duplicateRuleRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public duplicateRule(ruleId: string, duplicateRuleRequestBody: DuplicateRuleRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).duplicateRule(ruleId, duplicateRuleRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップの制約違反部分を空にして取得
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {SanitizedAllocationStepRequestBody} sanitizedAllocationStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchSanitizedAllocationStep(ruleId: string, stepId: string, sanitizedAllocationStepRequestBody: SanitizedAllocationStepRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).fetchSanitizedAllocationStep(ruleId, stepId, sanitizedAllocationStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替ステップの制約違反部分を空にして取得
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {SanitizedTransferStepRequestBody} sanitizedTransferStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchSanitizedTransferStep(ruleId: string, stepId: string, sanitizedTransferStepRequestBody: SanitizedTransferStepRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).fetchSanitizedTransferStep(ruleId, stepId, sanitizedTransferStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップの設定値取得
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).fetchStep(ruleId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替ステップの設定値取得
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchTransferStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).fetchTransferStep(ruleId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルールの取得
     * @param {string} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findRule1(ruleId: string, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).findRule1(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップサマリを取得
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findStepSummary(ruleId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).findStepSummary(ruleId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ルール一覧の取得
     * @param {ListRulesRequest} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listRules1(request: ListRulesRequest, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).listRules1(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パターン作成時の選択用ルール一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listRulesForSelect(options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).listRulesForSelect(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップの更新
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {UpdateStepRequestBody} updateStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAllocationStep(ruleId: string, stepId: string, updateStepRequestBody: UpdateStepRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).updateAllocationStep(ruleId, stepId, updateStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ルールの更新
     * @param {string} ruleId 
     * @param {UpdateRuleRequestBody} updateRuleRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRule(ruleId: string, updateRuleRequestBody: UpdateRuleRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).updateRule(ruleId, updateRuleRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップの順序更新
     * @param {string} ruleId 
     * @param {UpdateStepOrderRequestBody} updateStepOrderRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStepOrder(ruleId: string, updateStepOrderRequestBody: UpdateStepOrderRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).updateStepOrder(ruleId, updateStepOrderRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替ステップの更新
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {UpdateTransferStepV2RequestBody} updateTransferStepV2RequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTransferStepV2(ruleId: string, stepId: string, updateTransferStepV2RequestBody: UpdateTransferStepV2RequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).updateTransferStepV2(ruleId, stepId, updateTransferStepV2RequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 配賦ステップの制約違反チェック
     * @param {ValidateAllocationStepRequestBody} validateAllocationStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateAllocationStep(validateAllocationStepRequestBody: ValidateAllocationStepRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).validateAllocationStep(validateAllocationStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替ステップの制約違反チェック
     * @param {ValidateTransferStepRequestBody} validateTransferStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateTransferStep(validateTransferStepRequestBody: ValidateTransferStepRequestBody, options?: RawAxiosRequestConfig) {
        return RuleControllerApiFp(this.configuration).validateTransferStep(validateTransferStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScenarioControllerApi - axios parameter creator
 */
export const ScenarioControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シナリオの詳細情報を取得
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScenarioDetail: async (scenarioId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('fetchScenarioDetail', 'scenarioId', scenarioId)
            const localVarPath = `/api/scenario/{scenarioId}`
                .replace('{scenarioId}', encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シナリオの財務モデルIDを切り替え
         * @param {string} scenarioId 
         * @param {SwitchFinancialModelIdRequestBody} switchFinancialModelIdRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchFinancialModelId: async (scenarioId: string, switchFinancialModelIdRequestBody: SwitchFinancialModelIdRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scenarioId' is not null or undefined
            assertParamExists('switchFinancialModelId', 'scenarioId', scenarioId)
            // verify required parameter 'switchFinancialModelIdRequestBody' is not null or undefined
            assertParamExists('switchFinancialModelId', 'switchFinancialModelIdRequestBody', switchFinancialModelIdRequestBody)
            const localVarPath = `/api/scenario/{scenarioId}/switch-financial-model-id`
                .replace('{scenarioId}', encodeURIComponent(String(scenarioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(switchFinancialModelIdRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScenarioControllerApi - functional programming interface
 */
export const ScenarioControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScenarioControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シナリオの詳細情報を取得
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchScenarioDetail(scenarioId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScenarioDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchScenarioDetail(scenarioId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenarioControllerApi.fetchScenarioDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シナリオの財務モデルIDを切り替え
         * @param {string} scenarioId 
         * @param {SwitchFinancialModelIdRequestBody} switchFinancialModelIdRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchFinancialModelId(scenarioId: string, switchFinancialModelIdRequestBody: SwitchFinancialModelIdRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchFinancialModelId(scenarioId, switchFinancialModelIdRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScenarioControllerApi.switchFinancialModelId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScenarioControllerApi - factory interface
 */
export const ScenarioControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScenarioControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary シナリオの詳細情報を取得
         * @param {string} scenarioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchScenarioDetail(scenarioId: string, options?: RawAxiosRequestConfig): AxiosPromise<ScenarioDetailView> {
            return localVarFp.fetchScenarioDetail(scenarioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シナリオの財務モデルIDを切り替え
         * @param {string} scenarioId 
         * @param {SwitchFinancialModelIdRequestBody} switchFinancialModelIdRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchFinancialModelId(scenarioId: string, switchFinancialModelIdRequestBody: SwitchFinancialModelIdRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.switchFinancialModelId(scenarioId, switchFinancialModelIdRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScenarioControllerApi - object-oriented interface
 */
export class ScenarioControllerApi extends BaseAPI {
    /**
     * 
     * @summary シナリオの詳細情報を取得
     * @param {string} scenarioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchScenarioDetail(scenarioId: string, options?: RawAxiosRequestConfig) {
        return ScenarioControllerApiFp(this.configuration).fetchScenarioDetail(scenarioId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シナリオの財務モデルIDを切り替え
     * @param {string} scenarioId 
     * @param {SwitchFinancialModelIdRequestBody} switchFinancialModelIdRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public switchFinancialModelId(scenarioId: string, switchFinancialModelIdRequestBody: SwitchFinancialModelIdRequestBody, options?: RawAxiosRequestConfig) {
        return ScenarioControllerApiFp(this.configuration).switchFinancialModelId(scenarioId, switchFinancialModelIdRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingControllerApi - axios parameter creator
 */
export const SettingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSettingsParam} updateSettingsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (updateSettingsParam: UpdateSettingsParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSettingsParam' is not null or undefined
            assertParamExists('update', 'updateSettingsParam', updateSettingsParam)
            const localVarPath = `/api/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSettingsParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingControllerApi - functional programming interface
 */
export const SettingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingControllerApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateSettingsParam} updateSettingsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(updateSettingsParam: UpdateSettingsParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(updateSettingsParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingControllerApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingControllerApi - factory interface
 */
export const SettingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(options?: RawAxiosRequestConfig): AxiosPromise<SettingsView> {
            return localVarFp.get(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSettingsParam} updateSettingsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(updateSettingsParam: UpdateSettingsParam, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.update(updateSettingsParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingControllerApi - object-oriented interface
 */
export class SettingControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get(options?: RawAxiosRequestConfig) {
        return SettingControllerApiFp(this.configuration).get(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSettingsParam} updateSettingsParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public update(updateSettingsParam: UpdateSettingsParam, options?: RawAxiosRequestConfig) {
        return SettingControllerApiFp(this.configuration).update(updateSettingsParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingExcelSheetProtectionControllerApi - axios parameter creator
 */
export const SettingExcelSheetProtectionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 更新申請Excelフォーマットのシート保護パスワード取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/excel-sheet-protection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingExcelSheetProtectionControllerApi - functional programming interface
 */
export const SettingExcelSheetProtectionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingExcelSheetProtectionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 更新申請Excelフォーマットのシート保護パスワード取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingsExcelSheetProtectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingExcelSheetProtectionControllerApi.get1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingExcelSheetProtectionControllerApi - factory interface
 */
export const SettingExcelSheetProtectionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingExcelSheetProtectionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 更新申請Excelフォーマットのシート保護パスワード取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1(options?: RawAxiosRequestConfig): AxiosPromise<SettingsExcelSheetProtectionView> {
            return localVarFp.get1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingExcelSheetProtectionControllerApi - object-oriented interface
 */
export class SettingExcelSheetProtectionControllerApi extends BaseAPI {
    /**
     * 
     * @summary 更新申請Excelフォーマットのシート保護パスワード取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get1(options?: RawAxiosRequestConfig) {
        return SettingExcelSheetProtectionControllerApiFp(this.configuration).get1(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SimulatingWorkforceControllerApi - axios parameter creator
 */
export const SimulatingWorkforceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 既存人員の計画一括編集フォーマットExcelをダウンロードする
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSimulatingWorkforceBulkEditFormatExcel: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('downloadSimulatingWorkforceBulkEditFormatExcel', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/simulations/workforces/bulk-edit/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (simulationId !== undefined) {
                localVarQueryParameter['simulationId'] = simulationId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 既存人員の計画一括編集のアップロードファイルをダウンロードする
         * @param {string} historyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSimulatingWorkforceBulkUploadFile: async (historyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'historyId' is not null or undefined
            assertParamExists('downloadSimulatingWorkforceBulkUploadFile', 'historyId', historyId)
            const localVarPath = `/api/workforce-planning/simulations/workforces/bulk-edit/upload-histories/{historyId}`
                .replace('{historyId}', encodeURIComponent(String(historyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatingWorkforceConstraint: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSimulatingWorkforceConstraint', 'id', id)
            const localVarPath = `/api/workforce-planning/simulations/workforces/{id}/constraint`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatingWorkforceCurrent: async (id: string, yearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSimulatingWorkforceCurrent', 'id', id)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getSimulatingWorkforceCurrent', 'yearMonth', yearMonth)
            const localVarPath = `/api/workforce-planning/simulations/workforces/{id}/current`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatingWorkforceEvents: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSimulatingWorkforceEvents', 'id', id)
            const localVarPath = `/api/workforce-planning/simulations/workforces/{id}/events`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 既存人員の計画一括編集のアップロード履歴一覧を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingWorkforceBulkUploadHistories: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('listSimulatingWorkforceBulkUploadHistories', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/simulations/workforces/bulk-edit/upload-histories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (simulationId !== undefined) {
                localVarQueryParameter['simulationId'] = simulationId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {ListSimulatingWorkforceConcurrentPostHistoriesBody} listSimulatingWorkforceConcurrentPostHistoriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingWorkforceConcurrentPostHistories: async (simulationId: string, listSimulatingWorkforceConcurrentPostHistoriesBody: ListSimulatingWorkforceConcurrentPostHistoriesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('listSimulatingWorkforceConcurrentPostHistories', 'simulationId', simulationId)
            // verify required parameter 'listSimulatingWorkforceConcurrentPostHistoriesBody' is not null or undefined
            assertParamExists('listSimulatingWorkforceConcurrentPostHistories', 'listSimulatingWorkforceConcurrentPostHistoriesBody', listSimulatingWorkforceConcurrentPostHistoriesBody)
            const localVarPath = `/api/workforce-planning/simulations/workforces/concurrent-post-histories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (simulationId !== undefined) {
                localVarQueryParameter['simulationId'] = simulationId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listSimulatingWorkforceConcurrentPostHistoriesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {ListSimulatingWorkforceHistoriesBody} listSimulatingWorkforceHistoriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingWorkforceHistories: async (simulationId: string, listSimulatingWorkforceHistoriesBody: ListSimulatingWorkforceHistoriesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('listSimulatingWorkforceHistories', 'simulationId', simulationId)
            // verify required parameter 'listSimulatingWorkforceHistoriesBody' is not null or undefined
            assertParamExists('listSimulatingWorkforceHistories', 'listSimulatingWorkforceHistoriesBody', listSimulatingWorkforceHistoriesBody)
            const localVarPath = `/api/workforce-planning/simulations/workforces/histories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (simulationId !== undefined) {
                localVarQueryParameter['simulationId'] = simulationId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listSimulatingWorkforceHistoriesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSimulatingWorkforceBody} updateSimulatingWorkforceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimulatingWorkforce: async (id: string, updateSimulatingWorkforceBody: UpdateSimulatingWorkforceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSimulatingWorkforce', 'id', id)
            // verify required parameter 'updateSimulatingWorkforceBody' is not null or undefined
            assertParamExists('updateSimulatingWorkforce', 'updateSimulatingWorkforceBody', updateSimulatingWorkforceBody)
            const localVarPath = `/api/workforce-planning/simulations/workforces/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSimulatingWorkforceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 既存人員の計画一括編集 Excel をアップロードする
         * @param {string} simulationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSimulatingWorkforceBulkEditExcel: async (simulationId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('uploadSimulatingWorkforceBulkEditExcel', 'simulationId', simulationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadSimulatingWorkforceBulkEditExcel', 'file', file)
            const localVarPath = `/api/workforce-planning/simulations/workforces/bulk-edit/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (simulationId !== undefined) {
                localVarQueryParameter['simulationId'] = simulationId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimulatingWorkforceControllerApi - functional programming interface
 */
export const SimulatingWorkforceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimulatingWorkforceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 既存人員の計画一括編集フォーマットExcelをダウンロードする
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSimulatingWorkforceBulkEditFormatExcel(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSimulatingWorkforceBulkEditFormatExcel(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.downloadSimulatingWorkforceBulkEditFormatExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 既存人員の計画一括編集のアップロードファイルをダウンロードする
         * @param {string} historyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSimulatingWorkforceBulkUploadFile(historyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSimulatingWorkforceBulkUploadFile(historyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.downloadSimulatingWorkforceBulkUploadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulatingWorkforceConstraint(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchSimulatingWorkforceConstraintUseCaseReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulatingWorkforceConstraint(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.getSimulatingWorkforceConstraint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulatingWorkforceCurrent(id: string, yearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchSimulatingWorkforceUseCaseReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulatingWorkforceCurrent(id, yearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.getSimulatingWorkforceCurrent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulatingWorkforceEvents(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchSimulatingWorkforceEventsUseCaseReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulatingWorkforceEvents(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.getSimulatingWorkforceEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 既存人員の計画一括編集のアップロード履歴一覧を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSimulatingWorkforceBulkUploadHistories(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimulatingWorkforceBulkUploadHistoryView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSimulatingWorkforceBulkUploadHistories(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.listSimulatingWorkforceBulkUploadHistories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {ListSimulatingWorkforceConcurrentPostHistoriesBody} listSimulatingWorkforceConcurrentPostHistoriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSimulatingWorkforceConcurrentPostHistories(simulationId: string, listSimulatingWorkforceConcurrentPostHistoriesBody: ListSimulatingWorkforceConcurrentPostHistoriesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSimulatingWorkforceConcurrentPostHistoryUseCaseReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSimulatingWorkforceConcurrentPostHistories(simulationId, listSimulatingWorkforceConcurrentPostHistoriesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.listSimulatingWorkforceConcurrentPostHistories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {ListSimulatingWorkforceHistoriesBody} listSimulatingWorkforceHistoriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSimulatingWorkforceHistories(simulationId: string, listSimulatingWorkforceHistoriesBody: ListSimulatingWorkforceHistoriesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSimulatingWorkforceHistoryUseCaseReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSimulatingWorkforceHistories(simulationId, listSimulatingWorkforceHistoriesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.listSimulatingWorkforceHistories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSimulatingWorkforceBody} updateSimulatingWorkforceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSimulatingWorkforce(id: string, updateSimulatingWorkforceBody: UpdateSimulatingWorkforceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSimulatingWorkforce(id, updateSimulatingWorkforceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.updateSimulatingWorkforce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 既存人員の計画一括編集 Excel をアップロードする
         * @param {string} simulationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSimulatingWorkforceBulkEditExcel(simulationId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSimulatingWorkforceBulkEditExcel(simulationId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceControllerApi.uploadSimulatingWorkforceBulkEditExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SimulatingWorkforceControllerApi - factory interface
 */
export const SimulatingWorkforceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimulatingWorkforceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 既存人員の計画一括編集フォーマットExcelをダウンロードする
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSimulatingWorkforceBulkEditFormatExcel(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSimulatingWorkforceBulkEditFormatExcel(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 既存人員の計画一括編集のアップロードファイルをダウンロードする
         * @param {string} historyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSimulatingWorkforceBulkUploadFile(historyId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSimulatingWorkforceBulkUploadFile(historyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatingWorkforceConstraint(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchSimulatingWorkforceConstraintUseCaseReturn> {
            return localVarFp.getSimulatingWorkforceConstraint(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatingWorkforceCurrent(id: string, yearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchSimulatingWorkforceUseCaseReturn> {
            return localVarFp.getSimulatingWorkforceCurrent(id, yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulatingWorkforceEvents(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchSimulatingWorkforceEventsUseCaseReturn> {
            return localVarFp.getSimulatingWorkforceEvents(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 既存人員の計画一括編集のアップロード履歴一覧を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingWorkforceBulkUploadHistories(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SimulatingWorkforceBulkUploadHistoryView>> {
            return localVarFp.listSimulatingWorkforceBulkUploadHistories(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {ListSimulatingWorkforceConcurrentPostHistoriesBody} listSimulatingWorkforceConcurrentPostHistoriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingWorkforceConcurrentPostHistories(simulationId: string, listSimulatingWorkforceConcurrentPostHistoriesBody: ListSimulatingWorkforceConcurrentPostHistoriesBody, options?: RawAxiosRequestConfig): AxiosPromise<ListSimulatingWorkforceConcurrentPostHistoryUseCaseReturn> {
            return localVarFp.listSimulatingWorkforceConcurrentPostHistories(simulationId, listSimulatingWorkforceConcurrentPostHistoriesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {ListSimulatingWorkforceHistoriesBody} listSimulatingWorkforceHistoriesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingWorkforceHistories(simulationId: string, listSimulatingWorkforceHistoriesBody: ListSimulatingWorkforceHistoriesBody, options?: RawAxiosRequestConfig): AxiosPromise<ListSimulatingWorkforceHistoryUseCaseReturn> {
            return localVarFp.listSimulatingWorkforceHistories(simulationId, listSimulatingWorkforceHistoriesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSimulatingWorkforceBody} updateSimulatingWorkforceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSimulatingWorkforce(id: string, updateSimulatingWorkforceBody: UpdateSimulatingWorkforceBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateSimulatingWorkforce(id, updateSimulatingWorkforceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 既存人員の計画一括編集 Excel をアップロードする
         * @param {string} simulationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSimulatingWorkforceBulkEditExcel(simulationId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadSimulatingWorkforceBulkEditExcel(simulationId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimulatingWorkforceControllerApi - object-oriented interface
 */
export class SimulatingWorkforceControllerApi extends BaseAPI {
    /**
     * 
     * @summary 既存人員の計画一括編集フォーマットExcelをダウンロードする
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadSimulatingWorkforceBulkEditFormatExcel(simulationId: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).downloadSimulatingWorkforceBulkEditFormatExcel(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 既存人員の計画一括編集のアップロードファイルをダウンロードする
     * @param {string} historyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadSimulatingWorkforceBulkUploadFile(historyId: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).downloadSimulatingWorkforceBulkUploadFile(historyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulatingWorkforceConstraint(id: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).getSimulatingWorkforceConstraint(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} yearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulatingWorkforceCurrent(id: string, yearMonth: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).getSimulatingWorkforceCurrent(id, yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulatingWorkforceEvents(id: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).getSimulatingWorkforceEvents(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 既存人員の計画一括編集のアップロード履歴一覧を取得する
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSimulatingWorkforceBulkUploadHistories(simulationId: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).listSimulatingWorkforceBulkUploadHistories(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {ListSimulatingWorkforceConcurrentPostHistoriesBody} listSimulatingWorkforceConcurrentPostHistoriesBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSimulatingWorkforceConcurrentPostHistories(simulationId: string, listSimulatingWorkforceConcurrentPostHistoriesBody: ListSimulatingWorkforceConcurrentPostHistoriesBody, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).listSimulatingWorkforceConcurrentPostHistories(simulationId, listSimulatingWorkforceConcurrentPostHistoriesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {ListSimulatingWorkforceHistoriesBody} listSimulatingWorkforceHistoriesBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSimulatingWorkforceHistories(simulationId: string, listSimulatingWorkforceHistoriesBody: ListSimulatingWorkforceHistoriesBody, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).listSimulatingWorkforceHistories(simulationId, listSimulatingWorkforceHistoriesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateSimulatingWorkforceBody} updateSimulatingWorkforceBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSimulatingWorkforce(id: string, updateSimulatingWorkforceBody: UpdateSimulatingWorkforceBody, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).updateSimulatingWorkforce(id, updateSimulatingWorkforceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 既存人員の計画一括編集 Excel をアップロードする
     * @param {string} simulationId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadSimulatingWorkforceBulkEditExcel(simulationId: string, file: File, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceControllerApiFp(this.configuration).uploadSimulatingWorkforceBulkEditExcel(simulationId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SimulatingWorkforceSlotControllerApi - axios parameter creator
 */
export const SimulatingWorkforceSlotControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} simulationId 
         * @param {CreateSimulatingWorkforceSlotBody} createSimulatingWorkforceSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlot: async (simulationId: string, createSimulatingWorkforceSlotBody: CreateSimulatingWorkforceSlotBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('createSlot', 'simulationId', simulationId)
            // verify required parameter 'createSimulatingWorkforceSlotBody' is not null or undefined
            assertParamExists('createSlot', 'createSimulatingWorkforceSlotBody', createSimulatingWorkforceSlotBody)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/slots/create`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSimulatingWorkforceSlotBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {DeleteSimulatingSlotsBody} deleteSimulatingSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSimulatingSlots: async (simulationId: string, deleteSimulatingSlotsBody: DeleteSimulatingSlotsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deleteSimulatingSlots', 'simulationId', simulationId)
            // verify required parameter 'deleteSimulatingSlotsBody' is not null or undefined
            assertParamExists('deleteSimulatingSlots', 'deleteSimulatingSlotsBody', deleteSimulatingSlotsBody)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/slots`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSimulatingSlotsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画枠一括編集フォーマットExcelをダウンロードする
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSimulatingWorkforceSlotBulkEditFormatExcel: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('downloadSimulatingWorkforceSlotBulkEditFormatExcel', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/slots/bulk-edit/excel`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画枠一括編集のアップロードファイルをダウンロードする
         * @param {string} simulationId 
         * @param {string} historyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSimulatingWorkforceSlotBulkUploadFile: async (simulationId: string, historyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('downloadSimulatingWorkforceSlotBulkUploadFile', 'simulationId', simulationId)
            // verify required parameter 'historyId' is not null or undefined
            assertParamExists('downloadSimulatingWorkforceSlotBulkUploadFile', 'historyId', historyId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/slots/bulk-edit/upload-histories/{historyId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)))
                .replace('{historyId}', encodeURIComponent(String(historyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーション枠の実績内訳を取得する
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingSlotActualEventConnections: async (simulationId: string, simulatingSlotId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('listSimulatingSlotActualEventConnections', 'simulationId', simulationId)
            // verify required parameter 'simulatingSlotId' is not null or undefined
            assertParamExists('listSimulatingSlotActualEventConnections', 'simulatingSlotId', simulatingSlotId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/slots/{simulatingSlotId}/actual-event-connections`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)))
                .replace('{simulatingSlotId}', encodeURIComponent(String(simulatingSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画枠一括編集のアップロード履歴一覧を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingWorkforceSlotBulkUploadHistories: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('listSimulatingWorkforceSlotBulkUploadHistories', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/slots/bulk-edit/upload-histories`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {ListSimulatingWorkforceSlotsBody} listSimulatingWorkforceSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSlots: async (simulationId: string, listSimulatingWorkforceSlotsBody: ListSimulatingWorkforceSlotsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('listSlots', 'simulationId', simulationId)
            // verify required parameter 'listSimulatingWorkforceSlotsBody' is not null or undefined
            assertParamExists('listSlots', 'listSimulatingWorkforceSlotsBody', listSimulatingWorkforceSlotsBody)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/slots`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listSimulatingWorkforceSlotsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {UpdateWorkforceSimulationSlotBody} updateWorkforceSimulationSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlot: async (simulationId: string, simulatingSlotId: string, updateWorkforceSimulationSlotBody: UpdateWorkforceSimulationSlotBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateSlot', 'simulationId', simulationId)
            // verify required parameter 'simulatingSlotId' is not null or undefined
            assertParamExists('updateSlot', 'simulatingSlotId', simulatingSlotId)
            // verify required parameter 'updateWorkforceSimulationSlotBody' is not null or undefined
            assertParamExists('updateSlot', 'updateWorkforceSimulationSlotBody', updateWorkforceSimulationSlotBody)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/slots/{simulatingSlotId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)))
                .replace('{simulatingSlotId}', encodeURIComponent(String(simulatingSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkforceSimulationSlotBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画枠一括編集 Excel をアップロードする
         * @param {string} simulationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSimulatingWorkforceSlotBulkEditExcel: async (simulationId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('uploadSimulatingWorkforceSlotBulkEditExcel', 'simulationId', simulationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadSimulatingWorkforceSlotBulkEditExcel', 'file', file)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/slots/bulk-edit/excel`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimulatingWorkforceSlotControllerApi - functional programming interface
 */
export const SimulatingWorkforceSlotControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimulatingWorkforceSlotControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} simulationId 
         * @param {CreateSimulatingWorkforceSlotBody} createSimulatingWorkforceSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSlot(simulationId: string, createSimulatingWorkforceSlotBody: CreateSimulatingWorkforceSlotBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedSimulatingWorkforceSlotView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSlot(simulationId, createSimulatingWorkforceSlotBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceSlotControllerApi.createSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {DeleteSimulatingSlotsBody} deleteSimulatingSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSimulatingSlots(simulationId: string, deleteSimulatingSlotsBody: DeleteSimulatingSlotsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSimulatingSlots(simulationId, deleteSimulatingSlotsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceSlotControllerApi.deleteSimulatingSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画枠一括編集フォーマットExcelをダウンロードする
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSimulatingWorkforceSlotBulkEditFormatExcel(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSimulatingWorkforceSlotBulkEditFormatExcel(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceSlotControllerApi.downloadSimulatingWorkforceSlotBulkEditFormatExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画枠一括編集のアップロードファイルをダウンロードする
         * @param {string} simulationId 
         * @param {string} historyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSimulatingWorkforceSlotBulkUploadFile(simulationId: string, historyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSimulatingWorkforceSlotBulkUploadFile(simulationId, historyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceSlotControllerApi.downloadSimulatingWorkforceSlotBulkUploadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーション枠の実績内訳を取得する
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSimulatingSlotActualEventConnections(simulationId: string, simulatingSlotId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulatingWorkforceSlotActualEventConnectionsReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSimulatingSlotActualEventConnections(simulationId, simulatingSlotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceSlotControllerApi.listSimulatingSlotActualEventConnections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画枠一括編集のアップロード履歴一覧を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSimulatingWorkforceSlotBulkUploadHistories(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimulatingWorkforceSlotBulkUploadHistoryView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSimulatingWorkforceSlotBulkUploadHistories(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceSlotControllerApi.listSimulatingWorkforceSlotBulkUploadHistories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {ListSimulatingWorkforceSlotsBody} listSimulatingWorkforceSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSlots(simulationId: string, listSimulatingWorkforceSlotsBody: ListSimulatingWorkforceSlotsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulatingWorkforceSlotListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSlots(simulationId, listSimulatingWorkforceSlotsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceSlotControllerApi.listSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {UpdateWorkforceSimulationSlotBody} updateWorkforceSimulationSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlot(simulationId: string, simulatingSlotId: string, updateWorkforceSimulationSlotBody: UpdateWorkforceSimulationSlotBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlot(simulationId, simulatingSlotId, updateWorkforceSimulationSlotBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceSlotControllerApi.updateSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画枠一括編集 Excel をアップロードする
         * @param {string} simulationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSimulatingWorkforceSlotBulkEditExcel(simulationId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSimulatingWorkforceSlotBulkEditExcel(simulationId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulatingWorkforceSlotControllerApi.uploadSimulatingWorkforceSlotBulkEditExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SimulatingWorkforceSlotControllerApi - factory interface
 */
export const SimulatingWorkforceSlotControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimulatingWorkforceSlotControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} simulationId 
         * @param {CreateSimulatingWorkforceSlotBody} createSimulatingWorkforceSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlot(simulationId: string, createSimulatingWorkforceSlotBody: CreateSimulatingWorkforceSlotBody, options?: RawAxiosRequestConfig): AxiosPromise<CreatedSimulatingWorkforceSlotView> {
            return localVarFp.createSlot(simulationId, createSimulatingWorkforceSlotBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {DeleteSimulatingSlotsBody} deleteSimulatingSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSimulatingSlots(simulationId: string, deleteSimulatingSlotsBody: DeleteSimulatingSlotsBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteSimulatingSlots(simulationId, deleteSimulatingSlotsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画枠一括編集フォーマットExcelをダウンロードする
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSimulatingWorkforceSlotBulkEditFormatExcel(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSimulatingWorkforceSlotBulkEditFormatExcel(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画枠一括編集のアップロードファイルをダウンロードする
         * @param {string} simulationId 
         * @param {string} historyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSimulatingWorkforceSlotBulkUploadFile(simulationId: string, historyId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSimulatingWorkforceSlotBulkUploadFile(simulationId, historyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーション枠の実績内訳を取得する
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingSlotActualEventConnections(simulationId: string, simulatingSlotId: string, options?: RawAxiosRequestConfig): AxiosPromise<SimulatingWorkforceSlotActualEventConnectionsReturn> {
            return localVarFp.listSimulatingSlotActualEventConnections(simulationId, simulatingSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画枠一括編集のアップロード履歴一覧を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulatingWorkforceSlotBulkUploadHistories(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SimulatingWorkforceSlotBulkUploadHistoryView>> {
            return localVarFp.listSimulatingWorkforceSlotBulkUploadHistories(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {ListSimulatingWorkforceSlotsBody} listSimulatingWorkforceSlotsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSlots(simulationId: string, listSimulatingWorkforceSlotsBody: ListSimulatingWorkforceSlotsBody, options?: RawAxiosRequestConfig): AxiosPromise<SimulatingWorkforceSlotListView> {
            return localVarFp.listSlots(simulationId, listSimulatingWorkforceSlotsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {string} simulatingSlotId 
         * @param {UpdateWorkforceSimulationSlotBody} updateWorkforceSimulationSlotBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlot(simulationId: string, simulatingSlotId: string, updateWorkforceSimulationSlotBody: UpdateWorkforceSimulationSlotBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateSlot(simulationId, simulatingSlotId, updateWorkforceSimulationSlotBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画枠一括編集 Excel をアップロードする
         * @param {string} simulationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSimulatingWorkforceSlotBulkEditExcel(simulationId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadSimulatingWorkforceSlotBulkEditExcel(simulationId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimulatingWorkforceSlotControllerApi - object-oriented interface
 */
export class SimulatingWorkforceSlotControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} simulationId 
     * @param {CreateSimulatingWorkforceSlotBody} createSimulatingWorkforceSlotBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSlot(simulationId: string, createSimulatingWorkforceSlotBody: CreateSimulatingWorkforceSlotBody, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceSlotControllerApiFp(this.configuration).createSlot(simulationId, createSimulatingWorkforceSlotBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {DeleteSimulatingSlotsBody} deleteSimulatingSlotsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSimulatingSlots(simulationId: string, deleteSimulatingSlotsBody: DeleteSimulatingSlotsBody, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceSlotControllerApiFp(this.configuration).deleteSimulatingSlots(simulationId, deleteSimulatingSlotsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画枠一括編集フォーマットExcelをダウンロードする
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadSimulatingWorkforceSlotBulkEditFormatExcel(simulationId: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceSlotControllerApiFp(this.configuration).downloadSimulatingWorkforceSlotBulkEditFormatExcel(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画枠一括編集のアップロードファイルをダウンロードする
     * @param {string} simulationId 
     * @param {string} historyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadSimulatingWorkforceSlotBulkUploadFile(simulationId: string, historyId: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceSlotControllerApiFp(this.configuration).downloadSimulatingWorkforceSlotBulkUploadFile(simulationId, historyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーション枠の実績内訳を取得する
     * @param {string} simulationId 
     * @param {string} simulatingSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSimulatingSlotActualEventConnections(simulationId: string, simulatingSlotId: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceSlotControllerApiFp(this.configuration).listSimulatingSlotActualEventConnections(simulationId, simulatingSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画枠一括編集のアップロード履歴一覧を取得する
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSimulatingWorkforceSlotBulkUploadHistories(simulationId: string, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceSlotControllerApiFp(this.configuration).listSimulatingWorkforceSlotBulkUploadHistories(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {ListSimulatingWorkforceSlotsBody} listSimulatingWorkforceSlotsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSlots(simulationId: string, listSimulatingWorkforceSlotsBody: ListSimulatingWorkforceSlotsBody, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceSlotControllerApiFp(this.configuration).listSlots(simulationId, listSimulatingWorkforceSlotsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {string} simulatingSlotId 
     * @param {UpdateWorkforceSimulationSlotBody} updateWorkforceSimulationSlotBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSlot(simulationId: string, simulatingSlotId: string, updateWorkforceSimulationSlotBody: UpdateWorkforceSimulationSlotBody, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceSlotControllerApiFp(this.configuration).updateSlot(simulationId, simulatingSlotId, updateWorkforceSimulationSlotBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画枠一括編集 Excel をアップロードする
     * @param {string} simulationId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadSimulatingWorkforceSlotBulkEditExcel(simulationId: string, file: File, options?: RawAxiosRequestConfig) {
        return SimulatingWorkforceSlotControllerApiFp(this.configuration).uploadSimulatingWorkforceSlotBulkEditExcel(simulationId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SimulationWorkforcePlanUpdateRequestControllerApi - axios parameter creator
 */
export const SimulationWorkforcePlanUpdateRequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetPlanningProjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-plannings/simulations/target-planning-projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {SimulationPlanUpdateRequestBody} simulationPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPlanUpdateRequestFromSimulation: async (simulationId: string, simulationPlanUpdateRequestBody: SimulationPlanUpdateRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('submitPlanUpdateRequestFromSimulation', 'simulationId', simulationId)
            // verify required parameter 'simulationPlanUpdateRequestBody' is not null or undefined
            assertParamExists('submitPlanUpdateRequestFromSimulation', 'simulationPlanUpdateRequestBody', simulationPlanUpdateRequestBody)
            const localVarPath = `/api/workforce-plannings/simulations/{simulationId}/workforce-plan-update-requests/submit`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulationPlanUpdateRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimulationWorkforcePlanUpdateRequestControllerApi - functional programming interface
 */
export const SimulationWorkforcePlanUpdateRequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimulationWorkforcePlanUpdateRequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTargetPlanningProjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenWorkforcePlanUpdateRequestTargetPlanningProjects>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTargetPlanningProjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationWorkforcePlanUpdateRequestControllerApi.getTargetPlanningProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {SimulationPlanUpdateRequestBody} simulationPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitPlanUpdateRequestFromSimulation(simulationId: string, simulationPlanUpdateRequestBody: SimulationPlanUpdateRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitPlanUpdateRequestFromSimulation(simulationId, simulationPlanUpdateRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimulationWorkforcePlanUpdateRequestControllerApi.submitPlanUpdateRequestFromSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SimulationWorkforcePlanUpdateRequestControllerApi - factory interface
 */
export const SimulationWorkforcePlanUpdateRequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimulationWorkforcePlanUpdateRequestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetPlanningProjects(options?: RawAxiosRequestConfig): AxiosPromise<OpenWorkforcePlanUpdateRequestTargetPlanningProjects> {
            return localVarFp.getTargetPlanningProjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {SimulationPlanUpdateRequestBody} simulationPlanUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPlanUpdateRequestFromSimulation(simulationId: string, simulationPlanUpdateRequestBody: SimulationPlanUpdateRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.submitPlanUpdateRequestFromSimulation(simulationId, simulationPlanUpdateRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimulationWorkforcePlanUpdateRequestControllerApi - object-oriented interface
 */
export class SimulationWorkforcePlanUpdateRequestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTargetPlanningProjects(options?: RawAxiosRequestConfig) {
        return SimulationWorkforcePlanUpdateRequestControllerApiFp(this.configuration).getTargetPlanningProjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {SimulationPlanUpdateRequestBody} simulationPlanUpdateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitPlanUpdateRequestFromSimulation(simulationId: string, simulationPlanUpdateRequestBody: SimulationPlanUpdateRequestBody, options?: RawAxiosRequestConfig) {
        return SimulationWorkforcePlanUpdateRequestControllerApiFp(this.configuration).submitPlanUpdateRequestFromSimulation(simulationId, simulationPlanUpdateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantsControllerApi - axios parameter creator
 */
export const TenantsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary テナントの情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenant: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantsControllerApi - functional programming interface
 */
export const TenantsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary テナントの情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenant(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenant(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantsControllerApi.getTenant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantsControllerApi - factory interface
 */
export const TenantsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary テナントの情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenant(options?: RawAxiosRequestConfig): AxiosPromise<TenantView> {
            return localVarFp.getTenant(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantsControllerApi - object-oriented interface
 */
export class TenantsControllerApi extends BaseAPI {
    /**
     * 
     * @summary テナントの情報を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTenant(options?: RawAxiosRequestConfig) {
        return TenantsControllerApiFp(this.configuration).getTenant(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransferStepControllerApi - axios parameter creator
 */
export const TransferStepControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 振替ステップの作成
         * @param {string} ruleId 
         * @param {CreateTransferStepRequestBody} createTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransferStep: async (ruleId: string, createTransferStepRequestBody: CreateTransferStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('createTransferStep', 'ruleId', ruleId)
            // verify required parameter 'createTransferStepRequestBody' is not null or undefined
            assertParamExists('createTransferStep', 'createTransferStepRequestBody', createTransferStepRequestBody)
            const localVarPath = `/api/allocations/rules/{ruleId}/transfer-steps`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTransferStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替ステップの取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTransferStep: async (ruleId: string, stepId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('findTransferStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('findTransferStep', 'stepId', stepId)
            const localVarPath = `/api/allocations/rules/{ruleId}/transfer-steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 振替ステップの更新
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateTransferStepRequestBody} updateTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferStep: async (ruleId: string, stepId: string, updateTransferStepRequestBody: UpdateTransferStepRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateTransferStep', 'ruleId', ruleId)
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('updateTransferStep', 'stepId', stepId)
            // verify required parameter 'updateTransferStepRequestBody' is not null or undefined
            assertParamExists('updateTransferStep', 'updateTransferStepRequestBody', updateTransferStepRequestBody)
            const localVarPath = `/api/allocations/rules/{ruleId}/transfer-steps/{stepId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)))
                .replace('{stepId}', encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTransferStepRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransferStepControllerApi - functional programming interface
 */
export const TransferStepControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransferStepControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 振替ステップの作成
         * @param {string} ruleId 
         * @param {CreateTransferStepRequestBody} createTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransferStep(ruleId: string, createTransferStepRequestBody: CreateTransferStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransferStep(ruleId, createTransferStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferStepControllerApi.createTransferStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替ステップの取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTransferStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferStepView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTransferStep(ruleId, stepId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferStepControllerApi.findTransferStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 振替ステップの更新
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateTransferStepRequestBody} updateTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransferStep(ruleId: string, stepId: string, updateTransferStepRequestBody: UpdateTransferStepRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransferStep(ruleId, stepId, updateTransferStepRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferStepControllerApi.updateTransferStep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransferStepControllerApi - factory interface
 */
export const TransferStepControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransferStepControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 振替ステップの作成
         * @param {string} ruleId 
         * @param {CreateTransferStepRequestBody} createTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransferStep(ruleId: string, createTransferStepRequestBody: CreateTransferStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createTransferStep(ruleId, createTransferStepRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替ステップの取得
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTransferStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferStepView> {
            return localVarFp.findTransferStep(ruleId, stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 振替ステップの更新
         * @param {string} ruleId 
         * @param {string} stepId 
         * @param {UpdateTransferStepRequestBody} updateTransferStepRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferStep(ruleId: string, stepId: string, updateTransferStepRequestBody: UpdateTransferStepRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateTransferStep(ruleId, stepId, updateTransferStepRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransferStepControllerApi - object-oriented interface
 */
export class TransferStepControllerApi extends BaseAPI {
    /**
     * 
     * @summary 振替ステップの作成
     * @param {string} ruleId 
     * @param {CreateTransferStepRequestBody} createTransferStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTransferStep(ruleId: string, createTransferStepRequestBody: CreateTransferStepRequestBody, options?: RawAxiosRequestConfig) {
        return TransferStepControllerApiFp(this.configuration).createTransferStep(ruleId, createTransferStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替ステップの取得
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findTransferStep(ruleId: string, stepId: string, options?: RawAxiosRequestConfig) {
        return TransferStepControllerApiFp(this.configuration).findTransferStep(ruleId, stepId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 振替ステップの更新
     * @param {string} ruleId 
     * @param {string} stepId 
     * @param {UpdateTransferStepRequestBody} updateTransferStepRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTransferStep(ruleId: string, stepId: string, updateTransferStepRequestBody: UpdateTransferStepRequestBody, options?: RawAxiosRequestConfig) {
        return TransferStepControllerApiFp(this.configuration).updateTransferStep(ruleId, stepId, updateTransferStepRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnitAmountControllerApi - axios parameter creator
 */
export const UnitAmountControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人件費単価一覧をダウンロードする
         * @param {string} yearMonth 
         * @param {boolean} [withoutUnitAmountOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUnitAmountExcel: async (yearMonth: string, withoutUnitAmountOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('downloadUnitAmountExcel', 'yearMonth', yearMonth)
            const localVarPath = `/api/workforce-planning/unit-amount/download/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (withoutUnitAmountOnly !== undefined) {
                localVarQueryParameter['withoutUnitAmountOnly'] = withoutUnitAmountOnly;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定した年月の単価が設定されていない人員のリストを取得する
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforcesWithoutUnitAmount: async (yearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('listWorkforcesWithoutUnitAmount', 'yearMonth', yearMonth)
            const localVarPath = `/api/workforce-planning/unit-amount/workforces-without-unit-amount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人件費単価一覧を検索する
         * @param {SearchUnitAmountRequestBody} searchUnitAmountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUnitAmount: async (searchUnitAmountRequestBody: SearchUnitAmountRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchUnitAmountRequestBody' is not null or undefined
            assertParamExists('searchUnitAmount', 'searchUnitAmountRequestBody', searchUnitAmountRequestBody)
            const localVarPath = `/api/workforce-planning/unit-amount/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchUnitAmountRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人件費単価の一括登録/更新の Excel ファイルをアップロードする
         * @param {string} yearMonth 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUnitAmountExcel: async (yearMonth: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('uploadUnitAmountExcel', 'yearMonth', yearMonth)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadUnitAmountExcel', 'file', file)
            const localVarPath = `/api/workforce-planning/unit-amount/upload/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitAmountControllerApi - functional programming interface
 */
export const UnitAmountControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitAmountControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人件費単価一覧をダウンロードする
         * @param {string} yearMonth 
         * @param {boolean} [withoutUnitAmountOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadUnitAmountExcel(yearMonth: string, withoutUnitAmountOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadUnitAmountExcel(yearMonth, withoutUnitAmountOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitAmountControllerApi.downloadUnitAmountExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定した年月の単価が設定されていない人員のリストを取得する
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkforcesWithoutUnitAmount(yearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceWithoutUnitAmountItems>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkforcesWithoutUnitAmount(yearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitAmountControllerApi.listWorkforcesWithoutUnitAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人件費単価一覧を検索する
         * @param {SearchUnitAmountRequestBody} searchUnitAmountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUnitAmount(searchUnitAmountRequestBody: SearchUnitAmountRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoUnitAmountListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUnitAmount(searchUnitAmountRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitAmountControllerApi.searchUnitAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人件費単価の一括登録/更新の Excel ファイルをアップロードする
         * @param {string} yearMonth 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadUnitAmountExcel(yearMonth: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadUnitAmountExcel(yearMonth, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitAmountControllerApi.uploadUnitAmountExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnitAmountControllerApi - factory interface
 */
export const UnitAmountControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitAmountControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人件費単価一覧をダウンロードする
         * @param {string} yearMonth 
         * @param {boolean} [withoutUnitAmountOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUnitAmountExcel(yearMonth: string, withoutUnitAmountOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadUnitAmountExcel(yearMonth, withoutUnitAmountOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定した年月の単価が設定されていない人員のリストを取得する
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforcesWithoutUnitAmount(yearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforceWithoutUnitAmountItems> {
            return localVarFp.listWorkforcesWithoutUnitAmount(yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人件費単価一覧を検索する
         * @param {SearchUnitAmountRequestBody} searchUnitAmountRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUnitAmount(searchUnitAmountRequestBody: SearchUnitAmountRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoUnitAmountListItem> {
            return localVarFp.searchUnitAmount(searchUnitAmountRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人件費単価の一括登録/更新の Excel ファイルをアップロードする
         * @param {string} yearMonth 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUnitAmountExcel(yearMonth: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadUnitAmountExcel(yearMonth, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnitAmountControllerApi - object-oriented interface
 */
export class UnitAmountControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人件費単価一覧をダウンロードする
     * @param {string} yearMonth 
     * @param {boolean} [withoutUnitAmountOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadUnitAmountExcel(yearMonth: string, withoutUnitAmountOnly?: boolean, options?: RawAxiosRequestConfig) {
        return UnitAmountControllerApiFp(this.configuration).downloadUnitAmountExcel(yearMonth, withoutUnitAmountOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定した年月の単価が設定されていない人員のリストを取得する
     * @param {string} yearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkforcesWithoutUnitAmount(yearMonth: string, options?: RawAxiosRequestConfig) {
        return UnitAmountControllerApiFp(this.configuration).listWorkforcesWithoutUnitAmount(yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人件費単価一覧を検索する
     * @param {SearchUnitAmountRequestBody} searchUnitAmountRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUnitAmount(searchUnitAmountRequestBody: SearchUnitAmountRequestBody, options?: RawAxiosRequestConfig) {
        return UnitAmountControllerApiFp(this.configuration).searchUnitAmount(searchUnitAmountRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人件費単価の一括登録/更新の Excel ファイルをアップロードする
     * @param {string} yearMonth 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadUnitAmountExcel(yearMonth: string, file: File, options?: RawAxiosRequestConfig) {
        return UnitAmountControllerApiFp(this.configuration).uploadUnitAmountExcel(yearMonth, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnitPriceMasterItemDimensionMappingControllerApi - axios parameter creator
 */
export const UnitPriceMasterItemDimensionMappingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 単価項目分析軸マッピングに紐づく分析軸を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMappedDimensionForUnitPriceMasterItem: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/unit-price-master-item-dimension-mapping/mapped-dimension`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単価項目分析軸マッピングを作成もしくは更新する
         * @param {UpsertUnitPriceMasterItemDimensionMappingRequest} upsertUnitPriceMasterItemDimensionMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertUnitPriceMasterItemDimensionMapping: async (upsertUnitPriceMasterItemDimensionMappingRequest: UpsertUnitPriceMasterItemDimensionMappingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertUnitPriceMasterItemDimensionMappingRequest' is not null or undefined
            assertParamExists('upsertUnitPriceMasterItemDimensionMapping', 'upsertUnitPriceMasterItemDimensionMappingRequest', upsertUnitPriceMasterItemDimensionMappingRequest)
            const localVarPath = `/api/unit-price-master-item-dimension-mapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertUnitPriceMasterItemDimensionMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitPriceMasterItemDimensionMappingControllerApi - functional programming interface
 */
export const UnitPriceMasterItemDimensionMappingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitPriceMasterItemDimensionMappingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 単価項目分析軸マッピングに紐づく分析軸を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMappedDimensionForUnitPriceMasterItem(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MappedDimensionForUnitPriceMasterItemView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMappedDimensionForUnitPriceMasterItem(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitPriceMasterItemDimensionMappingControllerApi.fetchMappedDimensionForUnitPriceMasterItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単価項目分析軸マッピングを作成もしくは更新する
         * @param {UpsertUnitPriceMasterItemDimensionMappingRequest} upsertUnitPriceMasterItemDimensionMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertUnitPriceMasterItemDimensionMapping(upsertUnitPriceMasterItemDimensionMappingRequest: UpsertUnitPriceMasterItemDimensionMappingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertUnitPriceMasterItemDimensionMapping(upsertUnitPriceMasterItemDimensionMappingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitPriceMasterItemDimensionMappingControllerApi.upsertUnitPriceMasterItemDimensionMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnitPriceMasterItemDimensionMappingControllerApi - factory interface
 */
export const UnitPriceMasterItemDimensionMappingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitPriceMasterItemDimensionMappingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 単価項目分析軸マッピングに紐づく分析軸を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMappedDimensionForUnitPriceMasterItem(options?: RawAxiosRequestConfig): AxiosPromise<MappedDimensionForUnitPriceMasterItemView> {
            return localVarFp.fetchMappedDimensionForUnitPriceMasterItem(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単価項目分析軸マッピングを作成もしくは更新する
         * @param {UpsertUnitPriceMasterItemDimensionMappingRequest} upsertUnitPriceMasterItemDimensionMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertUnitPriceMasterItemDimensionMapping(upsertUnitPriceMasterItemDimensionMappingRequest: UpsertUnitPriceMasterItemDimensionMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.upsertUnitPriceMasterItemDimensionMapping(upsertUnitPriceMasterItemDimensionMappingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnitPriceMasterItemDimensionMappingControllerApi - object-oriented interface
 */
export class UnitPriceMasterItemDimensionMappingControllerApi extends BaseAPI {
    /**
     * 
     * @summary 単価項目分析軸マッピングに紐づく分析軸を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchMappedDimensionForUnitPriceMasterItem(options?: RawAxiosRequestConfig) {
        return UnitPriceMasterItemDimensionMappingControllerApiFp(this.configuration).fetchMappedDimensionForUnitPriceMasterItem(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単価項目分析軸マッピングを作成もしくは更新する
     * @param {UpsertUnitPriceMasterItemDimensionMappingRequest} upsertUnitPriceMasterItemDimensionMappingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upsertUnitPriceMasterItemDimensionMapping(upsertUnitPriceMasterItemDimensionMappingRequest: UpsertUnitPriceMasterItemDimensionMappingRequest, options?: RawAxiosRequestConfig) {
        return UnitPriceMasterItemDimensionMappingControllerApiFp(this.configuration).upsertUnitPriceMasterItemDimensionMapping(upsertUnitPriceMasterItemDimensionMappingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnitPriceMasterItemsControllerApi - axios parameter creator
 */
export const UnitPriceMasterItemsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 単価項目を新規作成する
         * @param {CreateUnitPriceMasterItemRequest} createUnitPriceMasterItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnitPriceMasterItem: async (createUnitPriceMasterItemRequest: CreateUnitPriceMasterItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUnitPriceMasterItemRequest' is not null or undefined
            assertParamExists('createUnitPriceMasterItem', 'createUnitPriceMasterItemRequest', createUnitPriceMasterItemRequest)
            const localVarPath = `/api/unit-price-master-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUnitPriceMasterItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単価項目を削除する
         * @param {string} unitPriceMasterItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnitPriceMasterItem: async (unitPriceMasterItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitPriceMasterItemId' is not null or undefined
            assertParamExists('deleteUnitPriceMasterItem', 'unitPriceMasterItemId', unitPriceMasterItemId)
            const localVarPath = `/api/unit-price-master-items/{unitPriceMasterItemId}`
                .replace('{unitPriceMasterItemId}', encodeURIComponent(String(unitPriceMasterItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 全ての単価項目を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllUnitPriceMasterItems: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/unit-price-master-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単価項目を更新する
         * @param {string} unitPriceMasterItemId 
         * @param {UpdateUnitPriceMasterItemParam} updateUnitPriceMasterItemParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnitPriceMasterItem: async (unitPriceMasterItemId: string, updateUnitPriceMasterItemParam: UpdateUnitPriceMasterItemParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitPriceMasterItemId' is not null or undefined
            assertParamExists('updateUnitPriceMasterItem', 'unitPriceMasterItemId', unitPriceMasterItemId)
            // verify required parameter 'updateUnitPriceMasterItemParam' is not null or undefined
            assertParamExists('updateUnitPriceMasterItem', 'updateUnitPriceMasterItemParam', updateUnitPriceMasterItemParam)
            const localVarPath = `/api/unit-price-master-items/{unitPriceMasterItemId}`
                .replace('{unitPriceMasterItemId}', encodeURIComponent(String(unitPriceMasterItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUnitPriceMasterItemParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitPriceMasterItemsControllerApi - functional programming interface
 */
export const UnitPriceMasterItemsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitPriceMasterItemsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 単価項目を新規作成する
         * @param {CreateUnitPriceMasterItemRequest} createUnitPriceMasterItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUnitPriceMasterItem(createUnitPriceMasterItemRequest: CreateUnitPriceMasterItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUnitPriceMasterItem(createUnitPriceMasterItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitPriceMasterItemsControllerApi.createUnitPriceMasterItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単価項目を削除する
         * @param {string} unitPriceMasterItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUnitPriceMasterItem(unitPriceMasterItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUnitPriceMasterItem(unitPriceMasterItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitPriceMasterItemsControllerApi.deleteUnitPriceMasterItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 全ての単価項目を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllUnitPriceMasterItems(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitPriceMasterItemListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllUnitPriceMasterItems(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitPriceMasterItemsControllerApi.fetchAllUnitPriceMasterItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単価項目を更新する
         * @param {string} unitPriceMasterItemId 
         * @param {UpdateUnitPriceMasterItemParam} updateUnitPriceMasterItemParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUnitPriceMasterItem(unitPriceMasterItemId: string, updateUnitPriceMasterItemParam: UpdateUnitPriceMasterItemParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUnitPriceMasterItem(unitPriceMasterItemId, updateUnitPriceMasterItemParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitPriceMasterItemsControllerApi.updateUnitPriceMasterItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnitPriceMasterItemsControllerApi - factory interface
 */
export const UnitPriceMasterItemsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitPriceMasterItemsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 単価項目を新規作成する
         * @param {CreateUnitPriceMasterItemRequest} createUnitPriceMasterItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnitPriceMasterItem(createUnitPriceMasterItemRequest: CreateUnitPriceMasterItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createUnitPriceMasterItem(createUnitPriceMasterItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単価項目を削除する
         * @param {string} unitPriceMasterItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnitPriceMasterItem(unitPriceMasterItemId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteUnitPriceMasterItem(unitPriceMasterItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 全ての単価項目を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllUnitPriceMasterItems(options?: RawAxiosRequestConfig): AxiosPromise<UnitPriceMasterItemListView> {
            return localVarFp.fetchAllUnitPriceMasterItems(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単価項目を更新する
         * @param {string} unitPriceMasterItemId 
         * @param {UpdateUnitPriceMasterItemParam} updateUnitPriceMasterItemParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnitPriceMasterItem(unitPriceMasterItemId: string, updateUnitPriceMasterItemParam: UpdateUnitPriceMasterItemParam, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateUnitPriceMasterItem(unitPriceMasterItemId, updateUnitPriceMasterItemParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnitPriceMasterItemsControllerApi - object-oriented interface
 */
export class UnitPriceMasterItemsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 単価項目を新規作成する
     * @param {CreateUnitPriceMasterItemRequest} createUnitPriceMasterItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUnitPriceMasterItem(createUnitPriceMasterItemRequest: CreateUnitPriceMasterItemRequest, options?: RawAxiosRequestConfig) {
        return UnitPriceMasterItemsControllerApiFp(this.configuration).createUnitPriceMasterItem(createUnitPriceMasterItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単価項目を削除する
     * @param {string} unitPriceMasterItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUnitPriceMasterItem(unitPriceMasterItemId: string, options?: RawAxiosRequestConfig) {
        return UnitPriceMasterItemsControllerApiFp(this.configuration).deleteUnitPriceMasterItem(unitPriceMasterItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 全ての単価項目を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllUnitPriceMasterItems(options?: RawAxiosRequestConfig) {
        return UnitPriceMasterItemsControllerApiFp(this.configuration).fetchAllUnitPriceMasterItems(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単価項目を更新する
     * @param {string} unitPriceMasterItemId 
     * @param {UpdateUnitPriceMasterItemParam} updateUnitPriceMasterItemParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUnitPriceMasterItem(unitPriceMasterItemId: string, updateUnitPriceMasterItemParam: UpdateUnitPriceMasterItemParam, options?: RawAxiosRequestConfig) {
        return UnitPriceMasterItemsControllerApiFp(this.configuration).updateUnitPriceMasterItem(unitPriceMasterItemId, updateUnitPriceMasterItemParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnitPricesControllerApi - axios parameter creator
 */
export const UnitPricesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 単価の一括登録・更新をするフォーマットをダウンロードする
         * @param {string} targetYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUnitPriceExcel: async (targetYearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetYearMonth' is not null or undefined
            assertParamExists('downloadUnitPriceExcel', 'targetYearMonth', targetYearMonth)
            const localVarPath = `/api/unit-prices/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetYearMonth !== undefined) {
                localVarQueryParameter['targetYearMonth'] = targetYearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定した項目の全ての単価を取得する
         * @param {string} unitPriceMasterItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllUnitPrices: async (unitPriceMasterItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitPriceMasterItemId' is not null or undefined
            assertParamExists('fetchAllUnitPrices', 'unitPriceMasterItemId', unitPriceMasterItemId)
            const localVarPath = `/api/unit-prices/{unitPriceMasterItemId}`
                .replace('{unitPriceMasterItemId}', encodeURIComponent(String(unitPriceMasterItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Excelアップロードで単価の一括作成・更新・削除を行う
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUnitPriceExcel: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadUnitPriceExcel', 'file', file)
            const localVarPath = `/api/unit-prices/bulk-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitPricesControllerApi - functional programming interface
 */
export const UnitPricesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitPricesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 単価の一括登録・更新をするフォーマットをダウンロードする
         * @param {string} targetYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadUnitPriceExcel(targetYearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadUnitPriceExcel(targetYearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitPricesControllerApi.downloadUnitPriceExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定した項目の全ての単価を取得する
         * @param {string} unitPriceMasterItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllUnitPrices(unitPriceMasterItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitPriceListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllUnitPrices(unitPriceMasterItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitPricesControllerApi.fetchAllUnitPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Excelアップロードで単価の一括作成・更新・削除を行う
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadUnitPriceExcel(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadUnitPriceExcel(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnitPricesControllerApi.uploadUnitPriceExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnitPricesControllerApi - factory interface
 */
export const UnitPricesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitPricesControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 単価の一括登録・更新をするフォーマットをダウンロードする
         * @param {string} targetYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUnitPriceExcel(targetYearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadUnitPriceExcel(targetYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定した項目の全ての単価を取得する
         * @param {string} unitPriceMasterItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllUnitPrices(unitPriceMasterItemId: string, options?: RawAxiosRequestConfig): AxiosPromise<UnitPriceListView> {
            return localVarFp.fetchAllUnitPrices(unitPriceMasterItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Excelアップロードで単価の一括作成・更新・削除を行う
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUnitPriceExcel(file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadUnitPriceExcel(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnitPricesControllerApi - object-oriented interface
 */
export class UnitPricesControllerApi extends BaseAPI {
    /**
     * 
     * @summary 単価の一括登録・更新をするフォーマットをダウンロードする
     * @param {string} targetYearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadUnitPriceExcel(targetYearMonth: string, options?: RawAxiosRequestConfig) {
        return UnitPricesControllerApiFp(this.configuration).downloadUnitPriceExcel(targetYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定した項目の全ての単価を取得する
     * @param {string} unitPriceMasterItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllUnitPrices(unitPriceMasterItemId: string, options?: RawAxiosRequestConfig) {
        return UnitPricesControllerApiFp(this.configuration).fetchAllUnitPrices(unitPriceMasterItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Excelアップロードで単価の一括作成・更新・削除を行う
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadUnitPriceExcel(file: File, options?: RawAxiosRequestConfig) {
        return UnitPricesControllerApiFp(this.configuration).uploadUnitPriceExcel(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserControllerApi - axios parameter creator
 */
export const UserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ユーザーを再登録する
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('activateUser', 'userId', userId)
            const localVarPath = `/api/users/{userId}/activate`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 契約ユーザー数とアクティブユーザー数の一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countActiveUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーを削除する
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/api/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー一括追加Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBulkCreateUsersExcel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー一覧Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsersListExcel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/list/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログイン中のユーザー情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログイン中のユーザーのメール通知の個人設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserEmailNotificationSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/current/email-notification-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー情報を返却する
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRole: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserRole', 'userId', userId)
            const localVarPath = `/api/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーを招待する
         * @param {CreateUserParam} createUserParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (createUserParam: CreateUserParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserParam' is not null or undefined
            assertParamExists('inviteUser', 'createUserParam', createUserParam)
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーのGoogleアカウントをリンクする
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkWithGoogleAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ソーシャルログインの状況を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialLogins: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーIDと氏名の対応一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserNames: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/user-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー一覧
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {boolean} [isActive] 
         * @param {string} [nameOrEmailOrAssignments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (limit?: number, offset?: number, isActive?: boolean, nameOrEmailOrAssignments?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }

            if (nameOrEmailOrAssignments !== undefined) {
                localVarQueryParameter['nameOrEmailOrAssignments'] = nameOrEmailOrAssignments;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーの多要素認証をリセットする
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserMfa: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetUserMfa', 'userId', userId)
            const localVarPath = `/api/users/{userId}/reset-mfa`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーのGoogleアカウントのリンクを解除する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkGoogleAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログイン中のユーザーのメール通知の個人設定を更新する
         * @param {UpdateCurrentUserEmailNotificationSettingsParam} updateCurrentUserEmailNotificationSettingsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUserEmailNotificationSettings: async (updateCurrentUserEmailNotificationSettingsParam: UpdateCurrentUserEmailNotificationSettingsParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCurrentUserEmailNotificationSettingsParam' is not null or undefined
            assertParamExists('updateCurrentUserEmailNotificationSettings', 'updateCurrentUserEmailNotificationSettingsParam', updateCurrentUserEmailNotificationSettingsParam)
            const localVarPath = `/api/users/current/email-notification-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCurrentUserEmailNotificationSettingsParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーを更新する
         * @param {string} userId 
         * @param {EditUserParam} editUserParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRole: async (userId: string, editUserParam: EditUserParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserRole', 'userId', userId)
            // verify required parameter 'editUserParam' is not null or undefined
            assertParamExists('updateUserRole', 'editUserParam', editUserParam)
            const localVarPath = `/api/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editUserParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー一括追加Excelのアップロード
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBulkCreateUsersExcel: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadBulkCreateUsersExcel', 'file', file)
            const localVarPath = `/api/users/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserControllerApi - functional programming interface
 */
export const UserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ユーザーを再登録する
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.activateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 契約ユーザー数とアクティブユーザー数の一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countActiveUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractUserTypeAndActiveUserCountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countActiveUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.countActiveUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザーを削除する
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザー一括追加Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBulkCreateUsersExcel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBulkCreateUsersExcel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.downloadBulkCreateUsersExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザー一覧Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadUsersListExcel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadUsersListExcel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.downloadUsersListExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ログイン中のユーザー情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUserView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ログイン中のユーザーのメール通知の個人設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserEmailNotificationSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUserEmailNotificationSettingsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserEmailNotificationSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getCurrentUserEmailNotificationSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザー情報を返却する
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRole(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithMfaMethodView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRole(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザーを招待する
         * @param {CreateUserParam} createUserParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(createUserParam: CreateUserParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUser(createUserParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.inviteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザーのGoogleアカウントをリンクする
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkWithGoogleAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkWithGoogleAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.linkWithGoogleAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ソーシャルログインの状況を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSocialLogins(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SocialLoginsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSocialLogins(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.listSocialLogins']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザーIDと氏名の対応一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserNames(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserNameView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserNames(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.listUserNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザー一覧
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {boolean} [isActive] 
         * @param {string} [nameOrEmailOrAssignments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(limit?: number, offset?: number, isActive?: boolean, nameOrEmailOrAssignments?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDtoUserWithDepartmentNamesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(limit, offset, isActive, nameOrEmailOrAssignments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.listUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザーの多要素認証をリセットする
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserMfa(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserMfa(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.resetUserMfa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザーのGoogleアカウントのリンクを解除する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkGoogleAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkGoogleAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.unlinkGoogleAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ログイン中のユーザーのメール通知の個人設定を更新する
         * @param {UpdateCurrentUserEmailNotificationSettingsParam} updateCurrentUserEmailNotificationSettingsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCurrentUserEmailNotificationSettings(updateCurrentUserEmailNotificationSettingsParam: UpdateCurrentUserEmailNotificationSettingsParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCurrentUserEmailNotificationSettings(updateCurrentUserEmailNotificationSettingsParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateCurrentUserEmailNotificationSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザーを更新する
         * @param {string} userId 
         * @param {EditUserParam} editUserParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRole(userId: string, editUserParam: EditUserParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithMfaMethodView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRole(userId, editUserParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザー一括追加Excelのアップロード
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBulkCreateUsersExcel(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBulkCreateUsersExcel(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.uploadBulkCreateUsersExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserControllerApi - factory interface
 */
export const UserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ユーザーを再登録する
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserView> {
            return localVarFp.activateUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 契約ユーザー数とアクティブユーザー数の一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countActiveUsers(options?: RawAxiosRequestConfig): AxiosPromise<ContractUserTypeAndActiveUserCountDto> {
            return localVarFp.countActiveUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーを削除する
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserView> {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー一括追加Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBulkCreateUsersExcel(options?: RawAxiosRequestConfig): AxiosPromise<ModelAndView> {
            return localVarFp.downloadBulkCreateUsersExcel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー一覧Excelのダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsersListExcel(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadUsersListExcel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ログイン中のユーザー情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<CurrentUserView> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ログイン中のユーザーのメール通知の個人設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserEmailNotificationSettings(options?: RawAxiosRequestConfig): AxiosPromise<CurrentUserEmailNotificationSettingsView> {
            return localVarFp.getCurrentUserEmailNotificationSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー情報を返却する
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRole(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserWithMfaMethodView> {
            return localVarFp.getUserRole(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーを招待する
         * @param {CreateUserParam} createUserParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(createUserParam: CreateUserParam, options?: RawAxiosRequestConfig): AxiosPromise<UserView> {
            return localVarFp.inviteUser(createUserParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーのGoogleアカウントをリンクする
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkWithGoogleAccount(options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.linkWithGoogleAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ソーシャルログインの状況を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSocialLogins(options?: RawAxiosRequestConfig): AxiosPromise<SocialLoginsDto> {
            return localVarFp.listSocialLogins(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーIDと氏名の対応一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserNames(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserNameView>> {
            return localVarFp.listUserNames(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー一覧
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {boolean} [isActive] 
         * @param {string} [nameOrEmailOrAssignments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(limit?: number, offset?: number, isActive?: boolean, nameOrEmailOrAssignments?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageDtoUserWithDepartmentNamesDto> {
            return localVarFp.listUsers(limit, offset, isActive, nameOrEmailOrAssignments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーの多要素認証をリセットする
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserMfa(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.resetUserMfa(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーのGoogleアカウントのリンクを解除する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkGoogleAccount(options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.unlinkGoogleAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ログイン中のユーザーのメール通知の個人設定を更新する
         * @param {UpdateCurrentUserEmailNotificationSettingsParam} updateCurrentUserEmailNotificationSettingsParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentUserEmailNotificationSettings(updateCurrentUserEmailNotificationSettingsParam: UpdateCurrentUserEmailNotificationSettingsParam, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateCurrentUserEmailNotificationSettings(updateCurrentUserEmailNotificationSettingsParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーを更新する
         * @param {string} userId 
         * @param {EditUserParam} editUserParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRole(userId: string, editUserParam: EditUserParam, options?: RawAxiosRequestConfig): AxiosPromise<UserWithMfaMethodView> {
            return localVarFp.updateUserRole(userId, editUserParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー一括追加Excelのアップロード
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBulkCreateUsersExcel(file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadBulkCreateUsersExcel(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserControllerApi - object-oriented interface
 */
export class UserControllerApi extends BaseAPI {
    /**
     * 
     * @summary ユーザーを再登録する
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public activateUser(userId: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).activateUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 契約ユーザー数とアクティブユーザー数の一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public countActiveUsers(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).countActiveUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーを削除する
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUser(userId: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー一括追加Excelのダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadBulkCreateUsersExcel(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).downloadBulkCreateUsersExcel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー一覧Excelのダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadUsersListExcel(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).downloadUsersListExcel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ログイン中のユーザー情報を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ログイン中のユーザーのメール通知の個人設定を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUserEmailNotificationSettings(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getCurrentUserEmailNotificationSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー情報を返却する
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserRole(userId: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getUserRole(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーを招待する
     * @param {CreateUserParam} createUserParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inviteUser(createUserParam: CreateUserParam, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).inviteUser(createUserParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーのGoogleアカウントをリンクする
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public linkWithGoogleAccount(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).linkWithGoogleAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ソーシャルログインの状況を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSocialLogins(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).listSocialLogins(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーIDと氏名の対応一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listUserNames(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).listUserNames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー一覧
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {boolean} [isActive] 
     * @param {string} [nameOrEmailOrAssignments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listUsers(limit?: number, offset?: number, isActive?: boolean, nameOrEmailOrAssignments?: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).listUsers(limit, offset, isActive, nameOrEmailOrAssignments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーの多要素認証をリセットする
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetUserMfa(userId: string, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).resetUserMfa(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーのGoogleアカウントのリンクを解除する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unlinkGoogleAccount(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).unlinkGoogleAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ログイン中のユーザーのメール通知の個人設定を更新する
     * @param {UpdateCurrentUserEmailNotificationSettingsParam} updateCurrentUserEmailNotificationSettingsParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCurrentUserEmailNotificationSettings(updateCurrentUserEmailNotificationSettingsParam: UpdateCurrentUserEmailNotificationSettingsParam, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateCurrentUserEmailNotificationSettings(updateCurrentUserEmailNotificationSettingsParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーを更新する
     * @param {string} userId 
     * @param {EditUserParam} editUserParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserRole(userId: string, editUserParam: EditUserParam, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUserRole(userId, editUserParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー一括追加Excelのアップロード
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadBulkCreateUsersExcel(file: File, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).uploadBulkCreateUsersExcel(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ViewPermissionControllerApi - axios parameter creator
 */
export const ViewPermissionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 閲覧権限新規作成
         * @param {CreateViewPermissionParams} createViewPermissionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createViewPermission: async (createViewPermissionParams: CreateViewPermissionParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createViewPermissionParams' is not null or undefined
            assertParamExists('createViewPermission', 'createViewPermissionParams', createViewPermissionParams)
            const localVarPath = `/api/view-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createViewPermissionParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 閲覧権限削除
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteViewPermission: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteViewPermission', 'id', id)
            const localVarPath = `/api/view-permissions/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 閲覧権限詳細
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findViewPermission: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findViewPermission', 'id', id)
            const localVarPath = `/api/view-permissions/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 閲覧権限に指定するユーザーを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersForSelection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/view-permissions/users/for-selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 閲覧権限一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listViewPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/view-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 閲覧権限編集
         * @param {string} id 
         * @param {UpdateViewPermissionParams} updateViewPermissionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewPermission: async (id: string, updateViewPermissionParams: UpdateViewPermissionParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateViewPermission', 'id', id)
            // verify required parameter 'updateViewPermissionParams' is not null or undefined
            assertParamExists('updateViewPermission', 'updateViewPermissionParams', updateViewPermissionParams)
            const localVarPath = `/api/view-permissions/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateViewPermissionParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ViewPermissionControllerApi - functional programming interface
 */
export const ViewPermissionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ViewPermissionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 閲覧権限新規作成
         * @param {CreateViewPermissionParams} createViewPermissionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createViewPermission(createViewPermissionParams: CreateViewPermissionParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createViewPermission(createViewPermissionParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewPermissionControllerApi.createViewPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 閲覧権限削除
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteViewPermission(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteViewPermission(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewPermissionControllerApi.deleteViewPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 閲覧権限詳細
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findViewPermission(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewPermission>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findViewPermission(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewPermissionControllerApi.findViewPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 閲覧権限に指定するユーザーを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsersForSelection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewPermissionUsersForSelectionView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersForSelection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewPermissionControllerApi.listUsersForSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 閲覧権限一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listViewPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewPermissionView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listViewPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewPermissionControllerApi.listViewPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 閲覧権限編集
         * @param {string} id 
         * @param {UpdateViewPermissionParams} updateViewPermissionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateViewPermission(id: string, updateViewPermissionParams: UpdateViewPermissionParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateViewPermission(id, updateViewPermissionParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewPermissionControllerApi.updateViewPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ViewPermissionControllerApi - factory interface
 */
export const ViewPermissionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ViewPermissionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 閲覧権限新規作成
         * @param {CreateViewPermissionParams} createViewPermissionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createViewPermission(createViewPermissionParams: CreateViewPermissionParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createViewPermission(createViewPermissionParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 閲覧権限削除
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteViewPermission(id: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteViewPermission(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 閲覧権限詳細
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findViewPermission(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ViewPermission> {
            return localVarFp.findViewPermission(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 閲覧権限に指定するユーザーを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersForSelection(options?: RawAxiosRequestConfig): AxiosPromise<Array<ViewPermissionUsersForSelectionView>> {
            return localVarFp.listUsersForSelection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 閲覧権限一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listViewPermissions(options?: RawAxiosRequestConfig): AxiosPromise<Array<ViewPermissionView>> {
            return localVarFp.listViewPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 閲覧権限編集
         * @param {string} id 
         * @param {UpdateViewPermissionParams} updateViewPermissionParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateViewPermission(id: string, updateViewPermissionParams: UpdateViewPermissionParams, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateViewPermission(id, updateViewPermissionParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ViewPermissionControllerApi - object-oriented interface
 */
export class ViewPermissionControllerApi extends BaseAPI {
    /**
     * 
     * @summary 閲覧権限新規作成
     * @param {CreateViewPermissionParams} createViewPermissionParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createViewPermission(createViewPermissionParams: CreateViewPermissionParams, options?: RawAxiosRequestConfig) {
        return ViewPermissionControllerApiFp(this.configuration).createViewPermission(createViewPermissionParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 閲覧権限削除
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteViewPermission(id: string, options?: RawAxiosRequestConfig) {
        return ViewPermissionControllerApiFp(this.configuration).deleteViewPermission(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 閲覧権限詳細
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findViewPermission(id: string, options?: RawAxiosRequestConfig) {
        return ViewPermissionControllerApiFp(this.configuration).findViewPermission(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 閲覧権限に指定するユーザーを取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listUsersForSelection(options?: RawAxiosRequestConfig) {
        return ViewPermissionControllerApiFp(this.configuration).listUsersForSelection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 閲覧権限一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listViewPermissions(options?: RawAxiosRequestConfig) {
        return ViewPermissionControllerApiFp(this.configuration).listViewPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 閲覧権限編集
     * @param {string} id 
     * @param {UpdateViewPermissionParams} updateViewPermissionParams 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateViewPermission(id: string, updateViewPermissionParams: UpdateViewPermissionParams, options?: RawAxiosRequestConfig) {
        return ViewPermissionControllerApiFp(this.configuration).updateViewPermission(id, updateViewPermissionParams, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforceActualAppliedEventControllerApi - axios parameter creator
 */
export const WorkforceActualAppliedEventControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} actualImportEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyWorkforceActualToFinancialActualImportEventAsync: async (actualImportEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actualImportEventId' is not null or undefined
            assertParamExists('applyWorkforceActualToFinancialActualImportEventAsync', 'actualImportEventId', actualImportEventId)
            const localVarPath = `/api/workforce-planning/actual/applied-events/async`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (actualImportEventId !== undefined) {
                localVarQueryParameter['actualImportEventId'] = actualImportEventId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} actualAppliedEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceActualAppliedEvent: async (actualAppliedEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actualAppliedEventId' is not null or undefined
            assertParamExists('deleteWorkforceActualAppliedEvent', 'actualAppliedEventId', actualAppliedEventId)
            const localVarPath = `/api/workforce-planning/actual/applied-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (actualAppliedEventId !== undefined) {
                localVarQueryParameter['actualAppliedEventId'] = actualAppliedEventId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllWorkforceActualAppliedEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/actual/applied-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforceActualAppliedEventControllerApi - functional programming interface
 */
export const WorkforceActualAppliedEventControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforceActualAppliedEventControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} actualImportEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyWorkforceActualToFinancialActualImportEventAsync(actualImportEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyWorkforceActualToFinancialActualImportEventAsync(actualImportEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualAppliedEventControllerApi.applyWorkforceActualToFinancialActualImportEventAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} actualAppliedEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkforceActualAppliedEvent(actualAppliedEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkforceActualAppliedEvent(actualAppliedEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualAppliedEventControllerApi.deleteWorkforceActualAppliedEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllWorkforceActualAppliedEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkforceActualAppliedEventView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllWorkforceActualAppliedEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualAppliedEventControllerApi.listAllWorkforceActualAppliedEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforceActualAppliedEventControllerApi - factory interface
 */
export const WorkforceActualAppliedEventControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforceActualAppliedEventControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} actualImportEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyWorkforceActualToFinancialActualImportEventAsync(actualImportEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.applyWorkforceActualToFinancialActualImportEventAsync(actualImportEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} actualAppliedEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceActualAppliedEvent(actualAppliedEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteWorkforceActualAppliedEvent(actualAppliedEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllWorkforceActualAppliedEvents(options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkforceActualAppliedEventView>> {
            return localVarFp.listAllWorkforceActualAppliedEvents(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforceActualAppliedEventControllerApi - object-oriented interface
 */
export class WorkforceActualAppliedEventControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} actualImportEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public applyWorkforceActualToFinancialActualImportEventAsync(actualImportEventId: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualAppliedEventControllerApiFp(this.configuration).applyWorkforceActualToFinancialActualImportEventAsync(actualImportEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} actualAppliedEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWorkforceActualAppliedEvent(actualAppliedEventId: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualAppliedEventControllerApiFp(this.configuration).deleteWorkforceActualAppliedEvent(actualAppliedEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAllWorkforceActualAppliedEvents(options?: RawAxiosRequestConfig) {
        return WorkforceActualAppliedEventControllerApiFp(this.configuration).listAllWorkforceActualAppliedEvents(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforceActualControllerApi - axios parameter creator
 */
export const WorkforceActualControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 入社取消
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStartEvent: async (workforceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceId' is not null or undefined
            assertParamExists('cancelStartEvent', 'workforceId', workforceId)
            const localVarPath = `/api/workforce-planning/actual/{workforceId}/cancel-start-event`
                .replace('{workforceId}', encodeURIComponent(String(workforceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} periodYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeWorkforceActualAsync: async (periodYearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodYearMonth' is not null or undefined
            assertParamExists('closeWorkforceActualAsync', 'periodYearMonth', periodYearMonth)
            const localVarPath = `/api/workforce-planning/actual/close/async`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (periodYearMonth !== undefined) {
                localVarQueryParameter['periodYearMonth'] = periodYearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員編集ダイアログ用の取得
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActual: async (workforceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceId' is not null or undefined
            assertParamExists('getWorkforceActual', 'workforceId', workforceId)
            const localVarPath = `/api/workforce-planning/actual/{workforceId}`
                .replace('{workforceId}', encodeURIComponent(String(workforceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActualClosing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/actual/closing-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActualClosingJobLatest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/actual/closing-jobs/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員情報パネル用の取得
         * @param {string} workforceId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActualCurrent: async (workforceId: string, yearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceId' is not null or undefined
            assertParamExists('getWorkforceActualCurrent', 'workforceId', workforceId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getWorkforceActualCurrent', 'yearMonth', yearMonth)
            const localVarPath = `/api/workforce-planning/actual/{workforceId}/current`
                .replace('{workforceId}', encodeURIComponent(String(workforceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} periodYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openWorkforceActualAsync: async (periodYearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodYearMonth' is not null or undefined
            assertParamExists('openWorkforceActualAsync', 'periodYearMonth', periodYearMonth)
            const localVarPath = `/api/workforce-planning/actual/open/async`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (periodYearMonth !== undefined) {
                localVarQueryParameter['periodYearMonth'] = periodYearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員編集ダイアログの保存
         * @param {string} workforceId 
         * @param {ReplaceWorkforceActualBody} replaceWorkforceActualBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceWorkforceActual: async (workforceId: string, replaceWorkforceActualBody: ReplaceWorkforceActualBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceId' is not null or undefined
            assertParamExists('replaceWorkforceActual', 'workforceId', workforceId)
            // verify required parameter 'replaceWorkforceActualBody' is not null or undefined
            assertParamExists('replaceWorkforceActual', 'replaceWorkforceActualBody', replaceWorkforceActualBody)
            const localVarPath = `/api/workforce-planning/actual/{workforceId}`
                .replace('{workforceId}', encodeURIComponent(String(workforceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceWorkforceActualBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforceActualControllerApi - functional programming interface
 */
export const WorkforceActualControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforceActualControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 入社取消
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelStartEvent(workforceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelStartEvent(workforceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualControllerApi.cancelStartEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} periodYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeWorkforceActualAsync(periodYearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceActualClosingJobAcceptedView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeWorkforceActualAsync(periodYearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualControllerApi.closeWorkforceActualAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員編集ダイアログ用の取得
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforceActual(workforceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceActualDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforceActual(workforceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualControllerApi.getWorkforceActual']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforceActualClosing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceActualClosingHistoryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforceActualClosing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualControllerApi.getWorkforceActualClosing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforceActualClosingJobLatest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceActualClosingJobLatestView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforceActualClosingJobLatest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualControllerApi.getWorkforceActualClosingJobLatest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員情報パネル用の取得
         * @param {string} workforceId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforceActualCurrent(workforceId: string, yearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceActualCurrentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforceActualCurrent(workforceId, yearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualControllerApi.getWorkforceActualCurrent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} periodYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openWorkforceActualAsync(periodYearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceActualClosingJobAcceptedView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openWorkforceActualAsync(periodYearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualControllerApi.openWorkforceActualAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員編集ダイアログの保存
         * @param {string} workforceId 
         * @param {ReplaceWorkforceActualBody} replaceWorkforceActualBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceWorkforceActual(workforceId: string, replaceWorkforceActualBody: ReplaceWorkforceActualBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceWorkforceActual(workforceId, replaceWorkforceActualBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualControllerApi.replaceWorkforceActual']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforceActualControllerApi - factory interface
 */
export const WorkforceActualControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforceActualControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 入社取消
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStartEvent(workforceId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.cancelStartEvent(workforceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} periodYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeWorkforceActualAsync(periodYearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforceActualClosingJobAcceptedView> {
            return localVarFp.closeWorkforceActualAsync(periodYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員編集ダイアログ用の取得
         * @param {string} workforceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActual(workforceId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforceActualDto> {
            return localVarFp.getWorkforceActual(workforceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActualClosing(options?: RawAxiosRequestConfig): AxiosPromise<WorkforceActualClosingHistoryView> {
            return localVarFp.getWorkforceActualClosing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActualClosingJobLatest(options?: RawAxiosRequestConfig): AxiosPromise<WorkforceActualClosingJobLatestView> {
            return localVarFp.getWorkforceActualClosingJobLatest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員情報パネル用の取得
         * @param {string} workforceId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActualCurrent(workforceId: string, yearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforceActualCurrentDto> {
            return localVarFp.getWorkforceActualCurrent(workforceId, yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} periodYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openWorkforceActualAsync(periodYearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforceActualClosingJobAcceptedView> {
            return localVarFp.openWorkforceActualAsync(periodYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員編集ダイアログの保存
         * @param {string} workforceId 
         * @param {ReplaceWorkforceActualBody} replaceWorkforceActualBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceWorkforceActual(workforceId: string, replaceWorkforceActualBody: ReplaceWorkforceActualBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.replaceWorkforceActual(workforceId, replaceWorkforceActualBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforceActualControllerApi - object-oriented interface
 */
export class WorkforceActualControllerApi extends BaseAPI {
    /**
     * 
     * @summary 入社取消
     * @param {string} workforceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelStartEvent(workforceId: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualControllerApiFp(this.configuration).cancelStartEvent(workforceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} periodYearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public closeWorkforceActualAsync(periodYearMonth: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualControllerApiFp(this.configuration).closeWorkforceActualAsync(periodYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員編集ダイアログ用の取得
     * @param {string} workforceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforceActual(workforceId: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualControllerApiFp(this.configuration).getWorkforceActual(workforceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforceActualClosing(options?: RawAxiosRequestConfig) {
        return WorkforceActualControllerApiFp(this.configuration).getWorkforceActualClosing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforceActualClosingJobLatest(options?: RawAxiosRequestConfig) {
        return WorkforceActualControllerApiFp(this.configuration).getWorkforceActualClosingJobLatest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員情報パネル用の取得
     * @param {string} workforceId 
     * @param {string} yearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforceActualCurrent(workforceId: string, yearMonth: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualControllerApiFp(this.configuration).getWorkforceActualCurrent(workforceId, yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} periodYearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public openWorkforceActualAsync(periodYearMonth: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualControllerApiFp(this.configuration).openWorkforceActualAsync(periodYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員編集ダイアログの保存
     * @param {string} workforceId 
     * @param {ReplaceWorkforceActualBody} replaceWorkforceActualBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replaceWorkforceActual(workforceId: string, replaceWorkforceActualBody: ReplaceWorkforceActualBody, options?: RawAxiosRequestConfig) {
        return WorkforceActualControllerApiFp(this.configuration).replaceWorkforceActual(workforceId, replaceWorkforceActualBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforceActualImportEventControllerApi - axios parameter creator
 */
export const WorkforceActualImportEventControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceActualImportEvent: async (importEventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importEventId' is not null or undefined
            assertParamExists('deleteWorkforceActualImportEvent', 'importEventId', importEventId)
            const localVarPath = `/api/workforce-planning/actual/import-event/{importEventId}`
                .replace('{importEventId}', encodeURIComponent(String(importEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員・採用枠工数実績登録フォーマット(Excel)のダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadWorkforceActualFormatExcel: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/actual/import-event/format/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceActualUploadEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/actual/import-event/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWorkforceActualUpdateRequest: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadWorkforceActualUpdateRequest', 'file', file)
            const localVarPath = `/api/workforce-planning/actual/import-event/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforceActualImportEventControllerApi - functional programming interface
 */
export const WorkforceActualImportEventControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforceActualImportEventControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkforceActualImportEvent(importEventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkforceActualImportEvent(importEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportEventControllerApi.deleteWorkforceActualImportEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員・採用枠工数実績登録フォーマット(Excel)のダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadWorkforceActualFormatExcel(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadWorkforceActualFormatExcel(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportEventControllerApi.downloadWorkforceActualFormatExcel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkforceActualUploadEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkforceActualUploadEventView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkforceActualUploadEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportEventControllerApi.listWorkforceActualUploadEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadWorkforceActualUpdateRequest(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadWorkforceActualUpdateRequest(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportEventControllerApi.uploadWorkforceActualUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforceActualImportEventControllerApi - factory interface
 */
export const WorkforceActualImportEventControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforceActualImportEventControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} importEventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceActualImportEvent(importEventId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteWorkforceActualImportEvent(importEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員・採用枠工数実績登録フォーマット(Excel)のダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadWorkforceActualFormatExcel(options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadWorkforceActualFormatExcel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceActualUploadEvents(options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkforceActualUploadEventView>> {
            return localVarFp.listWorkforceActualUploadEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWorkforceActualUpdateRequest(file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadWorkforceActualUpdateRequest(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforceActualImportEventControllerApi - object-oriented interface
 */
export class WorkforceActualImportEventControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} importEventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWorkforceActualImportEvent(importEventId: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualImportEventControllerApiFp(this.configuration).deleteWorkforceActualImportEvent(importEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員・採用枠工数実績登録フォーマット(Excel)のダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadWorkforceActualFormatExcel(options?: RawAxiosRequestConfig) {
        return WorkforceActualImportEventControllerApiFp(this.configuration).downloadWorkforceActualFormatExcel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkforceActualUploadEvents(options?: RawAxiosRequestConfig) {
        return WorkforceActualImportEventControllerApiFp(this.configuration).listWorkforceActualUploadEvents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadWorkforceActualUpdateRequest(file: File, options?: RawAxiosRequestConfig) {
        return WorkforceActualImportEventControllerApiFp(this.configuration).uploadWorkforceActualUpdateRequest(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforceActualImportMappingSettingControllerApi - axios parameter creator
 */
export const WorkforceActualImportMappingSettingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 取込設定を作成する
         * @param {UpsertWorkforceActualImportMappingSettingParam} upsertWorkforceActualImportMappingSettingParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforceActualImportMappingSetting: async (upsertWorkforceActualImportMappingSettingParam: UpsertWorkforceActualImportMappingSettingParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertWorkforceActualImportMappingSettingParam' is not null or undefined
            assertParamExists('createWorkforceActualImportMappingSetting', 'upsertWorkforceActualImportMappingSettingParam', upsertWorkforceActualImportMappingSettingParam)
            const localVarPath = `/api/workforce-planning/mapping-setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertWorkforceActualImportMappingSettingParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取込設定を削除する
         * @param {string} workforceActualImportMappingSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceActualImportMappingSetting: async (workforceActualImportMappingSettingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceActualImportMappingSettingId' is not null or undefined
            assertParamExists('deleteWorkforceActualImportMappingSetting', 'workforceActualImportMappingSettingId', workforceActualImportMappingSettingId)
            const localVarPath = `/api/workforce-planning/mapping-setting/{workforceActualImportMappingSettingId}`
                .replace('{workforceActualImportMappingSettingId}', encodeURIComponent(String(workforceActualImportMappingSettingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取込設定の初期値を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultWorkforceActualImportMappingSetting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/mapping-setting/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取込設定を取得する
         * @param {string} workforceActualImportMappingSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActualImportMappingSetting: async (workforceActualImportMappingSettingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceActualImportMappingSettingId' is not null or undefined
            assertParamExists('getWorkforceActualImportMappingSetting', 'workforceActualImportMappingSettingId', workforceActualImportMappingSettingId)
            const localVarPath = `/api/workforce-planning/mapping-setting/{workforceActualImportMappingSettingId}`
                .replace('{workforceActualImportMappingSettingId}', encodeURIComponent(String(workforceActualImportMappingSettingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取込設定一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceActualImportMappingSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/mapping-setting/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取込設定を更新する
         * @param {string} workforceActualImportMappingSettingId 
         * @param {UpsertWorkforceActualImportMappingSettingParam} upsertWorkforceActualImportMappingSettingParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforceActualImportMappingSetting: async (workforceActualImportMappingSettingId: string, upsertWorkforceActualImportMappingSettingParam: UpsertWorkforceActualImportMappingSettingParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceActualImportMappingSettingId' is not null or undefined
            assertParamExists('updateWorkforceActualImportMappingSetting', 'workforceActualImportMappingSettingId', workforceActualImportMappingSettingId)
            // verify required parameter 'upsertWorkforceActualImportMappingSettingParam' is not null or undefined
            assertParamExists('updateWorkforceActualImportMappingSetting', 'upsertWorkforceActualImportMappingSettingParam', upsertWorkforceActualImportMappingSettingParam)
            const localVarPath = `/api/workforce-planning/mapping-setting/{workforceActualImportMappingSettingId}`
                .replace('{workforceActualImportMappingSettingId}', encodeURIComponent(String(workforceActualImportMappingSettingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertWorkforceActualImportMappingSettingParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforceActualImportMappingSettingControllerApi - functional programming interface
 */
export const WorkforceActualImportMappingSettingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforceActualImportMappingSettingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 取込設定を作成する
         * @param {UpsertWorkforceActualImportMappingSettingParam} upsertWorkforceActualImportMappingSettingParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkforceActualImportMappingSetting(upsertWorkforceActualImportMappingSettingParam: UpsertWorkforceActualImportMappingSettingParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkforceActualImportMappingSetting(upsertWorkforceActualImportMappingSettingParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportMappingSettingControllerApi.createWorkforceActualImportMappingSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 取込設定を削除する
         * @param {string} workforceActualImportMappingSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportMappingSettingControllerApi.deleteWorkforceActualImportMappingSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 取込設定の初期値を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultWorkforceActualImportMappingSetting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceActualImportMappingSettingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultWorkforceActualImportMappingSetting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportMappingSettingControllerApi.getDefaultWorkforceActualImportMappingSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 取込設定を取得する
         * @param {string} workforceActualImportMappingSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceActualImportMappingSettingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportMappingSettingControllerApi.getWorkforceActualImportMappingSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 取込設定一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkforceActualImportMappingSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkforceActualImportMappingSettingListItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkforceActualImportMappingSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportMappingSettingControllerApi.listWorkforceActualImportMappingSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 取込設定を更新する
         * @param {string} workforceActualImportMappingSettingId 
         * @param {UpsertWorkforceActualImportMappingSettingParam} upsertWorkforceActualImportMappingSettingParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId: string, upsertWorkforceActualImportMappingSettingParam: UpsertWorkforceActualImportMappingSettingParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId, upsertWorkforceActualImportMappingSettingParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceActualImportMappingSettingControllerApi.updateWorkforceActualImportMappingSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforceActualImportMappingSettingControllerApi - factory interface
 */
export const WorkforceActualImportMappingSettingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforceActualImportMappingSettingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 取込設定を作成する
         * @param {UpsertWorkforceActualImportMappingSettingParam} upsertWorkforceActualImportMappingSettingParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforceActualImportMappingSetting(upsertWorkforceActualImportMappingSettingParam: UpsertWorkforceActualImportMappingSettingParam, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createWorkforceActualImportMappingSetting(upsertWorkforceActualImportMappingSettingParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取込設定を削除する
         * @param {string} workforceActualImportMappingSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取込設定の初期値を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultWorkforceActualImportMappingSetting(options?: RawAxiosRequestConfig): AxiosPromise<WorkforceActualImportMappingSettingView> {
            return localVarFp.getDefaultWorkforceActualImportMappingSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取込設定を取得する
         * @param {string} workforceActualImportMappingSettingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforceActualImportMappingSettingView> {
            return localVarFp.getWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取込設定一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceActualImportMappingSettings(options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkforceActualImportMappingSettingListItem>> {
            return localVarFp.listWorkforceActualImportMappingSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取込設定を更新する
         * @param {string} workforceActualImportMappingSettingId 
         * @param {UpsertWorkforceActualImportMappingSettingParam} upsertWorkforceActualImportMappingSettingParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId: string, upsertWorkforceActualImportMappingSettingParam: UpsertWorkforceActualImportMappingSettingParam, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId, upsertWorkforceActualImportMappingSettingParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforceActualImportMappingSettingControllerApi - object-oriented interface
 */
export class WorkforceActualImportMappingSettingControllerApi extends BaseAPI {
    /**
     * 
     * @summary 取込設定を作成する
     * @param {UpsertWorkforceActualImportMappingSettingParam} upsertWorkforceActualImportMappingSettingParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createWorkforceActualImportMappingSetting(upsertWorkforceActualImportMappingSettingParam: UpsertWorkforceActualImportMappingSettingParam, options?: RawAxiosRequestConfig) {
        return WorkforceActualImportMappingSettingControllerApiFp(this.configuration).createWorkforceActualImportMappingSetting(upsertWorkforceActualImportMappingSettingParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取込設定を削除する
     * @param {string} workforceActualImportMappingSettingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualImportMappingSettingControllerApiFp(this.configuration).deleteWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取込設定の初期値を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDefaultWorkforceActualImportMappingSetting(options?: RawAxiosRequestConfig) {
        return WorkforceActualImportMappingSettingControllerApiFp(this.configuration).getDefaultWorkforceActualImportMappingSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取込設定を取得する
     * @param {string} workforceActualImportMappingSettingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId: string, options?: RawAxiosRequestConfig) {
        return WorkforceActualImportMappingSettingControllerApiFp(this.configuration).getWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取込設定一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkforceActualImportMappingSettings(options?: RawAxiosRequestConfig) {
        return WorkforceActualImportMappingSettingControllerApiFp(this.configuration).listWorkforceActualImportMappingSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取込設定を更新する
     * @param {string} workforceActualImportMappingSettingId 
     * @param {UpsertWorkforceActualImportMappingSettingParam} upsertWorkforceActualImportMappingSettingParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId: string, upsertWorkforceActualImportMappingSettingParam: UpsertWorkforceActualImportMappingSettingParam, options?: RawAxiosRequestConfig) {
        return WorkforceActualImportMappingSettingControllerApiFp(this.configuration).updateWorkforceActualImportMappingSetting(workforceActualImportMappingSettingId, upsertWorkforceActualImportMappingSettingParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanUpdateRequestControllerApi - axios parameter creator
 */
export const WorkforcePlanUpdateRequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人員計画更新申請を削除する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforcePlanUpdateRequest: async (workforcePlanUpdateRequestId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanUpdateRequestId' is not null or undefined
            assertParamExists('deleteWorkforcePlanUpdateRequest', 'workforcePlanUpdateRequestId', workforcePlanUpdateRequestId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('deleteWorkforcePlanUpdateRequest', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/{workforcePlanUpdateRequestId}`
                .replace('{workforcePlanUpdateRequestId}', encodeURIComponent(String(workforcePlanUpdateRequestId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 提出元人員計画更新申請Excelをダウンロードする
         * @param {string} planningProjectId 
         * @param {string} workforcePlanUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubmittedWorkforcePlanUpdateRequestFile: async (planningProjectId: string, workforcePlanUpdateRequestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('downloadSubmittedWorkforcePlanUpdateRequestFile', 'planningProjectId', planningProjectId)
            // verify required parameter 'workforcePlanUpdateRequestId' is not null or undefined
            assertParamExists('downloadSubmittedWorkforcePlanUpdateRequestFile', 'workforcePlanUpdateRequestId', workforcePlanUpdateRequestId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/{workforcePlanUpdateRequestId}/excel`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{workforcePlanUpdateRequestId}', encodeURIComponent(String(workforcePlanUpdateRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人件費変換の計算状況を取得する
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationStatus: async (planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getCalculationStatus', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/calculation-status`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PL差分を返す
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {GetPLDiffShowInEnum} showIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPLDiff: async (workforcePlanUpdateRequestId: string, planningProjectId: string, showIn: GetPLDiffShowInEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanUpdateRequestId' is not null or undefined
            assertParamExists('getPLDiff', 'workforcePlanUpdateRequestId', workforcePlanUpdateRequestId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getPLDiff', 'planningProjectId', planningProjectId)
            // verify required parameter 'showIn' is not null or undefined
            assertParamExists('getPLDiff', 'showIn', showIn)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/{workforcePlanUpdateRequestId}/pl-diff`
                .replace('{workforcePlanUpdateRequestId}', encodeURIComponent(String(workforcePlanUpdateRequestId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (showIn !== undefined) {
                localVarQueryParameter['showIn'] = showIn;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 工数差分を返す
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceDiff: async (workforcePlanUpdateRequestId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanUpdateRequestId' is not null or undefined
            assertParamExists('getWorkforceDiff', 'workforcePlanUpdateRequestId', workforcePlanUpdateRequestId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getWorkforceDiff', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/{workforcePlanUpdateRequestId}/workforce-diff`
                .replace('{workforcePlanUpdateRequestId}', encodeURIComponent(String(workforcePlanUpdateRequestId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequest: async (workforcePlanUpdateRequestId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanUpdateRequestId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequest', 'workforcePlanUpdateRequestId', workforcePlanUpdateRequestId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequest', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/{workforcePlanUpdateRequestId}`
                .replace('{workforcePlanUpdateRequestId}', encodeURIComponent(String(workforcePlanUpdateRequestId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画更新申請のイベント一覧を取得する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestEvents: async (workforcePlanUpdateRequestId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanUpdateRequestId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestEvents', 'workforcePlanUpdateRequestId', workforcePlanUpdateRequestId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestEvents', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/{workforcePlanUpdateRequestId}/events`
                .replace('{workforcePlanUpdateRequestId}', encodeURIComponent(String(workforcePlanUpdateRequestId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画更新申請ExcelのフォーマットをDLする
         * @param {string} planningProjectId 
         * @param {string} departmentId 
         * @param {boolean} [includeDescendants] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestFormat: async (planningProjectId: string, departmentId: string, includeDescendants?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestFormat', 'planningProjectId', planningProjectId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestFormat', 'departmentId', departmentId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/excel`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (includeDescendants !== undefined) {
                localVarQueryParameter['includeDescendants'] = includeDescendants;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestStatuses: async (planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestStatuses', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/statuses`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員・採用枠と年月を指定して、更新申請における人員・採用枠の詳細情報を取得する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {string} workforceId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth: async (workforcePlanUpdateRequestId: string, planningProjectId: string, workforceId: string, yearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanUpdateRequestId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth', 'workforcePlanUpdateRequestId', workforcePlanUpdateRequestId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth', 'planningProjectId', planningProjectId)
            // verify required parameter 'workforceId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth', 'workforceId', workforceId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth', 'yearMonth', yearMonth)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/{workforcePlanUpdateRequestId}/details/{workforceId}`
                .replace('{workforcePlanUpdateRequestId}', encodeURIComponent(String(workforcePlanUpdateRequestId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{workforceId}', encodeURIComponent(String(workforceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 枠と年月を指定して、更新申請における枠の詳細情報を取得する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {string} workforceSlotId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth: async (workforcePlanUpdateRequestId: string, planningProjectId: string, workforceSlotId: string, yearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanUpdateRequestId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth', 'workforcePlanUpdateRequestId', workforcePlanUpdateRequestId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth', 'planningProjectId', planningProjectId)
            // verify required parameter 'workforceSlotId' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth', 'workforceSlotId', workforceSlotId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth', 'yearMonth', yearMonth)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/{workforcePlanUpdateRequestId}/details/workforce-slots/{workforceSlotId}`
                .replace('{workforcePlanUpdateRequestId}', encodeURIComponent(String(workforcePlanUpdateRequestId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)))
                .replace('{workforceSlotId}', encodeURIComponent(String(workforceSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 最新人員情報を反映
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reflectLatestWorkforceInfo: async (planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('reflectLatestWorkforceInfo', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/reflect-latest-workforce`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画更新申請を非同期で承認する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startApprovingWorkforcePlanUpdateRequest: async (workforcePlanUpdateRequestId: string, planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanUpdateRequestId' is not null or undefined
            assertParamExists('startApprovingWorkforcePlanUpdateRequest', 'workforcePlanUpdateRequestId', workforcePlanUpdateRequestId)
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('startApprovingWorkforcePlanUpdateRequest', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/{workforcePlanUpdateRequestId}/start-approving`
                .replace('{workforcePlanUpdateRequestId}', encodeURIComponent(String(workforcePlanUpdateRequestId)))
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人件費変換を非同期で実行する
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCalculation: async (planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('startCalculation', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/start-calculation`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画更新申請Excelをアップロードする
         * @param {string} planningProjectId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWorkforcePlanUpdateRequest: async (planningProjectId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('uploadWorkforcePlanUpdateRequest', 'planningProjectId', planningProjectId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadWorkforcePlanUpdateRequest', 'file', file)
            const localVarPath = `/api/planningProjects/{planningProjectId}/workforce-plan-update-requests/excel`
                .replace('{planningProjectId}', encodeURIComponent(String(planningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanUpdateRequestControllerApi - functional programming interface
 */
export const WorkforcePlanUpdateRequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanUpdateRequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人員計画更新申請を削除する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.deleteWorkforcePlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 提出元人員計画更新申請Excelをダウンロードする
         * @param {string} planningProjectId 
         * @param {string} workforcePlanUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSubmittedWorkforcePlanUpdateRequestFile(planningProjectId: string, workforcePlanUpdateRequestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSubmittedWorkforcePlanUpdateRequestFile(planningProjectId, workforcePlanUpdateRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.downloadSubmittedWorkforcePlanUpdateRequestFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人件費変換の計算状況を取得する
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalculationStatus(planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanUpdateRequestCalculationStatusView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalculationStatus(planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.getCalculationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary PL差分を返す
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {GetPLDiffShowInEnum} showIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPLDiff(workforcePlanUpdateRequestId: string, planningProjectId: string, showIn: GetPLDiffShowInEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanUpdateRequestPLView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPLDiff(workforcePlanUpdateRequestId, planningProjectId, showIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.getPLDiff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 工数差分を返す
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforceDiff(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanUpdateRequestWorkforceDiffView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforceDiff(workforcePlanUpdateRequestId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.getWorkforceDiff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanUpdateRequestView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.getWorkforcePlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画更新申請のイベント一覧を取得する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanUpdateRequestEvents(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanUpdateRequestEventsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanUpdateRequestEvents(workforcePlanUpdateRequestId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.getWorkforcePlanUpdateRequestEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画更新申請ExcelのフォーマットをDLする
         * @param {string} planningProjectId 
         * @param {string} departmentId 
         * @param {boolean} [includeDescendants] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanUpdateRequestFormat(planningProjectId: string, departmentId: string, includeDescendants?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanUpdateRequestFormat(planningProjectId, departmentId, includeDescendants, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.getWorkforcePlanUpdateRequestFormat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanUpdateRequestStatuses(planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanUpdateRequestStatusesView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanUpdateRequestStatuses(planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.getWorkforcePlanUpdateRequestStatuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員・採用枠と年月を指定して、更新申請における人員・採用枠の詳細情報を取得する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {string} workforceId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth(workforcePlanUpdateRequestId: string, planningProjectId: string, workforceId: string, yearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanUpdateRequestWorkforceDetailByYearMonthView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth(workforcePlanUpdateRequestId, planningProjectId, workforceId, yearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 枠と年月を指定して、更新申請における枠の詳細情報を取得する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {string} workforceSlotId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth(workforcePlanUpdateRequestId: string, planningProjectId: string, workforceSlotId: string, yearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanUpdateRequestWorkforceDetailByYearMonthView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth(workforcePlanUpdateRequestId, planningProjectId, workforceSlotId, yearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 最新人員情報を反映
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reflectLatestWorkforceInfo(planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reflectLatestWorkforceInfo(planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.reflectLatestWorkforceInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画更新申請を非同期で承認する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startApprovingWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startApprovingWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId, planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.startApprovingWorkforcePlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人件費変換を非同期で実行する
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startCalculation(planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startCalculation(planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.startCalculation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画更新申請Excelをアップロードする
         * @param {string} planningProjectId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadWorkforcePlanUpdateRequest(planningProjectId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadWorkforcePlanUpdateRequest(planningProjectId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanUpdateRequestControllerApi.uploadWorkforcePlanUpdateRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanUpdateRequestControllerApi - factory interface
 */
export const WorkforcePlanUpdateRequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanUpdateRequestControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人員計画更新申請を削除する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 提出元人員計画更新申請Excelをダウンロードする
         * @param {string} planningProjectId 
         * @param {string} workforcePlanUpdateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSubmittedWorkforcePlanUpdateRequestFile(planningProjectId: string, workforcePlanUpdateRequestId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSubmittedWorkforcePlanUpdateRequestFile(planningProjectId, workforcePlanUpdateRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人件費変換の計算状況を取得する
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalculationStatus(planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanUpdateRequestCalculationStatusView> {
            return localVarFp.getCalculationStatus(planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PL差分を返す
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {GetPLDiffShowInEnum} showIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPLDiff(workforcePlanUpdateRequestId: string, planningProjectId: string, showIn: GetPLDiffShowInEnum, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanUpdateRequestPLView> {
            return localVarFp.getPLDiff(workforcePlanUpdateRequestId, planningProjectId, showIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 工数差分を返す
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceDiff(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanUpdateRequestWorkforceDiffView> {
            return localVarFp.getWorkforceDiff(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanUpdateRequestView> {
            return localVarFp.getWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画更新申請のイベント一覧を取得する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestEvents(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanUpdateRequestEventsView> {
            return localVarFp.getWorkforcePlanUpdateRequestEvents(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画更新申請ExcelのフォーマットをDLする
         * @param {string} planningProjectId 
         * @param {string} departmentId 
         * @param {boolean} [includeDescendants] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestFormat(planningProjectId: string, departmentId: string, includeDescendants?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getWorkforcePlanUpdateRequestFormat(planningProjectId, departmentId, includeDescendants, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestStatuses(planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanUpdateRequestStatusesView> {
            return localVarFp.getWorkforcePlanUpdateRequestStatuses(planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員・採用枠と年月を指定して、更新申請における人員・採用枠の詳細情報を取得する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {string} workforceId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth(workforcePlanUpdateRequestId: string, planningProjectId: string, workforceId: string, yearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanUpdateRequestWorkforceDetailByYearMonthView> {
            return localVarFp.getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth(workforcePlanUpdateRequestId, planningProjectId, workforceId, yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 枠と年月を指定して、更新申請における枠の詳細情報を取得する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {string} workforceSlotId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth(workforcePlanUpdateRequestId: string, planningProjectId: string, workforceSlotId: string, yearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanUpdateRequestWorkforceDetailByYearMonthView> {
            return localVarFp.getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth(workforcePlanUpdateRequestId, planningProjectId, workforceSlotId, yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 最新人員情報を反映
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reflectLatestWorkforceInfo(planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.reflectLatestWorkforceInfo(planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画更新申請を非同期で承認する
         * @param {string} workforcePlanUpdateRequestId 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startApprovingWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.startApprovingWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人件費変換を非同期で実行する
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCalculation(planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.startCalculation(planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画更新申請Excelをアップロードする
         * @param {string} planningProjectId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadWorkforcePlanUpdateRequest(planningProjectId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.uploadWorkforcePlanUpdateRequest(planningProjectId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanUpdateRequestControllerApi - object-oriented interface
 */
export class WorkforcePlanUpdateRequestControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人員計画更新申請を削除する
     * @param {string} workforcePlanUpdateRequestId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).deleteWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 提出元人員計画更新申請Excelをダウンロードする
     * @param {string} planningProjectId 
     * @param {string} workforcePlanUpdateRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadSubmittedWorkforcePlanUpdateRequestFile(planningProjectId: string, workforcePlanUpdateRequestId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).downloadSubmittedWorkforcePlanUpdateRequestFile(planningProjectId, workforcePlanUpdateRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人件費変換の計算状況を取得する
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCalculationStatus(planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).getCalculationStatus(planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PL差分を返す
     * @param {string} workforcePlanUpdateRequestId 
     * @param {string} planningProjectId 
     * @param {GetPLDiffShowInEnum} showIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPLDiff(workforcePlanUpdateRequestId: string, planningProjectId: string, showIn: GetPLDiffShowInEnum, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).getPLDiff(workforcePlanUpdateRequestId, planningProjectId, showIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 工数差分を返す
     * @param {string} workforcePlanUpdateRequestId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforceDiff(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).getWorkforceDiff(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} workforcePlanUpdateRequestId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).getWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画更新申請のイベント一覧を取得する
     * @param {string} workforcePlanUpdateRequestId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanUpdateRequestEvents(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).getWorkforcePlanUpdateRequestEvents(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画更新申請ExcelのフォーマットをDLする
     * @param {string} planningProjectId 
     * @param {string} departmentId 
     * @param {boolean} [includeDescendants] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanUpdateRequestFormat(planningProjectId: string, departmentId: string, includeDescendants?: boolean, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).getWorkforcePlanUpdateRequestFormat(planningProjectId, departmentId, includeDescendants, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanUpdateRequestStatuses(planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).getWorkforcePlanUpdateRequestStatuses(planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員・採用枠と年月を指定して、更新申請における人員・採用枠の詳細情報を取得する
     * @param {string} workforcePlanUpdateRequestId 
     * @param {string} planningProjectId 
     * @param {string} workforceId 
     * @param {string} yearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth(workforcePlanUpdateRequestId: string, planningProjectId: string, workforceId: string, yearMonth: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).getWorkforcePlanUpdateRequestWorkforceDetailByYearMonth(workforcePlanUpdateRequestId, planningProjectId, workforceId, yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 枠と年月を指定して、更新申請における枠の詳細情報を取得する
     * @param {string} workforcePlanUpdateRequestId 
     * @param {string} planningProjectId 
     * @param {string} workforceSlotId 
     * @param {string} yearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth(workforcePlanUpdateRequestId: string, planningProjectId: string, workforceSlotId: string, yearMonth: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).getWorkforcePlanUpdateRequestWorkforceSlotDetailByYearMonth(workforcePlanUpdateRequestId, planningProjectId, workforceSlotId, yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 最新人員情報を反映
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reflectLatestWorkforceInfo(planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).reflectLatestWorkforceInfo(planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画更新申請を非同期で承認する
     * @param {string} workforcePlanUpdateRequestId 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startApprovingWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId: string, planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).startApprovingWorkforcePlanUpdateRequest(workforcePlanUpdateRequestId, planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人件費変換を非同期で実行する
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startCalculation(planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).startCalculation(planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画更新申請Excelをアップロードする
     * @param {string} planningProjectId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadWorkforcePlanUpdateRequest(planningProjectId: string, file: File, options?: RawAxiosRequestConfig) {
        return WorkforcePlanUpdateRequestControllerApiFp(this.configuration).uploadWorkforcePlanUpdateRequest(planningProjectId, file, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetPLDiffShowInEnum = {
    One: 'ONE',
    Thousand: 'THOUSAND',
    Million: 'MILLION',
    Billion: 'BILLION',
} as const;
export type GetPLDiffShowInEnum = typeof GetPLDiffShowInEnum[keyof typeof GetPLDiffShowInEnum];


/**
 * WorkforcePlanningAllowedActionControllerApi - axios parameter creator
 */
export const WorkforcePlanningAllowedActionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllowedActions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/allowed-actions/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningAllowedActionControllerApi - functional programming interface
 */
export const WorkforcePlanningAllowedActionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningAllowedActionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAllowedActions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchWorkforcePlanningAllowedActionReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAllowedActions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningAllowedActionControllerApi.fetchAllowedActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningAllowedActionControllerApi - factory interface
 */
export const WorkforcePlanningAllowedActionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningAllowedActionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllowedActions(options?: RawAxiosRequestConfig): AxiosPromise<FetchWorkforcePlanningAllowedActionReturn> {
            return localVarFp.fetchAllowedActions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningAllowedActionControllerApi - object-oriented interface
 */
export class WorkforcePlanningAllowedActionControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAllowedActions(options?: RawAxiosRequestConfig) {
        return WorkforcePlanningAllowedActionControllerApiFp(this.configuration).fetchAllowedActions(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningBaseSalaryIncreaseRuleControllerApi - axios parameter creator
 */
export const WorkforcePlanningBaseSalaryIncreaseRuleControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人員計画明細科目昇給ルールを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWorkforcePlanningBaseSalaryIncreaseRule: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/convert/base-salary-increase-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画明細科目昇給ルールを保存する
         * @param {UpdateWorkforcePlanningBaseSalaryIncreaseRuleViewBody} updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningBaseSalaryIncreaseRule: async (updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody: UpdateWorkforcePlanningBaseSalaryIncreaseRuleViewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody' is not null or undefined
            assertParamExists('updateWorkforcePlanningBaseSalaryIncreaseRule', 'updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody', updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody)
            const localVarPath = `/api/workforce-planning/convert/base-salary-increase-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningBaseSalaryIncreaseRuleControllerApi - functional programming interface
 */
export const WorkforcePlanningBaseSalaryIncreaseRuleControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningBaseSalaryIncreaseRuleControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人員計画明細科目昇給ルールを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchWorkforcePlanningBaseSalaryIncreaseRule(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningBaseSalaryIncreaseRuleView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchWorkforcePlanningBaseSalaryIncreaseRule(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningBaseSalaryIncreaseRuleControllerApi.fetchWorkforcePlanningBaseSalaryIncreaseRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画明細科目昇給ルールを保存する
         * @param {UpdateWorkforcePlanningBaseSalaryIncreaseRuleViewBody} updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkforcePlanningBaseSalaryIncreaseRule(updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody: UpdateWorkforcePlanningBaseSalaryIncreaseRuleViewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkforcePlanningBaseSalaryIncreaseRule(updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningBaseSalaryIncreaseRuleControllerApi.updateWorkforcePlanningBaseSalaryIncreaseRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningBaseSalaryIncreaseRuleControllerApi - factory interface
 */
export const WorkforcePlanningBaseSalaryIncreaseRuleControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningBaseSalaryIncreaseRuleControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人員計画明細科目昇給ルールを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWorkforcePlanningBaseSalaryIncreaseRule(options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningBaseSalaryIncreaseRuleView> {
            return localVarFp.fetchWorkforcePlanningBaseSalaryIncreaseRule(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画明細科目昇給ルールを保存する
         * @param {UpdateWorkforcePlanningBaseSalaryIncreaseRuleViewBody} updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningBaseSalaryIncreaseRule(updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody: UpdateWorkforcePlanningBaseSalaryIncreaseRuleViewBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateWorkforcePlanningBaseSalaryIncreaseRule(updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningBaseSalaryIncreaseRuleControllerApi - object-oriented interface
 */
export class WorkforcePlanningBaseSalaryIncreaseRuleControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人員計画明細科目昇給ルールを取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchWorkforcePlanningBaseSalaryIncreaseRule(options?: RawAxiosRequestConfig) {
        return WorkforcePlanningBaseSalaryIncreaseRuleControllerApiFp(this.configuration).fetchWorkforcePlanningBaseSalaryIncreaseRule(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画明細科目昇給ルールを保存する
     * @param {UpdateWorkforcePlanningBaseSalaryIncreaseRuleViewBody} updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWorkforcePlanningBaseSalaryIncreaseRule(updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody: UpdateWorkforcePlanningBaseSalaryIncreaseRuleViewBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningBaseSalaryIncreaseRuleControllerApiFp(this.configuration).updateWorkforcePlanningBaseSalaryIncreaseRule(updateWorkforcePlanningBaseSalaryIncreaseRuleViewBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningDimensionControllerApi - axios parameter creator
 */
export const WorkforcePlanningDimensionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人員・枠以外の分析軸を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforcePlanningUsingDimensions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/using-dimensions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningDimensionControllerApi - functional programming interface
 */
export const WorkforcePlanningDimensionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningDimensionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人員・枠以外の分析軸を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkforcePlanningUsingDimensions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkforcePlanningUsingDimensionView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkforcePlanningUsingDimensions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningDimensionControllerApi.listWorkforcePlanningUsingDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningDimensionControllerApi - factory interface
 */
export const WorkforcePlanningDimensionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningDimensionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人員・枠以外の分析軸を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforcePlanningUsingDimensions(options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkforcePlanningUsingDimensionView>> {
            return localVarFp.listWorkforcePlanningUsingDimensions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningDimensionControllerApi - object-oriented interface
 */
export class WorkforcePlanningDimensionControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人員・枠以外の分析軸を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkforcePlanningUsingDimensions(options?: RawAxiosRequestConfig) {
        return WorkforcePlanningDimensionControllerApiFp(this.configuration).listWorkforcePlanningUsingDimensions(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningItemConversionRuleControllerApi - axios parameter creator
 */
export const WorkforcePlanningItemConversionRuleControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人員計画明細科目変換ルールを作成する
         * @param {CreateWorkforceConversionRuleBody} createWorkforceConversionRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforcePlanningItemConvertRule: async (createWorkforceConversionRuleBody: CreateWorkforceConversionRuleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWorkforceConversionRuleBody' is not null or undefined
            assertParamExists('createWorkforcePlanningItemConvertRule', 'createWorkforceConversionRuleBody', createWorkforceConversionRuleBody)
            const localVarPath = `/api/workforce-planning/convert/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkforceConversionRuleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 科目変換ルールの確認のため手動で実行するデバッグ目的のエンドポイント
         * @param {string} targetId 
         * @param {DryRunWorkforcePlanningItemConvertRuleTypeEnum} type 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunWorkforcePlanningItemConvertRule: async (targetId: string, type: DryRunWorkforcePlanningItemConvertRuleTypeEnum, startYearMonth: string, endYearMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('dryRunWorkforcePlanningItemConvertRule', 'targetId', targetId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('dryRunWorkforcePlanningItemConvertRule', 'type', type)
            // verify required parameter 'startYearMonth' is not null or undefined
            assertParamExists('dryRunWorkforcePlanningItemConvertRule', 'startYearMonth', startYearMonth)
            // verify required parameter 'endYearMonth' is not null or undefined
            assertParamExists('dryRunWorkforcePlanningItemConvertRule', 'endYearMonth', endYearMonth)
            const localVarPath = `/api/workforce-planning/convert/rules/dry-run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (targetId !== undefined) {
                localVarQueryParameter['targetId'] = targetId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールを取得する
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningItemConvertRule: async (ruleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('getWorkforcePlanningItemConvertRule', 'ruleId', ruleId)
            const localVarPath = `/api/workforce-planning/convert/rules/{ruleId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールを更新する
         * @param {string} ruleId 
         * @param {UpdateWorkforceConversionRuleBody} updateWorkforceConversionRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningItemConvertRule: async (ruleId: string, updateWorkforceConversionRuleBody: UpdateWorkforceConversionRuleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateWorkforcePlanningItemConvertRule', 'ruleId', ruleId)
            // verify required parameter 'updateWorkforceConversionRuleBody' is not null or undefined
            assertParamExists('updateWorkforcePlanningItemConvertRule', 'updateWorkforceConversionRuleBody', updateWorkforceConversionRuleBody)
            const localVarPath = `/api/workforce-planning/convert/rules/{ruleId}`
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkforceConversionRuleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningItemConversionRuleControllerApi - functional programming interface
 */
export const WorkforcePlanningItemConversionRuleControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningItemConversionRuleControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人員計画明細科目変換ルールを作成する
         * @param {CreateWorkforceConversionRuleBody} createWorkforceConversionRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkforcePlanningItemConvertRule(createWorkforceConversionRuleBody: CreateWorkforceConversionRuleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkforcePlanningItemConvertRule(createWorkforceConversionRuleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRuleControllerApi.createWorkforcePlanningItemConvertRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 科目変換ルールの確認のため手動で実行するデバッグ目的のエンドポイント
         * @param {string} targetId 
         * @param {DryRunWorkforcePlanningItemConvertRuleTypeEnum} type 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRunWorkforcePlanningItemConvertRule(targetId: string, type: DryRunWorkforcePlanningItemConvertRuleTypeEnum, startYearMonth: string, endYearMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DryRunConversionRulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRunWorkforcePlanningItemConvertRule(targetId, type, startYearMonth, endYearMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRuleControllerApi.dryRunWorkforcePlanningItemConvertRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールを取得する
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanningItemConvertRule(ruleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningItemConvertRuleDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanningItemConvertRule(ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRuleControllerApi.getWorkforcePlanningItemConvertRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールを更新する
         * @param {string} ruleId 
         * @param {UpdateWorkforceConversionRuleBody} updateWorkforceConversionRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkforcePlanningItemConvertRule(ruleId: string, updateWorkforceConversionRuleBody: UpdateWorkforceConversionRuleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkforcePlanningItemConvertRule(ruleId, updateWorkforceConversionRuleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRuleControllerApi.updateWorkforcePlanningItemConvertRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningItemConversionRuleControllerApi - factory interface
 */
export const WorkforcePlanningItemConversionRuleControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningItemConversionRuleControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人員計画明細科目変換ルールを作成する
         * @param {CreateWorkforceConversionRuleBody} createWorkforceConversionRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforcePlanningItemConvertRule(createWorkforceConversionRuleBody: CreateWorkforceConversionRuleBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.createWorkforcePlanningItemConvertRule(createWorkforceConversionRuleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 科目変換ルールの確認のため手動で実行するデバッグ目的のエンドポイント
         * @param {string} targetId 
         * @param {DryRunWorkforcePlanningItemConvertRuleTypeEnum} type 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunWorkforcePlanningItemConvertRule(targetId: string, type: DryRunWorkforcePlanningItemConvertRuleTypeEnum, startYearMonth: string, endYearMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<DryRunConversionRulesResponse> {
            return localVarFp.dryRunWorkforcePlanningItemConvertRule(targetId, type, startYearMonth, endYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールを取得する
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningItemConvertRule(ruleId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningItemConvertRuleDetailView> {
            return localVarFp.getWorkforcePlanningItemConvertRule(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールを更新する
         * @param {string} ruleId 
         * @param {UpdateWorkforceConversionRuleBody} updateWorkforceConversionRuleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningItemConvertRule(ruleId: string, updateWorkforceConversionRuleBody: UpdateWorkforceConversionRuleBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateWorkforcePlanningItemConvertRule(ruleId, updateWorkforceConversionRuleBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningItemConversionRuleControllerApi - object-oriented interface
 */
export class WorkforcePlanningItemConversionRuleControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人員計画明細科目変換ルールを作成する
     * @param {CreateWorkforceConversionRuleBody} createWorkforceConversionRuleBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createWorkforcePlanningItemConvertRule(createWorkforceConversionRuleBody: CreateWorkforceConversionRuleBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRuleControllerApiFp(this.configuration).createWorkforcePlanningItemConvertRule(createWorkforceConversionRuleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 科目変換ルールの確認のため手動で実行するデバッグ目的のエンドポイント
     * @param {string} targetId 
     * @param {DryRunWorkforcePlanningItemConvertRuleTypeEnum} type 
     * @param {string} startYearMonth 
     * @param {string} endYearMonth 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dryRunWorkforcePlanningItemConvertRule(targetId: string, type: DryRunWorkforcePlanningItemConvertRuleTypeEnum, startYearMonth: string, endYearMonth: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRuleControllerApiFp(this.configuration).dryRunWorkforcePlanningItemConvertRule(targetId, type, startYearMonth, endYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画明細科目変換ルールを取得する
     * @param {string} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanningItemConvertRule(ruleId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRuleControllerApiFp(this.configuration).getWorkforcePlanningItemConvertRule(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画明細科目変換ルールを更新する
     * @param {string} ruleId 
     * @param {UpdateWorkforceConversionRuleBody} updateWorkforceConversionRuleBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWorkforcePlanningItemConvertRule(ruleId: string, updateWorkforceConversionRuleBody: UpdateWorkforceConversionRuleBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRuleControllerApiFp(this.configuration).updateWorkforcePlanningItemConvertRule(ruleId, updateWorkforceConversionRuleBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const DryRunWorkforcePlanningItemConvertRuleTypeEnum = {
    EachWorkforcePlanVersion: 'EACH_WORKFORCE_PLAN_VERSION',
    WorkforceSlotPlanVersion: 'WORKFORCE_SLOT_PLAN_VERSION',
    SimulatingWorkforce: 'SIMULATING_WORKFORCE',
    SimulatingWorkforceSlot: 'SIMULATING_WORKFORCE_SLOT',
} as const;
export type DryRunWorkforcePlanningItemConvertRuleTypeEnum = typeof DryRunWorkforcePlanningItemConvertRuleTypeEnum[keyof typeof DryRunWorkforcePlanningItemConvertRuleTypeEnum];


/**
 * WorkforcePlanningItemConversionRulesetControllerApi - axios parameter creator
 */
export const WorkforcePlanningItemConversionRulesetControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットのコピーを作成する
         * @param {string} rulesetId 
         * @param {CopyWorkforcePlanningItemConversionRulesetBody} copyWorkforcePlanningItemConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyWorkforcePlanningItemConversionRuleset: async (rulesetId: string, copyWorkforcePlanningItemConversionRulesetBody: CopyWorkforcePlanningItemConversionRulesetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rulesetId' is not null or undefined
            assertParamExists('copyWorkforcePlanningItemConversionRuleset', 'rulesetId', rulesetId)
            // verify required parameter 'copyWorkforcePlanningItemConversionRulesetBody' is not null or undefined
            assertParamExists('copyWorkforcePlanningItemConversionRuleset', 'copyWorkforcePlanningItemConversionRulesetBody', copyWorkforcePlanningItemConversionRulesetBody)
            const localVarPath = `/api/workforce-planning/convert/rulesets/{rulesetId}/copy`
                .replace('{rulesetId}', encodeURIComponent(String(rulesetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyWorkforcePlanningItemConversionRulesetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを作成する
         * @param {CreateWorkforcePlanningItemConversionRulesetBody} createWorkforcePlanningItemConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforcePlanningItemConversionRuleset: async (createWorkforcePlanningItemConversionRulesetBody: CreateWorkforcePlanningItemConversionRulesetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWorkforcePlanningItemConversionRulesetBody' is not null or undefined
            assertParamExists('createWorkforcePlanningItemConversionRuleset', 'createWorkforcePlanningItemConversionRulesetBody', createWorkforcePlanningItemConversionRulesetBody)
            const localVarPath = `/api/workforce-planning/convert/rulesets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkforcePlanningItemConversionRulesetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを削除する
         * @param {string} rulesetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforcePlanningItemConversionRuleset: async (rulesetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rulesetId' is not null or undefined
            assertParamExists('deleteWorkforcePlanningItemConversionRuleset', 'rulesetId', rulesetId)
            const localVarPath = `/api/workforce-planning/convert/rulesets/{rulesetId}`
                .replace('{rulesetId}', encodeURIComponent(String(rulesetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを取得する
         * @param {string} rulesetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningItemConversionRuleset: async (rulesetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rulesetId' is not null or undefined
            assertParamExists('getWorkforcePlanningItemConversionRuleset', 'rulesetId', rulesetId)
            const localVarPath = `/api/workforce-planning/convert/rulesets/{rulesetId}`
                .replace('{rulesetId}', encodeURIComponent(String(rulesetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセット一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforcePlanningItemConversionRuleset: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/convert/rulesets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットからルールを削除する
         * @param {string} rulesetId 
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkforcePlanningItemConversionRule: async (rulesetId: string, ruleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rulesetId' is not null or undefined
            assertParamExists('removeWorkforcePlanningItemConversionRule', 'rulesetId', rulesetId)
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('removeWorkforcePlanningItemConversionRule', 'ruleId', ruleId)
            const localVarPath = `/api/workforce-planning/convert/rulesets/{rulesetId}/remove-rule/{ruleId}`
                .replace('{rulesetId}', encodeURIComponent(String(rulesetId)))
                .replace('{ruleId}', encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを更新する
         * @param {string} rulesetId 
         * @param {UpdateWorkforcePlanningItemConversionRulesetBody} updateWorkforcePlanningItemConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningItemConversionRuleset: async (rulesetId: string, updateWorkforcePlanningItemConversionRulesetBody: UpdateWorkforcePlanningItemConversionRulesetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rulesetId' is not null or undefined
            assertParamExists('updateWorkforcePlanningItemConversionRuleset', 'rulesetId', rulesetId)
            // verify required parameter 'updateWorkforcePlanningItemConversionRulesetBody' is not null or undefined
            assertParamExists('updateWorkforcePlanningItemConversionRuleset', 'updateWorkforcePlanningItemConversionRulesetBody', updateWorkforcePlanningItemConversionRulesetBody)
            const localVarPath = `/api/workforce-planning/convert/rulesets/{rulesetId}`
                .replace('{rulesetId}', encodeURIComponent(String(rulesetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkforcePlanningItemConversionRulesetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningItemConversionRulesetControllerApi - functional programming interface
 */
export const WorkforcePlanningItemConversionRulesetControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningItemConversionRulesetControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットのコピーを作成する
         * @param {string} rulesetId 
         * @param {CopyWorkforcePlanningItemConversionRulesetBody} copyWorkforcePlanningItemConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyWorkforcePlanningItemConversionRuleset(rulesetId: string, copyWorkforcePlanningItemConversionRulesetBody: CopyWorkforcePlanningItemConversionRulesetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopyWorkforcePlanningItemConversionRulesetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyWorkforcePlanningItemConversionRuleset(rulesetId, copyWorkforcePlanningItemConversionRulesetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRulesetControllerApi.copyWorkforcePlanningItemConversionRuleset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを作成する
         * @param {CreateWorkforcePlanningItemConversionRulesetBody} createWorkforcePlanningItemConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkforcePlanningItemConversionRuleset(createWorkforcePlanningItemConversionRulesetBody: CreateWorkforcePlanningItemConversionRulesetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateWorkforcePlanningItemConversionRulesetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkforcePlanningItemConversionRuleset(createWorkforcePlanningItemConversionRulesetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRulesetControllerApi.createWorkforcePlanningItemConversionRuleset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを削除する
         * @param {string} rulesetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkforcePlanningItemConversionRuleset(rulesetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkforcePlanningItemConversionRuleset(rulesetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRulesetControllerApi.deleteWorkforcePlanningItemConversionRuleset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを取得する
         * @param {string} rulesetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanningItemConversionRuleset(rulesetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningItemConversionRulesetDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanningItemConversionRuleset(rulesetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRulesetControllerApi.getWorkforcePlanningItemConversionRuleset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセット一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkforcePlanningItemConversionRuleset(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkforcePlanningItemConversionRulesetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkforcePlanningItemConversionRuleset(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRulesetControllerApi.listWorkforcePlanningItemConversionRuleset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットからルールを削除する
         * @param {string} rulesetId 
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWorkforcePlanningItemConversionRule(rulesetId: string, ruleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWorkforcePlanningItemConversionRule(rulesetId, ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRulesetControllerApi.removeWorkforcePlanningItemConversionRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを更新する
         * @param {string} rulesetId 
         * @param {UpdateWorkforcePlanningItemConversionRulesetBody} updateWorkforcePlanningItemConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkforcePlanningItemConversionRuleset(rulesetId: string, updateWorkforcePlanningItemConversionRulesetBody: UpdateWorkforcePlanningItemConversionRulesetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkforcePlanningItemConversionRuleset(rulesetId, updateWorkforcePlanningItemConversionRulesetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningItemConversionRulesetControllerApi.updateWorkforcePlanningItemConversionRuleset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningItemConversionRulesetControllerApi - factory interface
 */
export const WorkforcePlanningItemConversionRulesetControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningItemConversionRulesetControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットのコピーを作成する
         * @param {string} rulesetId 
         * @param {CopyWorkforcePlanningItemConversionRulesetBody} copyWorkforcePlanningItemConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyWorkforcePlanningItemConversionRuleset(rulesetId: string, copyWorkforcePlanningItemConversionRulesetBody: CopyWorkforcePlanningItemConversionRulesetBody, options?: RawAxiosRequestConfig): AxiosPromise<CopyWorkforcePlanningItemConversionRulesetView> {
            return localVarFp.copyWorkforcePlanningItemConversionRuleset(rulesetId, copyWorkforcePlanningItemConversionRulesetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを作成する
         * @param {CreateWorkforcePlanningItemConversionRulesetBody} createWorkforcePlanningItemConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforcePlanningItemConversionRuleset(createWorkforcePlanningItemConversionRulesetBody: CreateWorkforcePlanningItemConversionRulesetBody, options?: RawAxiosRequestConfig): AxiosPromise<CreateWorkforcePlanningItemConversionRulesetView> {
            return localVarFp.createWorkforcePlanningItemConversionRuleset(createWorkforcePlanningItemConversionRulesetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを削除する
         * @param {string} rulesetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforcePlanningItemConversionRuleset(rulesetId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteWorkforcePlanningItemConversionRuleset(rulesetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを取得する
         * @param {string} rulesetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningItemConversionRuleset(rulesetId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningItemConversionRulesetDetailView> {
            return localVarFp.getWorkforcePlanningItemConversionRuleset(rulesetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセット一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforcePlanningItemConversionRuleset(options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkforcePlanningItemConversionRulesetDto>> {
            return localVarFp.listWorkforcePlanningItemConversionRuleset(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットからルールを削除する
         * @param {string} rulesetId 
         * @param {string} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkforcePlanningItemConversionRule(rulesetId: string, ruleId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.removeWorkforcePlanningItemConversionRule(rulesetId, ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画明細科目変換ルールセットを更新する
         * @param {string} rulesetId 
         * @param {UpdateWorkforcePlanningItemConversionRulesetBody} updateWorkforcePlanningItemConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningItemConversionRuleset(rulesetId: string, updateWorkforcePlanningItemConversionRulesetBody: UpdateWorkforcePlanningItemConversionRulesetBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateWorkforcePlanningItemConversionRuleset(rulesetId, updateWorkforcePlanningItemConversionRulesetBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningItemConversionRulesetControllerApi - object-oriented interface
 */
export class WorkforcePlanningItemConversionRulesetControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人員計画明細科目変換ルールセットのコピーを作成する
     * @param {string} rulesetId 
     * @param {CopyWorkforcePlanningItemConversionRulesetBody} copyWorkforcePlanningItemConversionRulesetBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyWorkforcePlanningItemConversionRuleset(rulesetId: string, copyWorkforcePlanningItemConversionRulesetBody: CopyWorkforcePlanningItemConversionRulesetBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRulesetControllerApiFp(this.configuration).copyWorkforcePlanningItemConversionRuleset(rulesetId, copyWorkforcePlanningItemConversionRulesetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画明細科目変換ルールセットを作成する
     * @param {CreateWorkforcePlanningItemConversionRulesetBody} createWorkforcePlanningItemConversionRulesetBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createWorkforcePlanningItemConversionRuleset(createWorkforcePlanningItemConversionRulesetBody: CreateWorkforcePlanningItemConversionRulesetBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRulesetControllerApiFp(this.configuration).createWorkforcePlanningItemConversionRuleset(createWorkforcePlanningItemConversionRulesetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画明細科目変換ルールセットを削除する
     * @param {string} rulesetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWorkforcePlanningItemConversionRuleset(rulesetId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRulesetControllerApiFp(this.configuration).deleteWorkforcePlanningItemConversionRuleset(rulesetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画明細科目変換ルールセットを取得する
     * @param {string} rulesetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanningItemConversionRuleset(rulesetId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRulesetControllerApiFp(this.configuration).getWorkforcePlanningItemConversionRuleset(rulesetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画明細科目変換ルールセット一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkforcePlanningItemConversionRuleset(options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRulesetControllerApiFp(this.configuration).listWorkforcePlanningItemConversionRuleset(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画明細科目変換ルールセットからルールを削除する
     * @param {string} rulesetId 
     * @param {string} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeWorkforcePlanningItemConversionRule(rulesetId: string, ruleId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRulesetControllerApiFp(this.configuration).removeWorkforcePlanningItemConversionRule(rulesetId, ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画明細科目変換ルールセットを更新する
     * @param {string} rulesetId 
     * @param {UpdateWorkforcePlanningItemConversionRulesetBody} updateWorkforcePlanningItemConversionRulesetBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWorkforcePlanningItemConversionRuleset(rulesetId: string, updateWorkforcePlanningItemConversionRulesetBody: UpdateWorkforcePlanningItemConversionRulesetBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningItemConversionRulesetControllerApiFp(this.configuration).updateWorkforcePlanningItemConversionRuleset(rulesetId, updateWorkforcePlanningItemConversionRulesetBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningProjectControllerApi - axios parameter creator
 */
export const WorkforcePlanningProjectControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 編成PJに科目変換ルールセットを設定する
         * @param {string} workforcePlanningProjectId 
         * @param {UpdateWorkforcePlanningProjectConversionRulesetBody} updateWorkforcePlanningProjectConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWorkforcePlanningProjectConversionRuleset: async (workforcePlanningProjectId: string, updateWorkforcePlanningProjectConversionRulesetBody: UpdateWorkforcePlanningProjectConversionRulesetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanningProjectId' is not null or undefined
            assertParamExists('assignWorkforcePlanningProjectConversionRuleset', 'workforcePlanningProjectId', workforcePlanningProjectId)
            // verify required parameter 'updateWorkforcePlanningProjectConversionRulesetBody' is not null or undefined
            assertParamExists('assignWorkforcePlanningProjectConversionRuleset', 'updateWorkforcePlanningProjectConversionRulesetBody', updateWorkforcePlanningProjectConversionRulesetBody)
            const localVarPath = `/api/workforce-planning/workforce-planning-projects/{workforcePlanningProjectId}/conversion-ruleset`
                .replace('{workforcePlanningProjectId}', encodeURIComponent(String(workforcePlanningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkforcePlanningProjectConversionRulesetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningProjectByProjectId: async (planningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planningProjectId' is not null or undefined
            assertParamExists('getWorkforcePlanningProjectByProjectId', 'planningProjectId', planningProjectId)
            const localVarPath = `/api/workforce-planning/workforce-planning-projects/by-planning-project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planningProjectId !== undefined) {
                localVarQueryParameter['planningProjectId'] = planningProjectId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画編成プロジェクトの一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforcePlanningProjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/workforce-planning-projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningProjectControllerApi - functional programming interface
 */
export const WorkforcePlanningProjectControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningProjectControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 編成PJに科目変換ルールセットを設定する
         * @param {string} workforcePlanningProjectId 
         * @param {UpdateWorkforcePlanningProjectConversionRulesetBody} updateWorkforcePlanningProjectConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignWorkforcePlanningProjectConversionRuleset(workforcePlanningProjectId: string, updateWorkforcePlanningProjectConversionRulesetBody: UpdateWorkforcePlanningProjectConversionRulesetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignWorkforcePlanningProjectConversionRuleset(workforcePlanningProjectId, updateWorkforcePlanningProjectConversionRulesetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningProjectControllerApi.assignWorkforcePlanningProjectConversionRuleset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanningProjectByProjectId(planningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchWorkforcePlanningProjectUseCaseReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanningProjectByProjectId(planningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningProjectControllerApi.getWorkforcePlanningProjectByProjectId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画編成プロジェクトの一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkforcePlanningProjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkforcePlanningProjectsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkforcePlanningProjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningProjectControllerApi.listWorkforcePlanningProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningProjectControllerApi - factory interface
 */
export const WorkforcePlanningProjectControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningProjectControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 編成PJに科目変換ルールセットを設定する
         * @param {string} workforcePlanningProjectId 
         * @param {UpdateWorkforcePlanningProjectConversionRulesetBody} updateWorkforcePlanningProjectConversionRulesetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignWorkforcePlanningProjectConversionRuleset(workforcePlanningProjectId: string, updateWorkforcePlanningProjectConversionRulesetBody: UpdateWorkforcePlanningProjectConversionRulesetBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.assignWorkforcePlanningProjectConversionRuleset(workforcePlanningProjectId, updateWorkforcePlanningProjectConversionRulesetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningProjectByProjectId(planningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchWorkforcePlanningProjectUseCaseReturn> {
            return localVarFp.getWorkforcePlanningProjectByProjectId(planningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画編成プロジェクトの一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforcePlanningProjects(options?: RawAxiosRequestConfig): AxiosPromise<ListWorkforcePlanningProjectsView> {
            return localVarFp.listWorkforcePlanningProjects(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningProjectControllerApi - object-oriented interface
 */
export class WorkforcePlanningProjectControllerApi extends BaseAPI {
    /**
     * 
     * @summary 編成PJに科目変換ルールセットを設定する
     * @param {string} workforcePlanningProjectId 
     * @param {UpdateWorkforcePlanningProjectConversionRulesetBody} updateWorkforcePlanningProjectConversionRulesetBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignWorkforcePlanningProjectConversionRuleset(workforcePlanningProjectId: string, updateWorkforcePlanningProjectConversionRulesetBody: UpdateWorkforcePlanningProjectConversionRulesetBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningProjectControllerApiFp(this.configuration).assignWorkforcePlanningProjectConversionRuleset(workforcePlanningProjectId, updateWorkforcePlanningProjectConversionRulesetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanningProjectByProjectId(planningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningProjectControllerApiFp(this.configuration).getWorkforcePlanningProjectByProjectId(planningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画編成プロジェクトの一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkforcePlanningProjects(options?: RawAxiosRequestConfig) {
        return WorkforcePlanningProjectControllerApiFp(this.configuration).listWorkforcePlanningProjects(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningProjectSimulationControllerApi - axios parameter creator
 */
export const WorkforcePlanningProjectSimulationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 編成PJからシミュレーションを新規作成する
         * @param {string} workforcePlanningProjectId 
         * @param {CreateWorkforcePlanningProjectSimulationBody} createWorkforcePlanningProjectSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforcePlanningProjectSimulation: async (workforcePlanningProjectId: string, createWorkforcePlanningProjectSimulationBody: CreateWorkforcePlanningProjectSimulationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanningProjectId' is not null or undefined
            assertParamExists('createWorkforcePlanningProjectSimulation', 'workforcePlanningProjectId', workforcePlanningProjectId)
            // verify required parameter 'createWorkforcePlanningProjectSimulationBody' is not null or undefined
            assertParamExists('createWorkforcePlanningProjectSimulation', 'createWorkforcePlanningProjectSimulationBody', createWorkforcePlanningProjectSimulationBody)
            const localVarPath = `/api/workforce-planning/workforce-planning-projects/{workforcePlanningProjectId}/simulations`
                .replace('{workforcePlanningProjectId}', encodeURIComponent(String(workforcePlanningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkforcePlanningProjectSimulationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成PJに紐づくシミュレーションを取得する
         * @param {string} workforcePlanningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningProjectSimulationConnection: async (workforcePlanningProjectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanningProjectId' is not null or undefined
            assertParamExists('getWorkforcePlanningProjectSimulationConnection', 'workforcePlanningProjectId', workforcePlanningProjectId)
            const localVarPath = `/api/workforce-planning/workforce-planning-projects/{workforcePlanningProjectId}/simulation-connection`
                .replace('{workforcePlanningProjectId}', encodeURIComponent(String(workforcePlanningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 編成PJのシミュレーションを上書き作成する
         * @param {string} workforcePlanningProjectId 
         * @param {OverwriteWorkforcePlanningProjectSimulationBody} overwriteWorkforcePlanningProjectSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteWorkforcePlanningProjectSimulation: async (workforcePlanningProjectId: string, overwriteWorkforcePlanningProjectSimulationBody: OverwriteWorkforcePlanningProjectSimulationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforcePlanningProjectId' is not null or undefined
            assertParamExists('overwriteWorkforcePlanningProjectSimulation', 'workforcePlanningProjectId', workforcePlanningProjectId)
            // verify required parameter 'overwriteWorkforcePlanningProjectSimulationBody' is not null or undefined
            assertParamExists('overwriteWorkforcePlanningProjectSimulation', 'overwriteWorkforcePlanningProjectSimulationBody', overwriteWorkforcePlanningProjectSimulationBody)
            const localVarPath = `/api/workforce-planning/workforce-planning-projects/{workforcePlanningProjectId}/simulations/overwrite`
                .replace('{workforcePlanningProjectId}', encodeURIComponent(String(workforcePlanningProjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overwriteWorkforcePlanningProjectSimulationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningProjectSimulationControllerApi - functional programming interface
 */
export const WorkforcePlanningProjectSimulationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningProjectSimulationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 編成PJからシミュレーションを新規作成する
         * @param {string} workforcePlanningProjectId 
         * @param {CreateWorkforcePlanningProjectSimulationBody} createWorkforcePlanningProjectSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkforcePlanningProjectSimulation(workforcePlanningProjectId: string, createWorkforcePlanningProjectSimulationBody: CreateWorkforcePlanningProjectSimulationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedWorkforcePlanningProjectSimulationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkforcePlanningProjectSimulation(workforcePlanningProjectId, createWorkforcePlanningProjectSimulationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningProjectSimulationControllerApi.createWorkforcePlanningProjectSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成PJに紐づくシミュレーションを取得する
         * @param {string} workforcePlanningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanningProjectSimulationConnection(workforcePlanningProjectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningProjectSimulationConnectionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanningProjectSimulationConnection(workforcePlanningProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningProjectSimulationControllerApi.getWorkforcePlanningProjectSimulationConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 編成PJのシミュレーションを上書き作成する
         * @param {string} workforcePlanningProjectId 
         * @param {OverwriteWorkforcePlanningProjectSimulationBody} overwriteWorkforcePlanningProjectSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overwriteWorkforcePlanningProjectSimulation(workforcePlanningProjectId: string, overwriteWorkforcePlanningProjectSimulationBody: OverwriteWorkforcePlanningProjectSimulationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverwrittenWorkforcePlanningProjectSimulationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overwriteWorkforcePlanningProjectSimulation(workforcePlanningProjectId, overwriteWorkforcePlanningProjectSimulationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningProjectSimulationControllerApi.overwriteWorkforcePlanningProjectSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningProjectSimulationControllerApi - factory interface
 */
export const WorkforcePlanningProjectSimulationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningProjectSimulationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 編成PJからシミュレーションを新規作成する
         * @param {string} workforcePlanningProjectId 
         * @param {CreateWorkforcePlanningProjectSimulationBody} createWorkforcePlanningProjectSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkforcePlanningProjectSimulation(workforcePlanningProjectId: string, createWorkforcePlanningProjectSimulationBody: CreateWorkforcePlanningProjectSimulationBody, options?: RawAxiosRequestConfig): AxiosPromise<CreatedWorkforcePlanningProjectSimulationView> {
            return localVarFp.createWorkforcePlanningProjectSimulation(workforcePlanningProjectId, createWorkforcePlanningProjectSimulationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成PJに紐づくシミュレーションを取得する
         * @param {string} workforcePlanningProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningProjectSimulationConnection(workforcePlanningProjectId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningProjectSimulationConnectionView> {
            return localVarFp.getWorkforcePlanningProjectSimulationConnection(workforcePlanningProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 編成PJのシミュレーションを上書き作成する
         * @param {string} workforcePlanningProjectId 
         * @param {OverwriteWorkforcePlanningProjectSimulationBody} overwriteWorkforcePlanningProjectSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteWorkforcePlanningProjectSimulation(workforcePlanningProjectId: string, overwriteWorkforcePlanningProjectSimulationBody: OverwriteWorkforcePlanningProjectSimulationBody, options?: RawAxiosRequestConfig): AxiosPromise<OverwrittenWorkforcePlanningProjectSimulationView> {
            return localVarFp.overwriteWorkforcePlanningProjectSimulation(workforcePlanningProjectId, overwriteWorkforcePlanningProjectSimulationBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningProjectSimulationControllerApi - object-oriented interface
 */
export class WorkforcePlanningProjectSimulationControllerApi extends BaseAPI {
    /**
     * 
     * @summary 編成PJからシミュレーションを新規作成する
     * @param {string} workforcePlanningProjectId 
     * @param {CreateWorkforcePlanningProjectSimulationBody} createWorkforcePlanningProjectSimulationBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createWorkforcePlanningProjectSimulation(workforcePlanningProjectId: string, createWorkforcePlanningProjectSimulationBody: CreateWorkforcePlanningProjectSimulationBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningProjectSimulationControllerApiFp(this.configuration).createWorkforcePlanningProjectSimulation(workforcePlanningProjectId, createWorkforcePlanningProjectSimulationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成PJに紐づくシミュレーションを取得する
     * @param {string} workforcePlanningProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanningProjectSimulationConnection(workforcePlanningProjectId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningProjectSimulationControllerApiFp(this.configuration).getWorkforcePlanningProjectSimulationConnection(workforcePlanningProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 編成PJのシミュレーションを上書き作成する
     * @param {string} workforcePlanningProjectId 
     * @param {OverwriteWorkforcePlanningProjectSimulationBody} overwriteWorkforcePlanningProjectSimulationBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public overwriteWorkforcePlanningProjectSimulation(workforcePlanningProjectId: string, overwriteWorkforcePlanningProjectSimulationBody: OverwriteWorkforcePlanningProjectSimulationBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningProjectSimulationControllerApiFp(this.configuration).overwriteWorkforcePlanningProjectSimulation(workforcePlanningProjectId, overwriteWorkforcePlanningProjectSimulationBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningSettingControllerApi - axios parameter creator
 */
export const WorkforcePlanningSettingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人員計画分析軸の情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWorkforceDimension: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/settings/workforce-dimension`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画枠利用開始する年月取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWorkforceSlotStartYearMonth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画枠利用開始する年月更新
         * @param {UpdateWorkforceSlotStartYearMonthParam} updateWorkforceSlotStartYearMonthParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforceSlotStartYearMonth: async (updateWorkforceSlotStartYearMonthParam: UpdateWorkforceSlotStartYearMonthParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateWorkforceSlotStartYearMonthParam' is not null or undefined
            assertParamExists('updateWorkforceSlotStartYearMonth', 'updateWorkforceSlotStartYearMonthParam', updateWorkforceSlotStartYearMonthParam)
            const localVarPath = `/api/workforce-planning/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkforceSlotStartYearMonthParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningSettingControllerApi - functional programming interface
 */
export const WorkforcePlanningSettingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningSettingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人員計画分析軸の情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchWorkforceDimension(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceDimensionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchWorkforceDimension(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSettingControllerApi.fetchWorkforceDimension']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画枠利用開始する年月取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchWorkforceSlotStartYearMonth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceSlotStartYearMonthView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchWorkforceSlotStartYearMonth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSettingControllerApi.fetchWorkforceSlotStartYearMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画枠利用開始する年月更新
         * @param {UpdateWorkforceSlotStartYearMonthParam} updateWorkforceSlotStartYearMonthParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkforceSlotStartYearMonth(updateWorkforceSlotStartYearMonthParam: UpdateWorkforceSlotStartYearMonthParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkforceSlotStartYearMonth(updateWorkforceSlotStartYearMonthParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSettingControllerApi.updateWorkforceSlotStartYearMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningSettingControllerApi - factory interface
 */
export const WorkforcePlanningSettingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningSettingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人員計画分析軸の情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWorkforceDimension(options?: RawAxiosRequestConfig): AxiosPromise<WorkforceDimensionView> {
            return localVarFp.fetchWorkforceDimension(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画枠利用開始する年月取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWorkforceSlotStartYearMonth(options?: RawAxiosRequestConfig): AxiosPromise<WorkforceSlotStartYearMonthView> {
            return localVarFp.fetchWorkforceSlotStartYearMonth(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画枠利用開始する年月更新
         * @param {UpdateWorkforceSlotStartYearMonthParam} updateWorkforceSlotStartYearMonthParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforceSlotStartYearMonth(updateWorkforceSlotStartYearMonthParam: UpdateWorkforceSlotStartYearMonthParam, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateWorkforceSlotStartYearMonth(updateWorkforceSlotStartYearMonthParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningSettingControllerApi - object-oriented interface
 */
export class WorkforcePlanningSettingControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人員計画分析軸の情報取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchWorkforceDimension(options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSettingControllerApiFp(this.configuration).fetchWorkforceDimension(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画枠利用開始する年月取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchWorkforceSlotStartYearMonth(options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSettingControllerApiFp(this.configuration).fetchWorkforceSlotStartYearMonth(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画枠利用開始する年月更新
     * @param {UpdateWorkforceSlotStartYearMonthParam} updateWorkforceSlotStartYearMonthParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWorkforceSlotStartYearMonth(updateWorkforceSlotStartYearMonthParam: UpdateWorkforceSlotStartYearMonthParam, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSettingControllerApiFp(this.configuration).updateWorkforceSlotStartYearMonth(updateWorkforceSlotStartYearMonthParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningSimulationControllerApi - axios parameter creator
 */
export const WorkforcePlanningSimulationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シミュレーションを削除する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforcePlanningSimulation: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('deleteWorkforcePlanningSimulation', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーション条件を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationCondition: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulationCondition', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/condition`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーションで使用する分析軸（タグ情報付き）を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsingDimensions: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getUsingDimensions', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/using-dimensions`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーションの基本情報を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningSimulation: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getWorkforcePlanningSimulation', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーションの非同期処理ステータスを取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningSimulationAsyncStatus: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getWorkforcePlanningSimulationAsyncStatus', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/async-status`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーション計算時から参照ルールに変更があるかを取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningSimulationRuleVersionStaleness: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getWorkforcePlanningSimulationRuleVersionStaleness', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/rule-version-staleness`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/in-development/simulations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTargetDepartments: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('listTargetDepartments', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/target-departments`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーション同時編集者の一覧を更新・取得する（自分の最終アクセス時刻を記録し、直近3分以内にアクセスのあるユーザー一覧を返す）
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSimulationActiveEditors: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('refreshSimulationActiveEditors', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/active-editors`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 作成に失敗したシミュレーションの作成処理をやり直す
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryWorkforcePlanningSimulationCreation: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('retryWorkforcePlanningSimulationCreation', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/retry-creation`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーションの基準年月を更新する
         * @param {string} simulationId 
         * @param {UpdateSimulationBaseYearMonthBody} updateSimulationBaseYearMonthBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningSimulationBaseYearMonth: async (simulationId: string, updateSimulationBaseYearMonthBody: UpdateSimulationBaseYearMonthBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateWorkforcePlanningSimulationBaseYearMonth', 'simulationId', simulationId)
            // verify required parameter 'updateSimulationBaseYearMonthBody' is not null or undefined
            assertParamExists('updateWorkforcePlanningSimulationBaseYearMonth', 'updateSimulationBaseYearMonthBody', updateSimulationBaseYearMonthBody)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/base-year-month`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSimulationBaseYearMonthBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーション名を更新する
         * @param {string} simulationId 
         * @param {UpdateSimulationNameBody} updateSimulationNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningSimulationName: async (simulationId: string, updateSimulationNameBody: UpdateSimulationNameBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('updateWorkforcePlanningSimulationName', 'simulationId', simulationId)
            // verify required parameter 'updateSimulationNameBody' is not null or undefined
            assertParamExists('updateWorkforcePlanningSimulationName', 'updateSimulationNameBody', updateSimulationNameBody)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/name`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSimulationNameBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningSimulationControllerApi - functional programming interface
 */
export const WorkforcePlanningSimulationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningSimulationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シミュレーションを削除する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkforcePlanningSimulation(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkforcePlanningSimulation(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.deleteWorkforcePlanningSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーション条件を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulationCondition(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningSimulationConditionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulationCondition(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.getSimulationCondition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーションで使用する分析軸（タグ情報付き）を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsingDimensions(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchWorkforcePlanningSimulationUsingDimensionUseCaseReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsingDimensions(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.getUsingDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーションの基本情報を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanningSimulation(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningSimulationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanningSimulation(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.getWorkforcePlanningSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーションの非同期処理ステータスを取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanningSimulationAsyncStatus(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningSimulationAsyncStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanningSimulationAsyncStatus(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.getWorkforcePlanningSimulationAsyncStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーション計算時から参照ルールに変更があるかを取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkforcePlanningSimulationRuleVersionStaleness(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforcePlanningSimulationRuleVersionStalenessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkforcePlanningSimulationRuleVersionStaleness(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.getWorkforcePlanningSimulationRuleVersionStaleness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSimulations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSimulationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSimulations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.listSimulations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTargetDepartments(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchWorkforcePlanningSimulationTargetDepartmentUseCaseReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTargetDepartments(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.listTargetDepartments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーション同時編集者の一覧を更新・取得する（自分の最終アクセス時刻を記録し、直近3分以内にアクセスのあるユーザー一覧を返す）
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshSimulationActiveEditors(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkforcePlanningSimulationActiveEditorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshSimulationActiveEditors(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.refreshSimulationActiveEditors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 作成に失敗したシミュレーションの作成処理をやり直す
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryWorkforcePlanningSimulationCreation(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryWorkforcePlanningSimulationCreation(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.retryWorkforcePlanningSimulationCreation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーションの基準年月を更新する
         * @param {string} simulationId 
         * @param {UpdateSimulationBaseYearMonthBody} updateSimulationBaseYearMonthBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkforcePlanningSimulationBaseYearMonth(simulationId: string, updateSimulationBaseYearMonthBody: UpdateSimulationBaseYearMonthBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkforcePlanningSimulationBaseYearMonth(simulationId, updateSimulationBaseYearMonthBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.updateWorkforcePlanningSimulationBaseYearMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーション名を更新する
         * @param {string} simulationId 
         * @param {UpdateSimulationNameBody} updateSimulationNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkforcePlanningSimulationName(simulationId: string, updateSimulationNameBody: UpdateSimulationNameBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkforcePlanningSimulationName(simulationId, updateSimulationNameBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationControllerApi.updateWorkforcePlanningSimulationName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningSimulationControllerApi - factory interface
 */
export const WorkforcePlanningSimulationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningSimulationControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary シミュレーションを削除する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforcePlanningSimulation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteWorkforcePlanningSimulation(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーション条件を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationCondition(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningSimulationConditionView> {
            return localVarFp.getSimulationCondition(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーションで使用する分析軸（タグ情報付き）を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsingDimensions(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchWorkforcePlanningSimulationUsingDimensionUseCaseReturn> {
            return localVarFp.getUsingDimensions(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーションの基本情報を取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningSimulation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningSimulationView> {
            return localVarFp.getWorkforcePlanningSimulation(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーションの非同期処理ステータスを取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningSimulationAsyncStatus(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningSimulationAsyncStatusDto> {
            return localVarFp.getWorkforcePlanningSimulationAsyncStatus(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーション計算時から参照ルールに変更があるかを取得する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforcePlanningSimulationRuleVersionStaleness(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforcePlanningSimulationRuleVersionStalenessDto> {
            return localVarFp.getWorkforcePlanningSimulationRuleVersionStaleness(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSimulations(options?: RawAxiosRequestConfig): AxiosPromise<ListSimulationView> {
            return localVarFp.listSimulations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTargetDepartments(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<FetchWorkforcePlanningSimulationTargetDepartmentUseCaseReturn> {
            return localVarFp.listTargetDepartments(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーション同時編集者の一覧を更新・取得する（自分の最終アクセス時刻を記録し、直近3分以内にアクセスのあるユーザー一覧を返す）
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshSimulationActiveEditors(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkforcePlanningSimulationActiveEditorDto>> {
            return localVarFp.refreshSimulationActiveEditors(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 作成に失敗したシミュレーションの作成処理をやり直す
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryWorkforcePlanningSimulationCreation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.retryWorkforcePlanningSimulationCreation(simulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーションの基準年月を更新する
         * @param {string} simulationId 
         * @param {UpdateSimulationBaseYearMonthBody} updateSimulationBaseYearMonthBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningSimulationBaseYearMonth(simulationId: string, updateSimulationBaseYearMonthBody: UpdateSimulationBaseYearMonthBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateWorkforcePlanningSimulationBaseYearMonth(simulationId, updateSimulationBaseYearMonthBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーション名を更新する
         * @param {string} simulationId 
         * @param {UpdateSimulationNameBody} updateSimulationNameBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforcePlanningSimulationName(simulationId: string, updateSimulationNameBody: UpdateSimulationNameBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateWorkforcePlanningSimulationName(simulationId, updateSimulationNameBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningSimulationControllerApi - object-oriented interface
 */
export class WorkforcePlanningSimulationControllerApi extends BaseAPI {
    /**
     * 
     * @summary シミュレーションを削除する
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWorkforcePlanningSimulation(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).deleteWorkforcePlanningSimulation(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーション条件を取得する
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulationCondition(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).getSimulationCondition(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーションで使用する分析軸（タグ情報付き）を取得する
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsingDimensions(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).getUsingDimensions(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーションの基本情報を取得する
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanningSimulation(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).getWorkforcePlanningSimulation(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーションの非同期処理ステータスを取得する
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanningSimulationAsyncStatus(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).getWorkforcePlanningSimulationAsyncStatus(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーション計算時から参照ルールに変更があるかを取得する
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkforcePlanningSimulationRuleVersionStaleness(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).getWorkforcePlanningSimulationRuleVersionStaleness(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSimulations(options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).listSimulations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTargetDepartments(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).listTargetDepartments(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーション同時編集者の一覧を更新・取得する（自分の最終アクセス時刻を記録し、直近3分以内にアクセスのあるユーザー一覧を返す）
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshSimulationActiveEditors(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).refreshSimulationActiveEditors(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 作成に失敗したシミュレーションの作成処理をやり直す
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retryWorkforcePlanningSimulationCreation(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).retryWorkforcePlanningSimulationCreation(simulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーションの基準年月を更新する
     * @param {string} simulationId 
     * @param {UpdateSimulationBaseYearMonthBody} updateSimulationBaseYearMonthBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWorkforcePlanningSimulationBaseYearMonth(simulationId: string, updateSimulationBaseYearMonthBody: UpdateSimulationBaseYearMonthBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).updateWorkforcePlanningSimulationBaseYearMonth(simulationId, updateSimulationBaseYearMonthBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーション名を更新する
     * @param {string} simulationId 
     * @param {UpdateSimulationNameBody} updateSimulationNameBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWorkforcePlanningSimulationName(simulationId: string, updateSimulationNameBody: UpdateSimulationNameBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationControllerApiFp(this.configuration).updateWorkforcePlanningSimulationName(simulationId, updateSimulationNameBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningSimulationPlControllerApi - axios parameter creator
 */
export const WorkforcePlanningSimulationPlControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シミュレーションのレポート集計データを取得する
         * @param {string} simulationId 
         * @param {SimulationReportBody} simulationReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationReport: async (simulationId: string, simulationReportBody: SimulationReportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulationReport', 'simulationId', simulationId)
            // verify required parameter 'simulationReportBody' is not null or undefined
            assertParamExists('getSimulationReport', 'simulationReportBody', simulationReportBody)
            const localVarPath = `/api/workforce-planning/in-development/simulations/pl/{simulationId}/report`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulationReportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーションの明細データを取得する
         * @param {string} simulationId 
         * @param {SimulationReportDetailParam} simulationReportDetailParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationReportDetail: async (simulationId: string, simulationReportDetailParam: SimulationReportDetailParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('getSimulationReportDetail', 'simulationId', simulationId)
            // verify required parameter 'simulationReportDetailParam' is not null or undefined
            assertParamExists('getSimulationReportDetail', 'simulationReportDetailParam', simulationReportDetailParam)
            const localVarPath = `/api/workforce-planning/in-development/simulations/pl/{simulationId}/report-detail`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulationReportDetailParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シミュレーションの再計算を実行する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateWorkforcePlanningSimulation: async (simulationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('recalculateWorkforcePlanningSimulation', 'simulationId', simulationId)
            const localVarPath = `/api/workforce-planning/in-development/simulations/pl/{simulationId}/recalculate`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningSimulationPlControllerApi - functional programming interface
 */
export const WorkforcePlanningSimulationPlControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningSimulationPlControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シミュレーションのレポート集計データを取得する
         * @param {string} simulationId 
         * @param {SimulationReportBody} simulationReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulationReport(simulationId: string, simulationReportBody: SimulationReportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulationReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulationReport(simulationId, simulationReportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationPlControllerApi.getSimulationReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーションの明細データを取得する
         * @param {string} simulationId 
         * @param {SimulationReportDetailParam} simulationReportDetailParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimulationReportDetail(simulationId: string, simulationReportDetailParam: SimulationReportDetailParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulationReportDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimulationReportDetail(simulationId, simulationReportDetailParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationPlControllerApi.getSimulationReportDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary シミュレーションの再計算を実行する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculateWorkforcePlanningSimulation(simulationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recalculateWorkforcePlanningSimulation(simulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationPlControllerApi.recalculateWorkforcePlanningSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningSimulationPlControllerApi - factory interface
 */
export const WorkforcePlanningSimulationPlControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningSimulationPlControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary シミュレーションのレポート集計データを取得する
         * @param {string} simulationId 
         * @param {SimulationReportBody} simulationReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationReport(simulationId: string, simulationReportBody: SimulationReportBody, options?: RawAxiosRequestConfig): AxiosPromise<SimulationReportResponse> {
            return localVarFp.getSimulationReport(simulationId, simulationReportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーションの明細データを取得する
         * @param {string} simulationId 
         * @param {SimulationReportDetailParam} simulationReportDetailParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimulationReportDetail(simulationId: string, simulationReportDetailParam: SimulationReportDetailParam, options?: RawAxiosRequestConfig): AxiosPromise<SimulationReportDetailResponse> {
            return localVarFp.getSimulationReportDetail(simulationId, simulationReportDetailParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シミュレーションの再計算を実行する
         * @param {string} simulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculateWorkforcePlanningSimulation(simulationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.recalculateWorkforcePlanningSimulation(simulationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningSimulationPlControllerApi - object-oriented interface
 */
export class WorkforcePlanningSimulationPlControllerApi extends BaseAPI {
    /**
     * 
     * @summary シミュレーションのレポート集計データを取得する
     * @param {string} simulationId 
     * @param {SimulationReportBody} simulationReportBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulationReport(simulationId: string, simulationReportBody: SimulationReportBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationPlControllerApiFp(this.configuration).getSimulationReport(simulationId, simulationReportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーションの明細データを取得する
     * @param {string} simulationId 
     * @param {SimulationReportDetailParam} simulationReportDetailParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSimulationReportDetail(simulationId: string, simulationReportDetailParam: SimulationReportDetailParam, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationPlControllerApiFp(this.configuration).getSimulationReportDetail(simulationId, simulationReportDetailParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シミュレーションの再計算を実行する
     * @param {string} simulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recalculateWorkforcePlanningSimulation(simulationId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationPlControllerApiFp(this.configuration).recalculateWorkforcePlanningSimulation(simulationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApi - axios parameter creator
 */
export const WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シミュレーションから編成プロジェクトに更新申請を提出し、申請に含まれなかった計画を理由つきで返す
         * @param {string} simulationId 
         * @param {SubmitPlanUpdateRequestFromWorkforcePlanningSimulationBody} submitPlanUpdateRequestFromWorkforcePlanningSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPlanUpdateRequestFromWorkforcePlanningSimulation: async (simulationId: string, submitPlanUpdateRequestFromWorkforcePlanningSimulationBody: SubmitPlanUpdateRequestFromWorkforcePlanningSimulationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationId' is not null or undefined
            assertParamExists('submitPlanUpdateRequestFromWorkforcePlanningSimulation', 'simulationId', simulationId)
            // verify required parameter 'submitPlanUpdateRequestFromWorkforcePlanningSimulationBody' is not null or undefined
            assertParamExists('submitPlanUpdateRequestFromWorkforcePlanningSimulation', 'submitPlanUpdateRequestFromWorkforcePlanningSimulationBody', submitPlanUpdateRequestFromWorkforcePlanningSimulationBody)
            const localVarPath = `/api/workforce-planning/in-development/simulations/{simulationId}/workforce-plan-update-requests/submit`
                .replace('{simulationId}', encodeURIComponent(String(simulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitPlanUpdateRequestFromWorkforcePlanningSimulationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApi - functional programming interface
 */
export const WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シミュレーションから編成プロジェクトに更新申請を提出し、申請に含まれなかった計画を理由つきで返す
         * @param {string} simulationId 
         * @param {SubmitPlanUpdateRequestFromWorkforcePlanningSimulationBody} submitPlanUpdateRequestFromWorkforcePlanningSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitPlanUpdateRequestFromWorkforcePlanningSimulation(simulationId: string, submitPlanUpdateRequestFromWorkforcePlanningSimulationBody: SubmitPlanUpdateRequestFromWorkforcePlanningSimulationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitPlanUpdateRequestFromWorkforcePlanningSimulationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitPlanUpdateRequestFromWorkforcePlanningSimulation(simulationId, submitPlanUpdateRequestFromWorkforcePlanningSimulationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApi.submitPlanUpdateRequestFromWorkforcePlanningSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApi - factory interface
 */
export const WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary シミュレーションから編成プロジェクトに更新申請を提出し、申請に含まれなかった計画を理由つきで返す
         * @param {string} simulationId 
         * @param {SubmitPlanUpdateRequestFromWorkforcePlanningSimulationBody} submitPlanUpdateRequestFromWorkforcePlanningSimulationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPlanUpdateRequestFromWorkforcePlanningSimulation(simulationId: string, submitPlanUpdateRequestFromWorkforcePlanningSimulationBody: SubmitPlanUpdateRequestFromWorkforcePlanningSimulationBody, options?: RawAxiosRequestConfig): AxiosPromise<SubmitPlanUpdateRequestFromWorkforcePlanningSimulationView> {
            return localVarFp.submitPlanUpdateRequestFromWorkforcePlanningSimulation(simulationId, submitPlanUpdateRequestFromWorkforcePlanningSimulationBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApi - object-oriented interface
 */
export class WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApi extends BaseAPI {
    /**
     * 
     * @summary シミュレーションから編成プロジェクトに更新申請を提出し、申請に含まれなかった計画を理由つきで返す
     * @param {string} simulationId 
     * @param {SubmitPlanUpdateRequestFromWorkforcePlanningSimulationBody} submitPlanUpdateRequestFromWorkforcePlanningSimulationBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitPlanUpdateRequestFromWorkforcePlanningSimulation(simulationId: string, submitPlanUpdateRequestFromWorkforcePlanningSimulationBody: SubmitPlanUpdateRequestFromWorkforcePlanningSimulationBody, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningSimulationWorkforcePlanUpdateRequestControllerApiFp(this.configuration).submitPlanUpdateRequestFromWorkforcePlanningSimulation(simulationId, submitPlanUpdateRequestFromWorkforcePlanningSimulationBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforcePlanningUnitAmountItemControllerApi - axios parameter creator
 */
export const WorkforcePlanningUnitAmountItemControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UpsertUnitAmountItemParam} upsertUnitAmountItemParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnitAmountItem: async (upsertUnitAmountItemParam: UpsertUnitAmountItemParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertUnitAmountItemParam' is not null or undefined
            assertParamExists('createUnitAmountItem', 'upsertUnitAmountItemParam', upsertUnitAmountItemParam)
            const localVarPath = `/api/workforce-planning/unit-amount-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertUnitAmountItemParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unitAmountItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnitAmountItem: async (unitAmountItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitAmountItemId' is not null or undefined
            assertParamExists('deleteUnitAmountItem', 'unitAmountItemId', unitAmountItemId)
            const localVarPath = `/api/workforce-planning/unit-amount-items/{unitAmountItemId}`
                .replace('{unitAmountItemId}', encodeURIComponent(String(unitAmountItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnitAmountItems: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/unit-amount-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unitAmountItemId 
         * @param {UpsertUnitAmountItemParam} upsertUnitAmountItemParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnitAmountItem: async (unitAmountItemId: string, upsertUnitAmountItemParam: UpsertUnitAmountItemParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitAmountItemId' is not null or undefined
            assertParamExists('updateUnitAmountItem', 'unitAmountItemId', unitAmountItemId)
            // verify required parameter 'upsertUnitAmountItemParam' is not null or undefined
            assertParamExists('updateUnitAmountItem', 'upsertUnitAmountItemParam', upsertUnitAmountItemParam)
            const localVarPath = `/api/workforce-planning/unit-amount-items/{unitAmountItemId}`
                .replace('{unitAmountItemId}', encodeURIComponent(String(unitAmountItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertUnitAmountItemParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforcePlanningUnitAmountItemControllerApi - functional programming interface
 */
export const WorkforcePlanningUnitAmountItemControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforcePlanningUnitAmountItemControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UpsertUnitAmountItemParam} upsertUnitAmountItemParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUnitAmountItem(upsertUnitAmountItemParam: UpsertUnitAmountItemParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUnitAmountItem(upsertUnitAmountItemParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningUnitAmountItemControllerApi.createUnitAmountItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} unitAmountItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUnitAmountItem(unitAmountItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUnitAmountItem(unitAmountItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningUnitAmountItemControllerApi.deleteUnitAmountItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUnitAmountItems(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUnitAmountItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUnitAmountItems(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningUnitAmountItemControllerApi.listUnitAmountItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} unitAmountItemId 
         * @param {UpsertUnitAmountItemParam} upsertUnitAmountItemParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUnitAmountItem(unitAmountItemId: string, upsertUnitAmountItemParam: UpsertUnitAmountItemParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUnitAmountItem(unitAmountItemId, upsertUnitAmountItemParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforcePlanningUnitAmountItemControllerApi.updateUnitAmountItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforcePlanningUnitAmountItemControllerApi - factory interface
 */
export const WorkforcePlanningUnitAmountItemControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforcePlanningUnitAmountItemControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {UpsertUnitAmountItemParam} upsertUnitAmountItemParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUnitAmountItem(upsertUnitAmountItemParam: UpsertUnitAmountItemParam, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createUnitAmountItem(upsertUnitAmountItemParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unitAmountItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnitAmountItem(unitAmountItemId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUnitAmountItem(unitAmountItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnitAmountItems(options?: RawAxiosRequestConfig): AxiosPromise<ListUnitAmountItemsResponse> {
            return localVarFp.listUnitAmountItems(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unitAmountItemId 
         * @param {UpsertUnitAmountItemParam} upsertUnitAmountItemParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnitAmountItem(unitAmountItemId: string, upsertUnitAmountItemParam: UpsertUnitAmountItemParam, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUnitAmountItem(unitAmountItemId, upsertUnitAmountItemParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforcePlanningUnitAmountItemControllerApi - object-oriented interface
 */
export class WorkforcePlanningUnitAmountItemControllerApi extends BaseAPI {
    /**
     * 
     * @param {UpsertUnitAmountItemParam} upsertUnitAmountItemParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUnitAmountItem(upsertUnitAmountItemParam: UpsertUnitAmountItemParam, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningUnitAmountItemControllerApiFp(this.configuration).createUnitAmountItem(upsertUnitAmountItemParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} unitAmountItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUnitAmountItem(unitAmountItemId: string, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningUnitAmountItemControllerApiFp(this.configuration).deleteUnitAmountItem(unitAmountItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listUnitAmountItems(options?: RawAxiosRequestConfig) {
        return WorkforcePlanningUnitAmountItemControllerApiFp(this.configuration).listUnitAmountItems(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} unitAmountItemId 
     * @param {UpsertUnitAmountItemParam} upsertUnitAmountItemParam 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUnitAmountItem(unitAmountItemId: string, upsertUnitAmountItemParam: UpsertUnitAmountItemParam, options?: RawAxiosRequestConfig) {
        return WorkforcePlanningUnitAmountItemControllerApiFp(this.configuration).updateUnitAmountItem(unitAmountItemId, upsertUnitAmountItemParam, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi - axios parameter creator
 */
export const WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人員の実績イベントに枠を紐づける
         * @param {CreateConnectionBody} createConnectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnection: async (createConnectionBody: CreateConnectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createConnectionBody' is not null or undefined
            assertParamExists('createConnection', 'createConnectionBody', createConnectionBody)
            const localVarPath = `/api/v2/workforce-planning/workforce-slot-to-workforce-actual-connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConnectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員・枠の紐づけを解除する
         * @param {DeleteConnectionBody} deleteConnectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnection: async (deleteConnectionBody: DeleteConnectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteConnectionBody' is not null or undefined
            assertParamExists('deleteConnection', 'deleteConnectionBody', deleteConnectionBody)
            const localVarPath = `/api/v2/workforce-planning/workforce-slot-to-workforce-actual-connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteConnectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 紐づける必要のある枠タイプを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnconnectedSlotTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/workforce-planning/workforce-slot-to-workforce-actual-connections/unconnected-slot-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員に紐づいている枠を取得する
         * @param {string} workforceActualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectedByWorkforce: async (workforceActualId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceActualId' is not null or undefined
            assertParamExists('listConnectedByWorkforce', 'workforceActualId', workforceActualId)
            const localVarPath = `/api/v2/workforce-planning/workforce-slot-to-workforce-actual-connections/by-workforce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (workforceActualId !== undefined) {
                localVarQueryParameter['workforceActualId'] = workforceActualId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 枠に紐づいている人員実績イベントを取得する
         * @param {string} workforceSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectionsByWorkforceSlot: async (workforceSlotId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceSlotId' is not null or undefined
            assertParamExists('listConnectionsByWorkforceSlot', 'workforceSlotId', workforceSlotId)
            const localVarPath = `/api/v2/workforce-planning/workforce-slot-to-workforce-actual-connections/by-slot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (workforceSlotId !== undefined) {
                localVarQueryParameter['workforceSlotId'] = workforceSlotId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 枠に紐づいていない人員実績一覧を取得する
         * @param {ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum} workforceSlotType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnconnectedWorkforceActualEvent: async (workforceSlotType: ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceSlotType' is not null or undefined
            assertParamExists('listUnconnectedWorkforceActualEvent', 'workforceSlotType', workforceSlotType)
            const localVarPath = `/api/v2/workforce-planning/workforce-slot-to-workforce-actual-connections/unconnected-workforce-actual-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (workforceSlotType !== undefined) {
                localVarQueryParameter['workforceSlotType'] = workforceSlotType;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi - functional programming interface
 */
export const WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人員の実績イベントに枠を紐づける
         * @param {CreateConnectionBody} createConnectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnection(createConnectionBody: CreateConnectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnection(createConnectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi.createConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員・枠の紐づけを解除する
         * @param {DeleteConnectionBody} deleteConnectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConnection(deleteConnectionBody: DeleteConnectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConnection(deleteConnectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi.deleteConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 紐づける必要のある枠タイプを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnconnectedSlotTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnconnectedSlotTypesReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnconnectedSlotTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi.getUnconnectedSlotTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員に紐づいている枠を取得する
         * @param {string} workforceActualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectedByWorkforce(workforceActualId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FetchConnectionByWorkforceResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectedByWorkforce(workforceActualId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi.listConnectedByWorkforce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 枠に紐づいている人員実績イベントを取得する
         * @param {string} workforceSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectionsByWorkforceSlot(workforceSlotId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FetchConnectionsBySlotResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectionsByWorkforceSlot(workforceSlotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi.listConnectionsByWorkforceSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 枠に紐づいていない人員実績一覧を取得する
         * @param {ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum} workforceSlotType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUnconnectedWorkforceActualEvent(workforceSlotType: ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUnconnectedWorkforceActualEventReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUnconnectedWorkforceActualEvent(workforceSlotType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi.listUnconnectedWorkforceActualEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi - factory interface
 */
export const WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人員の実績イベントに枠を紐づける
         * @param {CreateConnectionBody} createConnectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnection(createConnectionBody: CreateConnectionBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createConnection(createConnectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員・枠の紐づけを解除する
         * @param {DeleteConnectionBody} deleteConnectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnection(deleteConnectionBody: DeleteConnectionBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteConnection(deleteConnectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 紐づける必要のある枠タイプを取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnconnectedSlotTypes(options?: RawAxiosRequestConfig): AxiosPromise<GetUnconnectedSlotTypesReturn> {
            return localVarFp.getUnconnectedSlotTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員に紐づいている枠を取得する
         * @param {string} workforceActualId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectedByWorkforce(workforceActualId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FetchConnectionByWorkforceResult>> {
            return localVarFp.listConnectedByWorkforce(workforceActualId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 枠に紐づいている人員実績イベントを取得する
         * @param {string} workforceSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectionsByWorkforceSlot(workforceSlotId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FetchConnectionsBySlotResult>> {
            return localVarFp.listConnectionsByWorkforceSlot(workforceSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 枠に紐づいていない人員実績一覧を取得する
         * @param {ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum} workforceSlotType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnconnectedWorkforceActualEvent(workforceSlotType: ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<ListUnconnectedWorkforceActualEventReturn> {
            return localVarFp.listUnconnectedWorkforceActualEvent(workforceSlotType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi - object-oriented interface
 */
export class WorkforceSlotToWorkforceActualEventConnectionV2ControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人員の実績イベントに枠を紐づける
     * @param {CreateConnectionBody} createConnectionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createConnection(createConnectionBody: CreateConnectionBody, options?: RawAxiosRequestConfig) {
        return WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiFp(this.configuration).createConnection(createConnectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員・枠の紐づけを解除する
     * @param {DeleteConnectionBody} deleteConnectionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConnection(deleteConnectionBody: DeleteConnectionBody, options?: RawAxiosRequestConfig) {
        return WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiFp(this.configuration).deleteConnection(deleteConnectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 紐づける必要のある枠タイプを取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUnconnectedSlotTypes(options?: RawAxiosRequestConfig) {
        return WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiFp(this.configuration).getUnconnectedSlotTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員に紐づいている枠を取得する
     * @param {string} workforceActualId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listConnectedByWorkforce(workforceActualId: string, options?: RawAxiosRequestConfig) {
        return WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiFp(this.configuration).listConnectedByWorkforce(workforceActualId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 枠に紐づいている人員実績イベントを取得する
     * @param {string} workforceSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listConnectionsByWorkforceSlot(workforceSlotId: string, options?: RawAxiosRequestConfig) {
        return WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiFp(this.configuration).listConnectionsByWorkforceSlot(workforceSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 枠に紐づいていない人員実績一覧を取得する
     * @param {ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum} workforceSlotType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listUnconnectedWorkforceActualEvent(workforceSlotType: ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum, options?: RawAxiosRequestConfig) {
        return WorkforceSlotToWorkforceActualEventConnectionV2ControllerApiFp(this.configuration).listUnconnectedWorkforceActualEvent(workforceSlotType, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum = {
    Hiring: 'HIRING',
    Resignation: 'RESIGNATION',
    LeaveOfAbsence: 'LEAVE_OF_ABSENCE',
    ReturnToWork: 'RETURN_TO_WORK',
    TransferDepartment: 'TRANSFER_DEPARTMENT',
} as const;
export type ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum = typeof ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum[keyof typeof ListUnconnectedWorkforceActualEventWorkforceSlotTypeEnum];


/**
 * WorkforceSlotUnitAmountSuggestionControllerApi - axios parameter creator
 */
export const WorkforceSlotUnitAmountSuggestionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary シミュレーションで枠登録時にサジェストする単価を取得する
         * @param {FetchUnitAmountSuggestionsRequestBody} fetchUnitAmountSuggestionsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSuggestions: async (fetchUnitAmountSuggestionsRequestBody: FetchUnitAmountSuggestionsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchUnitAmountSuggestionsRequestBody' is not null or undefined
            assertParamExists('fetchSuggestions', 'fetchUnitAmountSuggestionsRequestBody', fetchUnitAmountSuggestionsRequestBody)
            const localVarPath = `/api/workforce-planning/slot-unit-amount-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchUnitAmountSuggestionsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforceSlotUnitAmountSuggestionControllerApi - functional programming interface
 */
export const WorkforceSlotUnitAmountSuggestionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforceSlotUnitAmountSuggestionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary シミュレーションで枠登録時にサジェストする単価を取得する
         * @param {FetchUnitAmountSuggestionsRequestBody} fetchUnitAmountSuggestionsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchSuggestions(fetchUnitAmountSuggestionsRequestBody: FetchUnitAmountSuggestionsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchUnitAmountSuggestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchSuggestions(fetchUnitAmountSuggestionsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotUnitAmountSuggestionControllerApi.fetchSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforceSlotUnitAmountSuggestionControllerApi - factory interface
 */
export const WorkforceSlotUnitAmountSuggestionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforceSlotUnitAmountSuggestionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary シミュレーションで枠登録時にサジェストする単価を取得する
         * @param {FetchUnitAmountSuggestionsRequestBody} fetchUnitAmountSuggestionsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSuggestions(fetchUnitAmountSuggestionsRequestBody: FetchUnitAmountSuggestionsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<FetchUnitAmountSuggestionsResponse> {
            return localVarFp.fetchSuggestions(fetchUnitAmountSuggestionsRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforceSlotUnitAmountSuggestionControllerApi - object-oriented interface
 */
export class WorkforceSlotUnitAmountSuggestionControllerApi extends BaseAPI {
    /**
     * 
     * @summary シミュレーションで枠登録時にサジェストする単価を取得する
     * @param {FetchUnitAmountSuggestionsRequestBody} fetchUnitAmountSuggestionsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchSuggestions(fetchUnitAmountSuggestionsRequestBody: FetchUnitAmountSuggestionsRequestBody, options?: RawAxiosRequestConfig) {
        return WorkforceSlotUnitAmountSuggestionControllerApiFp(this.configuration).fetchSuggestions(fetchUnitAmountSuggestionsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforceSlotUnitAmountTableControllerApi - axios parameter creator
 */
export const WorkforceSlotUnitAmountTableControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 単価テーブルを作成する
         * @param {CreateWorkforceSlotUnitAmountTableBody} createWorkforceSlotUnitAmountTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlotUnitAmountTable: async (createWorkforceSlotUnitAmountTableBody: CreateWorkforceSlotUnitAmountTableBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWorkforceSlotUnitAmountTableBody' is not null or undefined
            assertParamExists('createSlotUnitAmountTable', 'createWorkforceSlotUnitAmountTableBody', createWorkforceSlotUnitAmountTableBody)
            const localVarPath = `/api/workforce-planning/slot-unit-amount-tables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkforceSlotUnitAmountTableBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単価テーブルを削除する
         * @param {string} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotUnitAmountTable: async (tableId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tableId' is not null or undefined
            assertParamExists('deleteSlotUnitAmountTable', 'tableId', tableId)
            const localVarPath = `/api/workforce-planning/slot-unit-amount-tables/{tableId}`
                .replace('{tableId}', encodeURIComponent(String(tableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単価テーブルを取得する
         * @param {string} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotUnitAmountTable: async (tableId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tableId' is not null or undefined
            assertParamExists('getSlotUnitAmountTable', 'tableId', tableId)
            const localVarPath = `/api/workforce-planning/slot-unit-amount-tables/{tableId}`
                .replace('{tableId}', encodeURIComponent(String(tableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単価テーブル一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSlotUnitAmountTables: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/slot-unit-amount-tables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単価テーブルを更新する
         * @param {string} tableId 
         * @param {UpdateWorkforceSlotUnitAmountTableBody} updateWorkforceSlotUnitAmountTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotUnitAmountTable: async (tableId: string, updateWorkforceSlotUnitAmountTableBody: UpdateWorkforceSlotUnitAmountTableBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tableId' is not null or undefined
            assertParamExists('updateSlotUnitAmountTable', 'tableId', tableId)
            // verify required parameter 'updateWorkforceSlotUnitAmountTableBody' is not null or undefined
            assertParamExists('updateSlotUnitAmountTable', 'updateWorkforceSlotUnitAmountTableBody', updateWorkforceSlotUnitAmountTableBody)
            const localVarPath = `/api/workforce-planning/slot-unit-amount-tables/{tableId}`
                .replace('{tableId}', encodeURIComponent(String(tableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkforceSlotUnitAmountTableBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 単価テーブル名を更新する
         * @param {string} tableId 
         * @param {RenameWorkforceSlotUnitAmountTableBody} renameWorkforceSlotUnitAmountTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotUnitAmountTableName: async (tableId: string, renameWorkforceSlotUnitAmountTableBody: RenameWorkforceSlotUnitAmountTableBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tableId' is not null or undefined
            assertParamExists('updateSlotUnitAmountTableName', 'tableId', tableId)
            // verify required parameter 'renameWorkforceSlotUnitAmountTableBody' is not null or undefined
            assertParamExists('updateSlotUnitAmountTableName', 'renameWorkforceSlotUnitAmountTableBody', renameWorkforceSlotUnitAmountTableBody)
            const localVarPath = `/api/workforce-planning/slot-unit-amount-tables/{tableId}/name`
                .replace('{tableId}', encodeURIComponent(String(tableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameWorkforceSlotUnitAmountTableBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforceSlotUnitAmountTableControllerApi - functional programming interface
 */
export const WorkforceSlotUnitAmountTableControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforceSlotUnitAmountTableControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 単価テーブルを作成する
         * @param {CreateWorkforceSlotUnitAmountTableBody} createWorkforceSlotUnitAmountTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSlotUnitAmountTable(createWorkforceSlotUnitAmountTableBody: CreateWorkforceSlotUnitAmountTableBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateWorkforceSlotUnitAmountTableView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSlotUnitAmountTable(createWorkforceSlotUnitAmountTableBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotUnitAmountTableControllerApi.createSlotUnitAmountTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単価テーブルを削除する
         * @param {string} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSlotUnitAmountTable(tableId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSlotUnitAmountTable(tableId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotUnitAmountTableControllerApi.deleteSlotUnitAmountTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単価テーブルを取得する
         * @param {string} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlotUnitAmountTable(tableId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceSlotUnitAmountTableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlotUnitAmountTable(tableId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotUnitAmountTableControllerApi.getSlotUnitAmountTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単価テーブル一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSlotUnitAmountTables(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkforceSlotUnitAmountTableListDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSlotUnitAmountTables(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotUnitAmountTableControllerApi.listSlotUnitAmountTables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単価テーブルを更新する
         * @param {string} tableId 
         * @param {UpdateWorkforceSlotUnitAmountTableBody} updateWorkforceSlotUnitAmountTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlotUnitAmountTable(tableId: string, updateWorkforceSlotUnitAmountTableBody: UpdateWorkforceSlotUnitAmountTableBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlotUnitAmountTable(tableId, updateWorkforceSlotUnitAmountTableBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotUnitAmountTableControllerApi.updateSlotUnitAmountTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 単価テーブル名を更新する
         * @param {string} tableId 
         * @param {RenameWorkforceSlotUnitAmountTableBody} renameWorkforceSlotUnitAmountTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlotUnitAmountTableName(tableId: string, renameWorkforceSlotUnitAmountTableBody: RenameWorkforceSlotUnitAmountTableBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlotUnitAmountTableName(tableId, renameWorkforceSlotUnitAmountTableBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotUnitAmountTableControllerApi.updateSlotUnitAmountTableName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforceSlotUnitAmountTableControllerApi - factory interface
 */
export const WorkforceSlotUnitAmountTableControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforceSlotUnitAmountTableControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 単価テーブルを作成する
         * @param {CreateWorkforceSlotUnitAmountTableBody} createWorkforceSlotUnitAmountTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlotUnitAmountTable(createWorkforceSlotUnitAmountTableBody: CreateWorkforceSlotUnitAmountTableBody, options?: RawAxiosRequestConfig): AxiosPromise<CreateWorkforceSlotUnitAmountTableView> {
            return localVarFp.createSlotUnitAmountTable(createWorkforceSlotUnitAmountTableBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単価テーブルを削除する
         * @param {string} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlotUnitAmountTable(tableId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteSlotUnitAmountTable(tableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単価テーブルを取得する
         * @param {string} tableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlotUnitAmountTable(tableId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforceSlotUnitAmountTableDto> {
            return localVarFp.getSlotUnitAmountTable(tableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単価テーブル一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSlotUnitAmountTables(options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkforceSlotUnitAmountTableListDto>> {
            return localVarFp.listSlotUnitAmountTables(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単価テーブルを更新する
         * @param {string} tableId 
         * @param {UpdateWorkforceSlotUnitAmountTableBody} updateWorkforceSlotUnitAmountTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotUnitAmountTable(tableId: string, updateWorkforceSlotUnitAmountTableBody: UpdateWorkforceSlotUnitAmountTableBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateSlotUnitAmountTable(tableId, updateWorkforceSlotUnitAmountTableBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 単価テーブル名を更新する
         * @param {string} tableId 
         * @param {RenameWorkforceSlotUnitAmountTableBody} renameWorkforceSlotUnitAmountTableBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlotUnitAmountTableName(tableId: string, renameWorkforceSlotUnitAmountTableBody: RenameWorkforceSlotUnitAmountTableBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateSlotUnitAmountTableName(tableId, renameWorkforceSlotUnitAmountTableBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforceSlotUnitAmountTableControllerApi - object-oriented interface
 */
export class WorkforceSlotUnitAmountTableControllerApi extends BaseAPI {
    /**
     * 
     * @summary 単価テーブルを作成する
     * @param {CreateWorkforceSlotUnitAmountTableBody} createWorkforceSlotUnitAmountTableBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSlotUnitAmountTable(createWorkforceSlotUnitAmountTableBody: CreateWorkforceSlotUnitAmountTableBody, options?: RawAxiosRequestConfig) {
        return WorkforceSlotUnitAmountTableControllerApiFp(this.configuration).createSlotUnitAmountTable(createWorkforceSlotUnitAmountTableBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単価テーブルを削除する
     * @param {string} tableId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSlotUnitAmountTable(tableId: string, options?: RawAxiosRequestConfig) {
        return WorkforceSlotUnitAmountTableControllerApiFp(this.configuration).deleteSlotUnitAmountTable(tableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単価テーブルを取得する
     * @param {string} tableId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSlotUnitAmountTable(tableId: string, options?: RawAxiosRequestConfig) {
        return WorkforceSlotUnitAmountTableControllerApiFp(this.configuration).getSlotUnitAmountTable(tableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単価テーブル一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSlotUnitAmountTables(options?: RawAxiosRequestConfig) {
        return WorkforceSlotUnitAmountTableControllerApiFp(this.configuration).listSlotUnitAmountTables(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単価テーブルを更新する
     * @param {string} tableId 
     * @param {UpdateWorkforceSlotUnitAmountTableBody} updateWorkforceSlotUnitAmountTableBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSlotUnitAmountTable(tableId: string, updateWorkforceSlotUnitAmountTableBody: UpdateWorkforceSlotUnitAmountTableBody, options?: RawAxiosRequestConfig) {
        return WorkforceSlotUnitAmountTableControllerApiFp(this.configuration).updateSlotUnitAmountTable(tableId, updateWorkforceSlotUnitAmountTableBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 単価テーブル名を更新する
     * @param {string} tableId 
     * @param {RenameWorkforceSlotUnitAmountTableBody} renameWorkforceSlotUnitAmountTableBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSlotUnitAmountTableName(tableId: string, renameWorkforceSlotUnitAmountTableBody: RenameWorkforceSlotUnitAmountTableBody, options?: RawAxiosRequestConfig) {
        return WorkforceSlotUnitAmountTableControllerApiFp(this.configuration).updateSlotUnitAmountTableName(tableId, renameWorkforceSlotUnitAmountTableBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkforceSlotsControllerApi - axios parameter creator
 */
export const WorkforceSlotsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 人員計画枠を削除する
         * @param {string} workforceSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceSlot: async (workforceSlotId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceSlotId' is not null or undefined
            assertParamExists('deleteWorkforceSlot', 'workforceSlotId', workforceSlotId)
            const localVarPath = `/api/workforce-planning/workforce-slots/{workforceSlotId}`
                .replace('{workforceSlotId}', encodeURIComponent(String(workforceSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員計画枠の枠数利用状況を取得する
         * @param {string} workforceSlotId 
         * @param {string} [planMasterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWorkforceSlotUsage: async (workforceSlotId: string, planMasterId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceSlotId' is not null or undefined
            assertParamExists('fetchWorkforceSlotUsage', 'workforceSlotId', workforceSlotId)
            const localVarPath = `/api/workforce-planning/workforce-slots/{workforceSlotId}/usage`
                .replace('{workforceSlotId}', encodeURIComponent(String(workforceSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            if (planMasterId !== undefined) {
                localVarQueryParameter['planMasterId'] = planMasterId;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 枠情報を取得する
         * @param {string} workforceSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWorkforceSlot: async (workforceSlotId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceSlotId' is not null or undefined
            assertParamExists('findWorkforceSlot', 'workforceSlotId', workforceSlotId)
            const localVarPath = `/api/workforce-planning/workforce-slots/{workforceSlotId}`
                .replace('{workforceSlotId}', encodeURIComponent(String(workforceSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計画指定の人員・採用枠一覧を取得する
         * @param {ListPlannedWorkforceSlotsRequestBody} listPlannedWorkforceSlotsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlannedWorkforceSlots: async (listPlannedWorkforceSlotsRequestBody: ListPlannedWorkforceSlotsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listPlannedWorkforceSlotsRequestBody' is not null or undefined
            assertParamExists('listPlannedWorkforceSlots', 'listPlannedWorkforceSlotsRequestBody', listPlannedWorkforceSlotsRequestBody)
            const localVarPath = `/api/workforce-planning/workforce-slots/planned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listPlannedWorkforceSlotsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 計画外の人員・採用枠一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnplannedWorkforceSlots: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/workforce-planning/workforce-slots/unplanned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 人員・採用枠一覧を取得する
         * @param {ListWorkforceSlotsRequestBody} listWorkforceSlotsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceSlotsV2: async (listWorkforceSlotsRequestBody: ListWorkforceSlotsRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listWorkforceSlotsRequestBody' is not null or undefined
            assertParamExists('listWorkforceSlotsV2', 'listWorkforceSlotsRequestBody', listWorkforceSlotsRequestBody)
            const localVarPath = `/api/workforce-planning/workforce-slots/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listWorkforceSlotsRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 枠コードと枠名を変更する
         * @param {string} workforceSlotId 
         * @param {UpdateWorkforceSlotNameAndCodeRequestBody} updateWorkforceSlotNameAndCodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforceSlotNameAndCode: async (workforceSlotId: string, updateWorkforceSlotNameAndCodeRequestBody: UpdateWorkforceSlotNameAndCodeRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workforceSlotId' is not null or undefined
            assertParamExists('updateWorkforceSlotNameAndCode', 'workforceSlotId', workforceSlotId)
            // verify required parameter 'updateWorkforceSlotNameAndCodeRequestBody' is not null or undefined
            assertParamExists('updateWorkforceSlotNameAndCode', 'updateWorkforceSlotNameAndCodeRequestBody', updateWorkforceSlotNameAndCodeRequestBody)
            const localVarPath = `/api/workforce-planning/workforce-slots/{workforceSlotId}`
                .replace('{workforceSlotId}', encodeURIComponent(String(workforceSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkforceSlotNameAndCodeRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkforceSlotsControllerApi - functional programming interface
 */
export const WorkforceSlotsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkforceSlotsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 人員計画枠を削除する
         * @param {string} workforceSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkforceSlot(workforceSlotId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkforceSlot(workforceSlotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotsControllerApi.deleteWorkforceSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員計画枠の枠数利用状況を取得する
         * @param {string} workforceSlotId 
         * @param {string} [planMasterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchWorkforceSlotUsage(workforceSlotId: string, planMasterId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceSlotAndSlotPlanVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchWorkforceSlotUsage(workforceSlotId, planMasterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotsControllerApi.fetchWorkforceSlotUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 枠情報を取得する
         * @param {string} workforceSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findWorkforceSlot(workforceSlotId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkforceSlotView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findWorkforceSlot(workforceSlotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotsControllerApi.findWorkforceSlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計画指定の人員・採用枠一覧を取得する
         * @param {ListPlannedWorkforceSlotsRequestBody} listPlannedWorkforceSlotsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlannedWorkforceSlots(listPlannedWorkforceSlotsRequestBody: ListPlannedWorkforceSlotsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkforceSlotsReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlannedWorkforceSlots(listPlannedWorkforceSlotsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotsControllerApi.listPlannedWorkforceSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 計画外の人員・採用枠一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUnplannedWorkforceSlots(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkforceSlotsReturn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUnplannedWorkforceSlots(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotsControllerApi.listUnplannedWorkforceSlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 人員・採用枠一覧を取得する
         * @param {ListWorkforceSlotsRequestBody} listWorkforceSlotsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkforceSlotsV2(listWorkforceSlotsRequestBody: ListWorkforceSlotsRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkforceSlotsV2Return>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkforceSlotsV2(listWorkforceSlotsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotsControllerApi.listWorkforceSlotsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 枠コードと枠名を変更する
         * @param {string} workforceSlotId 
         * @param {UpdateWorkforceSlotNameAndCodeRequestBody} updateWorkforceSlotNameAndCodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkforceSlotNameAndCode(workforceSlotId: string, updateWorkforceSlotNameAndCodeRequestBody: UpdateWorkforceSlotNameAndCodeRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkJson>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkforceSlotNameAndCode(workforceSlotId, updateWorkforceSlotNameAndCodeRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkforceSlotsControllerApi.updateWorkforceSlotNameAndCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkforceSlotsControllerApi - factory interface
 */
export const WorkforceSlotsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkforceSlotsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary 人員計画枠を削除する
         * @param {string} workforceSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkforceSlot(workforceSlotId: string, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.deleteWorkforceSlot(workforceSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員計画枠の枠数利用状況を取得する
         * @param {string} workforceSlotId 
         * @param {string} [planMasterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWorkforceSlotUsage(workforceSlotId: string, planMasterId?: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforceSlotAndSlotPlanVersionView> {
            return localVarFp.fetchWorkforceSlotUsage(workforceSlotId, planMasterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 枠情報を取得する
         * @param {string} workforceSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWorkforceSlot(workforceSlotId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkforceSlotView> {
            return localVarFp.findWorkforceSlot(workforceSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計画指定の人員・採用枠一覧を取得する
         * @param {ListPlannedWorkforceSlotsRequestBody} listPlannedWorkforceSlotsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlannedWorkforceSlots(listPlannedWorkforceSlotsRequestBody: ListPlannedWorkforceSlotsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ListWorkforceSlotsReturn> {
            return localVarFp.listPlannedWorkforceSlots(listPlannedWorkforceSlotsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 計画外の人員・採用枠一覧を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnplannedWorkforceSlots(options?: RawAxiosRequestConfig): AxiosPromise<ListWorkforceSlotsReturn> {
            return localVarFp.listUnplannedWorkforceSlots(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 人員・採用枠一覧を取得する
         * @param {ListWorkforceSlotsRequestBody} listWorkforceSlotsRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceSlotsV2(listWorkforceSlotsRequestBody: ListWorkforceSlotsRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<ListWorkforceSlotsV2Return> {
            return localVarFp.listWorkforceSlotsV2(listWorkforceSlotsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 枠コードと枠名を変更する
         * @param {string} workforceSlotId 
         * @param {UpdateWorkforceSlotNameAndCodeRequestBody} updateWorkforceSlotNameAndCodeRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkforceSlotNameAndCode(workforceSlotId: string, updateWorkforceSlotNameAndCodeRequestBody: UpdateWorkforceSlotNameAndCodeRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OkJson> {
            return localVarFp.updateWorkforceSlotNameAndCode(workforceSlotId, updateWorkforceSlotNameAndCodeRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkforceSlotsControllerApi - object-oriented interface
 */
export class WorkforceSlotsControllerApi extends BaseAPI {
    /**
     * 
     * @summary 人員計画枠を削除する
     * @param {string} workforceSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWorkforceSlot(workforceSlotId: string, options?: RawAxiosRequestConfig) {
        return WorkforceSlotsControllerApiFp(this.configuration).deleteWorkforceSlot(workforceSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員計画枠の枠数利用状況を取得する
     * @param {string} workforceSlotId 
     * @param {string} [planMasterId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchWorkforceSlotUsage(workforceSlotId: string, planMasterId?: string, options?: RawAxiosRequestConfig) {
        return WorkforceSlotsControllerApiFp(this.configuration).fetchWorkforceSlotUsage(workforceSlotId, planMasterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 枠情報を取得する
     * @param {string} workforceSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findWorkforceSlot(workforceSlotId: string, options?: RawAxiosRequestConfig) {
        return WorkforceSlotsControllerApiFp(this.configuration).findWorkforceSlot(workforceSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計画指定の人員・採用枠一覧を取得する
     * @param {ListPlannedWorkforceSlotsRequestBody} listPlannedWorkforceSlotsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listPlannedWorkforceSlots(listPlannedWorkforceSlotsRequestBody: ListPlannedWorkforceSlotsRequestBody, options?: RawAxiosRequestConfig) {
        return WorkforceSlotsControllerApiFp(this.configuration).listPlannedWorkforceSlots(listPlannedWorkforceSlotsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 計画外の人員・採用枠一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listUnplannedWorkforceSlots(options?: RawAxiosRequestConfig) {
        return WorkforceSlotsControllerApiFp(this.configuration).listUnplannedWorkforceSlots(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 人員・採用枠一覧を取得する
     * @param {ListWorkforceSlotsRequestBody} listWorkforceSlotsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkforceSlotsV2(listWorkforceSlotsRequestBody: ListWorkforceSlotsRequestBody, options?: RawAxiosRequestConfig) {
        return WorkforceSlotsControllerApiFp(this.configuration).listWorkforceSlotsV2(listWorkforceSlotsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 枠コードと枠名を変更する
     * @param {string} workforceSlotId 
     * @param {UpdateWorkforceSlotNameAndCodeRequestBody} updateWorkforceSlotNameAndCodeRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWorkforceSlotNameAndCode(workforceSlotId: string, updateWorkforceSlotNameAndCodeRequestBody: UpdateWorkforceSlotNameAndCodeRequestBody, options?: RawAxiosRequestConfig) {
        return WorkforceSlotsControllerApiFp(this.configuration).updateWorkforceSlotNameAndCode(workforceSlotId, updateWorkforceSlotNameAndCodeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * XpaDashboardControllerApi - axios parameter creator
 */
export const XpaDashboardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ダッシュボードコピーの件数上限のチェック（何も作らずにコピー後の件数・上限と、件数上限の違反を返す）
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkXpaDashboardCopyLimits: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('checkXpaDashboardCopyLimits', 'dashboardId', dashboardId)
            const localVarPath = `/api/dashboards/{dashboardId}/copy-limit-check`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボードコピー
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyXpaDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('copyXpaDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/api/dashboards/{dashboardId}/copy`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボード作成
         * @param {CreateDashboardRequestBody} createDashboardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createXpaDashboard: async (createDashboardRequestBody: CreateDashboardRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDashboardRequestBody' is not null or undefined
            assertParamExists('createXpaDashboard', 'createDashboardRequestBody', createDashboardRequestBody)
            const localVarPath = `/api/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDashboardRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボード削除
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteXpaDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('deleteXpaDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/api/dashboards/{dashboardId}`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボード取得
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXpaDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getXpaDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/api/dashboards/{dashboardId}`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボード一覧取得（件数制限ステータス付き）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listXpaDashboards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボード移動
         * @param {string} dashboardId 
         * @param {MoveDashboardRequestBody} moveDashboardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveXpaDashboard: async (dashboardId: string, moveDashboardRequestBody: MoveDashboardRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('moveXpaDashboard', 'dashboardId', dashboardId)
            // verify required parameter 'moveDashboardRequestBody' is not null or undefined
            assertParamExists('moveXpaDashboard', 'moveDashboardRequestBody', moveDashboardRequestBody)
            const localVarPath = `/api/dashboards/{dashboardId}/move`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveDashboardRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボード編集
         * @param {string} dashboardId 
         * @param {UpdateDashboardRequestBody} updateDashboardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateXpaDashboard: async (dashboardId: string, updateDashboardRequestBody: UpdateDashboardRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateXpaDashboard', 'dashboardId', dashboardId)
            // verify required parameter 'updateDashboardRequestBody' is not null or undefined
            assertParamExists('updateXpaDashboard', 'updateDashboardRequestBody', updateDashboardRequestBody)
            const localVarPath = `/api/dashboards/{dashboardId}`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDashboardRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボード編集制限の更新
         * @param {string} dashboardId 
         * @param {UpdateDashboardEditRestrictedRequestBody} updateDashboardEditRestrictedRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateXpaDashboardEditRestricted: async (dashboardId: string, updateDashboardEditRestrictedRequestBody: UpdateDashboardEditRestrictedRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateXpaDashboardEditRestricted', 'dashboardId', dashboardId)
            // verify required parameter 'updateDashboardEditRestrictedRequestBody' is not null or undefined
            assertParamExists('updateXpaDashboardEditRestricted', 'updateDashboardEditRestrictedRequestBody', updateDashboardEditRestrictedRequestBody)
            const localVarPath = `/api/dashboards/{dashboardId}/edit-restricted`
                .replace('{dashboardId}', encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDashboardEditRestrictedRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XpaDashboardControllerApi - functional programming interface
 */
export const XpaDashboardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XpaDashboardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ダッシュボードコピーの件数上限のチェック（何も作らずにコピー後の件数・上限と、件数上限の違反を返す）
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkXpaDashboardCopyLimits(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardCopyLimitCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkXpaDashboardCopyLimits(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XpaDashboardControllerApi.checkXpaDashboardCopyLimits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボードコピー
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyXpaDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopiedDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyXpaDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XpaDashboardControllerApi.copyXpaDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボード作成
         * @param {CreateDashboardRequestBody} createDashboardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createXpaDashboard(createDashboardRequestBody: CreateDashboardRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedDashboardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createXpaDashboard(createDashboardRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XpaDashboardControllerApi.createXpaDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボード削除
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteXpaDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteXpaDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XpaDashboardControllerApi.deleteXpaDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボード取得
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getXpaDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<XpaDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getXpaDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XpaDashboardControllerApi.getXpaDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボード一覧取得（件数制限ステータス付き）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listXpaDashboards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<XpaDashboardListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listXpaDashboards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XpaDashboardControllerApi.listXpaDashboards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボード移動
         * @param {string} dashboardId 
         * @param {MoveDashboardRequestBody} moveDashboardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveXpaDashboard(dashboardId: string, moveDashboardRequestBody: MoveDashboardRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveXpaDashboard(dashboardId, moveDashboardRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XpaDashboardControllerApi.moveXpaDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボード編集
         * @param {string} dashboardId 
         * @param {UpdateDashboardRequestBody} updateDashboardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateXpaDashboard(dashboardId: string, updateDashboardRequestBody: UpdateDashboardRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateXpaDashboard(dashboardId, updateDashboardRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XpaDashboardControllerApi.updateXpaDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボード編集制限の更新
         * @param {string} dashboardId 
         * @param {UpdateDashboardEditRestrictedRequestBody} updateDashboardEditRestrictedRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateXpaDashboardEditRestricted(dashboardId: string, updateDashboardEditRestrictedRequestBody: UpdateDashboardEditRestrictedRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateXpaDashboardEditRestricted(dashboardId, updateDashboardEditRestrictedRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['XpaDashboardControllerApi.updateXpaDashboardEditRestricted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * XpaDashboardControllerApi - factory interface
 */
export const XpaDashboardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XpaDashboardControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ダッシュボードコピーの件数上限のチェック（何も作らずにコピー後の件数・上限と、件数上限の違反を返す）
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkXpaDashboardCopyLimits(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardCopyLimitCheckResponse> {
            return localVarFp.checkXpaDashboardCopyLimits(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボードコピー
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyXpaDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<CopiedDashboardResponse> {
            return localVarFp.copyXpaDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボード作成
         * @param {CreateDashboardRequestBody} createDashboardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createXpaDashboard(createDashboardRequestBody: CreateDashboardRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<CreatedDashboardDto> {
            return localVarFp.createXpaDashboard(createDashboardRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボード削除
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteXpaDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteXpaDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボード取得
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXpaDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<XpaDashboardResponse> {
            return localVarFp.getXpaDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボード一覧取得（件数制限ステータス付き）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listXpaDashboards(options?: RawAxiosRequestConfig): AxiosPromise<XpaDashboardListResponse> {
            return localVarFp.listXpaDashboards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボード移動
         * @param {string} dashboardId 
         * @param {MoveDashboardRequestBody} moveDashboardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveXpaDashboard(dashboardId: string, moveDashboardRequestBody: MoveDashboardRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveXpaDashboard(dashboardId, moveDashboardRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボード編集
         * @param {string} dashboardId 
         * @param {UpdateDashboardRequestBody} updateDashboardRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateXpaDashboard(dashboardId: string, updateDashboardRequestBody: UpdateDashboardRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateXpaDashboard(dashboardId, updateDashboardRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボード編集制限の更新
         * @param {string} dashboardId 
         * @param {UpdateDashboardEditRestrictedRequestBody} updateDashboardEditRestrictedRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateXpaDashboardEditRestricted(dashboardId: string, updateDashboardEditRestrictedRequestBody: UpdateDashboardEditRestrictedRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateXpaDashboardEditRestricted(dashboardId, updateDashboardEditRestrictedRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XpaDashboardControllerApi - object-oriented interface
 */
export class XpaDashboardControllerApi extends BaseAPI {
    /**
     * 
     * @summary ダッシュボードコピーの件数上限のチェック（何も作らずにコピー後の件数・上限と、件数上限の違反を返す）
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkXpaDashboardCopyLimits(dashboardId: string, options?: RawAxiosRequestConfig) {
        return XpaDashboardControllerApiFp(this.configuration).checkXpaDashboardCopyLimits(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボードコピー
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyXpaDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return XpaDashboardControllerApiFp(this.configuration).copyXpaDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボード作成
     * @param {CreateDashboardRequestBody} createDashboardRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createXpaDashboard(createDashboardRequestBody: CreateDashboardRequestBody, options?: RawAxiosRequestConfig) {
        return XpaDashboardControllerApiFp(this.configuration).createXpaDashboard(createDashboardRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボード削除
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteXpaDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return XpaDashboardControllerApiFp(this.configuration).deleteXpaDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボード取得
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getXpaDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return XpaDashboardControllerApiFp(this.configuration).getXpaDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボード一覧取得（件数制限ステータス付き）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listXpaDashboards(options?: RawAxiosRequestConfig) {
        return XpaDashboardControllerApiFp(this.configuration).listXpaDashboards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボード移動
     * @param {string} dashboardId 
     * @param {MoveDashboardRequestBody} moveDashboardRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveXpaDashboard(dashboardId: string, moveDashboardRequestBody: MoveDashboardRequestBody, options?: RawAxiosRequestConfig) {
        return XpaDashboardControllerApiFp(this.configuration).moveXpaDashboard(dashboardId, moveDashboardRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボード編集
     * @param {string} dashboardId 
     * @param {UpdateDashboardRequestBody} updateDashboardRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateXpaDashboard(dashboardId: string, updateDashboardRequestBody: UpdateDashboardRequestBody, options?: RawAxiosRequestConfig) {
        return XpaDashboardControllerApiFp(this.configuration).updateXpaDashboard(dashboardId, updateDashboardRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボード編集制限の更新
     * @param {string} dashboardId 
     * @param {UpdateDashboardEditRestrictedRequestBody} updateDashboardEditRestrictedRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateXpaDashboardEditRestricted(dashboardId: string, updateDashboardEditRestrictedRequestBody: UpdateDashboardEditRestrictedRequestBody, options?: RawAxiosRequestConfig) {
        return XpaDashboardControllerApiFp(this.configuration).updateXpaDashboardEditRestricted(dashboardId, updateDashboardEditRestrictedRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ZendeskControllerApi - axios parameter creator
 */
export const ZendeskControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Zendeskでサポートサイトと連携するための認証用JWTを返す
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwt: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/zendesk/jwt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer-jwt required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication tenant-id required
            await setApiKeyToObject(localVarHeaderParameter, "X-Loglass-Tenant-Id", configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZendeskControllerApi - functional programming interface
 */
export const ZendeskControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZendeskControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Zendeskでサポートサイトと連携するための認証用JWTを返す
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jwt(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZendeskJwtDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jwt(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZendeskControllerApi.jwt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ZendeskControllerApi - factory interface
 */
export const ZendeskControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZendeskControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Zendeskでサポートサイトと連携するための認証用JWTを返す
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwt(options?: RawAxiosRequestConfig): AxiosPromise<ZendeskJwtDto> {
            return localVarFp.jwt(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZendeskControllerApi - object-oriented interface
 */
export class ZendeskControllerApi extends BaseAPI {
    /**
     * 
     * @summary Zendeskでサポートサイトと連携するための認証用JWTを返す
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jwt(options?: RawAxiosRequestConfig) {
        return ZendeskControllerApiFp(this.configuration).jwt(options).then((request) => request(this.axios, this.basePath));
    }
}



